let makeObject = {
  Acura: {
    ILX: ["2015", "2014", "2013"],
    Integra: ["2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    RL: ["2008", "2007", "2006", "2005"],
    RSX: ["2006", "2005", "2004", "2003", "2002"],
    TL: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
    ],
    TLX: ["2016", "2015"],
    TSX: [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
    ],
  },
  Audi: {
    A4: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
    ],
    A6: [
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
    ],
  },
  BMW: {
    "3-Series 2DR": [
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
    ],
    "3-Series 4DR": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "318TI": ["1998", "1997", "1996", "1995"],
    "5-Series": [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
    ],
    Z4: ["2008", "2007", "2006", "2005", "2004", "2003", "2002"],
  },
  Buick: {
    Century: ["2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    Lacrosse: ["2013", "2012", "2011", "2010"],
    Lucerne: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
    ],
    Regal: ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
  },
  Cadillac: {
    ATS: ["2015", "2014", "2013"],
    "CTS Coupe": [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
    ],
    "CTS Sedan": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
    ],
    Catera: ["2002", "2001", "2000", "1999", "1998", "1997"],
    "Deville DTS": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "El Dorado": [
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
    ],
    Escalade: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2004",
      "2003",
      "2002",
    ],
    STS: ["2011", "2010", "2009", "2008", "2007", "2006", "2005"],
  },
  Chevrolet: {
    Aveo: ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    Beretta: ["1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    C1500: ["2006", "2005", "2004", "2003"],
    Camaro: [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
    ],
    "Camaro Z28": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Cavalier Z24": ["2002", "2001", "2000"],
    "Cobalt 2DR": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Cobalt 4DR": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Corvette C5": [
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
    ],
    "Corvette C6": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
    ],
    "Corvette C7": ["2016", "2015", "2014"],
    Cruze: ["2015", "2014", "2013", "2012", "2011"],
    Equinox: ["2013", "2012", "2011", "2010"],
    HHR: ["2011", "2010", "2009", "2008", "2007", "2006"],
    Impala: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
    ],
    Malibu: [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
    ],
    "Malibu Maxx": ["2007", "2006", "2005", "2004"],
    Prizm: ["2002", "2001", "2000", "1999", "1998"],
    SSR: ["2006", "2005", "2004"],
    Silverado: ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Suburban: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
    ],
    Tahoe: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
    ],
    Trailblazer: [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
    ],
  },
  Chrysler: {
    200: ["2016", "2015", "2014", "2013", "2012", "2011"],
    300: [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
    ],
    "300M": ["2004", "2003", "2002", "2001", "2000", "1999"],
    Aspen: ["2009", "2008", "2007", "2006"],
    Concorde: ["1997", "1996", "1995", "1994", "1993"],
    "PT Cruiser": [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
    ],
    Sebring: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
    ],
    "Town and Country": [
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
    ],
  },
  Dodge: {
    Avenger: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "1996",
      "1995",
    ],
    Caliber: ["2011", "2010", "2009", "2008", "2007", "2006"],
    Caravan: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
    ],
    Challenger: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
    ],
    Charger: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
    ],
    "Charger 500": ["2010", "2009", "2008", "2007", "2006"],
    "Charger Daytona": ["2010", "2009", "2008", "2007", "2006"],
    Dart: ["2015", "2014", "2013"],
    Durango: ["2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    Intrepid: [
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
    ],
    Neon: [
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
    ],
    Nitro: ["2011", "2010", "2009", "2008", "2007"],
    Ram: [
      "2015",
      "2014",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
    ],
    Stratus: ["2005", "2004", "2003", "2002", "2001"],
  },
  Fiat: {
    500: ["2015", "2014", "2013", "2012"],
  },
  Ford: {
    "Five Hundred": ["2007", "2006", "2005"],
    Contour: ["2001", "2000", "1999", "1998"],
    "Crown Victoria": [
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
    ],
    Escape: ["2012", "2011", "2010", "2009", "2008"],
    Expedition: ["2001", "2000", "1999", "1998", "1997"],
    Explorer: ["2007", "2006", "2005", "2004", "2003", "2002"],
    Flex: ["2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "F-150": ["2008", "2007", "2006", "2005", "2004"],
    Fiesta: ["2015", "2014", "2013", "2012", "2011"],
    Focus: [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
    ],
    Fusion: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
    ],
    "F-150 Lightning": ["2004", "2003", "2002", "2001", "2000", "1999"],
    Mustang: [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
    ],
    "Mustang GT": ["2004", "2003", "2002", "2001", "2000", "1999"],
    "Mustang GT350R": ["2016", "2015"],
    "Mustang GT500": ["2009", "2008", "2007", "2006", "2005"],
    Taurus: ["2012", "2011", "2010", "2009", "2008"],
    Thunderbird: [
      "1997",
      "1996",
      "1995",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
    ],
  },
  GMC: {
    Denali: ["1999", "1998", "1997", "1996", "1995", "1996", "1995", "1994"],
    Envoy: [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
    ],
    Sierra: ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Tahoe: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2005",
      "2004",
      "2003",
      "2002",
    ],
    Yukon: [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2005",
      "2004",
      "2003",
      "2002",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1996",
      "1995",
      "1994",
    ],
  },
  Mitsubishi: {
    "Outlander SEL": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander XLS": [
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Outlander PHEV GT": ["2018", "2019", "2020"],
    "Outlander PHEV SEL": ["2018", "2019", "2020"],
    "Outlander Sport BE": ["2020", "2021"],
    "Outlander Sport ES": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander Sport GT": [
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander Sport LE": ["2018", "2019", "2021", "2022", "2023", "2024"],
    "Outlander Sport S": ["2021", "2022", "2023", "2024"],
    "Outlander Sport SE": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander Sport SEL": ["2016", "2017", "2018"],
    "Outlander Sport SP": ["2019", "2020"],
    "Eclipse GT": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Eclipse GTS": ["2003", "2004", "2005"],
    "Eclipse Spyder GT": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Eclipse Spyder GTS": ["2003", "2004", "2005"],
    "Lancer ES": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Lancer GT": ["2012", "2013", "2014", "2015", "2016"],
    "Lancer SE": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Lancer SEL": ["2016", "2017"],
    "Lancer Evolution GSR": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "3000GT Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "3000GT SL": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "3000GT Spyder SL": ["1995", "1996"],
    "Cordia Base": ["1983", "1984"],
    "Cordia L": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "Cordia LS": ["1983", "1984"],
    "Cordia Turbo": ["1984", "1985", "1986", "1987", "1988"],
    "Eclipse Base": ["1990", "1991", "1992", "1993", "1994", "1996", "1997"],
    "Eclipse GS": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Eclipse GST": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Eclipse GSX": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Eclipse RS": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Eclipse Spyder GS": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Eclipse Spyder GST": ["1996", "1997", "1998", "1999"],
    "Expo Base": ["1992", "1993", "1994", "1995"],
    "Expo SP": ["1992", "1993"],
    "Expo LRV Base": ["1992", "1993", "1994"],
    "Galant Base": ["1985", "1986", "1987", "1989", "1990", "1991", "1992"],
    "Galant DE": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Galant ES": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Galant GS": ["1989", "1990", "1991", "1992"],
    "Galant GSR": ["1991", "1992"],
    "Galant GSX": ["1990", "1991", "1992"],
    "Galant LS": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Galant S": ["1993", "1994", "1995", "1996"],
    "Galant VR-4": ["1991", "1992"],
    "Lancer Ralliart": [
      "2004",
      "2005",
      "2006",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Mirage Base": ["1985", "1986", "1987", "1989", "1990", "1991", "1992"],
    "Mirage DE": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2014",
      "2015",
    ],
    "Mirage ES": [
      "1993",
      "1994",
      "1995",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Mirage GS": ["1991", "1992"],
    "Mirage L": ["1985", "1986", "1987", "1988"],
    "Mirage LS": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Mirage S": ["1993", "1994", "1995", "1996"],
    "Mirage SE": [
      "1991",
      "1992",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Mirage Turbo": ["1985", "1986", "1987", "1988", "1989"],
    "Mirage VL": ["1990", "1991", "1992"],
    "Precis Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Precis RS": ["1988", "1989", "1990", "1991"],
    "Tredia Base": ["1983", "1984", "1985", "1986"],
    "Tredia L": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "Tredia LS": ["1983", "1984", "1986", "1987", "1988"],
    "Tredia Turbo": ["1984", "1985", "1986", "1987", "1988"],
    "Starion ESi-R": ["1986", "1987", "1988", "1989"],
    "Lancer Evolution": ["2003", "2004", "2005", "2006"],
    "Lancer Evolution MR": [
      "2005",
      "2006",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Lancer Evolution RS": ["2005", "2006"],
    "Lancer LS": ["2002", "2003", "2004"],
    "Lancer OZ Rally": ["2002", "2003", "2004", "2005", "2006"],
    "3000GT Spyder VR-4": ["1995", "1996"],
    "3000GT VR-4": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Lancer Evolution MR Touring": ["2010", "2011"],
    "Montero Limited": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Montero XLS": ["2001", "2002", "2003", "2004"],
    "Eclipse Cross ES": ["2018", "2019", "2020", "2022", "2023", "2024"],
    "Eclipse Cross LE": ["2018", "2019", "2020", "2022", "2023", "2024"],
    "Eclipse Cross SE": ["2018", "2019", "2020", "2022", "2023", "2024"],
    "Eclipse Cross SEL": ["2018", "2019", "2020", "2022", "2023", "2024"],
    "Eclipse Cross SEL Touring": ["2023", "2024"],
    "Eclipse Cross SP": ["2019", "2020"],
    "Lancer DE": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Lancer ES Sportback": ["2011", "2012", "2013", "2014"],
    "Lancer GT Sportback": ["2012", "2013", "2014"],
    "Lancer GTS": ["2008", "2009", "2010", "2011"],
    "Lancer GTS Sportback": ["2010", "2011"],
    "Lancer Ralliart Sportback": ["2010", "2011"],
    "Outlander ES": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander GT": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Outlander LS": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "Outlander SE": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "Mighty Max 1 Ton": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Mighty Max Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Mighty Max Sport": ["1986", "1987", "1988", "1989"],
    "Mighty Max SPX": ["1983", "1984", "1985", "1986", "1987", "1988", "1989"],
    "Diamante ES": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Diamante LS": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1997",
      "1998",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Montero Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1998",
      "1999",
      "2000",
    ],
    "Montero LS": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Montero RS": ["1990", "1991", "1992", "1993"],
    "Montero SP": ["1989", "1990"],
    "Montero Sport": ["1987", "1988", "1989", "1990"],
    "Montero SR": ["1992", "1993", "1994", "1995", "1996", "1997"],
    "Montero Sport ES": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Montero Sport Limited": ["1999", "2000", "2001", "2002", "2003"],
    "Montero Sport LS": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Montero Sport XLS": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Outlander LE": ["2018", "2019", "2020"],
    "Eclipse GS Sport": ["2010", "2011", "2012"],
    "Eclipse SE": ["2007", "2008"],
    "Endeavor Limited": ["2004", "2005", "2006"],
    "Endeavor LS": ["2004", "2005", "2006", "2007", "2008", "2010", "2011"],
    "Endeavor SE": ["2007", "2008", "2010", "2011"],
    "Endeavor XLS": ["2004", "2005"],
    "Galant FE": ["2011", "2012"],
    "Galant GTS": ["2004", "2005", "2006", "2007"],
    "Galant Ralliart": ["2007", "2008", "2009"],
    "Galant SE": ["2005", "2006", "2007", "2010", "2011", "2012"],
    "Diamante VR-X": ["2002", "2003", "2004"],
    "Mirage Black Edition": ["2022", "2023"],
    "Mirage GT": ["2017", "2018", "2019", "2020"],
    "Mirage LE": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Outlander Limited": ["2005", "2006"],
    "Raider DuroCross": ["2006", "2007"],
    "Raider LS": ["2006", "2007", "2008", "2009"],
    "Galant GTZ": ["1999", "2000", "2001", "2002", "2003"],
    "Mirage G4 ES": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Mirage G4 SE": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Expo LRV Sport": ["1992", "1993", "1994"],
    "Mighty Max S": ["1983", "1984"],
    "Mighty Max SP": ["1983", "1984", "1985"],
    "Sigma Base": ["1989", "1990"],
    "Mirage G4 Black Edition": ["2022", "2023"],
    "Mirage G4 LE": ["2020", "2021", "2022", "2023", "2024"],
    "Van Base": ["1987", "1988", "1989", "1990"],
    "Van LS": ["1987", "1988", "1989", "1990"],
    "Precis LS": ["1987", "1988", "1989"],
    "Starion ES": ["1984", "1985"],
    "Starion LE": ["1984", "1985", "1986", "1987"],
    "Starion LS": ["1983", "1984", "1985"],
    "i-MiEV ES": ["2016", "2017"],
  },
  Nissan: {
    "350Z Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "350Z Enthusiast": ["2003", "2004", "2005", "2006", "2007", "2008", "2009"],
    "350Z Grand Touring": ["2005", "2006", "2007", "2008", "2009"],
    "350Z Nismo": ["2007", "2008"],
    "350Z Performance": ["2003", "2004", "2005"],
    "350Z Touring": ["2003", "2004", "2005", "2006", "2007", "2008", "2009"],
    "350Z Track": ["2003", "2004", "2005", "2006"],
    "370Z Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "370Z Nismo": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
    ],
    "370Z Nismo Tech": ["2015", "2016", "2017", "2018"],
    "370Z Sport": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "370Z Sport Tech": ["2015", "2016", "2017", "2018"],
    "370Z Touring": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "370Z Touring Sport": ["2015", "2016", "2017", "2018"],
    "Altima Base": [
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Altima GLE": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Altima GXE": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Altima Hybrid": ["2007", "2008", "2009", "2010", "2011"],
    "Altima S": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Altima SE": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Altima SE-R": ["2005", "2006"],
    "Altima SL": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Altima SR": [
      "2010",
      "2011",
      "2012",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Altima SV": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Altima XE": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Armada LE": ["2005", "2006", "2007", "2008", "2009"],
    "Armada Midnight Edition": ["2021", "2022", "2023", "2024"],
    "Armada Platinum": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Armada Platinum Reserve": ["2018", "2019", "2020"],
    "Armada S": ["2021", "2022", "2023"],
    "Armada SE": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "Armada SE Off-Road": ["2005", "2006"],
    "Armada SL": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Armada SV": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cube Base": ["2009", "2010", "2011", "2012"],
    "Cube Krom": ["2009", "2010", "2011"],
    "Cube S": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Cube SL": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Frontier Base": ["2002", "2003"],
    "Frontier Desert Runner": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Frontier LE": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "Frontier Nismo Off-Road": ["2005", "2006", "2007", "2008"],
    "Frontier PRO-4X": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Frontier PRO-X": ["2022", "2023", "2024"],
    "Frontier S": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Frontier SC": ["2001", "2002", "2003", "2004"],
    "Frontier SE": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Frontier SL": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Frontier SV": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Frontier SVE": ["2002", "2003", "2004"],
    "Frontier XE": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "GT-R Base": ["2009", "2010"],
    "GT-R Black Edition": ["2012", "2013", "2014", "2015", "2016"],
    "GT-R Nismo": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GT-R Premium": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GT-R Pure": ["2018", "2019"],
    "GT-R Track Edition": ["2014", "2015", "2018", "2019", "2020"],
    "Maxima GLE": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Maxima GXE": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Maxima Platinum": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Maxima S": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Maxima SE": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Maxima SL": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Maxima SR": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Maxima SV": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Murano CrossCabriolet": ["2011", "2012", "2013", "2014"],
    "Murano LE": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Murano Platinum": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Murano S": [
      "2005",
      "2006",
      "2007",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Murano SE": ["2003", "2004", "2005", "2006", "2007"],
    "Murano SL": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Murano SV": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "NV1500 S": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NV1500 SV": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NV200 S": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NV200 SV": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NV200 Taxi": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NV2500 S": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NV2500 SL": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "NV2500 SV": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NV3500 S": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NV3500 SL": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NV3500 SV": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Pathfinder LE": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Pathfinder Platinum": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "Pathfinder Platinum Hybrid": ["2014", "2015"],
    "Pathfinder S": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "Pathfinder SE": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Pathfinder SE Off-Road": ["2005", "2006", "2007", "2008", "2009"],
    "Pathfinder Silver Edition": ["2011", "2012"],
    "Pathfinder SL": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "Pathfinder SL Hybrid": ["2014", "2015"],
    "Pathfinder SV": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "Pathfinder SV Hybrid": ["2014", "2015"],
    "Pathfinder XE": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Quest Base": ["2005", "2006", "2007", "2008", "2009"],
    "Quest GLE": ["1999", "2000", "2001", "2002"],
    "Quest GXE": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Quest LE": ["2011", "2012", "2013", "2014"],
    "Quest Platinum": ["2015", "2016", "2017"],
    "Quest S": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Quest SE": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Quest SL": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Quest SV": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "Rogue S": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Rogue SL": [
      "2008",
      "2009",
      "2010",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Rogue SV": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Rogue Select S": ["2014", "2015"],
    "Sentra Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1995",
      "1996",
      "1997",
      "1998",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Sentra CA": ["2001", "2002"],
    "Sentra FE+S": ["2013", "2014", "2015", "2016"],
    "Sentra FE+SV": ["2013", "2014"],
    "Sentra GXE": [
      "1987",
      "1988",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Sentra S": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sentra SE": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Sentra SE-R": [
      "1991",
      "1992",
      "1993",
      "1994",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Sentra SE-R Spec V": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Sentra SL": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Sentra SR": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sentra SV": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sentra XE": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Titan LE": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "Titan Platinum Reserve": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Titan PRO-4X": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Titan S": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Titan SE": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "Titan SL": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Titan SV": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Titan XE": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "Titan XD Platinum Reserve": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Titan XD PRO-4X": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Titan XD S": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Titan XD SL": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Titan XD SV": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Versa S": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Versa SL": ["2007", "2008", "2009", "2010", "2011"],
    "Xterra Off-Road": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "Xterra PRO-4X": ["2011", "2012", "2013", "2014", "2015"],
    "Xterra S": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Xterra SE": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Xterra X": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Xterra XE": ["2000", "2001", "2002", "2003", "2004"],
    "370Z Heritage Edition": ["2018", "2019"],
    "370Z Sport Touring": ["2019", "2020"],
    "Z Performance": ["2023", "2024"],
    "Z Sport": ["2023", "2024"],
    "Juke Nismo": ["2013", "2014", "2015", "2016", "2017"],
    "Juke Nismo RS": ["2014", "2015", "2016", "2017"],
    "Juke S": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "Juke SL": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "Juke SV": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "Altima Platinum": ["2019", "2020", "2021", "2022"],
    "200SX SE": ["1987", "1988", "1995", "1996", "1997", "1998"],
    "200SX SE-R": ["1995", "1996", "1997", "1998"],
    "240SX Base": ["1991", "1992", "1993", "1995", "1996", "1997", "1998"],
    "240SX LE": ["1991", "1992", "1997", "1998"],
    "240SX SE": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "240SX XE": ["1989", "1990"],
    "280Z Base": ["1975", "1976", "1977", "1978"],
    "280ZX 2+2": ["1982", "1983"],
    "280ZX 2+2 GL": ["1980", "1981"],
    "280ZX 2+2 Turbo": ["1982", "1983"],
    "280ZX Base": ["1979", "1980", "1981", "1982", "1983"],
    "280ZX GL": ["1980", "1981"],
    "280ZX Turbo": ["1982", "1983"],
    "300ZX 2+2": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "300ZX Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "300ZX Turbo": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "620 Base": ["1975", "1976", "1977", "1978", "1979"],
    "720 Base": ["1980", "1981", "1982", "1983", "1984", "1985", "1986"],
    "720 Deluxe": ["1980", "1981", "1982", "1983", "1984", "1985", "1986"],
    "720 Sport Truck": ["1985", "1986"],
    "D21 Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "D21 E": ["1986", "1987", "1988", "1989"],
    "D21 XE": ["1986", "1987", "1988", "1989"],
    "Maxima GL": ["1982", "1983", "1984", "1985", "1986"],
    "NX SE": ["1991", "1992", "1993"],
    "NX XE": ["1991", "1992", "1993"],
    "Pickup Base": ["1995", "1996", "1997"],
    "Pickup SE": ["1995", "1996", "1997"],
    "Pickup XE": ["1995", "1996", "1997"],
    "Pulsar NX XE": ["1987", "1988", "1989", "1990"],
    "Sentra E": ["1987", "1988", "1989", "1991", "1992", "1993", "1994"],
    "Sentra GLE": ["1995", "1996", "1997", "1998"],
    "Stanza GXE": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Stanza XE": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Ariya Empower+": ["2023", "2024"],
    "Ariya Engage": ["2023", "2024"],
    "Ariya Engage+": ["2023", "2024"],
    "Ariya Evolve+": ["2023", "2024"],
    "Ariya Platinum+": ["2023", "2024"],
    "Ariya Venture+": ["2023", "2024"],
    "Pathfinder Rock Creek": ["2023", "2024"],
    "Rogue Platinum": ["2021", "2022", "2023", "2024"],
    "Kicks S": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Kicks SR": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Kicks SV": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Leaf S": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Leaf SL": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Leaf SV": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Rogue SL Hybrid": ["2017", "2018", "2019"],
    "Rogue SV Hybrid": ["2017", "2018", "2019"],
    "Rogue Sport S": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Rogue Sport SL": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Rogue Sport SV": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Sentra Nismo": ["2017", "2018", "2019"],
    "Sentra SR Turbo": ["2017", "2018", "2019"],
    "Versa SR": ["2020", "2021", "2022"],
    "Versa SV": ["2019", "2020", "2021", "2022"],
    "240Z Base": ["1970", "1971", "1972", "1973"],
    "280Z 2+2": ["1975", "1976", "1977", "1978"],
    "510 Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "610 Base": ["1973", "1974", "1975", "1976"],
    "810 Base": ["1977", "1978", "1979", "1980"],
    "D21 SE": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "260Z 2+2": ["1974", "1975"],
    "260Z Base": ["1974", "1975"],
    "200SX Base": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Versa 1.6": ["2009", "2010", "2011"],
    "Versa 1.6 Base": ["2009", "2010", "2011"],
    "Versa 1.6 S": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Versa 1.6 S Plus": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Versa 1.6 SL": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Versa 1.6 SV": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Versa Note S": ["2014", "2015", "2016", "2018", "2019"],
    "Versa Note S Plus": ["2014", "2015", "2016", "2017"],
    "Versa Note SL": ["2015", "2016", "2017"],
    "Versa Note SR": ["2015", "2016", "2017", "2018", "2019"],
    "Versa Note SV": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Pulsar NX Base": ["1983", "1984", "1985", "1986"],
    "Pulsar NX SE": ["1987", "1988", "1989"],
    "Pulsar NX Turbo": ["1983", "1984"],
    "Quest XE": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Sentra DX": ["1982", "1983", "1984", "1985", "1986"],
    "Stanza E": ["1987", "1988", "1989"],
    "Rogue Midnight Edition": ["2023", "2024"],
    "710 Base": ["1975", "1976", "1977"],
    "1200 Base": ["1971", "1972"],
    "210 Base": ["1979", "1980", "1981", "1982"],
    "310 Deluxe": ["1979", "1980", "1981", "1982"],
    "310 GX": ["1979", "1980", "1981", "1982"],
    "200SX Turbo": ["1984", "1985", "1986"],
    "200SX XE": ["1984", "1985", "1986", "1987", "1988"],
    "210 Deluxe": ["1980", "1981", "1982"],
    "Stanza Base": ["1982", "1983"],
    "Stanza GL": ["1983", "1984", "1985", "1986"],
    "Van E": ["1987", "1988"],
    "Van GXE": ["1987", "1988"],
    "Van XE": ["1987", "1988"],
    "521 Pickup Base": ["1968", "1969", "1971", "1972"],
    "620 Pickup Base": ["1972", "1973", "1974"],
    "410 Base": ["1963", "1964", "1965"],
    "411 Base": ["1963", "1964", "1965", "1966", "1967"],
    "520 Pickup Base": ["1965", "1966", "1967", "1968"],
    "Altra EV Base": ["1999", "2000", "2001"],
    "Leaf S Plus": ["2019", "2020", "2021", "2022"],
    "Leaf SL Plus": ["2019", "2020", "2021", "2022"],
    "Leaf SV Plus": ["2019", "2020", "2021", "2022", "2023", "2024"],
  },
  Plymouth: {
    "Colt Base": ["1988", "1989", "1990", "1991", "1992", "1993", "1994"],
    "Colt GL": ["1990", "1991", "1992", "1993", "1994"],
    "Colt Vista": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Colt Vista SE": ["1992", "1993", "1994"],
    "Laser RS": ["1990", "1991", "1992", "1993", "1994"],
    "Arrow Base": ["1976", "1977", "1978", "1979", "1980"],
    "Arrow GS": ["1976", "1977", "1978", "1979", "1980"],
    "Arrow GT": ["1976", "1977", "1978", "1979", "1980"],
    "Champ Base": ["1979", "1980", "1981", "1982"],
    "Champ Custom": ["1979", "1980", "1981", "1982"],
    "Laser Base": ["1990", "1991", "1992", "1993", "1994"],
    "Neon High Line": ["1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    "Neon LX": ["2000", "2001"],
    "Barracuda Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Barracuda Gran Coupe": ["1970", "1971"],
    "Belvedere Base": [
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
    ],
    "Belvedere Satellite": ["1968", "1969", "1970", "1971"],
    "Belvedere II Base": ["1965", "1966", "1967"],
    "Duster 340": ["1970", "1971", "1972", "1973"],
    "Duster 360": ["1974", "1975"],
    "Duster Base": ["1970", "1971", "1972", "1973", "1974", "1975"],
    "Fury Base": [
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Fury Custom Suburban": ["1970", "1971", "1972", "1973", "1974", "1975"],
    "Fury Salon": ["1976", "1977", "1978"],
    "Fury Sport": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Fury Sport GT": ["1970", "1971"],
    "Fury Sport Suburban": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Fury Suburban": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Fury VIP": ["1968", "1969"],
    "Fury I Base": ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "Fury I Suburban": ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "Fury II Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Fury II Custom Suburban": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Fury III Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Fury III Sport Suburban": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Gran Fury Base": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "Gran Fury Brougham": ["1975", "1976", "1977"],
    "Gran Fury Custom": ["1975", "1976"],
    "Gran Fury Custom Suburban": ["1972", "1973", "1974", "1975", "1976"],
    "Gran Fury Sport": ["1975", "1976", "1977"],
    "Gran Fury Sport Suburban": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
    ],
    "Gran Fury Suburban": ["1972", "1973", "1974", "1975", "1976", "1977"],
    "GTX Base": ["1967", "1968", "1969", "1970", "1971"],
    "PB100 Voyager": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "PB200 Voyager": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "PB300 Voyager": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Plaza Base": ["1954", "1955", "1956", "1957", "1958"],
    "Road Runner Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
    ],
    "Satellite Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Satellite Custom": ["1971", "1972", "1973", "1974"],
    "Satellite Regent": ["1971", "1972", "1973", "1974"],
    "Satellite Sebring": ["1971", "1972", "1973", "1974"],
    "Satellite Sebring Plus": ["1971", "1972", "1973", "1974"],
    "Satellite Sport": ["1968", "1969", "1970"],
    "Savoy Base": [
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
    ],
    "Savoy Deluxe": ["1960", "1961"],
    "Scamp Base": ["1971", "1972", "1973", "1974", "1975", "1976"],
    "Scamp Special": ["1975", "1976"],
    "Suburban Base": [
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
    ],
    "Suburban Custom": ["1956", "1957", "1958", "1959", "1960", "1961"],
    "Suburban Deluxe": ["1956", "1957", "1958", "1959"],
    "Suburban Sport": ["1956", "1957", "1958", "1959", "1960", "1961"],
    "Trailduster Base": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "Valiant 100": ["1968", "1969"],
    "Valiant 200": ["1960", "1961", "1962", "1963", "1964"],
    "Valiant Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "Valiant Brougham": ["1974", "1975"],
    "Valiant Signet": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "Volare Base": ["1976", "1977", "1978", "1979", "1980"],
    "Volare Custom": ["1976", "1977"],
    "Volare Premier": ["1976", "1977"],
    "Neon ACR": ["1998", "1999"],
    "Neon Base": ["1995", "1996", "1997"],
    "Neon Expresso": ["1998", "1999"],
    "Neon Sport": ["1995", "1996"],
    "Neon Style": ["1998", "1999"],
    "Acclaim Base": ["1989", "1990", "1991", "1992", "1993", "1994", "1995"],
    "Acclaim LE": ["1989", "1990", "1991"],
    "Acclaim LX": ["1989", "1990", "1991"],
    "Caravelle Base": ["1986", "1987", "1988"],
    "Caravelle SE": ["1985", "1986", "1987", "1988"],
    "Horizon America": ["1987", "1988", "1989"],
    "Horizon Base": ["1980", "1981", "1982", "1983", "1984", "1985", "1986"],
    "Horizon Miser": ["1981", "1982"],
    "Horizon SE": ["1984", "1985", "1986"],
    "Reliant America": ["1988", "1989"],
    "Reliant Base": ["1981", "1982", "1983", "1984", "1985", "1986", "1987"],
    "Reliant Custom": ["1981", "1982", "1983", "1984"],
    "Reliant LE": ["1985", "1986", "1987"],
    "Reliant SE": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "Sundance Base": ["1987", "1988", "1989", "1990", "1993", "1994"],
    "Sundance RS": ["1988", "1989", "1990", "1991"],
    "TC3 Base": ["1980", "1981"],
    "TC3 Miser": ["1981", "1982"],
    "Turismo Base": ["1983", "1984", "1985", "1986", "1987"],
    "Turismo 2.2 Base": ["1983", "1984", "1985", "1986"],
    "Gran Fury Salon": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "Grand Voyager Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Grand Voyager Expresso": ["1998", "1999"],
    "Grand Voyager LE": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Grand Voyager SE": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Prowler Base": ["1999", "2000", "2001"],
    "Sundance America": ["1991", "1992"],
    "Sundance Duster": ["1992", "1993", "1994"],
    "Sundance High Line": ["1991", "1992"],
    "Voyager Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Voyager Expresso": ["1998", "1999"],
    "Voyager LE": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Voyager LX": ["1990", "1991", "1992", "1993", "1994"],
    "Voyager SE": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "PB250 Voyager": ["1981", "1982", "1983"],
    "PB350 Voyager": ["1981", "1982", "1983"],
    "Breeze Base": ["1996", "1997", "1998", "1999", "2000"],
    "Breeze Expresso": ["1998", "1999"],
    "Colt DL": ["1984", "1985", "1986", "1987", "1988", "1989", "1990"],
    "Colt GT": ["1989", "1990"],
    "Cuda Base": ["1970", "1971", "1972", "1973", "1974"],
    "Arrow Pickup Base": ["1979", "1980", "1981", "1982"],
    "Arrow Pickup Sport": ["1979", "1980", "1981", "1982"],
    "Conquest Base": ["1984", "1985", "1986"],
    "Custom Base": ["1958", "1959", "1960", "1961"],
    "Fleet Special Base": ["1960", "1961", "1962", "1963"],
    "Sport Wagon Base": ["1960", "1961"],
    "PB150 Voyager": ["1981", "1982", "1983"],
    "Colt E": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "Colt Premier": ["1985", "1986", "1987", "1988"],
    "Sapporo Base": ["1980", "1981", "1982", "1983"],
  },
  Saturn: {
    "Vue Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "Vue Red Line": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "Outlook XE": ["2007", "2008", "2009", "2010"],
    "Outlook XR": ["2007", "2008", "2009", "2010"],
    "Vue XE": ["2008", "2009", "2010"],
    "Vue XR": ["2008", "2009", "2010"],
    "Sky Base": ["2007", "2008", "2009", "2010"],
    "Sky Red Line": ["2007", "2008", "2009", "2010"],
    "SC Base": ["1991", "1992"],
    "SC1 Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "SC2 Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "SL Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "SL1 Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "SL2 Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "SW1 Base": ["1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    "SW2 Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Vue Green Line": ["2007", "2008"],
    "Ion 2": ["2003", "2004", "2005", "2006", "2007"],
    "Ion 3": ["2003", "2004", "2005", "2006", "2007"],
    "Ion Red Line": ["2004", "2005", "2006", "2007"],
    "L200 Base": ["2001", "2002", "2003"],
    "L300 Base": ["2001", "2002", "2003"],
    "LW200 Base": ["2001", "2002", "2003"],
    "LW300 Base": ["2001", "2002", "2003"],
    "Relay 2": ["2005", "2006", "2007"],
    "Relay 3": ["2005", "2006", "2007"],
    "Aura XR": ["2007", "2008", "2009"],
    "Aura XE": ["2007", "2008", "2009"],
    "Ion 1": ["2003", "2004", "2005"],
    "Aura Green Line": ["2007", "2008"],
    "L100 Base": ["2001", "2002"],
  },
  Subaru: {
    "Ascent Base": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Ascent Limited": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Ascent Premium": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Ascent Touring": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Crosstrek Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Crosstrek Limited": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Crosstrek Premium": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Forester 2.0XT Premium": ["2014", "2015", "2016", "2017", "2018"],
    "Forester 2.0XT Touring": ["2014", "2015", "2016", "2017", "2018"],
    "Forester 2.5i": ["2014", "2015", "2016", "2017", "2018"],
    "Forester 2.5i Limited": ["2014", "2015", "2016", "2017", "2018"],
    "Forester 2.5i Premium": ["2014", "2015", "2016", "2017", "2018"],
    "Forester 2.5i Touring": ["2014", "2015", "2016", "2017", "2018"],
    "Forester Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Forester Limited": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Forester Premium": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Forester Sport": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Forester Touring": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Forester X": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Forester X Limited": ["2009", "2010", "2011", "2012", "2013"],
    "Forester X Premium": ["2009", "2010", "2011", "2012", "2013"],
    "Forester X Touring": ["2011", "2012", "2013"],
    "Forester XT Premium": ["2010", "2011", "2012", "2013"],
    "Forester XT Touring": ["2011", "2012", "2013"],
    "Impreza Base": [
      "1993",
      "1994",
      "1995",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Impreza Limited": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Impreza Premium": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Impreza Sport": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Impreza Sport Limited": ["2012", "2013", "2014", "2015", "2016"],
    "Impreza Sport Premium": ["2012", "2013", "2014", "2015", "2016"],
    "Impreza WRX": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Impreza WRX Limited": [
      "2006",
      "2007",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Impreza WRX Premium": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Impreza WRX STI": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Impreza WRX STI Limited": ["2011", "2012", "2013", "2014"],
    "Legacy 2.5i": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Legacy 2.5i Limited": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Legacy 2.5i Premium": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Legacy 2.5i Sport": ["2017", "2018", "2019"],
    "Outback 2.5i": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Outback 2.5i Limited": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Outback 2.5i Premium": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Outback 2.5i Touring": ["2017", "2018", "2019"],
    "WRX Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "WRX Limited": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "WRX Premium": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "WRX STI Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "WRX STI Limited": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "XV Crosstrek Hybrid": ["2014", "2015"],
    "XV Crosstrek Hybrid Touring": ["2014", "2015"],
    "XV Crosstrek Limited": ["2013", "2014", "2015"],
    "XV Crosstrek Premium": ["2013", "2014", "2015"],
    "B9 Tribeca Base": ["2006", "2007"],
    "B9 Tribeca Limited": ["2006", "2007"],
    "Forester XT Limited": ["2006", "2007", "2008", "2009", "2010"],
    "Impreza 2.5 GT": ["2009", "2010"],
    "Impreza 2.5i": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Impreza 2.5i Premium": ["2010", "2011"],
    "Impreza Outback Sport": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Legacy 2.5GT": ["2010", "2011", "2012"],
    "Legacy 2.5i Special Edition": ["2007", "2008", "2009"],
    "Legacy 3.0 R Limited": ["2008", "2009"],
    "Legacy 3.6R": ["2010", "2011", "2012", "2013"],
    "Legacy 3.6R Limited": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Legacy 3.6R Premium": ["2010", "2011", "2012"],
    "Legacy GT": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Legacy GT Limited": ["2000", "2001", "2002", "2007", "2008", "2009"],
    "Legacy GT spec.B": ["2006", "2007", "2008", "2009"],
    "Outback 3.6R": ["2010", "2011", "2012", "2013"],
    "Outback 3.6R Limited": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Outback 3.6R Premium": ["2010", "2011", "2012"],
    "Outback 3.6R Touring": ["2017", "2018", "2019"],
    "Outback R": ["2005", "2006"],
    "Outback R L.L. Bean Edition": ["2005", "2006", "2007", "2008"],
    "Outback XT": ["2005", "2006"],
    "Outback XT Limited": ["2005", "2006", "2007", "2008", "2009"],
    "Tribeca Base": ["2008", "2009"],
    "Tribeca Limited": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "Tribeca Premium": ["2010", "2011", "2012"],
    "Tribeca Touring": ["2010", "2011", "2012"],
    "Ascent Onyx Edition": ["2022", "2023", "2024"],
    "Ascent Onyx Edition Limited": ["2023", "2024"],
    "Crosstrek Hybrid": ["2019", "2020", "2021", "2022", "2023"],
    "Crosstrek Sport": ["2021", "2022", "2023", "2024", "2025"],
    "Crosstrek Wilderness": ["2024", "2025"],
    "Forester Wilderness": ["2022", "2023", "2024"],
    "Legacy Base": ["2020", "2021", "2022", "2023", "2024"],
    "Legacy Limited": ["2020", "2021", "2022", "2023", "2024"],
    "Legacy Limited XT": ["2020", "2021", "2022", "2023"],
    "Legacy Premium": ["2020", "2021", "2022", "2023", "2024"],
    "Legacy Sport": [
      "1991",
      "1992",
      "1993",
      "1994",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Legacy Touring XT": ["2020", "2021", "2022", "2023", "2024"],
    "Outback Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outback Limited": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outback Limited XT": ["2020", "2021", "2022", "2023", "2024"],
    "Outback Onyx Edition": ["2023", "2024"],
    "Outback Onyx Edition XT": ["2020", "2021", "2022", "2023", "2024"],
    "Outback Premium": ["2020", "2021", "2022", "2023", "2024"],
    "Outback Touring": ["2020", "2021", "2022", "2023", "2024"],
    "Outback Touring XT": ["2020", "2021", "2022", "2023", "2024"],
    "Outback Wilderness": ["2022", "2023", "2024"],
    "WRX GT": ["2022", "2023", "2024"],
    "Forester XT": ["2004", "2005"],
    "Impreza WRX TR": ["2006", "2007"],
    "Baja Turbo": ["2004", "2005", "2006"],
    "BRZ Limited": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "BRZ Premium": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2022",
      "2023",
      "2024",
    ],
    "Baja Sport": ["2003", "2004", "2005", "2006"],
    "Forester L": ["1998", "1999", "2000", "2001", "2002"],
    "Forester S": ["1998", "1999", "2000", "2001", "2002"],
    "Forester X L.L. Bean Edition": ["2006", "2007", "2008"],
    "Forester XS": ["2003", "2004", "2005"],
    "Impreza Brighton": ["1996", "1997"],
    "Impreza L": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Impreza LX": ["1995", "1996"],
    "Impreza Outback": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Impreza RS": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Impreza TS": ["2002", "2003", "2004"],
    "Legacy Brighton": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Legacy L": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Legacy LS": ["1990", "1991", "1992", "1993", "1994", "1995", "1996"],
    "Legacy LSi": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "Legacy Outback": ["1995", "1996", "1997", "1998", "1999"],
    "Legacy Postal": ["1995", "1996", "1997", "1998"],
    "Brat DL": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "DL Base": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "GF Base": ["1975", "1976", "1977", "1978", "1979"],
    "GL Base": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Outback H6": ["2002", "2003", "2004"],
    "Outback L.L. Bean": ["2001", "2002", "2003", "2004"],
    "Outback VDC": ["2001", "2002", "2003"],
    "Impreza LS": ["1993", "1994"],
    "Justy DL": ["1987", "1988", "1989", "1990"],
    "Justy GL": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Standard Base": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "SVX L": ["1994", "1995", "1996", "1997"],
    "SVX LS": ["1994", "1995"],
    "SVX LSi": ["1994", "1995", "1996", "1997"],
    "SVX LSL": ["1992", "1993"],
    "Brat GL": ["1980", "1981", "1982", "1983", "1984", "1985", "1986", "1987"],
    "Brat GL Turbo": ["1983", "1984"],
    "Deluxe Base": ["1972", "1973"],
    "GL Turbo": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "GL-10 Base": ["1985", "1986", "1987", "1988", "1989"],
    "GL-10 Turbo": ["1985", "1986", "1987", "1988", "1989"],
    "GLF Base": ["1980", "1981", "1982"],
    "Loyale Base": ["1990", "1991", "1992", "1993", "1994"],
    "RX Turbo": ["1985", "1986", "1987", "1988", "1989"],
    "XT DL": ["1985", "1986", "1987", "1988"],
    "XT GL": ["1985", "1986", "1987", "1988", "1989", "1990", "1991"],
    "XT GL-10 Turbo": ["1985", "1986", "1987"],
    "XT XT6": ["1988", "1989", "1990", "1991"],
    "Solterra Limited": ["2023", "2024"],
    "Solterra Premium": ["2023", "2024"],
    "Solterra Touring": ["2023", "2024"],
    "1400 Base": ["1973", "1974"],
  },
  Suzuki: {
    "Equator RMZ-4": ["2009", "2010", "2011", "2012"],
    "Equator Sport": ["2009", "2010", "2011", "2012"],
    "AN200 Burgman": ["2016", "2017", "2018", "2019", "2020"],
    "AN400 Burgman": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "AN400S Burgman Type S": ["2003", "2004", "2005", "2006"],
    "AN650 Burgman": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2013",
      "2014",
      "2015",
    ],
    "AN650A Burgman Executive": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2016",
      "2017",
      "2018",
    ],
    "DL1000 V-Strom": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
    ],
    "DL1000 V-Strom Adventure ABS": ["2014", "2015", "2016"],
    "DL650 V-Strom": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2019",
      "2020",
      "2021",
    ],
    "DL650 V-Strom Adventure ABS": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "DL650 V-Strom XT": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "DL650A V-Strom ABS": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "DR-Z110": ["2003", "2004", "2005", "2006"],
    "DR-Z125": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "DR-Z125L": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "DR-Z250 Non CA Model": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "DR-Z400": ["2000", "2001", "2002", "2003", "2004"],
    "DR-Z400E Non CA Model": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "DR-Z400S": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "DR-Z400SM": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "DR-Z70": ["2008", "2009", "2015", "2016", "2017", "2018"],
    DR100: ["1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990"],
    DR125: ["1982", "1983", "1984", "1985", "1986", "1987", "1988"],
    DR125SE: [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    DR200: ["1986", "1987", "1988"],
    DR200S: ["2015", "2016", "2017", "2018", "2019", "2020"],
    DR200SE: [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2015",
      "2016",
      "2017",
    ],
    DR250: ["1982", "1983", "1984", "1985", "1990", "1991", "1992", "1993"],
    DR250SE: ["1990", "1991", "1992", "1993", "1994", "1995"],
    DR350: [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    DR350S: ["1990", "1991", "1992", "1993", "1994", "1995", "1996"],
    DR350SE: [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    DR370: ["1978", "1979"],
    DR400: ["1982", "1983"],
    DR500: ["1981", "1982", "1983", "1984"],
    DR650S: [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    DR650SE: [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    DR650SES: ["1991", "1992", "1993", "1994", "1995"],
    DS100: ["1978", "1979", "1980", "1981"],
    DS125: ["1979", "1980", "1981"],
    DS185: ["1978", "1979", "1980"],
    DS80: [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    FA50: [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    FS50: ["1980", "1981"],
    FZ50: ["1979", "1980", "1981", "1982", "1983"],
    GN125E: [
      "1982",
      "1983",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    GN250: ["1982", "1983"],
    GN400: ["1980", "1981", "1982"],
    GS1000: ["1978", "1979", "1980", "1981", "1982", "1983", "1984"],
    GS1000E: ["1978", "1979", "1980"],
    GS1000G: ["1980", "1981", "1982", "1983"],
    GS1000GL: ["1980", "1981", "1982", "1983"],
    GS1000S: ["1979", "1980", "1981", "1982", "1983"],
    GS1100E: ["1980", "1981", "1982", "1983"],
    GS1100G: ["1982", "1983"],
    GS1100GK: ["1982", "1983", "1984", "1985", "1986"],
    GS1100GL: ["1981", "1982", "1983"],
    GS1100L: ["1980", "1981"],
    GS1150E: ["1983", "1984", "1985", "1986"],
    GS250T: ["1980", "1981"],
    GS300L: ["1982", "1983", "1984", "1985"],
    GS400X: ["1977", "1978"],
    GS425E: ["1979", "1980"],
    GS450E: [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    GS450GA: ["1982", "1983", "1984", "1985"],
    GS450L: ["1980", "1981", "1982", "1983", "1985", "1986", "1987", "1988"],
    GS450S: ["1980", "1981", "1982", "1983"],
    GS450T: ["1981", "1982", "1983"],
    GS450TX: ["1981", "1982", "1983"],
    GS500E: [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    GS500F: ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    GS550: ["1977", "1978", "1979"],
    GS550E: [
      "1977",
      "1978",
      "1979",
      "1980",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    GS550ES: ["1983", "1984", "1985", "1986"],
    GS550L: ["1979", "1980", "1981", "1982", "1983", "1984", "1985", "1986"],
    GS650E: ["1981", "1982"],
    GS650G: ["1981", "1982", "1983", "1984"],
    GS650GL: ["1981", "1982", "1983", "1984"],
    GS750: ["1980", "1981", "1982", "1983", "1984", "1985"],
    GS750B: ["1978", "1979"],
    GS750E: ["1978", "1979", "1980", "1981", "1982", "1983"],
    GS750L: ["1979", "1980", "1981"],
    GS750T: ["1982", "1983"],
    GS850G: ["1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    GS850GL: ["1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    "GSF1200S Bandit": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "GSF1250S Bandit": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "GSF1250SA Bandit ABS": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "GSF400 Bandit": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "GSF600S Bandit": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "GSX-R1000": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GSX-R1000R": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "GSX-R1100": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "GSX-R1300 Hayabusa": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GSX-R1300 LE Hayabusa": ["2012", "2013", "2014"],
    "GSX-R600": [
      "1992",
      "1993",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GSX-R750": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GSX-S1000": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "GSX-S1000F": ["2016", "2017", "2018", "2020", "2021"],
    "GSX-S750": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "GSX-S750Z": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "GSX1100F Katana": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    GSX1100G: ["1991", "1992", "1993", "1994", "1995", "1996"],
    GSX1250FA: ["2011", "2012"],
    "GSX1300BK B-King": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "GSX600F Katana": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    GSX650F: ["2008", "2009", "2010", "2011", "2012"],
    "GSX750F Katana": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    GT185: ["1973", "1974", "1975", "1976", "1977"],
    GT250: ["1973", "1974", "1975", "1976", "1977"],
    GT380: ["1972", "1973", "1974", "1975", "1976", "1977"],
    GT500: ["1976", "1977"],
    GT550: ["1972", "1973", "1974", "1975", "1976", "1977"],
    "GT750 Le Mans": ["1972", "1973", "1974", "1975", "1976", "1977"],
    "GV1200 Madura": ["1985", "1986"],
    "GV1400 Cavalcade": ["1986", "1987", "1988", "1989"],
    "GV700GL Madura": ["1985", "1986"],
    "GZ250 Marauder": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    Jr50: [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    Jr80: ["2001", "2002", "2003", "2004"],
    "LS650B S40 Boulevard": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "LS650P Savage": [
      "1986",
      "1987",
      "1988",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    OR50: ["1979", "1980"],
    Pe175: ["1978", "1979", "1980", "1981", "1982", "1983", "1984"],
    Pe250: ["1977", "1978", "1979", "1980", "1981"],
    Pe400: ["1980", "1981"],
    RF600R: ["1993", "1994", "1995", "1996", "1997", "1998"],
    RF900R: ["1994", "1995", "1996", "1997"],
    "RM-Z250": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "RM-Z450": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    RM100: ["1976", "1977", "1978", "1979", "1980", "1981"],
    RM125: [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    RM250: [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    RM370: ["1976", "1977"],
    RM400: ["1978", "1979", "1980"],
    RM465: ["1981", "1982"],
    RM50: ["1978", "1979", "1980"],
    RM500: ["1983", "1984"],
    RM60: ["1979", "1980", "1981", "1982", "1983"],
    RM65: ["2003", "2004", "2005"],
    RM80: [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    RM85: [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    RM85L: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    RMX250: [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    RMX450Z: [
      "2005",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    RS175: ["1980", "1981", "1982"],
    RS250: ["1980", "1981"],
    RV125: ["1973", "1974", "1975", "1976", "1977"],
    RV90: ["1972", "1973", "1974", "1975", "1976", "1977"],
    "SFV650 Gladius": ["2009", "2010", "2011", "2013", "2014", "2015"],
    Sp125: ["1982", "1983", "1986", "1987", "1988"],
    Sp200: ["1986", "1987", "1988"],
    Sp250: ["1982", "1983", "1984", "1985"],
    Sp370: ["1978", "1979"],
    Sp500: ["1981", "1982", "1983"],
    SV1000: ["2003", "2004", "2006", "2007"],
    SV1000S: ["2003", "2004", "2005", "2006", "2007"],
    SV650: [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "SV650A ABS": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    SV650S: [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "SV650SA ABS": ["2007", "2008", "2009", "2010", "2011", "2012"],
    T350: ["1971", "1972"],
    "T500 Titan": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
    ],
    TC100: ["1973", "1974", "1975", "1976", "1977"],
    TC125: ["1971", "1972", "1973", "1974", "1975", "1976", "1977"],
    TC185: ["1974", "1975", "1976", "1977"],
    TL1000R: ["1998", "1999", "2000", "2001", "2002", "2003"],
    TL1000S: ["1997", "1998", "1999", "2000", "2001"],
    Tm100: ["1974", "1975"],
    Tm125: ["1973", "1974", "1975"],
    Tm250: ["1972", "1973", "1974", "1975"],
    Tm400: ["1971", "1972", "1973", "1974", "1975"],
    Tm75: ["1974", "1975", "1976"],
    Ts100: [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    Ts125: [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    Ts185: [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    Ts250: [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    Ts400: ["1972", "1973", "1974", "1975", "1976", "1977"],
    Ts50: ["1971", "1972", "1973", "1974"],
    Ts75: ["1975", "1976", "1977"],
    TU250X: [
      "1998",
      "1999",
      "2000",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "VanVan 200": ["2017", "2018", "2019"],
    "VL1500 C90 Boulevard": ["2005", "2006", "2007", "2008", "2009"],
    "VL1500 C90 Boulevard Black": ["2005", "2006", "2007", "2008"],
    "VL1500 Intruder LC": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "VL1500B C90 Boulevard B.O.S.S.": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "VL1500BT C90T Boulevard Touring B.O.S.S.": ["2013", "2014"],
    "VL1500T C90T Boulevard Touring": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "VL800 C50 Boulevard (spoke wheels)": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "VL800 Intruder Volusia": ["2001", "2002", "2003", "2004"],
    "VL800C C50SE Boulevard (cast wheels)": [
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
    ],
    "VL800T C50T Boulevard Touring": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "VLR1800 C109R Boulevard": ["2008", "2009"],
    "VLR1800T C109RT Boulevard Touring": ["2008", "2009"],
    "VS1400 S83 Boulevard": ["2005", "2006", "2007", "2008", "2009"],
    "VS1400GLP Intruder": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "VS700 Intruder": ["1985", "1986", "1987", "1988"],
    "VS750GL Intruder": ["1987", "1988", "1989", "1990", "1991"],
    "VS800 S50 Boulevard": ["2005", "2006", "2007", "2008", "2009"],
    "VS800GL Intruder": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    VX800: ["1990", "1991", "1992", "1993"],
    "VZ1500 M90 Boulevard": ["2013", "2014", "2015", "2017", "2018", "2019"],
    "VZ800 M50 Boulevard": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
    ],
    "VZ800 M50 Boulevard Black": ["2005", "2006"],
    "VZ800 Marauder": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "VZR1800 M109R Boulevard": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "VZR1800B M109R Boulevard B.O.S.S.": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "VZR1800N M109R2 Boulevard": ["2008", "2009"],
    "VZR1800Z M109RZ Boulevard LE": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XN85 Turbo": ["1983", "1984", "1985", "1986"],
    "Swift Base": ["1995", "1996", "1997", "1998", "1999"],
    "Swift GA": ["1990", "1991", "1992", "1993", "1994", "2000", "2001"],
    "Swift GLX": ["1989", "1990"],
    "Swift GS": ["1990", "1991", "1992", "1993", "1994"],
    "Swift GT": ["1990", "1991", "1992", "1993", "1994"],
    "Lt-Z400 QuadSport Z": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "Lt-R450 Quadracer": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Lt-V700F Twin Peaks 700 4X4 [SRA]": ["2004", "2005", "2006"],
    "LT-A400 Eiger 2X4 Auto [SRA]": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "LT-A400F Eiger 4X4 Auto [SRA]": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "LT-A400F KingQuad AS [SRA]": ["2008", "2009", "2010"],
    "LT-A400F KingQuad ASi [IRS]": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "LT-A450X KingQuad AXi 4X4 [IRS]": ["2007", "2008", "2009", "2010"],
    "LT-A500F QuadMaster [SRA]": ["2000", "2001"],
    "Lt-A500F Vinson 500 4X4 Auto [SRA]": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "LT-A500X KingQuad AXi [IRS]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "LT-A500XP KingQuad AXi EPS [IRS]": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Lt-A700X KingQuad 4X4 [IRS]": ["2005", "2006", "2007"],
    "LT-A750X KingQuad AXi [IRS]": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "LT-A750XP KingQuad AXi EPS [IRS]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "LT-F400 Eiger 2X4 [SRA]": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "LT-F400F Eiger 4X4 [SRA]": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "LT-F400F KingQuad FSi [SRA]": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "LT-F500F QuadRunner 4X4 [SRA]": ["1998", "1999", "2000", "2001", "2002"],
    "Lt-F500F Vinson 500 4X4 [SRA]": ["2003", "2004", "2005", "2006", "2007"],
    "DR-Z250 CA Model": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "DR-Z400E CA Model": ["2004", "2005", "2006", "2007"],
    "LT-4WD Quadrunner 250 [IRS]": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "LT-4WDX King Quad 250 [IRS]": ["1996", "1997", "1998"],
    "Lt-F160 QuadRunner": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2003",
      "2004",
    ],
    "Lt-F230": ["1986", "1987"],
    "LT-F250 Ozark [SRA]": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Lt-F250 QuadRunner [IRS]": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "LT-F250F QuadRunner 4X4 [IRS]": ["1999", "2000", "2001", "2002"],
    "LT-F300F KingQuad 4X4 [IRS]": ["1999", "2000", "2001", "2002"],
    "Lt-Z250 QuadSport Z": ["2004", "2005", "2006", "2007", "2008", "2009"],
    Lt160E: ["1989", "1990", "1991", "1992"],
    "Lt230E Quadrunner": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    Lt230Ge: ["1985", "1986"],
    "Lt230S Quadsport": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "Lt250S Quadsport": ["1989", "1990"],
    Alt125: ["1983", "1984", "1985", "1986"],
    Alt185: ["1984", "1985"],
    "LT-Z90 QuadSport": [
      "2007",
      "2008",
      "2009",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    Lt125: ["1983", "1984", "1985", "1986", "1987"],
    Lt185: ["1984", "1985", "1986", "1987"],
    "DL1000 V-Strom Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2018",
      "2019",
    ],
    "DL1000 V-Strom ABS Base": ["2014", "2015", "2016"],
    "DL1000 V-Strom ABS Adventure Base": ["2014", "2015", "2016"],
    "DL650A V-Strom ABS Base": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "DL650A V-Strom XT ABS Base": ["2015", "2016", "2017", "2018"],
    "GSX-R1000 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "GSX-R600 Base": [
      "1992",
      "1993",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "GSX-R750 Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "GSX1300R Hayabusa Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "GSX1300R Hayabusa Limited Edition Base": ["2012", "2013"],
    "Forenza Base": ["2006", "2007", "2008"],
    "Forenza EX": ["2004", "2005"],
    "Forenza LX": ["2004", "2005"],
    "Forenza S": ["2004", "2005"],
    "Grand Vitara Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Grand Vitara Limited": [
      "2000",
      "2001",
      "2002",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Grand Vitara Luxury": ["2006", "2007", "2008", "2009"],
    "Grand Vitara Premium": ["2009", "2010", "2011", "2012", "2013"],
    "Grand Vitara XSport": ["2006", "2007", "2008", "2009", "2010"],
    "GSF1250S Bandit Base": ["2007", "2008", "2009"],
    "GSF1250SA Bandit ABS Base": ["2007", "2008", "2009"],
    "GSX650F Base": ["2008", "2009"],
    "Kizashi S": ["2010", "2011", "2012"],
    "Kizashi SE": ["2010", "2011", "2012", "2013"],
    "Kizashi Sport GTS": ["2011", "2012"],
    "Kizashi Sport SLS": ["2011", "2012"],
    "Reno Base": ["2006", "2007", "2008"],
    "UH200 Burgman ABS Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Verona EX": ["2004", "2005"],
    "Verona LX": ["2004", "2005"],
    "Verona S": ["2004", "2005"],
    "Samurai JA": ["1986", "1987", "1988", "1991", "1992", "1993"],
    "Samurai JL": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "Samurai JX": ["1986", "1987", "1988"],
    "Samurai JX SE": ["1986", "1987"],
    "Equator Base": ["2009", "2010", "2011", "2012"],
    "Equator Premium": ["2009", "2010", "2011", "2012"],
    "Sidekick JLX": ["1989", "1990", "1991", "1992", "1993", "1994", "1995"],
    "Sidekick JLX Sport": ["1996", "1997", "1998"],
    "Sidekick JS": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Sidekick JS Sport": ["1997", "1998"],
    "Sidekick JX": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Sidekick JX Sport": ["1996", "1997", "1998"],
    "SX4 Base": ["2007", "2008", "2009", "2010"],
    "SX4 Crossover": ["2010", "2011", "2012", "2013"],
    "SX4 LE": ["2010", "2011", "2012", "2013"],
    "SX4 Sport": ["2007", "2008", "2009"],
    "SX4 Sport GTS": ["2010", "2011"],
    "SX4 Sport S": ["2010", "2011"],
    "SX4 Sport SE": ["2010", "2011", "2012", "2013"],
    "SX4 Sportback": ["2010", "2011", "2012", "2013"],
    "Aerio Base": ["2006", "2007"],
    "Aerio GS": ["2002", "2003"],
    "Aerio LX": ["2004", "2005"],
    "Aerio Premium": ["2006", "2007"],
    "Aerio S": ["2002", "2003", "2004", "2005"],
    "Aerio SX": ["2002", "2003", "2004", "2005", "2006"],
    "Grand Vitara EX": ["2004", "2005"],
    "Grand Vitara JLS": ["2000", "2001", "2002"],
    "Grand Vitara JLS Plus": ["2000", "2001"],
    "Grand Vitara JLX": ["1999", "2000", "2001", "2002"],
    "Grand Vitara JLX Plus": ["1999", "2000", "2001"],
    "Grand Vitara LX": ["2004", "2005"],
    "XL-7 EX": ["2004", "2005"],
    "XL-7 Limited": ["2002", "2003", "2007", "2008", "2009"],
    "XL-7 LX": ["2004", "2005"],
    "XL-7 Touring": ["2002", "2003"],
    "Esteem GL": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Esteem GLX": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Esteem GLX Plus": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Swift GL": ["2000", "2001"],
    "X-90 Base": ["1996", "1997", "1998"],
    "LT-F4WDX KingQuad 300 [IRS]": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "DL800 V-Strom 800 DE": ["2023", "2024"],
    "DL1050 V-Strom": ["2020", "2021", "2022", "2023", "2024"],
    "GSF1250 Bandit": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "GSX-8S": ["2023", "2024", "2025"],
    Lt160: ["2003", "2004"],
    "Lt250R Quadracer": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "GSX-S1000Z": ["2018", "2019"],
    "LT-A500XP KingQuad AXi EPS SE [IRS]": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "LT-A500XP KingQuad AXi EPS SE+ [IRS]": ["2019", "2020", "2021", "2022"],
    "LT-A750XP KingQuad AXi EPS SE [IRS]": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "LT-A750XP KingQuad AXi EPS SE+ [IRS]": ["2019", "2020", "2021", "2022"],
    "GS1000S Katana": ["2019", "2020", "2021", "2022"],
    "GSX-S750 ABS": ["2019", "2020", "2021"],
    SV650X: ["2019", "2020", "2021", "2022", "2023"],
    "LT-A400 King Quad": ["2008", "2009"],
    "LT-A400F KingQuad ASi SE+ [IRS]": ["2019", "2020", "2021", "2022"],
    GSX250R: ["2018", "2019", "2020", "2021"],
    "GSX-R1000 ABS": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "DL1050 V-Strom Adventure XT": ["2020", "2021", "2022", "2023", "2024"],
    "DL800 V-Strom 800 DE Adventure": ["2023", "2024"],
    Alt50: ["1983", "1984"],
    "Lt50 Quadrunner": ["1984", "1985", "1986", "1987"],
    "Lt80 Quadsport": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Lt500R Quadracer": ["1987", "1988", "1989", "1990"],
    "Lt-A50 QuadMaster": ["2002", "2003", "2004", "2005"],
    "DR-Z50": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "GSX-S1000GT": ["2022", "2023"],
    Lt250Ef: ["1985", "1986"],
    "LT-Z50 QuadSport": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "GSX-R1000RZ": ["2022", "2023"],
    "GSX-R600Z": ["2022", "2023"],
    "GSX-R750Z": ["2022", "2023"],
    Lt300E: ["1987", "1988", "1989"],
    "XL-7 Base": ["2006", "2007", "2008"],
    "XL-7 Luxury": ["2007", "2008", "2009"],
    "XL-7 Premium": ["2008", "2009"],
    "AN650 Burgman Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "AN650A Burgman ABS Base": ["2013", "2014", "2015"],
    "AN650A Burgman ABS Executive Base": ["2016", "2017", "2018"],
    "AN650A Burgman Executive Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
    ],
    "GSX1100G Base": ["1991", "1992", "1993"],
    "LT-A400 Eiger 2x4 Auto Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "LT-A400F Eiger 4x4 Auto Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "LT-A400F KingQuad AS Base": ["2008", "2009", "2010"],
    "LT-A400F KingQuad ASi Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "LT-A400F KingQuad ASi SE Base": ["2017", "2018"],
    "LT-A450X KingQuad AXi 4x4 Base": ["2007", "2008", "2009", "2010"],
    "LT-F400 Eiger 2x4 Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "LT-F400F Eiger 4x4 Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "LT-F400F KingQuad FS Base": ["2008", "2009", "2010"],
    "LT-F400F KingQuad FSi Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "LT-V700F Twin Peaks 700 4x4 Base": ["2004", "2005"],
    "SV1000/S Base": ["2003", "2004", "2005", "2006", "2007"],
    "Vitara JLX": ["2000", "2001", "2002"],
    "Vitara JX": ["1999", "2000", "2001"],
    "Vitara JLS": ["2000", "2001", "2002"],
    "Vitara JS": ["1999", "2000", "2001"],
    "GSF650S Bandit": ["2005", "2006", "2007"],
    "Alt125 Base": ["1983", "1984", "1985", "1986"],
    "Alt50 Base": ["1983", "1984"],
    "C109R Boulevard Base": ["2008", "2009"],
    "C109RT Boulevard Base": ["2008", "2009"],
    "C50 Boulevard Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "C50B Boulevard Base": ["2005", "2006", "2007", "2008"],
    "C50C Boulevard Base": ["2006", "2007", "2008"],
    "C50T Boulevard Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "C90 Boulevard Base": ["2005", "2006", "2007", "2008", "2009"],
    "C90 Boulevard B.O.S.S. Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "C90B Boulevard Base": ["2005", "2006", "2007", "2008"],
    "C90T Boulevard Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "DL650 V-Strom Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "DL650A V-Strom ABS Adventure Base": ["2012", "2013", "2014", "2015"],
    "DL650A V-Strom XT Base": ["2019", "2020"],
    "DR-Z110 Base": ["2003", "2004", "2005"],
    "DR-Z125 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "DR-Z125L Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "DR-Z250 Base": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "DR-Z400 Base": ["2000", "2001", "2002", "2003", "2004"],
    "DR-Z400E Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "DR-Z400S Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "DR-Z400SM Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "DR-Z50 Base": ["2019", "2020"],
    "DR-Z70 Base": ["2008", "2009", "2015", "2016", "2017", "2018"],
    "DR100 Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "DR125 Base": ["1982", "1983", "1984", "1985", "1986", "1987", "1988"],
    "DR125SE Base": ["1994", "1995", "1996"],
    "DR200 Base": ["1986", "1987", "1988"],
    "DR200S Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "DR200SE Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "DR250 Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "DR250SE Base": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "DR350 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "DR350S Base": ["1990", "1991", "1992", "1993"],
    "DR350SE Base": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "DR500 Base": ["1981", "1982", "1983"],
    "DR650S Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "DR650SE Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "DR650SES Base": ["1992", "1993", "1994", "1995"],
    "DS100 Base": ["1980", "1981"],
    "DS125 Base": ["1980", "1981"],
    "DS80 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "GN125E Base": [
      "1982",
      "1983",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "GN250 Base": ["1982", "1983"],
    "GN400 Base": ["1980", "1981", "1982"],
    "GS1000G Base": ["1980", "1981"],
    "GS1000GL Base": ["1980", "1981"],
    "GS1100E Base": ["1980", "1981", "1982", "1983"],
    "GS1100G Base": ["1982", "1983"],
    "GS1100GK Base": ["1982", "1983"],
    "GS1100GL Base": ["1982", "1983"],
    "GS1150E Base": ["1984", "1985", "1986"],
    "GS250T Base": ["1980", "1981"],
    "GS300L Base": ["1982", "1983"],
    "GS450E Base": ["1980", "1981", "1982", "1983"],
    "GS450GA Base": ["1982", "1983"],
    "GS450L Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "GS450S Base": ["1980", "1981"],
    "GS450T Base": ["1981", "1982"],
    "GS450TX Base": ["1981", "1982", "1983"],
    "GS500 Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "GS500F Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "GS550E Base": ["1983", "1984", "1985", "1986"],
    "GS550ES Base": ["1983", "1984", "1985", "1986"],
    "GS550L Base": ["1980", "1981", "1982", "1983", "1984", "1985", "1986"],
    "GS650E Base": ["1981", "1982"],
    "GS650G Base": ["1981", "1982", "1983"],
    "GS650GL Base": ["1981", "1982", "1983"],
    "GS750E Base": ["1980", "1981", "1982", "1983"],
    "GS750L Base": ["1980", "1981"],
    "GS750T Base": ["1982", "1983"],
    "GS850G Base": ["1980", "1981", "1982", "1983"],
    "GS850GL Base": ["1980", "1981", "1982", "1983", "1984"],
    "GSF1200S Bandit Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "GSF400 Bandit Base": ["1991", "1992", "1993"],
    "GSF600S Bandit Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "GSX-R1000 ABS Base": ["2017", "2018"],
    "GSX-R1000R Base": ["2017", "2018", "2019", "2020"],
    "GSX-R1100 Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "GSX-S1000 Base": ["2016", "2017"],
    "GSX-S1000 ABS Base": ["2016", "2017", "2018", "2019", "2020"],
    "GSX-S1000F ABS Base": ["2016", "2017", "2018"],
    "GSX-S1000Z Base": ["2018", "2019"],
    "GSX-S750 Base": ["2015", "2016"],
    "GSX-S750Z Base": ["2018", "2019"],
    "GSX1100F Katana Base": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "GSX250R Base": ["2018", "2019", "2020"],
    "GSX250R ABS Base": ["2019", "2020"],
    "GSX600F Katana Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "GSX750F Katana Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "GV1200 Madura Base": ["1985", "1986"],
    "GV1400 Cavalcade Base": ["1986", "1987", "1988", "1989"],
    "GV700GL Madura Base": ["1985", "1986"],
    "GZ250 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Jr50 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Jr80 Base": ["2001", "2002", "2003", "2004"],
    "LS650 Savage Base": [
      "1986",
      "1987",
      "1988",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "LT-4WD QuadRunner 250 Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "LT-4WDX King Quad 250 Base": ["1996", "1997", "1998"],
    "LT-A400F KingQuad ASi+ Base": ["2019", "2020"],
    "Lt-A50 QuadMaster Base": ["2002", "2003", "2004", "2005"],
    "LT-A500 KingQuad AXi Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "LT-A500 KingQuad AXi Power Steering Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "LT-A500 KingQuad AXi Power Steering SE Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "LT-A500 KingQuad AXi Power Steering SE+ Base": ["2019", "2020"],
    "LT-A500F QuadMaster Base": ["2000", "2001"],
    "LT-A500F Vinson 500 4x4 Auto Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "LT-A700X KingQuad 4x4 Base": ["2005", "2006", "2007"],
    "LT-A750 KingQuad AXi Power Steering Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "LT-A750 KingQuad AXi Power Steering LE Base": ["2014", "2015"],
    "LT-A750 KingQuad AXi Power Steering SE Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "LT-A750 KingQuad AXi Power Steering SE+ Base": ["2019", "2020"],
    "LT-A750X KingQuad AXi 4x4 Base": [
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Lt-F160 QuadRunner Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2003",
      "2004",
    ],
    "Lt-F230 Base": ["1986", "1987"],
    "LT-F250 Ozark Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "LT-F250 QuadRunner Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "LT-F250F QuadRunner 4x4 Base": ["1999", "2000", "2001", "2002"],
    "LT-F300F KingQuad 4x4 Base": ["1999", "2000", "2001", "2002"],
    "LT-F4WDX King Quad 300 Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "LT-F500F QuadRunner 4x4 Base": ["1998", "1999", "2000", "2001", "2002"],
    "LT-F500F Vinson 500 4x4 Base": ["2003", "2004", "2005", "2006", "2007"],
    "Lt-R450 Quadracer Base": ["2006", "2007", "2008", "2009"],
    "Lt-Z250 QuadSport Z Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Lt-Z400 QuadSport Z Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "LT-Z50 QuadSport Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "LT-Z90 QuadSport Base": [
      "2007",
      "2008",
      "2009",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Lt125 Base": ["1983", "1984", "1985", "1986", "1987"],
    "Lt160 Base": ["2003", "2004"],
    "Lt160E Base": ["1989", "1990", "1991", "1992"],
    "Lt185 Base": ["1984", "1985", "1986", "1987"],
    "Lt230E Quadrunner Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Lt230Ge Base": ["1985", "1986"],
    "Lt230S Quadsport Base": ["1985", "1986", "1987", "1988"],
    "Lt250Ef Base": ["1985", "1986"],
    "Lt250R Quadracer Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "LT250S Base": ["1989", "1990"],
    "Lt300E Base": ["1987", "1988", "1989"],
    "Lt50 Quadrunner Base": ["1984", "1985", "1986", "1987"],
    "Lt500R Quadracer Base": ["1987", "1988", "1989", "1990"],
    "Lt80 Quadsport Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "M109R Boulevard Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "M109R Boulevard B.O.S.S. Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "M109R2 Boulevard Base": ["2008", "2009"],
    "M109RZ Boulevard Limited Base": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "M50 Boulevard Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "M50B Boulevard Base": ["2005", "2006"],
    "M90 Boulevard Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Pe175 Base": ["1980", "1981", "1982", "1983", "1984"],
    "Pe250 Base": ["1980", "1981"],
    "Pe400 Base": ["1980", "1981"],
    "RF600 Base": ["1994", "1995", "1996"],
    "RF900 Base": ["1994", "1995", "1996", "1997"],
    "RM100 Base": ["1980", "1981"],
    "RM125 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "RM250 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "RM465 Base": ["1981", "1982"],
    "RM500 Base": ["1983", "1984"],
    "RM60 Base": ["1980", "1981", "1982", "1983"],
    "RM65 Base": ["2003", "2004", "2005"],
    "RM80 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "RM85 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "RM85L Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "RMX250 Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "RMX450Z Base": ["2017", "2018", "2019"],
    "RMZ250 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "RMZ450 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "RS175 Base": ["1980", "1981", "1982"],
    "RS250 Base": ["1980", "1981"],
    "RV200 VanVan 200 Base": ["2018", "2019"],
    "S40 Boulevard Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "S50 Boulevard Base": ["2005", "2006", "2007", "2008", "2009"],
    "S83 Boulevard Base": ["2005", "2006", "2007", "2008"],
    "SFV650 Base": ["2013", "2014", "2015"],
    "Sp125 Base": ["1982", "1983", "1986", "1987", "1988"],
    "Sp200 Base": ["1986", "1987", "1988"],
    "Sp250 Base": ["1982", "1983", "1984", "1985"],
    "Sp500 Base": ["1981", "1982", "1983"],
    "SV650 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "SV650 ABS Base": ["2017", "2018", "2019", "2020"],
    "SV650A ABS Base": ["2007", "2008"],
    "SV650S Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "SV650SA ABS Base": ["2007", "2008", "2009"],
    "SV650X Base": ["2019", "2020"],
    "TL1000R Base": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "TL1000S Base": ["1997", "1998", "1999", "2000", "2001"],
    "Ts100 Base": ["1980", "1981"],
    "Ts125 Base": ["1980", "1981"],
    "Ts185 Base": ["1980", "1981"],
    "TS200R Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Ts250 Base": ["1980", "1981"],
    "TU250X Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "VL1500 Intruder Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "VL800 Intruder Volusia Base": ["2001", "2002", "2003", "2004"],
    "VS1400GL Intruder Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "VS700 Intruder Base": ["1985", "1986", "1987"],
    "VS750GL Intruder Base": ["1988", "1989", "1990", "1991"],
    "VS800GL Intruder Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "VX800 Base": ["1990", "1991", "1992", "1993"],
    "VZ800 Marauder Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "GSX250R ABS": ["2019", "2020", "2021"],
    "AN400 Burgman Base": ["2007", "2008", "2009"],
    "AN400 Burgman ABS Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
  },
  Ford: {
    "F-250 Super Duty King Ranch": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-250 Super Duty Lariat": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-250 Super Duty Limited": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-250 Super Duty Platinum": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-250 Super Duty XL": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-250 Super Duty XLT": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-350 Super Duty King Ranch": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-350 Super Duty Lariat": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-350 Super Duty Limited": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-350 Super Duty Platinum": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-350 Super Duty XL": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-350 Super Duty XLT": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Explorer King Ranch": ["2021", "2022", "2023", "2024"],
    "Explorer Platinum": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Explorer ST": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "F-250 Super Duty Cabela's": ["2009", "2010"],
    "F-250 Super Duty FX4": ["2008", "2009"],
    "F-250 Super Duty Harley-Davidson Edition": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "F-350 Super Duty Cabela's": ["2009", "2010"],
    "F-350 Super Duty FX4": ["2008", "2009"],
    "F-350 Super Duty Harley-Davidson Edition": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Edge SE": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Edge SEL": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Edge Sport": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Edge ST": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Edge ST-Line": ["2020", "2021", "2022", "2023", "2024"],
    "Edge Titanium": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Fusion Energi Platinum": ["2017", "2018"],
    "Fusion Energi SE": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Fusion Energi Titanium": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Fusion Platinum": ["2017", "2018"],
    "Fusion Platinum Hybrid": ["2017", "2018"],
    "Fusion S": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Fusion S Hybrid": ["2014", "2015", "2016", "2017", "2018"],
    "Fusion SE": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Fusion SE Hybrid": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Fusion SEL": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2019",
      "2020",
    ],
    "Fusion SEL Hybrid": ["2019", "2020"],
    "Fusion Sport": ["2010", "2011", "2012", "2017", "2018", "2019"],
    "Fusion Titanium": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Fusion Titanium Hybrid": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "SSV Plug-In Hybrid Base": ["2019", "2020"],
    "Mustang Bullitt": ["2008", "2009", "2019", "2020"],
    "Mustang EcoBoost": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Mustang EcoBoost Premium": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Mustang GT": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Mustang GT Premium": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Mustang Shelby GT350": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Mustang Shelby GT350R": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Mustang V6": ["2015", "2016", "2017"],
    "F-150 FX2": ["2007", "2008", "2010", "2011", "2012", "2013", "2014"],
    "F-150 FX4": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "F-150 King Ranch": [
      "2001",
      "2002",
      "2003",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-150 Lariat": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-150 Platinum": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-150 XL": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-150 XLT": [
      "1983",
      "1984",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-150 Limited": [
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "F-150 SSV": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Escape SE": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Escape SEL": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Escape Titanium": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Focus RS": ["2016", "2017", "2018"],
    "Focus S": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Focus SE": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Focus SEL": ["2009", "2010", "2011", "2012", "2017", "2018"],
    "Focus ST": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Focus Titanium": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Transit Connect XL": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Transit Connect XLT": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Excursion Eddie Bauer": ["2003", "2004", "2005"],
    "Excursion Limited": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "Excursion XLS": ["2004", "2005"],
    "Excursion XLT": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "C-Max Energi SEL": ["2013", "2014", "2015", "2016"],
    "C-Max Hybrid SE": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "C-Max Hybrid SEL": ["2013", "2014", "2015", "2016"],
    "Focus SES": ["2007", "2008", "2009", "2010", "2011"],
    "Transit Connect Titanium": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Bronco Badlands": ["2021", "2022", "2023", "2024"],
    "Bronco Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "2021",
      "2022",
      "2023",
    ],
    "Bronco Big Bend": ["2021", "2022", "2023", "2024"],
    "Bronco Black Diamond": ["2021", "2022", "2023", "2024"],
    "Bronco Everglades": ["2022", "2023", "2024"],
    "Bronco Outer Banks": ["2021", "2022", "2023", "2024"],
    "Bronco Raptor": ["2022", "2023", "2024"],
    "Bronco Wildtrak": ["2021", "2022", "2023", "2024"],
    "F-150 Raptor": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-150 Police Responder": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-150 Tremor": ["2021", "2022", "2023", "2024"],
    "Escort LX": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Escort SE": ["1998", "1999", "2001", "2002"],
    "Escort ZX2": ["2000", "2001", "2002", "2003"],
    "Escort ZX2 Cool Coupe": ["1998", "1999"],
    "Escort ZX2 Hot Coupe": ["1998", "1999"],
    "Escort ZX2 S/R": ["1999", "2000"],
    "Probe Base": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "Probe SE": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Escort Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Escort GT": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Escort LX Sport": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "Escort LX-E": ["1992", "1993"],
    "Escort Sport": ["1996", "1997"],
    "Probe GL": ["1989", "1990", "1991", "1992"],
    "Probe GT": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Ranger XL": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Ranger XLS": ["1983", "1984", "1985"],
    "Ranger XLT": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Mustang Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1979",
      "1980",
      "1981",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Mustang Boss 302": ["1969", "1970", "1971", "2012", "2013"],
    "Probe LX": ["1989", "1990", "1991", "1992"],
    "F-150 Harley-Davidson Edition": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
    ],
    "F-150 STX": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "F-150 SVT Raptor": ["2010", "2011", "2012", "2013", "2014"],
    "Expedition King Ranch": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Expedition Limited": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Expedition Max Limited": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Expedition Max Platinum": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Expedition Max SSV": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Expedition Max XL": ["2018", "2019", "2022", "2023"],
    "Expedition Max XLT": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Expedition Platinum": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Expedition SSV": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Expedition XL": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2022",
      "2023",
    ],
    "Expedition XLT": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Explorer Limited": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Explorer Sport": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Explorer XLT": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Taurus SHO": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Mustang Mach 1": [
      "1970",
      "1971",
      "1972",
      "1973",
      "2003",
      "2004",
      "2021",
      "2022",
      "2023",
    ],
    "Mustang Shelby GT": ["2007", "2008"],
    "Thunderbird Base": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "F-150 Lightning": [
      "1993",
      "1994",
      "1995",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Mustang Shelby GT500": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2020",
      "2021",
      "2022",
    ],
    "Mustang SVT Cobra": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2003",
      "2004",
    ],
    "Mustang LX": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Mustang SVO": ["1984", "1985", "1986"],
    "Mustang Boss 429": ["1969", "1970"],
    "Mustang Shelby GT-350": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "Mustang Shelby GT-500": ["1967", "1968", "1969", "1970"],
    "Mustang Ghia": ["1979", "1980", "1981"],
    "Mustang GL": ["1982", "1983"],
    "Mustang GLX": ["1982", "1983"],
    "Mustang L": ["1982", "1983", "1984"],
    "Fusion Hybrid": ["2010", "2011", "2012"],
    "Bronco Sport Badlands": ["2021", "2022", "2023", "2024"],
    "Bronco Sport Base": ["2021", "2022", "2023"],
    "Bronco Sport Big Bend": ["2021", "2022", "2023", "2024"],
    "Bronco Sport Heritage Edition": ["2023", "2024"],
    "Bronco Sport Outer Banks": ["2021", "2022", "2023", "2024"],
    "Escape S": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Escape SE Hybrid": ["2021", "2022", "2023"],
    "Escape SE Plug-In Hybrid": ["2020", "2021", "2022", "2023"],
    "Escape SEL Hybrid": ["2021", "2022", "2023"],
    "Escape SEL Plug-In Hybrid": ["2020", "2021", "2022", "2023"],
    "Escape Titanium Hybrid": ["2020", "2021", "2022", "2023"],
    "Escape Titanium Plug-In Hybrid": ["2020", "2021", "2022", "2023"],
    "Explorer Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Explorer Limited Hybrid": ["2020", "2021", "2022", "2023"],
    "Explorer Platinum Hybrid": ["2021", "2022", "2023"],
    "Explorer ST-Line": ["2022", "2023", "2024", "2025"],
    "Explorer Timberline": ["2021", "2022", "2023", "2024"],
    "Mustang Mach-E California Route 1": ["2021", "2022", "2023", "2024"],
    "Mustang Mach-E GT": ["2021", "2022", "2023", "2024"],
    "Mustang Mach-E Premium": ["2021", "2022", "2023", "2024"],
    "Mustang Mach-E Select": ["2021", "2022", "2023", "2024"],
    "Bronco Heritage Edition": ["2023", "2024"],
    "Bronco Heritage Limited Edition": ["2023", "2024"],
    "Aerostar Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Aerostar Eddie Bauer": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Aerostar XL": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Aerostar XL Plus": ["1989", "1990", "1991", "1992", "1993", "1994"],
    "Aerostar XL Sport": ["1991", "1992", "1993", "1994"],
    "Aerostar XLT": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Aerostar XLT Plus": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Aerostar XLT Sport": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Bronco Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Bronco Eddie Bauer": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Bronco XL": ["1990", "1991", "1992", "1993", "1994", "1995", "1996"],
    "Bronco XLT": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1994",
      "1995",
      "1996",
    ],
    "Bronco XLT Sport": ["1995", "1996"],
    "E-150 Econoline Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "E-150 Econoline XL": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "E-150 Econoline Club Wagon Chateau": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "E-150 Econoline Club Wagon Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "E-150 Econoline Club Wagon XL": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "2001",
      "2002",
    ],
    "E-150 Econoline Club Wagon XLT": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "E-250 Econoline Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "E-250 Econoline XL": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "E-350 Econoline Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "E-350 Econoline XL": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "E-350 Econoline Club Wagon Chateau": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "E-350 Econoline Club Wagon Chateau HD": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "E-350 Econoline Club Wagon Custom": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "E-350 Econoline Club Wagon Custom HD": ["1992", "1993"],
    "E-350 Econoline Club Wagon XL": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "2001",
      "2002",
    ],
    "E-350 Econoline Club Wagon XL HD": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "E-350 Econoline Club Wagon XLT": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "E-350 Econoline Club Wagon XLT HD": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "E-350 Super Duty Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "E-350 Super Duty XL": [
      "1999",
      "2000",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Escape Hybrid": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Escape Limited": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Escape Limited Hybrid": ["2009", "2010", "2011", "2012"],
    "Escape XLS": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Escape XLT": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Expedition Eddie Bauer": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Explorer Eddie Bauer": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Explorer XL": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Explorer XLS": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "F-150 Base": [
      "1976",
      "1977",
      "1978",
      "1983",
      "1984",
      "1985",
      "1986",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "F-150 Eddie Bauer": ["1995", "1996"],
    "F-150 Special": ["1995", "1996"],
    "F-250 Base": [
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1976",
      "1977",
      "1978",
      "1983",
      "1984",
      "1985",
      "1986",
      "1997",
      "1998",
      "1999",
    ],
    "F-250 Eddie Bauer": ["1995", "1996"],
    "F-250 Lariat": ["1997", "1998", "1999"],
    "F-250 Special": ["1995", "1996"],
    "F-250 XL": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "F-250 XLT": [
      "1983",
      "1984",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "F-350 Special": ["1995", "1996"],
    "F-350 XL": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "F-350 XLT": ["1983", "1984", "1993", "1994", "1995", "1996", "1997"],
    "Ranger Custom": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Ranger S": ["1986", "1987", "1988", "1989", "1990", "1991", "1992"],
    "Ranger Splash": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Ranger Sport": [
      "1991",
      "1992",
      "1993",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Ranger STX": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "2005",
      "2006",
      "2007",
    ],
    "Windstar Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Windstar GL": ["1995", "1996", "1997", "1998"],
    "Windstar LX": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Bronco II Eddie Bauer": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "Bronco II XL": ["1987", "1988", "1989", "1990"],
    "Bronco II XL Sport": ["1988", "1989", "1990"],
    "Bronco II XLT": ["1984", "1985", "1986", "1987", "1988", "1989", "1990"],
    "Bronco II XLT Plus": ["1989", "1990"],
    "Contour Base": ["1997", "1998"],
    "Contour GL": ["1995", "1996", "1997", "1998"],
    "Contour LX": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Contour SE": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Contour Sport": ["1996", "1997"],
    "Contour SVT": ["1998", "1999", "2000"],
    "Country Squire Base": [
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Country Squire LX": ["1987", "1988", "1989", "1990", "1991"],
    "Crown Victoria Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
    ],
    "Crown Victoria LX": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Crown Victoria Police Interceptor": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Crown Victoria S": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "E-150 Econoline Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "E-250 Econoline Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "E-250 Econoline Club Wagon Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "E-250 Econoline Club Wagon XL": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "E-250 Econoline Club Wagon XLT": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "E-350 Econoline Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Escort GL": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Escort GT Turbo": ["1984", "1985"],
    "Escort Pony": ["1986", "1987", "1988", "1989", "1990"],
    "EXP Base": ["1982", "1983", "1984", "1985"],
    "EXP Luxury": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "EXP Sport": ["1986", "1987", "1988"],
    "EXP Turbo": ["1984", "1985"],
    "F-150 Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "F-150 XLT Lariat": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "F-250 Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "F-250 XLT Lariat": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "F-350 Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "F-350 XLT Lariat": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "LTD Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "LTD Brougham": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "LTD Country Squire": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "LTD Crown Victoria": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "LTD Crown Victoria Base": ["1987", "1988", "1989", "1990", "1991"],
    "LTD Crown Victoria LX": ["1987", "1988", "1989", "1990", "1991"],
    "LTD Crown Victoria S": ["1987", "1988", "1989", "1990", "1991"],
    "Ranger Base": ["1985", "1986"],
    "Ranger GT": ["1988", "1989"],
    "Taurus G": ["1996", "1997"],
    "Taurus GL": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Taurus L": ["1986", "1987", "1988", "1989", "1990", "1991", "1992"],
    "Taurus LX": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Taurus MT5": ["1986", "1987", "1988"],
    "Taurus SE": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Tempo AWD": ["1987", "1988", "1989"],
    "Tempo Base": ["1984", "1985", "1986"],
    "Tempo GL": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Tempo GLS": ["1988", "1989", "1990", "1991", "1992"],
    "Tempo GLX": ["1984", "1985", "1986"],
    "Tempo L": ["1990", "1991"],
    "Tempo L AWD": ["1990", "1991"],
    "Tempo LX": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Tempo LX AWD": ["1990", "1991"],
    "Tempo Sport": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Thunderbird Elan": ["1984", "1985", "1986"],
    "Thunderbird Fila": ["1984", "1985"],
    "Thunderbird LX": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Thunderbird Sport": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "Thunderbird Turbo": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "Crown Victoria Fleet": ["2006", "2007", "2008", "2009"],
    "Crown Victoria LWB": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Crown Victoria LX Sport": ["2004", "2005", "2006"],
    "E-150 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "E-150 Chateau": ["2006", "2007"],
    "E-150 XL": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "E-150 XLT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "E-150 Club Wagon Chateau": ["2003", "2004", "2005"],
    "E-150 Club Wagon XL": ["2003", "2004", "2005"],
    "E-150 Club Wagon XLT": ["2003", "2004", "2005"],
    "E-250 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "E-350 Club Wagon Chateau": ["2003", "2004", "2005"],
    "E-350 Club Wagon XL": ["2003", "2004", "2005"],
    "E-350 Club Wagon XLT": ["2003", "2004", "2005"],
    "E-350 Super Duty XLT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Expedition XLS": ["2004", "2005", "2006"],
    "Explorer Postal": ["2000", "2001", "2002", "2003"],
    "Explorer XL Fleet": ["2000", "2001"],
    "Explorer XLS Sport": ["2004", "2005"],
    "Explorer XLT Sport": ["2004", "2005"],
    "Explorer Sport Trac XLS": ["2003", "2004", "2005"],
    "Explorer Sport Trac XLT": [
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Five Hundred Limited": ["2005", "2006", "2007"],
    "Five Hundred SE": ["2005", "2006"],
    "Five Hundred SEL": ["2005", "2006", "2007"],
    "Focus LX": ["2000", "2001", "2002", "2003", "2004"],
    "Focus SVT": ["2002", "2003", "2004"],
    "Focus ZTS": ["2000", "2001", "2002", "2003", "2004"],
    "Focus ZTW": ["2002", "2003", "2004"],
    "Focus ZX3": ["2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "Focus ZX4": ["2005", "2006"],
    "Focus ZX4 ST": ["2005", "2006"],
    "Focus ZX5": ["2002", "2003", "2004", "2005", "2006"],
    "Focus ZXW": ["2005", "2006"],
    "Freestar Base": ["2004", "2005", "2006", "2007"],
    "Freestar Limited": ["2004", "2005", "2006", "2007"],
    "Freestar S": ["2004", "2005"],
    "Freestar SE": ["2004", "2005", "2006", "2007"],
    "Freestar SEL": ["2004", "2005", "2006", "2007"],
    "Freestar SES": ["2004", "2005"],
    "Freestyle Limited": ["2005", "2006", "2007"],
    "Freestyle SE": ["2005", "2006"],
    "Freestyle SEL": ["2005", "2006", "2007"],
    "Windstar Limited": ["2000", "2001", "2002", "2003"],
    "Windstar SE": ["1999", "2000", "2001", "2002", "2003"],
    "Windstar SE Sport": ["2001", "2002"],
    "Windstar SEL": ["1999", "2000", "2001", "2002", "2003"],
    "Club Base": ["1954", "1955", "1956", "1958", "1959"],
    "Cortina Base": ["1963", "1964", "1965", "1966", "1967"],
    "Country Sedan Base": [
      "1954",
      "1955",
      "1956",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Courier Base": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "Courier XLT": ["1979", "1980", "1981", "1982"],
    "Courier Sedan Delivery Base": [
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
    ],
    "Customline Base": ["1954", "1955", "1956"],
    "F-100 Base": [
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1976",
      "1977",
      "1978",
    ],
    "F-350 Base": [
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1976",
      "1977",
      "1978",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Fairlane 500": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
    ],
    "Fairlane Base": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "Mainline Base": ["1954", "1955", "1956"],
    "P-350 Base": ["1954", "1955", "1956"],
    "Ranch Wagon Base": [
      "1954",
      "1955",
      "1956",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Skyliner Base": ["1954", "1955", "1956", "1958", "1959"],
    "Sunliner Base": ["1954", "1955", "1956", "1958", "1959", "1960"],
    "Victoria Base": ["1954", "1955", "1956", "1958", "1959", "1960"],
    "Zephyr Base": ["1954", "1955"],
    "Transit Connect Electric": ["2011", "2012"],
    "Transit Connect XLT Premium": ["2011", "2012", "2013"],
    "Expedition Max King Ranch": ["2020", "2021", "2022", "2023", "2024"],
    "Expedition Timberline": ["2022", "2023", "2024"],
    "Ranger Lariat": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Expedition EL King Ranch": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Expedition EL Limited": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Expedition EL Platinum": ["2015", "2016", "2017"],
    "Expedition EL SSV": ["2016", "2017"],
    "Expedition EL XL": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Expedition EL XLT": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Police Responder Hybrid Base": ["2019", "2020"],
    "Maverick Lariat": ["2022", "2023", "2024"],
    "Maverick XL": ["2022", "2023", "2024"],
    "Maverick XLT": ["2022", "2023", "2024"],
    "F-150 Raptor R": ["2023", "2024"],
    "Ranger Raptor": ["2023", "2024", "2025"],
    "Mustang Shelby GT500KR": ["2008", "2009"],
    "Custom 500 Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
    ],
    "Galaxie 500 Base": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Gran Torino Base": ["1972", "1973", "1974", "1975", "1976"],
    "Gran Torino Brougham": ["1973", "1974", "1975", "1976"],
    "Gran Torino Elite": ["1974", "1975"],
    "Gran Torino Sport": ["1972", "1973", "1974", "1975"],
    "Gran Torino Squire": ["1972", "1973", "1974", "1975", "1976"],
    "LTD Landau": ["1975", "1976", "1977", "1978", "1979"],
    "LTD II Base": ["1977", "1978", "1979"],
    "LTD II Brougham": ["1977", "1978"],
    "LTD II S": ["1977", "1978", "1979"],
    "Ranchero 500": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
    ],
    "Ranchero GT": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
    ],
    "Ranchero Squire": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
    ],
    "Thunderbird Town Landau": ["1978", "1979", "1980", "1981", "1982"],
    "Torino Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "Granada Base": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Granada ESS": ["1978", "1979", "1980"],
    "Granada Ghia": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Ranchero Base": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
    ],
    "Torino Brougham": ["1970", "1971"],
    "Torino Cobra": ["1969", "1970", "1971"],
    "Torino GT": ["1968", "1969", "1970", "1971"],
    "Torino Squire": ["1969", "1970", "1971"],
    "Torino Super Cobra Jet": ["1970", "1971"],
    "Bronco Ranger XLT": ["1978", "1979", "1980", "1981"],
    "Bronco XLS": ["1982", "1983"],
    "Bronco XLT Lariat": ["1982", "1983"],
    "Fairmont Base": ["1978", "1979", "1980", "1981", "1982"],
    "Fairmont Futura": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "Granada GL": ["1981", "1982"],
    "Granada GLX": ["1981", "1982"],
    "Granada L": ["1981", "1982"],
    "Ranger Edge": ["2001", "2002", "2003", "2004", "2005"],
    "Ranger EV": ["1998", "1999", "2000", "2001", "2002"],
    "Thunderbird Heritage": ["1981", "1982", "1983"],
    "Thunderbird Super Coupe": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "LTD S": ["1980", "1981", "1982"],
    "Bronco Roadster": ["1968", "1969"],
    "Bronco Sport": ["1975", "1976", "1977"],
    "Bronco Wagon": ["1968", "1969", "1970", "1971", "1972", "1973"],
    "Explorer Sport Base": ["2001", "2002"],
    "Ranger FX4": ["2005", "2006", "2007", "2008", "2009"],
    "Bronco II Base": ["1984", "1985", "1986"],
    "Bronco II XLS": ["1984", "1985"],
    "F-150 Ranger": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "F-150 Ranger Lariat": ["1978", "1979", "1980", "1981"],
    "F-150 Ranger XLT": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "F-150 XLS": ["1982", "1983"],
    "F-250 Ranger": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "F-250 Ranger Lariat": ["1978", "1979", "1980", "1981"],
    "F-250 Ranger XLT": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "F-250 XLS": ["1982", "1983"],
    "F-350 Ranger": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "F-350 Ranger Lariat": ["1978", "1979", "1980", "1981"],
    "F-350 Ranger XLT": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "F-350 XLS": ["1982", "1983"],
    "F-150 Lightning Lariat": ["2022", "2023", "2024"],
    "F-150 Lightning Platinum": ["2022", "2023", "2024"],
    "F-150 Lightning Pro": ["2022", "2023", "2024"],
    "F-150 Lightning XLT": ["2022", "2023", "2024"],
    "F-150 Lightning Pro SSV": ["2023", "2024"],
    "Flex Limited": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Flex SE": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Flex SEL": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Flex Titanium": ["2011", "2012"],
    "Police Interceptor Sedan Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Police Interceptor Utility Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Special Service Police Sedan Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Taurus Limited": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Taurus SEL": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "C-Max Hybrid Titanium": ["2017", "2018"],
    "Edge Limited": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "Escape ST-Line Elite": ["2023", "2024"],
    "Escape ST-Line Elite Hybrid": ["2023", "2024"],
    "Escape ST-Line Hybrid": ["2023", "2024"],
    "Escape ST-Line Select": ["2023", "2024"],
    "Focus Electric": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "EcoSport S": ["2018", "2019", "2020", "2021", "2022"],
    "EcoSport SE": ["2018", "2019", "2020", "2021", "2022"],
    "EcoSport SES": ["2018", "2019", "2020", "2021", "2022"],
    "EcoSport Titanium": ["2018", "2019", "2020", "2021", "2022"],
    "Expedition EL Eddie Bauer": ["2007", "2008", "2009", "2010"],
    "Fiesta S": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Fiesta SE": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Fiesta SEL": ["2011", "2012"],
    "Fiesta SES": ["2011", "2012"],
    "Fiesta ST": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Fiesta Titanium": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Mustang Grande": ["1970", "1971", "1972", "1973"],
    "Elite Base": ["1975", "1976"],
    "Maverick Base": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
    ],
    "Maverick Grabber": ["1975", "1976", "1977"],
    "Explorer Sport Trac Limited": ["2007", "2008", "2009", "2010"],
    "E-200 Econoline Base": ["1969", "1970", "1971", "1972", "1973", "1974"],
    "E-200 Econoline Chateau Wagon": ["1971", "1972"],
    "E-200 Econoline Club Wagon": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "E-200 Econoline Custom Wagon": ["1970", "1971", "1972", "1973", "1974"],
    "E-250 Econoline Chateau": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "E-300 Econoline Base": ["1969", "1970", "1971", "1972", "1973", "1974"],
    "E-300 Econoline Chateau Wagon": ["1970", "1971", "1972", "1973", "1974"],
    "E-300 Econoline Club Wagon": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "E-300 Econoline Custom Wagon": ["1971", "1972"],
    "E-350 Econoline Chateau": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "E-350 Econoline Northland": ["1975", "1976", "1977", "1978"],
    "F-250 Northland": ["1975", "1976", "1977", "1978"],
    "E-100 Econoline Base": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "E-100 Econoline Club Wagon": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "E-150 Econoline Chateau": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "E-150 Econoline Northland": ["1975", "1976", "1977", "1978"],
    "F-100 Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "F-100 Northland": ["1975", "1976", "1977", "1978"],
    "F-100 Ranger": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "F-100 Ranger Lariat": ["1978", "1979", "1980", "1981"],
    "F-100 Ranger XLT": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "F-150 Northland": ["1975", "1976", "1977", "1978"],
    "Transit-150 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Transit-150 XL": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Transit-150 XLT": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Transit-250 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Transit-250 PTV": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Transit-350 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Transit-350 XL": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Transit-350 XLT": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "F-350 Northland": ["1975", "1976", "1977", "1978"],
    "E-350 Econoline Club Wagon Base": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
    ],
    "E-150 Econoline Club Wagon Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
    ],
    "E-250 Econoline Club Wagon Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
    ],
    "E-150 Econoline Club Wagon Northland": ["1975", "1976", "1977", "1978"],
    "E-250 Econoline Northland": ["1975", "1976", "1977", "1978"],
    "E-250 Econoline Club Wagon Chateau": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "E-250 Econoline Club Wagon Northland": ["1975", "1976", "1977", "1978"],
    "E-350 Econoline Club Wagon Northland": ["1977", "1978"],
    "GT Base": ["2005", "2006", "2017", "2018", "2019", "2020", "2021"],
    "Custom Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
    ],
    "Custom 300 Base": ["1958", "1959", "1960"],
    "Fairlane 500XL": ["1966", "1967"],
    "Galaxie Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "Galaxie 500 Sunliner": ["1962", "1963", "1964"],
    "Galaxie 500 Victoria": ["1962", "1963", "1964"],
    "Galaxie 500 XL": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
    ],
    "GT40 Base": ["1964", "1965"],
    "GT40 MK III": ["1966", "1967"],
    "Ranchero Custom": ["1957", "1958"],
    "E-100 Econoline Chateau": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "E-100 Econoline Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "E-100 Econoline Northland": ["1975", "1976", "1977", "1978"],
    "E-100 Econoline Club Wagon Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "E-100 Econoline Club Wagon Chateau": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "E-100 Econoline Club Wagon Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "E-100 Econoline Club Wagon Northland": ["1975", "1976", "1977", "1978"],
    "F-100 XL": ["1982", "1983"],
    "F-100 XLS": ["1982", "1983"],
    "F-100 XLT Lariat": ["1982", "1983"],
    "Falcon Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
    ],
    "Falcon Futura": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
    ],
    "Mustang Boss 351": ["1971", "1972"],
    "Mustang II Base": ["1974", "1975", "1976", "1977", "1978"],
    "Mustang II Ghia": ["1974", "1975", "1976", "1977", "1978"],
    "Mustang II Mach 1": ["1974", "1975", "1976", "1977", "1978"],
    "Transit-350 HD Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Transit-350 HD XL": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Transit-350 HD XLT": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Fiesta Base": ["1978", "1979", "1980"],
    "Windstar 3.0L": ["1998", "1999"],
    "Transit-150 PTV": ["2020", "2021", "2022", "2023", "2024"],
    "Aspire Base": ["1994", "1995", "1996", "1997"],
    "Aspire SE": ["1994", "1995"],
    "Festiva GL": ["1990", "1991", "1992", "1993"],
    "Festiva L": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "Festiva LX": ["1988", "1989", "1990"],
    "Escort GLX": ["1981", "1982", "1983"],
    "Escort L": ["1981", "1982", "1985", "1986"],
    "Taurus SES": ["2000", "2001", "2002", "2003", "2004"],
    "Taurus X Eddie Bauer": ["2008", "2009"],
    "Taurus X Limited": ["2008", "2009"],
    "Taurus X SEL": ["2008", "2009"],
    "Falcon Futura Sprint": ["1963", "1964", "1965"],
    "Falcon Sedan Delivery Base": ["1961", "1962", "1963", "1964", "1965"],
    "Pinto Base": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "Pinto Pony": ["1976", "1977", "1978", "1979", "1980"],
    "Pinto Squire": ["1976", "1977", "1978", "1979", "1980"],
    "Transit-350 PTV": ["2020", "2021", "2022", "2023", "2024"],
    "Transit-350 HD PTV": ["2020", "2021", "2022", "2023", "2024"],
    "P-500 Base": ["1975", "1976", "1977"],
    "P-500 Custom": ["1975", "1976", "1977"],
    "Custom 500 Ranch Wagon": ["1975", "1976", "1977"],
    "E-Transit Base": ["2022", "2023", "2024"],
    "Mustang Dark Horse": ["2024", "2025"],
    "Mustang Dark Horse Premium": ["2024", "2025"],
    "Econoline Base": ["1961", "1962", "1963", "1964", "1965", "1966", "1967"],
    "Anglia Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "P-400 Base": ["1975", "1976"],
    "P-400 Custom": ["1975", "1976"],
    "Sprint Base": ["1963", "1964"],
  },
  Dodge: {
    "Ram 2500 Laramie": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "Ram 2500 SLT": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Ram 2500 Sport": ["2006", "2007"],
    "Ram 2500 ST": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Ram 2500 SXT": ["2008", "2009", "2010"],
    "Ram 2500 TRX4": ["2006", "2007"],
    "Ram 3500 Laramie": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Ram 3500 SLT": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Ram 3500 Sport": ["2006", "2007"],
    "Ram 3500 ST": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Ram 3500 SXT": ["2008", "2009"],
    "Ram 1500 Laramie": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Ram 1500 SLT": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Ram 1500 Sport": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2006",
      "2007",
      "2009",
      "2010",
    ],
    "Ram 1500 ST": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Ram 1500 TRX": ["2009", "2010"],
    "Ram 1500 TRX4": ["2006", "2007", "2009", "2010"],
    "Durango Citadel": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Durango Crew": ["2011", "2012", "2013"],
    "Durango GT": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Durango GT Plus": ["2020", "2021", "2022", "2023", "2024"],
    "Durango GT Premium": ["2023", "2024"],
    "Durango Limited": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2014",
      "2015",
      "2016",
    ],
    "Durango Pursuit": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Durango R/T": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Durango R/T Hemi Orange": ["2022", "2023"],
    "Durango R/T Plus": ["2022", "2023", "2024"],
    "Durango R/T Premium": ["2023", "2024"],
    "Durango Rallye": ["2014", "2015"],
    "Durango Special Service": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Durango SRT": ["2018", "2019", "2020", "2021"],
    "Durango SRT 392": ["2022", "2023", "2024"],
    "Durango SXT": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Durango SXT Plus": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Avenger Express": ["2010", "2011"],
    "Avenger R/T": ["2008", "2009", "2010", "2012", "2013", "2014"],
    "Avenger SE": ["2008", "2009", "2012", "2013", "2014"],
    "Avenger SXT": ["2008", "2009", "2010", "2012", "2013", "2014"],
    "Caliber Express": ["2010", "2011"],
    "Caliber Heat": ["2010", "2011"],
    "Caliber Mainstreet": ["2010", "2011"],
    "Caliber R/T": ["2007", "2008", "2009", "2010"],
    "Caliber Rush": ["2010", "2011"],
    "Caliber SE": ["2007", "2008", "2009", "2010"],
    "Caliber SRT-4": ["2008", "2009"],
    "Caliber SXT": ["2007", "2008", "2009", "2010"],
    "Caliber Uptown": ["2010", "2011"],
    "Journey AVP": ["2012", "2013"],
    "Journey Crossroad": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Journey R/T": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Journey SE": [
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Journey SXT": [
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Ram 1500 SRT-10": ["2004", "2005", "2006"],
    "Neon SRT-4": ["2003", "2004", "2005"],
    "Challenger R/T": [
      "1970",
      "1971",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Challenger R/T 392": ["2017", "2018", "2019"],
    "Challenger R/T Plus": ["2015", "2016"],
    "Challenger R/T Scat Pack": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Challenger R/T Scat Pack Widebody": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Challenger SRT 392": ["2015", "2016", "2017", "2018"],
    "Challenger SRT Hellcat": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Challenger SRT Hellcat Widebody": ["2018", "2019", "2020", "2021", "2022"],
    "Challenger SRT8": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "Challenger T/A": ["2017", "2018"],
    "Challenger T/A 392": ["2017", "2018"],
    "Colt Base": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Colt Custom": ["1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    "Colt Deluxe": ["1982", "1983"],
    "Colt DL": ["1984", "1985", "1986", "1987", "1988", "1989", "1990"],
    "Colt E": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "Colt GL": ["1990", "1991", "1992", "1993"],
    "Colt GT": ["1973", "1974", "1975", "1976", "1977", "1989", "1990"],
    "Colt Premier": ["1985", "1986", "1987", "1988"],
    "Colt Vista": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Stealth Base": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Stealth ES": ["1991", "1992", "1993"],
    "Stealth R/T": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Stealth R/T Turbo": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Avenger Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Avenger ES": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Neon ACR": ["1998", "1999", "2001", "2002"],
    "Neon Base": ["1995", "1996", "1997", "2001", "2002"],
    "Neon ES": ["2000", "2001", "2002"],
    "Neon High Line": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Neon R/T": ["1998", "1999", "2001", "2002", "2003", "2004"],
    "Neon SE": ["2001", "2002", "2003", "2004", "2005"],
    "Neon Sport": ["1995", "1996", "1997", "1998", "1999"],
    "Neon SXT": ["2003", "2004", "2005"],
    "Dakota Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Dakota Big Horn": ["2009", "2010"],
    "Dakota Laramie": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "Dakota LE": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "Dakota Lone Star": ["2009", "2010"],
    "Dakota R/T": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "Dakota S": ["1990", "1991", "1992", "1993"],
    "Dakota SE": ["1987", "1988", "1989", "1990", "1991"],
    "Dakota SLT": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Dakota Sport": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Dakota ST": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "Dakota TRX4": ["2008", "2009", "2010"],
    "Dakota WS": ["1994", "1995", "1996"],
    "Durango SRT 392 Plus": ["2023", "2024"],
    "Durango SRT 392 Premium": ["2023", "2024"],
    "Challenger SXT": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Charger Pursuit": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Charger R/T": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Charger SE": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Charger SRT8": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
    ],
    "Charger SXT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Durango SRT Hellcat Plus": ["2023", "2024"],
    "Durango SRT Hellcat Premium": ["2023", "2024"],
    "Sprinter 2500 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Sprinter 3500 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Challenger GT": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "Challenger SRT Hellcat Redeye": ["2019", "2020", "2021", "2022"],
    "Challenger SRT Hellcat Redeye Widebody": ["2019", "2020", "2021", "2022"],
    "Challenger SRT Super Stock": ["2020", "2021", "2022", "2023"],
    "Challenger SXT Plus": ["2015", "2016", "2017", "2018"],
    "Charger Daytona": ["2017", "2018"],
    "Charger Daytona 392": ["2017", "2018"],
    "Charger GT": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Charger R/T 392": ["2017", "2018"],
    "Charger R/T Road & Track": ["2015", "2016"],
    "Charger R/T Scat Pack": ["2015", "2016", "2017", "2018"],
    "Charger Scat Pack": ["2019", "2020", "2021", "2022", "2023"],
    "Charger Scat Pack Widebody": ["2022", "2023"],
    "Charger SRT 392": ["2015", "2016", "2017", "2018"],
    "Charger SRT Hellcat": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Charger SRT Hellcat Redeye Widebody": ["2021", "2022", "2023"],
    "Charger SRT Hellcat Widebody": ["2020", "2021", "2022", "2023"],
    "Journey Crew": ["2010", "2011", "2012", "2013"],
    "Journey GT": ["2017", "2018", "2019"],
    "Journey Limited": ["2014", "2015"],
    "330 Base": ["1963", "1964"],
    "440 Base": ["1963", "1964"],
    "880 Base": ["1962", "1963", "1964", "1965"],
    "880 Custom": ["1962", "1963", "1964", "1965"],
    "Aspen Base": ["1976", "1977", "1978", "1979", "1980"],
    "Aspen Custom": ["1976", "1977"],
    "Aspen Special Edition": ["1976", "1977"],
    "B100 Base": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "B200 Base": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "B300 Base": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Challenger Base": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "Charger 500": ["1969", "1970", "1971"],
    "Charger Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "2006",
      "2007",
    ],
    "Charger Special Edition": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Coronet 440": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "Coronet 500": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "Coronet Base": [
      "1950",
      "1951",
      "1952",
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1965",
      "1966",
      "1967",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "Coronet Brougham": ["1975", "1976"],
    "Coronet Crestwood": ["1971", "1972", "1973", "1974", "1975", "1976"],
    "Coronet Custom": ["1971", "1972", "1973", "1974", "1975"],
    "Coronet Deluxe": ["1968", "1969", "1970"],
    "Coronet R/T": ["1967", "1968", "1969", "1970"],
    "Coronet Super Bee": ["1968", "1969", "1970"],
    "Custom Base": [
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
    ],
    "D100 Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "D100 Warlock": ["1976", "1977", "1978"],
    "D100 Pickup Base": [
      "1957",
      "1958",
      "1959",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "D150 Base": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "D150 Li'l Red Express": ["1978", "1979"],
    "D150 Miser": ["1982", "1983"],
    "D150 S": ["1990", "1991"],
    "D200 Base": ["1977", "1978", "1979", "1980"],
    "D200 Custom": ["1975", "1976"],
    "D200 Pickup Base": [
      "1957",
      "1958",
      "1959",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "D250 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "D300 Base": ["1977", "1978", "1979", "1980"],
    "D300 Custom": ["1975", "1976"],
    "D300 Pickup Base": [
      "1957",
      "1958",
      "1959",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "D350 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Dart 270": ["1963", "1964", "1965", "1966", "1967", "1968"],
    "Dart Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "Dart Custom": ["1969", "1970", "1971", "1972", "1973", "1974", "1975"],
    "Dart Demon": ["1971", "1972"],
    "Dart Demon 340": ["1971", "1972"],
    "Dart GT": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Dart GTS": ["1968", "1969"],
    "Dart Phoenix": ["1960", "1961"],
    "Dart Pioneer": ["1960", "1961"],
    "Dart Special": ["1971", "1972", "1973", "1974"],
    "Dart Special Edition": ["1974", "1975"],
    "Dart Sport": ["1973", "1974", "1975", "1976"],
    "Dart Sport 360": ["1974", "1975"],
    "Dart Swinger": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "Dart Swinger 340": ["1969", "1970"],
    "Dart Swinger Special": ["1975", "1976"],
    "Diplomat Base": ["1977", "1978", "1979", "1980", "1981"],
    "Diplomat Medallion": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "Lancer 770": ["1961", "1962"],
    "Lancer Base": [
      "1958",
      "1959",
      "1961",
      "1962",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Meadowbrook Base": ["1950", "1951", "1952", "1953", "1954"],
    "Monaco 500": ["1967", "1968"],
    "Monaco Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Monaco Brougham": ["1977", "1978"],
    "Monaco Crestwood": ["1977", "1978"],
    "Monaco Royal": ["1975", "1976"],
    "Monaco Royal Brougham": ["1975", "1976"],
    "Omni Base": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "P300 Series Base": ["1958", "1959"],
    "P310 Series Base": ["1958", "1959"],
    "P320 Series Base": ["1958", "1959"],
    "P410 Series Base": ["1958", "1959"],
    "P420 Series Base": ["1958", "1959"],
    "Polara 500": ["1968", "1969"],
    "Polara Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
    ],
    "Polara Custom": ["1970", "1971", "1972", "1973"],
    "Power Wagon Base": ["1958", "1959"],
    "Ramcharger Base": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Ramcharger SE": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Royal Base": ["1958", "1959"],
    "Sierra Base": ["1958", "1959"],
    "Sierra Custom": ["1958", "1959"],
    "Truck Base": ["1957", "1958", "1959", "1960"],
    "W100 Custom": [
      "1975",
      "1976",
      "1977",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "W100 Pickup Base": [
      "1957",
      "1958",
      "1959",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "W100 Series Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "W150 Base": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "W200 Base": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "W200 Pickup Base": [
      "1957",
      "1958",
      "1959",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "W300 Base": ["1977", "1978", "1979", "1980"],
    "W300 Custom": ["1975", "1976"],
    "W300 Pickup Base": [
      "1958",
      "1959",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "W300 Series Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "Wm300 Power Wagon Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
    ],
    "Ram 2500 Power Wagon": ["2006", "2007", "2008", "2009", "2010"],
    "W250 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "W350 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Ram 2500 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Ram 3500 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Magnum XE": ["1978", "1979"],
    "400 Base": ["1982", "1983"],
    "600 Base": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "600 ES": ["1983", "1984", "1985", "1986"],
    "600 SE": ["1985", "1986", "1987", "1988"],
    "Aries America": ["1988", "1989"],
    "Aries Base": ["1981", "1982", "1983", "1984", "1985", "1986", "1987"],
    "Aries Custom": ["1981", "1982", "1983", "1984"],
    "Aries LE": ["1985", "1986", "1987"],
    "Aries SE": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "Charger 2.2": ["1983", "1984", "1985", "1986"],
    "Charger Shelby": ["1983", "1984", "1985", "1986", "1987"],
    "D50 Custom": ["1981", "1982"],
    "D50 Royal": ["1981", "1982"],
    "D50 Sport": ["1979", "1980", "1981", "1982"],
    "Daytona Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Daytona ES": ["1989", "1990", "1991", "1992", "1993"],
    "Daytona ES Turbo": ["1989", "1990"],
    "Daytona Pacifica": ["1987", "1988"],
    "Daytona Shelby": ["1989", "1990", "1991"],
    "Daytona Shelby Z": ["1987", "1988"],
    "Daytona Turbo": ["1984", "1985"],
    "Lancer ES": ["1985", "1986", "1987", "1988", "1989"],
    "Lancer Shelby": ["1988", "1989"],
    "Omni 024": ["1979", "1980", "1981", "1982"],
    "Omni 024 Miser": ["1981", "1982"],
    "Omni America": ["1987", "1988", "1989"],
    "Omni Custom": ["1982", "1983"],
    "Omni GLH": ["1984", "1985", "1986"],
    "Omni Miser": ["1981", "1982"],
    "Omni SE": ["1984", "1985", "1986"],
    "Power Ram 50 Custom": ["1983", "1984", "1985", "1986"],
    "Power Ram 50 Royal": ["1984", "1985"],
    "Power Ram 50 Sport": ["1983", "1984", "1985", "1986"],
    "Ram 1500 Base": ["1994", "1995", "1996"],
    "Ram 1500 WS": ["1997", "1998", "1999", "2000", "2001"],
    "Ram 50 Base": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "Ram 50 Custom": ["1983", "1984", "1985", "1986", "1987", "1988", "1989"],
    "Ram 50 LE": ["1990", "1991"],
    "Ram 50 Royal": ["1983", "1984", "1985"],
    "Ram 50 SE": ["1990", "1991", "1992", "1993"],
    "Ram 50 Sport": ["1983", "1984", "1985", "1986", "1987", "1988", "1989"],
    "Ramcharger Canyon Sport": ["1991", "1992", "1993"],
    "Ramcharger Royal SE": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Shadow Base": ["1987", "1988", "1989", "1990", "1993", "1994"],
    "Shadow ES": ["1988", "1989", "1990", "1991", "1992", "1993", "1994"],
    "Shadow Shelby": ["1987", "1988", "1989"],
    "Spirit Base": ["1989", "1990", "1991", "1992", "1994", "1995"],
    "Spirit ES": ["1989", "1990", "1991", "1992", "1993"],
    "Spirit LE": ["1989", "1990", "1991", "1992"],
    "Magnum R/T": ["2005", "2006", "2007", "2008"],
    "Magnum SE": ["2005", "2006", "2007", "2008"],
    "Magnum SRT8": ["2006", "2007", "2008"],
    "Magnum SXT": ["2005", "2006", "2007", "2008"],
    "Caravan Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2006",
      "2007",
    ],
    "Caravan C/V": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Caravan SE": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Caravan Sport": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "Caravan SXT": ["2004", "2005", "2006", "2007"],
    "Dart Aero": ["2013", "2014", "2015", "2016"],
    "Dart Limited": ["2013", "2014", "2015", "2016"],
    "Dart SE": ["2013", "2014", "2015", "2016"],
    "Dart SXT": ["2013", "2014", "2015", "2016"],
    "Durango Adventurer": ["2006", "2007", "2008"],
    "Durango Base": ["1998", "1999", "2000", "2001"],
    "Durango SLT": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Durango SLT Plus": ["1999", "2000", "2002", "2003"],
    "Durango Sport": ["2002", "2003"],
    "Durango ST": ["2004", "2005"],
    "Nitro Detonator": ["2010", "2011"],
    "Nitro Heat": ["2010", "2011"],
    "Nitro R/T": ["2007", "2008", "2009"],
    "Nitro SE": ["2009", "2010", "2011"],
    "Nitro Shock": ["2010", "2011"],
    "Nitro SLT": ["2007", "2008", "2009"],
    "Nitro SXT": ["2007", "2008", "2010", "2011"],
    "Caravan ES": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Caravan LE": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Challenger SE": ["2009", "2010", "2011"],
    "Viper ACR": ["1999", "2000", "2001", "2002", "2016", "2017"],
    "Viper Base": ["1992", "1993", "1994", "1995", "1996"],
    "Viper GTS": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2015",
      "2016",
      "2017",
    ],
    "Viper R/T-10": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "B150 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "B250 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "B350 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Daytona Iroc": ["1991", "1992", "1993"],
    "Daytona Iroc R/T": ["1992", "1993"],
    "Diplomat Salon": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Diplomat SE": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "Dynasty Base": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "Dynasty LE": ["1988", "1989", "1990"],
    "Dynasty LS": ["1991", "1992", "1993"],
    "Grand Caravan Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2006",
      "2007",
    ],
    "Grand Caravan C/V": ["2004", "2005", "2008", "2009", "2010", "2011"],
    "Grand Caravan EL": ["2002", "2003"],
    "Grand Caravan ES": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Grand Caravan EX": ["2001", "2002", "2003", "2004"],
    "Grand Caravan LE": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Grand Caravan SE": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Grand Caravan Sport": ["2000", "2001", "2002", "2003"],
    "Grand Caravan SXT": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Intrepid Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Intrepid ES": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Intrepid R/T": ["2000", "2001", "2002"],
    "Intrepid SE": ["2001", "2002", "2003", "2004"],
    "Intrepid SXT": ["2003", "2004"],
    "Mini Ram Base": ["1984", "1985", "1986", "1987", "1988"],
    "Mini Ram Royal": ["1984", "1985", "1986", "1987"],
    "Monaco ES": ["1990", "1991", "1992"],
    "Monaco LE": ["1990", "1991", "1992"],
    "Shadow America": ["1991", "1992"],
    "Shadow High Line": ["1991", "1992", "1993"],
    "Spirit R/T": ["1991", "1992"],
    "Viper SRT-10": ["2003", "2004", "2005", "2006", "2008", "2009", "2010"],
    "Viper SRT-10 ACR": ["2008", "2009", "2010"],
    "W150 S": ["1990", "1991"],
    "B100 Van Base": ["1971", "1972", "1973", "1974"],
    "B100 Van Sportsman": ["1971", "1972", "1973", "1974"],
    "B200 Van Base": ["1971", "1972", "1973", "1974"],
    "B200 Van Maxi": ["1972", "1973", "1974"],
    "B200 Van Maxi Wagon": ["1972", "1973", "1974"],
    "B200 Van Sportsman": ["1971", "1972", "1973", "1974"],
    "B2500 Base": ["1995", "1996", "1997", "1998"],
    "B300 Van Base": ["1971", "1972", "1973", "1974"],
    "B300 Van Maxi": ["1972", "1973", "1974"],
    "B300 Van Maxi Wagon": ["1972", "1973", "1974"],
    "B300 Van Sportsman": ["1971", "1972", "1973", "1974"],
    "B3500 Base": ["1995", "1996", "1997", "1998"],
    "D200 Series Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "D300 Series Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "Ram 2500 Van Base": ["1999", "2000", "2001", "2002", "2003"],
    "Ram 3500 Van Base": ["1999", "2000", "2001", "2002", "2003"],
    "W200 Series Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "Grand Caravan Crew": ["2011", "2012", "2013"],
    "Grand Caravan R/T": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Ram 1500 SS/T 5.9L": ["1997", "1998"],
    "Stratus ES": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Stratus R/T": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Stratus SE": ["2000", "2001", "2002", "2003", "2004"],
    "Stratus SXT": ["2003", "2004", "2005", "2006"],
    "Mirada Special Coupe": ["1980", "1981", "1982", "1983"],
    "St. Regis Base": ["1979", "1980", "1981"],
    "Grand Caravan American Value Package": ["2014", "2015", "2016"],
    "Grand Caravan GT": ["2017", "2018", "2019", "2020"],
    "B1500 Base": ["1995", "1996", "1997", "1998"],
    "Ram 1500 Van Base": ["1999", "2000", "2001", "2002", "2003"],
    "Viper GTC": ["2016", "2017"],
    "Viper SRT": ["2016", "2017"],
    "Stratus Base": ["1995", "1996", "1997", "1998", "1999"],
    "A100 Truck Base": ["1964", "1965", "1966", "1967", "1968", "1969", "1970"],
    "A100 Truck Sportsman": ["1968", "1969", "1970"],
    "RD200 Base": ["1978", "1979", "1980"],
    "D100 Series Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "Challenger Premium": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "Conquest Base": ["1984", "1985", "1986"],
    "Raider Base": ["1987", "1988", "1989"],
    "Rampage 2.2": ["1983", "1984"],
    "Rampage Base": ["1983", "1984"],
    "CB300 Base": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "Colt Carousel": ["1975", "1976", "1977"],
    "D50 Base": ["1979", "1980"],
    "Royal Monaco Base": ["1975", "1976", "1977"],
    "Royal Monaco Brougham": ["1975", "1976", "1977"],
    "Grand Caravan SE Plus": ["2016", "2017", "2018"],
    "M300 Base": ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "MB300 Base": ["1970", "1971", "1972", "1973", "1974"],
    "Phoenix Base": ["1960", "1961"],
    "Pioneer Base": ["1960", "1961"],
    "R300 Base": ["1972", "1973", "1974"],
    "RM300 Base": ["1973", "1974"],
    "Seneca Base": ["1960", "1961"],
    "W100 Base": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "C-1 DU6": ["1954", "1955"],
    "C-1 DUL6": ["1954", "1955"],
    "C-1 EUL6": ["1954", "1955"],
    "C-3 B": ["1954", "1955", "1956"],
    "C-3 C": ["1954", "1955", "1956"],
    "C-3 D": ["1954", "1955", "1956"],
    "RM300 Motorhome": ["1973", "1974"],
    "A100 Pickup Base": ["1967", "1968", "1969", "1970"],
    "P200 Base": ["1971", "1972"],
    "P300 Base": ["1971", "1972"],
  },
  Ram: {
    "2500 Big Horn": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "2500 Laramie": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "2500 Laramie Limited": ["2014", "2015"],
    "2500 Laramie Longhorn": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "2500 Limited": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "2500 Limited Longhorn": ["2021", "2022", "2023", "2024"],
    "2500 Lone Star": [
      "2013",
      "2014",
      "2015",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "2500 Outdoorsman": ["2012", "2013", "2014", "2015", "2016"],
    "2500 Rebel": ["2023", "2024"],
    "2500 SLT": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "2500 ST": ["2011", "2012", "2013"],
    "2500 Tradesman": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "3500 Big Horn": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "3500 Laramie": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "3500 Laramie Limited": ["2014", "2015"],
    "3500 Laramie Longhorn": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "3500 Limited": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "3500 Limited Longhorn": ["2021", "2022", "2023", "2024"],
    "3500 Lone Star": ["2013", "2014", "2015", "2019", "2020", "2021", "2022"],
    "3500 SLT": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "3500 ST": ["2011", "2012", "2013"],
    "3500 Tradesman": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "1500 Big Horn": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "1500 Express": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "1500 HFE": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "1500 Laramie": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "1500 Laramie Limited": ["2014", "2015"],
    "1500 Laramie Longhorn": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "1500 Limited": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "1500 Limited Longhorn": ["2021", "2022", "2023", "2024", "2025"],
    "1500 Lone Star": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "1500 Outdoorsman": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "1500 Rebel": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "1500 SLT": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "1500 Special Service": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2020",
      "2021",
      "2022",
    ],
    "1500 Sport": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "1500 ST": ["2011", "2012"],
    "1500 Tradesman": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "1500 Classic Express": ["2019", "2020", "2021", "2022"],
    "1500 Classic SLT": ["2019", "2020", "2021", "2022"],
    "1500 Classic Special Service": ["2019", "2020", "2021", "2022", "2023"],
    "1500 Classic Tradesman": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "1500 Classic Warlock": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "2500 Power Wagon": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "1500 TRX": ["2021", "2022", "2023", "2024"],
    "ProMaster 1500 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "ProMaster 2500 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "ProMaster 3500 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "ProMaster City Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "ProMaster City SLT": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "ProMaster City Tradesman": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "ProMaster City Tradesman SLT": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "C/V Base": ["2012", "2013", "2014", "2015"],
  },
  Chevrolet: {
    "Corvette Base": [
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Corvette Grand Sport": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2017",
      "2018",
      "2019",
    ],
    "Corvette Z06": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2023",
      "2024",
    ],
    "Corvette ZR1": ["2009", "2010", "2011", "2012", "2013"],
    "Corvette Stingray": [
      "1975",
      "1976",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Camaro SS": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Traverse LS": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Traverse LT": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Traverse LTZ": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Captiva Sport LS": ["2012", "2013", "2014", "2015"],
    "Captiva Sport LT": ["2012", "2013", "2014", "2015"],
    "Captiva Sport LTZ": ["2012", "2013", "2014", "2015"],
    "Equinox L": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "Equinox LS": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Equinox LT": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Equinox LTZ": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Silverado 2500 HD Custom": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Silverado 2500 HD High Country": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Silverado 2500 HD LT": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Silverado 2500 HD LTZ": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Silverado 2500 HD WT": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Silverado 3500 HD High Country": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Silverado 3500 HD LT": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Silverado 3500 HD LTZ": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Silverado 3500 HD WT": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Colorado Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Colorado LT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Colorado WT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Colorado Z71": [
      "2004",
      "2005",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Colorado ZR2": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Avalanche LS": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "Avalanche LT": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "Avalanche LTZ": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "Avalanche 1500 Base": ["2002", "2003", "2004", "2005"],
    "Avalanche 1500 LS": ["2005", "2006"],
    "Avalanche 1500 LT": ["2005", "2006"],
    "Avalanche 1500 North Face": ["2002", "2003"],
    "Avalanche 1500 On Road Edition": ["2002", "2003"],
    "Avalanche 1500 Z66": ["2004", "2005", "2006"],
    "Avalanche 1500 Z71": ["2002", "2003", "2004", "2005", "2006"],
    "Avalanche 2500 Base": ["2002", "2003", "2004"],
    "Avalanche 2500 LS": ["2005", "2006"],
    "Avalanche 2500 LT": ["2005", "2006"],
    "Silverado 1500 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Silverado 1500 Custom": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Silverado 1500 High Country": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Silverado 1500 Hybrid": [
      "2004",
      "2005",
      "2006",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Silverado 1500 LS": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Silverado 1500 LT": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Silverado 1500 LTZ": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Silverado 1500 SS": ["2003", "2004", "2005", "2006"],
    "Silverado 1500 SSV": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Silverado 1500 WT": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Silverado 1500 XFE": ["2010", "2011", "2012", "2013"],
    "Silverado 1500 HD LS": ["2001", "2002", "2003"],
    "Silverado 1500 HD LT": ["2001", "2002", "2003", "2005", "2006"],
    "Silverado 2500 Base": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Silverado 2500 LS": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Silverado 2500 LT": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Silverado 2500 HD Base": ["2001", "2002", "2003", "2004", "2005"],
    "Silverado 2500 HD LS": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Silverado 3500 Base": ["2001", "2002", "2003", "2004", "2005"],
    "Silverado 3500 LS": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Silverado 3500 LT": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Suburban LS": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Suburban LT": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Suburban LTZ": ["2015", "2016"],
    "Suburban Premier": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Suburban 1500 Base": ["2000", "2001"],
    "Suburban 1500 LS": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Suburban 1500 LT": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Suburban 1500 LTZ": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Suburban 1500 Z71": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "Suburban 2500 Base": ["2000", "2001"],
    "Suburban 2500 LS": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Suburban 2500 LT": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Tahoe Base": ["1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    "Tahoe Hybrid": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Tahoe LS": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tahoe LT": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tahoe LTZ": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Tahoe PPV": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tahoe Premier": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tahoe SSV": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tahoe Z71": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cruze Diesel": ["2014", "2015", "2017", "2018", "2019"],
    "Cruze L": ["2015", "2016", "2017", "2018", "2019"],
    "Cruze LS": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Cruze LT": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Cruze Premier": ["2016", "2017", "2018", "2019"],
    "Cruze Eco": ["2011", "2012", "2013", "2014", "2015"],
    "Cruze LTZ": ["2011", "2012", "2013", "2014", "2015"],
    "Camaro Z/28": ["2014", "2015"],
    "Camaro Z28": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Camaro Z28 SS": ["1998", "1999", "2000", "2001", "2002"],
    "SSR Base": ["2003", "2004", "2005", "2006"],
    "Nova Base": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Nova CL": ["1985", "1986", "1987", "1988"],
    "Camaro Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Camaro Berlinetta": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Camaro Iroc-Z": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "Camaro LT": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Camaro LT Rally Sport": ["1976", "1977", "1978"],
    "Camaro Rally Sport": ["1976", "1977", "1978", "1979", "1980"],
    "Camaro RS": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1989",
      "1990",
      "1991",
      "1992",
      "1996",
      "1997",
    ],
    "Camaro Sport": ["1981", "1982", "1983", "1984", "1985", "1986", "1987"],
    "Chevelle SS": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
    ],
    "Bel Air Base": [
      "1951",
      "1952",
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
    ],
    "Bel Air Nomad": ["1955", "1956", "1957"],
    "Biscayne Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
    ],
    "C10 Big Ten": ["1978", "1979", "1980"],
    "C10 Cheyenne": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "C10 Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "C10 Custom Deluxe": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "C10 Scottsdale": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C10 Silverado": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C10 Pickup Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "C10 Suburban Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "C10 Suburban Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "C10 Suburban Custom Deluxe": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "C10 Suburban Scottsdale": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1984",
      "1985",
      "1986",
    ],
    "C10 Suburban Silverado": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C1500 Base": ["1994", "1995", "1996", "1997"],
    "C1500 Cheyenne": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "C1500 Scottsdale": ["1988", "1989", "1990", "1991", "1992"],
    "C1500 Silverado": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "C1500 WT": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "C20 Cheyenne": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "C20 Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "C20 Custom Deluxe": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "C20 Scottsdale": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C20 Silverado": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C20 Pickup Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "C20 Suburban Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "C20 Suburban Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "C20 Suburban Custom Deluxe": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "C20 Suburban Scottsdale": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1984",
      "1985",
      "1986",
    ],
    "C20 Suburban Silverado": [
      "1975",
      "1976",
      "1977",
      "1979",
      "1980",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C2500 Base": ["1994", "1995", "1996", "1997", "1999", "2000"],
    "C2500 Cheyenne": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "C2500 Scottsdale": ["1988", "1989", "1990", "1991", "1992"],
    "C2500 Silverado": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "C2500 WT": ["1994", "1995"],
    "C30 Cheyenne": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "C30 Custom Deluxe": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "C30 Scottsdale": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C30 Silverado": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C30 Pickup Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Caprice Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Chevelle 300 Deluxe": ["1967", "1968", "1969"],
    "Chevelle Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1970",
      "1971",
      "1972",
    ],
    "Chevelle Concours": ["1967", "1968", "1969", "1970", "1971", "1972"],
    "Chevelle Concours Estate": ["1969", "1970", "1971", "1972"],
    "Chevelle Greenbrier": ["1969", "1970", "1971", "1972"],
    "Chevelle Malibu": ["1968", "1969", "1970", "1971", "1972"],
    "Chevelle Nomad": ["1968", "1969", "1970", "1971", "1972"],
    "Chevy II Base": ["1962", "1963", "1964", "1965", "1966", "1967"],
    "Chevy II Nova": ["1962", "1963", "1964", "1965", "1966", "1967", "1968"],
    "Chevy II Nova SS": ["1964", "1965", "1966", "1967"],
    "El Camino Base": [
      "1959",
      "1960",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "El Camino Classic": ["1975", "1976", "1977"],
    "El Camino Conquista": [
      "1977",
      "1978",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "El Camino Custom": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "El Camino SS": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Impala Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Impala SS": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1994",
      "1995",
      "1996",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "K10 Cheyenne": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "K10 Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "K10 Custom Deluxe": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "K10 Scottsdale": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K10 Silverado": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K10 Pickup Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "K10 Suburban Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "K10 Suburban Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "K10 Suburban Custom Deluxe": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "K10 Suburban Scottsdale": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1984",
      "1985",
      "1986",
    ],
    "K10 Suburban Silverado": [
      "1975",
      "1976",
      "1977",
      "1979",
      "1980",
      "1982",
      "1983",
      "1985",
      "1986",
    ],
    "K1500 Base": ["1994", "1995", "1996", "1997"],
    "K1500 Cheyenne": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "K1500 Scottsdale": ["1988", "1989", "1990", "1991", "1992"],
    "K1500 Silverado": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "K1500 WT": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "K20 Cheyenne": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "K20 Custom Deluxe": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "K20 Scottsdale": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K20 Silverado": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1985",
      "1986",
    ],
    "K20 Pickup Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "K20 Suburban Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "K20 Suburban Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "K20 Suburban Custom Deluxe": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "K20 Suburban Scottsdale": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1984",
      "1985",
      "1986",
    ],
    "K20 Suburban Silverado": [
      "1975",
      "1976",
      "1977",
      "1979",
      "1980",
      "1982",
      "1983",
      "1985",
      "1986",
    ],
    "K2500 Base": ["1994", "1995", "1996", "1997", "1999", "2000"],
    "K2500 Cheyenne": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "K2500 Scottsdale": ["1988", "1989", "1990", "1991", "1992"],
    "K2500 Silverado": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "K2500 WT": ["1994", "1995"],
    "K30 Cheyenne": ["1977", "1978", "1979", "1980", "1981"],
    "K30 Custom Deluxe": ["1977", "1978", "1979", "1980"],
    "K30 Scottsdale": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K30 Pickup Base": ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "K5 Blazer Cheyenne": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "K5 Blazer Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "K5 Blazer Custom Deluxe": ["1977", "1978", "1979", "1980"],
    "K5 Blazer Silverado": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Malibu Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Malibu Classic": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "Malibu Classic Estate": ["1975", "1976", "1978", "1979", "1980"],
    "Malibu Classic Landau": ["1976", "1977", "1978", "1979", "1980", "1981"],
    "Malibu Estate": ["1973", "1974", "1979", "1980"],
    "Malibu Sport": ["1979", "1980"],
    "Monte Carlo Base": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Monte Carlo Landau": ["1973", "1974", "1978", "1979", "1980", "1981"],
    "Monte Carlo S": ["1975", "1976", "1977"],
    "Nova Concours": ["1976", "1977"],
    "Nova Custom": ["1973", "1974", "1975", "1978", "1979"],
    "Nova Police": ["1975", "1976", "1977", "1978"],
    "Nova Rally": ["1977", "1978", "1979"],
    "Blazer Base": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Brookwood Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1969",
      "1970",
      "1971",
      "1972",
    ],
    "Estate Base": ["1969", "1970"],
    "G20 Van Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "G20 Van Sportvan": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Kingswood Base": ["1959", "1960", "1961", "1969", "1970", "1971", "1972"],
    "Kingswood Estate": ["1969", "1970", "1971", "1972"],
    "Townsman Base": ["1969", "1970", "1971", "1972"],
    "Silverado 1500 Custom Trail Boss": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Silverado 1500 LT Trail Boss": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Silverado 1500 RST": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Silverado 1500 ZR2": ["2022", "2023", "2024"],
    "Astro Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Astro LS": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Astro LT": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Blazer LS": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Blazer LT": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Blazer Trailblazer": ["1999", "2000", "2001"],
    "Blazer Xtreme": ["2001", "2002", "2003", "2004", "2005"],
    "Express 2500 Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Express 2500 LS": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Express 3500 Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Express 3500 LS": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S10 Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "S10 LS": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "S10 Xtreme": ["1999", "2000", "2001", "2002", "2003"],
    "S10 ZR2": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Camaro LS": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Camaro LT1": ["2020", "2021", "2022", "2023", "2024"],
    "Camaro ZL1": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Equinox Premier": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Express 2500 LT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Express 3500 LT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Impala LS": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Impala Police": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Monte Carlo LS": [
      "1986",
      "1987",
      "1988",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Monte Carlo SS": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "SS Base": ["2014", "2015", "2016", "2017"],
    "Suburban 3500 HD LS": ["2016", "2017", "2018", "2019"],
    "Suburban 3500 HD LT": ["2016", "2017", "2018", "2019"],
    "Blazer ZR2": ["2003", "2004", "2005"],
    "S10 SS": ["1994", "1995", "1996", "1997", "1998"],
    "S10 ZR5": ["2002", "2003", "2004"],
    "Astro CL": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Astro CS": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Beretta Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Beretta GT": ["1989", "1990", "1991", "1992", "1993"],
    "Beretta GTZ": ["1990", "1991", "1992", "1993"],
    "Beretta Z26": ["1994", "1995", "1996"],
    "Blazer Cheyenne": ["1992", "1993"],
    "Blazer Silverado": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "C1500 Suburban Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "C1500 Suburban LS": ["1995", "1996", "1997", "1998", "1999"],
    "C1500 Suburban LT": ["1995", "1996", "1997"],
    "C1500 Suburban Silverado": ["1992", "1993", "1994"],
    "C2500 LS": ["1999", "2000"],
    "C2500 Suburban Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "C2500 Suburban LS": ["1995", "1996", "1997", "1998", "1999"],
    "C2500 Suburban LT": ["1995", "1996", "1997"],
    "C2500 Suburban Silverado": ["1992", "1993", "1994"],
    "C3500 Base": ["1994", "1995", "1996", "1997", "1999", "2000"],
    "C3500 Cheyenne": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "C3500 LS": ["1999", "2000"],
    "C3500 Silverado": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Caprice Classic": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Caprice Classic LS": ["1993", "1994"],
    "Caprice Classic LTZ": ["1991", "1992", "1993"],
    "Cavalier Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Cavalier LS": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Cavalier LS Sport": ["2002", "2003", "2004", "2005"],
    "Cavalier RS": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1997",
      "1998",
      "1999",
    ],
    "Cavalier VL": ["1988", "1989", "1990", "1991", "1992", "1993", "1994"],
    "Cavalier Z24": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Celebrity Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "Celebrity CL": ["1982", "1983"],
    "Celebrity Eurosport": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "Classic Base": ["2004", "2005"],
    "Colorado Sport": ["2004", "2005"],
    "Colorado Sport LS": ["2004", "2005"],
    "Colorado Z71 LS": ["2004", "2005"],
    "Colorado Z85": ["2004", "2005"],
    "Colorado Z85 LS": ["2004", "2005"],
    "Commercial Chassis Base": ["1991", "1992", "1993", "1994"],
    "Corsica Base": ["1987", "1988", "1989", "1994", "1995", "1996"],
    "Corsica LT": ["1987", "1988", "1990", "1991", "1992", "1993"],
    "Corvette ZR-1": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "Express 1500 Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Express 1500 LS": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Express 1500 LT": [
      "2001",
      "2002",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "G10 Beauville": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G10 Chevy Van": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G10 Sportvan": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G20 Beauville": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G20 Chevy Van": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G20 Sportvan": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G30 Beauville": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "G30 Chevy Van": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "G30 Hi-Cube": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "G30 Sportvan": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "K1500 Suburban Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "K1500 Suburban LS": ["1995", "1996", "1997", "1998", "1999"],
    "K1500 Suburban LT": ["1995", "1996", "1997"],
    "K1500 Suburban Silverado": ["1992", "1993", "1994"],
    "K2500 LS": ["1999", "2000"],
    "K2500 Suburban Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "K2500 Suburban LS": ["1995", "1996", "1997", "1998", "1999"],
    "K2500 Suburban LT": ["1995", "1996", "1997"],
    "K2500 Suburban Silverado": ["1992", "1993", "1994"],
    "K3500 Base": ["1994", "1995", "1996", "1997", "1999", "2000"],
    "K3500 Cheyenne": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "K3500 LS": ["1999", "2000"],
    "K3500 Silverado": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "LLV Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Lumina Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Lumina Euro": ["1990", "1991", "1992", "1993", "1994"],
    "Lumina LS": ["1995", "1996", "1997", "1998", "1999"],
    "Lumina LTZ": ["1997", "1998", "1999"],
    "Lumina Z34": ["1991", "1992", "1993", "1994"],
    "Lumina APV Base": ["1990", "1991", "1992", "1993", "1994", "1995", "1996"],
    "Lumina APV LS": ["1993", "1994", "1995", "1996"],
    "Malibu LS": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Malibu LT": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Malibu Maxx LS": ["2004", "2005", "2006", "2007"],
    "Malibu Maxx LT": ["2004", "2005", "2006", "2007"],
    "Monte Carlo Z34": ["1995", "1996", "1997", "1998", "1999"],
    "P30 Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "S10 EL": ["1992", "1993"],
    "S10 Blazer Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "S10 Blazer Tahoe": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "S10 Blazer Tahoe LT": ["1991", "1992", "1993", "1994"],
    "Tracker LT": ["2001", "2002", "2003", "2004"],
    "Tracker ZR2": ["2001", "2002", "2003", "2004"],
    "Venture Base": ["1997", "1998", "1999", "2000"],
    "Venture LS": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Venture LT": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "Venture Plus": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "Venture Value": ["2000", "2001", "2002", "2003"],
    "Venture Warner Bros.": ["2000", "2001", "2002", "2003"],
    "Bel Air Beauville": ["1955", "1956"],
    "Celebrity Estate": ["1985", "1986", "1987"],
    "Citation II Base": ["1984", "1985"],
    "Citation II X-11": ["1984", "1985"],
    "LUV Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "LUV Mighty Mike": ["1977", "1978", "1979"],
    "LUV Mikado": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "LUV Sport": ["1980", "1981", "1982"],
    "Luv Pickup Base": ["1972", "1973", "1974"],
    "One-Fifty Series Base": ["1955", "1956", "1957"],
    "Two-Ten Series Base": ["1955", "1956", "1957"],
    "Two-Ten Series Del Ray": ["1955", "1956", "1957"],
    "Blazer Scottsdale": ["1988", "1989", "1990", "1991"],
    "C1500 454 SS": ["1990", "1991", "1992", "1993"],
    "C3500 Scottsdale": ["1988", "1989", "1990", "1991", "1992"],
    "Caprice Classic Brougham": ["1986", "1987", "1988", "1989", "1990"],
    "Caprice Classic LS Brougham": ["1987", "1988", "1989", "1990"],
    "Caprice PPV": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "Cavalier CL": ["1982", "1983", "1984", "1985", "1986"],
    "Cavalier CS": ["1983", "1984", "1985", "1986", "1987"],
    "Cavalier Type-10": ["1984", "1985"],
    "Cobalt LS": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "Cobalt LT": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "Cobalt LTZ": ["2006", "2007"],
    "Cobalt SS": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "Equinox Sport": ["2008", "2009"],
    "HHR LS": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "HHR LS Panel": ["2007", "2008", "2009", "2010", "2011"],
    "HHR LT": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "HHR LT Panel": ["2007", "2008", "2009", "2010"],
    "HHR SS": ["2008", "2009", "2010"],
    "Impala LT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Impala LTZ": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Impala Limited LS": ["2014", "2015", "2016"],
    "Impala Limited LT": ["2014", "2015", "2016"],
    "Impala Limited LTZ": ["2014", "2015", "2016"],
    "Impala Limited Police": ["2014", "2015", "2016"],
    "K3500 Scottsdale": ["1988", "1989", "1990", "1991", "1992"],
    "Lumina APV CL": ["1990", "1991", "1992"],
    "Malibu Eco": ["2013", "2014"],
    "Malibu Hybrid": ["2008", "2009", "2010", "2016", "2017", "2018", "2019"],
    "Malibu LTZ": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Malibu Maxx LTZ": ["2006", "2007"],
    "Malibu Maxx SS": ["2006", "2007"],
    "Malibu SS": ["2006", "2007"],
    "Metro Base": ["1998", "1999", "2000"],
    "Metro LSi": ["1998", "1999", "2000", "2001"],
    "P20 Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "P20 Step-Van": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1987",
      "1988",
      "1989",
    ],
    "P30 Step-Van": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "Prizm Base": ["1998", "1999", "2000", "2001", "2002"],
    "Prizm LSi": ["1998", "1999", "2000", "2001", "2002"],
    "R10 Suburban Scottsdale": ["1987", "1988"],
    "R10 Suburban Silverado": ["1987", "1988"],
    "R1500 Suburban Scottsdale": ["1989", "1990", "1991"],
    "R1500 Suburban Silverado": ["1989", "1990", "1991"],
    "R20 Custom Deluxe": ["1987", "1988"],
    "R20 Scottsdale": ["1987", "1988"],
    "R20 Silverado": ["1987", "1988"],
    "R20 Suburban Scottsdale": ["1987", "1988"],
    "R20 Suburban Silverado": ["1987", "1988"],
    "R2500 Suburban Scottsdale": ["1989", "1990", "1991"],
    "R2500 Suburban Silverado": ["1989", "1990", "1991"],
    "R30 Custom Deluxe": ["1987", "1988"],
    "R30 Scottsdale": ["1987", "1988"],
    "R30 Silverado": ["1987", "1988"],
    "R3500 Cheyenne": ["1989", "1990", "1991"],
    "R3500 Scottsdale": ["1989", "1990"],
    "R3500 Silverado": ["1989", "1990", "1991"],
    "S10 Durango": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "S10 Sport": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "S10 Tahoe": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "S10 Blazer High Country": ["1987", "1988", "1989"],
    "S10 Blazer Sport": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "Sonic LS": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sonic LT": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sonic LTZ": ["2012", "2013", "2014", "2015", "2016"],
    "Sonic RS": ["2013", "2014", "2015", "2016"],
    "Spark LS": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Spark LT": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Spectrum Turbo": ["1987", "1988"],
    "Sprint Base": ["1985", "1986", "1987", "1988"],
    "Sprint Metro": ["1987", "1988"],
    "Sprint Turbo": ["1987", "1988"],
    "Trailblazer LS": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Trailblazer LT": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Trailblazer LTZ": ["2002", "2003"],
    "Trailblazer North Face": ["2002", "2003", "2004"],
    "Trailblazer SS": ["2006", "2007", "2008", "2009"],
    "Trailblazer EXT LS": ["2003", "2004", "2005", "2006"],
    "Trailblazer EXT LT": ["2002", "2003", "2004", "2005", "2006"],
    "Trailblazer EXT North Face": ["2002", "2003", "2004"],
    "Uplander Base": ["2005", "2006", "2007", "2008"],
    "Uplander LS": ["2005", "2006", "2007", "2008"],
    "Uplander LT": ["2005", "2006", "2007", "2008"],
    "V10 Suburban Scottsdale": ["1987", "1988"],
    "V10 Suburban Silverado": ["1987", "1988"],
    "V1500 Suburban Scottsdale": ["1989", "1990", "1991"],
    "V1500 Suburban Silverado": ["1989", "1990", "1991"],
    "V20 Suburban Scottsdale": ["1987", "1988"],
    "V20 Suburban Silverado": ["1987", "1988"],
    "V2500 Suburban Scottsdale": ["1989", "1990", "1991"],
    "V2500 Suburban Silverado": ["1989", "1990", "1991"],
    "V30 Custom Deluxe": ["1987", "1988"],
    "V30 Scottsdale": ["1987", "1988"],
    "V30 Silverado": ["1987", "1988"],
    "V3500 Cheyenne": ["1989", "1990", "1991"],
    "V3500 Scottsdale": ["1989", "1990"],
    "V3500 Silverado": ["1989", "1990", "1991"],
    "Volt Base": ["2011", "2012", "2013", "2014", "2015"],
    "Corvette E-Ray": ["2024", "2025"],
    "Silverado 2500 HD ZR2": ["2024", "2025"],
    "LCF 3500 Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Monte Carlo LT": ["2005", "2006", "2007"],
    "Silverado 1500 PPV": ["2023", "2024"],
    "Malibu L": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "Malibu Premier": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "Malibu RS": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Impala Premier": ["2017", "2018", "2019", "2020"],
    "Colorado Trail Boss": ["2023", "2024", "2025"],
    "Suburban Commercial": ["2021", "2022", "2023", "2024"],
    "Suburban RST": ["2021", "2022", "2023", "2024"],
    "Suburban Z71": ["2021", "2022", "2023", "2024"],
    "Chevelle 300": ["1967", "1968"],
    "Chevelle Deluxe": ["1965", "1966", "1967"],
    "El Camino Royal Knight": ["1979", "1980", "1981"],
    "Malibu Classic Sport": ["1979", "1980"],
    "Caprice Classic Estate": ["1976", "1977", "1978", "1981", "1982"],
    "Caprice Classic Landau": ["1976", "1977", "1978", "1979", "1980", "1981"],
    "Corsica LTZ": ["1989", "1990"],
    "Impala Estate": ["1981", "1982"],
    "C30 Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "G10 Bonaventure": ["1981", "1982", "1983", "1984", "1986", "1987"],
    "G10 Van Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "G10 Van Sportvan": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "G20 Bonaventure": ["1983", "1984"],
    "G20 Nomad": ["1978", "1979", "1980", "1981"],
    "Laguna Base": ["1973", "1974", "1975"],
    "Laguna S3": ["1975", "1976"],
    "Caprice Classic Sport": ["1975", "1976", "1979", "1980"],
    "Impala Landau": ["1977", "1978", "1979"],
    "K20 Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "K30 Custom": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "K30 Silverado": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Suburban High Country": ["2021", "2022", "2023", "2024"],
    "Tahoe Commercial": ["2022", "2023", "2024"],
    "Tahoe High Country": ["2021", "2022", "2023", "2024"],
    "Tahoe RST": ["2021", "2022", "2023", "2024"],
    "City Express LS": ["2015", "2016", "2017", "2018"],
    "City Express LT": ["2015", "2016", "2017", "2018"],
    "Traverse High Country": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Traverse L": ["2018", "2019", "2020", "2021"],
    "Traverse Premier": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Traverse RS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Blazer L": ["2019", "2020", "2021"],
    "Blazer Premier": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Blazer RS": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Colorado LS": ["2006", "2007", "2008"],
    "Equinox RS": ["2022", "2023", "2024", "2025"],
    "Trailblazer ACTIV": ["2021", "2022", "2023", "2024", "2025"],
    "Trailblazer L": ["2021", "2022"],
    "Trailblazer RS": ["2021", "2022", "2023", "2024", "2025"],
    "Aveo LS": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "Aveo LT": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "Aveo Special Value": ["2005", "2006"],
    "Sonic Premier": ["2017", "2018", "2019", "2020"],
    "Tracker Base": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "Tracker LSi": ["1998", "1999", "2000"],
    "Trax LS": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "Trax LT": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "Trax LTZ": ["2015", "2016"],
    "Trax Premier": ["2017", "2018", "2019", "2020"],
    "Spark ACTIV": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Spark EV LT": ["2014", "2015", "2016"],
    "Caprice Estate": ["1973", "1974"],
    "Impala Custom": ["1975", "1976", "1977"],
    "Impala Sport": ["1975", "1976", "1979", "1980"],
    "Nomad Base": ["1955", "1956", "1957", "1958", "1959", "1960", "1961"],
    "Truck 3100": ["1955", "1956", "1957", "1958", "1959"],
    "Truck 3200": ["1955", "1956", "1957", "1958"],
    "Truck 3400": ["1955", "1956", "1957", "1958"],
    "Truck 3500": ["1955", "1956", "1957", "1958"],
    "Truck 3600": ["1955", "1956", "1957", "1958"],
    "Truck 3700": ["1955", "1956", "1957", "1958"],
    "Truck 3800": ["1955", "1956", "1957", "1958"],
    "Truck Base": ["1955", "1956", "1957", "1958"],
    "Chevette Base": [
      "1976",
      "1977",
      "1978",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "Chevette CS": ["1984", "1985", "1986", "1987"],
    "G30 Bonaventure": ["1983", "1984"],
    "Suburban Base": ["1960", "1961", "1962", "1963", "1964", "1965", "1966"],
    "G30 Van Base": ["1970", "1971", "1972", "1973", "1974"],
    "G30 Van Sportvan": ["1970", "1971", "1972", "1973", "1974"],
    "Aveo5 LS": ["2007", "2008", "2009", "2010", "2011"],
    "Aveo5 LT": ["2009", "2010", "2011"],
    "Aveo5 Special Value": ["2007", "2008"],
    "Citation Base": ["1980", "1981", "1982", "1983"],
    "Citation X-11": ["1980", "1981", "1982", "1983"],
    "Volt LT": ["2016", "2017", "2018", "2019"],
    "Volt Premier": ["2016", "2017", "2018", "2019"],
    "Chevette Scooter": [
      "1976",
      "1977",
      "1978",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "Spectrum Base": ["1985", "1986", "1987", "1988"],
    "Spectrum CL": ["1987", "1988"],
    "Spectrum CL Plus": ["1987", "1988"],
    "Spectrum Express": ["1987", "1988"],
    "Sprint ER": ["1986", "1987", "1988"],
    "Monza 2+2": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Monza 2+2 Sport": ["1978", "1979", "1980"],
    "Monza 2+2 Spyder": ["1976", "1977", "1978", "1979", "1980"],
    "Monza Base": ["1978", "1979", "1980"],
    "Monza S": ["1978", "1979"],
    "Monza Towne Coupe": ["1976", "1977"],
    "Monza Towne Coupe Cabriolet": ["1976", "1977"],
    "Monza Towne Coupe Sport": ["1976", "1977"],
    "Vega Base": ["1971", "1972", "1973", "1974", "1975", "1976", "1977"],
    "Vega Cosworth": ["1975", "1976"],
    "Vega Estate": ["1976", "1977"],
    "Vega GT": ["1976", "1977"],
    "Vega Panel": ["1971", "1972", "1973", "1974"],
    "Vega Sport": ["1976", "1977"],
    "P20 Van Base": ["1970", "1971"],
    "P30 Van Base": ["1970", "1971", "1972", "1973", "1974"],
    "C10 Panel Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "C30 Panel Base": ["1960", "1961", "1962", "1963", "1964", "1965"],
    "Del Ray Base": ["1957", "1958"],
    "P10 Series Base": ["1963", "1964", "1965", "1966", "1967"],
    "P10 Van Base": ["1968", "1969"],
    "P20 Series Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "P30 Series Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "P10 Base": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "P10 Step-Van": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Bolt EUV LT": ["2022", "2023"],
    "Bolt EUV Premier": ["2022", "2023"],
    "LCF 3500HG Base": ["2024", "2025"],
    "Parkwood Base": ["1959", "1960", "1961"],
    "Corvair 95": ["1961", "1962", "1963", "1964"],
    "Corvair Base": ["1960", "1961", "1962", "1963", "1964"],
    "Corvair Deluxe": ["1960", "1961"],
    "Corvair Monza": ["1960", "1961", "1962", "1963", "1964"],
    "Corvair Monza Spyder": ["1962", "1963", "1964"],
    "Corvair Truck 95": ["1961", "1962", "1963", "1964"],
    "Sedan Delivery Base": ["1958", "1959", "1960"],
    "Bolt EV LT": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "Bolt EV Premier": ["2017", "2018", "2019", "2020", "2021"],
  },
  Infiniti: {
    "G37 Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "G37 IPL": ["2011", "2012", "2013"],
    "G37 Journey": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "G37 Sport": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "G37 X": ["2009", "2010", "2011", "2012", "2013"],
    "Q60 Base": ["2014", "2015"],
    "Q60 IPL": ["2014", "2015"],
    "Q60 Journey": ["2014", "2015"],
    "Q60 S": ["2014", "2015"],
    "QX56 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "QX80 Base": ["2014", "2015", "2016", "2017", "2018"],
    "QX80 Limited": ["2016", "2017", "2019", "2020"],
    "QX80 Luxe": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "QX80 Premium Select": ["2021", "2022", "2023", "2024"],
    "QX80 Sensory": ["2021", "2022", "2023", "2024"],
    "FX35 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "FX50 Base": ["2009", "2010", "2011", "2012", "2013"],
    "M56 Base": ["2011", "2012", "2013"],
    "M56 X": ["2011", "2012", "2013"],
    "Q50 Premium": ["2014", "2015", "2016", "2017"],
    "Q50 Red Sport 400": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Q50 Sport": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "Q70 5.6": ["2014", "2015", "2016", "2017"],
    "Q70L 5.6": ["2015", "2016", "2017"],
    "QX70 Base": ["2014", "2015", "2016", "2017"],
    "G35 Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "G35 X": ["2004", "2005", "2006", "2007", "2008"],
    "G20 Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "G20 T": ["1994", "1995", "1996", "1999", "2000", "2001", "2002"],
    "G35 Journey": ["2007", "2008"],
    "G35 Sport": ["2007", "2008"],
    "I30 Base": ["1996", "1997", "1998", "1999", "2000", "2001"],
    "I30 T": ["1996", "1997", "1998", "1999", "2000", "2001"],
    "QX50 Autograph": ["2020", "2021", "2022", "2023", "2024"],
    "QX50 Essential": ["2019", "2020", "2021", "2022"],
    "QX50 Luxe": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "QX50 Pure": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "QX50 Sensory": ["2020", "2021", "2022", "2023", "2024"],
    "QX50 Sport": ["2023", "2024"],
    "QX55 Essential": ["2022", "2023", "2024"],
    "QX55 Luxe": ["2022", "2023", "2024"],
    "QX55 Sensory": ["2022", "2023", "2024"],
    "QX60 Autograph": ["2022", "2023", "2024"],
    "QX60 Luxe": ["2019", "2020", "2022", "2023", "2024"],
    "QX60 Pure": ["2019", "2020", "2022", "2023", "2024"],
    "QX60 Sensory": ["2022", "2023", "2024"],
    "FX45 Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "Q50 Base": ["2014", "2015", "2016", "2017"],
    "Q50 Luxe": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Q50 Pure": ["2018", "2019", "2020", "2021", "2022"],
    "EX35 Base": ["2008", "2009", "2010", "2011", "2012"],
    "EX35 Journey": ["2008", "2009", "2010", "2011", "2012"],
    "M35 Base": ["2006", "2007", "2008", "2009", "2010"],
    "M35 X": ["2006", "2007", "2008", "2009", "2010"],
    "M35h Base": ["2012", "2013"],
    "M37 Base": ["2011", "2012", "2013"],
    "M37 X": ["2011", "2012", "2013"],
    "Q50 Hybrid Premium": ["2014", "2015", "2016", "2017"],
    "Q50 Hybrid Sport": ["2014", "2015"],
    "Q50 Sensory": ["2021", "2022", "2023", "2024"],
    "Q60 Luxe": ["2018", "2019", "2020", "2021", "2022"],
    "Q60 Pure": ["2018", "2019", "2020", "2021", "2022"],
    "Q60 Red Sport 400": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Q60 Sport": ["2017", "2018"],
    "Q70 3.7": ["2014", "2015", "2016", "2017"],
    "Q70 Hybrid": ["2014", "2015", "2016", "2017", "2018"],
    "Q70L 3.7": ["2015", "2016", "2017"],
    "Q70L 3.7 Luxe": ["2018", "2019"],
    "QX50 Base": ["2014", "2015", "2016", "2017"],
    "QX50 Journey": ["2014", "2015"],
    "QX30 Base": ["2017", "2018"],
    "QX30 Luxury": ["2017", "2018"],
    "QX30 Premium": ["2017", "2018"],
    "QX30 Sport": ["2017", "2018", "2019"],
    "QX4 Base": ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "G25 Base": ["2011", "2012"],
    "G25 Journey": ["2011", "2012"],
    "G25 X": ["2011", "2012"],
    "M35 Sport": ["2006", "2007"],
    "M45 Base": ["2003", "2004", "2006", "2007", "2008", "2009", "2010"],
    "M45 Sport": ["2006", "2007"],
    "M45 X": ["2008", "2009", "2010"],
    "Q70 5.6 Luxe": ["2018", "2019"],
    "QX60 Base": ["2014", "2015", "2016", "2017", "2018"],
    "QX60 Hybrid": ["2014", "2015", "2016", "2017"],
    "Q45 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Q70L 5.6 Luxe": ["2018", "2019"],
    "Q45 A": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Q45 T": ["1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    "I35 Base": ["2002", "2003", "2004"],
    "J30 Base": ["1993", "1994", "1995", "1996", "1997"],
    "J30 T": ["1993", "1994", "1995", "1996", "1997"],
    "M30 Base": ["1990", "1991", "1992"],
  },
  Toyota: {
    "Tundra 1794 Edition": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tundra Capstone": ["2022", "2023", "2024"],
    "Tundra Limited": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tundra Platinum": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tundra SR": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tundra SR5": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tundra TRD Pro": [
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Avalon Hybrid Limited": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Avalon Hybrid XLE": ["2013", "2014", "2019", "2020", "2021", "2022"],
    "Avalon Hybrid XSE": ["2019", "2020", "2021"],
    "Avalon Limited": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Avalon Touring": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Avalon TRD": ["2020", "2021"],
    "Avalon XLE": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Avalon XSE": ["2019", "2020"],
    "C-HR LE": ["2019", "2020", "2021", "2022"],
    "C-HR Limited": ["2019", "2020", "2021", "2022"],
    "C-HR XLE": ["2018", "2019", "2020", "2021", "2022"],
    "Camry Hybrid LE": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Camry Hybrid SE": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Camry Hybrid XLE": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Camry L": ["2012", "2013", "2014", "2018", "2019", "2020"],
    "Camry LE": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Camry SE": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Camry SE Nightshade": ["2020", "2021", "2022", "2023", "2024"],
    "Camry TRD": ["2020", "2021", "2022", "2023", "2024"],
    "Camry XLE": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Camry XSE": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Corolla Hybrid LE": ["2020", "2021", "2022", "2023", "2024"],
    "Corolla Hybrid SE": ["2023", "2024"],
    "Corolla Hybrid XLE": ["2023", "2024"],
    "Corolla L": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Corolla LE": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Corolla SE": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Corolla SE Apex": ["2021", "2022"],
    "Corolla SE Nightshade": ["2020", "2021", "2022"],
    "Corolla XLE": [
      "2009",
      "2010",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Corolla XSE": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Corolla XSE Apex": ["2021", "2022"],
    "Highlander Hybrid Bronze Edition": ["2022", "2023", "2024"],
    "Highlander Hybrid LE": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Highlander Hybrid Limited": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Highlander Hybrid Platinum": ["2020", "2021", "2022", "2023", "2024"],
    "Highlander Hybrid XLE": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Highlander L": ["2020", "2021", "2022", "2023"],
    "Highlander LE": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Highlander Limited": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Highlander Platinum": ["2020", "2021", "2022", "2023", "2024"],
    "Highlander XLE": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Prius Four": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Prius Four Touring": ["2016", "2017", "2018"],
    "Prius L Eco": ["2019", "2020", "2021", "2022"],
    "Prius LE": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Prius Limited": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Prius One": ["2017", "2018"],
    "Prius Three": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Prius Three Touring": ["2016", "2017", "2018"],
    "Prius Two": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Prius Two Eco": ["2016", "2017", "2018"],
    "Prius XLE": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Prius AWD-e LE": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Prius AWD-e XLE": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Prius Prime Advanced": ["2017", "2018", "2019"],
    "Prius Prime LE": ["2020", "2021", "2022"],
    "Prius Prime Limited": ["2020", "2021", "2022"],
    "Prius Prime Plus": ["2017", "2018", "2019"],
    "Prius Prime Premium": ["2017", "2018", "2019"],
    "Prius Prime XLE": ["2020", "2021", "2022"],
    "RAV4 Adventure": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "RAV4 Hybrid LE": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "RAV4 Hybrid Limited": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RAV4 Hybrid XLE": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RAV4 Hybrid XSE": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "RAV4 LE": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RAV4 Limited": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RAV4 TRD Off-Road": ["2020", "2021", "2022", "2023", "2024"],
    "RAV4 XLE": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RAV4 XLE Premium": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Venza LE": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Venza Limited": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Venza Nightshade": ["2023", "2024"],
    "Venza XLE": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Avalon Hybrid XLE Plus": ["2016", "2017", "2018"],
    "Avalon Hybrid XLE Premium": ["2015", "2016", "2017", "2018"],
    "RAV4 Platinum": ["2017", "2018"],
    "RAV4 SE": ["2016", "2017", "2018"],
    "Sequoia Limited": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Sequoia Nightshade": ["2021", "2022"],
    "Sequoia Platinum": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Sequoia SR5": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Sequoia TRD Pro": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "Sequoia TRD Sport": ["2018", "2019", "2020", "2021", "2022"],
    "Tacoma Limited": [
      "1998",
      "1999",
      "2000",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tacoma SR": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tacoma SR5": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tacoma TRD Off-Road": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tacoma TRD Pro": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tacoma TRD Sport": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Avalon Base": ["2011", "2012"],
    "Avalon XL": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Avalon XLS": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Corolla LE Eco": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Corolla S": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Corolla XRS": ["2005", "2006", "2009", "2010"],
    "Matrix S": ["2009", "2010", "2011", "2012", "2013"],
    "Matrix XRS": ["2003", "2004", "2005", "2006", "2009", "2010"],
    "RAV4 Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "RAV4 Sport": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Venza Base": ["2009", "2010", "2011"],
    "4Runner Limited": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "4Runner Sport": ["2003", "2004", "2005", "2006", "2007", "2008", "2009"],
    "4Runner SR5": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FJ Cruiser Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Tacoma Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Tacoma Pre Runner": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Tacoma X-Runner": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Tundra Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Land Cruiser Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Land Cruiser Heritage Edition": ["2020", "2021"],
    "GR Supra Base": ["2020", "2021", "2022", "2023", "2024"],
    "GR Supra A91 Edition": ["2021", "2022", "2023"],
    "GR Supra Premium": ["2020", "2021", "2022", "2023", "2024"],
    "Supra Twin Turbo": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Supra Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Supra Turbo": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "MR2 Turbo": ["1991", "1992", "1993", "1994", "1995"],
    "Camry Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "2005",
      "2006",
      "2009",
      "2010",
      "2011",
    ],
    "Celica GT": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Celica GTS": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Celica ST": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Corolla Base": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "2009",
      "2010",
      "2011",
    ],
    "Corolla CE": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Corolla DX": ["1993", "1994", "1995", "1996", "1997"],
    "Corolla VE": ["1998", "1999", "2000"],
    "Matrix Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Matrix XR": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "MR2 Spyder Base": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "Camry CE": ["1997", "1998", "1999", "2000", "2001", "2007", "2008"],
    "Camry DLX All Trac": ["1988", "1989", "1990", "1991"],
    "Camry LE All Trac": ["1988", "1989", "1990", "1991"],
    "Celica All Trac": ["1988", "1989", "1990", "1991", "1992"],
    "Solara SE": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Solara SLE": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Celica Supra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Cressida Luxury": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Pickup Base": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Pickup Base Turbo": ["1986", "1987"],
    "Pickup DLX": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Pickup SR5 Turbo": ["1985", "1986", "1987", "1988"],
    "86 Base": ["2017", "2018", "2019", "2020"],
    "86 GT": ["2018", "2019", "2020"],
    "Corolla DLX": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Corolla DLX All Trac": ["1988", "1989", "1990", "1991", "1992"],
    "Corolla GTS": ["1988", "1989", "1990", "1991"],
    "MR2 GT": ["1985", "1986", "1987", "1988", "1989"],
    "Corolla FX": ["1987", "1988"],
    "Corolla FX16": ["1987", "1988"],
    "Corolla FX16 GTS": ["1987", "1988"],
    "Corolla SR5": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Corolla SR5 All Trac": ["1988", "1989", "1990"],
    "Paseo Base": ["1992", "1993", "1994", "1995", "1996", "1997", "1998"],
    "Paseo Convertible": ["1997", "1998"],
    "Tercel CE": ["1997", "1998"],
    "Tercel DLX": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Tercel DX": ["1987", "1988", "1989", "1990", "1995", "1996"],
    "Tercel LE": ["1991", "1992", "1993", "1994"],
    "Tercel STD": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "4Runner DLX": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "Celica Base": ["1972", "1973", "1974"],
    "Corona Base": ["1971", "1972", "1973", "1974", "1975", "1976"],
    "Corona Custom": ["1977", "1978"],
    "Corona DLX": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "Corona LE": ["1979", "1980", "1981", "1982"],
    "Corona Mark II": ["1971", "1972", "1973"],
    "Corona SR5": ["1975", "1976", "1977"],
    "Crown Base": ["1967", "1968", "1969", "1970", "1971", "1972"],
    "Hi-Lux Base": ["1970", "1971", "1972", "1973", "1974"],
    "Mark II Base": ["1972", "1973", "1974", "1975", "1976"],
    "Pickup SR5": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "T100 DLX": ["1996", "1997"],
    "T100 SR5": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Tacoma S-Runner": ["2001", "2002", "2003", "2004"],
    "Van Wagon Crg": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "Van Wagon DX": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "Van Wagon LE": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "Camry DLX": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Echo Base": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "Yaris Base": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "Yaris L": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Yaris S": ["2007", "2008", "2009"],
    "Yaris SE": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Sequoia Capstone": ["2023", "2024", "2025"],
    "4Runner Nightshade": ["2020", "2021"],
    "4Runner SR5 Premium": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "4Runner Trail": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2021",
      "2022",
    ],
    "4Runner TRD Off-Road": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "4Runner TRD Off-Road Premium": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "4Runner TRD Pro": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "4Runner TRD Sport": ["2022", "2023", "2024"],
    "4Runner Venture": ["2020", "2021"],
    "Prius Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Prius Touring": ["2007", "2008", "2009"],
    "Sienna CE": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Sienna LE": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sienna XLE": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sienna XLE Limited": ["2004", "2005"],
    "Mirai Base": ["2016", "2017", "2018", "2019", "2020"],
    "Prius Five": ["2012", "2013", "2014", "2015"],
    "Prius Plug-In Base": ["2012", "2013", "2014", "2015"],
    "Prius V Five": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Prius V Four": ["2015", "2016", "2017"],
    "Prius V Three": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Prius V Two": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Camry Hybrid": ["2007", "2008", "2009", "2010", "2011"],
    "Highlander Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Highlander Hybrid": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Highlander SE": ["2010", "2011", "2012", "2013", "2017", "2018", "2019"],
    "Highlander Sport": ["2006", "2007", "2008", "2009", "2010"],
    "MR2 Base": ["1991", "1992", "1993", "1994", "1995"],
    "MR2 Super Charged": ["1988", "1989"],
    "Avalon XLE Plus": ["2016", "2017", "2018"],
    "Avalon XLE Premium": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Avalon XLE Touring": ["2013", "2014", "2015"],
    "Corolla iM Base": ["2017", "2018"],
    "Highlander LE Plus": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Prius C Four": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Prius C One": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Prius C Three": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Prius C Two": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "RAV4 Hybrid SE": ["2017", "2018", "2022", "2023", "2024"],
    "Sienna Base": ["2011", "2012", "2013"],
    "Sienna L": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sienna Limited": [
      "2006",
      "2007",
      "2008",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sienna Limited Premium": ["2018", "2019", "2020"],
    "Sienna SE": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sienna SE Premium": ["2018", "2019", "2020"],
    "Sienna XLE Premium": ["2018", "2019", "2020"],
    "Yaris LE": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Carina Base": ["1971", "1972", "1973"],
    "Corolla Custom": ["1977", "1978", "1979"],
    "4Runner Base": ["1996", "1997", "1998", "1999", "2000", "2001"],
    "Yaris XLE": ["2019", "2020"],
    "Yaris iA Base": ["2017", "2018"],
    "Corolla Sport DLX": ["1984", "1985", "1986", "1987"],
    "Corolla Sport GTS": ["1985", "1986", "1987"],
    "Corolla Sport SR5": ["1984", "1985", "1986", "1987"],
    "Corolla LE Limited": ["1985", "1986"],
    "Camry Hybrid SE Nightshade": ["2022", "2023", "2024"],
    "Camry Hybrid XSE": ["2021", "2022", "2023", "2024", "2025"],
    "GR86 Base": ["2022", "2023", "2024"],
    "GR86 Premium": ["2022", "2023", "2024"],
    "Camry DX": ["1993", "1994", "1995", "1996"],
    "Previa DX": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "Previa LE": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "Sienna Platinum": ["2021", "2022", "2023", "2024"],
    "Sienna Woodland Edition": ["2022", "2023", "2024"],
    "Sienna XSE": ["2021", "2022", "2023", "2024"],
    "Highlander XSE": ["2021", "2022", "2023", "2024"],
    "RAV4 EV": ["2012", "2013", "2014"],
    "RAV4 Hybrid XLE Premium": ["2021", "2022", "2023", "2024"],
    "C-HR Nightshade": ["2021", "2022"],
    "Cressida Base": ["1978", "1979", "1980"],
    "T100 Base": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "T100 DX": ["1994", "1995"],
    "Tercel Base": ["1989", "1990"],
    "Tercel EZ": ["1988", "1989", "1990"],
    "Tercel SR5": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Solara Sport": ["2007", "2008"],
    "Stout Base": ["1966", "1967", "1968"],
    "Starlet Base": ["1981", "1982", "1983", "1984"],
    "bZ4X Limited": ["2023", "2024"],
    "bZ4X XLE": ["2023", "2024"],
    "Corolla Cross Hybrid S": ["2023", "2024"],
    "Corolla Cross Hybrid SE": ["2023", "2024"],
    "Corolla Cross Hybrid XSE": ["2023", "2024"],
    "Corolla Cross L": ["2022", "2023", "2024"],
    "Corolla Cross LE": ["2022", "2023", "2024"],
    "Corolla Cross XLE": ["2022", "2023", "2024"],
    "GR Corolla Circuit Edition": ["2023", "2024", "2025"],
    "GR Corolla Core": ["2023", "2024", "2025"],
    "GR Corolla Premium": ["2024", "2025"],
    "Mirai Platinum": ["2022", "2023"],
    "Mirai XLE": ["2021", "2022", "2023", "2024"],
    "Prius Prime SE": ["2023", "2024", "2025"],
    "Prius Prime XSE": ["2023", "2024", "2025"],
    "Prius Prime XSE Premium": ["2023", "2024", "2025"],
    "RAV4 Hybrid Woodland Edition": ["2023", "2024"],
    "Crown Limited": ["2023", "2024", "2025"],
    "Crown Platinum": ["2023", "2024", "2025"],
    "Crown XLE": ["2023", "2024", "2025"],
    "Grand Highlander Hybrid Limited": ["2024", "2025"],
    "Grand Highlander Hybrid Platinum": ["2024", "2025"],
    "Grand Highlander Hybrid XLE": ["2024", "2025"],
    "Grand Highlander Limited": ["2024", "2025"],
    "Grand Highlander Platinum": ["2024", "2025"],
    "Grand Highlander XLE": ["2024", "2025"],
    "Prius AWD-e Limited": ["2023", "2024", "2025"],
    "RAV4 Prime SE": ["2021", "2022", "2023", "2024"],
    "RAV4 Prime XSE": ["2021", "2022", "2023", "2024"],
  },
  BMW: {
    "M3 Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "528i Base": [
      "1979",
      "1980",
      "1981",
      "1997",
      "1998",
      "1999",
      "2000",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "528i xDrive Base": [
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "535d Base": ["2014", "2015", "2016"],
    "535d xDrive Base": ["2014", "2015", "2016"],
    "535i Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "535i GT Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "535i GT xDrive Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "535i xDrive Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "550i Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "550i Gt Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "550i GT xDrive Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "550i xDrive Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "640i Base": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "640i Gran Coupe Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "640i xDrive Base": ["2014", "2015", "2016", "2017", "2018"],
    "640i xDrive Gran Coupe Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "640i xDrive Gran Turismo Base": ["2018", "2019"],
    "650i Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "650i Gran Coupe Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "650i xDrive Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "650i xDrive Gran Coupe Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "740i Base": [
      "1993",
      "1994",
      "1995",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "740Li Base": ["2011", "2012", "2013", "2014", "2015"],
    "740Li xDrive Base": ["2013", "2014", "2015"],
    "750i ActiveHybrid": ["2011", "2012"],
    "750i Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "750i xDrive Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "750Li ActiveHybrid": ["2011", "2012"],
    "750Li Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "750Li xDrive Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "760Li Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "ActiveHybrid 5 Base": ["2012", "2013", "2014", "2015", "2016"],
    "ActiveHybrid 7 Base": ["2013", "2014", "2015"],
    "Alpina B6 xDrive Gran Coupe Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Alpina B7 Base": ["2007", "2008", "2011", "2012", "2013", "2014", "2015"],
    "Alpina B7 xDrive Base": ["2011", "2012", "2013", "2014", "2015"],
    "Alpina B7L Base": ["2011", "2012", "2013", "2014", "2015"],
    "Alpina B7L xDrive Base": ["2011", "2012", "2013", "2014", "2015"],
    "M5 Base": [
      "1991",
      "1992",
      "1993",
      "2000",
      "2001",
      "2002",
      "2003",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "M6 Base": [
      "1987",
      "1988",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "M6 Gran Coupe Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "X1 sDrive28i": [
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "X1 xDrive28i": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "X2 sDrive28i": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "X2 xDrive28i": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "M2 Competition": ["2019", "2020", "2021"],
    "M4 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "M4 CS": ["2019", "2020"],
    "530i Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1994",
      "1995",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "540i Base": [
      "1994",
      "1995",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "545i Base": ["2004", "2005"],
    "740iL Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "745i Base": ["2002", "2003", "2004", "2005"],
    "745Li Base": ["2002", "2003", "2004", "2005"],
    "840Ci Base": ["1994", "1995", "1996", "1997"],
    "X5 3.0i": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "X5 4.4i": ["2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "X5 4.6is": ["2002", "2003"],
    "X5 4.8is": ["2004", "2005", "2006"],
    "Z8 Base": ["2000", "2001", "2002", "2003"],
    "323i Base": ["1998", "1999", "2000"],
    "323is Base": ["1998", "1999"],
    "325Ci Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "325i Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "325is Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "325xi Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "328i Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "328is Base": ["1996", "1997", "1998", "1999"],
    "330Ci Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "330i Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "330xi Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "525i Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "X3 2.5i": ["2004", "2005"],
    "X3 3.0i": ["2004", "2005", "2006"],
    "Z3 Coupe": ["1999", "2000", "2001", "2002"],
    "Z3 M Coupe": ["1999", "2000", "2001", "2002"],
    "Z3 M Roadster": ["1998", "1999", "2000", "2001", "2002"],
    "Z3 Roadster": ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    "Z4 2.5i": ["2003", "2004", "2005"],
    "Z4 3.0i": ["2003", "2004", "2005"],
    "Z4 M Roadster": ["2006", "2007", "2008"],
    "Z4 sDrive30i": [
      "2009",
      "2010",
      "2011",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "335i Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "340i Base": ["2016", "2017", "2018"],
    "340i GT xDrive Base": ["2017", "2018", "2019"],
    "340i xDrive Base": ["2016", "2017", "2018"],
    "440i Base": ["2017", "2018", "2019", "2020"],
    "440i Gran Coupe Base": ["2017", "2018", "2019", "2020"],
    "440i xDrive Base": ["2017", "2018", "2019", "2020"],
    "440i xDrive Gran Coupe Base": ["2017", "2018", "2019", "2020"],
    "540i xDrive Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "740i xDrive Base": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "M240i Base": ["2017", "2018", "2019", "2020", "2021"],
    "M240i xDrive Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "228i Base": ["2014", "2015", "2016"],
    "228i xDrive Base": ["2015", "2016"],
    "320i Base": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "320i xDrive Base": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "328i GT xDrive Base": ["2014", "2015", "2016"],
    "328i xDrive Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "428i Base": ["2014", "2015", "2016"],
    "428i Gran Coupe Base": ["2015", "2016"],
    "428i xDrive Base": ["2014", "2015", "2016"],
    "428i xDrive Gran Coupe Base": ["2015", "2016"],
    "Z4 M40i": ["2022", "2023", "2024"],
    "Z4 sDrive M40i": ["2020", "2021"],
    "318i Base": [
      "1984",
      "1985",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "318is Base": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "318ti Base": ["1995", "1996", "1997", "1998", "1999"],
    "128i Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "135i Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "328xi Base": ["2007", "2008"],
    "335i xDrive Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "335is Base": ["2011", "2012", "2013"],
    "335xi Base": ["2007", "2008"],
    "435i Base": ["2014", "2015", "2016"],
    "435i xDrive Base": ["2014", "2015", "2016"],
    "525xi Base": ["2006", "2007"],
    "530xi Base": ["2006", "2007"],
    "X3 3.0si": ["2007", "2008"],
    "Z4 sDrive35i": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    F650: ["1997", "1998", "1999", "2000"],
    "F650 Funduro": ["1998", "1999", "2000", "2001"],
    F650CS: ["2001", "2002", "2003", "2004", "2005", "2006"],
    "F650CS ABS": ["2003", "2004", "2005"],
    F650GS: [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "F650GS ABS": ["2001", "2002", "2003"],
    "F650GS Dakar": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "F650GS Dakar ABS": ["2002", "2003", "2004", "2005"],
    F650ST: ["1997", "1998", "1999"],
    F700GS: ["2013", "2014", "2015", "2016", "2017", "2018"],
    F800GS: [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "F800GS Adventure": ["2013", "2014", "2015", "2016", "2017", "2018"],
    F800GT: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    F800R: [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    F800S: ["2006", "2007", "2008"],
    F800ST: ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    G310GS: ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    G310R: ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    G450X: ["2008", "2009", "2010", "2011"],
    "G650 Xchallenge": ["2007", "2008"],
    "G650 Xcountry": ["2007", "2008", "2009"],
    "G650 Xmoto": ["2007", "2008"],
    G650GS: ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "G650GS Sertao": ["2012", "2013", "2014", "2015"],
    "Hp2 Enduro": ["2006", "2007", "2008"],
    "Hp2 Megamoto": ["2007", "2008", "2009", "2010", "2011"],
    "Hp2 Sport": ["2008", "2009", "2010", "2011"],
    "HP4 Race": ["2013", "2014", "2015", "2017", "2018", "2019", "2020"],
    K1: ["1988", "1989", "1990", "1991", "1992", "1993", "1994"],
    K100: ["1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990"],
    K100LT: [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "K100LT ABS": ["1989", "1990", "1991", "1992"],
    K100RS: [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "K100RS ABS": ["1988", "1989"],
    "K100RS FL": ["1991", "1992"],
    "K100RS FL ABS": ["1991", "1992"],
    K100RT: [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    K1100LT: ["1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    K1100RS: ["1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    K1200GT: ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    K1200LT: [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    K1200LTC: ["1999", "2000", "2001", "2002"],
    "K1200LTI Icon": ["1999", "2000", "2001"],
    K1200LTS: ["1999", "2000"],
    K1200R: ["2005", "2006", "2007", "2008"],
    "K1200R Sport": ["2007", "2008"],
    K1200RS: [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    K1200S: ["2005", "2006", "2007", "2008"],
    K1300GT: ["2009", "2010", "2011"],
    K1300S: ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "K1300S HP": ["2009", "2010", "2011", "2012", "2013"],
    K1600B: ["2017", "2018", "2019", "2020", "2021", "2022"],
    K1600GT: [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    K1600GTL: [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    K75: [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    K75C: ["1985", "1986", "1987", "1988"],
    K75RT: ["1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "K75RT ABS": ["1991", "1992", "1993", "1994", "1995"],
    K75S: [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "K75S Abs": ["1991", "1992", "1993", "1994", "1995"],
    K75T: ["1986", "1987"],
    "R Nine T": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "R Nine T Pure": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "R Nine T Racer": ["2017", "2018", "2019", "2020", "2021"],
    "R Nine T Scrambler": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "R Nine T Urban G/S": ["2017", "2018", "2019", "2020"],
    R100: [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
    ],
    "R100/7": ["1976", "1977", "1978"],
    R100CS: [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    R100GS: [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "R100GS Paris-Dakar": ["1990", "1991", "1992", "1993", "1994", "1995"],
    R100R: [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    R100RS: [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    R100RT: [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    R100S: [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    R100T: ["1978", "1979", "1980", "1981", "1982", "1983", "1984"],
    R1100GS: ["1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    "R1100GS ABS": ["1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    R1100R: ["1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    R1100RS: ["1993", "1994"],
    "R1100RS ABS": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    R1100RSL: ["1994", "1995", "1996", "1997"],
    R1100RT: ["1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    R1100RTL: ["1996", "1997"],
    R1100S: ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "R1100S ABS": ["2004", "2005"],
    "R1100S Boxer Cup Replica": ["2003", "2004", "2005"],
    R1100SA: ["2000", "2001"],
    R1150GS: ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "R1150GS Adventure": ["2002", "2003", "2004", "2005"],
    R1150R: ["2001", "2002", "2003", "2004", "2005", "2006"],
    "R1150R Rockster": ["2002", "2003", "2004", "2005", "2006"],
    R1150RS: ["2001", "2002", "2003", "2004", "2005"],
    R1150RT: ["2001", "2002", "2003", "2004", "2005"],
    "R1200 Hp2": ["2008", "2009", "2010"],
    R1200C: ["1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "R1200C Avantgarde": ["2000", "2001", "2002", "2003"],
    "R1200C Classic": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "R1200C Euro": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "R1200C Independent": ["2000", "2001", "2002", "2003", "2004"],
    "R1200C Montana": ["2000", "2001", "2002", "2003", "2004"],
    "R1200C Montauk": ["2003", "2004", "2005"],
    "R1200C Phoenix": ["2000", "2001", "2002", "2003", "2004"],
    R1200CL: ["2002", "2003", "2004", "2005", "2006"],
    R1200GS: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "R1200GS Adventure": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "R1200GS Hp2": ["2005", "2006", "2007", "2008"],
    "R1200GS Triple Black": ["2011", "2012"],
    R1200R: [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "R1200R Classic": ["2011", "2012"],
    R1200RS: ["2015", "2016", "2017", "2018", "2019"],
    R1200RT: [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    R1200S: ["2006", "2007", "2008", "2009", "2010", "2011"],
    R1200ST: ["2005", "2006", "2007", "2008"],
    R45: ["1978", "1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    "R50/2": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "R50/5": ["1969", "1970", "1971", "1972", "1973"],
    "R60/2": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "R60/5": ["1969", "1970", "1971", "1972", "1973", "1974"],
    "R60/6": ["1973", "1974", "1975", "1976"],
    "R60/7": ["1976", "1977", "1978", "1979", "1980"],
    R65: [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    R65LS: ["1978", "1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    "R75/5": ["1969", "1970", "1971", "1972", "1973"],
    "R75/6": ["1973", "1974", "1975", "1976"],
    "R75/7": ["1976", "1977", "1978", "1979"],
    R80: [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "R80/7": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
    ],
    "R80G/S": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    R80R: ["1992", "1993", "1994", "1995"],
    R80RT: [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    R80ST: [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "R850C Avantgarde": ["2000", "2001", "2002", "2003"],
    "R850C Classic": ["1996", "1997", "1998", "1999", "2000", "2001"],
    "R850C Euro": ["2000", "2001"],
    R850R: [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "R90/6": ["1973", "1974", "1975", "1976"],
    R90S: ["1969", "1970", "1971", "1972", "1973", "1974", "1975", "1976"],
    RG1200GS: ["2004", "2005", "2006"],
    S1000R: [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    S1000RR: [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    S1000XR: [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "M2 Base": ["2016", "2017", "2018", "2023", "2024"],
    "M3 Competition": ["2021", "2022", "2023", "2024"],
    "M4 Competition": ["2021", "2022", "2023", "2024"],
    "M440i xDrive Base": ["2021", "2022", "2023"],
    "M4 Competition xDrive": ["2021", "2022", "2023", "2024"],
    "230i Base": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "230i xDrive Base": ["2017", "2018", "2019", "2020", "2021"],
    "328d Base": ["2014", "2015", "2016", "2017", "2018"],
    "328d xDrive Base": ["2014", "2015", "2016", "2017", "2018"],
    "330i xDrive Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "430i Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "430i Gran Coupe Base": ["2017", "2018", "2019", "2020", "2022", "2023"],
    "430i xDrive Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "435i Gran Coupe Base": ["2015", "2016"],
    "ActiveHybrid 3 Base": ["2013", "2014", "2015"],
    "M235i Base": ["2014", "2015", "2016"],
    "M235i xDrive Base": ["2015", "2016"],
    "735i Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "735iL Base": ["1988", "1989", "1990", "1991", "1992"],
    "750iL Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "325iX Base": ["1988", "1989", "1990", "1991"],
    "325 Base": ["1986", "1987", "1988"],
    "325e Base": ["1984", "1985", "1986", "1987"],
    "325es Base": ["1986", "1987"],
    "C 600 Sport": ["2013", "2014", "2015"],
    C400GT: ["2019", "2020", "2021"],
    C400X: ["2019", "2020", "2021"],
    "C650 Sport": ["2016", "2017", "2018", "2019", "2020"],
    C650GT: [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "K1600 Grand America": ["2019", "2020", "2021", "2022"],
    F750GS: ["2018", "2019", "2020", "2021", "2022", "2023"],
    F850GS: ["2018", "2019", "2020", "2021", "2022", "2023"],
    "F850GS Adventure": ["2018", "2019", "2020", "2021", "2022", "2023"],
    F900R: ["2020", "2021", "2022", "2023", "2024"],
    F900XR: ["2020", "2021", "2022", "2023", "2024"],
    K1300R: ["2011", "2012"],
    R1250GS: ["2019", "2020", "2021", "2022", "2023"],
    "R1250GS Adventure": ["2019", "2020", "2021", "2022", "2023", "2024"],
    R1250R: ["2019", "2020", "2021", "2022", "2023"],
    R1250RS: ["2019", "2020", "2021", "2022", "2023", "2024"],
    R1250RT: ["2019", "2020"],
    "335i GT xDrive Base": ["2014", "2015", "2016"],
    "435i xDrive Gran Coupe Base": ["2015", "2016"],
    "X1 xDrive35i": ["2013", "2014", "2015"],
    "X3 sDrive28i": ["2015", "2016", "2017"],
    "X3 xDrive28d": ["2015", "2016", "2017"],
    "X3 xDrive28i": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "X3 xDrive30i": [
      "2009",
      "2010",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "X3 xDrive35i": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "X4 M40i": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "X4 xDrive28i": ["2015", "2016", "2017", "2018"],
    "X4 xDrive35i": ["2015", "2016"],
    "X5 3.0si": ["2007", "2008"],
    "X5 4.8i": ["2007", "2008"],
    "X5 M": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "X5 sDrive35i": ["2014", "2015", "2016", "2017", "2018"],
    "X5 xDrive30i": ["2009", "2010"],
    "X5 xDrive35d": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "X5 xDrive35i": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "X5 xDrive40e": ["2016", "2017", "2018"],
    "X5 xDrive48i": ["2009", "2010"],
    "X5 xDrive50i": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "X6 ActiveHybrid": ["2010", "2011"],
    "X6 M": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "X6 sDrive35i": ["2015", "2016", "2017", "2018", "2019"],
    "X6 xDrive35i": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "X6 xDrive50i": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Z4 Coupe 3.0si": ["2006", "2007", "2008"],
    "Z4 M Coupe": ["2006", "2007", "2008"],
    "Z4 Roadster 3.0i": ["2006", "2007", "2008"],
    "Z4 Roadster 3.0si": ["2006", "2007", "2008"],
    "Z4 sDrive28i": ["2012", "2013", "2014", "2015", "2016"],
    "Z4 sDrive35is": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "K1200LT Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "335d Base": ["2009", "2010", "2011"],
    "645Ci Base": ["2004", "2005"],
    "760i Base": ["2004", "2005", "2006"],
    "C600 Sport Base": ["2013", "2014"],
    "C650GT Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "F650GS Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "F700GS Base": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "F800GS Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "F800GS Adventure Base": ["2014", "2015", "2016", "2017"],
    "F800GT Base": ["2013", "2014", "2015", "2016"],
    "F800R Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "F800S Base": ["2006", "2007", "2008"],
    "F800ST Base": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "Hp2 Sport Base": ["2008", "2009", "2010"],
    "HP4 Base": ["2013", "2014"],
    "i3 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "i3 Range Extender": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "K1200GT Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "K1200LTC Base": ["1999", "2000", "2001", "2002"],
    "K1200LTI Icon Base": ["1999", "2000", "2001"],
    "K1200LTS Base": ["1999", "2000"],
    "K1200R Base": ["2005", "2006", "2007", "2008"],
    "K1200R Sport Base": ["2007", "2008"],
    "K1200RS Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "K1200S Base": ["2005", "2006", "2007", "2008"],
    "K1300GT Base": ["2009", "2010"],
    "K1300R Base": ["2009", "2010", "2011"],
    "K1300S Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "K1600GT Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "K1600GTL Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "K1600GTL Exclusive Base": ["2014", "2015", "2016"],
    "R1100S Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "R1100S ABS Base": ["2004", "2005"],
    "R1100S Boxer Cup Replica Base": ["2003", "2004", "2005"],
    "R1100SA Base": ["2000", "2001"],
    "R1150RT Base": ["2001", "2002", "2003", "2004", "2005"],
    "R1200GS Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "R1200GS Adventure Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "R1200GS Hp2 Base": ["2006", "2007"],
    "R1200RS Base": ["2015", "2016", "2017", "2018"],
    "R1200RT Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "R1200S Base": ["2006", "2007"],
    "RG1200GS Base": ["2004", "2005", "2006"],
    "S1000R Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "S1000RR Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "S1000XR Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "2002 Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "2002 Cabriolet": ["1971", "1972", "1973", "1974"],
    "2002 Turbo": ["1973", "1974"],
    "2002ti Base": ["1968", "1969", "1970", "1971"],
    "2002tii Base": ["1971", "1972", "1973", "1974"],
    "330i GT xDrive Base": ["2017", "2018", "2019"],
    "430i xDrive Gran Coupe Base": ["2017", "2018", "2019", "2020"],
    "M5 Competition": ["2019", "2020", "2021"],
    "M8 Gran Coupe Base": ["2020", "2021", "2022"],
    "M8 Gran Coupe Competition": ["2020", "2021", "2022", "2023", "2024"],
    "X2 M35i": ["2019", "2020", "2021", "2022", "2023"],
    "X3 M": ["2020", "2021", "2022", "2023", "2024"],
    "X3 M Competition": ["2020", "2021", "2022", "2023"],
    "X3 M40i": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "X3 sDrive30i": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "X3 xDrive30e": ["2020", "2021"],
    "X4 M": ["2020", "2021", "2022", "2023", "2024"],
    "X4 M Competition": ["2020", "2021", "2022"],
    "X4 xDrive30i": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "X5 M50i": ["2020", "2021", "2022", "2023"],
    "X5 sDrive40i": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "X5 xDrive40i": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "X5 xDrive45e": ["2021", "2022", "2023"],
    "X7 M50i": ["2020", "2021", "2022"],
    "X7 M60i": ["2023", "2024"],
    "X7 xDrive40i": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "X7 xDrive50i": ["2019", "2020"],
    "530e Base": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "530e xDrive Base": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "530i xDrive Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "1600 Base": ["1966", "1967", "1968", "1969", "1970", "1971"],
    "1600 Cabriolet": ["1968", "1969", "1970", "1971"],
    "1600-2 Base": ["1966", "1967", "1968", "1969", "1970", "1971"],
    "1600ti Base": ["1966", "1967", "1968"],
    "1602 Base": ["1967", "1968", "1969", "1970", "1971"],
    M1000RR: ["2021", "2022", "2023", "2024"],
    R18: ["2021", "2022", "2023"],
    "R18 Classic": ["2021", "2022"],
    "C Evolution": ["2017", "2018", "2019", "2020"],
    "M3 Competition xDrive": ["2022", "2023", "2024"],
    "M4 CSL": ["2023", "2024"],
    "2000 Base": ["1966", "1967", "1968", "1969", "1970", "1971", "1972"],
    "2000 Touring": ["1971", "1972"],
    "524td Base": ["1985", "1986"],
    "528e Base": ["1982", "1983", "1984", "1985", "1986", "1987", "1988"],
    "533i Base": ["1983", "1984"],
    "633CSi Base": ["1978", "1979", "1980", "1981", "1982", "1983", "1984"],
    "635CSi Base": ["1985", "1986", "1987", "1988", "1989"],
    "733i Base": ["1978", "1979", "1980", "1981", "1982", "1983", "1984"],
    "850Ci Base": ["1993", "1994", "1995", "1996", "1997"],
    "850CSi Base": ["1994", "1995"],
    "850i Base": ["1991", "1992"],
    "L7 Base": ["1986", "1987"],
    "740e xDrive iPerformance": ["2017", "2018", "2019"],
    "Alpina B7 xDrive": ["2017", "2018", "2019", "2020", "2021"],
    "M760i xDrive Base": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "228i xDrive Gran Coupe Base": ["2020", "2021", "2022", "2023", "2024"],
    "M235i xDrive Gran Coupe Base": ["2020", "2021"],
    "630CSi Base": ["1977", "1978"],
    "Bavaria Base": ["1972", "1973", "1974"],
    "X6 M Competition": ["2020", "2021", "2024", "2025"],
    "X6 M50i": ["2020", "2021", "2022", "2023"],
    "X6 sDrive40i": ["2020", "2021"],
    "X6 xDrive40i": ["2020", "2021", "2022", "2023"],
    "X5 M Competition": ["2024", "2025"],
    "X5 M60i": ["2024", "2025"],
    "X5 xDrive50e": ["2024", "2025"],
    "330e Base": ["2021", "2022", "2023"],
    "330e xDrive Base": ["2021", "2022", "2023"],
    "228i Gran Coupe Base": ["2021", "2022", "2023", "2024"],
    "745e xDrive Base": ["2020", "2021", "2022"],
    "840i Base": ["2020", "2021", "2022", "2023"],
    "840i Gran Coupe Base": ["2020", "2021", "2022"],
    "840i xDrive Base": ["2020", "2021", "2022", "2023"],
    "840i xDrive Gran Coupe Base": ["2020", "2021", "2022"],
    "M340i Base": ["2020", "2021", "2022", "2023"],
    "M340i xDrive Base": ["2020", "2021", "2022", "2023"],
    "M850i xDrive Base": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "F650 Base": ["1997", "1998", "1999", "2000"],
    "F650 Enduro Base": ["1998", "1999", "2000", "2001"],
    "F650CS Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "F650CS ABS Base": ["2003", "2004", "2005"],
    "F650GS ABS Base": ["2001", "2002", "2003"],
    "F650GS Dakar Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "F650GS Dakar ABS Base": ["2002", "2003", "2004", "2005"],
    "F650ST Base": ["1997", "1998", "1999"],
    "F750GS Base": ["2019", "2020"],
    "F850GS Base": ["2019", "2020"],
    "F850GS Adventure Base": ["2019", "2020"],
    "G310GS Base": ["2018", "2019"],
    "G310R Base": ["2016", "2017", "2018", "2019"],
    "G450X Base": ["2008", "2009", "2010"],
    "G650 Xcountry Base": ["2007", "2008", "2009"],
    "G650GS Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "G650GS Sertao Base": ["2012", "2013", "2014"],
    "Hp2 Enduro Base": ["2007", "2008"],
    "Hp2 Megamoto Base": ["2007", "2008", "2009"],
    "K1 Base": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "K100 Base": ["1983", "1984", "1985", "1986"],
    "K100LT Base": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "K100LT ABS Base": ["1989", "1990", "1991", "1992"],
    "K100RS Base": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "K100RS ABS Base": ["1988", "1989"],
    "K100RS FL Base": ["1991", "1992"],
    "K100RS FL ABS Base": ["1991", "1992"],
    "K100RT Base": ["1985", "1986", "1987", "1988"],
    "K1100LT Base": ["1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    "K1100RS Base": ["1993", "1994", "1995", "1996"],
    "K1600 Grand America Base": ["2018", "2019", "2020"],
    "K1600B Base": ["2018", "2019"],
    "K75 Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "K75C Base": ["1986", "1987", "1988"],
    "K75RT Base": ["1990", "1991", "1992"],
    "K75RT ABS Base": ["1991", "1992", "1993", "1994", "1995"],
    "K75S Base": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "K75S Abs Base": ["1991", "1992", "1993", "1994", "1995"],
    "K75T Base": ["1986", "1987"],
    "R Nine T Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "R Nine T Pure Base": ["2017", "2018", "2019", "2020"],
    "R Nine T Racer Base": ["2017", "2018"],
    "R Nine T Scrambler Base": ["2016", "2017", "2018", "2019", "2020"],
    "R100 Base": ["1983", "1984"],
    "R100CS Base": ["1980", "1981", "1982", "1983", "1984"],
    "R100GS Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "R100GS Paris-Dakar Base": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "R100R Base": ["1992", "1993", "1994", "1995"],
    "R100RS Base": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "R100RT Base": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "R100T Base": ["1978", "1979", "1980", "1981", "1982", "1983", "1984"],
    "R1100GS Base": ["1994", "1995"],
    "R1100GS ABS Base": ["1995", "1996", "1997", "1998", "1999"],
    "R1100R Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "R1100RS Base": ["1993", "1994"],
    "R1100RS ABS Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "R1100RSL Base": ["1994", "1995", "1996"],
    "R1100RT Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "R1100RTL Base": ["1996", "1997"],
    "R1150GS Base": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "R1150GS Adventure Base": ["2002", "2003", "2004", "2005"],
    "R1150R Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "R1150R Roadster Base": ["2002", "2003", "2004", "2005", "2006"],
    "R1150RS Base": ["2001", "2002", "2003", "2004"],
    "R1200C Base": ["1998", "1999", "2000", "2001", "2002"],
    "R1200C Avantgarde Base": ["2000", "2001", "2002", "2003"],
    "R1200C Classic Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "R1200C Euro Base": ["1998", "1999", "2000", "2001", "2002"],
    "R1200C Independent Base": ["2000", "2001", "2002", "2003", "2004"],
    "R1200C Montana Base": ["2000", "2001", "2002", "2003"],
    "R1200C Montauk Base": ["2004", "2005"],
    "R1200C Phoenix Base": ["2000", "2001", "2002"],
    "R1200CL Base": ["2002", "2003", "2004", "2005", "2006"],
    "R1200R Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
    ],
    "R1200ST Base": ["2005", "2006", "2007"],
    "R1250GS Base": ["2019", "2020", "2021"],
    "R1250GS Adventure Base": ["2019", "2020", "2021"],
    "R1250RT Base": ["2019", "2020"],
    "R45 Base": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "R65 Base": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "R65LS Base": ["1981", "1982", "1983", "1984", "1985"],
    "R80 Base": ["1985", "1986", "1987"],
    "R80/7 Base": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
    ],
    "R80G/S Base": ["1980", "1981", "1982", "1983", "1984", "1985", "1986"],
    "R80R Base": ["1992", "1993", "1994"],
    "R80RT Base": ["1982", "1983", "1984", "1985", "1986", "1987"],
    "R80ST Base": ["1982", "1983", "1984"],
    "R850C Avantgarde Base": ["2000", "2001", "2002", "2003"],
    "R850C Classic Base": ["1996", "1997", "1998", "1999", "2000", "2001"],
    "R850C Euro Base": ["2000", "2001"],
    "R850R Base": ["1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    "i3s Range Extender": ["2018", "2019", "2020"],
    "i8 Base": ["2014", "2015", "2016", "2017", "2019", "2020"],
    "M550i xDrive Base": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "M850i xDrive Gran Coupe Base": ["2020", "2021", "2022", "2023", "2024"],
    M1000R: ["2023", "2024"],
    "Alpina B8 Gran Coupe xDrive": ["2022", "2023", "2024"],
    "Alpina XB7 Base": ["2021", "2022", "2023", "2024"],
    "M8 Competition": ["2022", "2023", "2024"],
    "2500 Base": ["1968", "1969", "1970", "1971"],
    "2800 Base": ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "2800CS Base": ["1968", "1969", "1970", "1971"],
    "3.0CS Base": ["1971", "1972", "1973", "1974"],
    "3.0CSi Base": ["1971", "1972", "1973", "1974"],
    "3.0S Base": ["1971", "1972", "1973", "1974"],
    "3.0Si Base": ["1975", "1976"],
    "R60/6 Base": ["1973", "1974", "1975", "1976"],
    "R75/6 Base": ["1973", "1974", "1975", "1976"],
    "R90/6 Base": ["1973", "1974", "1975", "1976"],
    "R90S Base": ["1973", "1974", "1975", "1976"],
    "i4 M50": ["2022", "2023"],
    "M440i Base": ["2021", "2022", "2023"],
    "M440i xDrive Gran Coupe Base": ["2022", "2023"],
    "iX xDrive50": ["2022", "2023"],
    "M440i Gran Coupe Base": ["2022", "2023"],
    "R100/7 Base": ["1976", "1977", "1978"],
    "R100S Base": ["1976", "1977", "1978", "1979", "1980"],
    "R50/5 Base": ["1969", "1970", "1971", "1972", "1973"],
    "R60/5 Base": ["1969", "1970", "1971", "1972", "1973", "1974"],
    "R60/7 Base": ["1976", "1977", "1978", "1979", "1980"],
    "R75/5 Base": ["1969", "1970", "1971", "1972", "1973"],
    "R75/7 Base": ["1976", "1977"],
    "i3s Base": ["2018", "2019", "2020"],
    "C650 Sport Base": ["2016", "2017"],
  },
  Lincoln: {
    "Continental Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2019",
      "2020",
    ],
    "Continental Black Label": ["2017", "2018", "2019", "2020"],
    "Continental Livery": ["2017", "2018", "2019", "2020"],
    "Continental Premiere": ["2017", "2018"],
    "Continental Reserve": ["2017", "2018", "2019", "2020"],
    "Continental Select": ["2017", "2018", "2019"],
    "MKX Black Label": ["2016", "2017", "2018"],
    "MKX Premiere": ["2016", "2017", "2018"],
    "MKX Reserve": ["2016", "2017", "2018"],
    "MKX Select": ["2016", "2017", "2018"],
    "MKZ Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2019",
      "2020",
    ],
    "MKZ Black Label": ["2015", "2016", "2017", "2018"],
    "MKZ Black Label Hybrid": ["2015", "2016", "2017", "2018"],
    "MKZ Hybrid": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "MKZ Premiere": ["2017", "2018"],
    "MKZ Premiere Hybrid": ["2017", "2018"],
    "MKZ Reserve": ["2017", "2018"],
    "MKZ Reserve Hybrid": ["2017", "2018"],
    "MKZ Select": ["2017", "2018"],
    "MKZ Select Hybrid": ["2017", "2018"],
    "Nautilus Base": ["2019", "2020", "2021", "2022", "2023"],
    "Nautilus Black Label": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Nautilus Reserve": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "MKC Black Label": ["2015", "2016", "2017", "2018", "2019"],
    "MKC Premiere": ["2016", "2017", "2018"],
    "MKC Reserve": ["2016", "2017", "2018", "2019"],
    "MKC Select": ["2016", "2017", "2018", "2019"],
    "Mark LT Base": ["2006", "2007", "2008"],
    "Aviator Base": ["2003", "2004", "2005", "2020", "2021", "2022", "2023"],
    "Aviator Black Label": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "Aviator Black Label Grand Touring": ["2020", "2021", "2022", "2023"],
    "Aviator Grand Touring": ["2020", "2021", "2022", "2023"],
    "Aviator Livery": ["2022", "2023", "2024", "2025"],
    "Aviator Premiere": ["2024", "2025"],
    "Aviator Reserve": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "Corsair Base": ["2020", "2021", "2022", "2023", "2024"],
    "Corsair Reserve": ["2020", "2021", "2022", "2023", "2024"],
    "Navigator Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Continental Executive": ["1991", "1992", "1993", "1994"],
    "Continental Givenchy": ["1982", "1983", "1984", "1985", "1986", "1987"],
    "Continental Signature": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Continental Spinnaker Edition": ["1995", "1996", "1997"],
    "Continental Valentino": ["1983", "1984", "1985"],
    "Mark VII Base": ["1984", "1985", "1986", "1987"],
    "Mark VII Bill Blass": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Mark VII LSC": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Mark VII Versace": ["1984", "1985"],
    "Town Car Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Town Car Cartier": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Town Car Cypress": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "Town Car Executive": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Town Car Signature": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Town Car Touring Edition": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "LS Base": ["2000", "2001", "2002", "2003", "2004"],
    "LS LSE": ["2001", "2002", "2003"],
    "Town Car Cartier L": ["2001", "2002", "2003"],
    "Town Car Designer Series": ["2006", "2007"],
    "Town Car Executive L": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Town Car Protection Series": ["2004", "2005", "2006"],
    "Town Car Signature L": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Town Car Signature Limited": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Capri Base": [
      "1952",
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
    ],
    "Cosmopolitan Base": ["1950", "1951", "1952", "1953", "1954"],
    "Lincoln Base": ["1950", "1951"],
    "Mark II Base": ["1956", "1957"],
    "Premier Base": ["1956", "1957", "1958", "1959", "1960"],
    "Versailles Base": ["1977", "1978", "1979", "1980"],
    "MKS Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "MKS EcoBoost": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "MKT Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "MKT EcoBoost": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "MKT Limousine": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "MKT Livery": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "MKT Reserve": ["2018", "2019"],
    "Navigator Black Label": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Navigator L Black Label": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Navigator L Livery": ["2020", "2021", "2022", "2023", "2024"],
    "Navigator L Reserve": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Navigator L Select": ["2016", "2017", "2018", "2019"],
    "Navigator Reserve": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Navigator Select": ["2016", "2017", "2018", "2019"],
    "Corsair Grand Touring": ["2021", "2022", "2023", "2024"],
    "MKX Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Navigator L": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Navigator Luxury": ["2006", "2007"],
    "Navigator Ultimate": ["2006", "2007"],
    "Mark VI Base": ["1980", "1981", "1982", "1983"],
    "Mark VI Bill Blass": ["1982", "1983"],
    "Mark VI Pucci": ["1982", "1983"],
    "Mark VI Signature": ["1982", "1983"],
    "Mark VIII Base": ["1993", "1994", "1995", "1997", "1998"],
    "Mark VIII LSC": ["1995", "1996", "1997", "1998"],
    "LS Sport": ["2005", "2006"],
    "Mark III Base": ["1968", "1969", "1970", "1971"],
    "Mark IV Base": ["1972", "1973", "1974", "1975", "1976"],
    "Mark V Base": ["1977", "1978", "1979"],
  },
  Jeep: {
    "Grand Cherokee Altitude": ["2018", "2019", "2020", "2022", "2023", "2024"],
    "Grand Cherokee High Altitude": ["2018", "2019", "2020", "2021"],
    "Grand Cherokee Laredo": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "Grand Cherokee Limited": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Grand Cherokee Limited X": ["2019", "2020", "2021"],
    "Grand Cherokee Overland": [
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Grand Cherokee SRT": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Grand Cherokee SRT8": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
    ],
    "Grand Cherokee Summit": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Grand Cherokee Trackhawk": ["2018", "2019", "2020", "2021"],
    "Grand Cherokee Trailhawk": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Grand Cherokee Upland": ["2019", "2020"],
    "Cherokee Latitude": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Cherokee Limited": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1998",
      "1999",
      "2000",
      "2001",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Cherokee Overland": ["2016", "2017", "2018", "2019", "2020"],
    "Cherokee Sport": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Cherokee Trailhawk": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Compass Altitude": ["2019", "2020", "2021", "2022", "2023"],
    "Compass High Altitude": ["2019", "2020"],
    "Compass Latitude": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Compass Limited": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Compass Sport": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Compass Trailhawk": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Renegade Altitude": ["2018", "2019", "2020", "2022", "2023"],
    "Renegade High Altitude": ["2019", "2020"],
    "Renegade Latitude": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Renegade Limited": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Renegade Sport": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Renegade Trailhawk": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Renegade Upland": ["2019", "2020", "2021"],
    "Patriot Latitude": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Patriot Limited": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Patriot Sport": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Wrangler Unlimited Rubicon 392": ["2021", "2022", "2023", "2024"],
    "Cherokee Altitude": ["2019", "2020", "2021", "2022"],
    "Cherokee High Altitude": ["2019", "2020", "2021", "2022"],
    "Cherokee Latitude Lux": ["2021", "2022"],
    "Cherokee Latitude Plus": ["2018", "2019", "2020", "2021"],
    "Cherokee Trailhawk Elite": ["2019", "2020"],
    "Wrangler Rubicon": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Wrangler Sahara": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Wrangler Sport": [
      "1987",
      "1988",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Wrangler Unlimited Rubicon": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Wrangler Unlimited Sahara": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Wrangler Unlimited Sport": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Wrangler Unlimited X": ["2007", "2008", "2009", "2010"],
    "Wrangler X": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Cherokee Base": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Cherokee Briarwood": ["1991", "1992"],
    "Cherokee Chief": ["1981", "1982", "1985", "1986", "1987", "1988"],
    "Cherokee Classic": ["1998", "1999", "2000", "2001"],
    "Cherokee Country": ["1993", "1994", "1995", "1996", "1997"],
    "Cherokee Laredo": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Cherokee Pioneer": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "Cherokee SE": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "CJ5 Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "CJ5 Golden Eagle": ["1977", "1978", "1979", "1980"],
    "CJ5 Laredo": ["1980", "1981", "1982", "1983"],
    "CJ5 Renegade": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "CJ5A Base": ["1966", "1967", "1968"],
    "CJ6 Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
    ],
    "CJ6A Base": ["1966", "1967", "1968"],
    "CJ7 Base": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "CJ7 Golden Eagle": ["1977", "1978", "1979"],
    "CJ7 Laredo": ["1980", "1981", "1982", "1983", "1985", "1986"],
    "CJ7 Renegade": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Comanche Base": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Comanche Chief": ["1987", "1988"],
    "Comanche Eliminator": ["1988", "1989", "1990", "1991", "1992"],
    "Comanche Laredo": ["1987", "1988"],
    "Comanche Pioneer": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Grand Cherokee SE": ["1994", "1995"],
    "Grand Cherokee TSi": ["1997", "1998"],
    "J-2500 Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
    ],
    "J-4500 Base": ["1970", "1971", "1972", "1973"],
    "J-4600 Base": ["1970", "1971", "1972", "1973"],
    "Wrangler Base": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "Wrangler Islander": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "2021",
      "2022",
    ],
    "Wrangler Laredo": ["1987", "1988", "1989", "1990"],
    "Gladiator High Altitude": ["2021", "2022", "2023"],
    "Gladiator Mojave": ["2020", "2021", "2022", "2023", "2024"],
    "Gladiator Overland": ["2020", "2021", "2022", "2023"],
    "Gladiator Rubicon": ["2020", "2021", "2022", "2023", "2024"],
    "Gladiator Sport": ["2020", "2021", "2022", "2023", "2024"],
    "Gladiator Sport S": ["2020", "2021", "2022", "2023", "2024"],
    "Gladiator Texas Trail": ["2021", "2022", "2023"],
    "Gladiator Willys": ["2021", "2022", "2023", "2024"],
    "Gladiator Willys Sport": ["2021", "2022", "2023"],
    "Wrangler Sport S": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Wrangler Unlimited High Altitude": ["2021", "2022", "2023"],
    "Wrangler Unlimited High Altitude 4xe": ["2021", "2022", "2023", "2024"],
    "Wrangler Unlimited High Tide": ["2022", "2023"],
    "Wrangler Unlimited Moab": ["2018", "2019"],
    "Wrangler Unlimited Rubicon 4xe": ["2021", "2022", "2023", "2024"],
    "Wrangler Unlimited Sahara 4xe": ["2021", "2022", "2023", "2024"],
    "Wrangler Unlimited Sahara Altitude": ["2021", "2022", "2023"],
    "Wrangler Unlimited Sport Altitude": ["2021", "2022", "2023"],
    "Wrangler Unlimited Sport S": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Wrangler Unlimited Willys": ["2021", "2022", "2023", "2024"],
    "Wrangler Unlimited Willys 4xe": ["2023", "2024"],
    "Wrangler Unlimited Willys Sport": ["2021", "2022", "2023", "2024"],
    "Wrangler Willys": ["2021", "2022", "2023", "2024"],
    "Wrangler Willys Sport": ["2021", "2022", "2023", "2024"],
    "Commando Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
    ],
    "DJ5 Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "Jeepster Commando": ["1966", "1967", "1968", "1969", "1970", "1971"],
    "Wagoneer Base": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Wagoneer Custom": ["1973", "1974", "1975", "1976"],
    "Wrangler SE": [
      "1994",
      "1995",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Wrangler Unlimited": ["2004", "2005", "2006"],
    "Liberty Limited": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Liberty Renegade": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2010",
      "2011",
    ],
    "Liberty Sport": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Wrangler Renegade": ["1991", "1992", "1993", "1994"],
    "Wrangler S": ["1991", "1992", "1993", "1994"],
    "J10 Base": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Scrambler Base": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "Wagoneer Limited": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "CJ5 Limited": ["1982", "1983"],
    "CJ7 Limited": ["1982", "1983"],
    "Grand Wagoneer Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Grand Wagoneer Limited": ["1984", "1985"],
    "Cherokee S": ["1974", "1975", "1976", "1977", "1978", "1979", "1980"],
    "Cherokee Wide Track": ["1978", "1979", "1980"],
    "Cherokee Wide Track Chief": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "Cherokee Wide Track Golden Eagle": ["1979", "1980"],
    "Cherokee Wide Track Laredo": ["1980", "1981", "1982", "1983"],
    "Scrambler Laredo": ["1985", "1986"],
    "Scrambler Renegade": ["1985", "1986"],
    "Scrambler SL": ["1982", "1983"],
    "Scrambler SR": ["1982", "1983", "1984"],
    "Gladiator Base": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "Commander Base": ["2006", "2007"],
    "Commander Limited": ["2006", "2007", "2008", "2009", "2010"],
    "Commander Overland": ["2007", "2008", "2009"],
    "Commander Sport": ["2007", "2008", "2009", "2010"],
    "Compass Latitude Lux": ["2022", "2023", "2024"],
    "Compass Red": ["2022", "2023"],
    "Grand Cherokee 4xe": ["2023", "2024"],
    "Grand Cherokee Altitude X": ["2023", "2024"],
    "Grand Cherokee Laredo X": ["2023", "2024"],
    "Grand Cherokee Overland 4xe": ["2022", "2023", "2024"],
    "Grand Cherokee Summit 4xe": ["2022", "2023", "2024"],
    "Grand Cherokee Summit Reserve": ["2022", "2023", "2024"],
    "Grand Cherokee Summit Reserve 4xe": ["2022", "2023", "2024"],
    "Grand Cherokee Trailhawk 4xe": ["2022", "2023", "2024"],
    "Wagoneer Brougham": ["1982", "1983"],
    "Willys CJ-5": ["1954", "1955", "1956", "1957", "1958"],
    "Willys CJ-2": ["1943", "1944", "1945", "1946", "1947", "1948", "1949"],
    "Willys CJ-3": [
      "1949",
      "1950",
      "1951",
      "1952",
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
    ],
    "CJ3 Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
    ],
    "Willys CJ-6": ["1955", "1956", "1957", "1958"],
    "Dispatcher Base": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "DJ3 Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
    ],
    "DJ6 Base": ["1965", "1966", "1967", "1968"],
    "F4 Base": ["1957", "1958", "1959", "1960"],
    "FC150 Base": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
    ],
    "FC170 Base": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
    ],
    "FC170HD Base": ["1963", "1964", "1965", "1966"],
    "J-100 Base": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
    ],
    "J-2600 Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
    ],
    "J-2700 Base": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "J-3500 Base": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "J-3600 Base": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "J-3700 Base": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "Jeepster Base": ["1966", "1967", "1968", "1969", "1970", "1971"],
    "Universal Base": ["1961", "1962", "1963", "1964", "1965", "1966", "1967"],
    "Utility Base": ["1961", "1962"],
    "Willys 1-Ton": [
      "1947",
      "1948",
      "1949",
      "1950",
      "1951",
      "1952",
      "1953",
      "1954",
      "1955",
    ],
    "Willys DJ-3": ["1956", "1957", "1958"],
    "Willys Jeepster": ["1948", "1949", "1950", "1951", "1952"],
    "Willys Panel": ["1946", "1947", "1948", "1949", "1950"],
    "Willys Sedan Delivery": ["1951", "1952", "1953", "1954", "1955"],
    "Utility Wagon Base": [
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
    ],
    "Willys CJ-3 Chassis": ["1951", "1952"],
    "J20 Base": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Grand Cherokee L Altitude": ["2021", "2022", "2023", "2024"],
    "Grand Cherokee L Altitude X": ["2023", "2024"],
    "Grand Cherokee L Laredo": ["2021", "2022", "2023", "2024"],
    "Grand Cherokee L Laredo X": ["2023", "2024"],
    "Grand Cherokee L Limited": ["2021", "2022", "2023", "2024"],
    "Grand Cherokee L Overland": ["2021", "2022", "2023", "2024"],
    "Grand Cherokee L Summit": ["2021", "2022", "2023", "2024"],
    "Grand Cherokee L Summit Reserve": ["2021", "2022", "2023", "2024"],
    "Wagoneer Series I": ["2022", "2023"],
    "Grand Wagoneer Obsidian": ["2022", "2023", "2024"],
    "Grand Wagoneer Series I": ["2022", "2023"],
    "Grand Wagoneer Series II": ["2022", "2023", "2024"],
    "Grand Wagoneer Series III": ["2022", "2023", "2024"],
    "Wagoneer Series II": ["2022", "2023"],
    "Wagoneer Series III": ["2022", "2023"],
    "Renegade Islander": ["2021", "2022"],
    "Renegade Jeepster": ["2021", "2022"],
    "J-200 Base": ["1963", "1964", "1965"],
    "J-210 Base": ["1963", "1964", "1965"],
    "J-220 Base": ["1963", "1964", "1965"],
    "J-230 Base": ["1963", "1964", "1965"],
    "J-2800 Base": ["1965", "1966", "1967", "1968"],
    "J-300 Base": ["1963", "1964", "1965"],
    "J-310 Base": ["1963", "1964", "1965"],
    "J-320 Base": ["1963", "1964", "1965"],
    "J-330 Base": ["1963", "1964", "1965"],
    "J-3800 Base": ["1965", "1966", "1967", "1968", "1969", "1970", "1971"],
    "J-4700 Base": ["1970", "1971", "1972", "1973"],
    "J-4800 Base": ["1970", "1971", "1972", "1973"],
    "Truck Base": [
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
    ],
    "Grand Cherokee Limited 4xe": ["2022", "2023"],
    "F-134 Base": ["1963", "1964", "1965", "1966"],
    "M151 Base": ["1965", "1966", "1967", "1968", "1971", "1972"],
    "Tornado Base": ["1962", "1963", "1964", "1965"],
    "Universal Truck Base": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "Willys M38A1": ["1952", "1953", "1954", "1955", "1956", "1957"],
    "Willys 463": ["1947", "1948", "1949", "1950"],
    "Willys 473": ["1951", "1952"],
    "Willys M38": ["1950", "1951", "1952"],
    "Willys Truck": [
      "1947",
      "1948",
      "1949",
      "1950",
      "1951",
      "1952",
      "1953",
      "1954",
    ],
    "F4-134 Base": ["1957", "1958", "1959", "1960", "1961", "1962"],
    "FA-134 Base": ["1958", "1959", "1960"],
    "FJ3A Base": ["1961", "1962", "1963", "1964"],
  },
  Kia: {
    "Soul !": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Soul +": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Soul Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Soul EV +": ["2015", "2016", "2017", "2018", "2019"],
    "Soul EV Base": ["2015", "2016", "2017", "2018", "2019"],
    "Soul EV E": ["2016", "2017", "2018"],
    "Forte EX": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Forte LX": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2023",
      "2024",
    ],
    "Forte S": ["2017", "2018", "2019"],
    "Forte Koup EX": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "Forte Koup SX": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "Cadenza Limited": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "Cadenza Premium": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Optima EX": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Optima Hybrid": ["2011", "2012"],
    "Optima Hybrid EX": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Optima Hybrid LX": ["2013", "2014", "2015"],
    "Optima Limited": ["2014", "2015"],
    "Optima LX": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Optima SX": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Optima SX Turbo": ["2014", "2015"],
    "Optima SXL Turbo": ["2014", "2015"],
    "Sedona EX": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Sedona L": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Sedona LX": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Sedona SX": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "Sedona SXL": ["2015", "2016", "2017"],
    "K900 Luxury": ["2019", "2020"],
    "Stinger Base": ["2018", "2019"],
    "Stinger GT": ["2018", "2019", "2020", "2021"],
    "Stinger GT-Line": ["2020", "2021", "2022", "2023"],
    "Stinger GT1": ["2018", "2019", "2020", "2021", "2022"],
    "Stinger GT2": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Stinger Premium": ["2018", "2019"],
    "Telluride EX": ["2020", "2021", "2022", "2023", "2024"],
    "Telluride EX X-Line": ["2023", "2024"],
    "Telluride LX": ["2020", "2021", "2022", "2023", "2024"],
    "Telluride S": ["2020", "2021", "2022", "2023", "2024"],
    "Telluride SX": ["2020", "2021", "2022", "2023", "2024"],
    "Telluride SX Prestige": ["2023", "2024"],
    "Telluride SX Prestige X-Line": ["2023", "2024"],
    "Telluride SX Prestige X-Pro": ["2023", "2024"],
    "Telluride SX X-Line": ["2023", "2024"],
    "Telluride SX X-Pro": ["2023", "2024"],
    "Forte5 EX": ["2014", "2015", "2016", "2017", "2018"],
    "Forte5 LX": ["2016", "2017", "2018"],
    "Sportage Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2011",
      "2012",
      "2013",
    ],
    "Sportage EX": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Sportage LX": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Rio EX": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Rio LX": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Rio SX": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Sportage SX": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2023",
      "2024",
      "2025",
    ],
    "Soul EX": ["2020", "2021", "2022", "2023", "2024"],
    "Soul GT-Line": ["2020", "2021", "2022", "2023", "2024"],
    "Soul LX": ["2020", "2021", "2022", "2023", "2024"],
    "Soul S": ["2020", "2021", "2022", "2023", "2024"],
    "Soul X-Line": ["2020", "2021", "2022"],
    "Sorento EX": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Sorento SX": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sorento SX Prestige": ["2021", "2022", "2023", "2024"],
    "Sorento X-Line EX": ["2022", "2023", "2024"],
    "Sorento X-Line SX Prestige": ["2022", "2023", "2024"],
    "K5 EX": ["2021", "2022", "2023", "2024"],
    "K5 GT-Line": ["2021", "2022", "2023", "2024", "2025"],
    "K5 LX": ["2021", "2022", "2023"],
    "K5 LXS": ["2021", "2022", "2023", "2024", "2025"],
    "Sephia Base": ["1998", "1999", "2000", "2001"],
    "Sephia GS": ["1994", "1995", "1996", "1997"],
    "Sephia LS": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Sephia RS": ["1994", "1995", "1996", "1997"],
    "Spectra Base": ["2002", "2003", "2004"],
    "Spectra GS": ["2000", "2001", "2002", "2003", "2004"],
    "Spectra GSX": ["2000", "2001", "2002", "2003", "2004"],
    "Spectra LS": ["2002", "2003", "2004"],
    "Forte FE": ["2019", "2020", "2021", "2022"],
    "Forte GT": ["2020", "2021", "2022", "2023", "2024"],
    "Forte GT-Line": ["2020", "2021", "2022", "2023", "2024"],
    "Forte LXS": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Forte5 SX": ["2014", "2015", "2016", "2017", "2018"],
    "Optima Hybrid Premium": ["2017", "2018"],
    "Optima LX 1.6T": ["2016", "2017", "2018"],
    "Optima Plug-In Hybrid EX": ["2017", "2018", "2019", "2020"],
    "Optima S": ["2018", "2019", "2020"],
    "Optima SX Limited": ["2016", "2017"],
    "Sorento L": ["2016", "2017", "2018", "2019", "2020"],
    "Sorento Limited": ["2014", "2015"],
    "Sorento LX": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sorento S": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Sorento SX Limited": ["2016", "2017", "2018", "2019"],
    "Sportage S": ["2020", "2021"],
    "Sportage SX Turbo": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Cadenza Technology": ["2017", "2018", "2019", "2020"],
    "Forte SX": ["2010", "2011", "2012", "2013"],
    "Rio Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Rio5 LX": ["2008", "2009", "2010", "2011"],
    "Rio5 SX": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Rondo EX": ["2007", "2008", "2009", "2010"],
    "Rondo LX": ["2007", "2008", "2009", "2010"],
    "Sorento Base": ["2007", "2008", "2009", "2011", "2012"],
    "Rio Cinco": ["2002", "2003", "2004", "2005"],
    "Amanti Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "Optima SE": ["2001", "2002", "2003"],
    "EV9 GT-Line": ["2024", "2025"],
    "EV9 Land": ["2024", "2025"],
    "EV9 Light": ["2024", "2025"],
    "EV9 Light Long Range": ["2024", "2025"],
    "EV9 Wind": ["2024", "2025"],
    "Soul Turbo": ["2021", "2022"],
    "Sedona Base": ["2007", "2008", "2009", "2010"],
    "Soul Sport": ["2010", "2011"],
    "Sportage Hybrid EX": ["2023", "2024", "2025"],
    "Sportage Hybrid LX": ["2023", "2024", "2025"],
    "Sportage Hybrid SX Prestige": ["2023", "2024", "2025"],
    "Sportage Plug-In Hybrid X-Line": ["2023", "2024", "2025"],
    "Sportage Plug-In Hybrid X-Line Prestige": ["2023", "2024", "2025"],
    "Sportage SX Prestige": ["2023", "2024", "2025"],
    "Sportage X-Line": ["2023", "2024", "2025"],
    "Sportage X-Pro": ["2023", "2024", "2025"],
    "Sportage X-Pro Prestige": ["2023", "2024", "2025"],
    "Rio S": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Seltos EX": ["2021", "2022", "2023", "2024"],
    "Seltos LX": ["2021", "2022", "2023", "2024"],
    "Seltos Nightfall Edition": ["2022", "2023"],
    "Seltos S": ["2021", "2022", "2023", "2024"],
    "Seltos SX Turbo": ["2021", "2022", "2023"],
    "Spectra EX": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "Spectra LX": ["2004", "2005", "2007", "2008", "2009"],
    "Spectra SX": ["2005", "2006", "2007", "2008", "2009"],
    "Spectra5 Base": ["2005", "2006"],
    "K900 V6 Luxury": ["2016", "2017"],
    "K900 V6 Premium": ["2016", "2017"],
    "K900 V8 Luxury": ["2015", "2016", "2017"],
    "K5 GT": ["2021", "2022", "2023", "2024", "2025"],
    "Carnival EX": ["2022", "2023", "2024"],
    "Carnival LX": ["2022", "2023", "2024"],
    "Carnival SX": ["2022", "2023", "2024"],
    "Carnival SX Prestige": ["2022", "2023", "2024"],
    "Sorento Hybrid EX": ["2021", "2022", "2023", "2024"],
    "Sorento Hybrid S": ["2021", "2022"],
    "Sorento Hybrid SX Prestige": ["2023", "2024"],
    "Sorento Plug-in Hybrid SX Prestige": ["2022", "2023", "2024"],
    "Sorento X-Line S": ["2022", "2023", "2024"],
    "Niro EX": ["2017", "2018", "2019"],
    "Niro FE": ["2017", "2018", "2019"],
    "Niro LX": ["2017", "2018", "2019", "2020"],
    "Niro Plug-In Hybrid EX": ["2018", "2019", "2020"],
    "Niro Touring": ["2017", "2018", "2019", "2020"],
    "Spectra5 SX": ["2007", "2008", "2009"],
    "Niro EV Wave": ["2023", "2024"],
    "Niro EV Wind": ["2023", "2024"],
    "Niro Plug-In Hybrid EX Premium": ["2018", "2019"],
    "Niro Plug-In Hybrid LX": ["2018", "2019"],
  },
  Buick: {
    "Enclave Base": ["2012", "2013"],
    "Enclave Convenience": ["2014", "2015", "2016", "2017"],
    "Enclave CX": ["2008", "2009", "2010", "2011"],
    "Enclave CXL": ["2008", "2009", "2010", "2011"],
    "Enclave Leather": ["2014", "2015", "2016", "2017"],
    "Enclave Premium": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Skylark Base": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1990",
      "1991",
    ],
    "Skylark Custom": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1978",
      "1979",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Skylark S": ["1976", "1977", "1978", "1979"],
    "Century Custom": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Century Limited": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2004",
      "2005",
    ],
    "LaCrosse CX": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "LaCrosse CXL": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "LaCrosse CXS": ["2005", "2006", "2007", "2008", "2010", "2011"],
    "LaCrosse Super": ["2008", "2009"],
    "Regal GS": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Regal LS": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Century Special": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Commercial Chassis Base": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "LeSabre Custom": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1975",
      "1976",
      "1977",
      "1978",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "LeSabre Limited": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Park Avenue Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Park Avenue Ultra": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Rainier CXL": ["2004", "2005", "2006", "2007"],
    "Rainier CXL Plus": ["2004", "2005"],
    "Regal Custom": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Regal Gran Sport": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Regal Limited": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Rendezvous CX": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "Rendezvous CX Plus": ["2002", "2003"],
    "Rendezvous CXL": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "Rendezvous CXL Plus": ["2002", "2003"],
    "Rendezvous Ultra": ["2004", "2005"],
    "Riviera Base": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Riviera Luxury": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Roadmaster Base": ["1992", "1993", "1994", "1995"],
    "Roadmaster Estate Wagon": ["1991", "1992", "1993", "1994", "1995"],
    "Roadmaster Limited": ["1992", "1993", "1994", "1995"],
    "Skylark Gran Sport": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Skylark Limited": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Electra Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "Gran Sport Base": ["1965", "1966", "1967"],
    "LeSabre Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Riviera Gran Sport": ["1965", "1966"],
    "Special Base": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "Special Deluxe": ["1961", "1962", "1963", "1964", "1965", "1966", "1967"],
    "Sportwagon Base": ["1965", "1966", "1968", "1969", "1970", "1971", "1972"],
    "Wildcat Base": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "Wildcat Custom": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "Century Estate Wagon": ["1985", "1986", "1987", "1988", "1989"],
    "Electra Limited": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "Electra Park Avenue": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "Electra Park Avenue Ultra": ["1989", "1990"],
    "Electra T-Type": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "Reatta Base": ["1988", "1989", "1990", "1991"],
    "Regal Base": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Regal Grand National": ["1984", "1985", "1986", "1987"],
    "Regal T-Type": ["1983", "1984", "1985", "1986"],
    "Riviera T-Type": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Skyhawk Custom": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Skyhawk Limited": ["1982", "1983", "1984", "1985", "1986", "1987"],
    "Skyhawk SE": ["1988", "1989"],
    "Skyhawk Sport": ["1986", "1987"],
    "Skyhawk T-Type": ["1983", "1984", "1985", "1986", "1987"],
    "Skylark Luxury Edition": ["1990", "1991"],
    "LaCrosse Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "LaCrosse Leather": ["2012", "2013", "2014", "2015", "2016"],
    "LaCrosse Premium": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "LaCrosse Touring": ["2012", "2013"],
    "Verano Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Verano Convenience": ["2012", "2013", "2014", "2015", "2016"],
    "Verano Leather": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Verano Premium": ["2013", "2014", "2015", "2016"],
    "Verano Sport Touring": ["2016", "2017"],
    "Cascada Base": ["2016", "2017", "2018", "2019"],
    "Cascada Premium": ["2016", "2017", "2018", "2019"],
    "Regal Premium": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Lucerne CX": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Lucerne CXL": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Century Base": ["1973", "1974", "1975", "1976", "1977", "1980", "1981"],
    "Century Estate": ["1980", "1981"],
    "Century Sport": ["1978", "1979", "1980", "1981"],
    "Century T-Type": ["1983", "1984", "1985", "1986"],
    "Electra Estate Wagon": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Estate Wagon Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "LeSabre Estate Wagon": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "LeSabre Sport": ["1978", "1979", "1980", "1981"],
    "Regal Estate Wagon": ["1982", "1983"],
    "Regal Sport": ["1978", "1979", "1980", "1981", "1982"],
    "Skylark Sport": ["1980", "1981", "1982", "1983"],
    "Skylark T-Type": ["1983", "1984"],
    "Somerset Custom": ["1986", "1987"],
    "Somerset Limited": ["1986", "1987"],
    "Century Luxus": ["1973", "1974", "1975"],
    "Electra 225": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1976",
      "1977",
      "1978",
      "1979",
    ],
    "Electra 225 Custom": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Electra Custom": ["1966", "1967"],
    "Regal SR": ["1976", "1977"],
    "Skylark SR": ["1975", "1976", "1977"],
    "Enclave Avenir": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Enclave Essence": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Enclave Preferred": ["2019", "2020", "2021", "2022"],
    "Encore Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Encore Convenience": ["2013", "2014", "2015", "2016"],
    "Encore Essence": ["2017", "2018", "2019", "2020"],
    "Encore Leather": ["2013", "2014", "2015", "2016"],
    "Encore Preferred": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Encore Preferred II": ["2017", "2018"],
    "Encore Premium": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Encore Sport Touring": ["2016", "2017", "2018", "2019", "2020"],
    "Lucerne CXS": ["2006", "2007", "2008"],
    "Lucerne Super": ["2008", "2009", "2010", "2011"],
    "Envision Base": ["2017", "2018", "2019", "2020"],
    "Envision Essence": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Envision Preferred": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Envision Premium": ["2016", "2017", "2018", "2019", "2020"],
    "Envision Premium II": ["2019", "2020"],
    "Regal Sport Touring": ["2016", "2017"],
    "Apollo Base": ["1973", "1974", "1975"],
    "Centurion Base": ["1971", "1972", "1973"],
    "Riviera S": ["1979", "1980"],
    "Terraza CX": ["2005", "2006", "2007"],
    "Terraza CXL": ["2005", "2006", "2007"],
    "Regal Sportback GS": ["2018", "2019", "2020"],
    "Encore GX Essence": ["2020", "2021", "2022", "2023"],
    "Encore GX Preferred": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "Encore GX Select": ["2020", "2021", "2022", "2023"],
    "LaCrosse Essence": ["2017", "2018", "2019"],
    "LaCrosse Preferred": ["2017", "2018", "2019"],
    "Opel Base": ["1976", "1977", "1978", "1979"],
    "Opel Deluxe": ["1977", "1978", "1979"],
    "LaCrosse Avenir": ["2018", "2019"],
    "Regal Sportback Avenir": ["2019", "2020"],
    "Regal Sportback Base": ["2018", "2019", "2020"],
    "Regal Sportback Essence": ["2018", "2019", "2020"],
    "Regal Sportback Preferred": ["2018", "2019", "2020"],
    "Regal Sportback Preferred II": ["2018", "2019"],
    "Regal TourX Base": ["2018", "2019", "2020"],
    "Regal TourX Essence": ["2018", "2019", "2020"],
    "Regal TourX Preferred": ["2018", "2019", "2020"],
    "Skyhawk Base": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Skyhawk Road Hawk": ["1979", "1980"],
    "Skyhawk S": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Cascada Sport Touring": ["2017", "2018", "2019"],
    "Envision Avenir": ["2021", "2022", "2023", "2024", "2025"],
    "Encore GX Avenir": ["2024", "2025"],
    "Encore GX Sport Touring": ["2024", "2025"],
    "Envision Sport Touring": ["2024", "2025"],
    "GS Base": ["1970", "1971", "1972"],
    "GS 350 Base": ["1968", "1969"],
    "GS 400 Base": ["1968", "1969"],
    "GS 455 Base": ["1970", "1971", "1972"],
    "Sportwagon Custom": ["1968", "1969"],
    "Invicta Base": ["1959", "1960", "1961", "1962", "1963"],
    "Opel Sport": ["1978", "1979"],
    "Envista Avenir": ["2024", "2025"],
    "Envista Preferred": ["2024", "2025"],
    "Envista Sport Touring": ["2024", "2025"],
  },
  GMC: {
    "Acadia Denali": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Acadia SL": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Acadia SLE": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Acadia SLT": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Terrain Denali": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Terrain SL": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "Terrain SLE": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Terrain SLT": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sierra 2500 HD AT4": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "Sierra 2500 HD Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Sierra 2500 HD Denali": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Sierra 2500 HD SLE": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Sierra 2500 HD SLT": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Sierra 3500 HD AT4": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "Sierra 3500 HD Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Sierra 3500 HD Denali": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Sierra 3500 HD SLE": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Sierra 3500 HD SLT": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Canyon All Terrain": ["2018", "2019", "2020"],
    "Canyon AT4": ["2021", "2022", "2023", "2024", "2025"],
    "Canyon Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Canyon Denali": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Canyon Elevation": ["2021", "2022", "2023", "2024", "2025"],
    "Canyon Elevation Standard": ["2021", "2022"],
    "Canyon SL": [
      "2006",
      "2007",
      "2008",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Canyon SLE": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Canyon SLT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sierra 1500 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Sierra 1500 Denali": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sierra 1500 Hybrid": [
      "2005",
      "2006",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Sierra 1500 SL": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Sierra 1500 SLE": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sierra 1500 SLT": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sierra 1500 WT": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Sierra 1500 XFE": ["2010", "2011", "2012", "2013"],
    "Sierra 1500 HD SLE": ["2001", "2002", "2003", "2005", "2006"],
    "Sierra 1500 HD SLT": ["2001", "2002", "2003", "2005", "2006"],
    "Sierra 2500 Base": ["2002", "2003", "2004"],
    "Sierra 2500 SL": ["1999", "2000", "2001", "2002"],
    "Sierra 2500 SLE": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Sierra 2500 SLT": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Sierra 2500 WT": ["2003", "2004"],
    "Sierra 2500 HD SL": ["2001", "2002"],
    "Sierra 2500 HD WT": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Sierra 3500 Base": ["2002", "2003", "2004", "2005"],
    "Sierra 3500 SL": ["2001", "2002"],
    "Sierra 3500 SLE": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Sierra 3500 SLT": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Sierra 3500 WT": ["2004", "2005", "2006"],
    "Sierra 3500 HD WT": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Yukon Denali": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Yukon Denali Hybrid": ["2010", "2011", "2012", "2013"],
    "Yukon Hybrid": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Yukon SLE": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Yukon SLT": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Yukon XL Denali": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Yukon XL SLE": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Yukon XL SLT": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Yukon XL 1500 Denali": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Yukon XL 1500 SLE": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Yukon XL 1500 SLT": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Yukon XL 2500 SLE": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Yukon XL 2500 SLT": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "C15 Base": ["1975", "1976", "1977", "1978"],
    "C15 Heavy Half": ["1977", "1978"],
    "C15 High Sierra": ["1975", "1976", "1977", "1978"],
    "C15 Sierra Classic": ["1975", "1976", "1977", "1978"],
    "C15 Sierra Grande": ["1975", "1976", "1977", "1978"],
    "C15 Suburban Base": ["1975", "1976", "1977", "1978"],
    "C15 Suburban High Sierra": ["1975", "1976", "1977", "1978"],
    "C15 Suburban Sierra Classic": ["1975", "1976", "1977", "1978"],
    "C15 Suburban Sierra Grande": ["1975", "1976", "1977", "1978"],
    "C15/C1500 Pickup Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "C15/C1500 Suburban Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "C1500 Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C1500 Heavy Half": ["1979", "1980"],
    "C1500 High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C1500 Sierra": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "C1500 Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C1500 Sierra Grande": ["1979", "1980", "1981", "1982"],
    "C1500 Sierra SL": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "C1500 Sierra SLE": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "C1500 Sierra SLT": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "C1500 Sierra SLX": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "C1500 Sierra Special": ["1994", "1995", "1996", "1997", "1998"],
    "C1500 Street Coupe": ["1979", "1980", "1981", "1982"],
    "C1500 Suburban Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "C1500 Suburban High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C1500 Suburban Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C1500 Suburban Sierra Grande": ["1979", "1980", "1981", "1982"],
    "C1500 Suburban SLE": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "C25 Base": ["1975", "1976", "1977", "1978"],
    "C25 High Sierra": ["1975", "1976", "1977", "1978"],
    "C25 Sierra Classic": ["1975", "1976", "1977", "1978"],
    "C25 Sierra Grande": ["1975", "1976", "1977", "1978"],
    "C25 Suburban Base": ["1975", "1976", "1977", "1978"],
    "C25 Suburban High Sierra": ["1975", "1976", "1977", "1978"],
    "C25 Suburban Sierra Classic": ["1975", "1976", "1977", "1978"],
    "C25 Suburban Sierra Grande": ["1975", "1976", "1977", "1978"],
    "C25/C2500 Pickup Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "C25/C2500 Suburban Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "C2500 Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C2500 High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C2500 Sierra": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "C2500 Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C2500 Sierra Grande": ["1979", "1980", "1981", "1982"],
    "C2500 Sierra SL": ["1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    "C2500 Sierra SLE": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "C2500 Sierra SLT": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "C2500 Sierra SLX": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "C2500 Suburban Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "C2500 Suburban High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C2500 Suburban Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C2500 Suburban Sierra Grande": ["1979", "1980", "1981", "1982"],
    "C2500 Suburban SLE": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "C35 Base": ["1975", "1976", "1977", "1978"],
    "C35 High Sierra": ["1975", "1976", "1977", "1978"],
    "C35 Sierra Classic": ["1975", "1976", "1977", "1978"],
    "C35 Sierra Grande": ["1975", "1976", "1977", "1978"],
    "C35/C3500 Pickup Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "C3500 Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C3500 High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C3500 Sierra": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "C3500 Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "C3500 Sierra Grande": ["1979", "1980", "1981", "1982"],
    "C3500 Sierra SL": ["1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    "C3500 Sierra SLE": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "C3500 Sierra SLT": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "C3500 Sierra SLX": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "K15 Base": ["1975", "1976", "1977", "1978"],
    "K15 High Sierra": ["1975", "1976", "1977", "1978"],
    "K15 Sierra Classic": ["1975", "1976", "1977", "1978"],
    "K15 Sierra Grande": ["1975", "1976", "1977", "1978"],
    "K15 Suburban Base": ["1975", "1976", "1977", "1978"],
    "K15 Suburban High Sierra": ["1975", "1976", "1977", "1978"],
    "K15 Suburban Sierra Classic": ["1975", "1976", "1977", "1978"],
    "K15 Suburban Sierra Grande": ["1975", "1976", "1977", "1978"],
    "K15/K1500 Pickup Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "K15/K1500 Suburban Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "K1500 Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K1500 High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K1500 Sierra": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "K1500 Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K1500 Sierra Grande": ["1979", "1980", "1981", "1982"],
    "K1500 Sierra SL": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "K1500 Sierra SLE": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "K1500 Sierra SLT": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "K1500 Sierra SLX": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "K1500 Sierra Special": ["1994", "1995", "1996", "1997", "1998"],
    "K1500 Suburban Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "K1500 Suburban High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K1500 Suburban Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K1500 Suburban Sierra Grande": ["1979", "1980", "1981", "1982"],
    "K1500 Suburban SLE": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "K25 Base": ["1975", "1976", "1977", "1978"],
    "K25 High Sierra": ["1975", "1976", "1977", "1978"],
    "K25 Sierra Classic": ["1975", "1976", "1977", "1978"],
    "K25 Sierra Grande": ["1975", "1976", "1977", "1978"],
    "K25 Suburban Base": ["1975", "1976", "1977", "1978"],
    "K25 Suburban High Sierra": ["1975", "1976", "1977", "1978"],
    "K25 Suburban Sierra Classic": ["1975", "1976", "1977", "1978"],
    "K25 Suburban Sierra Grande": ["1975", "1976", "1977", "1978"],
    "K25/K2500 Pickup Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "K25/K2500 Suburban Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "K2500 Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K2500 High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K2500 Sierra": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "K2500 Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K2500 Sierra Grande": ["1979", "1980", "1981", "1982"],
    "K2500 Sierra SL": ["1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    "K2500 Sierra SLE": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "K2500 Sierra SLT": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "K2500 Sierra SLX": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "K2500 Suburban Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "K2500 Suburban High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K2500 Suburban Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K2500 Suburban Sierra Grande": ["1979", "1980", "1981", "1982"],
    "K2500 Suburban SLE": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "K35 Base": ["1977", "1978"],
    "K35 High Sierra": ["1977", "1978"],
    "K35 Sierra Classic": ["1977", "1978"],
    "K35 Sierra Grande": ["1977", "1978"],
    "K35/K3500 Pickup Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "K3500 Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K3500 High Sierra": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K3500 Sierra": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "K3500 Sierra Classic": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "K3500 Sierra Grande": ["1979", "1980", "1981", "1982"],
    "K3500 Sierra SL": ["1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    "K3500 Sierra SLE": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "K3500 Sierra SLT": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "K3500 Sierra SLX": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "G35/G3500 Van Base": ["1970", "1971"],
    "G35/G3500 Van Rally": ["1971", "1972", "1973", "1974"],
    "G35/G3500 Van Vandura": ["1971", "1972", "1973", "1974"],
    "Jimmy Base": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Sprint Base": ["1971", "1972", "1973", "1974", "1975", "1976", "1977"],
    "Sprint Custom": ["1972", "1973", "1974"],
    "Sierra 1500 AT4": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Sierra 1500 AT4X": ["2022", "2023", "2024"],
    "Sierra 1500 Denali Ultimate": ["2022", "2023", "2024"],
    "Sierra 1500 Elevation": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Sierra 1500 Pro": ["2022", "2023", "2024"],
    "Jimmy Diamond Edition": ["2000", "2001"],
    "Jimmy SLE": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Jimmy SLS": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Jimmy SLT": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Safari Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "2003",
      "2004",
      "2005",
    ],
    "Safari SL": [
      "1985",
      "1986",
      "1987",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Safari SLE": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Safari SLT": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Savana 1500 Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Savana 1500 SLT": ["2001", "2002"],
    "Savana 2500 Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Savana 2500 SLE": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2003",
      "2004",
      "2005",
    ],
    "Savana 3500 Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Savana 3500 SLE": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2003",
      "2004",
      "2005",
    ],
    "Savana 3500 SLT": ["2001", "2002"],
    "Sonoma SL": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Sonoma SLE": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Sonoma SLS": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Savana 2500 LS": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Savana 2500 LT": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Savana 3500 LS": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Savana 3500 LT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Jimmy Envoy": ["1998", "1999", "2000"],
    "Jimmy SL": ["1995", "1996", "1997", "1998", "1999"],
    "C1500 Suburban SLT": ["1995", "1996", "1997", "1998", "1999"],
    "C2500 Suburban SLT": ["1995", "1996", "1997", "1998", "1999"],
    "Canyon Z71 Fleet": ["2004", "2005"],
    "Canyon Z71 SL": ["2004", "2005"],
    "Canyon Z71 SLE": ["2004", "2005"],
    "Canyon Z85 SL": ["2004", "2005"],
    "Canyon Z85 SLE": ["2004", "2005"],
    "Envoy SLE": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Envoy SLT": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Envoy XL SLE": ["2002", "2003", "2004", "2005", "2006"],
    "Envoy XL SLT": ["2002", "2003", "2004", "2005", "2006"],
    "Envoy XUV SLE": ["2004", "2005"],
    "Envoy XUV SLT": ["2004", "2005"],
    "G1500 Rally": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G1500 Rally STX": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G1500 Vandura": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G2500 Rally": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G2500 Rally STX": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G2500 Vandura": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "G3500 Magnavan": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "G3500 Rally": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "G3500 Rally Camper Special": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "G3500 Rally STX": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "G3500 Vandura": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "G3500 Vandura Special": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "K1500 Suburban SLT": ["1995", "1996", "1997", "1998", "1999"],
    "K2500 Suburban SLT": ["1995", "1996", "1997", "1998", "1999"],
    "P3500 Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Safari SLX": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Savana 1500 SLE": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2003",
      "2004",
      "2005",
    ],
    "Sonoma Base": ["1991", "1992", "1993"],
    "Typhoon Base": ["1992", "1993"],
    "Yukon Base": ["1992", "1993", "1994", "1995"],
    "Yukon SL": ["1996", "1997"],
    "Caballero Amarillo": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "Caballero Base": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Caballero Diablo": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Canyon WT": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "Envoy Denali": ["2005", "2006", "2007", "2008", "2009"],
    "Envoy XL Denali": ["2005", "2006"],
    "Jimmy Sierra Classic": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "P2500 Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "P2500 Value Van": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "P3500 Value Van": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "R1500 Suburban Base": ["1987", "1988", "1989", "1990", "1991"],
    "R1500 Suburban Sierra Classic": ["1987", "1988", "1989"],
    "R2500 Base": ["1987", "1988", "1989"],
    "R2500 High Sierra": ["1987", "1988", "1989"],
    "R2500 Sierra Classic": ["1987", "1988", "1989"],
    "R2500 Suburban Base": ["1987", "1988", "1989", "1990", "1991"],
    "R2500 Suburban Sierra Classic": ["1987", "1988", "1989"],
    "R3500 Base": ["1987", "1988", "1989", "1990", "1991"],
    "R3500 High Sierra": ["1987", "1988", "1989"],
    "R3500 Sierra Classic": ["1987", "1988", "1989"],
    "R3500 SLE": ["1990", "1991"],
    "S15 Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "S15 Gypsy": ["1986", "1987", "1988"],
    "S15 High Sierra": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "S15 Sierra Classic": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "S15 Jimmy Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "S15 Jimmy Gypsy": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "S15 Jimmy Sierra Classic": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "S15 Jimmy Timberline": ["1988", "1989"],
    "V1500 Suburban Base": ["1987", "1988", "1989", "1990", "1991"],
    "V1500 Suburban Sierra Classic": ["1987", "1988", "1989"],
    "V2500 Suburban Base": ["1987", "1988", "1989", "1990", "1991"],
    "V2500 Suburban Sierra Classic": ["1987", "1988", "1989"],
    "V3500 Base": ["1987", "1988", "1989", "1990", "1991"],
    "V3500 High Sierra": ["1987", "1988", "1989"],
    "V3500 Sierra Classic": ["1987", "1988", "1989"],
    "V3500 SLE": ["1990", "1991"],
    "Sierra 2500 HD AT4X": ["2024", "2025"],
    "Sierra 2500 HD Denali Ultimate": ["2024", "2025"],
    "Sierra 2500 HD Pro": ["2023", "2024", "2025"],
    "Sierra 3500 HD Denali Ultimate": ["2024", "2025"],
    "Sierra 3500 HD Pro": ["2023", "2024", "2025"],
    "Canyon AT4X": ["2023", "2024", "2025"],
    "Savana 1500 LS": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Savana 1500 LT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Yukon XL AT4": ["2021", "2022", "2023", "2024"],
    "Jimmy High Sierra": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "Jimmy Sierra Grande": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "Jimmy Street Coupe": ["1978", "1979", "1980", "1981", "1982"],
    "Yukon AT4": ["2021", "2022", "2023", "2024"],
    "Yukon Denali Ultimate": ["2023", "2024"],
    "Yukon XL Denali Ultimate": ["2023", "2024"],
    "Terrain AT4": ["2022", "2023", "2024"],
    "Acadia AT4": ["2020", "2021", "2022", "2023", "2024"],
    "G1500 Rally Custom": ["1983", "1984"],
    "G2500 Rally Custom": ["1983", "1984"],
    "G3500 Rally Custom": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "G35 Magnavan": ["1975", "1976", "1977", "1978"],
    "G35 Rally": ["1975", "1976", "1977", "1978"],
    "G35 Rally Camper Special": ["1975", "1976", "1977", "1978"],
    "G35 Rally STX": ["1975", "1976", "1977", "1978"],
    "G35 Vandura": ["1975", "1976", "1977", "1978"],
    "G35 Vandura Special": ["1975", "1976", "1977", "1978"],
    "G15/G1500 Van Base": ["1970", "1971"],
    "G15/G1500 Van Rally": ["1968", "1969", "1971", "1972", "1973", "1974"],
    "G15/G1500 Van Vandura": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "G1500 Base": ["1964", "1965", "1966"],
    "Suburban Base": ["1960", "1961", "1962", "1963", "1964", "1965", "1966"],
    "G25 Rally": ["1975", "1976", "1977", "1978"],
    "G25 Rally STX": ["1975", "1976", "1977", "1978"],
    "G25 Vandura": ["1975", "1976", "1977", "1978"],
    "G25/G2500 Van Rally": ["1968", "1969", "1971", "1972", "1973", "1974"],
    "G25/G2500 Van Vandura": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "G15 Vandura": ["1975", "1976", "1977", "1978"],
    "G25/G2500 Van Base": ["1970", "1971", "1972"],
    "Sprint Classic": ["1975", "1976", "1977"],
    "Sprint SP": ["1975", "1976"],
    "Caballero Laredo": ["1978", "1979", "1980"],
    "P25/P2500 Van Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "P35 Base": ["1975", "1976", "1977", "1978"],
    "P35 Value Van": ["1975", "1976", "1977", "1978"],
    "P35/P3500 Van Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "1000 Series Base": ["1960", "1961", "1962", "1963", "1964", "1965"],
    "1500 Series Base": ["1960", "1961", "1962", "1963", "1964", "1965"],
    "2500 Series Base": ["1960", "1961", "1962", "1963", "1964", "1965"],
    "G1000 Series Base": ["1963", "1964", "1965", "1966"],
    "G15 Rally": ["1975", "1976", "1977", "1978"],
    "G15 Rally STX": ["1975", "1976", "1977", "1978"],
    "P15 Base": ["1975", "1976", "1977", "1978"],
    "P15 Value Van": ["1975", "1976", "1977", "1978"],
    "P1500 Base": ["1979", "1980"],
    "P1500 Value Van": ["1979", "1980"],
    "P25 Base": ["1975", "1976", "1977", "1978"],
    "P25 Value Van": ["1975", "1976", "1977", "1978"],
    "P15/P1500 Van Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "100 Base": ["1958", "1959"],
    "150 Base": ["1958", "1959"],
    "Transmode Base": ["1973", "1974"],
    "3000 Base": ["1960", "1961", "1962", "1963", "1964", "1965", "1966"],
    "3500 Base": ["1960", "1961", "1962", "1963", "1964", "1965", "1966"],
    "250 Base": ["1958", "1959"],
    "300 Base": ["1958", "1959"],
    "350-8 Base": ["1958", "1959"],
    "370 Base": ["1958", "1959"],
  },
  Chrysler: {
    "200 C": ["2015", "2016", "2017"],
    "200 Limited": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "200 LX": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "200 S": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "200 Touring": ["2011", "2012", "2013", "2014"],
    "Sebring Limited": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Sebring LX": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2008",
      "2009",
      "2010",
    ],
    "Sebring Touring": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "Conquest TSi": ["1988", "1989"],
    "PT Cruiser Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "PT Cruiser GT": ["2003", "2004", "2005", "2006", "2007"],
    "PT Cruiser Limited": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "PT Cruiser Touring": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "300 Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "2005",
      "2006",
      "2007",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "300 C": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "300 C Luxury": ["2012", "2013", "2014"],
    "300 C Platinum": ["2015", "2016", "2017"],
    "300 Limited": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "300 S": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "300 SRT8": ["2012", "2013", "2014"],
    "300 Touring": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "300 Touring L": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Cordoba Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "Imperial Base": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1981",
      "1982",
      "1983",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Imperial Crown": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
    ],
    "Imperial LeBaron": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
    ],
    "LeBaron Base": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "LeBaron Medallion": ["1977", "1978", "1979", "1980", "1981", "1982"],
    "New Yorker Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1994",
      "1995",
      "1996",
    ],
    "New Yorker Brougham": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Newport Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "Newport Custom": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "Newport Royal": ["1971", "1972"],
    "Pacifica Hybrid Limited": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Pacifica Hybrid Pinnacle": ["2021", "2022", "2023", "2024"],
    "Pacifica Hybrid Touring": ["2020", "2021"],
    "Pacifica Hybrid Touring L": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Pacifica Hybrid Touring Plus": ["2018", "2019"],
    "Pacifica L": ["2018", "2019"],
    "Pacifica Limited": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Pacifica LX": ["2017", "2018", "2019"],
    "Pacifica Pinnacle": ["2021", "2022", "2023", "2024"],
    "Pacifica Touring": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Pacifica Touring L": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Pacifica Touring L Plus": ["2017", "2018", "2019", "2020"],
    "Pacifica Touring Plus": ["2018", "2019"],
    "Voyager L": ["2020", "2021"],
    "Voyager LX": [
      "2001",
      "2002",
      "2003",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Voyager LXi": ["2020", "2021"],
    "Crossfire Base": ["2004", "2005", "2006", "2007"],
    "Crossfire Limited": ["2005", "2006", "2007", "2008"],
    "Crossfire SRT-6": ["2005", "2006"],
    "Pacifica Base": ["2004", "2005", "2006", "2007"],
    "Cordoba 300": ["1979", "1980"],
    "LeBaron GTS": ["1985", "1986", "1987", "1988", "1989"],
    "LeBaron Mark Cross": ["1983", "1984", "1985", "1986"],
    "LeBaron Premium": ["1987", "1988", "1989", "1990"],
    "Prowler Base": ["2001", "2002"],
    "PT Cruiser LX": ["2008", "2009"],
    "PT Cruiser Street Cruiser": ["2005", "2006"],
    "300 C SRT8": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "300 LX": ["2008", "2009"],
    "Voyager Base": ["2000", "2001", "2002"],
    "Aspen Limited": ["2007", "2008", "2009"],
    "300M Base": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "300M Special": ["2002", "2003", "2004"],
    "Concorde Base": ["1993", "1994", "1995"],
    "Concorde Limited": ["2002", "2003", "2004"],
    "Concorde LX": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Concorde LXi": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Fifth Avenue Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Laser Base": ["1984", "1985", "1986"],
    "Laser XE": ["1984", "1985", "1986"],
    "LeBaron GT": ["1989", "1990"],
    "LeBaron GTC": ["1989", "1990", "1991", "1992", "1993", "1994", "1995"],
    "LeBaron High Line": ["1989", "1990"],
    "LeBaron Landau": ["1992", "1993", "1994"],
    "LeBaron LE": ["1993", "1994"],
    "LeBaron LX": ["1991", "1992", "1993"],
    "LHS Base": ["1994", "1995", "1996", "1997", "1999", "2000", "2001"],
    "New Yorker Fifth Avenue": ["1990", "1991", "1992", "1993"],
    "New Yorker Landau": ["1988", "1989", "1990"],
    "New Yorker Salon": ["1990", "1991", "1992", "1993"],
    "TC Maserati Base": ["1989", "1990", "1991"],
    "Town & Country Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Town & Country EL": ["2002", "2003"],
    "Town & Country EX": ["2001", "2002", "2003", "2004"],
    "Town & Country Limited": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Town & Country LX": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2015",
      "2016",
    ],
    "Town & Country LXi": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Town & Country Mark Cross": ["1983", "1984", "1985", "1986"],
    "Town & Country SX": ["1997", "1998", "1999"],
    "Town & Country Touring": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Town & Country Touring L": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Sebring GTC": ["2002", "2003", "2004", "2005", "2006"],
    "Sebring LXi": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Cordoba LS": ["1980", "1981", "1982"],
    "LeBaron Salon": ["1979", "1980", "1981"],
    "LeBaron Special": ["1980", "1981"],
    "Town & Country S": ["2013", "2014", "2015", "2016"],
    "Cirrus LX": ["1995", "1996", "1997", "1999", "2000"],
    "Cirrus LXi": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Sebring Base": ["2004", "2005", "2006", "2007"],
    "Sebring JX": ["1996", "1997", "1998", "1999", "2000"],
    "Sebring JXi": ["1996", "1997", "1998", "1999", "2000"],
    "Sebring TSi": ["2005", "2006"],
    "Town & Country Limited Platinum": ["2015", "2016"],
    "E Class Base": ["1983", "1984"],
    "Executive Sedan Base": ["1983", "1984"],
    "300 Sport": ["1962", "1963"],
    "Saratoga Base": ["1958", "1959", "1960"],
    "Windsor Base": ["1958", "1959", "1960", "1961"],
  },
  Hyundai: {
    "Accent GLS": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Accent GS": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Accent SE": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Elantra GLS": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Elantra Limited": [
      "2006",
      "2007",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Elantra SE": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Elantra Sport": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "Elantra Coupe GS": ["2013", "2014"],
    "Elantra GT Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Azera Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Azera Limited": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Santa Fe GLS": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Santa Fe Limited": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Santa Fe Limited Ultimate": ["2017", "2018"],
    "Santa Fe SE": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Santa Fe SE Ultimate": ["2017", "2018"],
    "Santa Fe Sport 2.0T": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Santa Fe Sport 2.0T Ultimate": ["2017", "2018"],
    "Santa Fe Sport Base": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Sonata Hybrid": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Sonata Hybrid Limited": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sonata Limited": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Sonata SE": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Equus Signature": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Equus Ultimate": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Genesis 3.8": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Genesis 4.6": ["2009", "2010", "2011", "2012"],
    "Genesis 5.0": ["2015", "2016"],
    "Genesis 5.0 R-Spec": ["2012", "2013", "2014"],
    "Santa Fe SEL": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Tucson GL": ["2005", "2006", "2011", "2012", "2013"],
    "Tucson GLS": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Tucson Limited": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tucson SE": [
      "2007",
      "2008",
      "2009",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sonata Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2016",
      "2017",
    ],
    "Sonata Hybrid SE": ["2017", "2018", "2019"],
    "Sonata Limited 2.0T": ["2015", "2016", "2017", "2018", "2019"],
    "Sonata Plug-In Hybrid": ["2016", "2017", "2018", "2019"],
    "Sonata Plug-In Hybrid Limited": ["2016", "2017", "2018", "2019"],
    "Sonata Sport": ["2015", "2016", "2017", "2018", "2019"],
    "Sonata Sport 2.0T": ["2015", "2016", "2017", "2018"],
    "Accent Sport": ["2015", "2016", "2017"],
    "Veloster Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
      "2021",
    ],
    "Veloster RE:FLEX": ["2014", "2015"],
    "Veloster Turbo": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
      "2021",
    ],
    "Veloster Turbo R-Spec": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
      "2021",
    ],
    "Elantra Touring GLS": ["2010", "2011", "2012"],
    "Elantra Touring SE": ["2010", "2011", "2012"],
    "Santa Cruz Limited": ["2022", "2023", "2024"],
    "Santa Cruz Night": ["2023", "2024"],
    "Santa Cruz SE": ["2022", "2023", "2024"],
    "Santa Cruz SEL": ["2022", "2023", "2024"],
    "Santa Cruz SEL Premium": ["2022", "2023"],
    "Santa Fe Calligraphy": ["2021", "2022", "2023", "2024"],
    "Sonata SEL Plus": ["2020", "2021", "2022", "2023"],
    "Genesis Coupe 3.8": ["2015", "2016"],
    "Genesis Coupe 3.8 Grand Touring": ["2010", "2011", "2012", "2013", "2014"],
    "Genesis Coupe 3.8 R-Spec": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Genesis Coupe 3.8 Ultimate": ["2014", "2015", "2016"],
    "Genesis Coupe 2.0T": ["2010", "2011", "2012", "2013", "2014"],
    "Genesis Coupe 2.0T Premium": ["2010", "2011", "2012", "2013", "2014"],
    "Genesis Coupe 2.0T R-Spec": ["2010", "2011", "2012", "2013", "2014"],
    "Elantra Base": ["1992", "1993", "1994", "1995", "1996", "1997", "1998"],
    "Excel Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Excel GL": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Excel GLS": ["1986", "1987", "1988", "1989", "1990", "1991"],
    "Excel GS": ["1991", "1992", "1993", "1994"],
    "Scoupe Base": ["1991", "1992", "1993", "1994", "1995"],
    "Scoupe LS": ["1991", "1992", "1993", "1994", "1995"],
    "Scoupe Turbo": ["1993", "1994", "1995"],
    "Sonata GLS": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Genesis Coupe 3.8 Track": ["2010", "2011", "2012", "2013"],
    "Accent Base": ["1995", "1996", "2003", "2004"],
    "Accent GL": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Accent GT": ["1996", "1997", "2004", "2005"],
    "Accent L": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Elantra Eco": ["2017", "2018", "2019", "2020"],
    "Elantra SEL": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Elantra Value Edition": ["2016", "2017", "2018", "2019", "2020"],
    "Elantra GT N Line": ["2019", "2020"],
    "Kona Limited": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Kona SE": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Kona SEL": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Kona SEL Plus": ["2020", "2021"],
    "Kona Ultimate": ["2018", "2019", "2020", "2021"],
    "Sonata Eco": ["2015", "2016", "2017", "2018", "2019"],
    "Sonata SEL": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Tiburon Base": ["1997", "1998", "1999", "2000", "2001", "2003", "2004"],
    "Tiburon GT": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "Tucson Eco": ["2016", "2017"],
    "Tucson Fuel Cell": ["2015", "2016", "2017"],
    "Tucson Sport": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "Azera GLS": ["2007", "2008", "2009", "2010", "2011"],
    "Azera SE": ["2006", "2007"],
    "Elantra GT": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Entourage GLS": ["2007", "2008"],
    "Entourage Limited": ["2007", "2008"],
    "Sonata GL": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "2004",
      "2005",
      "2006",
    ],
    "Sonata LX": ["2002", "2003", "2004", "2005", "2006"],
    "Tiburon GS": ["2005", "2006", "2007", "2008"],
    "Tiburon GT Limited": ["2007", "2008"],
    "Tiburon SE": ["2005", "2006", "2007", "2008"],
    "Veracruz GLS": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "Veracruz Limited": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "Veracruz SE": ["2007", "2008"],
    "XG350 Base": ["2002", "2003", "2004", "2005"],
    "XG350 L": ["2002", "2003", "2004", "2005"],
    "Santa Fe LX": ["2001", "2002", "2003", "2004", "2005"],
    "Palisade Calligraphy": ["2021", "2022", "2023", "2024"],
    "Palisade Limited": ["2020", "2021", "2022", "2023", "2024"],
    "Palisade SE": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "Palisade SEL": ["2020", "2021", "2022", "2023", "2024"],
    "Palisade XRT": ["2023", "2024"],
    "Kona N Line": ["2022", "2023", "2024", "2025"],
    "Nexo Blue": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Nexo Limited": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Santa Fe Hybrid Blue": ["2021", "2022", "2023"],
    "Santa Fe Hybrid Limited": ["2021", "2022", "2023", "2024"],
    "Santa Fe Hybrid SEL Premium": ["2021", "2022", "2023"],
    "Santa Fe Plug-In Hybrid Limited": ["2022", "2023"],
    "Santa Fe Plug-In Hybrid SEL Convenience": ["2022", "2023"],
    "Santa Fe XRT": ["2022", "2023", "2024"],
    "Tucson Blue Hybrid": ["2022", "2023", "2024"],
    "Tucson Limited Hybrid": ["2022", "2023", "2024"],
    "Tucson Limited Plug-In Hybrid": ["2022", "2023", "2024"],
    "Tucson N Line": ["2022", "2023", "2024"],
    "Tucson SEL": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Tucson SEL Convenience Hybrid": ["2022", "2023", "2024"],
    "Tucson SEL Plug-In Hybrid": ["2022", "2023", "2024"],
    "Tucson XRT": ["2022", "2023", "2024"],
    "Tucson Ultimate": ["2019", "2020", "2021"],
    "Tucson Value Edition": ["2018", "2019", "2020", "2021"],
    "Venue Denim": ["2020", "2021"],
    "Venue Limited": ["2022", "2023", "2024"],
    "Venue SE": ["2020", "2021", "2022", "2023", "2024"],
    "Venue SEL": ["2020", "2021", "2022", "2023", "2024"],
    "Elantra GL": ["1996", "1997", "1998", "1999"],
    "Veloster N Base": ["2019", "2020", "2021", "2022"],
    "Accent Limited": ["2018", "2019", "2020", "2021", "2022"],
    "Accent SEL": ["2018", "2019", "2020", "2021", "2022"],
    "Elantra N Base": ["2022", "2023", "2024"],
    "Elantra N Line": ["2021", "2022", "2023", "2024"],
    "Sonata Hybrid Blue": ["2020", "2021", "2022", "2023"],
    "Sonata Hybrid SEL": ["2020", "2021", "2022", "2023", "2024"],
    "Sonata N Line": ["2021", "2022", "2023", "2024"],
    "Elantra Blue Hybrid": ["2022", "2023", "2024"],
    "Elantra Limited Hybrid": ["2021", "2022", "2023", "2024"],
    "Santa Fe Base": ["2002", "2003", "2004", "2005"],
    "Kona N Base": ["2022", "2023"],
    "Veloster Turbo Ultimate": ["2019", "2020", "2021"],
    "Ioniq Hybrid Blue": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Ioniq Hybrid Limited": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Ioniq Hybrid SE": ["2021", "2022"],
    "Ioniq Hybrid SEL": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Ioniq Plug-In Hybrid": ["2018", "2019"],
    "Ioniq Plug-In Hybrid Limited": ["2018", "2019", "2020", "2021"],
    "Ioniq Plug-In Hybrid SE": ["2020", "2021"],
    "Ioniq Plug-In Hybrid SEL": ["2020", "2021"],
    "Tiburon FX": ["1997", "1998", "1999"],
    "Veloster Premium": ["2019", "2020", "2021"],
    "Kona Electric Limited": ["2019", "2020"],
    "Kona Electric SEL": ["2019", "2020"],
    "Kona Electric Ultimate": ["2019", "2020"],
  },
  Genesis: {
    "G80 3.8": ["2017", "2018", "2019", "2020"],
    "G80 5.0": ["2017", "2018", "2019", "2020"],
    "G80 Advanced": ["2021", "2022", "2023"],
    "G80 Base": ["2021", "2022", "2023"],
    "G80 Prestige": ["2021", "2022", "2023"],
    "G80 Sport": ["2018", "2019", "2020", "2022", "2023"],
    "GV80 Advanced": ["2021", "2022", "2023"],
    "GV80 Advanced+": ["2021", "2022", "2023"],
    "GV80 Base": ["2021", "2022", "2023"],
    "GV80 Prestige": ["2021", "2022", "2023"],
    "G90 Premium": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "G90 Ultimate": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "G70 Base": ["2020", "2021", "2022", "2023", "2024"],
    "G70 Elite": ["2019", "2020", "2021"],
    "G70 Prestige": ["2019", "2020", "2021", "2022", "2023"],
    "G70 Sport": ["2019", "2020", "2021"],
    "G70 Sport Advanced": ["2022", "2023", "2024"],
    "G70 Sport Prestige": ["2022", "2023", "2024"],
  },
  Acura: {
    "ILX Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "ILX Hybrid": ["2013", "2014"],
    "MDX Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "MDX SH-AWD": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "MDX Sport Hybrid": ["2017", "2018", "2019", "2020"],
    "RDX Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RDX SH-AWD": [
      "2010",
      "2011",
      "2012",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RL Base": [
      "1996",
      "1997",
      "1998",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "RLX Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "RLX Sport Hybrid SH-AWD": ["2016", "2017", "2018", "2019", "2020"],
    "TL Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TL SH-AWD": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "TL Type-S": ["2002", "2003", "2007", "2008"],
    "TLX Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TLX SH-AWD": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TSX Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TSX Special Edition": ["2012", "2013", "2014"],
    "TSX V6": ["2010", "2011", "2012", "2013", "2014"],
    "ZDX Base": ["2010", "2011", "2012", "2013"],
    "RDX PMC Edition": ["2021", "2022"],
    "TLX Type S": ["2021", "2022", "2023", "2024"],
    "RSX Type-S": ["2002", "2003", "2004", "2005", "2006"],
    "Integra GS": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Integra GS-R": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Integra LS": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Integra RS": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "RSX Base": ["2002", "2003", "2004", "2005", "2006"],
    "CL Base": ["1997", "1998", "2002", "2003"],
    "CL Premium": ["1997", "1998", "1999"],
    "Integra Special Edition": ["1995", "1996"],
    "Integra Type R": ["1997", "1998", "2000", "2001"],
    "Integra A-Spec": ["2023", "2024", "2025"],
    "NSX Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2004",
      "2005",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "MDX Type S": ["2022", "2023", "2024"],
    "RL Premium": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "TL Premium": ["1995", "1996", "1997", "1998"],
    "MDX Touring": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Integra LS Special Edition": ["1987", "1988"],
    "Integra Base": ["2023", "2024", "2025"],
    "CL Type-S": ["2001", "2002", "2003"],
    "NSX T": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Vigor GS": ["1992", "1993", "1994"],
    "Vigor LS": ["1992", "1993", "1994"],
    "Integra Type S": ["2024", "2025"],
    "SLX Base": ["1996", "1997"],
    "SLX Premium": ["1996", "1997", "1998", "1999"],
    "Legend Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Legend GS": ["1994", "1995"],
    "Legend L": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Legend LS": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
  },
  Honda: {
    "Accord DX": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Accord EX": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2023",
      "2024",
      "2025",
    ],
    "Accord EX-L": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Accord Hybrid": [
      "2005",
      "2006",
      "2007",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Accord Hybrid EX": ["2018", "2019", "2020", "2021", "2022"],
    "Accord Hybrid EX-L": [
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Accord Hybrid Sport": ["2022", "2023", "2024"],
    "Accord Hybrid Sport-L": ["2023", "2024"],
    "Accord Hybrid Touring": [
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Accord LX": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Accord LX-P": ["2008", "2009", "2010", "2011", "2012"],
    "Accord LX-S": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Accord SE": ["2011", "2012"],
    "Accord Sport": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Accord Sport SE": ["2021", "2022"],
    "Accord Touring": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Accord Value Package": ["1996", "1997", "2001", "2002", "2006", "2007"],
    "Accord Crosstour EX": ["2010", "2011"],
    "Accord Crosstour EX-L": ["2010", "2011"],
    "Civic DX": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Civic EX": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Civic EX-L": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Civic GX": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Civic HF": ["2012", "2013", "2014", "2015"],
    "Civic Hybrid": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Civic Hybrid-L": ["2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "Civic LX": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Civic LX-S": ["2009", "2010", "2011"],
    "Civic Natural Gas": ["2013", "2014", "2015"],
    "Civic Si": [
      "1986",
      "1987",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1999",
      "2000",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "CR-V EX": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "CR-V EX-L": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "CR-V LX": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "CR-V Touring": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Crosstour EX": ["2012", "2013", "2014", "2015"],
    "Crosstour EX-L": ["2012", "2013", "2014", "2015"],
    "Odyssey EX": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Odyssey EX-L": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Odyssey LX": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Odyssey SE": ["2016", "2017"],
    "Odyssey Touring": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Odyssey Touring Elite": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Passport Elite": ["2019", "2020", "2021", "2022", "2023"],
    "Passport EX-L": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Passport Sport": ["2019", "2020", "2021", "2022"],
    "Passport Touring": ["2019", "2020", "2021", "2022"],
    "Passport TrailSport": ["2022", "2023", "2024", "2025"],
    "Pilot Black Edition": ["2020", "2021", "2022"],
    "Pilot Elite": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Pilot EX": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Pilot EX-L": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Pilot LX": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2023",
      "2024",
    ],
    "Pilot Special Edition": ["2021", "2022"],
    "Pilot Sport": ["2022", "2023", "2024"],
    "Pilot Touring": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Pilot TrailSport": ["2022", "2023", "2024"],
    "Ridgeline Black Edition": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Ridgeline RT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2017",
      "2018",
      "2019",
    ],
    "Ridgeline RTL": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Ridgeline RTL-E": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "Ridgeline RTL-T": ["2017", "2018", "2019"],
    "Ridgeline RTS": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Ridgeline RTX": ["2007", "2008"],
    "Ridgeline Sport": [
      "2012",
      "2013",
      "2014",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "CR-V SE": ["2000", "2001", "2005", "2006"],
    "Insight Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Civic EX-T": ["2016", "2017", "2018"],
    "Civic Sport": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Civic Sport Touring": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Civic Touring": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Civic Type R": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2023",
      "2024",
      "2025",
    ],
    "Clarity Electric": ["2017", "2018", "2019"],
    "Clarity Plug-In Hybrid": ["2018", "2019", "2020", "2021"],
    "Clarity Plug-In Hybrid Touring": ["2018", "2019", "2020", "2021"],
    "CR-V Hybrid EX": ["2020", "2021", "2022"],
    "CR-V Hybrid EX-L": ["2020", "2021", "2022"],
    "CR-V Hybrid Sport": ["2023", "2024"],
    "CR-V Hybrid Sport Touring": ["2023", "2024"],
    "CR-V Hybrid Touring": ["2020", "2021", "2022"],
    "CR-V Special Edition": ["2021", "2022"],
    "CR-Z Base": ["2011", "2012", "2013", "2014", "2015"],
    "CR-Z EX": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Fit Base": ["2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "Fit EV": ["2013", "2014"],
    "Fit EX": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Fit EX-L": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Fit LX": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Fit Sport": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2018",
      "2019",
      "2020",
    ],
    "HR-V EX": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "HR-V EX-L": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "HR-V LX": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "HR-V Sport": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "HR-V Touring": ["2019", "2020"],
    "Insight EX": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Insight LX": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2019",
      "2020",
      "2021",
    ],
    "Insight Touring": ["2019", "2020", "2021", "2022"],
    "Odyssey Elite": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "S2000 Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "S2000 CR": ["2008", "2009"],
    "Civic CX": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Civic HX": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Prelude Base": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Prelude Type SH": ["1997", "1998", "1999", "2000", "2001"],
    "Prelude S": ["1992", "1993", "1994", "1995", "1996"],
    "Prelude Si": ["1990", "1991", "1992", "1993", "1994", "1995", "1996"],
    "Prelude Si 4WS": ["1990", "1991", "1992", "1993", "1994"],
    "Prelude VTEC": ["1993", "1994", "1995", "1996"],
    "Civic RT 4WD": ["1988", "1989", "1990", "1991"],
    "CRX Si": ["1988", "1989", "1990", "1991"],
    "Ridgeline TrailSport": ["2024", "2025"],
    "Civic LX-P": ["2016", "2017", "2018"],
    "Civic del Sol VTEC": ["1994", "1995", "1996", "1997"],
    "Prelude 2.0 S": ["1988", "1989", "1990"],
    "Prelude 2.0 Si": ["1985", "1986", "1987", "1988", "1989", "1990", "1991"],
    "Prelude 2.0 Si 4WS": ["1988", "1989"],
    "Civic Value Package": ["2004", "2005"],
    "Civic VX": ["1992", "1993", "1994", "1995"],
    "Civic del Sol S": ["1993", "1994", "1995", "1996", "1997"],
    "Civic del Sol Si": ["1993", "1994", "1995", "1996", "1997"],
    "Civic Base": [
      "1973",
      "1974",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Civic Wagovan": ["1982", "1983", "1988", "1989"],
    "CRX Base": ["1989", "1990", "1991"],
    "CRX HF": ["1988", "1989", "1990", "1991"],
    C70: ["1980", "1981", "1982", "1983"],
    "CB100 Super Sport": ["1970", "1971", "1972"],
    CB1000: ["1993", "1994", "1995", "1996", "1997"],
    CB1000R: [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    CB1100: ["2013", "2014"],
    "CB1100A DLX": ["2013", "2014"],
    CB125S: [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "CB175 Super Sport": ["1969", "1970", "1971", "1972", "1973"],
    CB200: ["1974", "1975", "1976"],
    "CB250 Nighthawk": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    CB300F: ["2015", "2016", "2017", "2018"],
    "CB300FA ABS": ["2017", "2018"],
    "CB350F Four": ["1972", "1973", "1974"],
    "CB350K Twin": ["1968", "1969", "1970", "1971", "1972", "1973"],
    CB360: ["1974", "1975", "1976"],
    CB360T: ["1975", "1976"],
    "CB400F CB-1": ["1989", "1990"],
    "CB400F Super Sport": ["1975", "1976", "1977"],
    "CB400T Hawk": ["1980", "1981"],
    "CB400TI Hawk I": ["1978", "1979"],
    "CB400TII Hawk II": ["1978", "1979"],
    CB450K: ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "CB450SC Nighthawk": ["1982", "1983", "1984", "1985", "1986"],
    CB500: [
      "1971",
      "1972",
      "1973",
      "1974",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    CB500F: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "CB500FA ABS": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "CB500T Twin DOHC": ["1974", "1975", "1976", "1977"],
    CB500X: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "CB500XA ABS": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "CB550F Super Sport": ["1975", "1976", "1977"],
    CB550K: ["1974", "1975", "1976", "1977", "1978", "1979", "1980"],
    "CB550SC Nighthawk": ["1982", "1983"],
    CB600: [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "CB600F 599": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    CB650: ["1979", "1980", "1981", "1982"],
    "CB650C Custom": ["1980", "1981", "1982"],
    "CB650SC Nighthawk": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "CB700SC Nighthawk S": ["1984", "1985", "1986"],
    "CB750 Nighthawk": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "CB750A Automatic": ["1976", "1977", "1978"],
    "CB750C Custom": ["1980", "1981", "1982"],
    "CB750F Super Sport": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    CB750K: [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "CB750SC Nighthawk": ["1982", "1983"],
    "CB900C Custom": ["1980", "1981", "1982"],
    "CB900F 919": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "CB900F Super Sport": ["1979", "1980", "1981", "1982"],
    CBR1000F: ["1993", "1994", "1995", "1996"],
    "CBR1000F Hurricane": [
      "1987",
      "1988",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "CBR1000RA ABS": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    CBR1000RR: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "CBR1000RR SP": ["2014", "2015", "2016"],
    "CBR1000S1 SP": ["2017", "2018", "2019"],
    "CBR1100XX Super Blackbird": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    CBR250R: ["2011", "2012", "2013"],
    "CBR250R ABS": ["2011", "2012", "2013"],
    CBR300R: ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "CBR300RA ABS": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    CBR500R: [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "CBR500RA ABS": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    CBR600F: [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2011",
      "2012",
    ],
    "CBR600F F2": ["1991", "1992", "1993", "1994"],
    "CBR600F F3": ["1995", "1996", "1997", "1998"],
    "CBR600F F4": ["1999", "2000"],
    "CBR600F F4i": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "CBR600F Hurricane": ["1987", "1988", "1989", "1990"],
    "CBR600RA ABS": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    CBR600RR: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    CBR650F: ["2014", "2015", "2016", "2018", "2019"],
    "CBR650FA ABS": ["2014", "2015", "2016", "2018", "2019"],
    CBR900RR: [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    CBR929RR: ["2000", "2001"],
    CBR954RR: ["2002", "2003"],
    CBX: ["1978", "1979", "1980", "1981", "1982"],
    "CH150D Elite Deluxe": ["1985", "1986"],
    "CH250 Elite": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "CH80 Elite": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "CHF50 Metropolitan": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    CJ360: ["1976", "1977"],
    "CL100/S Scrambler": ["1970", "1971", "1972", "1973"],
    "CL125 Scrambler": ["1973", "1974"],
    "CL175 Scrambler": ["1968", "1969", "1970", "1971", "1972"],
    "CL350 Scrambler": ["1968", "1969", "1970", "1971", "1972", "1973"],
    "CL360 Scrambler": ["1974", "1975", "1976"],
    "CL450K Scrambler": ["1967", "1968", "1969", "1970", "1971", "1972"],
    CL70: ["1969", "1970", "1971", "1972"],
    "CM185T Twinstar": ["1978", "1979"],
    "CM200T Twinstar": ["1980", "1981", "1982"],
    "CM250C Custom": ["1982", "1983"],
    "CM400A Hondamatic": ["1979", "1980", "1981"],
    CM400E: ["1980", "1981"],
    CM400T: ["1979", "1980", "1981"],
    "CM450A Hondamatic": ["1982", "1983"],
    CM450E: ["1982", "1983"],
    "CMX250 Rebel 250": [
      "1985",
      "1986",
      "1987",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "CMX450 Rebel 450": ["1986", "1987"],
    "CN250 Helix": [
      "1986",
      "1987",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    CR125M: ["1974", "1975", "1976", "1977", "1978"],
    CR125R: [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    CR250M: ["1973", "1974", "1975", "1976"],
    CR250R: [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    CR480R: ["1982", "1983"],
    CR500AF: [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    CR500R: [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    CR60R: ["1983", "1984"],
    CR80R: [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "CR80RB Expert": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    CR85R: ["2003", "2004", "2005", "2006", "2007"],
    "CR85RB Expert": ["2003", "2004", "2005", "2006", "2007"],
    "CRF1000L Africa Twin": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "CRF1000LD Africa Twin DCT": ["2016", "2017", "2018", "2019"],
    CRF100F: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    CRF110F: [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    CRF125F: [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    CRF125FB: [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    CRF150F: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    CRF150R: [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "CRF150RB Expert": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    CRF230F: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
    ],
    CRF230L: ["2008", "2009"],
    CRF250L: [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    CRF250R: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    CRF250X: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
    ],
    CRF450R: [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    CRF450RX: [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    CRF450X: [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    CRF50F: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    CRF70F: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    CRF80F: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    CT110: ["1980", "1981", "1982", "1983", "1984", "1985", "1986"],
    CT70: [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    CT90: [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
    ],
    CTX700: ["2014", "2015", "2016"],
    CTX700D: ["2014", "2015", "2016", "2017"],
    CTX700N: ["2014", "2015"],
    CTX700ND: ["2014", "2015"],
    CX500: ["1978", "1979", "1980", "1981", "1982", "1983", "1984"],
    "CX500C Custom": ["1979", "1980", "1981", "1982", "1983", "1984"],
    "Cx500D Deluxe": ["1979", "1980", "1981"],
    "CX500TC Turbo": ["1982", "1983"],
    "CX650T Turbo": ["1983", "1984", "1985", "1986"],
    "Ez90 Cub": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "FSC600 Silver Wing": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "FSC600A Silver Wing ABS": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "FT500 Ascot": ["1982", "1983"],
    GB500: ["1989", "1990"],
    "GL1000 Gold Wing": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "GL1100 Gold Wing": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "GL1100A Gold Wing Aspencade": ["1982", "1983"],
    "GL1100I Gold Wing Interstate": ["1980", "1981", "1982", "1983"],
    "GL1200 Gold Wing": ["1984", "1985", "1986", "1987"],
    "GL1200A Gold Wing Aspencade": ["1984", "1985", "1986", "1987"],
    "GL1200I Gold Wing Interstate": ["1984", "1985", "1986", "1987"],
    "GL1500 Gold Wing": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "GL1500A Gold Wing Aspencade": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "GL1500C/CD Valkyrie": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "GL1500CF Valkyrie Interstate": ["1999", "2000", "2001"],
    "GL1500CT Valkyrie Tour": ["1997", "1998", "1999", "2000"],
    "GL1500I Gold Wing Interstate": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "GL1500SE Gold Wing Special Edition": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "GL1800 Gold Wing": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "GL1800 Gold Wing Airbag": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "GL1800A Gold Wing ABS": ["2001", "2002", "2003", "2004", "2005"],
    "GL1800B F6B": ["2013", "2014", "2015", "2016", "2018", "2019"],
    "GL1800B2 F6B Deluxe": ["2013", "2014", "2015", "2016"],
    "GL1800C Valkyrie": ["2014", "2015"],
    "GL1800HP Gold Wing Audio/Comfort": [
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GL1800HPN Gold Wing Audio/Comfort/Navi": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "GL1800HPNA Gold Wing Audio/Comfort/Navi/ABS": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "GL1800HPNM Gold Wing Audio/Comfort/Navi/XM": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GL1800HPNMA Gold Wing Audio/Comfort/Navi/XM/ABS": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GL1800P Gold Wing Premium Audio": ["2006", "2007", "2008"],
    "GL500 Silver Wing": ["1981", "1982"],
    "GL500I Silver Wing Interstate": ["1981", "1982"],
    "GL650 Silver Wing": ["1983", "1984", "1985", "1986"],
    Mr175: ["1975", "1976", "1977"],
    "MRT260 Montesa Cota 4RT260": ["2016", "2017"],
    "MRT300 Montesa Cota 300RR": ["2016", "2017"],
    "MSX125 Grom": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "MT 125 Elsinore": ["1975", "1976", "1977", "1978"],
    "MT 250": ["1974", "1975", "1976"],
    NA50: ["1979", "1980", "1981"],
    "NB50 Aero": ["1983", "1984", "1985", "1986", "1987"],
    "NC50 Express": ["1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    "NC700J NM4": ["2015", "2016"],
    NC700X: ["2012", "2013", "2014", "2015", "2016", "2017"],
    NC700XD: ["2012", "2013", "2014", "2015", "2016", "2017"],
    "NCH50 Metropolitan": ["2013", "2014", "2015"],
    "NCW50 Metropolitan": ["2016", "2017"],
    "NH80 Aero": ["1983", "1984", "1985"],
    "NPS50 Ruckus [Scooter]": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "NPS50S Ruckus [Scooter]": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "NRX1800 Rune": ["2004", "2005"],
    "NSA700 DN-01": ["2008", "2009", "2010"],
    "NSS250 Reflex": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "NSS250A Reflex ABS": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "NSS250AS Reflex Sport ABS": ["2004", "2005", "2006", "2007"],
    "NSS250S Reflex Sport": ["2004", "2005", "2006", "2007"],
    "NSS300 Forza": ["2014", "2015", "2016"],
    "NT650 Hawk GT": ["1988", "1989", "1990", "1991"],
    "NT700V Deauville": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "NT700VA Deauville ABS": ["2010", "2011"],
    NU50: ["1982", "1983"],
    NU50M: ["1982", "1983"],
    NX125: ["1988", "1989", "1990"],
    NX250: ["1988", "1989", "1990"],
    NX50M: ["1981", "1982"],
    "NX650 Dominator": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "PC800 Pacific Coast": [
      "1989",
      "1990",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    PCX150: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "PS250 Big Ruckus": ["2005", "2006"],
    Qa50: ["1971", "1972", "1973", "1974", "1975"],
    "RVF750R RC45": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "RVT1000R RC51": ["2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "SA50 Elite Sr": [
      "1988",
      "1989",
      "1990",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    SH150I: ["2008", "2009", "2010", "2011", "2012"],
    SL100: ["1970", "1971", "1972", "1973"],
    SL125: ["1971", "1972", "1973", "1974"],
    SL175: ["1970", "1971"],
    SL350: ["1970", "1971", "1972"],
    SL70: ["1971", "1972", "1973"],
    ST1100: [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "ST1100 ABS": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    ST1300: [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "ST1300 ABS": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
    ],
    ST90: ["1973", "1974", "1975"],
    TL125: ["1973", "1974", "1975", "1976"],
    TL250: ["1975", "1976"],
    "TLR200 Reflex": ["1986", "1987"],
    "TR200 Fatcat": ["1986", "1987"],
    "VF1000R Interceptor": ["1985", "1986"],
    "VF1100C V65 Magna": ["1982", "1983", "1984", "1985", "1986"],
    "VF1100S V65 Sabre": ["1984", "1985"],
    "VF500C V30 Magna": ["1984", "1985"],
    "VF500F Interceptor": ["1984", "1985", "1986", "1987"],
    "VF700C Magna": ["1984", "1985", "1986", "1987"],
    "VF700F Interceptor": ["1984", "1985"],
    "VF700S Sabre": ["1984", "1985"],
    "VF750C Magna": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "VF750C V45 Magna": ["1982", "1983"],
    "VF750CD Magna Deluxe": ["1995", "1996"],
    "VF750F V45 Interceptor": ["1983", "1984"],
    "VF750S V45 Sabre": ["1982", "1983"],
    VFR1200F: ["2012", "2013"],
    "VFR1200FD DCT": ["2012", "2013"],
    VFR1200X: ["2016", "2017", "2018"],
    VFR1200XD: ["2016", "2017"],
    "VFR700F Interceptor": ["1986", "1987"],
    "VFR750F Interceptor": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "VFR800 Interceptor": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "VFR800A Interceptor ABS": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "VFR800F Interceptor": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "VFR800FD Interceptor DLX": ["2014", "2015"],
    "VT1100C Shadow": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "VT1100C Shadow Spirit": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VT1100C2 Shadow A.C.E.": ["1995", "1996", "1997", "1998", "1999"],
    "VT1100C2 Shadow Sabre": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VT1100C3 Shadow Aero": ["1998", "1999", "2000", "2001", "2002"],
    "VT1100T Shadow A.C.E.Tour": ["1998", "1999", "2000", "2001"],
    "VT1300CR Stateline": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "VT1300CRA Stateline ABS": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "VT1300CS Sabre": ["2010", "2011", "2012", "2013", "2014"],
    "VT1300CSA Sabre ABS": ["2010", "2011", "2012", "2013", "2014"],
    "VT1300CT Interstate": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "VT1300CTA Interstate ABS": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "VT13CX Fury": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "VT13CXA Fury ABS": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VT500C Shadow": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "VT500FT Ascot": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "VT600C Shadow VLX": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VT600CD Shadow VLX Deluxe": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VT750C Shadow A.C.E.": ["1998", "1999", "2000"],
    "VT750C Shadow Aero": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "VT750C2 Shadow Spirit [shaft]": [
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "VT750C2B Shadow Phantom": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "VT750C2S Shadow Spirit ABS": ["2013", "2014"],
    "VT750CD Shadow A.C.E. Deluxe": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "VT750CS Shadow Aero ABS": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "VT750DC Shadow Spirit [chain]": [
      "2001",
      "2002",
      "2003",
      "2005",
      "2006",
      "2007",
    ],
    "VT750RS Shadow RS": ["2010", "2011", "2012", "2013"],
    "VTR1000 Super Hawk": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "VTR250 Interceptor": ["1988", "1989", "1990"],
    "VTX1300C Custom": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "VTX1300R Retro Cast": ["2005", "2006", "2007", "2008", "2009"],
    "VTX1300S Retro Spoke": ["2003", "2004", "2005", "2006", "2007"],
    "VTX1300T Tourer": ["2008", "2009"],
    "VTX1800C Classic": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "VTX1800F Performance": ["2005", "2006", "2007", "2008"],
    "VTX1800N Neo-Retro": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "VTX1800R Retro Cast": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "VTX1800S Retro Spoke": ["2002", "2003", "2004", "2005", "2006"],
    "VTX1800T Tourer": ["2007", "2008"],
    XL100: ["1974", "1975", "1976", "1977", "1978"],
    XL100S: ["1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    XL125: ["1974", "1975", "1976", "1977", "1978"],
    XL125S: ["1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    XL175: ["1973", "1974", "1975", "1976", "1977", "1978"],
    XL185S: ["1979", "1980", "1981", "1982", "1983"],
    XL200R: ["1983", "1984"],
    XL250: ["1972", "1973", "1974", "1975", "1976", "1977"],
    XL250R: ["1982", "1983", "1984", "1985", "1986", "1987"],
    XL250S: ["1978", "1979", "1980", "1981"],
    XL350: ["1974", "1975", "1976", "1977", "1978"],
    XL350R: ["1984", "1985"],
    XL500S: ["1979", "1980", "1981"],
    XL600R: ["1983", "1984", "1985", "1986", "1987"],
    "XL600V Transalp": ["1989", "1990"],
    XL70: ["1974", "1975", "1976"],
    XL75: ["1977", "1978", "1979"],
    XL80S: ["1980", "1981", "1982", "1983", "1984", "1985"],
    XR100: ["1981", "1982", "1983", "1984"],
    XR100R: [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    XR200: ["1980", "1981", "1982", "1983", "1984"],
    XR200R: [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    XR250: ["1979", "1980"],
    XR250L: ["1991", "1992", "1993", "1994", "1995", "1996"],
    XR250R: [
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    XR350R: ["1983", "1984", "1985"],
    XR400R: [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    XR500: ["1979", "1980"],
    XR500R: ["1981", "1982", "1983", "1984"],
    XR50R: ["2000", "2001", "2002", "2003"],
    XR600R: [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    XR650L: [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    XR650R: ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    XR70R: ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    XR75: ["1973", "1974", "1975", "1976", "1977", "1978"],
    XR80: ["1979", "1980", "1981", "1982", "1983", "1984"],
    XR80R: [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    Z50A: ["1972", "1973", "1974", "1975", "1976", "1977", "1978"],
    Z50R: [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "CRF1000L2 Africa Twin Adventure Sports": ["2018", "2019"],
    CRF250F: ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    CRF250RX: ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Passport Black Edition": ["2024", "2025"],
    "TRX450ER Electric Start": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    TRX450R: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "Accord Base": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "AquaTrax F-12 (ARX1200N3)": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "AquaTrax F-12X (ARX1200T3)": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "AquaTrax F-12X GPSCAPE (ARX1200T3D)": ["2005", "2006", "2007"],
    "AquaTrax F-15X (ARX1500T3)": ["2008", "2009"],
    "AquaTrax F-15X GPSCAPE (ARX1500T3D)": ["2008", "2009"],
    "AquaTrax R-12 (ARX1200N2)": ["2004", "2005", "2006"],
    "AquaTrax R-12X (ARX1200T2)": ["2003", "2004", "2005", "2006", "2007"],
    "CB1100 EX": ["2017", "2018", "2019", "2020", "2021"],
    CB650F: ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    CB650R: ["2019", "2020", "2021"],
    "CB650RA ABS": ["2019", "2020", "2021", "2022", "2023"],
    CBR650R: ["2019", "2020", "2021", "2022", "2023", "2024"],
    "CBR650RA ABS": ["2019", "2020", "2021", "2022", "2023"],
    "CMX500 Rebel 500": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "CMX500A Rebel 500 ABS": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "GL1800 Gold Wing Tour": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GL1800B Gold Wing Automatic DCT": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GL1800D Gold Wing Tour Automatic DCT": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GL1800DA Gold Wing Tour Airbag Automatic DCT": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    NC700S: ["2012", "2013"],
    NC750X: ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    ATC250SX: ["1985", "1986", "1987"],
    ATC350X: ["1985", "1986"],
    "TRX200D Fourtrax Type II": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "TRX300 Fourtrax": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "TRX300EX Sportrax": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "TRX300FW Fourtrax 4X4": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    TRX350: ["1986", "1987"],
    TRX350D: ["1987", "1988", "1989"],
    "TRX350FE Rancher 4X4 ES": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX350FM Rancher 4X4": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX350TE Rancher ES": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX350TM Rancher": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX400EX Sportrax": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "TRX400FW Foreman 4X4": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    TRX400X: ["2009", "2010", "2011", "2012", "2013", "2014"],
    "TRX450FE Foreman ES [SRA]": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "TRX450FM Foreman S [SRA]": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "TRX500FE Foreman 4X4 ES [SRA]": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX500FM Foreman 4X4 [SRA]": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX500FPE Foreman 4X4 ES w/PS [SRA]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX500FPM Rubicon 4X4 w/PS [SRA]": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX500TM Foreman [SRA]": ["2005", "2006"],
    CRF450L: ["2019", "2020", "2021"],
    "CRF450R W.E.": ["2019", "2020", "2021", "2022", "2023", "2024"],
    CRF450RL: ["2021", "2022", "2023", "2024"],
    "ATC250ES Big Red": ["1985", "1986", "1987"],
    TRX250: ["1985", "1986", "1987"],
    "TRX250X [SRA]": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    TRX700XX: ["2008", "2009"],
    "TRX400FA Rancher AT [SRA]": ["2004", "2005", "2006", "2007"],
    "TRX400FGA Rancher AT GPScape [SRA]": ["2004", "2005", "2006", "2007"],
    "TRX500FA Rubicon [SRA]": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TRX500FGA Rubicon GPScape [SRA]": ["2004", "2005", "2006", "2007", "2008"],
    "TRX500FPA Foreman 4X4 At w/PS [SRA]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TRX650FA Rincon [IRS]": ["2003", "2004", "2005"],
    "TRX650FGA Rincon GPScape [IRS]": ["2004", "2005"],
    "TRX680FA Rincon [IRS]": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "TRX680FGA Rincon GPScape [IRS]": ["2006", "2007", "2008", "2009"],
    "CBF1000A Base": ["2006", "2007", "2008", "2009", "2010"],
    "CBF600SA Base": ["2010", "2011", "2012"],
    "CBR1000RR Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "CBR1000RR ABS Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
    ],
    "CBR1000RR SP Repsol Edition Base": ["2015", "2016"],
    "CBR1100XX Super Blackbird Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "CBR125R Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "CBR300R Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "CBR300R ABS Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "CBR500R Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CBR500R ABS Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CBR600F F4i Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "CBR600RR Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CBR600RR ABS Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CBR929RR Base": ["2000", "2001"],
    "CBR954RR Base": ["2002", "2003"],
    "FSC600 Silver Wing Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "FSC600A Silver Wing ABS Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "GL1800 Gold Wing Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "GL1800 Gold Wing Airbag Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "GL1800A Gold Wing ABS Base": ["2001", "2002", "2003", "2004", "2005"],
    "GL1800B Gold Wing F6B Base": ["2013", "2014", "2015", "2016"],
    "GL1800B Gold Wing F6B Deluxe Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GL1800HP Gold Wing Audio/Comfort Base": [
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GL1800HPN Gold Wing Audio/Comfort/Navi Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "GL1800HPNA Gold Wing Audio/Comfort/Navi/ABS Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "GL1800HPNM Gold Wing Audio/Comfort/Navi/XM Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GL1800HPNM Gold Wing Audio/Comfort/Navi/XM/ABS Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GL1800P Gold Wing Premium Audio Base": ["2006", "2007", "2008"],
    "NRX1800 Rune Base": ["2004", "2005"],
    "NSS250 Reflex Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "NSS250A Reflex ABS Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "NSS250AS Reflex Sport ABS Base": ["2004", "2005", "2006", "2007"],
    "NSS250S Reflex Sport Base": ["2004", "2005", "2006", "2007"],
    "NT700VA ABS Base": ["2010", "2011"],
    "RVT1000R RC51 Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "VFR1200F Base": ["2012", "2013"],
    "VFR1200F DCT Base": ["2012", "2013"],
    "VFR800 Interceptor Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2014",
      "2015",
    ],
    "VFR800A Interceptor ABS Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Civic 1500 S": ["1983", "1984", "1985"],
    "Civic CRX": ["1984", "1985", "1986", "1987"],
    "Civic CRX HF": ["1985", "1986", "1987"],
    "Civic CRX Si": ["1985", "1986", "1987"],
    "Prelude Si ALB": ["1990", "1991"],
    "Element DX": ["2003", "2004"],
    "Element EX": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Element LX": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Element SC": ["2007", "2008", "2009", "2010"],
    "SXS500M2 Pioneer 500": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "TRX420FA Rancher AT [IRS]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TRX420FA5 Rancher 4x4 AT DCT [IRS]": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "TRX420FA6 Rancher 4x4 AT DCT EPS [IRS]": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "TRX420FE Rancher ES [SRA]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420FE1 Rancher 4x4 ES [SRA]": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "TRX420FM Rancher [SRA]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420FM1 Rancher 4x4 [SRA]": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "TRX420FPE Rancher ES w/PS [SRA]": ["2009", "2010", "2011", "2012", "2013"],
    "TRX420FPM Rancher w/PS [SRA]": ["2009", "2010", "2011", "2012", "2013"],
    "TRX420TE Rancher 2x4 ES [SRA]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420TE1 Rancher 2x4 ES [SRA]": [
      "2014",
      "2015",
      "2016",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "TRX420TM Rancher [SRA]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420TM1 Rancher [SRA]": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "TRX500FA5 Rubicon 4X4 Auto DCT [IRS]": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FA6 Rubicon 4X4 Auto DCT EPS [IRS]": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FE1 Foreman 4X4 ES [SRA]": ["2014", "2015", "2016"],
    "TRX500FM1 Foreman 4X4 [SRA]": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    ATC185S: ["1981", "1982", "1983"],
    ATC200: ["1981", "1982", "1983"],
    ATC200E: ["1982", "1983"],
    ATC200M: ["1984", "1985"],
    ATC200S: ["1984", "1985", "1986"],
    ATC200X: ["1983", "1984", "1985", "1986", "1987"],
    "TRX200 Fourtrax": ["1990", "1991"],
    TRX200SX: ["1986", "1987", "1988"],
    "Muv700 Big Red": ["2009", "2010", "2011", "2012", "2013"],
    "SXS700M2 Pioneer 700": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    ATC110: ["1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    "TRX250EX Sportrax": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "TRX250TE Recon ES [SRA]": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "TRX250TM Recon [SRA]": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Fl250 Odyssey": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
    ],
    "XL750 Transalp": ["2023", "2024"],
    "SXS10S2R Talon 1000R": ["2019", "2020", "2021", "2022", "2023"],
    "SXS10S2X Talon 1000X": ["2019", "2020", "2021", "2022"],
    "SXS10S4 Talon 1000X-4": ["2020", "2021", "2022", "2023"],
    "SXS10S4RD Talon 1000 R-4": ["2023", "2024"],
    "SXS10S4X Talon 1000X-4 Fox Live Valve": ["2020", "2021"],
    "SXS10M3 Pioneer 1000": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "SXS10M5P Pioneer 1000-5": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "SXS700M2D Pioneer 700 Deluxe": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "SXS700M4 Pioneer 700-4": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "SXS700M4D Pioneer 700-4 Deluxe": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Z125 Monkey": ["2019", "2020", "2021", "2022", "2023", "2024"],
    CRF300L: ["2020", "2021", "2022", "2023", "2024"],
    "CRF1100L Africa Twin": ["2020", "2021", "2022", "2023"],
    "CRF1100LD Africa Twin DCT": ["2020", "2021", "2022"],
    "CRF300LA ABS": ["2021", "2022", "2023", "2024"],
    "CRF250LA ABS": ["2017", "2018", "2019", "2020", "2021"],
    "CRF250RL Rally": ["2017", "2018", "2019", "2020", "2021"],
    "CRF250RLA Rally ABS": ["2017", "2018", "2019", "2020", "2021"],
    "CBR1000RR-R Fireblade SP": ["2020", "2021", "2022", "2023"],
    "MSX125A Grom ABS": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "CRF1100L2 Africa Twin Adventure Sports": ["2020", "2021", "2022", "2023"],
    "CRF300L Rally": ["2020", "2021", "2022", "2023", "2024"],
    TRX250R: ["1986", "1987", "1988", "1989"],
    "SXS10M3L Pioneer 1000 LE": ["2017", "2018", "2019"],
    "SXS10M5L Pioneer 1000-5 LE": ["2017", "2018", "2019", "2020", "2021"],
    "CMX1100 Rebel 1100": ["2021", "2022", "2023", "2024"],
    "CMX1100 Rebel 1100 DCT": ["2022", "2023", "2024"],
    "CMX300 Rebel 300": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "CMX300A Rebel 300 ABS": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "CMX500 Rebel 500 ABS SE": ["2021", "2022", "2023"],
    "Z125A Monkey ABS": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "SXS10M3D Pioneer 1000 Deluxe": ["2020", "2021", "2022", "2023"],
    "SXS10M3DT Pioneer 1000 Trail": ["2022", "2023"],
    "SXS10M3P Pioneer 1000 EPS": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "SXS10M5D Pioneer 1000-5 Deluxe": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "SXS10M5DT Pioneer 1000-5 Trail": ["2022", "2023"],
    "SXS520M2 Pioneer 520": ["2021", "2022", "2023"],
    "TRX500FA7 Rubicon 4X4 Auto DCT EPS Deluxe [IRS]": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FM5 Rubicon 4X4 [IRS]": ["2015", "2016", "2018", "2019"],
    "TRX500FM6 Rubicon 4X4 EPS [IRS]": ["2015", "2016", "2017", "2018", "2019"],
    "TRX500FM7 Rubicon 4X4 w/PS DLX [IRS]": ["2015", "2016"],
    "TRX500FE2 Foreman 4X4 ES EPS [SRA]": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FM2 Foreman 4X4 w/PS [SRA]": [
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
    ],
    "TRX420FPA Rancher w/PS [IRS]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TRX420FA1 Rancher 4x4 AT DCT [SRA]": ["2014", "2015", "2016"],
    "TRX420FA2 Rancher 4x4 AT DCT EPS [SRA]": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "TRX420FM2 Rancher 4x4 EPS [SRA]": [
      "2014",
      "2015",
      "2016",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "TRX520FE2 Foreman 4X4 ES EPS [SRA]": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "CRF1000L2D Africa Twin Adventure Sports DCT": ["2018", "2019"],
    "Neo Sorts Cafe Concept": ["2019", "2020"],
    "CB1000RA ABS": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "CRF1100L2D Africa Twin Adventure Sports DCT": ["2020", "2021", "2022"],
    "CMX1100T Rebel 1100 DCT": ["2023", "2024"],
    ATC70: [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "Z 50": ["1968", "1969", "1970", "1971"],
    ATC125M: ["1984", "1985", "1986", "1987"],
    ATC250R: ["1981", "1982", "1983", "1984", "1985", "1986"],
    TRX125: ["1985", "1986", "1987", "1988"],
    "TRX90 Sportrax": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX90EX Sportrax": ["2007", "2008"],
    "TRX90X [SRA]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "TRX420FE Rancher ES [IRS]": ["2020", "2021"],
    "TRX520FM1 Foreman 4X4 [SRA]": ["2020", "2021", "2022", "2023"],
    "VT750CA Shadow Aero ABS (front only)": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "CB300RA ABS": ["2019", "2020", "2021", "2022", "2023"],
    "CRF300LRA Rally ABS": ["2021", "2022", "2023", "2024"],
    "NC750XD DCT ABS": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "TRX520FA5 Rubicon 4X4 Auto DCT [IRS]": ["2020", "2021", "2022", "2023"],
    "TRX520FA6 Rubicon 4X4 Auto DCT EPS [IRS]": [
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "TRX520FA7 Rubicon 4X4 Auto DCT EPS Deluxe [IRS]": [
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "TRX520FM6 Rubicon 4X4 EPS [IRS]": ["2020", "2021", "2022", "2023"],
    "TRX520FM2 Foreman 4X4 EPS [SRA]": ["2020", "2021", "2022", "2023"],
    "CRF450R-S": ["2022", "2023", "2024"],
    ATC90: [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
    ],
    "Fl400R Pilot": ["1989", "1990"],
    "SXS10M3DF Pioneer 1000 Forest": ["2022", "2023"],
    "SXS10M5DF Pioneer 1000-5 Forest": ["2022", "2023"],
    CB300R: ["2018", "2019", "2020"],
    "SXS700M2FP Pioneer 700 Forest": ["2023", "2024"],
    "SXS700M4DF Pioneer 700-4 Forest": ["2023", "2024"],
    "CTX 200": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "CBR600RRA ABS": ["2020", "2021", "2022"],
    "PCX150A ABS": ["2018", "2019"],
    TRX70: ["1986", "1987"],
    TR200: ["1986", "1987"],
    "Fl400R Pilot Base": ["1989", "1990"],
    "GL1500C/CD Valkyrie Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "GL1500CF Valkyrie Interstate Base": ["1999", "2000", "2001"],
    "GL1500CT Valkyrie Tour Base": ["1997", "1998", "1999", "2000"],
    "Muv700 Big Red Base": ["2009", "2010", "2011", "2012", "2013"],
    "ST1100 Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "ST1100 ABS Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "SXS1000M3 Pioneer 1000 Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "SXS1000M3 Pioneer 1000 Deluxe Base": ["2020", "2021"],
    "SXS1000M3 Pioneer 1000 EPS Base": ["2016", "2017", "2018", "2019"],
    "SXS1000M3 Pioneer 1000 Limited Edition Base": ["2017", "2018", "2019"],
    "SXS1000M5 Pioneer 1000-5 Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "SXS1000M5 Pioneer 1000-5 Deluxe Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "SXS1000M5 Pioneer 1000-5 Limited Edition Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "SXS500M2 Pioneer 500 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "SXS700M2 Pioneer 700 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "SXS700M2 Pioneer 700 Deluxe Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "SXS700M4 Pioneer 700-4 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "SXS700M4 Pioneer 700-4 Deluxe Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "TRX300 Fourtrax Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "TRX300FW Fourtrax 4X4 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "TRX350D Base": ["1987", "1988", "1989"],
    "TRX350FE FourTrax Rancher 4x4 ES Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX350FM FourTrax Rancher 4X4 Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX350TE FourTrax Rancher ES Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX350TM FourTrax Rancher Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX400FA FourTrax Rancher AT Base": ["2004", "2005", "2006", "2007"],
    "TRX400FGA FourTrax Rancher AT GPScape Base": [
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "TRX400FW Foreman 4X4 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "TRX420FA Rancher AT Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TRX420FA1 FourTrax Rancher 4x4 Auto DCT Base": ["2014", "2015", "2016"],
    "TRX420FA2 FourTrax Rancher 4x4 Auto DCT with EPS Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "TRX420FA5 FourTrax Rancher 4x4 Auto DCT IRS Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "TRX420FA6 FourTrax Rancher 4x4 Auto DCT IRS EPS Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "TRX420FE FourTrax Rancher 4X4 ES Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420FE1 FourTrax Rancher 4x4 ES Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "TRX420FM FourTrax Rancher 4X4 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420FM1 FourTrax Rancher 4x4 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "TRX420FM2 FourTrax Rancher 4x4 with EPS Base": [
      "2014",
      "2015",
      "2016",
      "2020",
      "2021",
    ],
    "TRX420FPA Rancher AT 4x4 w/ Power Steering Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TRX420FPE Rancher ES 4x4 w/ Power Steering Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420FPM Rancher 4x4 w/ Power Steering Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420TE FourTrax Rancher ES Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420TE1 FourTrax Rancher ES Base": [
      "2014",
      "2015",
      "2016",
      "2020",
      "2021",
    ],
    "TRX420TM FourTrax Rancher Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "TRX420TM1 FourTrax Rancher Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "TRX450FE FourTrax Foreman ES Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "TRX450FM FourTrax Foreman S Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "TRX500FA FourTrax Foreman Rubicon Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TRX500FA5 FourTrax Foreman Rubicon Auto DCT Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FA6 FourTrax Foreman Rubicon Auto DCT EPS Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FA7 FourTrax Foreman Rubicon Auto DCT EPS DLX Base": [
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FE FourTrax Foreman 4x4 ES Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
    ],
    "TRX500FE1 FourTrax Foreman 4x4 ES Base": ["2014", "2015", "2016"],
    "TRX500FE2 FourTrax Foreman 4x4 ES with EPS Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FGA FourTrax Foreman Rubicon GPScape Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "TRX500FM FourTrax Foreman 4x4 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
    ],
    "TRX500FM1 FourTrax Foreman 4x4 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FM2 FourTrax Foreman 4x4 with EPS Base": ["2014", "2015", "2016"],
    "TRX500FM5 FourTrax Foreman Rubicon Base": ["2015", "2016"],
    "TRX500FM6 FourTrax Foreman Rubicon EPS Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "TRX500FPA FourTrax Foreman 4x4 AT w/ Power Steering Base": [
      "2011",
      "2012",
    ],
    "TRX500FPA FourTrax Foreman Rubicon with EPS Base": [
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "TRX500FPE FourTrax Foreman 4x4 ES w/ Power Steering Base": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
    ],
    "TRX500FPM FourTrax Foreman 4x4 w/ Power Steering Base": [
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
    ],
    "TRX500TM FourTrax Foreman Base": ["2005", "2006"],
    "TRX520FA5 FourTrax Foreman Rubicon Auto DCT Base": ["2020", "2021"],
    "TRX520FA6 FourTrax Foreman Rubicon Auto DCT EPS Base": ["2020", "2021"],
    "TRX520FA7 FourTrax Foreman Rubicon Auto DCT EPS DLX Base": [
      "2020",
      "2021",
    ],
    "TRX520FE2 FourTrax Foreman 4x4 ES EPS Base": ["2020", "2021"],
    "TRX520FM1 FourTrax Foreman 4x4 Base": ["2020", "2021"],
    "TRX520FM2 FourTrax Foreman 4x4 EPS Base": ["2020", "2021"],
    "TRX520FM6 FourTrax Foreman Rubicon EPS Base": ["2020", "2021"],
    "TRX650FA FourTrax Rincon Base": ["2003", "2004", "2005"],
    "TRX650FGA FourTrax Rincon GPScape Base": ["2004", "2005"],
    "VT1100C Shadow Spirit Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VT1100C2 Shadow Sabre Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VT1100C3 Shadow Aero Base": ["1998", "1999", "2000", "2001", "2002"],
    "VT750C/CD Shadow ACE Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "VTX1300C Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "VTX1300R Base": ["2005", "2006", "2007", "2008", "2009"],
    "VTX1300S Base": ["2003", "2004", "2005", "2006", "2007"],
    "VTX1300T Base": ["2008", "2009"],
    "C125A Super Cub ABS": ["2019", "2020", "2021"],
    "Civic 1200": ["1975", "1976", "1977", "1978", "1979"],
    "Civic 1300": ["1980", "1981", "1982", "1983"],
    "Civic 1300 DX": ["1980", "1981"],
    "Civic 1500 DX": ["1980", "1981", "1982", "1983"],
    "Civic 1500 GL": ["1980", "1981", "1982"],
    "Civic CVCC": ["1975", "1976", "1977", "1978", "1979"],
    "Passport EX": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Passport LX": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Odyssey Cargo": ["1999", "2000", "2001", "2002"],
    "Accord LXi": ["1986", "1987", "1988", "1989"],
    "Passport DX": ["1994", "1995", "1996"],
    "TRX450R Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "AquaTrax F-12 Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "AquaTrax F-12X Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "AquaTrax F-12X GPScape Base": ["2005", "2006", "2007"],
    "AquaTrax F-15X Base": ["2008", "2009"],
    "AquaTrax R-12 Base": ["2004", "2005", "2006"],
    "AquaTrax R-12X Base": ["2003", "2004", "2005", "2006", "2007"],
    "ATC110 Base": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "ATC125M Base": ["1984", "1985", "1986", "1987"],
    "ATC185S Base": ["1981", "1982", "1983"],
    "ATC200 Base": ["1981", "1982", "1983"],
    "ATC200E Base": ["1982", "1983"],
    "ATC200M Base": ["1984", "1985"],
    "ATC200S Base": ["1984", "1985", "1986"],
    "ATC200X Base": ["1983", "1984", "1985", "1986", "1987"],
    "ATC250ES Big Red Base": ["1985", "1986", "1987"],
    "ATC250R Base": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "ATC250SX Base": ["1985", "1986", "1987"],
    "ATC350X Base": ["1985", "1986"],
    "ATC70 Base": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "CB1000 Base": ["1994", "1995"],
    "CB1000R Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
    ],
    "CB1100 Base": ["2013", "2014"],
    "CB125S Base": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "CB250 Nighthawk Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "CB300F Base": ["2015", "2016", "2017", "2018"],
    "CB300F ABS Base": ["2017", "2018"],
    "CB300R ABS Base": ["2019", "2020"],
    "CB400F CB-1 Base": ["1989", "1990"],
    "CB400T Hawk Base": ["1980", "1981"],
    "CB450SC Nighthawk Base": ["1982", "1983", "1984", "1985", "1986"],
    "CB500F Base": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "CB500F ABS Base": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "CB500X Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CB500X ABS Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CB600F 599 Base": ["2006", "2007"],
    "CB650 Base": ["1980", "1981", "1982"],
    "CB650C Custom Base": ["1980", "1981"],
    "CB650R ABS Base": ["2019", "2020"],
    "CB650SC Nighthawk Base": ["1982", "1983", "1984", "1985"],
    "CB700SC Nighthawk S Base": ["1984", "1985", "1986"],
    "CB750 Nighthawk Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "CB750C Custom Base": ["1980", "1981", "1982"],
    "CB750F Super Sport Base": ["1980", "1981", "1982"],
    "CB750K Base": ["1980", "1981", "1982"],
    "CB750SC Nighthawk Base": ["1982", "1983"],
    "CB900C Custom Base": ["1980", "1981", "1982"],
    "CB900F 919 Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "CB900F Super Sport Base": ["1981", "1982"],
    "CBR1000F Base": ["1993", "1994", "1995", "1996"],
    "CBR1000F Hurricane Base": ["1987", "1988", "1990", "1991"],
    "CBR1000RR SP Base": ["2017", "2018", "2019"],
    "CBR250R Base": ["2011", "2012", "2013"],
    "CBR250R ABS Base": ["2011", "2012", "2013"],
    "CBR600F F2 Base": ["1991", "1992", "1993", "1994"],
    "CBR600F F3 Base": ["1995", "1996", "1997", "1998"],
    "CBR600F F4 Base": ["1999", "2000"],
    "CBR600F Hurricane Base": ["1987", "1988", "1989"],
    "CBR650F Base": ["2014", "2015", "2016"],
    "CBR650F ABS Base": ["2014", "2015", "2016"],
    "CBR650R ABS Base": ["2019", "2020"],
    "CBR900RR Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "CBX Base": ["1979", "1980", "1981", "1982"],
    "CM200T Twinstar Base": ["1980", "1981", "1982"],
    "CM250C Custom Base": ["1982", "1983"],
    "CM400A Hondamatic Base": ["1980", "1981"],
    "CM400E Base": ["1980", "1981"],
    "CM400T Base": ["1980", "1981"],
    "CM450A Hondamatic Base": ["1982", "1983"],
    "CM450E Base": ["1982", "1983"],
    "CMX250C Rebel Base": [
      "1985",
      "1986",
      "1987",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "CMX300 Rebel 300 Base": ["2017", "2018", "2019", "2020"],
    "CMX300 Rebel 300 ABS Base": ["2017", "2018", "2019", "2020"],
    "CMX450C Rebel Base": ["1986", "1987"],
    "CMX500 Rebel 500 Base": ["2017", "2018", "2019", "2020"],
    "CMX500 Rebel 500 ABS Base": ["2017", "2018", "2019", "2020"],
    "CR125R Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "CR250R Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "CR480R Base": ["1982", "1983"],
    "CR500R Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "CR60R Base": ["1983", "1984"],
    "CR80R Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "CR80RB Expert Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "CR85R Base": ["2003", "2004", "2005", "2006", "2007"],
    "CR85RB Expert Base": ["2003", "2004", "2005", "2006", "2007"],
    "CRF1000L Africa Twin Base": ["2016", "2017"],
    "CRF1000L Africa Twin ABS Base": ["2016", "2017", "2018", "2019"],
    "CRF1000L Africa Twin DCT Base": ["2016", "2017", "2018", "2019"],
    "CRF1000L2 Africa Twin Adventure Sports Base": ["2018", "2019"],
    "CRF1000L2 Africa Twin Adventure Sports DCT Base": ["2018", "2019"],
    "CRF100F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
    ],
    "CRF110F Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CRF125F Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "CRF125FB Big Wheel Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CRF150F Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "CRF150R Base": [
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CRF150R Expert Base": [
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CRF230F Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "CRF230L Base": ["2008", "2009"],
    "CRF250F Base": ["2019", "2020"],
    "CRF250L Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CRF250L ABS Base": ["2017", "2018", "2019", "2020"],
    "CRF250L Rally Base": ["2017", "2018", "2019", "2020"],
    "CRF250L Rally ABS Base": ["2017", "2018", "2019", "2020"],
    "CRF250R Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CRF250RX Base": ["2019", "2020"],
    "CRF250X Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
    ],
    "CRF450L Base": ["2019", "2020"],
    "CRF450R Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CRF450RWE Base": ["2019", "2020"],
    "CRF450RX Base": ["2017", "2018", "2019", "2020"],
    "CRF450X Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
    ],
    "CRF50F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "CRF70F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
    ],
    "CRF80F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
    ],
    "CT110 Base": ["1980", "1981", "1982", "1983", "1984", "1985", "1986"],
    "CT70 Base": ["1991", "1992", "1993", "1994"],
    "CTX700 Base": ["2014", "2015", "2016"],
    "CTX700 DCT ABS Base": ["2014", "2015", "2016", "2017", "2018"],
    "CTX700N Base": ["2014", "2015", "2016"],
    "CTX700N DCT ABS Base": ["2014", "2015", "2016"],
    "CX500C Custom Base": ["1980", "1981", "1982"],
    "Cx500D Deluxe Base": ["1980", "1981"],
    "Ez90 Cub Base": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Fl250 Odyssey Base": ["1980", "1981", "1982", "1983", "1984"],
    "FT500 Ascot Base": ["1982", "1983"],
    "GB500 Base": ["1989", "1990"],
    "GL1100 Gold Wing Base": ["1980", "1981", "1982", "1983"],
    "GL1100A Gold Wing Aspencade Base": ["1982", "1983"],
    "GL1100I Gold Wing Interstate Base": ["1980", "1981", "1982", "1983"],
    "GL1200A Gold Wing Aspencade Base": ["1984", "1985", "1986", "1987"],
    "GL1200I Gold Wing Interstate Base": ["1984", "1985", "1986", "1987"],
    "GL1500 Gold Wing Base": ["1988", "1989", "1990"],
    "GL1500A Gold Wing Aspencade Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "GL1500I Gold Wing Interstate Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "GL1500SE Gold Wing Special Edition Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "GL1800 Gold Wing Automatic DCT Base": ["2018", "2019", "2020", "2021"],
    "GL1800 Gold Wing Tour Base": ["2018", "2019", "2020", "2021"],
    "GL1800 Gold Wing Tour Airbag Automatic DCT Base": [
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "GL1800 Gold Wing Tour Automatic DCT Base": [
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "GL1800 Valkyrie Base": ["2014", "2015"],
    "GL500 Silver Wing Base": ["1981", "1982"],
    "GL500I Silver Wing Interstate Base": ["1981", "1982"],
    "Grom 125 Base": ["2014", "2015", "2017", "2018", "2019", "2020"],
    "Grom 125 ABS Base": ["2018", "2019", "2020"],
    "Monkey Base": ["2019", "2020"],
    "Monkey ABS Base": ["2019", "2020"],
    "MRT260 Montesa Cota 4RT260 Base": ["2016", "2017", "2018"],
    "MRT2604F Montesa Cota 4RT Repsol Ed. Base": ["2014", "2015"],
    "MRT300 Montesa Cota 300RR Base": ["2016", "2017", "2018"],
    "NC700J NM4 Base": ["2015", "2016", "2017", "2018"],
    "NC700X Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "NC700X DCT ABS Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "NC750X Base": ["2018", "2019", "2020"],
    "NC750X DCT Base": ["2018", "2019", "2020"],
    "NT650 Hawk GT Base": ["1988", "1989", "1990", "1991"],
    "NX125 Base": ["1988", "1989", "1990"],
    "NX250 Base": ["1988", "1989", "1990"],
    "NX650 Base": ["1988", "1989"],
    "PC800 Pacific Coast Base": [
      "1989",
      "1990",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "RVF750R RC45 Base": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "ST1300 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "ST1300 ABS Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "SXS10S2R Talon 1000R Base": ["2019", "2020"],
    "SXS10S2X Talon 1000X Base": ["2019", "2020"],
    "TLR200 Base": ["1986", "1987"],
    "TR200 Base": ["1986", "1987"],
    "TRX125 Base": ["1985", "1986", "1987", "1988"],
    "TRX200 Fourtrax Base": ["1990", "1991"],
    "TRX200D Fourtrax Type II Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "TRX200SX Base": ["1986", "1987", "1988"],
    "TRX250 Base": ["1985", "1986", "1987"],
    "TRX250EX Sportrax Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "TRX250R Base": ["1986", "1987", "1988", "1989"],
    "TRX250TE FourTrax Recon ES Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "TRX250TM FourTrax Recon Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "TRX250X Base": [
      "1987",
      "1988",
      "1991",
      "1992",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "TRX300EX Sportrax Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "TRX350 Base": ["1986", "1987"],
    "TRX400EX Sportrax Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "TRX400X Base": ["2012", "2013", "2014"],
    "TRX450ER Electric Start Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "TRX680FA FourTrax Rincon Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "TRX680FGA FourTrax Rincon GPScape Base": ["2006", "2007", "2008", "2009"],
    "TRX70 Base": ["1986", "1987"],
    "TRX700XX Base": ["2008", "2009"],
    "TRX90 Sportrax Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TRX90EX Sportrax Base": ["2007", "2008"],
    "TRX90X Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VF1000R Base": ["1985", "1986"],
    "VF1100C V65 Magna Base": ["1983", "1984", "1985", "1986"],
    "VF1100S V65 Sabre Base": ["1984", "1985"],
    "VF500C V30 Magna Base": ["1984", "1985"],
    "VF500F Interceptor Base": ["1984", "1985", "1986"],
    "VF700C Magna Base": ["1984", "1985", "1986", "1987"],
    "VF700F Interceptor Base": ["1984", "1985"],
    "VF700S Sabre Base": ["1984", "1985"],
    "VF750C Magna Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "VF750C V45 Magna Base": ["1982", "1983"],
    "VF750CD Magna Deluxe Base": ["1995", "1996"],
    "VF750F V45 Interceptor Base": ["1983", "1984"],
    "VF750S V45 Sabre Base": ["1982", "1983"],
    "VFR1200X Base": ["2016", "2017"],
    "VFR1200X DCT Base": ["2016", "2017"],
    "VFR700F Interceptor Base": ["1986", "1987"],
    "VFR750F Interceptor Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "VFR800D Interceptor DLX Base": ["2014", "2015"],
    "VT1100C Shadow Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "VT1100C2 Shadow ACE Base": ["1995", "1996", "1997", "1998", "1999"],
    "VT1100T Shadow ACE Tour Base": ["1998", "1999", "2000", "2001"],
    "VT1300CR Stateline Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "VT1300CRA Stateline ABS Base": ["2012", "2013", "2014", "2015", "2016"],
    "VT1300CS Sabre Base": ["2010", "2011", "2012", "2013", "2014"],
    "VT1300CSA Sabre ABS Base": ["2012", "2013", "2014"],
    "VT1300CT Interstate Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "VT1300CTA Interstate ABS Base": ["2011", "2012", "2013", "2014", "2015"],
    "VT13CX Fury Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VT13CXA Fury ABS Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "VT500C Shadow Base": ["1983", "1984", "1985", "1986"],
    "VT500FT Ascot Base": ["1983", "1984"],
    "VT600C Shadow VLX Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VT600CD Shadow VLX Deluxe Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VT700C Shadow Base": ["1983", "1984", "1985", "1986", "1987"],
    "VT750C Shadow Aero Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
    ],
    "VT750C2 Shadow Spirit Base": [
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "VT750C2 Shadow Spirit ABS Base": ["2013", "2014"],
    "VT750C2B Shadow Phantom Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VT750CA Shadow Aero ABS Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
    ],
    "VT750DC Shadow Spirit Base": [
      "2001",
      "2002",
      "2003",
      "2005",
      "2006",
      "2007",
    ],
    "VT750RS Shadow RS Base": ["2010", "2011", "2012", "2013"],
    "VTR1000 Super Hawk Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "VTR250 Interceptor Base": ["1988", "1989", "1990"],
    "VTX1800C Base": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "VTX1800F Base": ["2005", "2006", "2007", "2008"],
    "VTX1800N Base": ["2004", "2005", "2006", "2007", "2008"],
    "VTX1800R Base": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "VTX1800S Base": ["2002", "2003", "2004", "2005", "2006"],
    "VTX1800T Base": ["2007", "2008"],
    "XL100S Base": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "XL125S Base": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "XL185S Base": ["1980", "1981", "1982", "1983"],
    "XL200R Base": ["1983", "1984"],
    "XL250R Base": ["1982", "1983", "1984", "1985", "1986", "1987"],
    "XL250S Base": ["1980", "1981"],
    "XL350R Base": ["1984", "1985"],
    "XL500S Base": ["1980", "1981"],
    "XL600R Base": ["1983", "1984", "1985", "1986", "1987"],
    "XL600V Transalp Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "XL650V Transalp Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "XL80S Base": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "XR100 Base": ["1981", "1982", "1983", "1984"],
    "XR100R Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "XR200 Base": ["1980", "1981", "1982", "1983", "1984"],
    "XR200R Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "XR250L Base": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "XR250R Base": [
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "XR350R Base": ["1983", "1984", "1985"],
    "XR400R Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "XR500R Base": ["1981", "1982", "1983", "1984"],
    "XR50R Base": ["2000", "2001", "2002", "2003"],
    "XR600R Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "XR650L Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "XR650R Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "XR70R Base": ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "XR80 Base": ["1980", "1981", "1982", "1983", "1984"],
    "XR80R Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Z50R Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Civic 1300 FE": ["1982", "1983"],
    "Clarity Fuel Cell": ["2017", "2018", "2019", "2020"],
    "Wagovan DX": ["1986", "1987"],
    "NVA110B Navi": ["2022", "2023"],
    "NT 650": ["1988", "1989", "1990", "1991"],
    "CH150D Elite Deluxe Base": ["1985", "1986"],
    "CH250 Elite Base": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "CHF50 Metropolitan Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "CHF50P Metropolitan II Base": ["2002", "2003", "2004", "2005"],
    "CN250 Helix Base": [
      "1986",
      "1987",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "PS250 Big Ruckus Base": ["2005", "2006"],
    "NCH50 Metropolitan Base": ["2013", "2014", "2015", "2016"],
    "NCW50 Metropolitan Base": ["2016", "2017", "2018"],
    "NPS50 Ruckus Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "NPS50S Ruckus Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "NSS300 Forza Base": ["2014", "2015", "2016"],
    "NSS300A Forza ABS Base": ["2014", "2015", "2016"],
  },
  Fiat: {
    "500L Easy": ["2014", "2015", "2016"],
    "500L Lounge": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "500L Pop": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "500L Trekking": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "500L Urbana": ["2015", "2016", "2017", "2019", "2020"],
    "500X Lounge": ["2016", "2017", "2018"],
    "500X Pop": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "500X Sport": ["2020", "2021", "2022", "2023"],
    "500X Trekking": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "500X Trekking Plus": ["2019", "2020", "2021"],
    "500X Urbana": ["2017", "2018"],
    "124 Spider Abarth": ["2017", "2018", "2019", "2020"],
    "124 Spider Classica": ["2017", "2018", "2019", "2020"],
    "124 Spider Lusso": ["2017", "2018", "2019", "2020"],
    "124 Spider Urbana": ["2019", "2020"],
    "500 Abarth": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "500 Abarth Cabrio": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "500 c Lounge": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "500 c Pop": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "500 E": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "500 Lounge": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "500 Pop": ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "500 Sport": ["2012", "2013", "2014", "2015", "2016"],
    "500 Turbo": ["2013", "2014", "2015", "2016"],
    "124 Spider": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "128 Base": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
    ],
    "128 Custom": ["1976", "1977"],
    "128 SL": ["1973", "1974", "1975"],
    "131 Base": ["1976", "1977", "1978"],
    "Brava Base": ["1978", "1979", "1980", "1981"],
    "X-1/9 Base": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "124 Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
    ],
    "850 Base": ["1969", "1970", "1971"],
    "850 Racer": ["1970", "1971"],
    "850 Spider": ["1969", "1970", "1971", "1972", "1973"],
    "Strada Base": ["1980", "1981", "1982"],
    "Strada Custom": ["1980", "1981", "1982"],
  },
  Jaguar: {
    "F-Pace Base": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "F-Pace Portfolio": ["2018", "2019", "2020"],
    "F-Pace Premium": ["2017", "2018", "2019", "2020"],
    "F-Pace Prestige": ["2017", "2018", "2019", "2020"],
    "F-Pace R-Sport": ["2017", "2018", "2019", "2020"],
    "F-Pace S": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "F-Pace SVR": ["2019", "2020", "2021", "2022"],
    "I-Pace HSE": ["2019", "2020"],
    "I-Pace S": ["2019", "2020"],
    "I-Pace SE": ["2019", "2020"],
    "XF Portfolio": ["2018", "2019"],
    "XF Premium": [
      "2010",
      "2011",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "XF Prestige": ["2016", "2017", "2018", "2019", "2020"],
    "XF R-Dynamic SE": ["2021", "2022"],
    "XF S": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "XF SE": ["2021", "2022"],
    "XF Sportbrake Prestige": ["2019", "2020"],
    "S-Type Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "S-Type R": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "X-Type Base": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "XJ8 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XJ8 L": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XJR Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "XK Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "XK8 Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "XKR Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "XKR Portfolio": ["2008", "2009"],
    "XE Base": ["2017", "2018", "2019"],
    "XE Portfolio": ["2018", "2019"],
    "XE Premium": ["2017", "2018", "2019"],
    "XE Prestige": ["2017", "2018", "2019"],
    "XE R-Sport": ["2017", "2018", "2019"],
    "XE S": ["2018", "2019", "2020"],
    "XF Base": ["2010", "2011", "2012", "2013", "2014", "2017", "2018"],
    "XF R-Sport": ["2016", "2017", "2018"],
    "XF Sportbrake S": ["2018", "2019", "2020"],
    "XF Supercharged": ["2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "Super V8 Base": ["2005", "2006", "2007", "2008", "2009"],
    "Vanden Plas Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Vanden Plas SC": ["2000", "2001", "2002", "2003"],
    "XJ12 Base": ["1994", "1995", "1996"],
    "XJ6 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "XJ6 Sovereign": ["1990", "1991", "1992", "1993"],
    "XJ8 Sport": ["2002", "2003"],
    "XJS 2+2": ["1994", "1995", "1996"],
    "XJS Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "XF 3.0L": ["2013", "2014"],
    "XF 3.0L AWD": ["2013", "2014"],
    "XFR Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "XJS C": ["1987", "1988"],
    "XJ L Supercharged": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "XJ L Supersport": ["2010", "2011", "2012", "2013"],
    "XJ Supercharged": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "XJ Supersport": ["2010", "2011", "2012", "2013"],
    "XJR L": ["2014", "2015", "2016", "2017"],
    "XKR-S Base": ["2012", "2013", "2014", "2015"],
    "XJ Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "XJ L Portfolio": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "420 Base": ["1967", "1968"],
    "420 G": ["1967", "1968"],
    "Mark X Base": ["1962", "1963", "1964", "1965", "1966"],
    "F-Type Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "F-Type R": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "F-Type S": ["2014", "2015", "2016", "2017"],
    "F-Type V8 S": ["2014", "2015"],
    "XFR-S Base": ["2013", "2014", "2015"],
    "XJ R-Sport": ["2016", "2017", "2018", "2019"],
    "XKE Base": ["1969", "1970", "1971", "1972"],
    "F-Type R-Dynamic": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "F-Type SVR": ["2017", "2018", "2019", "2020"],
    "E-Pace Base": ["2018", "2019", "2020"],
    "E-Pace S": ["2018", "2019"],
    "E-Pace SE": ["2018", "2019", "2020"],
    "Vanden Plas Majestic": ["1989", "1990"],
    "XJ L": ["2010", "2011"],
    "XJR575 Base": ["2018", "2019"],
    "XJS Classic Collection": ["1990", "1991"],
    "XJS Collection Rouge": ["1989", "1990"],
    "XK120 Base": ["1949", "1950", "1951", "1952", "1953", "1954"],
    "XK120 M": ["1952", "1953", "1954"],
    "XK140 Base": ["1955", "1956", "1957"],
    "XK140 M": ["1955", "1956", "1957"],
    "XK140 MC": ["1955", "1956", "1957"],
    "XK150 Base": ["1958", "1959", "1960", "1961"],
    "XK150 S": ["1958", "1959", "1960", "1961"],
    "Mark IX Base": ["1959", "1960", "1961"],
    "Mark VII Base": ["1951", "1952", "1953", "1954"],
    "Mark VII M": ["1955", "1956", "1957"],
    "Mark VIII Base": ["1957", "1958"],
    "2.4 Base": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "3.4 S": ["1965", "1966", "1967", "1968"],
    "240 Base": ["1967", "1968", "1969"],
    "3.4 Base": ["1957", "1958", "1959"],
    "340 Base": ["1967", "1968", "1969", "1970"],
  },
  "Land Rover": {
    "Range Rover Autobiography": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Range Rover Base": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1999",
      "2000",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Range Rover HSE": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Range Rover Supercharged": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Range Rover SV Autobiography": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Range Rover SV Autobiography Dynamic": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Range Rover SV Autobiography Dynamic Black Edition": ["2021", "2022"],
    "Range Rover Westminster Edition": ["2021", "2022"],
    "Range Rover Sport HSE": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Range Rover Sport Supercharged": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Defender 90 Base": ["1994", "1995"],
    "Discovery Base": ["1994", "1995"],
    "Discovery HSE": ["2003", "2004", "2017", "2018", "2019", "2020"],
    "Discovery LSE": ["1997", "1998"],
    "Discovery S": ["2003", "2004"],
    "Discovery SD": ["1996", "1997"],
    "Discovery SE": [
      "1996",
      "1997",
      "2003",
      "2004",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Discovery SE7": ["1996", "1997"],
    "Discovery Series II": ["1999", "2000"],
    "Discovery Series II SD": ["2001", "2002"],
    "Discovery Series II SE": ["2001", "2002"],
    "Range Rover SE": ["1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    "Range Rover Velar Base": ["2018", "2019"],
    "Range Rover Velar R-Dynamic HSE": ["2018", "2019"],
    "Range Rover Velar R-Dynamic SE": ["2018", "2019"],
    "Range Rover Velar S": ["2018", "2019", "2020"],
    "Range Rover County": ["1989", "1990", "1992", "1993", "1994"],
    "Range Rover County LWB": ["1993", "1994", "1995"],
    "Freelander SE": ["2002", "2003", "2004", "2005"],
    "Freelander SE3": ["2003", "2004", "2005"],
    "LR2 Base": ["2011", "2012", "2013", "2014", "2015"],
    "LR2 HSE": ["2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "LR2 HSE Lux": ["2011", "2012", "2013", "2014", "2015"],
    "LR3 HSE": ["2005", "2006", "2007", "2008", "2009"],
    "LR3 SE": ["2005", "2006", "2007", "2008"],
    "LR4 Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "LR4 HSE": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "LR4 HSE Lux": ["2012", "2013", "2014", "2015", "2016"],
    "Range Rover Sport Autobiography": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Range Rover Sport Autobiography Dynamic": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Range Rover Sport HSE Dynamic": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Range Rover Sport HSE Silver Edition": ["2021", "2022"],
    "Range Rover Sport HST": ["2019", "2020", "2021", "2022"],
    "Range Rover Sport SE": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Range Rover Sport Supercharged Dynamic": ["2018", "2019"],
    "Range Rover Sport SVR": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Range Rover Sport SVR Carbon Edition": ["2021", "2022"],
    "Discovery HSE Luxury": ["2017", "2018", "2019", "2020"],
    "Discovery Sport HSE": ["2015", "2016", "2017", "2018", "2019"],
    "Discovery Sport HSE Lux": ["2015", "2016"],
    "Discovery Sport HSE Luxury": ["2017", "2018", "2019"],
    "Discovery Sport SE": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Range Rover Evoque Autobiography": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Range Rover Evoque Dynamic": ["2012", "2013", "2014", "2015"],
    "Range Rover Evoque HSE": ["2016", "2017", "2018", "2019"],
    "Range Rover Evoque HSE Dynamic": ["2016", "2017", "2018", "2019"],
    "Range Rover Evoque Landmark Edition": ["2018", "2019"],
    "Range Rover Evoque Prestige": ["2012", "2013", "2014", "2015"],
    "Range Rover Evoque Pure": ["2012", "2013", "2014", "2015"],
    "Range Rover Evoque SE": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "Range Rover Evoque SE Dynamic": ["2017", "2018", "2019"],
    "Range Rover Evoque SE Premium": ["2016", "2017", "2018", "2019"],
    "Freelander HSE": ["2002", "2003", "2004"],
    "Freelander S": ["2002", "2003"],
    "Range Rover Sport HSE Lux": ["2012", "2013"],
    "Defender 110 Base": ["2020", "2021"],
    "Defender 110 S": ["2020", "2021"],
    "Land Rover Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Discovery Sport Base": ["2020", "2021"],
    "Discovery Sport R-Dynamic S": ["2020", "2021", "2022"],
    "Discovery Sport R-Dynamic SE": ["2020", "2021", "2022"],
    "Discovery Sport S": ["2020", "2021", "2022"],
    "Defender 110 SE": ["2020", "2021"],
    "Defender 110 X": ["2020", "2021"],
    "Range Rover Evoque S": ["2020", "2021"],
  },
  Lexus: {
    "ES300h Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "ES300h Luxury": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "ES300h Ultra Luxury": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "ES350 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "ES350 F Sport": ["2019", "2020", "2021", "2022"],
    "ES350 Luxury": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "ES350 Ultra Luxury": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "RX350 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "RX350 F Sport": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "RX350h Base": ["2023", "2024", "2025"],
    "RX350h Luxury": ["2023", "2024"],
    "RX350h Premium": ["2023", "2024"],
    "RX350h Premium+": ["2023", "2024"],
    "RX350L Base": ["2018", "2019", "2020", "2021", "2022"],
    "UX200 Base": ["2019", "2020", "2021", "2022"],
    "UX200 F Sport": ["2019", "2020", "2021", "2022"],
    "UX200 Luxury": ["2019", "2020", "2021", "2022"],
    "HS250h Base": ["2010", "2011", "2012"],
    "HS250h Premium": ["2010", "2011", "2012"],
    "LS460 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "LS460 F Sport": ["2013", "2014", "2015", "2016", "2017"],
    "LS460 L": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "LS600h L": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "GS300 Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2018",
      "2019",
    ],
    "IS300 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "IS300 Sportcross": ["2002", "2003", "2004", "2005"],
    "LX570 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "NX200t Base": ["2015", "2016", "2017"],
    "NX200t F Sport": ["2015", "2016", "2017"],
    "IS250 Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "IS250 C": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "IS250 C F Sport": ["2014", "2015"],
    "IS250 F Sport": ["2014", "2015"],
    "IS350 Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "IS350 C": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "IS350 C F Sport": ["2014", "2015"],
    "IS350 F Sport": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "SC300 Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "ES250 Base": ["1990", "1991", "2021", "2022", "2023", "2024"],
    "ES300 Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "GX460 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GX460 Luxury": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GX460 Premium": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "CT200h Base": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "CT200h F Sport": ["2014", "2015", "2016", "2017"],
    "GS F Base": ["2016", "2017", "2018", "2019", "2020"],
    "GS350 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "GS430 Base": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "GS450h Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "GS460 Base": ["2008", "2009", "2010", "2011"],
    "IS F Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "NX300 Base": ["2018", "2019", "2020", "2021"],
    "NX300 F Sport": ["2018", "2019", "2020", "2021"],
    "NX300 Luxury": ["2020", "2021"],
    "NX300h Base": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "NX300h Luxury": ["2020", "2021"],
    "RX450h Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "LX600 Base": ["2022", "2023", "2024"],
    "LX600 F Sport": ["2022", "2023", "2024"],
    "LX600 Luxury": ["2022", "2023", "2024"],
    "LX600 Premium": ["2022", "2023", "2024"],
    "LX600 Ultra Luxury": ["2022", "2023", "2024"],
    "GX470 Base": ["2003", "2004", "2005", "2006", "2007", "2008", "2009"],
    "LX470 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "RX400h Base": ["2006", "2007", "2008"],
    "GS200t Base": ["2016", "2017"],
    "GS200t F Sport": ["2016", "2017"],
    "GS300 F Sport": ["2018", "2019"],
    "GS350 F Sport": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "GS450h F Sport": ["2015", "2016", "2017", "2018"],
    "RC F Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RC F Fuji Speedway Edition": ["2021", "2022"],
    "SC430 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "GS400 Base": ["1998", "1999", "2000"],
    "SC400 Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "IS200t Base": ["2016", "2017"],
    "IS200t F Sport": ["2016", "2017"],
    "IS300 F Sport": ["2016", "2017", "2018", "2019", "2020"],
    "RC200t F Sport": ["2016", "2017"],
    "RC350 F Sport": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RC200t Base": ["2016", "2017"],
    "RC300 Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RC300 F Sport": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RC350 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "LS400 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "ES250 F Sport": ["2021", "2022", "2023", "2024"],
    "ES250 Luxury": ["2021", "2022", "2023", "2024"],
    "ES250 Ultra Luxury": ["2021", "2022", "2023", "2024"],
    "UX250h Base": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "UX250h F Sport": ["2019", "2020", "2021", "2022"],
    "UX250h Luxury": ["2021", "2022"],
    "LS430 Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "LS500 Base": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "LS500 F Sport": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "LS500h Base": ["2018", "2019", "2020"],
    "LC500 Base": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "LC500h Base": ["2018", "2019", "2020", "2021"],
    "RX450h F Sport": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "LX450 Base": ["1996", "1997"],
    "RX450hL Base": ["2018", "2019", "2020", "2021", "2022"],
    "ES330 Base": ["2004", "2005", "2006"],
    "RX300 Base": ["1999", "2000", "2001", "2002", "2003"],
    "RX330 Base": ["2004", "2005", "2006"],
    "RX350 Luxury": ["2023", "2024", "2025"],
    "RX350 Premium": ["2023", "2024", "2025"],
    "RX350 Premium+": ["2023", "2024", "2025"],
    "ES300h F Sport Design": ["2023", "2024"],
    "ES300h F Sport Handling": ["2023", "2024"],
    "ES350 F Sport Design": ["2023", "2024"],
    "ES350 F Sport Handling": ["2023", "2024"],
    "NX250 Base": ["2022", "2023", "2024", "2025"],
    "NX350 Base": ["2022", "2023", "2024", "2025"],
    "NX350 F Sport": ["2022", "2023"],
    "NX350h Base": ["2022", "2023", "2024", "2025"],
    "NX450h+ Base": ["2022", "2023", "2024"],
    "NX450h+ F Sport": ["2022", "2023"],
    "RX350 F Sport Handling": ["2023", "2024", "2025"],
    "UX250h F Sport Design": ["2023", "2024"],
    "UX250h F Sport Handling": ["2023", "2024"],
    "UX250h Premium": ["2023", "2024"],
    "IS500 F Sport Performance": ["2022", "2023"],
    "IS500 F Sport Performance Premium": ["2022", "2023"],
  },
  Mazda: {
    "CX-9 Grand Touring": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "CX-9 Signature": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "CX-9 Sport": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "CX-9 Touring": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "MX-5 Miata Club": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "MX-5 Miata Grand Touring": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "MX-5 Miata RF Club": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "MX-5 Miata RF Grand Touring": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "MX-5 Miata Sport": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "3 Grand Touring": ["2017", "2018"],
    "3 i": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "3 i Grand Touring": ["2014", "2015", "2016"],
    "3 I Sport": ["2014", "2015", "2016"],
    "3 i SV": ["2014", "2015"],
    "3 I Touring": ["2014", "2015", "2016"],
    "3 s Grand Touring": ["2014", "2015", "2016"],
    "3 s Touring": ["2014", "2015", "2016"],
    "3 Sport": ["2017", "2018"],
    "3 Touring": ["2017", "2018"],
    "6 Grand Touring": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "6 Sport": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "6 Touring": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "CX-5 2.5 S": ["2022", "2023", "2024"],
    "CX-5 2.5 S Carbon Edition": ["2022", "2023", "2024"],
    "CX-5 Grand Touring": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "CX-5 Sport": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "CX-5 Touring": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "3 2.5 Turbo": ["2021", "2022", "2023"],
    "3 2.5 Turbo Premium Plus": ["2021", "2022", "2023", "2024"],
    "RX-7 Base": ["1986", "1987", "1993", "1994", "1995"],
    "RX-7 R2": ["1994", "1995"],
    "RX-7 Touring": ["1993", "1994", "1995"],
    "3 Mazdaspeed": ["2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "6 Mazdaspeed": ["2006", "2007"],
    "RX-7 Convertible": ["1988", "1989", "1990", "1991"],
    "RX-7 GS": ["1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    "RX-7 GSL": ["1981", "1982", "1983", "1984", "1985"],
    "RX-7 GSL-SE": ["1984", "1985"],
    "RX-7 GTU": ["1988", "1989", "1990"],
    "RX-7 GTUs": ["1989", "1990"],
    "RX-7 GXL": ["1986", "1987", "1988", "1989", "1990"],
    "RX-7 GXL 2+2": ["1987", "1988", "1989", "1990"],
    "RX-7 S": ["1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    "RX-8 Base": ["2004", "2005", "2006", "2007"],
    "RX-8 Grand Touring": ["2008", "2009", "2010", "2011"],
    "RX-8 R3": ["2009", "2010", "2011"],
    "RX-8 Sport": ["2008", "2009", "2010", "2011"],
    "RX-8 Touring": ["2008", "2009"],
    "MX-5 Miata SV": ["2007", "2008", "2009"],
    "MX-5 Miata Special Edition": ["2011", "2012"],
    "MX-5 Miata Touring": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Miata Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Miata LS": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "Miata M Edition": ["1994", "1995", "1996", "1997"],
    "Miata Mazdaspeed": ["2004", "2005"],
    "Miata SE": ["2000", "2001", "2002", "2003"],
    "RX-7 Turbo": ["1986", "1987", "1988", "1989", "1990", "1991"],
    "626 DX": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "626 ES": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "626 LX": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "MX-6 Base": ["1993", "1994", "1995", "1996", "1997"],
    "Protege DX": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Protege ES": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Protege LX": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Protege5 Base": ["2002", "2003"],
    "3 S": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "5 Sport": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "5 Touring": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "2 Sport": ["2011", "2012", "2013", "2014"],
    "2 Touring": ["2011", "2012", "2013", "2014"],
    "323 Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "323 DX": ["1986", "1987", "1988"],
    "323 GTX": ["1988", "1989"],
    "323 LX": ["1986", "1987", "1988", "1989"],
    "323 SE": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "626 GT": ["1986", "1987", "1990", "1991"],
    "626 Turbo": ["1988", "1989"],
    "929 Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "929 S": ["1990", "1991"],
    "B2000 Base": ["1979", "1980", "1981", "1986", "1987"],
    "B2000 LX": ["1986", "1987"],
    "B2000 SE-5": ["1986", "1987"],
    "B2200 Base": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "B2200 LE-5": ["1990", "1991", "1992", "1993"],
    "B2200 LX": ["1987", "1988", "1989"],
    "B2200 SE-5": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "GLC Base": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "GLC Custom": ["1980", "1981", "1982", "1983"],
    "GLC Custom L": ["1981", "1982", "1983"],
    "GLC DX": ["1977", "1978", "1979", "1984", "1985"],
    "GLC LX": ["1984", "1985"],
    "GLC Sport": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "MX-3 Base": ["1992", "1993", "1994", "1995"],
    "MX-3 GS": ["1992", "1993", "1994"],
    "MX-6 DX": ["1988", "1989", "1990", "1991", "1992"],
    "MX-6 GT": ["1988", "1989", "1990", "1991", "1992"],
    "MX-6 GT 4WS": ["1989", "1990"],
    "MX-6 LS": ["1993", "1994", "1995", "1996", "1997"],
    "MX-6 LX": ["1988", "1989", "1990", "1991", "1992"],
    "Protege 4WD": ["1990", "1991"],
    "B2600 Base": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "B2600 LX": ["1987", "1988", "1989"],
    "B2600 SE-5": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "6 S": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "5 Grand Touring": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "6 i": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "3 2.0": ["2021", "2022"],
    "3 2.5 S": ["2021", "2022", "2023", "2024"],
    "3 Base": ["2019", "2020"],
    "3 Carbon Edition": ["2022", "2023", "2024"],
    "3 Preferred": ["2020", "2021", "2022", "2023", "2024"],
    "3 Premium": ["2020", "2021", "2022", "2023", "2024"],
    "3 Select": ["2020", "2021", "2022", "2023"],
    "CX-30 2.5 S": ["2021", "2022", "2023", "2024"],
    "CX-30 2.5 S Carbon Edition": ["2022", "2023"],
    "CX-30 2.5 Turbo": ["2021", "2022", "2023", "2024"],
    "CX-50 2.5 S": ["2023", "2024"],
    "CX-50 2.5 Turbo": ["2023", "2024"],
    "MX-30 EV Base": ["2022", "2023"],
    "MX-30 EV Premium Plus": ["2022", "2023"],
    "B2300 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "B2300 SE": ["1994", "1995", "1996", "1997", "2003", "2004"],
    "B3000 Base": ["1994", "1995", "1996", "2005", "2006", "2007"],
    "B3000 SE": [
      "1994",
      "1995",
      "1996",
      "1998",
      "1999",
      "2000",
      "2001",
      "2003",
      "2004",
    ],
    "B4000 LE": ["1994", "1995", "1996"],
    "B4000 SE": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Navajo DX": ["1992", "1993", "1994"],
    "Navajo LX": ["1991", "1992", "1993", "1994"],
    "Tribute Hybrid": ["2008", "2009", "2010"],
    "Tribute i": ["2005", "2006", "2008", "2009", "2010", "2011"],
    "Tribute S": ["2005", "2006", "2008", "2009", "2010", "2011"],
    "Tribute DX": ["2001", "2002", "2003", "2004"],
    "Tribute ES": ["2001", "2002", "2003", "2004"],
    "Tribute LX": ["2001", "2002", "2003", "2004"],
    "B2500 SE": ["1998", "1999", "2000", "2001"],
    "B2500 SX": ["1998", "1999", "2000", "2001"],
    "616 Base": ["1970", "1971"],
    "626 Base": ["1979", "1980", "1981", "1982", "1983"],
    "808 Base": ["1972", "1973", "1974", "1975", "1976", "1977"],
    "B1600 Base": ["1972", "1973", "1974", "1975", "1976"],
    "B1800 Base": ["1977", "1978"],
    "B2000 Sundowner": ["1980", "1981"],
    "B2000 Sundowner Sport": ["1980", "1981", "1982", "1983", "1984"],
    "Cosmo Base": ["1976", "1977", "1978"],
    "Mizer Base": ["1976", "1977"],
    "R100 Base": ["1970", "1971", "1972"],
    "Rotary Pickup Base": ["1974", "1975", "1976", "1977"],
    "RX-2 Base": ["1971", "1972", "1973", "1974"],
    "RX-3 Base": ["1972", "1973", "1974", "1975", "1976"],
    "RX-3 SP": ["1977", "1978"],
    "RX-4 Base": ["1974", "1975", "1976", "1977", "1978"],
    "CX-7 Grand Touring": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "CX-7 Sport": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "CX-7 SV": ["2010", "2011", "2012"],
    "CX-7 Touring": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "6 Grand Touring Reserve": ["2018", "2019", "2020", "2021"],
    "6 Signature": ["2018", "2019", "2020", "2021"],
    "CX-3 Grand Touring": ["2016", "2017", "2018", "2019"],
    "CX-3 Sport": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "CX-3 Touring": ["2016", "2017", "2018", "2019"],
    "CX-30 Preferred": ["2020", "2021"],
    "CX-30 Premium": ["2020", "2021"],
    "CX-30 Select": ["2020", "2021"],
    "CX-5 Grand Touring Reserve": ["2019", "2020", "2021"],
    "CX-5 Signature": ["2019", "2020", "2021"],
    "B3000 DS": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "B3000 Troy Lee": ["1999", "2000"],
    "B4000 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "B4000 DS": ["2001", "2002", "2003", "2004"],
    "CX-90 PHEV": ["2024", "2025"],
    "CX-90 Turbo": ["2024", "2025"],
    "CX-90 Turbo S": ["2024", "2025"],
    "CX-9 Carbon Edition": ["2021", "2022", "2023"],
    "CX-9 Touring Plus": ["2022", "2023"],
    "CX-5 2.5 Turbo": ["2022", "2023", "2024"],
    "CX-5 2.5 Turbo Signature": ["2022", "2023", "2024"],
    "MPV DX": ["2000", "2001"],
    "MPV ES": [
      "1996",
      "1997",
      "1998",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "MPV LX": [
      "1995",
      "1996",
      "1997",
      "1998",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Millenia Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Millenia L": ["1995", "1996", "1997", "1998"],
    "Millenia S": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "B2000 Sundowner Base": ["1982", "1983", "1984"],
    "B2000 Sundowner DLX": ["1982", "1983"],
    "B2200 Sundowner Base": ["1982", "1983", "1984"],
    "B2200 Sundowner DLX": ["1982", "1983"],
    "B2600 LE-5": ["1990", "1991", "1992", "1993"],
    "MPV Cargo": ["1989", "1990", "1991", "1992"],
    "MPV Passenger": ["1989", "1990", "1991", "1992", "1993", "1994"],
  },
  Mini: {
    "Cooper Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper John Cooper Works": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper S": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper Clubman ALL4": ["2017", "2018", "2019"],
    "Cooper Clubman Base": ["2016", "2017", "2018", "2019"],
    "Cooper Clubman John Cooper Works ALL4": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper Clubman S": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper Clubman S ALL4": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper Countryman ALL4": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper Countryman Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper Countryman S": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper Countryman S ALL4": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Cooper Coupe S": ["2012", "2013", "2014", "2015"],
    "Cooper Roadster S": ["2012", "2013", "2014", "2015"],
    "Cooper S Clubman": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Cooper Coupe John Cooper Works": ["2012", "2013", "2014", "2015"],
    "Cooper John Cooper Works Clubman": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Cooper Roadster John Cooper Works": ["2012", "2013", "2014", "2015"],
    "Cooper Countryman John Cooper Works ALL4": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
    ],
    "Cooper Clubman": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "Cooper Coupe": ["2012", "2013", "2014", "2015"],
    "Cooper Roadster": ["2012", "2013", "2014", "2015"],
    "Cooper Paceman Base": ["2013", "2014", "2015", "2016"],
    "Cooper Paceman John Cooper Works ALL4": ["2013", "2014", "2015", "2016"],
    "Cooper Paceman S": ["2013", "2014", "2015", "2016"],
    "Cooper Paceman S ALL4": ["2013", "2014", "2015", "2016"],
    "Cooper SE": ["2020", "2021", "2022", "2023"],
    "Cooper Countryman S E ALL4": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Cooper John Cooper Works GP": ["2021", "2022"],
  },
  Audi: {
    "A3 Premium": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "A3 Premium Plus": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "A3 Prestige": ["2015", "2016", "2017", "2018", "2019"],
    "A3 Quattro Premium": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "A3 Quattro Premium Plus": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "A3 Quattro Prestige": ["2015", "2016", "2017", "2018", "2019"],
    "Q3 Premium": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Q3 Premium Plus": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Q3 S-Line Premium": ["2020", "2021", "2022"],
    "Q3 S-Line Premium Plus": ["2020", "2021", "2022"],
    "S3 Premium Plus": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "S3 Prestige": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2022",
      "2023",
      "2024",
    ],
    "TT Quattro Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "TTS Quattro Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "A4 Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "A4 Quattro Avant": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "A4 Quattro Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "A6 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "A6 Quattro Avant": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "A6 Quattro Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Allroad Quattro Base": ["2001", "2002", "2003", "2004", "2005"],
    "S4 Avant": ["2001", "2002", "2004", "2005", "2006", "2007", "2008"],
    "S4 Base": [
      "1992",
      "1993",
      "1994",
      "2000",
      "2001",
      "2002",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "S6 Avant": ["2002", "2003"],
    "A3 Base": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "TT Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
    ],
    "Q7 Base": ["2007", "2008", "2009", "2010"],
    "Q7 Premium": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Q7 Premium Plus": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Q7 Prestige": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Q7 TDI": ["2009", "2010"],
    "Q7 TDI Premium": ["2011", "2012", "2013", "2014", "2015"],
    "Q7 TDI Premium Plus": ["2011", "2012", "2013", "2014", "2015"],
    "Q7 TDI Prestige": ["2011", "2012", "2013", "2014", "2015"],
    "A3 TDI Premium": ["2015", "2016"],
    "A3 TDI Premium Plus": ["2015", "2016"],
    "A3 TDI Prestige": ["2015", "2016"],
    "A4 Premium": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "A4 Premium Plus": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "RS Q8 Base": ["2020", "2021", "2022", "2023"],
    "RS6 Avant Base": ["2021", "2022", "2023"],
    "RS7 Sportback Base": ["2021", "2022", "2023"],
    "S8 Base": [
      "2001",
      "2002",
      "2003",
      "2007",
      "2008",
      "2009",
      "2013",
      "2014",
      "2015",
      "2016",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "SQ7 Premium Plus": ["2020", "2021", "2022", "2023", "2024"],
    "SQ7 Prestige": ["2020", "2021", "2022", "2023", "2024"],
    "SQ8 Premium Plus": ["2020", "2021", "2022", "2023", "2024"],
    "SQ8 Prestige": ["2020", "2021", "2022", "2023", "2024"],
    "RS3 Base": ["2017", "2018", "2019", "2020", "2022", "2023", "2024"],
    "RS7 Base": ["2014", "2015", "2016", "2017", "2018"],
    "RS7 Performance": ["2016", "2017", "2018"],
    "TT Quattro Premium Plus": ["2012", "2013"],
    "TT Quattro Prestige": ["2012", "2013"],
    "TT RS Quattro Base": [
      "2012",
      "2013",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "A3 TDI": ["2010", "2011", "2012", "2013"],
    "A3 Quattro Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Q3 Prestige": ["2015", "2016", "2017"],
    "Q3 Quattro Premium": ["2017", "2018"],
    "Q3 Quattro Premium Plus": ["2015", "2016", "2017", "2018"],
    "Q3 Quattro Prestige": ["2015", "2016", "2017"],
    "A3 Sportback e-tron Premium": ["2016", "2017", "2018"],
    "A3 Sportback e-tron Premium Plus": ["2016", "2017", "2018"],
    "A3 Sportback e-tron Prestige": ["2016", "2017", "2018"],
    "S3 Premium": ["2022", "2023", "2024"],
    "A8 Quattro Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "A8 Quattro L": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "A8 Quattro L Sport": ["2017", "2018"],
    "A8 Quattro L TDI": ["2014", "2015", "2016"],
    "R8 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2017",
      "2018",
      "2020",
      "2021",
    ],
    "R8 Plus": ["2014", "2015", "2017", "2018"],
    "R8 Spyder": [
      "2011",
      "2012",
      "2014",
      "2015",
      "2017",
      "2018",
      "2020",
      "2021",
    ],
    "A6 Quattro Premium": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A6 Quattro Premium Plus": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A7 Sportback Premium Plus": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A7 Sportback Prestige": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "A4 Cabriolet": ["2003", "2004", "2005", "2006", "2007", "2008", "2009"],
    "A4 Quattro Cabriolet": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "A4 Quattro Premium": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A4 Quattro Premium Plus": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A5 Cabriolet": ["2010", "2011", "2012", "2013", "2014"],
    "A5 Quattro Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "A5 Quattro Cabriolet": ["2010", "2011", "2012", "2013", "2014"],
    "A5 Quattro Premium": [
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A5 Quattro Premium Plus": [
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A6 Premium": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "A6 Premium Plus": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "A6 Quattro Prestige": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A6 Quattro TDI Premium Plus": ["2014", "2015", "2016"],
    "A6 Quattro TDI Prestige": ["2014", "2015", "2016"],
    "allroad Premium": ["2013", "2014", "2015", "2016"],
    "allroad Premium Plus": ["2013", "2014", "2015", "2016"],
    "allroad Prestige": ["2013", "2014", "2015"],
    "Q5 Hybrid Prestige": ["2013", "2014", "2015", "2016"],
    "Q5 Premium": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Q5 Premium Plus": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Q5 Prestige": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Q5 TDI Premium Plus": ["2014", "2015", "2016"],
    "Q5 TDI Prestige": ["2014", "2015", "2016"],
    "S4 Cabriolet": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "A7 Quattro Base": ["2012", "2013"],
    "A7 Quattro Premium Plus": ["2014", "2015", "2016", "2017", "2018"],
    "A7 Quattro Prestige": ["2014", "2015", "2016", "2017", "2018"],
    "A7 Quattro TDI Premium Plus": ["2014", "2015", "2016"],
    "A7 Quattro TDI Prestige": ["2014", "2015", "2016"],
    "A8 Quattro L W12": ["2012", "2013", "2014", "2015", "2016"],
    "RS5 Base": [
      "2013",
      "2014",
      "2015",
      "2018",
      "2019",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RS5 Cabriolet": ["2014", "2015"],
    "S4 Premium Plus": [
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S4 Prestige": [
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S5 Premium Plus": [
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S5 Prestige": [
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S6 Base": ["2007", "2008", "2009", "2010", "2011", "2013", "2014", "2015"],
    "S7 Base": ["2013", "2014", "2015", "2016"],
    "SQ5 Premium Plus": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2023",
      "2024",
    ],
    "SQ5 Prestige": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2023",
      "2024",
    ],
    "Cabriolet Base": ["1994", "1995", "1996", "1997", "1998"],
    "A8 Base": ["1997", "1998", "1999"],
    "RS4 Base": ["2007", "2008"],
    "S5 Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "S5 Cabriolet": ["2010", "2011", "2012", "2013"],
    "S6 Premium Plus": [
      "2016",
      "2017",
      "2018",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S6 Prestige": [
      "2016",
      "2017",
      "2018",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S7 Premium Plus": ["2017", "2018"],
    "S7 Prestige": ["2017", "2018"],
    "S8 Plus": ["2016", "2017", "2018"],
    "Q8 Premium": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Q8 Premium Plus": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Q8 Prestige": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "A4 Prestige": ["2017", "2018", "2019", "2020"],
    "100 Base": ["1989", "1990", "1991", "1992", "1993"],
    "100 CS": ["1992", "1993", "1994"],
    "100 S": ["1992", "1993", "1994"],
    "80 Base": ["1988", "1989", "1990", "1991", "1992"],
    "S4 Premium": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "S5 Premium": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "90 Base": ["1988", "1989", "1990", "1991"],
    "90 Quattro 20v": ["1990", "1991"],
    "90 Quattro Base": ["1988", "1989"],
    "100 Quattro CS": ["1992", "1993", "1994"],
    "A6 Avant": ["1995", "1996", "1997"],
    "A4 allroad Premium": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A4 allroad Premium Plus": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A4 allroad Prestige": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A4 Quattro Prestige": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A4 Quattro Ultra sport": ["2019", "2020"],
    "A5 Quattro Prestige": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A5 Sportback Premium": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A5 Sportback Premium Plus": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "A5 Sportback Prestige": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S5 Sportback Premium": ["2020", "2021", "2022", "2023", "2024"],
    "S5 Sportback Premium Plus": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S5 Sportback Prestige": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "100 Quattro Base": ["1989", "1990", "1991"],
    "200 Base": ["1989", "1990", "1991"],
    "200 Quattro Base": ["1989", "1990", "1991"],
    "V8 Quattro Base": ["1990", "1991", "1992", "1993", "1994"],
    "A7 Sportback Premium": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "100 Series Base": ["1972", "1973"],
    "100 Series GL": ["1972", "1973"],
    "100 Series LS": ["1971", "1972", "1973", "1974", "1975", "1976", "1977"],
    "4000 Base": ["1980", "1981", "1982", "1983"],
    "4000 GT": ["1982", "1983"],
    "4000 S": ["1982", "1983", "1984", "1985", "1986", "1987"],
    "4000 Quattro S": ["1984", "1985"],
    "5000 Base": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "5000 CS": ["1986", "1987", "1988"],
    "5000 S": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "5000 S Turbo": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "5000 Quattro CS": ["1986", "1987", "1988"],
    "5000 Quattro S": ["1987", "1988"],
    "80 Quattro Base": ["1988", "1989", "1990", "1991", "1992"],
    "90 CS": ["1993", "1994"],
    "90 S": ["1993", "1994"],
    "90 Quattro CS": ["1993", "1994"],
    "Coupe GT": ["1986", "1987"],
    "Coupe Quattro 20v": ["1990", "1991"],
    "Fox Base": ["1973", "1974", "1975", "1976", "1977", "1978", "1979"],
    "Super 90 Base": ["1969", "1970", "1971", "1972"],
    "A6 allroad Premium Plus": ["2020", "2021", "2023", "2024"],
    "A6 allroad Prestige": ["2020", "2021", "2022", "2023", "2024"],
    "A8 Quattro L Plug-In Hybrid": ["2020", "2021"],
    "Q5 PHEV Premium": ["2020", "2021", "2022", "2023", "2024"],
    "Q5 PHEV Premium Plus": ["2020", "2021", "2022", "2023", "2024"],
    "Q5 PHEV Prestige": ["2020", "2021", "2022", "2023", "2024"],
    "S7 Sportback Premium Plus": ["2020", "2021", "2022", "2023", "2024"],
    "S7 Sportback Prestige": ["2020", "2021", "2022", "2023", "2024"],
    "SQ5 Premium": ["2019", "2020", "2021", "2023", "2024"],
    "Coupe Base": ["1981", "1982", "1983", "1984", "1985"],
    "Quattro Base": ["1983", "1984", "1985"],
    "e-tron Quattro Premium": ["2021", "2022", "2023"],
    "e-tron Quattro Premium Plus": ["2019", "2020", "2021", "2022", "2023"],
    "e-tron Quattro Prestige": ["2019", "2020", "2021"],
    "e-tron S Premium Plus": ["2022", "2023"],
    "e-tron S Prestige": ["2022", "2023"],
    "e-tron Sportback Premium": ["2021", "2022", "2023"],
    "S6 Premium": ["2023", "2024"],
    "Q5 Sportback Premium": ["2021", "2022", "2023", "2024"],
    "Q5 Sportback Premium Plus": ["2021", "2022", "2023", "2024"],
    "Q5 Sportback Prestige": ["2021", "2022", "2023", "2024"],
    "S7 Sportback Premium": ["2023", "2024"],
    "4000 Quattro CS": ["1986", "1987"],
    "e-tron Quattro Chronos Edition": ["2022", "2023"],
    "e-tron S Sportback Premium Plus": ["2022", "2023"],
    "e-tron S Sportback Prestige": ["2022", "2023"],
    "e-tron Sportback Premium Plus": ["2020", "2021", "2022", "2023"],
    "e-tron Sportback Prestige": ["2020", "2021", "2022", "2023"],
    "R8 Performance": ["2020", "2021", "2022", "2023"],
    "R8 Performance RWD": ["2022", "2023"],
    "R8 Performance RWD Spyder": ["2022", "2023"],
    "R8 Performance Spyder": ["2020", "2021", "2022", "2023"],
    "SQ5 Sportback Premium": ["2023", "2024"],
    "SQ5 Sportback Premium Plus": ["2023", "2024"],
    "SQ5 Sportback Prestige": ["2023", "2024"],
  },
  Volkswagen: {
    "Arteon SE": ["2019", "2020", "2021"],
    "Arteon SE R-Line": ["2022", "2023"],
    "Arteon SEL": ["2019", "2020"],
    "Arteon SEL Premium R-Line": ["2019", "2020", "2021", "2022", "2023"],
    "Arteon SEL R-Line": ["2019", "2020", "2021", "2022", "2023"],
    "Golf S": ["2015", "2016", "2017", "2018", "2019"],
    "Golf SE": ["2015", "2016", "2018", "2019"],
    "Golf SEL": ["2015", "2016"],
    "Golf Alltrack S": ["2017", "2018", "2019"],
    "Golf Alltrack SE": ["2017", "2018", "2019"],
    "Golf Alltrack SEL": ["2017", "2018", "2019"],
    "Golf R Base": [
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2022",
      "2023",
      "2024",
    ],
    "Golf SportWagen S": ["2015", "2016", "2017", "2018", "2019"],
    "Golf SportWagen SE": ["2015", "2016", "2017", "2018", "2019"],
    "Golf SportWagen SEL": ["2015", "2016", "2017", "2018"],
    "GTI Autobahn": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GTI S": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GTI SE": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Jetta GLI Autobahn": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Jetta GLI S": ["2019", "2020", "2021"],
    "Tiguan S": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tiguan SE": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tiguan SE R-Line Black": ["2020", "2021", "2022", "2023", "2024"],
    "Tiguan SEL": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Tiguan SEL Premium": ["2018", "2019"],
    "Tiguan SEL Premium R-Line": ["2019", "2020", "2021"],
    "Tiguan SEL R-Line": ["2022", "2023", "2024"],
    "Beetle Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Golf Base": [
      "1985",
      "1986",
      "1988",
      "1989",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Jetta 2.5": ["2005", "2006", "2007"],
    "Jetta S": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Jetta SE": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Jetta SEL": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Passat S": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2020",
      "2021",
    ],
    "Passat SE": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2020",
      "2021",
      "2022",
    ],
    "Passat SEL": ["2012", "2013"],
    "Passat SEL Premium": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Passat Wolfsburg Edition": ["2013", "2014", "2015"],
    "Rabbit 2.5": ["2006", "2007"],
    "Rabbit S": ["1981", "1982", "2008", "2009"],
    "Passat GL": ["1990", "1991", "1992", "1993", "2003", "2004", "2005"],
    "Passat GL TDI": ["2004", "2005"],
    "Passat GLS": [
      "1995",
      "1996",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Passat GLS 4 Motion": ["2001", "2002", "2004", "2005"],
    "Passat GLS TDI": ["2004", "2005"],
    "Passat GLX": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Passat GLX 4 Motion": ["2001", "2002", "2003", "2004", "2005"],
    "Passat W8": ["2002", "2003", "2004"],
    "Eos Komfort": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Eos Lux": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "GTI Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Jetta 2.0T": ["2006", "2007"],
    "Jetta GLI": [
      "1984",
      "1985",
      "1986",
      "1987",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2017",
      "2018",
    ],
    "Passat 2.0T": ["2006", "2007"],
    "Passat Komfort": ["2008", "2009", "2010"],
    "Passat Value Edition": ["2006", "2007"],
    "Touareg Base": ["2005", "2006", "2007", "2008", "2009"],
    "Touareg Hybrid": ["2011", "2012", "2013", "2014", "2015"],
    "Touareg TDI": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Touareg TDI Executive": ["2012", "2013", "2014", "2015", "2016"],
    "Touareg TDI Lux": ["2012", "2013", "2014", "2015", "2016"],
    "Touareg TDI Sport": ["2012", "2013", "2014", "2015", "2016"],
    "Touareg V6 Executive": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Touareg V6 Lux": ["2012", "2013", "2014", "2015", "2016"],
    "Touareg V6 R-Line": ["2014", "2015"],
    "Touareg V6 Sport": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Touareg VR6": ["2010", "2011"],
    "Jetta TDI": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Jetta TDI Premium": ["2012", "2013", "2014"],
    "Tiguan R-Line": ["2014", "2015", "2016"],
    "Golf GTI GLX": ["2000", "2001"],
    "Golf GTI VR6": [
      "1995",
      "1996",
      "1997",
      "1998",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Jetta GLS": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Jetta GLX": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Beetle R-Line": ["2013", "2014", "2015"],
    "Beetle Turbo": ["2012", "2013"],
    "CC R-Line": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "CC Sport": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Jetta GLI SE": ["2015", "2016"],
    "Jetta GLI SEL": ["2015", "2016"],
    "Jetta Wolfsburg Edition": ["1998", "1999", "2007", "2008", "2009", "2010"],
    "Beetle GL": ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "Beetle GLS": ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "Beetle GLX": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Beetle Sport": ["2001", "2002"],
    "Corrado G60": ["1990", "1991", "1992"],
    "Corrado SLC": ["1992", "1993", "1994"],
    "Golf GLS": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Golf GTI 1.8T": ["2002", "2003", "2004", "2005", "2006"],
    "Golf GTI GLS": ["2000", "2001"],
    "Jetta GL": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Passat TDI": ["1996", "1997"],
    "Beetle Turbo S": ["2002", "2003", "2004"],
    "Golf GL": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Cabrio Base": ["1995", "1996", "1997", "1998", "1999"],
    "Cabriolet Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Cabriolet Bestseller": ["1988", "1989", "1990"],
    "Cabriolet Boutique": ["1988", "1989", "1990"],
    "Cabriolet Carat": ["1991", "1992"],
    "Cabriolet Classic": ["1992", "1993"],
    "Fox Base": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "Fox GL": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "Golf GTI": ["1985", "1986", "1987", "1996", "1997", "1998", "1999"],
    "Golf K2": ["1997", "1998"],
    "Vanagon Base": ["1990", "1991"],
    "Vanagon Campmobile": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Vanagon Carat": ["1989", "1990", "1991"],
    "Vanagon GL": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Vanagon Syncro": ["1986", "1987", "1988", "1989", "1990", "1991"],
    "e-Golf SE": ["2016", "2017", "2018", "2019"],
    "e-Golf SEL Premium": ["2015", "2016", "2017", "2018", "2019"],
    "Golf TSi": ["2020", "2021"],
    "CC Luxury": ["2009", "2010", "2011"],
    "CC VR6": ["2009", "2010"],
    "CC VR6 4Motion": ["2009", "2010", "2011"],
    "CC VR6 Sport": ["2009", "2010"],
    "Passat 3.6": ["2006", "2007"],
    "Passat R-Line": ["2016", "2017", "2018", "2020", "2021", "2022"],
    "Passat TDI SE": ["2012", "2013", "2014", "2015"],
    "Passat TDI SEL": ["2012", "2013"],
    "Passat TDI SEL Premium": ["2014", "2015"],
    "Cabrio GL": ["2000", "2001", "2002"],
    "Cabrio GLS": ["1998", "1999", "2000", "2001", "2002"],
    "Cabrio GLX": ["2001", "2002"],
    "Golf GT": ["1987", "1988"],
    "Golf GTI 16-Valve": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Golf GTI 8-Valve": ["1990", "1991", "1992"],
    "Jetta Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Jetta Carat": ["1988", "1989", "1990", "1991", "1992"],
    "Jetta GLI 16-Valve": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Jetta GT": ["1997", "1998"],
    "Beetle R-Line SEL": ["2016", "2017"],
    "Beetle S": ["2016", "2017", "2018", "2019"],
    "Beetle SE": ["2016", "2017", "2018", "2019"],
    "Beetle TDI": ["2013", "2014", "2015"],
    "Eos Executive": ["2012", "2013", "2014", "2015"],
    "Eos Sport": ["2013", "2014"],
    "Golf TDI": ["2010", "2011", "2012", "2013", "2014"],
    "Jetta Hybrid SEL Premium": ["2014", "2015", "2016"],
    "Jetta Sport": ["2015", "2016", "2017", "2018", "2022", "2023", "2024"],
    "Super Beetle Base": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "EuroVan GLS": ["1999", "2000", "2001", "2002", "2003"],
    "EuroVan MV": ["1999", "2000", "2001", "2002", "2003"],
    "Vanagon Kombi": ["1980", "1981"],
    "Vanagon L": ["1982", "1983", "1984", "1985", "1986"],
    "Beetle Dune": ["2016", "2017", "2018"],
    "Beetle Fleet Edition": ["2015", "2016"],
    "Beetle SEL": ["2016", "2017"],
    "CC Executive": ["2014", "2015"],
    "CC Lux": ["2012", "2013"],
    "CC R-Line Executive": ["2016", "2017"],
    "Jetta Hybrid": ["2013", "2014"],
    "Jetta Hybrid SE": ["2013", "2014"],
    "Jetta Hybrid SEL": ["2013", "2014"],
    "Tiguan Limited Base": ["2017", "2018"],
    "Atlas S": ["2018", "2019", "2020", "2021", "2022"],
    "Atlas SE": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Atlas SEL": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Atlas SEL Premium": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Atlas SEL R-Line": ["2019", "2020", "2021", "2022", "2023"],
    "Atlas Cross Sport S": ["2020", "2021", "2022"],
    "Atlas Cross Sport SE": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "Atlas Cross Sport SE R-Line": ["2020", "2021"],
    "Atlas Cross Sport SEL": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "Atlas Cross Sport SEL Premium": ["2020", "2021"],
    "Atlas Cross Sport SEL Premium R-Line": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Atlas Cross Sport SEL R-Line": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Jetta R-Line": ["2019", "2020", "2021"],
    "Jetta SEL Premium": ["2019", "2020", "2021"],
    "Taos S": ["2022", "2023", "2024"],
    "Taos SE": ["2022", "2023", "2024"],
    "Taos SEL": ["2022", "2023", "2024"],
    "Beetle 2.5": ["2006", "2007"],
    "Phaeton V8": ["2004", "2005", "2006"],
    "Phaeton W12": ["2004", "2005", "2006"],
    "Routan S": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Routan SE": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Routan SEL": ["2009", "2010", "2011", "2012"],
    "Rabbit Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "Rabbit Custom": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Rabbit Deluxe": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Rabbit GL": ["1983", "1984"],
    "Rabbit L": ["1981", "1982", "1983", "1984"],
    "Rabbit LS": ["1981", "1982", "1983"],
    "Rabbit Wolfsburg Edition": ["1983", "1984"],
    "Rabbit Convertible Base": ["1980", "1981", "1982", "1983", "1984"],
    "Rabbit Convertible Wolfsburg Edition": ["1983", "1984"],
    "Routan SEL Premium": ["2010", "2011", "2012", "2013", "2014"],
    "Rabbit GTI": ["1983", "1984"],
    "Scirocco 16-Valve": ["1986", "1987", "1988"],
    "Scirocco Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Scirocco GL": ["1982", "1983"],
    "Scirocco S": ["1980", "1981"],
    "Fastback Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
    ],
    "Karmann Ghia Base": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Squareback Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
    ],
    "Thing Base": ["1973", "1974"],
    "Campmobile Base": ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "Transporter 211": ["1971", "1972", "1973", "1974"],
    "Transporter 215": ["1971", "1972", "1973"],
    "Transporter Base": [
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
    ],
    "Transporter Campmobile": ["1975", "1976", "1977", "1978", "1979"],
    "Transporter Kombi": ["1975", "1976", "1977", "1978", "1979"],
    "411 Base": ["1971", "1972", "1973"],
    "412 Base": ["1973", "1974"],
    "Dasher Base": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "Fox GL Sport": ["1989", "1990"],
    "Quantum Base": ["1982", "1983", "1985", "1986", "1987"],
    "Quantum GL": ["1982", "1983", "1984", "1985", "1986", "1987", "1988"],
    "Quantum Syncro": ["1986", "1987", "1988"],
    "Rabbit Pickup Base": ["1980", "1981", "1982", "1983"],
    "Rabbit Pickup LX": ["1980", "1981", "1982", "1983"],
    "Rabbit Pickup Sport": ["1980", "1981", "1982", "1983"],
    "Beetle Deluxe": [
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
    ],
  },
  Porsche: {
    "911 Carrera": [
      "1974",
      "1975",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "911 Carrera 4": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "911 Carrera 4 GTS": ["2015", "2016", "2018", "2019", "2022", "2023"],
    "911 Carrera 4S": [
      "1996",
      "1997",
      "1998",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "911 Carrera GTS": [
      "2011",
      "2012",
      "2015",
      "2016",
      "2018",
      "2019",
      "2022",
      "2023",
    ],
    "911 Carrera S": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "911 GT3": [
      "2004",
      "2005",
      "2007",
      "2008",
      "2010",
      "2011",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
    ],
    "911 GT3 RS": ["2007", "2008", "2016", "2017"],
    "911 Targa 4": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "911 Targa 4S": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "911 Turbo": [
      "1991",
      "1992",
      "1996",
      "1997",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "911 Turbo S": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Boxster Base": [
      "1997",
      "1998",
      "1999",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Boxster S": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Boxster Spyder": ["2011", "2012"],
    "Cayman Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2016",
    ],
    "Cayman S": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2016",
    ],
    "Cayenne Base": [
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Cayenne Diesel": ["2013", "2014", "2015", "2016"],
    "Cayenne GTS": [
      "2008",
      "2009",
      "2010",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2021",
      "2022",
      "2023",
    ],
    "Cayenne Platinum Edition": ["2017", "2018"],
    "Cayenne S": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Cayenne S E-Hybrid": ["2015", "2016", "2017", "2018"],
    "Cayenne S E-Hybrid Platinum Edition": ["2017", "2018"],
    "Cayenne S Hybrid": ["2011", "2012", "2013", "2014"],
    "Cayenne Turbo": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Cayenne Turbo S": ["2009", "2010", "2013", "2014", "2016", "2017", "2018"],
    "911 Carrera 2": ["1990", "1991", "1992", "1993", "1994"],
    "911 Turbo 3.6": ["1993", "1994"],
    "718 Boxster 25 Years": ["2021", "2022"],
    "718 Boxster Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "718 Boxster GTS": ["2018", "2019"],
    "718 Boxster GTS 4.0": ["2021", "2022", "2023", "2024"],
    "718 Boxster S": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "718 Boxster T": ["2020", "2021", "2022", "2023"],
    "718 Cayman Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "718 Cayman GT4": ["2020", "2021", "2022", "2023"],
    "718 Cayman GT4 RS": ["2022", "2023", "2024"],
    "718 Cayman GTS": ["2018", "2019"],
    "718 Cayman GTS 4.0": ["2021", "2022", "2023", "2024"],
    "718 Cayman S": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "718 Cayman T": ["2020", "2021", "2022", "2023"],
    "911 Carrera T": ["2018", "2019", "2023", "2024"],
    "911 Targa 4 GTS": ["2018", "2019", "2022", "2023"],
    "Cayenne Coupe": ["2020", "2021"],
    "Cayenne E-Hybrid": ["2019", "2020", "2021"],
    "Cayenne E-Hybrid Coupe": ["2020", "2021"],
    "Cayenne GTS Coupe": ["2021", "2022", "2023"],
    "Cayenne S Coupe": ["2020", "2021"],
    "Cayenne Turbo Coupe": ["2020", "2021", "2022", "2023"],
    "Cayenne Turbo GT Coupe": ["2022", "2023"],
    "Cayenne Turbo S E-Hybrid": ["2020", "2021", "2022", "2023"],
    "Cayenne Turbo S E-Hybrid Coupe": ["2020", "2021", "2022", "2023"],
    "Macan GTS": ["2017", "2018", "2020", "2021", "2022", "2023", "2024"],
    "Macan S": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Panamera 4": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Panamera 4 Executive": ["2017", "2018", "2019", "2020"],
    "Panamera 4S": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Panamera 4S Executive": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Panamera Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Panamera GTS": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Panamera GTS Sport Turismo": ["2019", "2020", "2021", "2022", "2023"],
    "Panamera Turbo": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Panamera Turbo Executive": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Panamera Turbo S E-Hybrid": ["2018", "2019", "2020"],
    "Panamera Turbo S E-Hybrid Executive": ["2018", "2019", "2020"],
    "Panamera Turbo S E-Hybrid Sport Turismo": ["2018", "2019", "2020"],
    "Panamera Turbo Sport Turismo": ["2018", "2019", "2020"],
    "Boxster Roadster": ["2000", "2001", "2002", "2003"],
    "Boxster Roadster S": ["2000", "2001", "2002", "2003"],
    "914 4": ["1970", "1971"],
    "914 6": ["1970", "1971"],
    "914 Base": ["1972", "1973", "1974", "1975", "1976"],
    "924 Base": ["1977", "1978", "1979", "1980", "1981", "1982"],
    "924 S": ["1987", "1988"],
    "924 Turbo": ["1979", "1980", "1981", "1982"],
    "944 Base": ["1983", "1984", "1985", "1986", "1987", "1988", "1989"],
    "911 E": ["1969", "1970", "1971", "1972", "1973"],
    "911 S": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
    ],
    "911 SC": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "911 T": ["1969", "1970", "1971", "1972", "1973"],
    "911 Turbo Carrera": ["1976", "1977", "1986", "1987", "1988", "1989"],
    "Macan Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Boxster GTS": ["2015", "2016"],
    "Cayman GTS": ["2015", "2016"],
    "911 GT2": ["2002", "2003", "2004", "2005", "2008", "2009"],
    "Macan Turbo": ["2015", "2016", "2017", "2018", "2020", "2021"],
    "Panamera S": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "Panamera S E-Hybrid": ["2014", "2015", "2016"],
    "Panamera S Hybrid": ["2012", "2013"],
    "Panamera Turbo S": ["2012", "2013", "2014", "2015", "2016"],
    "Panamera Turbo S Executive": ["2014", "2015", "2016"],
    "911 GT2 RS": ["2018", "2019"],
    "Macan T": ["2023", "2024"],
    "Panamera 4 E-Hybrid": ["2018", "2019", "2020"],
    "Panamera 4 E-Hybrid Executive": ["2018", "2019", "2020"],
    "Panamera 4 E-Hybrid Sport Turismo": ["2018", "2019", "2020"],
    "Panamera 4 Sport Turismo": ["2018", "2019", "2020"],
    "Panamera 4S Sport Turismo": ["2018", "2019", "2020"],
    "911 Base": ["1965", "1966", "1967", "1968"],
    "912 Base": ["1965", "1966", "1967", "1968", "1969"],
    "944 S": ["1987", "1988"],
    "944 S2": ["1989", "1990", "1991"],
    "944 Turbo": ["1986", "1987", "1988", "1989"],
    "968 Base": ["1992", "1993", "1994", "1995"],
    "928 Base": ["1978", "1979", "1980", "1981", "1982", "1990", "1991"],
    "928 S4": ["1987", "1988", "1989"],
    "930 Turbo": ["1978", "1979"],
    "928 S": ["1983", "1984", "1985", "1986"],
    "911 RS America": ["1993", "1994"],
    "911 Targa": ["1996", "1997", "1998"],
    "928 GT": ["1990", "1991"],
    "928 GTS": ["1993", "1994", "1995"],
    "Carrera GT Base": ["2004", "2005"],
    "356C Base": ["1964", "1965"],
    "356SC Base": ["1964", "1965"],
    "Taycan 4S": ["2020", "2021"],
    "Taycan Turbo": ["2020", "2021"],
    "Taycan Turbo S": ["2020", "2021"],
  },
  Pontiac: {
    "Vibe AWD": ["2009", "2010"],
    "Vibe Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Vibe GT": ["2003", "2004", "2005", "2006", "2009", "2010"],
    "GTO Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "2004",
      "2005",
      "2006",
    ],
    "Firebird Formula": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Firebird Trans Am": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Catalina Base": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "Catalina Brougham": ["1971", "1972"],
    "Catalina Safari": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "Firebird Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Firebird Esprit": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "Firebird S/E": ["1982", "1983", "1984", "1985", "1986"],
    "Firebird Trans Am GTA": ["1989", "1990", "1991", "1992"],
    "Bonneville Base": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Bonneville Custom": ["1959", "1960", "1961", "1962"],
    "Catalina Ventura": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
    ],
    "Firebird 400": ["1967", "1968", "1969"],
    "Firebird Sprint": ["1967", "1968", "1969"],
    "Grand Prix Base": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Ventura Base": [
      "1960",
      "1961",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
    ],
    "Grand Prix GT": [
      "1991",
      "1992",
      "1993",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2005",
      "2006",
      "2007",
    ],
    "Grand Prix GTP": [
      "1992",
      "1993",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Grand Prix SE": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "G8 Base": ["2008", "2009"],
    "G8 GT": ["2008", "2009"],
    "Aztek Base": ["2001", "2002", "2003", "2004", "2005"],
    "Aztek Rally": ["2004", "2005"],
    "Bonneville GXP": ["2004", "2005"],
    "Bonneville SE": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Bonneville SLE": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "Bonneville SSE": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Bonneville SSEi": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Grand Am GT": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Grand Am GT1": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "Grand Am SE": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Grand Am SE1": ["2000", "2001", "2002", "2003", "2004"],
    "Grand Am SE2": ["2003", "2004"],
    "Grand Prix LE": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Grand Prix STE": ["1990", "1991", "1992", "1993"],
    "Montana Base": ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "Sunbird GT": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Sunbird LE Value Leader": ["1992", "1993"],
    "Sunbird SE": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Sunfire GT": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Sunfire SE": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Trans Sport Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Tempest Base": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
    ],
    "Tempest LeMans": ["1961", "1962"],
    "Tempest Safari": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
    ],
    "6000 Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "6000 LE": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "6000 SE": ["1986", "1987", "1988"],
    "6000 STE": ["1983", "1984", "1985", "1986", "1987", "1988", "1989"],
    "Bonneville LE": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Fiero Base": ["1984", "1985"],
    "Fiero GT": ["1985", "1986", "1987", "1988"],
    "Fiero SE": ["1984", "1985", "1986", "1987"],
    "Fiero Sport": ["1984", "1985", "1986", "1987", "1988"],
    "Fiero Value Leader": ["1986", "1987", "1988"],
    "Grand Am Base": [
      "1973",
      "1974",
      "1975",
      "1978",
      "1979",
      "1980",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Grand Am LE": ["1985", "1986", "1987", "1988", "1989", "1990", "1991"],
    "Grand Prix Brougham": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "J2000 Base": ["1982", "1983"],
    "J2000 LE": ["1982", "1983"],
    "J2000 SE": ["1982", "1983"],
    "LeMans GSE": ["1989", "1990"],
    "LeMans LE": ["1989", "1990", "1991", "1992"],
    "LeMans SE": ["1988", "1989", "1992", "1993"],
    "LeMans Value Leader": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "Parisienne Base": ["1983", "1984", "1985", "1986"],
    "Parisienne Brougham": ["1983", "1984", "1985", "1986"],
    "Sunbird Base": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1986",
      "1987",
      "1988",
    ],
    "Sunbird LE": ["1989", "1990", "1991"],
    "Grand Prix GXP": ["2005", "2006", "2007", "2008"],
    "G6 Base": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "G6 GT": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "G6 GTP": ["2006", "2007"],
    "G6 GXP": ["2008", "2009"],
    "GTO The Judge": ["1970", "1971"],
    "LeMans Base": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "LeMans Safari": [
      "1969",
      "1970",
      "1973",
      "1974",
      "1975",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "LeMans Sport": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
    ],
    "Tempest Custom": ["1964", "1965", "1966", "1967", "1968", "1969"],
    "Ventura Custom": ["1973", "1974", "1975"],
    "Bonneville Brougham": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Bonneville Safari": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "Grand Prix LJ": ["1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    "Safari Base": ["1987", "1988", "1989"],
    "LeMans Luxury": ["1972", "1973", "1974"],
    "Grand Safari Base": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Phoenix Base": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
    ],
    "Phoenix LJ": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "Phoenix SJ": ["1978", "1979", "1982", "1983"],
    "Ventura SJ": ["1975", "1976", "1977"],
    "G3 Base": ["2009", "2010"],
    "G5 Base": ["2007", "2008", "2009"],
    "G5 GT": ["2007", "2008", "2009"],
    "Firebird 350": ["1968", "1969"],
    "Firebird HO": ["1967", "1968"],
    "Grand LeMans Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "Grand Prix SJ": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Grandville Base": ["1971", "1972", "1973", "1974"],
    "Montana SV6": ["2005", "2006"],
    "Grand LeMans Safari": ["1977", "1978", "1979", "1980", "1981"],
    "Torrent GXP": ["2008", "2009"],
    "6000 Special Edition": ["1989", "1990", "1991"],
    "J2000 Sunbird Base": ["1984", "1985"],
    "J2000 Sunbird LE": ["1984", "1985"],
    "J2000 Sunbird SE": ["1984", "1985"],
    "Solstice Base": ["2006", "2007", "2008", "2009"],
    "Solstice GXP": ["2007", "2008", "2009"],
    "Torrent Base": ["2006", "2007", "2008", "2009"],
    "Catalina 2+2": ["1964", "1965", "1966", "1967"],
    "Astre Base": ["1975", "1976", "1977"],
    "Astre Custom": ["1975", "1976"],
    "Sunbird Safari": ["1978", "1979"],
    "T1000 Base": ["1981", "1982", "1983", "1984", "1985", "1986", "1987"],
    "Chieftain Base": ["1955", "1956", "1957", "1958"],
    "Executive Base": ["1967", "1968", "1969", "1970"],
    "Executive Safari": ["1967", "1968", "1969", "1970"],
    "Star Chief Base": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
    ],
    "Star Chief Custom": ["1955", "1956", "1957"],
    "Super Chief Base": ["1957", "1958"],
  },
  Scion: {
    "tC Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "xB Base": [
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "FR-S Base": ["2013", "2014", "2015", "2016"],
    "xA Base": ["2004", "2005", "2006"],
    "tC Spec": ["2007", "2008"],
    "xD Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "iQ Base": ["2012", "2013", "2014", "2015"],
  },
  Cadillac: {
    "Escalade Base": [
      "1999",
      "2000",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Escalade Hybrid": ["2009", "2010", "2011", "2012", "2013"],
    "Escalade Hybrid Platinum": ["2010", "2011", "2012", "2013"],
    "Escalade Luxury": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Escalade Platinum": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Escalade Premium": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Escalade Premium Luxury": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Escalade ESV Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Escalade ESV Luxury": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Escalade ESV Platinum": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Escalade ESV Premium": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Escalade ESV Premium Luxury": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Escalade EXT Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Escalade EXT Luxury": ["2011", "2012", "2013"],
    "Escalade EXT Premium": ["2011", "2012", "2013"],
    "CT6 Base": ["2016", "2017", "2018"],
    "CT6 Luxury": ["2016", "2017", "2018", "2019", "2020"],
    "CTS V": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "ATS Luxury": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "ATS V": ["2016", "2017", "2018", "2019"],
    "CT6 Platinum": ["2016", "2017", "2018", "2019", "2020"],
    "CT6 Premium Luxury": ["2016", "2017", "2018", "2019", "2020"],
    "CT6 V": ["2019", "2020"],
    "CTS Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "CTS Luxury": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "CTS Premium Luxury": ["2017", "2018", "2019"],
    "CTS Vsport": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "CTS Vsport Premium Luxury": ["2017", "2018", "2019"],
    "ATS Base": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "Allante Base": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "Allante Value Leader": ["1990", "1991", "1992", "1993"],
    "Catera Base": ["1997", "1998", "1999", "2000", "2001"],
    "Catera Sport": ["1999", "2000", "2001"],
    "Commercial Chassis Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Commercial Chassis Brougham": ["1992", "1993", "1994", "1995", "1996"],
    "DeVille Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "DeVille Concours": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "DeVille d'Elegance": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "DeVille DHS": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "DeVille DTS": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "DeVille Protection Series": ["2004", "2005"],
    "DeVille Touring": ["1986", "1987", "1991", "1992", "1993"],
    "Eldorado Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Eldorado ESC": ["1998", "1999", "2000", "2001", "2002"],
    "Eldorado ETC": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Eldorado Touring": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Fleetwood Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Fleetwood Brougham": [
      "1968",
      "1969",
      "1970",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Seville Base": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Seville SLS": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Seville STS": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "SRX Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "XLR Base": ["2004", "2005", "2006", "2007", "2008"],
    "Cimarron Base": ["1982", "1983", "1984", "1985", "1986", "1987", "1988"],
    "Cimarron d'Oro": ["1984", "1985", "1986"],
    "Eldorado Biarritz": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Fleetwood 60 Special": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Fleetwood 75": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1985",
      "1986",
      "1987",
    ],
    "Fleetwood 75 Formal": ["1985", "1986", "1987"],
    "Fleetwood Brougham Commercial Chassis": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Fleetwood d'Elegance": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "CTS Performance": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "CTS Premium": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "Brougham Base": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Brougham d'Elegance": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "DeVille Cabriolet": [
      "1975",
      "1976",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "Eldorado Cabriolet": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "Fleetwood Brougham d'Elegance": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Fleetwood Formal": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
    ],
    "Seville Elegante": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "DeVille Phaeton": ["1978", "1979"],
    "Escalade Premium Luxury Platinum": ["2021", "2022", "2023", "2024"],
    "Escalade Sport": ["2021", "2022", "2023", "2024"],
    "Escalade Sport Platinum": ["2021", "2022", "2023", "2024"],
    "Escalade V": ["2023", "2024"],
    "Escalade ESV Premium Luxury Platinum": ["2021", "2022", "2023", "2024"],
    "Escalade ESV Sport": ["2021", "2022", "2023", "2024"],
    "Escalade ESV Sport Platinum": ["2021", "2022", "2023", "2024"],
    "Escalade ESV V": ["2023", "2024"],
    "STS Base": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "STS Platinum": ["2008", "2009"],
    "STS V": ["2006", "2007", "2008", "2009"],
    "XTS Base": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "XTS Livery": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "XTS Luxury": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "XTS Platinum": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "XTS Premium": ["2013", "2014", "2015", "2016"],
    "XTS Premium Luxury": ["2017", "2018", "2019"],
    "XTS Vsport Platinum": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "XTS Vsport Premium": ["2014", "2015", "2016"],
    "ATS Performance": ["2013", "2014", "2015", "2016"],
    "ATS Premium": ["2013", "2014", "2015", "2016"],
    "ATS Premium Luxury": ["2017", "2018", "2019"],
    "ATS Premium Performance": ["2017", "2018", "2019"],
    "SRX Luxury": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "SRX Performance": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "SRX Premium": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "XT5 Base": ["2017", "2018", "2019"],
    "XT5 Livery": ["2021", "2022", "2023", "2024"],
    "XT5 Luxury": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "XT5 Platinum": ["2017", "2018", "2019"],
    "XT5 Premium Luxury": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "XT5 Sport": ["2020", "2021", "2022", "2023", "2024"],
    "XT6 Luxury": ["2021", "2022", "2023", "2024"],
    "XT6 Premium Luxury": ["2020", "2021", "2022", "2023", "2024"],
    "XT6 Sport": ["2020", "2021", "2022", "2023", "2024"],
    "Seville Opera": ["1977", "1978"],
    "DTS Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "CT6 Plug-In": ["2017", "2018"],
    "CTS Vsport Premium": ["2014", "2015", "2016"],
    "XLR Platinum": ["2008", "2009"],
    "XLR V": ["2006", "2007", "2008", "2009"],
    "XT4 Luxury": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "XT4 Premium Luxury": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "XT4 Sport": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "CT4 V": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "CT5 V": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "CT4 Luxury": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "CT4 Premium Luxury": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "CT4 Sport": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "CT5 Luxury": ["2020", "2021", "2022", "2023", "2024"],
    "CT5 Premium Luxury": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "CT5 Sport": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "DTS Livery": ["2010", "2011"],
    "DTS Luxury": ["2007", "2008", "2009", "2010", "2011"],
    "DTS Platinum": ["2008", "2009", "2010", "2011"],
    "DTS Premium": ["2010", "2011"],
    "ELR Base": ["2014", "2015", "2016"],
    "CT4 V Blackwing": ["2022", "2023", "2024", "2025"],
    "CT5 V Blackwing": ["2022", "2023", "2024", "2025"],
    "Calais Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "Fleetwood 60 Special Brougham": ["1973", "1974", "1975", "1976"],
    "Eldorado Brougham": ["1959", "1960"],
    "Series 60 Fleetwood Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
    ],
    "Series 62 Base": ["1958", "1959", "1960", "1961", "1962", "1963"],
    "Series 75 Fleetwood Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
    ],
  },
  "Mercedes-Benz": {
    "CLA250 4Matic": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "CLA250 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GLA250 4Matic": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GLA250 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "A220 4Matic": ["2019", "2020", "2021", "2022"],
    "A220 Base": ["2019", "2020", "2021", "2022"],
    "A35 AMG 4Matic": ["2020", "2021", "2022"],
    "AMG GT 43 Base": ["2021", "2022", "2023"],
    "AMG GT 53 Base": ["2019", "2020", "2021", "2022", "2023"],
    "C300 4Matic": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "C300 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "CLA35 AMG 4Matic": ["2020", "2021", "2022", "2023"],
    "CLS450 4Matic": ["2019", "2020", "2021", "2022", "2023"],
    "CLS450 Base": ["2019", "2020", "2021", "2022", "2023"],
    "CLS53 AMG 4Matic": ["2019", "2020", "2021", "2022", "2023"],
    "E320 Bluetec": ["2007", "2008", "2009"],
    "E320 CDI": ["2005", "2006"],
    "E350 4Matic": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "E350 Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "E350 Bluetec": ["2011", "2012", "2013"],
    "E450 4Matic": ["2019", "2020", "2021", "2022", "2023"],
    "E450 Base": ["2019", "2020", "2021", "2022", "2023"],
    "E53 AMG 4Matic": ["2019", "2020", "2021", "2022", "2023"],
    "G550 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GL350 Bluetec 4Matic": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "GLA35 AMG 4Matic": ["2021", "2022", "2023"],
    "GLB250 4Matic": ["2020", "2021", "2022", "2023", "2024"],
    "GLB250 Base": ["2020", "2021", "2022", "2023", "2024"],
    "GLB35 AMG 4Matic": ["2021", "2022", "2023", "2024"],
    "GLC300 4Matic": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GLC300 Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GLE350 4Matic": [
      "2016",
      "2017",
      "2018",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GLE350 Base": ["2016", "2017", "2018", "2020", "2021", "2022", "2023"],
    "GLE450 4Matic": ["2020", "2021", "2022", "2023", "2024"],
    "GLE53 AMG 4Matic": ["2021", "2022", "2023"],
    "GLE53 AMG 4Matic+": ["2023", "2024"],
    "GLE580 4Matic": ["2020", "2021", "2022", "2023", "2024"],
    "GLK250 Bluetec 4Matic": ["2013", "2014", "2015"],
    "GLS450 4Matic": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "GLS580 4Matic": ["2020", "2021", "2022", "2023", "2024"],
    "Maybach GLS600 4Matic": ["2021", "2022", "2023", "2024"],
    "Maybach S560 4Matic": ["2018", "2019", "2020"],
    "Maybach S580 4Matic": ["2021", "2022", "2023", "2024"],
    "Maybach S680 4Matic": ["2022", "2023", "2024"],
    "ML320 CDI": ["2007", "2008"],
    "ML350 4Matic": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "ML350 Base": [
      "2003",
      "2004",
      "2005",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
    ],
    "ML350 Bluetec 4Matic": ["2010", "2011", "2012", "2013", "2014"],
    "S350 Bluetec 4Matic": ["2012", "2013"],
    "S500 4Matic": ["2003", "2004", "2005", "2006", "2021", "2022", "2023"],
    "S560 4Matic": ["2018", "2019", "2020", "2021"],
    "S560 Base": ["2018", "2019", "2020", "2021"],
    "S580 4Matic": ["2021", "2022", "2023", "2024"],
    "S580e 4Matic": ["2023", "2024"],
    "Sprinter 2500 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sprinter 3500 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sprinter 3500XD Base": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "CLS63 AMG S 4Matic": ["2014", "2015", "2016", "2017", "2018"],
    "E63 AMG 4Matic": ["2014", "2015"],
    "E63 AMG S 4Matic": [
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "190D 2.2": ["1984", "1985"],
    "190D 2.5": ["1986", "1987", "1988", "1989"],
    "190E 2.3": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1991",
      "1992",
      "1993",
    ],
    "190E 2.3-16": ["1986", "1987"],
    "190E 2.6": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "260E Base": ["1987", "1988", "1989"],
    "300CE Base": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "300D 2.5": ["1990", "1991", "1992", "1993"],
    "300E 2.6": ["1990", "1991", "1992"],
    "300E Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "300TE Base": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "E320 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "E420 Base": ["1994", "1995"],
    "E300 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2017",
      "2018",
      "2019",
    ],
    "E320 4Matic": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "E430 4Matic": ["2000", "2001", "2002"],
    "E430 Base": ["1998", "1999", "2000", "2001", "2002"],
    "E55 AMG Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "CLA45 AMG 4Matic": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GLA45 AMG 4Matic": ["2015", "2016", "2017", "2018", "2019"],
    "S400 Hybrid": ["2010", "2011", "2012", "2013"],
    "S550 4Matic": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "S550 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "S600 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
    ],
    "S63 AMG Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "S65 AMG Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "B Electric Drive Base": ["2014", "2015"],
    "B250e Base": ["2016", "2017"],
    "C230 Base": ["1997", "1998"],
    "C230 Kompressor": ["1999", "2000", "2002", "2003", "2004", "2005"],
    "C230 Sport": ["2006", "2007"],
    "C240 4Matic": ["2003", "2004", "2005"],
    "C240 Base": ["2001", "2002", "2003", "2004", "2005"],
    "C250 Base": ["2012", "2013", "2014", "2015"],
    "C250 Luxury": ["2012", "2013", "2014"],
    "C250 Sport": ["2012", "2013", "2014"],
    "C280 4Matic": ["2006", "2007"],
    "C280 Base": ["1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    "C280 Luxury": ["2006", "2007"],
    "C300 4Matic Luxury": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "C300 4Matic Sport": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "C300 Luxury": ["2008", "2009", "2010", "2011"],
    "C300 Sport": ["2008", "2009", "2010", "2011"],
    "C32 AMG Base": ["2002", "2003", "2004"],
    "C320 4Matic": ["2003", "2004", "2005"],
    "C320 Base": ["2001", "2002", "2003", "2004", "2005"],
    "C350 4Matic": ["2006", "2007", "2012", "2013", "2014", "2015"],
    "C350 Base": ["2012", "2013", "2014", "2015"],
    "C350 Luxury": ["2006", "2007"],
    "C350 Sport": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "C350e Base": ["2016", "2017", "2018"],
    "C43 AMG Base": ["1998", "1999", "2000"],
    "C55 AMG Base": ["2005", "2006"],
    "C63 AMG Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "C63 AMG S Base": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "CL500 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "CL55 AMG Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "CL550 4Matic": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "CL550 Base": ["2007", "2008"],
    "CL600 Base": [
      "1998",
      "1999",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "CL63 AMG Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "CL65 AMG Base": [
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "CLK320 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "CLK350 Base": ["2006", "2007", "2008", "2009"],
    "CLK430 Base": ["1999", "2000", "2001", "2002", "2003"],
    "CLK500 Base": ["2003", "2004", "2005", "2006"],
    "CLK55 AMG Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "CLK550 Base": ["2007", "2008", "2009"],
    "CLK63 AMG Base": ["2007", "2008"],
    "CLS550 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "CLS63 AMG Base": ["2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "E500 4Matic": ["2004", "2005", "2006"],
    "E500 Base": ["2003", "2004", "2005", "2006"],
    "E550 4Matic": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "E550 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "E63 AMG Base": ["2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "GL320 CDI": ["2007", "2008"],
    "GL450 4Matic": ["2015", "2016"],
    "GL450 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "GL550 4Matic": ["2013", "2014", "2015", "2016"],
    "GL550 Base": ["2008", "2009", "2010", "2011", "2012"],
    "GL63 AMG Base": ["2013", "2014", "2015", "2016"],
    "GLE400 4Matic": ["2016", "2017"],
    "GLE550e 4Matic": ["2016", "2017", "2018"],
    "GLE63 AMG Base": ["2016", "2017", "2018", "2019"],
    "GLE63 AMG S Base": ["2016", "2017", "2018", "2019"],
    "GLK350 4Matic": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "GLK350 Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Metris Base": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "ML320 Base": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "ML430 Base": ["1999", "2000", "2001"],
    "ML450 Hybrid 4Matic": ["2010", "2011"],
    "ML500 Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "ML55 AMG Base": ["2000", "2001", "2002", "2003"],
    "ML550 Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "ML63 AMG Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "R320 CDI": ["2007", "2008"],
    "R350 4Matic": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "R350 Base": ["2008", "2009"],
    "R350 Bluetec 4Matic": ["2010", "2011", "2012"],
    "R500 Base": ["2006", "2007"],
    "S320 LWB": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "S320 SWB": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "S420 Base": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "S430 4Matic": ["2003", "2004", "2005", "2006"],
    "S430 Base": ["2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "S500 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "S500 Guard": ["2000", "2001"],
    "S55 AMG Base": ["2001", "2002", "2004", "2005", "2006"],
    "SL400 Base": ["2015", "2016"],
    "SL500 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "SL55 AMG Base": ["2004", "2005", "2006", "2007", "2008"],
    "SL550 Base": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "SL600 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "SL63 AMG Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "SL65 AMG Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "SLK230 Kompressor": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "SLK250 Base": ["2012", "2013", "2014", "2015"],
    "SLK280 Base": ["2006", "2007", "2008"],
    "SLK300 Base": ["2009", "2010", "2011"],
    "SLK32 AMG Base": ["2002", "2003", "2004"],
    "SLK320 Base": ["2001", "2002", "2003", "2004"],
    "SLK350 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "SLK55 AMG Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "AMG GT Base": ["2017", "2018", "2019", "2020", "2021"],
    "AMG GT C Base": ["2018", "2019", "2020", "2021"],
    "G55 AMG Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "GLC63 AMG 4Matic": ["2018", "2019", "2020", "2021"],
    "GLC63 AMG S 4Matic": ["2018", "2019", "2020", "2021"],
    "CLS400 4Matic": ["2015", "2016", "2017"],
    "CLS400 Base": ["2015", "2016", "2017"],
    "CLS550 4Matic": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "E250 Bluetec": ["2014", "2015", "2016"],
    "E250 Bluetec 4Matic": ["2014", "2015", "2016"],
    "E400 4Matic": ["2015", "2016", "2017", "2018"],
    "E400 Base": ["2015", "2016", "2017", "2018"],
    "E400 Hybrid": ["2013", "2014", "2015"],
    "AMG GT 63 Base": ["2019", "2020", "2021"],
    "AMG GT 63 S Base": ["2019", "2020", "2021"],
    "AMG GT R Base": ["2018", "2019", "2020", "2021"],
    "AMG GT S Base": ["2016", "2017", "2018", "2019"],
    "G63 AMG Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "GLE43 AMG Base": ["2017", "2018", "2019"],
    "GLS550 4Matic": ["2017", "2018", "2019"],
    "GLS63 AMG Base": ["2017", "2018", "2019"],
    "Maybach S650 Base": ["2018", "2019", "2020"],
    "S63 AMG 4Matic": ["2018", "2019", "2020", "2021"],
    "SLS AMG Base": ["2011", "2012"],
    "SLS AMG GT": ["2013", "2014", "2015"],
    "Sprinter 1500 Base": ["2019", "2020", "2021", "2022", "2023"],
    "G500 Base": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "G550 4x4 Base": ["2017", "2018"],
    "G65 AMG Base": ["2016", "2017", "2018"],
    "GLE300d 4Matic": ["2016", "2017"],
    "Maybach S600 Base": ["2016", "2017"],
    "S550e Base": ["2015", "2016", "2017"],
    "S560e Base": ["2019", "2020"],
    "SL450 Base": ["2017", "2018", "2019", "2020"],
    "SLC300 Base": ["2017", "2018", "2019", "2020"],
    "SLC43 AMG Base": ["2017", "2018", "2019", "2020"],
    "300SEL Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "600 Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
    ],
    "600 Pullman": ["1964", "1965", "1966", "1967", "1968", "1969", "1970"],
    "240D Base": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "300CD Base": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "300D Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "300SD Base": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1992",
      "1993",
    ],
    "300SDL Base": ["1986", "1987"],
    "300SE Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "300SL Base": ["1990", "1991", "1992", "1993"],
    "300TD Base": ["1979", "1980", "1981", "1982", "1983", "1984", "1985"],
    "350SDL Base": ["1990", "1991"],
    "380SL Base": ["1981", "1982", "1983", "1984", "1985"],
    "400E Base": ["1992", "1993"],
    "420SEL Base": ["1986", "1987", "1988", "1989", "1990", "1991"],
    "500E Base": ["1992", "1993"],
    "500SEL Base": ["1984", "1985", "1992", "1993"],
    "500SL Base": ["1990", "1991", "1992", "1993"],
    "560SEC Base": ["1986", "1987", "1988", "1989", "1990", "1991"],
    "560SEL Base": ["1986", "1987", "1988", "1989", "1990", "1991"],
    "560SL Base": ["1986", "1987", "1988", "1989"],
    "600SEL Base": ["1992", "1993"],
    "C220 Base": ["1994", "1995", "1996"],
    "C36 AMG Base": ["1995", "1996", "1997"],
    "E300 4Matic": ["2017", "2018", "2019"],
    "E43 AMG 4Matic": ["2017", "2018"],
    "S350 Base": ["1994", "1995"],
    "SL320 Base": ["1994", "1995", "1996", "1997"],
    "300E 4Matic": ["1990", "1991", "1992", "1993"],
    "300TE 4Matic": ["1990", "1991", "1992", "1993"],
    "380SE Base": ["1984", "1985"],
    "380SEC Base": ["1982", "1983"],
    "380SEL Base": ["1981", "1982", "1983"],
    "500SEC Base": ["1984", "1985"],
    "C43 AMG 4Matic": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "GLC43 AMG 4Matic": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "SLR McLaren Base": ["2005", "2006", "2007", "2008", "2009"],
    "220 Base": ["1968", "1969", "1970", "1971", "1972", "1973"],
    "280CE Base": ["1978", "1979", "1980", "1981"],
    "280E Base": ["1977", "1978", "1979", "1980", "1981"],
    "280S Base": ["1968", "1969", "1970", "1971", "1975", "1976"],
    "280SE Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "GLC350e 4Matic": ["2018", "2019", "2020"],
    "220D Base": ["1968", "1969", "1970", "1971", "1972", "1973"],
    "230 Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "280 Base": ["1973", "1974", "1975", "1976"],
    "280C Base": ["1973", "1974", "1975", "1976"],
    "450SE Base": ["1973", "1974", "1975", "1976"],
    "450SEL 6.9": ["1977", "1978", "1979"],
    "450SEL Base": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "450SL Base": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "450SLC Base": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "190C Base": ["1963", "1964", "1965"],
    "200 Base": ["1966", "1967", "1968"],
    "230SL Base": ["1963", "1964", "1965", "1966", "1967"],
    "250 Base": ["1968", "1969", "1970", "1971", "1972", "1973"],
    "250C Base": ["1969", "1970", "1971", "1972", "1973"],
    "250S Base": ["1966", "1967"],
    "250SE Base": ["1966", "1967"],
    "280SEL Base": ["1968", "1969", "1970", "1971", "1972", "1973"],
    "280SL Base": ["1968", "1969", "1970", "1971"],
    "AMG GT R Pro Base": ["2020", "2021"],
    "S450 4Matic": ["2018", "2019", "2020"],
    "S450 Base": ["2018", "2019", "2020"],
    "200D Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
    ],
    "SL55 AMG 4Matic": ["2022", "2023"],
    "SL63 AMG 4Matic": ["2022", "2023"],
    "230S Base": ["1966", "1967", "1968", "1969"],
    "250SEC Base": ["1966", "1967", "1968"],
    "250SL Base": ["1966", "1967", "1968"],
    "280SE 4.5": ["1972", "1973"],
    "350SL Base": ["1972", "1973"],
  },
  Geo: {
    "Prizm Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Prizm GSi": ["1990", "1991", "1992"],
    "Prizm LSi": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "Metro Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Metro LSi": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Tracker Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Tracker LSi": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Storm 2+2": ["1990", "1991", "1992", "1993"],
    "Storm 2+2 GSi": ["1990", "1991", "1992", "1993"],
    "Storm Base": ["1990", "1991", "1992", "1993"],
    "Metro XFi": ["1989", "1990", "1991", "1992", "1993", "1994"],
  },
  Lotus: {
    "Elise Base": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "Elise SC": ["2008", "2009", "2010", "2011"],
    "Exige S": ["2007", "2008", "2009"],
    "Exige S 240": ["2008", "2009", "2010", "2011"],
    "Evora 400": ["2016", "2017", "2018", "2019"],
    "Evora Base": ["2010", "2011", "2012", "2013", "2014"],
    "Evora S": ["2013", "2014"],
    "Evora Sport 410": ["2018", "2019"],
    "Esprit Base": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
    ],
    "Esprit S3": ["1985", "1986", "1987"],
    "Esprit Turbo": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Europa Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
    ],
    "Europa S1": ["1967", "1968", "1969", "1970"],
    "Elan 2": ["1967", "1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "Elan 2S": ["1969", "1970"],
    "Elan 2S 130": ["1972", "1973", "1974"],
    "Elan Base": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1990",
      "1991",
      "1992",
    ],
    "Elan S4": ["1968", "1969", "1970", "1971"],
    "Elan Sprint": ["1971", "1972", "1973", "1974"],
    "Europa S2": ["1969", "1970", "1971", "1972"],
    "Europa Special": ["1971", "1972", "1973", "1974"],
    "Europa Twin": ["1971", "1972", "1973", "1974"],
    "Seven Base": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
    ],
    "Esprit S4": ["1994", "1995"],
    "Esprit Turbo SE": ["1989", "1990", "1991", "1992", "1993"],
    "Esprit V8": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
  },
  Eagle: {
    "Summit Base": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Summit DL": ["1989", "1990", "1992", "1993", "1994", "1995", "1996"],
    "Summit ES": ["1990", "1991", "1992", "1993", "1994"],
    "Summit ESi": ["1994", "1995", "1996"],
    "Summit LX": ["1989", "1990", "1992", "1993", "1994", "1995", "1996"],
    "Talon Base": ["1990", "1991", "1992", "1996", "1997", "1998"],
    "Talon DL": ["1993", "1994"],
    "Talon ES": ["1993", "1994"],
    "Talon ESi": ["1995", "1996", "1997", "1998"],
    "Talon TSi": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Medallion DL": ["1988", "1989"],
    "Medallion LX": ["1988", "1989"],
    "Premier ES": ["1988", "1989", "1990", "1991", "1992"],
    "Premier ES Limited": ["1990", "1991", "1992"],
    "Premier LX": ["1988", "1989", "1990", "1991", "1992"],
    "Vision ESi": ["1993", "1994", "1995", "1996", "1997"],
    "Vision TSi": ["1993", "1994", "1995", "1996", "1997"],
  },
  Mercury: {
    "Tracer GS": ["1997", "1998", "1999"],
    "Tracer LS": ["1997", "1998", "1999"],
    "Tracer Trio": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Capri Base": [
      "1966",
      "1967",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Capri XR2": ["1991", "1992", "1993", "1994"],
    "Tracer Base": [
      "1988",
      "1989",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Cougar Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1977",
      "1978",
      "1979",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Cougar Boss 302": ["1969", "1970"],
    "Cougar Boss 429": ["1969", "1970"],
    "Cougar Cobra Jet": ["1969", "1970"],
    "Cougar XR-7": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Mariner Base": ["2008", "2009", "2010", "2011"],
    "Mariner Hybrid": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Mariner Premier": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "Mountaineer Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Capri GS": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "Colony Park GS": ["1987", "1988", "1989", "1990", "1991"],
    "Colony Park LS": ["1987", "1988", "1989", "1990", "1991"],
    "Cougar LS": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Cougar V6": ["1999", "2000", "2001", "2002"],
    "Grand Marquis Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Grand Marquis Colony Park": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Grand Marquis GS": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Grand Marquis LS": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Lynx Base": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "Lynx GL": ["1981", "1982", "1983", "1984", "1985"],
    "Lynx GS": ["1981", "1982", "1983", "1984", "1985", "1986", "1987"],
    "Lynx LS": ["1981", "1982", "1983", "1984"],
    "Lynx LTS": ["1983", "1984"],
    "Lynx RS": ["1981", "1982", "1983", "1984"],
    "Lynx XR3": ["1985", "1986", "1987"],
    "Mariner Convenience": ["2006", "2007"],
    "Mariner Luxury": ["2006", "2007"],
    "Marquis Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Marquis Brougham": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "Mystique GS": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Mystique LS": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Sable GS": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Sable LS": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Topaz Base": ["1984", "1985", "1986"],
    "Topaz GS": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Topaz GS AWD": ["1987", "1988", "1989", "1990", "1991"],
    "Topaz LS": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Topaz LS AWD": ["1987", "1988", "1989", "1990", "1991"],
    "Topaz LTS": ["1988", "1989", "1990", "1991", "1992"],
    "Topaz LTS AWD": ["1990", "1991"],
    "Topaz Sport": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Topaz Sport AWD": ["1987", "1988", "1989", "1990", "1991"],
    "Topaz XR5": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Topaz XR5 AWD": ["1990", "1991"],
    "Tracer LTS": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Marauder Base": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "2003",
      "2004",
    ],
    "Milan Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Milan Premier": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Montego Luxury": ["2005", "2006", "2007"],
    "Montego Premier": ["2005", "2006", "2007"],
    "Monterey Premier": ["2004", "2005"],
    "Colony Park Base": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Commuter Base": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
    ],
    "Custom Base": ["1954", "1955", "1956"],
    "Medalist Base": ["1956", "1957"],
    "Montclair Base": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
    ],
    "Monterey Base": [
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Comet 404": ["1964", "1965"],
    "Comet Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
    ],
    "Comet Custom": ["1962", "1963"],
    "Comet S-22": ["1961", "1962", "1963"],
    "Monarch Base": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "Monarch Ghia": ["1975", "1976", "1977"],
    "Capri Black Magic": ["1982", "1983"],
    "Capri L": ["1982", "1983"],
    "Capri RS": ["1982", "1983", "1984", "1985"],
    "Mountaineer Convenience": ["2005", "2006"],
    "Mountaineer Luxury": ["2005", "2006"],
    "Mountaineer Premier": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Capri Ghia": ["1979", "1980"],
    "Bobcat Base": ["1977", "1978", "1979", "1980"],
    "Bobcat Runabout": ["1976", "1977", "1978", "1979", "1980"],
    "Bobcat Villager": ["1976", "1977", "1978", "1979", "1980"],
    "Zephyr Base": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "Zephyr GS": ["1982", "1983"],
    "Zephyr Z7": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "Monterey Luxury": ["2005", "2006", "2007"],
    "Caliente Base": ["1964", "1965", "1966", "1967"],
    "Cyclone Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
    ],
    "Cyclone Spoiler": ["1969", "1970", "1971"],
    "Marauder X-100": ["1969", "1970"],
    "Meteor Base": ["1961", "1962", "1963"],
    "Montego Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "Montego MX": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "Monterey Custom": [
      "1962",
      "1963",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Monterey S-55": ["1966", "1967"],
    "Park Lane Base": [
      "1958",
      "1959",
      "1960",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
    ],
    "Villager Base": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Voyager Base": ["1966", "1967"],
    "Cyclone GT": ["1970", "1971"],
    "Montego GT": ["1972", "1973"],
    "Montego MX Brougham": ["1970", "1971", "1972", "1973", "1974"],
    "Montego Villager": ["1970", "1971", "1972", "1973", "1974", "1975"],
    "Marquis Colony Park": ["1975", "1976"],
    "Villager Estate": ["1999", "2000", "2001", "2002"],
    "Villager GS": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Villager LS": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Villager Nautica": ["1994", "1995", "1996", "1997", "1998"],
    "Villager Sport": ["1999", "2000", "2001", "2002"],
    "Sable LS Premium": ["2000", "2001", "2002", "2003", "2004"],
    "Milan Hybrid": ["2010", "2011"],
    "Lynx L": ["1985", "1986", "1987"],
    "Sable Base": ["2008", "2009"],
    "Sable Premier": ["2008", "2009"],
    "LN7 Base": ["1982", "1983"],
    "Comet 202": ["1964", "1965"],
    "Meteor Custom": ["1962", "1963"],
    "Meteor S-33": ["1962", "1963"],
  },
  Oldsmobile: {
    "Cutlass Base": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1997",
      "1998",
    ],
    "Cutlass S": ["1971", "1972", "1973", "1974", "1975", "1976", "1977"],
    "Cutlass Brougham": ["1980", "1981"],
    "Cutlass Holiday": ["1964", "1965", "1966", "1967"],
    "Cutlass LS": ["1980", "1981"],
    "Bravada Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Intrigue GL": ["1998", "1999", "2000", "2001", "2002"],
    "Intrigue GLS": ["1998", "1999", "2000", "2001", "2002"],
    "Intrigue GX": ["1999", "2000", "2001", "2002"],
    "88 Royale": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "88 Royale LS": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "98 Regency": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1992",
      "1993",
      "1994",
    ],
    "98 Regency Elite": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "98 Touring": ["1991", "1992", "1993"],
    "Achieva S": ["1992", "1993", "1994", "1995", "1996"],
    "Achieva SC": ["1996", "1997"],
    "Achieva SCX": ["1992", "1993"],
    "Achieva SL": ["1992", "1993", "1994", "1995", "1996", "1997"],
    "Alero GL": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Alero GLS": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Alero GX": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Aurora Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2001",
      "2002",
      "2003",
    ],
    "Cutlass GLS": ["1997", "1998", "1999"],
    "Cutlass Ciera Base": [
      "1982",
      "1983",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1995",
      "1996",
    ],
    "Cutlass Ciera S": [
      "1986",
      "1987",
      "1988",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Cutlass Ciera SL": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Cutlass Cruiser Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1989",
      "1990",
      "1993",
      "1994",
    ],
    "Cutlass Cruiser S": ["1991", "1992", "1993", "1994"],
    "Cutlass Supreme Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Cutlass Supreme International": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Cutlass Supreme S": ["1992", "1993", "1994"],
    "Cutlass Supreme SL": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1995",
      "1996",
      "1997",
    ],
    "LSS Base": ["1996", "1997", "1998", "1999"],
    "Regency Base": ["1997", "1998"],
    "Silhouette Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Silhouette GL": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Silhouette GLS": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Silhouette GS": ["1998", "1999"],
    "Silhouette Premiere": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "88 Base": ["1954", "1955", "1956", "1957"],
    "98 Base": [
      "1951",
      "1952",
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "Deluxe 88 Base": ["1951", "1952", "1953", "1954", "1955", "1956"],
    "Jetfire Base": ["1962", "1963"],
    "Starfire Base": [
      "1954",
      "1955",
      "1956",
      "1957",
      "1961",
      "1962",
      "1963",
      "1965",
      "1966",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "Super 88 Base": [
      "1951",
      "1952",
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
    ],
    "98 Regency Brougham": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "98 Regency Touring": ["1987", "1988", "1989", "1990"],
    "Calais Base": ["1985", "1986", "1987"],
    "Calais GT": ["1986", "1987"],
    "Calais Supreme": ["1985", "1986", "1987"],
    "Cutlass Calais Base": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Cutlass Calais GT": ["1988", "1989", "1990", "1991"],
    "Cutlass Calais International": ["1988", "1989", "1990", "1991"],
    "Cutlass Calais S": ["1989", "1990", "1991"],
    "Cutlass Calais SL": ["1988", "1989", "1990", "1991"],
    "Cutlass Ciera Brougham": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Cutlass Ciera Cruiser LS": ["1984", "1985"],
    "Cutlass Ciera ES": ["1985", "1986"],
    "Cutlass Ciera GT": ["1985", "1986", "1987", "1989", "1990"],
    "Cutlass Ciera Holiday": ["1985", "1986"],
    "Cutlass Ciera LS": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Delta 88 Royale": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Delta 88 Royale Brougham": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Firenza Base": ["1984", "1985", "1986", "1987", "1988"],
    "Firenza Brougham LX": ["1984", "1985"],
    "Firenza Brougham SX": ["1984", "1985"],
    "Firenza Cruiser": ["1986", "1987", "1988"],
    "Firenza Cruiser LX": ["1983", "1984", "1985", "1986"],
    "Firenza Cruiser SX": ["1983", "1984", "1985"],
    "Firenza ES": ["1984", "1985"],
    "Firenza GT": ["1984", "1985", "1986", "1987"],
    "Firenza LC": ["1986", "1987"],
    "Firenza LX": ["1982", "1983", "1986", "1987"],
    "Firenza S": ["1982", "1983", "1984", "1986", "1987"],
    "Firenza SX": ["1982", "1983"],
    "Toronado Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Toronado Brougham": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Toronado Trofeo": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "442 Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
    ],
    "98 Holiday": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1965",
      "1966",
      "1967",
    ],
    "Cutlass Colonnade S": ["1976", "1977"],
    "Cutlass Vista Cruiser": ["1976", "1977", "1978", "1979"],
    "Cutlass Calais Hurst": ["1983", "1984"],
    "Cutlass Cruiser Brougham": ["1980", "1981"],
    "Cutlass Salon 442": ["1978", "1979", "1985", "1986"],
    "Cutlass Salon Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1985",
      "1986",
      "1987",
    ],
    "Cutlass Salon Brougham": ["1978", "1979", "1980"],
    "Cutlass Supreme Brougham": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Delmont 88 Base": ["1967", "1968"],
    "Delta 88 Base": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "Delta 88 Custom": ["1967", "1968", "1969", "1970", "1971"],
    "Delta 88 Holiday": ["1965", "1966", "1967", "1980", "1981"],
    "Dynamic 88 Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1965",
      "1966",
    ],
    "Dynamic 88 Holiday": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1965",
      "1966",
    ],
    "F85 Base": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
    ],
    "F85 Deluxe": ["1962", "1963", "1964", "1965", "1966"],
    "Jetstar 88 Base": ["1965", "1966"],
    "Jetstar 88 Holiday": ["1965", "1966"],
    "Vista Cruiser Base": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
    ],
    "Vista Cruiser Custom": ["1964", "1965", "1966", "1967"],
    "98 Luxury": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "Custom Cruiser Base": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Cutlass Ciera International": ["1988", "1989", "1990"],
    "Cutlass Cruiser LS": ["1987", "1988"],
    "Cutlass Cruiser SL": ["1988", "1989", "1990", "1991", "1992"],
    "Delta 88 Royale Brougham LS": ["1984", "1985"],
    "Omega Base": [
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
    ],
    "Omega Brougham": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
    ],
    "Omega ES": ["1981", "1982", "1983", "1984"],
    "Omega SX": ["1976", "1977", "1978", "1980", "1981"],
    "Toronado XSC": ["1980", "1981"],
    "Cutlass Supreme Colonnade": ["1976", "1977"],
    "Cutlass Supreme Cruiser": ["1974", "1975"],
    "Custom Cruiser Panel": ["1975", "1976"],
    "Omega Brougham LS": ["1978", "1979"],
    "Omega F85": ["1976", "1977"],
    "Starfire Firenza": ["1977", "1978", "1979", "1980"],
    "Starfire GT": ["1976", "1977", "1978", "1979", "1980"],
    "Starfire SX": ["1976", "1977", "1978", "1979", "1980"],
    "Toronado Custom": ["1968", "1969", "1970", "1975", "1976"],
    "Toronado XSR": ["1977", "1978", "1979"],
    "Fiesta Base": ["1958", "1959", "1960", "1961", "1962", "1963"],
    "Super 88 Holiday": ["1958", "1959", "1960", "1961", "1962", "1963"],
  },
  Saab: {
    "9-2X Aero": ["2005", "2006"],
    "900 S": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "900 SE": ["1994", "1995", "1996", "1997"],
    "900 SE Turbo": ["1994", "1995", "1996", "1997", "1998"],
    "9000 Aero": ["1993", "1994", "1995", "1996", "1997"],
    "9000 Base": ["1991", "1992"],
    "9000 CD": ["1989", "1990", "1991", "1992", "1993"],
    "9000 CD Turbo": ["1991", "1992", "1993"],
    "9000 CDE": ["1993", "1994", "1995"],
    "9000 CDE Turbo": ["1993", "1994"],
    "9000 CS": ["1993", "1994", "1995", "1996", "1997"],
    "9000 CS Turbo": ["1993", "1994"],
    "9000 CSE": ["1993", "1994", "1995", "1996", "1997"],
    "9000 CSE Turbo": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "9000 S": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "9000 Turbo": ["1986", "1987", "1988", "1990", "1991", "1992"],
    "9-3 Base": ["1999", "2000", "2001"],
    "9-3 SE": ["1999", "2000", "2001", "2002", "2003"],
    "9-3 Viggen": ["1999", "2000", "2001", "2002"],
    "9-7x 4.2i": ["2006", "2007", "2008", "2009"],
    "9-7x 5.3i": ["2006", "2007", "2008", "2009"],
    "9-7x Aero": ["2008", "2009"],
    "9-3 2.0T": ["2006", "2007", "2008", "2009", "2010"],
    "9-3 Aero": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "9-3 Aero XWD": ["2008", "2009"],
    "9-3 Arc": ["2003", "2004", "2005"],
    "9-3 Linear": ["2003", "2004", "2005"],
    "9-3X Base": ["2010", "2011"],
    "9-5 2.3t": ["2000", "2001", "2006", "2007", "2008", "2009"],
    "9-5 Aero": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "9-5 Arc": ["2002", "2003", "2004", "2005"],
    "9-5 Linear": ["2002", "2003", "2004", "2005"],
    "9-5 SE": ["1999", "2000", "2001"],
    "900 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "900 SPG": ["1986", "1987", "1988", "1989", "1990", "1991"],
    "900 Turbo": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1992",
      "1993",
      "1994",
    ],
    "99 Base": ["1969", "1970", "1971", "1972", "1973", "1974"],
    "99 EMS": ["1972", "1973", "1974"],
    "900 Turbo Commemorative Edition": ["1993", "1994"],
  },
  AJP: {
    "PR3 Enduro 240": ["2014", "2015", "2016", "2017", "2018"],
    "PR4 Enduro 240": ["2014", "2015", "2016", "2017", "2018"],
    "PR4 Extreme 240": ["2017", "2018"],
    "PR5 Enduro 250": ["2014", "2015", "2016", "2017", "2018"],
    "PR5 Extreme 250": ["2017", "2018"],
  },
  Alta: {
    "Redshift MX": ["2017", "2018"],
  },
  Aprilia: {
    "Caponord 1000": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "Caponord 1200": ["2013", "2014", "2015", "2016"],
    "Dorsoduro 1200": ["2011", "2012", "2013"],
    "Dorsoduro 750": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Dorsoduro 900": ["2017", "2018", "2019", "2020", "2021"],
    "Mana 850": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "Mana 850 Gt Abs": ["2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "MXV 450": ["2009", "2010", "2012", "2013"],
    "Pegaso 650": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    RS125: [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    RS125R: ["1992", "1993", "1994", "1995"],
    RS250: ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    RS50: [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "RST 1000 Futura": ["2001", "2002", "2003", "2004", "2005"],
    "RSV Mille": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "RSV Mille R": ["2000", "2001", "2002", "2003", "2004"],
    RSV1000R: ["2004", "2005", "2006", "2007", "2008", "2009"],
    "RSV1000R Factory": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "RSV4 R": ["2009", "2010", "2011", "2012"],
    "RSV4 R APRC": ["2012", "2013", "2014", "2015"],
    "RSV4 RF": ["2016", "2017", "2018", "2019"],
    "RSV4 RR": ["2016", "2017", "2018", "2019", "2020"],
    "RXV 450": ["2006", "2007", "2008", "2009", "2010", "2012", "2013"],
    "RXV 550": ["2006", "2007", "2008", "2012", "2013"],
    "Scarabeo 100": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "Scarabeo 200": ["2008", "2009", "2010", "2011"],
    "Scarabeo 500 Ie": ["2007", "2008", "2009", "2010", "2011"],
    "Shiver 750": ["2008", "2009"],
    "Shiver 900": ["2017", "2018", "2019", "2020", "2021"],
    "SL 1000 Falco": ["2000", "2001", "2002", "2003", "2004"],
    "SL 750 Shiver": ["2012", "2013", "2014", "2015", "2016"],
    "Sport City 125": ["2010", "2011"],
    "Sport City 125 Cube": ["2012", "2013"],
    "Sport City 250": ["2012", "2013"],
    "Sport City 50 4T": ["2011", "2012", "2013"],
    "Sportcity 125": ["2008", "2009"],
    "Sportcity 250": ["2007", "2008", "2009"],
    SR50: ["2010", "2011", "2012", "2013"],
    "SXV 450": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "SXV 550": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "Tuono 1000R": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Tuono 1000R Factory": ["2006", "2007", "2008", "2009", "2010"],
    "Tuono 125": ["2004", "2005"],
    "Tuono 50": ["2004", "2005"],
    "Tuono RSV": ["2004", "2005"],
    "Tuono RSV Factory": ["2004", "2005"],
    "Tuono V4 1100 Factory": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Tuono V4R": ["2011", "2012", "2013", "2014"],
    "Tuono V4RR 1100": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "Mojito Custom 50 Base": ["2003", "2004", "2005"],
    "Scarabeo 125 Base": ["2003", "2004", "2005", "2006"],
    "Scarabeo 250 Base": ["2004", "2005", "2006"],
    "Sportcity 125 Base": ["2008", "2009", "2010", "2011"],
    "Sportcity 250 Base": ["2007", "2008", "2009", "2010", "2011"],
    "Pegaso I.E": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "Pegaso 650 Trail": ["2006", "2007"],
    "RST1000 Futura Base": ["2001", "2002", "2003", "2004", "2005"],
    "RSV 1000 R Factory Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "RSV Mille Base": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "RSV Mille R Base": ["2000", "2001", "2002", "2003", "2004"],
    "RSV4 RF Base": ["2015", "2016", "2017", "2018", "2019"],
    "Scarabeo 200 Base": ["2008", "2009", "2010", "2011"],
    "Scarabeo 500 Ie Base": ["2007", "2008", "2009", "2010", "2011"],
    "Shiver 750 Base": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "SL 750 Shiver Base": ["2008", "2009"],
    "SL1000 Falco Base": ["2000", "2001", "2002", "2003", "2004"],
    "Tuono 1000 Base": ["2002", "2003", "2004", "2005"],
    "Tuono 1000 R Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Tuono 1000 R Factory Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Tuono V4 1100 Factory ABS Base": ["2015", "2016", "2017"],
    "Tuono V4 R APRC Base": ["2012", "2013"],
    "Tuareg 660": ["2022", "2023", "2024"],
    "RS 660": ["2020", "2021", "2022", "2023", "2024"],
    "RSV4 1100 Factory": ["2021", "2022", "2023", "2024"],
    "RSV4 Factory APRC": ["2014", "2015"],
    "Tuono 660": ["2021", "2022", "2023", "2024"],
    "RSV4 1100": ["2021", "2022", "2023"],
    "RSV4 1000RR": ["2019", "2020", "2021", "2022"],
    "RSV4 Factory APRC SE": ["2009", "2010", "2011"],
    "Tuono 660 Factory": ["2022", "2023", "2024"],
    "RSV4 X": ["2021", "2022"],
    Mojito: ["2007", "2008"],
    "Caponord 1200 Rally": ["2016", "2017"],
    "Atlantic 500": ["2001", "2002", "2003", "2004", "2005"],
    "Scarabeo 500": ["2003", "2004", "2005", "2006"],
    "Caponord 1200 ABS Rally Base": ["2015", "2016", "2017"],
    "Caponord 1200 ABS Travel Pack Base": ["2015", "2016"],
    "Dorsoduro 1200 Base": ["2011", "2012"],
    "Dorsoduro 750 Base": ["2010", "2011", "2012"],
    "Dorsoduro 750 ABS Base": ["2013", "2014", "2015", "2016"],
    "Dorsoduro 900 Base": ["2017", "2018", "2019", "2020"],
    "ETV 1000 Caponord Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Mana 850 Base": ["2008", "2009", "2010", "2011", "2012"],
    "Mana 850 Gt Abs Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "MXV 450 Base": ["2009", "2010"],
    "Pegaso 650 Base": ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    "Pegaso 650 Trail Base": ["2006", "2007"],
    "RS 125 Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "RS 125 R Extrema Base": ["1992", "1993", "1994", "1995"],
    "RS 250 Base": ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    "RS 50 Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "RS4 125 Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "RSV 1000 R Base": ["2005", "2006", "2007", "2008", "2009"],
    "RSV4 1100 Factory Base": ["2019", "2020"],
    "RSV4 Factory APRC ABS Base": ["2013", "2014", "2015"],
    "RSV4 Factory SE Base": ["2011", "2012"],
    "RSV4 R Base": ["2010", "2011", "2012"],
    "RSV4 R APRC ABS Base": ["2013", "2014", "2015"],
    "RSV4 RR Base": ["2016", "2017", "2018", "2019", "2020"],
    "RXV 450 Base": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "RXV 550 Base": ["2006", "2007", "2008", "2009"],
    "Shiver 900 Base": ["2017", "2018", "2019", "2020"],
    "SXV 450 Base": ["2006", "2007", "2008", "2009"],
    "SXV 550 Base": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "Tuono 125 Base": ["2004", "2005"],
    "Tuono 50 Base": ["2004", "2005"],
    "Tuono V4 1100 Factory Base": ["2018", "2019", "2020"],
    "Tuono V4 1100 RR Base": ["2018", "2019", "2020"],
    "Tuono V4 1100 RR ABS Base": ["2015", "2016", "2017"],
    "Sportcity 50 Base": ["2009", "2010", "2011"],
    "SR 50 Base": ["2012", "2013"],
    "SR 50 R Factory Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "SR 50 R Replica SBK Base": ["2013", "2014"],
    "SR Motard 50 Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Rally 50 (Air Cooled) Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Scarabeo 100 Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
  },
  ATK: {
    "125 Enduro": ["2002", "2003", "2004"],
    "250 Cc": ["1992", "1993", "1994", "1995", "1996"],
    "250 Enduro": ["2001", "2002", "2003", "2004"],
    "250 Lq": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "250 Mx": ["1992", "1993"],
    "260 Enduro": ["2000", "2001", "2002"],
    "260 Lq": ["1996", "1997", "1998", "1999"],
    350: ["1992", "1993"],
    "350 Cc": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "350 Ds": ["1994", "1995", "1996", "1997"],
    "350 Enduro": ["1998", "1999"],
    "350 Mx": ["1992", "1993"],
    "406 Cc": ["1992", "1993", "1994", "1995", "1996"],
    "406 Mx": ["1992", "1993"],
    "450 Enduro": ["2004", "2005", "2006", "2007"],
    "450 Motard": ["2006", "2007"],
    "450 Mx": ["2004", "2005", "2006", "2007"],
    "450 XC": ["2006", "2007"],
    "490 Cc": ["1999", "2000"],
    "490 Enduro": ["1999", "2000"],
    "50 Cc": ["1999", "2000"],
    "50 Mx": ["1999", "2000", "2001", "2002"],
    "500 Enduro": ["2002", "2003", "2004"],
    560: ["1986", "1987"],
    "600 Dt": ["1998", "1999", "2000", "2001", "2002"],
    "600 Dtm": ["2003", "2004"],
    "600 Mt": ["2000", "2001", "2002", "2003"],
    "605 Cc": ["1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    "605 Ds": ["1994", "1995", "1996", "1997"],
    "605 Enduro": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "605 Le": ["1996", "1997", "1998"],
    "125 Enduro Base": ["2002", "2003", "2004"],
    "250 Base": ["1988", "1989", "1990"],
    "250 Cc Base": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "250 Enduro Base": ["2001", "2002", "2003", "2004"],
    "250 Lq Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "250 Mx Base": ["1991", "1992", "1993"],
    "260 Enduro Base": ["2000", "2001", "2002"],
    "260 Lq Base": ["1996", "1997", "1998", "1999"],
    "350 Base": ["1991", "1992", "1993"],
    "350 Cc Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "350 Ds Base": ["1994", "1995", "1996", "1997"],
    "350 Enduro Base": ["1998", "1999"],
    "350 Mx Base": ["1991", "1992", "1993"],
    "406 Base": ["1988", "1989", "1990"],
    "406 Cc Base": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "406 Mx Base": ["1991", "1992", "1993"],
    "450 Dirt Track Base": ["2008", "2009"],
    "450 Enduro Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "450 Motard Base": ["2006", "2007", "2008", "2009"],
    "450 Mx Base": ["2004", "2005", "2006", "2007", "2008"],
    "450 Vr Base": ["2004", "2005"],
    "450 XC Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "450MX Base": ["2008", "2009"],
    "450VR Base": ["2008", "2009"],
    "490 Cc Base": ["1999", "2000"],
    "490 Enduro Base": ["1999", "2000"],
    "50 Cc Base": ["1999", "2000"],
    "50 Mx Base": ["1999", "2000", "2001", "2002"],
    "50 MXA Base": ["2003", "2004", "2005"],
    "50 MXE Base": ["2003", "2004", "2005"],
    "50 MXLQ Base": ["2003", "2004", "2005"],
    "500 Enduro Base": ["2002", "2003", "2004"],
    "560 Base": ["1986", "1987"],
    "600 Dt Base": ["1998", "1999", "2000", "2001", "2002"],
    "600 Dtm Base": ["2003", "2004"],
    "600 Mt Base": ["2000", "2001", "2002", "2003"],
    "604 Base": ["1988", "1989", "1990", "1991", "1992"],
    "604 Cc Base": ["1991", "1992"],
    "604 Mx Base": ["1991", "1992"],
    "605 Cc Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "605 Ds Base": ["1994", "1995", "1996", "1997"],
    "605 Enduro Base": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "605 Le Base": ["1996", "1997", "1998"],
    "620 Intimidator Base": ["2007", "2008", "2009"],
    "700 Intimidator Base": ["2007", "2008", "2009"],
    "GT250 Base": ["2011", "2012", "2013", "2014"],
    "GT250R Base": ["2011", "2012", "2013", "2014"],
    "GT650R Base": ["2011", "2012", "2013", "2014"],
    "GV250 Base": ["2011", "2012", "2013", "2014"],
    "GV650 Base": ["2011", "2012", "2013", "2014"],
  },
  Benelli: {
    "Cafe Racer 1130": ["2008", "2009", "2010", "2011"],
    "Titanium 07": ["2007", "2008"],
    "Tornado Naked TRE 1130": ["2004", "2005", "2006", "2007"],
    "Tornado Naked TRE 1130 Sport": ["2005", "2006"],
    "Tornado Naked TRE 1130 Sport EVO": ["2007", "2008"],
    "Tornado Naked TRE 899": ["2008", "2009", "2010"],
    "Tornado Naked TRE 899 S": ["2008", "2009", "2010"],
    "Tornado TRE 1130": ["2008", "2009"],
    "Tornado TRE 900": ["2003", "2004", "2005"],
    "Tornado TRE 900 RS": ["2004", "2005"],
    "Tornado TRE LE": ["2001", "2002"],
    "TRE 1130 K": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "TRE 1130 K Amazonas": ["2007", "2008", "2009", "2010", "2011"],
    "TRE 899 K": ["2009", "2010", "2011"],
    "TNT 300": ["2017", "2018"],
    "Cafe Racer 1130 Base": ["2005", "2006", "2007", "2008", "2009"],
    "Titanium 07 Base": ["2007", "2008"],
    "Tornado Naked TRE 1130 Base": ["2004", "2005", "2006", "2007"],
    "Tornado Naked TRE 1130 Sport Base": ["2005", "2006"],
    "Tornado Naked TRE 1130 Sport EVO Base": ["2007", "2008"],
    "Tornado TRE 1130 Base": ["2006", "2007", "2008", "2009"],
    "Tornado TRE 900 Base": ["2003", "2004", "2005"],
    "Tornado TRE 900 RS Base": ["2004", "2005"],
    "Tornado TRE LE Base": ["2001", "2002", "2003", "2004", "2005"],
    "TRE 1130 K Base": ["2006", "2007", "2008", "2009"],
    "TRE 1130 K Amazonas Base": ["2007", "2008", "2009"],
  },
  Beta: {
    "250 RR (2T)": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "300 RR (2t)": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "300 Xtrainer": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "350 RR": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "350 RR-S": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "350 RS": ["2012", "2013"],
    "390 RR": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "390 RR-S": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "400 RR": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "430 RR": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "430 RR-S": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "430 RS": ["2015", "2016"],
    "450 RR": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "450 RS": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "480 RR": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "498 RR": ["2012", "2013", "2014"],
    "500 RR-S": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "500 RS": ["2015", "2016"],
    "520 RR": ["2010", "2011"],
    "520 RS": ["2011", "2012", "2013", "2014"],
    "525 RR": ["2005", "2006", "2007", "2008", "2009"],
    "525 RS": ["2008", "2009", "2010"],
    "Evo 250": ["2010", "2011", "2012", "2013"],
    Gara: ["1993", "1994"],
    "Mini Trials": ["2010", "2011", "2012"],
    "REV3 125": ["2004", "2005", "2006", "2007", "2008"],
    "REV3 200": ["2004", "2005", "2006", "2007", "2008"],
    "REV3 250": ["2004", "2005", "2006", "2007", "2008"],
    "REV3 270": ["2004", "2005", "2006", "2007", "2008"],
    "Synt.": ["1993", "1994"],
    Zero: ["1989", "1990", "1991", "1992"],
    "125 RR (2t)": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "200 RR (2t)": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "390 RS": ["2015", "2016"],
    "300 RX (2T)": ["2021", "2022", "2023", "2024", "2025"],
    "200 RR (RE)": ["2021", "2022", "2023", "2024", "2025"],
    "250 RR (RE)": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "350 RR (RE)": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "390 RR (RE)": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "430 RR (RE)": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "480 RR (RE)": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "125 RR (RE)": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "300 RR (RE)": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "400 RS": ["2008", "2009"],
    "125 RR-S": ["2017", "2018", "2019"],
    "125 RR Base": ["2018", "2019", "2020"],
    "125 RR-Race Edition Base": ["2019", "2020"],
    "200 RR Base": ["2019", "2020"],
    "250 RR (2 Stroke) Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "250 RR-Race Edition Base": ["2017", "2018", "2019", "2020"],
    "300 RR (2 Stroke) Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "300 RR-Race Edition Base": ["2017", "2018", "2019", "2020"],
    "300 Xtrainer Base": ["2016", "2017"],
    "350 RR Base": ["2011", "2012", "2013", "2014"],
    "350 RR EFI Base": ["2015", "2016"],
    "350 RR-Race Edition Base": ["2017", "2018", "2019", "2020"],
    "350 RR-S Base": ["2017", "2018", "2019", "2020"],
    "350 RS Base": ["2012", "2013"],
    "390 RR Base": ["2015", "2016"],
    "390 RR-Race Edition Base": ["2017", "2018", "2019", "2020"],
    "390 RR-S Base": ["2017", "2018", "2019", "2020"],
    "400 RR Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "430 RR Base": ["2015", "2016"],
    "430 RR-Race Edition Base": ["2017", "2018", "2019", "2020"],
    "430 RR-S Base": ["2017", "2018", "2019", "2020"],
    "430 RS Base": ["2015", "2016"],
    "450 RR Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "450 RS Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "480 RR Base": ["2015", "2016"],
    "480 RR-Race Edition Base": ["2017", "2018", "2019", "2020"],
    "498 RR Base": ["2012", "2013", "2014"],
    "500 RR-S Base": ["2017", "2018", "2019", "2020"],
    "500 RS Base": ["2015", "2016"],
    "520 RR Base": ["2010", "2011"],
    "520 RS Base": ["2011", "2012", "2013", "2014"],
    "525 RR Base": ["2008", "2009"],
    "525 RS Base": ["2008", "2009", "2010"],
    "Alp 200 Base": ["2006", "2007"],
    "Alp 4.0 Base": ["2005", "2006"],
    "Evo 125 Base": ["2010", "2011", "2012", "2013", "2014", "2019", "2020"],
    "EVO 125 Factory Base": ["2019", "2020"],
    "Evo 200 Base": ["2010", "2011", "2012", "2013", "2014", "2019", "2020"],
    "EVO 250 (2 Stroke) Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2019",
      "2020",
    ],
    "EVO 250 (4 Stroke) Base": ["2010", "2011", "2012", "2013", "2014"],
    "EVO 250 Factory (2 Stroke) Base": ["2019", "2020"],
    "Evo 290 Base": ["2010", "2011"],
    "Evo 300 Base": ["2010", "2011", "2012", "2013", "2014"],
    "EVO 300 (4 Stroke) Base": ["2012", "2013", "2014", "2019", "2020"],
    "EVO 300 Factory (2 Stroke) Base": ["2019", "2020"],
    "EVO 300 Factory (4 Stroke) Base": ["2019", "2020"],
    "Evo 300 SS Base": ["2019", "2020"],
    "EVO 300 SS Super Smooth Base": ["2012", "2013", "2014"],
    "Evo 80 Base": ["2010", "2011", "2012", "2013"],
    "Evo 80 Jr Base": ["2010", "2011", "2012", "2013", "2014", "2019", "2020"],
    "EVO 80 SR Base": ["2019", "2020"],
    "Gara Base": ["1993", "1994"],
    "Mini Trials Base": ["2010", "2011", "2012"],
    "REV3 125 Base": ["2006", "2007", "2008"],
    "REV3 200 Base": ["2006", "2007", "2008"],
    "REV3 250 Base": ["2005", "2006", "2007", "2008"],
    "REV3 270 Base": ["2005", "2006", "2007", "2008"],
    "SuperTrial Base": ["1992", "1993"],
    "Synt. Base": ["1992", "1993", "1994"],
    "Techno 125 Base": ["1995", "1996", "1997", "1998", "1999"],
    "TR240 125 Base": ["1983", "1984"],
    "TR240 200 Base": ["1983", "1984"],
    "TR32 125 Base": ["1984", "1985"],
    "TR32 200 Base": ["1984", "1985"],
    "TR33 Base": ["1985", "1986"],
    "TR34 125 Base": ["1996", "1997", "1998"],
    "TR34 260 Base": ["1986", "1987", "1988", "1989", "1990"],
    "TR35 Base": ["1989", "1990", "1991"],
    "Xtrainer Base": ["2019", "2020"],
    "Zero Base": ["1989", "1990", "1991", "1992"],
  },
  Bimota: {
    DB4: ["1999", "2000"],
    DB5R: ["2007", "2008"],
    DB5S: ["2007", "2008"],
    "DB6 Delirio": ["2007", "2008"],
    SB8R: ["1998", "1999", "2000", "2001"],
    "DB4 Base": ["1999", "2000"],
    "DB5R Base": ["2007", "2008", "2009"],
    "DB5S Base": ["2007", "2008", "2009"],
    "DB6 Delirio Base": ["2007", "2008", "2009"],
    "DB6R Base": ["2008", "2009"],
    "DB7 Base": ["2008", "2009"],
    "SB8R Base": ["1998", "1999", "2000", "2001"],
    "Tesi 3D Base": ["2008", "2009"],
  },
  Buell: {
    "1125CR Helicon": ["2009", "2010"],
    "1125R Helicon": ["2008", "2009", "2010"],
    "Blast 500": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "M2 Cyclone": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "RR1000 Battletwin": ["1987", "1988", "1997", "1998"],
    "RR1200 Battletwin": ["1988", "1989", "1990"],
    "RS1200 Westwind": ["1989", "1990", "1991", "1992", "1993"],
    "RS1200/5 Westwind": ["1990", "1991", "1992"],
    "RSS1200 Westwind": ["1991", "1992", "1993"],
    "S1 Lightning": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "S2 Thunderbolt": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "S3 Thunderbolt": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "S3T Thunderbolt": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "X1 Lightning": ["1999", "2000", "2001", "2002"],
    "XB12R Firebolt": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "XB12S Lightning": ["2004", "2005", "2006", "2007", "2008"],
    "XB12Scg Lightning Low": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "XB12Ss Lightning Long": ["2006", "2007", "2008", "2009", "2010"],
    "XB12Stt Lightning Super Tt": ["2007", "2008"],
    "XB12X Ulysses": ["2006", "2007", "2008", "2009", "2010"],
    "XB12Xp Ulysses": ["2009", "2010"],
    "XB12Xt Ulysses": ["2008", "2009", "2010"],
    "XB9R Firebolt": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "XB9S Lightning": ["2003", "2004"],
    "XB9Sx Lightning City X": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "1125CR Base": ["2009", "2010"],
    "Lightning CityX XB9SX Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XB12S Lightning Base": ["2004", "2005", "2006", "2007", "2008"],
    "XB12Scg Lightning Base": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "XB12Ss Lightning Long Base": ["2007", "2008", "2009", "2010"],
    "XB12X Ulysses Base": ["2006", "2007", "2008", "2009", "2010"],
    "XB12XP Ulysses Police Base": ["2009", "2010"],
    "XB12Xt Ulysses Base": ["2008", "2009", "2010"],
    "XB9S Lightning Base": ["2003", "2004"],
    "XB9SX Lightning Base": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "1125R Base": ["2008", "2009", "2010"],
    "Blast Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "M2 Cyclone Base": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "RR1000 Base": ["1987", "1988", "1997", "1998"],
    "RR1200 Base": ["1989", "1990"],
    "RS1200 Base": ["1989", "1990", "1991", "1992", "1993"],
    "RSS1200 Base": ["1992", "1993"],
    "S1 Lightning Base": ["1996", "1997", "1998"],
    "S2 Thunderbolt Base": ["1995", "1996"],
    "S3 Thunderbolt Base": ["1997", "1998", "1999", "2000", "2001"],
    "S3T Thunderbolt Base": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "X1 Lightning Base": ["1999", "2000", "2001", "2002"],
    "XB12R Firebolt Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XB9R Firebolt Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
  },
  Cannondale: {
    C440R: ["2002", "2003", "2004"],
    E440: ["2002", "2003", "2004"],
    E440A: ["2003", "2004"],
    E440R: ["2003", "2004"],
    Mx400: ["2000", "2001"],
    X440: ["2002", "2003", "2004"],
    "Blaze 440": ["2002", "2003"],
    "Cannibal 440": ["2002", "2003"],
    "Moto 440": ["2002", "2003"],
    "Speed 440": ["2002", "2003"],
    "Blaze 440 Base": ["2002", "2003"],
    "C440R Base": ["2002", "2003", "2004", "2005"],
    "Cannibal 440 Base": ["2002", "2003"],
    "E440 Base": ["2002", "2003", "2004", "2005"],
    "E440A Base": ["2003", "2004", "2005"],
    "E440R Base": ["2003", "2004", "2005"],
    "Moto 440 Base": ["2002", "2003"],
    "Mx400 Base": ["2000", "2001"],
    "S440 Base": ["2003", "2004", "2005"],
    "Speed 440 Base": ["2002", "2003"],
    "X440 Base": ["2002", "2003", "2004", "2005"],
  },
  Cobra: {
    Bm50: ["1994", "1995", "1996", "1997"],
    CM50: [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "CX50 BW": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "CX50 F.W.E.": ["2017", "2018", "2019", "2020", "2021"],
    "CX50 Jr": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "CX50 OI": ["2007", "2008"],
    "CX50 P3": ["2017", "2018", "2019"],
    "CX50 Sr": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    CX65: [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    King: [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    Ecx50: ["2007", "2008", "2009"],
    "Bm50 Base": ["1994", "1995", "1996", "1997"],
    "CM50 Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "CX50 FWE Base": ["2016", "2017", "2018", "2019"],
    "CX50 P3 Base": ["2017", "2018", "2019"],
    "CX50-JR Base": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "CX50-OI Base": ["2007", "2008"],
    "CX50-SR Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "CX50BW Base": ["2014", "2015"],
    "CX65 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Ecx50 Base": ["2007", "2008", "2009"],
    "ECX70 Base": ["2005", "2006", "2007", "2008", "2009"],
    "King Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
  },
  Ducati: {
    1098: ["2007", "2008"],
    "1098 R": ["2008", "2009"],
    "1098 S": ["2007", "2008"],
    "1099 S/F": ["2009", "2010", "2011"],
    "1099 S/F S": ["2010", "2011"],
    1198: ["2009", "2010", "2011"],
    "1198 R Corse": ["2010", "2011"],
    "1198 S": ["2009", "2010", "2011"],
    "1199 Panigale": ["2012", "2013", "2014"],
    "1199 Panigale R": ["2013", "2014", "2015", "2016", "2017"],
    "1199 Panigale S": ["2012", "2013", "2014"],
    "1199 Panigale S Tricolore": ["2012", "2013"],
    "1299 Panigale": ["2015", "2016", "2017"],
    "1299 Panigale S": ["2015", "2016", "2017"],
    748: ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "748 Biposto": ["1995", "1996", "1997", "1998", "1999"],
    "748 Monoposto": ["2000", "2001", "2002"],
    "748 SP": ["1994", "1995", "1996", "1997", "1998"],
    "748 SPS": ["1998", "1999"],
    "748R": ["2000", "2001", "2002"],
    "748S": ["2000", "2001", "2002"],
    "748S Monoposto": ["2000", "2001", "2002"],
    749: ["2003", "2004", "2005", "2006"],
    "749 Dark": ["2005", "2006"],
    "749R": ["2004", "2005", "2006"],
    "749S": ["2003", "2004", "2005", "2006"],
    848: ["2008", "2009", "2010"],
    "848 Evo": ["2011", "2012", "2013"],
    "848 Streetfighter": ["2011", "2012"],
    "899 Panigale": ["2014", "2015"],
    900: ["1999", "2000", "2001", "2002"],
    916: ["1993", "1994", "1995", "1996", "1997", "1998"],
    "916 Biposto": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "916 Monoposto": ["1997", "1998"],
    "916 Senna": ["1996", "1997", "1998"],
    "916 SP": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "916 SPS": ["1997", "1998"],
    "916 SPS Fogarty": ["1998", "1999"],
    "916 Strada": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "959 Panigale": ["2016", "2017", "2018", "2019"],
    996: ["1998", "1999", "2000", "2001", "2002"],
    "996 Biposto": ["1999", "2000", "2001"],
    "996 Monoposto": ["1999", "2000", "2001"],
    "996 SPS": ["1999", "2000"],
    "996S": ["2000", "2001", "2002", "2003"],
    "998 Biposto": ["2002", "2003"],
    "998 Monoposto": ["2002", "2003", "2004"],
    999: ["2003", "2004", "2005", "2006"],
    "999R": ["2003", "2004", "2005", "2006"],
    "999R Fila": ["2003", "2004"],
    "999S": ["2003", "2004", "2005", "2006"],
    Diavel: ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "Diavel Amg": ["2011", "2012"],
    "Diavel Carbon": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Diavel Chromo": ["2012", "2013"],
    "Diavel Dark": ["2013", "2014"],
    "Diavel Strada": ["2013", "2014"],
    GT1000: ["2007", "2008", "2009", "2010"],
    "GT1000 Touring": ["2009", "2010"],
    "Hypermotard 1100": ["2008", "2009"],
    "Hypermotard 1100 Evo": ["2010", "2011", "2012"],
    "Hypermotard 1100 Evo Sp": ["2010", "2011", "2012", "2013"],
    "Hypermotard 1100 S": ["2008", "2009"],
    "Hypermotard 796": ["2010", "2011", "2012", "2013"],
    "Hypermotard 821": ["2013", "2014", "2015"],
    "Hypermotard 821 Sp": ["2013", "2014", "2015"],
    "Hypermotard 939": ["2016", "2017", "2018"],
    "Hypermotard 939 SP": ["2016", "2017", "2018"],
    "Hyperstrada 821": ["2013", "2014", "2015"],
    Mh900E: ["2000", "2001", "2002"],
    "Monster 1000": ["2003", "2004", "2005"],
    "Monster 1000S": ["2003", "2004", "2005"],
    "Monster 1100": ["2009", "2010", "2011"],
    "Monster 1100 Evo": ["2011", "2012", "2013"],
    "Monster 1100 S": ["2009", "2010", "2011"],
    "Monster 1200": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Monster 1200 R": ["2016", "2017", "2018", "2019", "2020"],
    "Monster 1200 S": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Monster 400": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Monster 400 Dark": ["2002", "2003", "2004", "2005"],
    "Monster 400 Metallic": ["2000", "2001"],
    "Monster 600": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Monster 600 Dark": ["1998", "1999", "2000", "2001"],
    "Monster 600 Dark City": ["1999", "2000"],
    "Monster 600 Metallic": ["2000", "2001"],
    "Monster 620": ["2002", "2003", "2004", "2005", "2006"],
    "Monster 620 Dark": ["2003", "2004", "2005", "2006"],
    "Monster 620 S": ["2002", "2003"],
    "Monster 695": ["2007", "2008"],
    "Monster 696": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "Monster 750": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2010",
      "2011",
    ],
    "Monster 750 Dark": ["1999", "2000", "2001", "2002"],
    "Monster 750 Metallic": ["2000", "2001", "2002"],
    "Monster 795": ["2012", "2013", "2014"],
    "Monster 796": ["2010", "2011", "2012", "2013", "2014"],
    "Monster 797": ["2017", "2018", "2020", "2021"],
    "Monster 800": ["2003", "2004"],
    "Monster 821": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Monster 821 Dark": ["2015", "2016"],
    "Monster 821 Stripe": ["2015", "2016", "2017"],
    "Monster 900": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Monster 900 Cromo": ["1998", "1999", "2000", "2001"],
    "Monster 900 Dark": ["1998", "1999", "2000", "2001", "2002"],
    "Monster 900 Metallic": ["2000", "2001"],
    "Monster 900S": ["1998", "1999", "2000", "2001"],
    "Monster S2R": ["2005", "2006"],
    "Monster S2R 1000": ["2006", "2007", "2008"],
    "Monster S2R 800 Dark": ["2005", "2006"],
    "Monster S4": ["2001", "2002"],
    "Monster S4R": ["2003", "2004", "2005", "2006", "2007"],
    "Monster S4R S Testastretta": ["2006", "2007", "2008"],
    "Monster S4R Testastretta": ["2007", "2008"],
    "Multistrada 1000": ["2003", "2004"],
    "Multistrada 1000 Ds": ["2005", "2006"],
    "Multistrada 1000S Ds": ["2005", "2006"],
    "Multistrada 1100": ["2007", "2008", "2009"],
    "Multistrada 1100 S": ["2007", "2008", "2009"],
    "Multistrada 1200": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Multistrada 1200 Enduro": ["2016", "2017", "2018"],
    "Multistrada 1200 Pike's Peak": ["2016", "2017"],
    "Multistrada 1200 S": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Multistrada 1200 S D'Air": ["2015", "2016", "2017"],
    "Multistrada 620": ["2005", "2006"],
    "Multistrada 620 Dark": ["2005", "2006"],
    "Multistrada 950": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Paso 906": ["1988", "1989", "1990"],
    "Paulsmart 1000 Le": ["2005", "2006"],
    "Scrambler Caf\u00e9 Racer": ["2017", "2018", "2019", "2020", "2021"],
    "Scrambler Classic": ["2015", "2016", "2017", "2018"],
    "Scrambler Desert Sled": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Scrambler Full Throttle": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Scrambler Icon": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Scrambler Sixty2": ["2016", "2017", "2019", "2020", "2021"],
    "Scrambler Urban Enduro": ["2015", "2016"],
    "Sport 1000": ["2006", "2007", "2008", "2009"],
    "Sport 1000 Biposto": ["2007", "2008"],
    "Sport 1000S": ["2007", "2008", "2009"],
    "Sport 750": ["1972", "1973", "1988", "1989", "1990", "2001", "2002"],
    ST2: ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    ST3: ["2004", "2005", "2006", "2007"],
    "ST3 S ABS": ["2006", "2007"],
    "ST4 916": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "ST4 S": ["2001", "2002", "2003", "2004", "2005"],
    "Super Sport 1000": ["2003", "2004", "2005", "2006"],
    "Super Sport 1000Ds": ["2005", "2006"],
    "Super Sport 750": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Super Sport 800": ["2003", "2004"],
    "Super Sport 900": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "SuperSport 939": ["2017", "2018", "2019", "2020", "2021"],
    "SuperSport 939 S": ["2017", "2018", "2019", "2020"],
    XDiavel: ["2016", "2017", "2018", "2019", "2020", "2021"],
    "XDiavel S": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "1100 Panigale V4": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "1100 Panigale V4 S": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "1100 Panigale V4 Speciale": ["2018", "2019", "2020", "2021"],
    "1100 Streetfighter V4": ["2020", "2021", "2022", "2023", "2024"],
    "1100 Streetfighter V4 S": ["2020", "2021", "2022", "2023", "2024"],
    "955 Panigale V2": ["2020", "2021", "2022", "2023", "2024"],
    "Superleggera V4": ["2020", "2021"],
    "600SL Pantah": ["1981", "1982"],
    "Diavel 1260": ["2019", "2020", "2021", "2022"],
    "Diavel 1260 S": ["2019", "2020", "2021"],
    "Hypermotard 950": ["2019", "2020", "2021"],
    "Hypermotard 950 SP": ["2019", "2020", "2021"],
    "Monster 797+": ["2019", "2020"],
    "Monster 821 Stealth": ["2019", "2020", "2021", "2022"],
    "Multistrada 1260": ["2018", "2019", "2020", "2021"],
    "Multistrada 1260 Enduro": ["2019", "2020", "2021"],
    "Multistrada 1260 Pike's Peak": ["2018", "2019", "2020", "2021"],
    "Multistrada 1260 S": ["2018", "2019", "2020", "2021"],
    "Multistrada 1260 S DAir": ["2019", "2020"],
    "Multistrada 950 S": ["2019", "2020", "2021", "2022"],
    "Multistrada 950 S Spoked": ["2019", "2020"],
    "Scrambler 1100": ["2018", "2019", "2020", "2021", "2022"],
    "Scrambler 1100 Pro": ["2020", "2021", "2022"],
    "Scrambler 1100 Sport Pro": ["2020", "2021", "2022"],
    "ST3 Base": ["2004", "2005", "2006", "2007"],
    "ST3S ABS Base": ["2006", "2007"],
    "ST4S Base": ["2001", "2002", "2003", "2004", "2005"],
    "ST4S ABS Base": ["2003", "2004", "2005"],
    "Diavel Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Diavel Carbon Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Diavel Strada Base": ["2013", "2014"],
    "Monster 1100 Base": ["2009", "2010", "2011"],
    "Monster 1100 Evo Base": ["2012", "2013"],
    "Monster 1100 S Base": ["2009", "2010", "2011"],
    "Monster 696 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Monster 750 Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2010",
      "2011",
    ],
    "Monster 796 Base": ["2011", "2012", "2013", "2014"],
    "Monster Diesel Base": ["2012", "2013"],
    "Multistrada 1000 Base": ["2003", "2004"],
    "Multistrada 1000 Ds Base": ["2005", "2006"],
    "Multistrada 1100 Base": ["2007", "2008", "2009"],
    "Multistrada 1100 S Base": ["2007", "2008", "2009"],
    "Multistrada 620 Base": ["2005", "2006"],
    "Multistrada 620 Dark Base": ["2005", "2006"],
    "Multistrada V4": ["2021", "2022"],
    "Multistrada V4S": ["2021", "2022", "2023"],
    "Multistrada V4S Sport": ["2021", "2022"],
    "Monster 937": ["2021", "2022", "2023", "2024"],
    "SuperSport 950": ["2021", "2022", "2023"],
    "Monster 937+": ["2021", "2022", "2023"],
    "Scrambler Icon Dark": ["2021", "2022"],
    "1100 Panigale V4 S Corse": ["2019", "2020", "2021"],
    "959 Panigale Corse": ["2018", "2019"],
    "SuperSport 950S": ["2021", "2022", "2023"],
    "1299 Panigale R Final Edition": ["2018", "2019"],
    "955 Panigale V2 Bayliss": ["2022", "2023"],
    "998 Panigale V4 R": ["2019", "2020", "2021", "2022", "2023"],
    "1100 Panigale V4 SP2": ["2023", "2024"],
    "Scrambler Nightshift": ["2021", "2022", "2023"],
    "900 MHR": ["1979", "1980"],
    "900 SD Darmah": ["1978", "1979"],
    "1000 Base": ["2003", "2004"],
    "1000DS Base": ["2005", "2006"],
    "1098 Base": ["2007", "2008"],
    "1098 R Base": ["2008", "2009"],
    "1098 S Base": ["2007", "2008"],
    "1198 Base": ["2009", "2010", "2011"],
    "1198 R Corse Base": ["2010", "2011"],
    "1198 S Base": ["2009", "2010"],
    "1199 Panigale Base": ["2012", "2013", "2014"],
    "1199 Panigale R Base": ["2013", "2014"],
    "1199 Panigale S Base": ["2012", "2013", "2014"],
    "1199 Panigale S Tricolore Base": ["2012", "2013"],
    "1299 Panigale Base": ["2015", "2016", "2017"],
    "1299 Panigale S Base": ["2015", "2016", "2017"],
    "748 Base": ["2000", "2001", "2002"],
    "748 Biposto Base": ["1997", "1998", "1999"],
    "748 Monoposto Base": ["2000", "2001", "2002"],
    "748 SPS Base": ["1998", "1999"],
    "748R Base": ["2000", "2001", "2002"],
    "748S Base": ["2000", "2001", "2002"],
    "748S Monoposto Base": ["2000", "2001", "2002"],
    "749 Base": ["2003", "2004", "2005", "2006"],
    "749 Dark Base": ["2005", "2006"],
    "749R Base": ["2004", "2005", "2006"],
    "749S Base": ["2003", "2004", "2005", "2006"],
    "750 Base": ["1999", "2000", "2001", "2002"],
    "750 Sport Base": ["2001", "2002"],
    "800 Base": ["2003", "2004"],
    "848 Base": ["2008", "2009", "2010"],
    "848 Evo Base": ["2011", "2012", "2013"],
    "848 EVO Corse SE Base": ["2012", "2013"],
    "899 Panigale Base": ["2014", "2015"],
    "900 Base": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "916 Monoposto Base": ["1997", "1998"],
    "916 Senna Base": ["1997", "1998"],
    "916 SPS Base": ["1997", "1998"],
    "959 Panigale Base": ["2016", "2017", "2018", "2019"],
    "959 Panigale Corse Base": ["2018", "2019"],
    "996 Biposto Base": ["1999", "2000", "2001"],
    "996 Monoposto Base": ["1999", "2000", "2001"],
    "996 SPS Base": ["1999", "2000"],
    "996S Base": ["2001", "2002", "2003"],
    "998 Biposto Base": ["2002", "2003"],
    "998 Monoposto Base": ["2002", "2003", "2004"],
    "999 Base": ["2003", "2004", "2005", "2006"],
    "999R Base": ["2003", "2004", "2005", "2006"],
    "999R Fila Base": ["2003", "2004"],
    "999S Base": ["2003", "2004", "2005", "2006"],
    "Desmosedici RR Base": ["2007", "2008"],
    "Diavel 1260 Base": ["2019", "2020"],
    "Diavel 1260 S Base": ["2019", "2020"],
    "Diavel Diesel Base": ["2017", "2018"],
    "GT1000 Base": ["2007", "2008", "2009", "2010"],
    "Hypermotard Base": ["2013", "2014", "2015"],
    "Hypermotard 1100 Base": ["2008", "2009"],
    "Hypermotard 1100 Evo Base": ["2010", "2011"],
    "Hypermotard 1100 Evo Sp Base": ["2010", "2011", "2012"],
    "Hypermotard 1100 S Base": ["2008", "2009"],
    "Hypermotard 796 Base": ["2010", "2011", "2012"],
    "Hypermotard 939 Base": ["2016", "2017", "2018"],
    "Hypermotard 939 SP Base": ["2016", "2017", "2018"],
    "Hypermotard 950 Base": ["2019", "2020"],
    "Hypermotard 950 SP Base": ["2019", "2020"],
    "Hypermotard SP Base": ["2013", "2014", "2015"],
    "Hyperstrada Base": ["2013", "2014", "2015"],
    "Mh900E Base": ["2000", "2001", "2002"],
    "Monster 1000 Base": ["2004", "2005"],
    "Monster 1000S Base": ["2003", "2004", "2005"],
    "Monster 1200 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Monster 1200 R Base": ["2016", "2017", "2018", "2019"],
    "Monster 1200 S Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Monster 400 Base": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "Monster 400 Dark Base": ["2002", "2003", "2004"],
    "Monster 400 Metallic Base": ["2000", "2001"],
    "Monster 600 Base": ["1997", "1998", "1999", "2000", "2001"],
    "Monster 600 Dark Base": ["1998", "1999", "2000", "2001"],
    "Monster 600 Dark City Base": ["1999", "2000"],
    "Monster 600 Metallic Base": ["2000", "2001"],
    "Monster 620 Base": ["2002", "2003", "2004", "2005", "2006"],
    "Monster 620 Dark Base": ["2005", "2006"],
    "Monster 620s Base": ["2002", "2003"],
    "Monster 695 Base": ["2007", "2008"],
    "Monster 750 Dark Base": ["1999", "2000", "2001", "2002"],
    "Monster 750 Metallic Base": ["2000", "2001", "2002"],
    "Monster 797 Base": ["2017", "2018"],
    "Monster 797+ Base": ["2017", "2018", "2019", "2020"],
    "Monster 821 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Monster 821 Dark Base": ["2015", "2016"],
    "Monster 821 Stealth Base": ["2019", "2020"],
    "Monster 821 Stripe Base": ["2015", "2016", "2017"],
    "Monster 900 Base": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "Monster 900 Cromo Base": ["1998", "1999", "2000", "2001"],
    "Monster 900 Dark Base": ["1998", "1999", "2000", "2001", "2002"],
    "Monster 900 Metallic Base": ["2000", "2001"],
    "Monster 900S Base": ["1998", "1999", "2000", "2001"],
    "Monster S2R Base": ["2005", "2006"],
    "Monster S2R 1000 Base": ["2006", "2007", "2008"],
    "Monster S2R Dark Base": ["2005", "2006"],
    "Monster S4 Base": ["2001", "2002"],
    "Monster S4R Base": ["2004", "2005", "2006", "2007"],
    "Monster S4R Testastretta Base": ["2007", "2008"],
    "Monster S4Rs Testastretta Base": ["2006", "2007", "2008"],
    "Multistrada 1200 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Multistrada 1200 Enduro Base": ["2016", "2017", "2018"],
    "Multistrada 1200 Pikes Peak Base": ["2016", "2017"],
    "Multistrada 1200 S Base": ["2010", "2011", "2015", "2016", "2017"],
    "Multistrada 1200 S Granturismo Base": ["2013", "2014"],
    "Multistrada 1200 S Pikes Peak Base": ["2012", "2013", "2014"],
    "Multistrada 1200 S Touring Base": ["2012", "2013", "2014"],
    "Multistrada 1260 Base": ["2018", "2019", "2020"],
    "Multistrada 1260 Enduro Base": ["2019", "2020"],
    "Multistrada 1260 Pikes Peak Base": ["2018", "2019", "2020"],
    "Multistrada 1260 S Base": ["2018", "2019", "2020"],
    "Multistrada 950 Base": ["2017", "2018", "2019", "2020"],
    "Multistrada 950 S Base": ["2019", "2020"],
    "Multistrada 950 S Spoked Wheels Base": ["2019", "2020"],
    "Panigale R Base": ["2015", "2016", "2017"],
    "Panigale V4 Base": ["2018", "2019", "2020"],
    "Panigale V4 R Base": ["2019", "2020"],
    "Panigale V4 S Base": ["2018", "2019", "2020"],
    "Panigale V4 S Corse Base": ["2019", "2020"],
    "Panigale V4 Speciale Base": ["2018", "2019", "2020"],
    "Paulsmart 1000 Le Base": ["2005", "2006"],
    "Scrambler 1100 Base": ["2018", "2019"],
    "Scrambler 1100 Special Base": ["2018", "2019"],
    "Scrambler 1100 Sport Base": ["2018", "2019"],
    "Scrambler Caf\u00e9 Racer Base": ["2017", "2018", "2019", "2020"],
    "Scrambler Classic Base": ["2015", "2016", "2017", "2018"],
    "Scrambler Desert Sled Base": ["2017", "2018", "2019", "2020"],
    "Scrambler Full Throttle Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Scrambler Icon Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Scrambler Sixty2 Base": ["2016", "2017", "2018", "2019", "2020"],
    "Scrambler Urban Enduro Base": ["2015", "2016"],
    "Sport 1000 Biposto Base": ["2007", "2008"],
    "Sport 1000S Base": ["2007", "2008", "2009"],
    "ST2 Base": ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "ST4 Base": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Streetfighter Base": ["2009", "2010", "2011"],
    "Streetfighter 848 Base": ["2012", "2013", "2014", "2015"],
    "Streetfighter S Base": ["2009", "2010", "2011", "2012"],
    "Super Sport Base": ["2017", "2018", "2019", "2020"],
    "Super Sport S Base": ["2017", "2018", "2019", "2020"],
    "XDiavel Base": ["2016", "2017", "2018", "2019", "2020"],
    "XDiavel S Base": ["2016", "2017", "2018", "2019", "2020"],
    "Multistrada V2S": ["2022", "2023"],
    "Multistrada V4 Pike's Peak": ["2022", "2023"],
  },
  "Gas Gas": {
    "Ec 125": ["2006", "2007", "2008"],
    "EC 200": ["2007", "2008"],
    "Ec 200 Hobby": ["2006", "2007"],
    "EC 250": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "EC 250F": ["2013", "2014"],
    "Pampera 370": ["1997", "1998"],
    "SM 125": ["2004", "2005"],
    "SM 400FSE": ["2002", "2003"],
    "300 Pro Base": ["2003", "2004"],
    "EC 125 Racing Base": ["2013", "2014"],
    "EC 200 Base": ["2014", "2015", "2019", "2020"],
    "Ec 200 Hobby Base": ["2006", "2007", "2008"],
    "EC 250 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2018",
      "2019",
      "2020",
    ],
    "EC 250 4T Base": ["2010", "2011"],
    "EC 250 Replica Base": ["2011", "2012", "2013", "2014"],
    "EC 250E Base": ["2011", "2012", "2013", "2014", "2015"],
    "EC 250F Base": ["2013", "2014", "2015"],
    "EC 300 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2018",
      "2019",
      "2020",
    ],
    "EC 300 Replica Base": ["2011", "2012", "2013", "2014"],
    "EC 300E Base": ["2011", "2012", "2013", "2014", "2015"],
    "EC 300F Base": ["2013", "2014", "2015"],
    "EC 400 FSE Base": ["2002", "2003"],
    "EC 450 FSE Base": ["2003", "2004", "2005", "2006"],
    "Ec 450 Fsr Base": ["2007", "2008", "2009"],
    "EC 450F Base": ["2013", "2014", "2015"],
    "Ec 515 Fsr Base": ["2008", "2009"],
    "EC Ranger 200 Base": ["2019", "2020"],
    "EC Ranger 300 Base": ["2019", "2020"],
    "Ec Rookie 50 Base": ["2001", "2002", "2003", "2004", "2005"],
    "Enducross 125 Base": ["1989", "1990", "1991", "1992", "1996", "1997"],
    "Enducross 250 Base": ["1989", "1990", "1991", "1992", "1996", "1997"],
    "Enducross EC 125 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Enducross EC 200 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Enducross EC 250 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Enducross EC 300 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Enducross EC Boy 50 Base": ["2004", "2005", "2006"],
    "Enducross Tt 125 Base": ["1993", "1994", "1995"],
    "Enducross TT 80 Base": ["1993", "1994"],
    "Mc 125 Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "Mc 250 Base": [
      "1998",
      "1999",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Mc 65 Base": ["2006", "2007"],
    "Mc Boy 50 Base": ["2005", "2006"],
    "Nomada Base": ["1989", "1990"],
    "Pampera 125 Base": [
      "1997",
      "1998",
      "2002",
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
    ],
    "Pampera 200 Base": ["1997", "1998"],
    "Pampera 250 Base": ["1995", "1996"],
    "Pampera 280 Base": ["2002", "2003", "2004", "2005"],
    "Pampera 370 Base": ["1997", "1998"],
    "Pampera 450 Base": ["2007", "2008"],
    "SM 125 Base": ["2002", "2003", "2004", "2005"],
    "SM 250 Base": ["2002", "2003", "2004", "2005"],
    "SM 400 FSE Base": ["2002", "2003"],
    "SM 450 FSE Base": ["2004", "2005"],
    "SM 450 FSR Base": ["2007", "2008"],
    "SM 50 Base": ["2002", "2003", "2004", "2005"],
    "TX50 Boy Base": ["2003", "2004"],
    "TXT 280 Base": ["2001", "2002", "2003"],
    "TXT 80 Rookie Base": ["2003", "2004", "2007", "2008"],
    "TXT Boy 50 Base": ["2008", "2009", "2010", "2011"],
    "TXT Cadet 80 Base": ["2009", "2010", "2011"],
    "TXT Pro 125 Base": ["2009", "2010", "2011", "2014", "2015"],
    "TXT Pro 250 Base": ["2009", "2010", "2011", "2014", "2015"],
    "TXT Pro 280 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2014",
      "2015",
    ],
    "TXT Pro 300 Base": ["2009", "2010", "2011", "2014", "2015"],
    "TXT Racing 125 Base": ["2019", "2020"],
    "TXT Racing 250 Base": ["2019", "2020"],
    "TXT Racing 280 Base": ["2019", "2020"],
    "TXT Racing 300 Base": ["2019", "2020"],
    "Wild HP 240 Base": ["2003", "2004", "2005"],
    "Wild Hp 300 Base": ["2003", "2004", "2005"],
    "Wild Hp 450 Base": ["2003", "2004", "2005", "2007", "2008"],
    "Wild HP 50 Base": ["2003", "2004", "2005"],
    "XC 250 Base": ["2011", "2012", "2013", "2018", "2019"],
    "XC 300 Base": ["2011", "2012", "2013", "2018", "2019"],
  },
  "Gas-Gas": {
    "Ec 125": ["2001", "2002", "2003", "2013", "2014", "2015"],
    "EC 200": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "EC 250": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "EC 300": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "EC 450F": ["2013", "2014", "2015", "2024", "2025"],
    "Ec Boy 50": ["2004", "2005", "2006"],
    "Ec Rookie 50": ["2001", "2002"],
    "Enducross 250": ["1996", "1997"],
    FSE450: ["2004", "2005"],
    "Mc 125": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Mc 250": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Mc 65": ["2006", "2007", "2021", "2022", "2023", "2024", "2025"],
    "Mc Boy 50": ["2005", "2006"],
    Nomada: ["1989", "1990"],
    "Pampera 125": ["1997", "1998", "2002", "2003", "2004", "2005"],
    "Pampera 200": ["1997", "1998"],
    "Pampera 250": ["1995", "1996"],
    "Pampera 280": ["2003", "2004", "2005"],
    "SM 125": ["2002", "2003", "2006", "2007", "2008", "2009"],
    "SM 250": ["2002", "2003", "2004", "2005"],
    "SM 450FSE": ["2004", "2005"],
    "SM 50": ["2002", "2003", "2004"],
    "XC 300": ["2012", "2013", "2018", "2019"],
    "EC 250F": ["2021", "2022", "2024", "2025"],
    "EC 350F": ["2021", "2022", "2023", "2024"],
    "EX 250F": ["2021", "2022", "2023", "2024", "2025"],
    "EX 350F": ["2021", "2022", "2023", "2024", "2025"],
    "EX 450F": ["2021", "2022", "2023", "2024"],
    "MC 250F": ["2021", "2022", "2023", "2024", "2025"],
    "MC 350F": ["2022", "2023", "2024", "2025"],
    "MC 450F": ["2021", "2022", "2023", "2024", "2025"],
    "EC 300 4T": ["2013", "2014", "2015"],
    "Wild Hp 450": ["2004", "2005", "2006", "2007", "2008"],
    "EX 250": ["2022", "2023", "2024", "2025"],
    "EX 300": ["2021", "2022", "2023", "2024", "2025"],
    "MC 85 17/14": ["2023", "2024", "2025"],
    "MC 85 19/16": ["2021", "2022", "2023", "2024", "2025"],
    "MC 50": ["2021", "2022", "2023", "2024", "2025"],
    "EC 250 Replica": ["2013", "2014"],
    "EC 300 Replica": ["2013", "2014"],
    "Ec 450 Fsr": ["2007", "2008", "2009"],
    "XC 200": ["2018", "2019"],
    "XC 250": ["2018", "2019"],
    "MC-E 5": ["2021", "2022", "2023", "2024"],
    "TXT Trials 125": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
    ],
    "TXT Trials 200": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "TXT Trials 250": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
    ],
    "TXT Trials 280": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
    ],
    "TXT Trials 300": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
    ],
    "SM Rookie 50": ["2004", "2005"],
    "EC Ranger 300": ["2019", "2020"],
  },
  "Harley Davidson": {
    "FLD Dyna Switchback": ["2012", "2013", "2014"],
    "FLH Electra Glide": [
      "1955",
      "1956",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "FLHC Electra Glide Classic": ["1980", "1981"],
    "FLHR Road King": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2005",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "FLHRC Road King Classic": ["2000", "2001", "2003", "2004", "2013", "2014"],
    "FLHRS Road King Custom": ["2004", "2005", "2006"],
    "FLHRXS Road King Special": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FLHS Electra Glide Sport": ["1987", "1988", "1989", "1990", "1991"],
    "FLHT Electra Glide": [
      "1986",
      "1987",
      "2005",
      "2006",
      "2007",
      "2008",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "FLHTC Electra Glide Classic": [
      "1984",
      "1985",
      "1990",
      "1991",
      "1992",
      "1993",
      "1996",
      "1997",
      "1998",
      "1999",
      "2001",
      "2002",
      "2011",
      "2012",
    ],
    "FLHTCSE CVO Electra Glide": ["2004", "2005"],
    "FLHTCU Electra Glide Ultra Classic": [
      "1991",
      "1992",
      "1994",
      "1995",
      "1996",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2005",
      "2006",
      "2007",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "FLHTCUL Electra Glide Ultra Classic Low": ["2015", "2016"],
    "FLHTCUSE CVO Electra Glide Ultra Classic": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "FLHTCUTG Tri Glide Ultra Classic": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FLHTK Electra Glide Ultra Limited": [
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FLHTKL Electra Glide Ultra Limited Low": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "FLHTKSE CVO Limited": ["2015", "2016", "2018", "2019", "2020", "2021"],
    "FLHX Electra Glide Special": ["1984", "1985"],
    "FLHX Street Glide": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FLHXS Street Glide Special": [
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "FLHXSE CVO Street Glide": [
      "2010",
      "2011",
      "2012",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FLHXXX Street Glide Trike": ["2010", "2011"],
    "FLRT Freewheeler": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FLS Softail Slim": ["2012", "2013", "2015", "2016"],
    "FLST Softail Heritage": ["1987", "1988", "1989", "1990"],
    "FLSTC Softail Heritage Classic": [
      "1988",
      "1989",
      "1991",
      "1992",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2015",
      "2016",
      "2017",
    ],
    "FLSTF Softail Fat Boy": [
      "1994",
      "1995",
      "1997",
      "1998",
      "2002",
      "2003",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "FLSTFB Softail Fat Boy Lo": ["2013", "2014", "2015", "2016"],
    "FLSTFSE CVO Softail Fat Boy": ["2005", "2006"],
    "FLSTN Softail Deluxe": [
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
    ],
    "FLSTN Softail Nostalgia": ["1993", "1994", "1995"],
    "FLSTS Softail Heritage Springer": ["1998", "1999", "2000", "2001"],
    "FLSTSB Softail Cross Bones": ["2008", "2009", "2010"],
    "FLSTSE CVO Softail": ["2011", "2012"],
    "FLT Tour Glide": ["1980", "1981", "1982"],
    "FLTC Tour Glide Classic": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1990",
      "1991",
      "1992",
    ],
    "FLTCU Ultra Classic Tour Glide": ["1995", "1996"],
    "FLTR Road Glide": [
      "2007",
      "2008",
      "2009",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "FLTRU Road Glide Ultra": ["2011", "2012", "2016", "2017", "2018", "2019"],
    "FLTRUSE CVO Road Glide Ultra": ["2015", "2016"],
    "FLTRX Road Glide Custom": [
      "2012",
      "2013",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FLTRXS Road Glide Special": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "FXB Sturgis": ["1980", "1981"],
    "FXCWC Softail Rocker C": ["2008", "2009", "2010", "2011"],
    "FXD Dyna Super Glide": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2006",
      "2007",
      "2009",
      "2010",
    ],
    "FXDB Dyna Street Bob": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
    ],
    "FXDC Dyna Super Glide Custom": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2012",
      "2013",
    ],
    "FXDF Dyna Fat Bob": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FXDL Dyna Low Rider": [
      "1995",
      "1996",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2008",
      "2009",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FXDS-Conv Dyna Convertible": ["1996", "1997", "1998"],
    "FXDWG Dyna Wide Glide": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "FXDWGSE CVO Dyna Switchblade": ["2001", "2002"],
    "FXDX Dyna Super Glide Sport": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "FXDXT Dyna Super Glide T-Sport": ["2001", "2002", "2003"],
    "FXE Super Glide": ["1974", "1975", "1977", "1978", "1983", "1984"],
    "FXEF Fat Bob": ["1980", "1981"],
    "FXLR Low Rider Custom": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "FXR Super Glide": [
      "1982",
      "1983",
      "1986",
      "1987",
      "1988",
      "1989",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "FXRS Low Glide": ["1987", "1988", "1990", "1991", "1992"],
    "FXRS-Conv Low Rider Convertible": ["1990", "1991", "1992", "1993", "1994"],
    "FXRS-SP Low Rider Sport": ["1989", "1990", "1992", "1993"],
    "FXRSE CVO FXR": ["1999", "2000"],
    "FXRT Sport Glide": ["1988", "1989", "1990", "1991", "1992"],
    "FXS Softail Blackline": ["2012", "2013"],
    "FXSB Low Rider - Belt": ["1983", "1984", "1985"],
    "FXSB Softail Breakout": ["2016", "2017"],
    "FXSE CVO Softail Pro Street Breakout": ["2016", "2017"],
    "FXST Softail": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2022",
      "2023",
      "2024",
    ],
    "FXSTB Softail Night Train": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2008",
      "2009",
    ],
    "FXSTC Softail Custom": [
      "1986",
      "1987",
      "1997",
      "1998",
      "1999",
      "2007",
      "2008",
    ],
    "FXSTDSE CVO Softail Deuce": ["2003", "2004"],
    "FXSTS Softail Springer": [
      "1988",
      "1989",
      "1991",
      "1992",
      "1993",
      "1994",
      "1997",
      "1998",
      "1999",
      "2001",
      "2002",
      "2005",
      "2006",
    ],
    "FXSTSSE CVO Softail Springer": ["2007", "2008", "2009"],
    "FXWG Wide Glide": ["1983", "1984", "1985"],
    "VRSCA V-Rod": ["2002", "2003", "2004", "2005", "2006"],
    "VRSCAW V-Rod": ["2008", "2009"],
    "VRSCB V-Rod": ["2004", "2005"],
    "VRSCD Night Rod": ["2006", "2007"],
    "VRSCDX Night Rod Special": ["2014", "2015", "2016", "2017"],
    "VRSCF V-Rod Muscle": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "VRSCR Street Rod": ["2006", "2007"],
    "VRSCSE CVO V-Rod": ["2005", "2006"],
    "XG 750 Street": ["2017", "2018", "2019", "2020", "2021"],
    "XG 750A Street Rod": ["2017", "2018", "2019", "2020", "2021"],
    "XL1200C Sportster 1200 Custom": [
      "1996",
      "1997",
      "1998",
      "2002",
      "2003",
      "2012",
      "2013",
      "2017",
      "2018",
      "2019",
    ],
    "XL1200L Sportster 1200 Low": ["2006", "2007", "2008", "2009", "2010"],
    "XL1200N Nightster": ["2007", "2008", "2009", "2010", "2011"],
    "XL1200R Roadster": ["2004", "2005", "2006", "2007"],
    "XL1200S Sportster Sport": ["1996", "1997", "1998", "1999"],
    "XL1200T Super Low Touring": ["2014", "2015"],
    "XL1200V Seventy Two": ["2013", "2014"],
    "XL1200X Forty-Eight": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "XL883 Sportster 883": ["2005", "2006", "2007", "2008"],
    "XL883C Sportster 883 Custom": [
      "1999",
      "2000",
      "2001",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XL883L Super Low": ["2006", "2007", "2016", "2017", "2018", "2019"],
    "XL883N Iron 883": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "XLH1000 Sportster 1000": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
    ],
    "XLH1200 Sportster 1200": [
      "1988",
      "1989",
      "1991",
      "1992",
      "1993",
      "1994",
      "1996",
      "1997",
      "2000",
      "2001",
    ],
    "XLH883 Sportster 883": [
      "1988",
      "1989",
      "1990",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "XLH883D Sportster 883 Deluxe": [
      "1986",
      "1987",
      "1988",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "XLH883H Sportster 883 Hugger": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1995",
      "1996",
      "1998",
      "1999",
      "2001",
      "2002",
      "2003",
    ],
    "XLS1000 1000 Roadster": ["1979", "1980"],
    "XLX1000 Sportster Sixty One 1000": ["1984", "1985"],
    "XG 500 Street": ["2018", "2019", "2020", "2021"],
    "VRSCA V-Rod Base": ["2002", "2003", "2004", "2005", "2006"],
    "VRSCAW V-Rod Base": ["2007", "2008", "2009", "2010"],
    "VRSCB V-Rod Base": ["2004", "2005"],
    "VRSCD Night Rod Base": ["2006", "2007", "2008"],
    "VRSCDX Night Rod Special Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "VRSCF V-Rod Muscle Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "VRSCR Street Rod Base": ["2006", "2007"],
    "FLDE Softail Deluxe": ["2018", "2019", "2020"],
    "FLFB Softail Fat Boy": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "FLFBS Softail Fat Boy 114": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FLHC Softail Heritage Classic": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "FLHCS Softail Heritage Classic 114": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FLSB Softail Sport Glide": ["2018", "2019", "2020", "2021"],
    "FLSL Softail Slim": ["2018", "2019", "2020", "2021"],
    "FLTRXSE CVO Road Glide": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FXBB Softail Street Bob": ["2018", "2019", "2020", "2021", "2022"],
    "FXBR Softail Breakout": ["2018", "2019", "2023", "2024"],
    "FXBRS Softail Breakout 114": ["2018", "2019", "2020"],
    "FXFB Softail Fat Bob": ["2018", "2019"],
    "FXFBS Softail Fat Bob 114": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "FXLR Softail Low Rider": ["2018", "2019", "2020", "2021"],
    "XL1200CX Roadster": ["2018", "2019", "2020", "2021"],
    "XL1200NS Iron 1200": ["2018", "2019", "2020", "2021"],
    "XL1200XS Forty Eight Special": ["2018", "2019"],
    "FLHR Road King Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "FLHRXS Road King Special Base": ["2017", "2018", "2019", "2020", "2021"],
    "FLHX Street Glide Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "FLHXS Street Glide Special Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Pan America 1250": ["2021", "2022", "2023"],
    "Pan America 1250 Special": ["2022", "2023", "2024"],
    "FLHTCUTGSE CVO Tri Glide": ["2020", "2021", "2022"],
    "FLTRK Road Glide Limited": ["2020", "2021", "2022", "2023", "2024"],
    "FXLRS Softail Low Rider S": ["2020", "2021", "2022", "2023", "2024"],
    "XL1250T Sportster S": ["2021", "2022", "2023", "2024"],
    "FLHXST Street Glide ST": ["2022", "2023"],
    "FLTRXST Road Glide ST": ["2022", "2023"],
    "FXD Dyna Super Glide Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "FXDB Street Bob Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FXDC Super Glide Custom Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "FXDF Fat Bob Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FXDL Dyna Low Rider Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FXDLS Low Rider S Base": ["2016", "2017"],
    "FXDS-Conv Dyna Convertible Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "FXDWG Dyna Wide Glide Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FXDXT Dyna Super Glide T-Sport Base": ["2001", "2002", "2003"],
    "XL1200C Sportster 1200 Custom Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "XL1200CX Roadster Base": ["2016", "2017", "2018", "2019", "2020"],
    "XL1200NS Iron 1200 Base": ["2018", "2019", "2020", "2021"],
    "XL1200T SuperLow 1200T Base": ["2014", "2015", "2016", "2017"],
    "XL1200X Forty-Eight Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "XL1200XS Forty-Eight Special Base": ["2018", "2019"],
    "XL883N Iron 883 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "FLSB Sport Glide 107 Base": ["2018", "2019", "2020", "2021"],
    "FXBB Street Bob 107 Base": ["2018", "2019", "2020"],
    "FXBRS Breakout 114 Base": ["2018", "2019", "2020"],
    "FXDRS FXDR 114 Base": ["2019", "2020"],
    "FXFB Fat Bob 107 Base": ["2018", "2019", "2020"],
    "FXFBS Fat Bob 114 Base": ["2018", "2019", "2020", "2021"],
    "FXST Softail Standard 107 Base": ["2020", "2021"],
    "FXBBS Softail Street Bob 114": ["2022", "2023", "2024"],
    "FXLRST Softail Low Rider ST": ["2022", "2023", "2024"],
    "XL975 Nightster": ["2022", "2023"],
    "FLTRKSE CVO Road Glide Limited": ["2022", "2023"],
    "FXDRS Softail FXDR 114": ["2019", "2020"],
    "FLTRT Trike Road Glide 3": ["2023", "2024"],
    "FLD Switchback Base": ["2012", "2013", "2014", "2015", "2016"],
    "FLDE Deluxe 107 Base": ["2018", "2019", "2020"],
    "FLFB Fat Boy 107 Base": ["2018", "2019"],
    "FLFBS Fat Boy 114 Base": ["2018", "2019", "2020", "2021"],
    "FLH Electra Glide Base": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "FLHC Electra Glide Classic Base": ["1979", "1980", "1981"],
    "FLHC Heritage Classic 107 Base": ["2018", "2019", "2020", "2021"],
    "FLHCS Heritage Classic 114 Base": ["2018", "2019", "2020", "2021"],
    "FLHRC Road King Classic Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "FLHRCI Road King Classic Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FLHRI Road King Base": [
      "1996",
      "1997",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FLHRS Road King Custom Base": ["2004", "2005", "2006", "2007"],
    "FLHRSI Road King Custom Base": ["2004", "2005", "2006"],
    "FLHS Electra Glide Sport Base": [
      "1980",
      "1981",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "FLHT Electra Glide Standard Base": [
      "1986",
      "1987",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "FLHTC Electra Glide Classic Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "FLHTCI Electra Glide Classic Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FLHTCU Electra Glide Ultra Classic Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "FLHTCUI Electra Glide Ultra Classic Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FLHTCUL Electra Glide Ultra Classic Low Base": ["2015", "2016"],
    "FLHTCUTG Tri Glide Ultra Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "FLHTCUTG Tri Glide Ultra Classic Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "FLHTI Electra Glide Standard Base": ["2003", "2004", "2005", "2006"],
    "FLHTK Electra Glide Ultra Limited Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "FLHTK Ultra Limited Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "FLHTKL Ultra Limited Low Base": ["2015", "2016", "2017", "2018", "2019"],
    "FLHTKSE CVO Limited Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "FLHX Electra Glide Special Base": ["1984", "1985"],
    "FLHXSE CVO Street Glide Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "FLHXXX Street Glide Trike Base": ["2010", "2011"],
    "FLRT Freewheeler Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "FLS Softail Slim Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "FLSL Softail Slim 107 Base": ["2018", "2019", "2020", "2021"],
    "FLSS Softail Slim S Base": ["2016", "2017"],
    "FLST Heritage Softail Base": ["1986", "1987", "1988", "1989", "1990"],
    "FLSTC Heritage Softail Classic Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FLSTCI Heritage Softail Classic Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FLSTF Fat Boy Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FLSTFB Fat Boy Lo Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "FLSTFBS Fat Boy S Base": ["2016", "2017"],
    "FLSTFI Fat Boy Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "FLSTN Heritage Softail Special Base": ["1994", "1995", "1996"],
    "FLSTN Softail Deluxe Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FLSTNI Softail Deluxe Base": ["2005", "2006"],
    "FLSTNSE CVO Softail Deluxe Base": ["2014", "2015"],
    "FLSTS Heritage Springer Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "FLSTSB Cross Bones Base": ["2008", "2009", "2010", "2011"],
    "FLSTSC Softail Springer Classic Base": ["2005", "2006", "2007"],
    "FLSTSCI Softail Springer Classic Base": ["2005", "2006"],
    "FLSTSI Heritage Springer Base": ["2001", "2002", "2003"],
    "FLT Tour Glide Base": ["1980", "1981", "1982", "1983"],
    "FLTC Tour Glide Classic Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "FLTCU Tour Glide Ultra Classic Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "FLTR Road Glide Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2007",
      "2008",
      "2009",
    ],
    "FLTRI Road Glide Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FLTRU Road Glide Ultra Base": [
      "2011",
      "2012",
      "2013",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "FLTRUSE CVO Road Glide Ultra Base": ["2015", "2016"],
    "FLTRX Road Glide Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "FLTRX Road Glide Custom Base": ["2010", "2011", "2012", "2013"],
    "FLTRXS Road Glide Special Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "FLTRXSE CVO Road Glide Base": ["2018", "2019", "2020"],
    "FXB Sturgis Base": ["1980", "1981", "1982"],
    "FXBR Breakout 107 Base": ["2018", "2019"],
    "FXCW Rocker Base": ["2008", "2009"],
    "FXCWC Rocker C Base": ["2008", "2009", "2010", "2011"],
    "FXDCI Super Glide Custom Base": ["2005", "2006"],
    "FXDI Dyna Super Glide Base": ["2004", "2005", "2006"],
    "FXDL Low Rider Base": ["2014", "2015", "2016", "2017"],
    "FXDLI Dyna Low Rider Base": ["2004", "2005", "2006"],
    "FXDWGI Dyna Wide Glide Base": ["2004", "2005", "2006"],
    "FXDX Dyna Super Glide Sport Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "FXDXI Dyna Super Glide Sport Base": ["2004", "2005"],
    "FXE Super Glide Base": ["1980", "1981", "1982", "1983", "1984"],
    "FXEF Fat Bob Base": ["1980", "1981"],
    "FXLR Low Rider 107 Base": ["2018", "2019", "2020"],
    "FXLR Low Rider Custom Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "FXR Super Glide II Base": [
      "1982",
      "1983",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "FXRS Low Glide Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "FXRS-Conv Low Rider Sport Convertible Base": [
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "FXRS-SP Low Rider Sport Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "FXRT Sport Glide Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "FXS Blackline Base": ["2011", "2012", "2013"],
    "FXS Low Rider Base": ["1980", "1981", "1982"],
    "FXSB Breakout Base": ["2013", "2014", "2015", "2016", "2017"],
    "FXSB Low Rider - Belt Base": ["1983", "1984", "1985"],
    "FXSBSE CVO Breakout Base": ["2013", "2014"],
    "FXSE CVO Pro Street Breakout Base": ["2016", "2017"],
    "FXST Softail Standard Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "FXSTB Night Train Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "FXSTBI Night Train Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "FXSTC Softail Custom Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "FXSTD Softail Deuce Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "FXSTDI Softail Deuce Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FXSTI Softail Standard Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FXSTS Springer Softail Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FXSTSB Bad Boy Base": ["1995", "1996", "1997"],
    "FXSTSI Springer Softail Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "FXWG Wide Glide Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
    ],
    "XG500 Street 500 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "XG750 Street 750 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "XG750A Street Rod Base": ["2017", "2018", "2019", "2020"],
    "XL1200L Sportster 1200 Low Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "XL1200N Sportster 1200 Nightster Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "XL1200R Sportster 1200 Roadster Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "XL1200S Sportster 1200 Sport Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "XL1200V Seventy-Two Base": ["2012", "2013", "2014", "2015", "2016"],
    "XL883 Sportster Base": ["2004", "2005", "2006", "2007", "2008"],
    "XL883C Sportster 883 Custom Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XL883L Sportster 883 Low Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XL883L SuperLow Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "XL883R Sportster 883 Roadster Base": [
      "2002",
      "2003",
      "2005",
      "2006",
      "2007",
    ],
    "XLH1000 Base": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
    ],
    "XLH1100 Base": ["1986", "1987"],
    "XLH1200 Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "XLH883 Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "XLH883DLX Sportster 883 Deluxe Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "XLH883HUG Sportster 883 Hugger Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "XLS Roadster Base": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "XLX 1000 Base": ["1983", "1984", "1985"],
    "XR1000 Base": ["1983", "1984", "1985"],
    "XR1200 Base": ["2009", "2010"],
    "XR1200X Base": ["2011", "2012"],
    "FLTRK Road Glide Limited Base": ["2020", "2021"],
    "FXLRS Low Rider S 114 Base": ["2020", "2021"],
    "FLFB Base": ["1965", "1966", "1967", "1968", "1969"],
    "FLHB Base": ["1965", "1966", "1967", "1968", "1969"],
    "FLHF Base": ["1970", "1971", "1972"],
    "FLHFB Base": ["1965", "1966", "1967", "1968", "1969"],
    "XLCH Base": ["1965", "1966", "1967", "1968", "1969"],
    "XLH900 Base": [
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
    ],
    "XLT Base": ["1977", "1978"],
  },
  "Harley-Davidson": {
    "FLH Electra Glide": ["1957", "1958"],
    "FLHR Road King": ["2000", "2001", "2003", "2004"],
    "FLHRC Road King Classic": ["2009", "2010", "2011", "2012"],
    "FLHRSE CVO Road King": ["2013", "2014"],
    "FLHS Electra Glide Sport": ["1980", "1981"],
    "FLHT Electra Glide": ["1996", "1997", "1998"],
    "FLHTC Electra Glide Classic": [
      "1986",
      "1987",
      "1994",
      "1995",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "FLHTCU Electra Glide Ultra Classic": ["2010", "2011"],
    "FLHTCUTG Tri Glide Ultra Classic": ["2016", "2017"],
    "FLHTK Electra Glide Ultra Limited": ["2016", "2017"],
    "FLRT Freewheeler": ["2015", "2016"],
    "FLSTC Softail Heritage Classic": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "FLSTFB Softail Fat Boy Lo": ["2011", "2012"],
    "FLTCU Ultra Classic Tour Glide": ["1993", "1994"],
    "FLTR Road Glide": ["2003", "2004"],
    "FLTRX Road Glide Custom": ["2010", "2011"],
    "FXD Dyna Super Glide": ["2004", "2005"],
    "FXDL Dyna Low Rider": ["1993", "1994"],
    "FXDS-Conv Dyna Convertible": ["1999", "2000"],
    "FXDWG Dyna Wide Glide": ["2007", "2008"],
    "FXE Super Glide": ["1981", "1982"],
    "FXRS-SP Low Rider Sport": ["1987", "1988"],
    "FXRT Sport Glide": ["1983", "1984", "1986", "1987"],
    "FXS Low Rider": ["1977", "1978", "1980", "1981"],
    "FXSBSE CVO Softail Breakout": ["2013", "2014"],
    "FXSTB Softail Night Train": ["2006", "2007"],
    "FXSTC Softail Custom": ["1994", "1995", "1996", "2009", "2010"],
    "FXSTD Softail Deuce": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "FXSTS Softail Springer": ["1995", "1996", "2003", "2004"],
    "FXWG Wide Glide": ["1981", "1982"],
    "VRSCDX Night Rod Special": ["2009", "2010", "2011"],
    "VRSCF V-Rod Muscle": ["2015", "2016"],
    "XG 500 Street": ["2016", "2017"],
    "XL1200C Sportster 1200 Custom": ["2006", "2007", "2008", "2009"],
    "XL1200S Sportster Sport": ["2000", "2001", "2002"],
    "XL1200V Seventy Two": ["2015", "2016"],
    "XL883C Sportster 883 Custom": ["2002", "2003"],
    "XL883D Sportster 883 Deluxe": ["1994", "1995"],
    "XL883L Super Low": ["2008", "2009"],
    "XL883R 883 Roadster": ["2002", "2003", "2006", "2007"],
    "XLH1000 Sportster 1000": ["1983", "1984"],
    "XLH1100 Sportster 1100": ["1986", "1987"],
    "XLH1200 Sportster 1200": ["1998", "1999"],
    "XLH883 Sportster 883": ["1997", "1998"],
    "XLH883D Sportster 883 Deluxe": ["1989", "1990", "1991"],
    "XLH883H Sportster 883 Hugger": ["1991", "1992"],
    "XLS1000 1000 Roadster": ["1981", "1982", "1983", "1984"],
    "FXBBS Street Bob 114 Base": ["2022", "2023"],
    "FXFBS Fat Bob 114 Base": ["2022", "2023"],
    "FXLRST Low Rider ST 117 Base": ["2022", "2023"],
    "FXST Softail Standard 107 Base": ["2022", "2023"],
  },
  Husaberg: {
    "FC 400": ["1996", "1997", "1998", "1999"],
    "FC 450": ["2001", "2002", "2003", "2004", "2005"],
    "FC 470": ["2001", "2002"],
    "FC 499": ["1992", "1993"],
    "FC 501": ["1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    "FC 550": ["2001", "2002", "2004", "2005"],
    "FC 600": ["1993", "1994", "1995", "1996", "1998", "1999", "2000"],
    "FE 250": ["2013", "2014"],
    "FE 350": ["1991", "1992", "1993", "1994", "1995", "1996", "2013", "2014"],
    "FE 390": ["2010", "2011", "2012"],
    "FE 400": ["1996", "1997", "1998", "1999", "2000"],
    "FE 400E": ["1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "FE 450": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "FE 450E": ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "FE 501": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2013",
      "2014",
    ],
    "FE 501E": ["1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "FE 550E": ["2004", "2005", "2006", "2007", "2008"],
    "FE 570": ["2009", "2010", "2011", "2012"],
    "FE 600": ["1993", "1994", "1995", "1996"],
    "FE 600E": ["1996", "1997", "1998", "1999", "2000"],
    "FE 650E": ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    FS450E: ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    FS570: ["2010", "2011", "2012"],
    FS600E: ["1998", "1999"],
    FS650C: ["2004", "2005", "2006", "2007", "2008"],
    FS650E: ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    Fx450: ["2010", "2011", "2012"],
    Fx470E: ["2001", "2002"],
    Fx501E: ["1997", "1998"],
    Fx600E: ["1997", "1998", "1999", "2000"],
    Fx650E: ["2001", "2002", "2003"],
    Te125: ["2011", "2012", "2013", "2014"],
    Te250: ["2011", "2012", "2013", "2014"],
    Te300: ["2011", "2012", "2013", "2014"],
    "FC 650": ["2004", "2005"],
    FS450C: ["2001", "2002", "2003", "2004", "2005", "2006"],
    FX450E: ["2001", "2002", "2003"],
    "FC400 Base": ["1996", "1997", "1998", "1999"],
    "FC450 Base": ["2004", "2005"],
    "FC470 Base": ["2001", "2002"],
    "FC499 Base": ["1992", "1993"],
    "FC501 Base": ["1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    "FC550 Base": ["2001", "2002", "2004", "2005"],
    "FC600 Base": ["1993", "1994", "1995", "1996", "1998", "1999", "2000"],
    "FE250 Base": ["2013", "2014"],
    "FE350 Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "2013",
      "2014",
    ],
    "FE390 Base": ["2010", "2011", "2012"],
    "FE400 Base": ["1996", "1997", "1998", "1999", "2000"],
    "FE400E Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "FE450 Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "FE450E Base": ["2004", "2005", "2006", "2007", "2008"],
    "FE501 Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2013",
      "2014",
    ],
    "FE501E Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "FE550E Base": ["2004", "2005", "2006", "2007", "2008"],
    "FE570 Base": ["2009", "2010", "2011", "2012"],
    "FE600 Base": ["1993", "1994", "1995", "1996"],
    "FE600E Base": ["1996", "1997", "1998", "1999", "2000"],
    "FE650E Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "FS450E Base": ["2004", "2005", "2006", "2007", "2008"],
    "FS600E Base": ["1998", "1999"],
    "FS650C Base": ["2005", "2006", "2007", "2008"],
    "FS650E Base": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "Fx450 Base": ["2010", "2011"],
    "Fx470E Base": ["2001", "2002"],
    "Fx501E Base": ["1997", "1998"],
    "Fx600E Base": ["1997", "1998", "1999", "2000"],
    "Fx650E Base": ["2001", "2002", "2003"],
    "Te125 Base": ["2012", "2013"],
    "Te250 Base": ["2011", "2012", "2013", "2014"],
    "Te300 Base": ["2011", "2012", "2013", "2014"],
  },
  Husqvarna: {
    "701 Enduro": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ae 430": ["1986", "1987", "1988"],
    "Automatic GP 360": ["1976", "1977"],
    CR125: [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    CR150: ["2011", "2012"],
    CR250: [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1986",
      "1987",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    CR360: ["1975", "1976"],
    CR390: ["1977", "1978", "1979", "1980"],
    CR430: ["1981", "1982", "1987", "1988"],
    CR50: ["1998", "1999", "2000", "2001", "2002"],
    CR500: ["1983", "1984"],
    "FC 250": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "FC 350": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "FC 450": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "FE 250": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "FE 350": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FE 350S": [
      "2015",
      "2016",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "FE 450": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "FE 501": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "FE 501S": ["2015", "2016", "2020", "2021", "2022", "2023", "2024", "2025"],
    FS450: ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "FX 350": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "FX 450": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "OR 250": ["1978", "1979", "1980"],
    "OR 390": ["1978", "1979", "1980"],
    "SM 125": ["2009", "2010"],
    "SM 630": ["2010", "2011"],
    SM450R: ["2003", "2004", "2006", "2007", "2008", "2009", "2010"],
    SM510R: ["2004", "2005", "2006", "2007", "2009", "2010"],
    "SMR 610": ["2000", "2001", "2006", "2007", "2008"],
    "TC 125": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TC 250": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TC 449": ["2011", "2012", "2013"],
    "TC 450": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "TC 50": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TC 510": ["1987", "1988", "2004", "2005", "2006", "2007", "2008", "2009"],
    "TC 610": ["1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "TC 65": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TC 85 (17/14)": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TE 125": ["2014", "2015", "2016"],
    "TE 150": ["2017", "2018", "2019", "2020"],
    "TE 250": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "TE 300": ["2014", "2015", "2016", "2017", "2018"],
    "Te 310": ["2008", "2009", "2010", "2011", "2012"],
    "Te 410": ["1996", "1997", "1998", "1999", "2000", "2001"],
    "Te 449": ["2011", "2012", "2013"],
    "Te 450": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Te 510": [
      "1986",
      "1987",
      "1988",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Te 511": ["2011", "2012", "2013"],
    "Te 570": ["2001", "2002", "2003", "2004"],
    "Te 610": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Te 630": ["2010", "2011"],
    "TX 300": ["2017", "2018", "2019"],
    "TX 510": ["1986", "1987", "1988"],
    "TXC 250": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "TXC 310": ["2012", "2013"],
    "TXC 450": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "TXC 510": ["2008", "2009", "2010", "2011"],
    "TXC 511": ["2011", "2012", "2013"],
    "WR 125": [
      "1982",
      "1983",
      "1984",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "WR 250": [
      "1972",
      "1973",
      "1974",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1986",
      "1987",
      "1988",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "WR 300": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "WR 360": [
      "1976",
      "1977",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "WR 390": ["1979", "1980"],
    "WR 400": ["1974", "1975"],
    "WR 430": ["1981", "1982", "1983", "1987", "1988"],
    "WR 500": ["1983", "1984"],
    "WRE 125": ["2009", "2010", "2011", "2012"],
    "Wxc 125": ["1996", "1997"],
    "Wxc 250": ["1992", "1993", "1996", "1997"],
    "Wxc 350": ["1992", "1993"],
    "Wxc 360": ["1992", "1993", "1996", "1997"],
    "Wxc 410": ["1996", "1997"],
    "Wxc 610": ["1992", "1993", "1996", "1997"],
    "Wxe 125": ["1990", "1991", "1992", "1994", "1995", "1996", "1997"],
    "Wxe 250": ["1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "Wxe 350": ["1992", "1993", "1994", "1995"],
    "Wxe 360": ["1992", "1993", "1994", "1995", "1996", "1997"],
    "Wxe 410": ["1996", "1997"],
    "Wxe 610": ["1993", "1994", "1995", "1996", "1997"],
    "XC 125": ["1982", "1983", "1984"],
    "XC 250": ["1981", "1982", "1983", "1984", "1986", "1987", "1988"],
    "XC 430": ["1981", "1982", "1987", "1988"],
    "Xc 500": ["1986", "1987"],
    "FE501 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "FE501S Base": ["2015", "2016"],
    "TC125 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "TC250 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "TC85 17/14 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "Te125 Base": ["2014", "2015", "2016"],
    "Te250 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Te300 Base": ["2014", "2015", "2016", "2017", "2018"],
    "Norden 901": ["2022", "2023", "2024"],
    "FC 450 Rockstar Edition": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "FR 450 Rally": ["2016", "2017", "2019", "2020", "2021", "2022", "2023"],
    "701 Supermoto": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Svartpilen 401": ["2017", "2018", "2019", "2020", "2021"],
    "Svartpilen 701": ["2019", "2020", "2021"],
    "Vitpilen 401": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "TX 300i": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "TE 150i": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "TE 250i": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "TE 300i": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "TC 570": ["2001", "2002"],
    "TX 125": ["2017", "2018", "2019"],
    "SM 610": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "TC 85 (19/16)": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "EE 5": ["2020", "2021", "2022", "2023", "2024"],
    SM570R: ["2001", "2002", "2003", "2004"],
    "TE 610E": ["1999", "2000", "2001"],
    "Vitpilen 701": ["2020", "2021"],
    "SMS 630": ["2010", "2011"],
    "701 Enduro LR": ["2021", "2022"],
    "SM 630 Base": ["2010", "2011"],
    "SMR 610 Base": ["2006", "2007", "2008"],
    "TE410 Base": ["1998", "1999", "2000", "2001"],
    "TE610 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "TE630 Base": ["2010", "2011"],
    "TX510 Base": ["1984", "1985", "1986", "1987", "1988"],
    "701 Enduro Base": ["2016", "2017", "2018"],
    "701 Supermoto Base": ["2016", "2017", "2018", "2019", "2020"],
    "AE430 Base": ["1986", "1987", "1988"],
    "CR125 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "CR150 Base": ["2011", "2012"],
    "CR250 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "CR430 Base": ["1981", "1982", "1987", "1988"],
    "CR50 Base": ["1998", "1999", "2000", "2001", "2002"],
    "CR500 Base": ["1983", "1984", "1985", "1986"],
    "FC250 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "FC350 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "FC450 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "FE250 Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "FE350 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "FE450 Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "FS450 Base": ["2017", "2018", "2019", "2020"],
    "FX350 Base": ["2017", "2018", "2019", "2020"],
    "Fx450 Base": ["2017", "2018", "2019", "2020"],
    "HUV 4210 G Base": ["2005", "2006"],
    "HUV 4210 GXP Base": ["2005", "2006"],
    "HUV 4421 D Base": ["2006", "2007", "2008", "2009"],
    "HUV 4421 DXP Base": ["2006", "2007", "2008", "2009"],
    "HUV 4421 G Base": ["2006", "2007", "2008", "2009"],
    "HUV 4421 GXP Base": ["2006", "2007", "2008", "2009"],
    "SM 125 Base": ["2009", "2010"],
    "SM 50 Base": ["2011", "2012"],
    "SMR 450 Base": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "SMR 510 Base": ["2005", "2006", "2007", "2008", "2009"],
    "Svartpilen 401 Base": ["2018", "2019", "2020"],
    "Svartpilen 701 Base": ["2019", "2020"],
    "TC449 Base": ["2011", "2012", "2013"],
    "TC450 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "TC50 Base": ["2017", "2018", "2019", "2020"],
    "TC500 Base": ["1985", "1986"],
    "TC510 Base": [
      "1987",
      "1988",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "TC610 Base": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "TC65 Base": ["2017", "2018", "2019", "2020"],
    "TC85 19/16 Base": ["2014", "2015", "2019", "2020"],
    "TE150 Base": ["2017", "2018", "2019"],
    "TE250i Base": ["2018", "2019", "2020"],
    "TE300i Base": ["2019", "2020"],
    "TE310 Base": ["2009", "2010", "2011", "2012"],
    "TE449 Base": ["2011", "2012", "2013"],
    "TE450 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "TE510 Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "TE511 Base": ["2011", "2012", "2013"],
    "TE570 Base": ["2001", "2002"],
    "TX300 Base": ["2017", "2018", "2019"],
    "TXC 250 Base": ["2008", "2009", "2010", "2011", "2012"],
    "TXC 450 Base": ["2008", "2009", "2010", "2011"],
    "TXC 510 Base": ["2008", "2009", "2010", "2011"],
    "TXC 511 Base": ["2011", "2012"],
    "Vitpilen 401 Base": ["2018", "2019", "2020"],
    "Vitpilen 701 Base": ["2018", "2019", "2020"],
    "WR125 Base": [
      "1982",
      "1983",
      "1984",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "WR250 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1986",
      "1987",
      "1988",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "WR300 Base": ["2009", "2010", "2011", "2012", "2013"],
    "WR360 Base": ["1998", "1999", "2000", "2001", "2002"],
    "WR400 Base": ["1984", "1985", "1986"],
    "WR430 Base": ["1981", "1982", "1983", "1987", "1988"],
    "WR500 Base": ["1983", "1984"],
    "WRE 125 Base": ["2009", "2010", "2011", "2012"],
    "Wxc 125 Base": ["1996", "1997"],
    "Wxc 250 Base": ["1992", "1993", "1996", "1997"],
    "Wxc 350 Base": ["1992", "1993"],
    "Wxc 360 Base": ["1992", "1993", "1996", "1997"],
    "Wxc 410 Base": ["1996", "1997"],
    "Wxc 610 Base": ["1992", "1993", "1996", "1997"],
    "Wxe 125 Base": ["1990", "1991", "1994", "1995", "1996", "1997"],
    "Wxe 250 Base": ["1990", "1991", "1994", "1995", "1996", "1997"],
    "Wxe 350 Base": ["1994", "1995"],
    "Wxe 360 Base": ["1994", "1995", "1996", "1997"],
    "Wxe 410 Base": ["1996", "1997"],
    "Wxe 610 Base": ["1994", "1995", "1996", "1997"],
    "XC125 Base": ["1982", "1983", "1984", "1985", "1986"],
    "XC250 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "XC430 Base": ["1981", "1982", "1987", "1988"],
    "XC500 Base": ["1984", "1985", "1986", "1987"],
    "SM 610E": ["1998", "1999", "2000", "2001"],
  },
  Hyosung: {
    GD250R: ["2016", "2017", "2018"],
    GT250: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    GT250R: [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    GT650: [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    GT650R: [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    GT650S: ["2005", "2006", "2007", "2008"],
    GV250: [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
    ],
    GV650: [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2016",
      "2017",
      "2018",
    ],
    ST7: ["2010", "2011", "2012", "2013", "2016", "2017", "2018"],
    "ST7 Deluxe": ["2012", "2013", "2016", "2017", "2018"],
    "MS3-250 Base": ["2008", "2009"],
    "GT250 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GT250R Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GT650 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GT650R Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GT650S Base": ["2005", "2006", "2007", "2008"],
    "GV650 Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "GV250 Base": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "GV250 Aquila Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "GV650 Aquila Pro Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "ST7 Base": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "ST7 Deluxe Base": ["2012", "2013", "2014", "2015", "2016"],
    "TE450S Base": ["2008", "2009", "2010"],
    "TE50 Base": ["2006", "2007"],
    "TE90 Base": ["2006", "2007"],
  },
  Indian: {
    Chief: [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2018",
      "2019",
      "2022",
      "2023",
    ],
    "Chief Classic": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Chief Dark Horse": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Chief Roadmaster": ["2009", "2010", "2011"],
    "Chief Vintage": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    Chieftain: [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Chieftain Dark Horse": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Chieftain Limited": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    Roadmaster: [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Roadmaster Classic": ["2017", "2018", "2019"],
    Scout: [
      "2001",
      "2002",
      "2003",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Scout Sixty": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    Spirit: ["2001", "2002", "2003"],
    Springfield: [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Scout Bobber": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Scout Bobber Twenty": ["2022", "2023"],
    "Scout Rogue": ["2022", "2023"],
    "FTR Championship Edition": ["2022", "2023"],
    FTR1200: ["2019", "2020", "2021", "2022", "2023"],
    "FTR1200 Rally": ["2022", "2023"],
    "FTR1200R Carbon": ["2022", "2023"],
    FTR1200S: ["2019", "2020", "2021", "2022"],
    "Chieftain Classic": ["2018", "2019", "2020"],
    "Chieftain Elite": ["2020", "2021", "2022", "2023"],
    "Roadmaster Dark Horse": ["2020", "2021", "2022", "2023"],
    "Roadmaster Elite": ["2018", "2019", "2020", "2021"],
    Challenger: ["2020", "2021", "2022", "2023"],
    "Challenger Dark Horse": ["2021", "2022", "2023"],
    "Challenger Limited": ["2021", "2022", "2023"],
    "Chief Bobber": ["2022", "2023"],
    "Chief Bobber Dark Horse": ["2022", "2023"],
    "Roadmaster Limited": ["2022", "2023"],
    "Springfield Dark Horse": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Chief Base": ["1999", "2000", "2001", "2002", "2003"],
    "Chief Classic Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Chief Dark Horse Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Chief Roadmaster Base": ["2009", "2010", "2011"],
    "Chief Vintage Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Chieftain Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Chieftain Classic Base": ["2018", "2019", "2020"],
    "Chieftain Dark Horse Base": ["2017", "2018", "2019", "2020", "2021"],
    "Chieftain Elite Base": ["2017", "2018", "2020", "2021"],
    "Chieftain Limited Base": ["2017", "2018", "2019", "2020", "2021"],
    "FTR 1200 Base": ["2019", "2020"],
    "FTR 1200 S Base": ["2019", "2020"],
    "Roadmaster Base": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "Roadmaster Classic Base": ["2017", "2018"],
    "Roadmaster Elite Base": ["2018", "2019", "2020", "2021"],
    "Scout Base": [
      "2001",
      "2002",
      "2003",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Scout Bobber Base": ["2018", "2019", "2020"],
    "Scout Sixty Base": ["2016", "2017", "2018", "2019", "2020"],
    "Spirit Base": ["2001", "2002", "2003"],
    "Springfield Base": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "Springfield Dark Horse Base": ["2018", "2019", "2020", "2021"],
    "Challenger Base": ["2020", "2021"],
    "Challenger Dark Horse Base": ["2020", "2021"],
    "Challenger Limited Base": ["2020", "2021"],
    "Roadmaster Dark Horse Base": ["2020", "2021"],
  },
  Kawasaki: {
    "A1 Samurai": ["1966", "1967", "1968", "1969", "1970", "1971"],
    "A1 SS": ["1967", "1968", "1969", "1970", "1971"],
    "A7 Avenger": ["1967", "1968", "1969", "1970", "1971"],
    "A7 SS": ["1967", "1968", "1969", "1970", "1971"],
    "BN125 Eliminator": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "C2 SS": ["1967", "1968", "1969"],
    "C2 TR": ["1967", "1968", "1969"],
    "EL250 Eliminator": [
      "1988",
      "1989",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "EN450A 454 Ltd": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "EN500 Vulcan 500": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "EN500C Vulcan 500 Ltd": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "EN650 Vulcan S": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "ER-6N": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "EX250F Ninja 250R": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "EX300F Ninja 300": ["2013", "2014", "2015", "2016", "2017"],
    EX500: ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "EX500 Ninja 500": ["1994", "1995", "1996", "1997"],
    "EX500 Ninja 500R": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "EX650 Ninja 650": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "EX650 Ninja 650 ABS": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "EX650 Ninja 650R": ["2006", "2007", "2008", "2009", "2010", "2011"],
    F11: ["1973", "1974", "1975"],
    "F3 Bushwhacker": ["1968", "1969", "1970"],
    F4: ["1969", "1970"],
    F5: ["1970", "1971"],
    "F5 Big Horn": ["1970", "1971"],
    F6: ["1971", "1972", "1973"],
    F7: ["1971", "1972", "1973", "1974", "1975"],
    F8: ["1971", "1972"],
    F9: ["1972", "1973", "1974", "1975"],
    G31M: ["1970", "1971"],
    G3SS: ["1969", "1970", "1971", "1972", "1973", "1974"],
    G3TR: ["1969", "1970"],
    G4TR: ["1970", "1971", "1972", "1973", "1974", "1975"],
    G5: ["1972", "1973", "1974", "1975"],
    "H1 Mach III": ["1969", "1970", "1971", "1972", "1973", "1974", "1975"],
    "H2 Mach IV": ["1972", "1973", "1974", "1975"],
    "KD 100": ["1976", "1977", "1978", "1979"],
    "KD 125": ["1975", "1976", "1977", "1978", "1979"],
    "KD 175": ["1976", "1977", "1978", "1979"],
    "KD 80": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "KDX 175": ["1980", "1981", "1982"],
    "KDX 200": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "KDX 220R": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "KDX 250": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "KDX 400": ["1979", "1980"],
    "KDX 50": ["2003", "2004", "2005", "2006"],
    "KDX 80": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "KE 100": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "KE 125": ["1976", "1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    "KE 175": ["1976", "1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    "KE 250": ["1977", "1978", "1979"],
    KH100: ["1976", "1977"],
    KH400: ["1976", "1977", "1978"],
    KL250: [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "KL250 Super Sherpa": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2009",
      "2010",
    ],
    KL600: [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "KL650B Tengai": ["1990", "1991"],
    "KLE300 Versys-X 300 ABS": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KLE650 Versys": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "KLE650 Versys LT": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    KLR250: [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    KLR650: [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2022",
      "2023",
      "2024",
    ],
    KLX110: [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    KLX110L: [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    KLX125: ["2003", "2004", "2005", "2006"],
    KLX125L: ["2003", "2004", "2005", "2006"],
    KLX140: [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    KLX140G: ["2017", "2018", "2019", "2020", "2021"],
    KLX140L: [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    KLX250: ["1979", "1980", "2018", "2019", "2020", "2021"],
    KLX250R: ["1994", "1995", "1996"],
    KLX250S: [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2018",
      "2019",
      "2020",
    ],
    KLX250SF: ["2009", "2010"],
    KLX300R: [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    KLX450R: [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    KLX650: ["1993", "1994", "1995", "1996"],
    KLX650R: ["1993", "1994", "1995", "1996"],
    "KLZ1000 Versys": ["2015", "2016"],
    "KLZ1000 Versys LT": ["2015", "2016", "2017", "2018", "2019"],
    Km100: ["1976", "1977", "1978", "1979", "1980", "1981"],
    KS125: ["1974", "1975"],
    "KT 250": ["1975", "1976"],
    KV75: [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    KX100: [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    KX125: [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    KX250: [
      "1974",
      "1975",
      "1976",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    KX250F: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    KX400: ["1975", "1976"],
    KX420: ["1980", "1981"],
    KX450F: [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    KX500: [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    KX60: [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    KX65: [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    KX80: [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "KX80 Big Wheel": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    KX85: [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "KZ1000A/J": ["1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    "KZ1000B/K Ltd": ["1977", "1978", "1979", "1980", "1981", "1982"],
    "KZ1000D Z1R": ["1978", "1979", "1980"],
    "KZ1000E Shaft": ["1978", "1979", "1980"],
    "KZ1000M CSR": ["1981", "1982"],
    "KZ1000R Lawson Replica": ["1982", "1983"],
    KZ1100A: ["1981", "1982", "1983"],
    "KZ1100B GPz": ["1981", "1982"],
    "KZ1100D Spectre": ["1982", "1983"],
    KZ1300: ["1979", "1980", "1981", "1982", "1983"],
    KZ200: ["1978", "1979"],
    KZ250: ["1980", "1981", "1982", "1983"],
    "KZ305 CSR": ["1981", "1982"],
    "KZ305B Ltd": ["1987", "1988"],
    "KZ400A Deluxe": ["1977", "1978"],
    KZ400B: ["1978", "1979"],
    KZ400D: ["1974", "1975", "1976", "1977"],
    "KZ400S Special": ["1975", "1976", "1977"],
    "KZ440A Ltd": ["1980", "1981", "1982", "1983"],
    "KZ440B/G": ["1980", "1981", "1982"],
    "KZ440D Ltd Belt": ["1980", "1981", "1982", "1983"],
    KZ550A: ["1980", "1981", "1982", "1983"],
    "KZ550C Ltd": ["1980", "1981", "1982", "1983"],
    "KZ550D/H GPz": ["1981", "1982", "1983", "1984"],
    "KZ650B/F": ["1977", "1978", "1979", "1980"],
    "KZ650C Custom": ["1977", "1978", "1979"],
    "KZ650D SR": ["1978", "1979"],
    "KZ650H CSR": ["1978", "1979", "1980", "1981", "1982", "1983"],
    KZ700A: ["1984", "1985"],
    "KZ750B [2Cyl]": ["1976", "1977", "1978", "1979", "1980", "1981", "1982"],
    "KZ750E [2Cyl]": ["1980", "1981", "1982"],
    "KZ750H Ltd [4Cyl]": ["1980", "1981", "1982", "1983"],
    "KZ750K Ltd Belt [2Cyl]": ["1983", "1984"],
    "KZ750N Spectre [4Cyl]": ["1982", "1983"],
    "KZ900/Z1": ["1973", "1974", "1975", "1976", "1977"],
    MC1: ["1973", "1974", "1975"],
    MC1M: ["1974", "1975"],
    MT1: ["1971", "1972", "1974", "1975"],
    "Ninja H2": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ninja H2-R": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ninja ZX-10R": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ninja ZX-10RR": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "S1 Mach I": ["1973", "1974", "1975"],
    "S2 Mach II": ["1972", "1973"],
    "S3 Mach II": ["1974", "1975"],
    "VN1500A Vulcan 1500": ["1996", "1997", "1998", "1999"],
    "VN1500A Vulcan 88": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "VN1500B Vulcan 88 SE": ["1987", "1988", "1989", "1990"],
    "VN1500C Vulcan L": ["1996", "1997"],
    "VN1500E Vulcan 1500 Classic": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "VN1500G Vulcan 1500 Nomad": ["1998", "1999", "2000", "2001"],
    "VN1500J/R Vulcan 1500 Drifter": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "VN1500L Vulcan Nomad Fi": ["2000", "2001", "2002", "2003", "2004"],
    "VN1500N Vulcan 1500 Classic Fi": ["2000", "2001", "2002"],
    "VN1500P Vulcan 1500 Mean Streak": ["2002", "2003"],
    "VN1600A Vulcan 1600 Classic": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "VN1600B Vulcan 1600 Mean Streak": ["2004", "2005", "2006", "2007", "2008"],
    "VN1600D Vulcan 1600 Nomad": ["2005", "2006", "2007", "2008"],
    "VN1700 Vulcan 1700 Classic": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "VN1700 Vulcan 1700 Classic LT": ["2009", "2010"],
    "VN1700 Vulcan 1700 Nomad": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "VN1700 Vulcan 1700 Vaquero": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "VN1700 Vulcan 1700 Voyager": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "VN2000A Vulcan 2000": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "VN2000D Vulcan 2000 Limited": ["2005", "2006"],
    "VN2000E Vulcan 2000 Classic": ["2006", "2007", "2008", "2009", "2010"],
    "VN2000F Vulcan 2000 Classic LT": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "VN700A Vulcan": ["1984", "1985"],
    "VN750A Vulcan 750": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "VN800A Vulcan 800": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "VN800B Vulcan 800 Classic": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "VN800E Vulcan 800 Drifter": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "VN900B Vulcan 900 Classic": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "VN900C Vulcan 900 Custom": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "VN900D Vulcan 900 Classic LT": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    W1: ["1966", "1967"],
    W1SS: ["1968", "1969"],
    "W2SS Commander": ["1968", "1969"],
    W650: ["2000", "2001"],
    Z1: ["1972", "1973", "1974", "1975"],
    Z1000: [
      "1974",
      "1975",
      "1981",
      "1982",
      "1983",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
    ],
    "Z125 Pro": ["2017", "2018", "2019", "2020", "2021"],
    Z650: ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Z750: [
      "1981",
      "1982",
      "1984",
      "1985",
      "1986",
      "1987",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    Z750R: ["2011", "2012"],
    Z750S: ["2005", "2006"],
    Z800: ["2016", "2017"],
    Z900: ["2017", "2018", "2019", "2020", "2021", "2022"],
    "ZG1000 Concours": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "ZG1200 Voyager XII": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "ZG1400 Concours": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "ZG1400 Concours ABS": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "ZL1000 Eliminator": ["1987", "1988"],
    "ZL600 Eliminator": ["1986", "1987", "1995", "1996", "1997", "1998"],
    "ZL900A Eliminator": ["1985", "1986"],
    "ZN1100B Ltd": ["1984", "1985"],
    "ZN1300 Voyager": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "ZN700A Ltd": ["1984", "1985"],
    "Zr-7": ["1999", "2000", "2001", "2002", "2003"],
    "Zr-7S": ["2001", "2002", "2003", "2004", "2005"],
    ZR1100: ["1992", "1993", "1994", "1995"],
    "ZR550 Zephyr": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "ZR750C Zephyr": ["1991", "1992", "1993"],
    ZRX1100: ["1996", "1997", "1998", "1999", "2000"],
    ZRX1200: ["2001", "2002", "2003", "2004", "2005", "2006"],
    "ZX1000 Ninja 1000": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "ZX1000 Ninja 1000R": ["1985", "1986", "1987"],
    "ZX1000 Ninja ZX-10": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "ZX1100 GPz": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "ZX1100 Ninja ZX-11": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "ZX1200 Ninja ZX-12R": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "ZX1400 Ninja ZX-14R": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "ZX550 GPz": ["1984", "1985"],
    "ZX600 Ninja 600R": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "ZX600 Ninja ZX-6": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "ZX600 Ninja ZX-6R": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "ZX600 Ninja ZX-6RR": ["2003", "2004", "2005", "2006", "2024", "2025"],
    "ZX600 ZZ-R 600": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "ZX636 Ninja ZX-6R": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "ZX750 GPz": ["1982", "1983", "1984", "1985"],
    "ZX750 Ninja ZX-7": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "ZX750 Ninja ZX-7R": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "ZX750 Ninja ZX-7RR": ["1996", "1997", "1998", "1999"],
    "ZX750E Turbo GPz 750": ["1984", "1985"],
    "ZX750F Ninja 750R": ["1987", "1988", "1989", "1990"],
    "ZX900 Ninja": ["1984", "1985", "1986"],
    "ZX900 Ninja ZX-9R": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "ZZ-R 1200": ["2002", "2003", "2004", "2005"],
    "KVF750 Brute Force 4X4i EPS [IRS]": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "KVF750 Brute Force 4X4i [IRS]": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KFX 450R": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "KRF 750 Teryx 4x4 LE": ["2008", "2009", "2010"],
    "KRF 750 Teryx FI 4X4": ["2009", "2010", "2011", "2012", "2013"],
    "KRF 750 Teryx FI 4X4 LE": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "KRF 750 Teryx FI 4X4 Sport": ["2009", "2010", "2011", "2012", "2013"],
    "KRT 750 Teryx4 4X4": ["2012", "2013"],
    "KRT 750 Teryx4 4X4 EPS": ["2012", "2013"],
    "KRT 750 Teryx4 4X4 EPS LE": ["2012", "2013"],
    "KZ1000C/P Police": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "EN650 Vulcan S Caf\u00e9": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "EX400 Ninja 400": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "EX400 Ninja 400 ABS": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KLF400 Bayou 4X4 [SRA]": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "KLZ1000 Versys SE LT+": ["2019", "2020", "2021", "2022", "2023"],
    "KVF300 Prairie 4X4 [SRA]": ["1999", "2000", "2001", "2002"],
    "KVF300B Prairie 2X4 [SRA]": ["1999", "2000", "2001", "2002"],
    "KVF400B Prairie 2X4 [SRA]": ["2000", "2001", "2002"],
    "KVF400C Prairie 4X4 [SRA]": ["1999", "2000", "2001", "2002"],
    "Ninja H2 Carbon": ["2020", "2021", "2022", "2023"],
    "Ninja ZX-10R ABS KRT Edition": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Ninja ZX-10R KRT Edition": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    STX: ["2009", "2010"],
    "STX-12F": ["2003", "2004", "2005", "2006", "2007"],
    "STX-15F": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Ultra 160 LX": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "VN1500D Vulcan 1500 Classic": ["1996", "1997"],
    Z1000SX: [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Z400 ABS": ["2019", "2020", "2021", "2022", "2023"],
    "Z900 ABS": ["2020", "2021", "2022", "2023", "2024"],
    "Z900 RS": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "ZX1000 Ninja H2 SX SE+": ["2019", "2020", "2021", "2022"],
    "ZX1400 Ninja ZX-14R SE": ["2016", "2017", "2018"],
    KX250X: ["2021", "2022", "2023", "2024", "2025"],
    KX450X: ["2021", "2022", "2023", "2024", "2025"],
    "KFX 700": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "KVF360A Prairie 4X4 [SRA]": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "KVF360B Prairie 2X4 [SRA]": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "KVF650 Brute Force 4X4 [SRA]": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "KVF650 Brute Force 4X4i [IRS]": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
    ],
    "KVF650 Prairie 4X4 [SRA]": ["2002", "2003"],
    "KVF700 Prairie 4X4 [SRA]": ["2004", "2005", "2006"],
    "SX-R": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Ultra 250X": ["2007", "2008"],
    "Ultra 260LX": ["2009", "2010"],
    "Ultra 260X": ["2009", "2010"],
    "Ultra 300LX": ["2011", "2012", "2013"],
    "Ultra 300X": ["2011", "2012", "2013"],
    "Ultra 310LX": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Ultra 310R": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Ultra 310X": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KFX 400": ["2003", "2004", "2005", "2006"],
    "KAF 300 Mule 520": ["2000", "2001"],
    "KAF 300 Mule 550": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "KAF 400 Mule 600": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "KAF 400 Mule 610 4X4": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "KAF 400 Mule 610 4X4 XC": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "KAF 620 Mule 2500": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "KAF 620 Mule 2510 4X4": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "KAF 620 Mule 2520": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "KAF 620 Mule 3000": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "KAF 620 Mule 3010 4X4": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "KAF 620 Mule 3010 Trans 4X4": ["2005", "2006", "2007", "2008"],
    "KAF 620 Mule 3020": ["2001", "2002", "2003"],
    "KAF 620 Mule 4000": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KAF 620 Mule 4010 4X4": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "KAF 620 Mule 4010 Trans 4X4": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KEF 300 Lakota Sport [SRA]": ["2001", "2002", "2003"],
    "KEF 300 Lakota Utility [SRA]": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "KLF220 Bayou [SRA]": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "KLF250 Bayou [SRA]": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "KLF300A Bayou 2x4 [SRA]": ["1986", "1987"],
    "KLF300B Bayou 2X4 [SRA]": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "KLF300C Bayou 4X4 [SRA]": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    KLT200A: ["1981", "1982", "1983"],
    "KSF250 Mojave": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    KLX110R: ["2021", "2022", "2023", "2024", "2025"],
    "KLX110R L": ["2021", "2022", "2023", "2024", "2025"],
    KLX150L: ["2014", "2015", "2016", "2017", "2018", "2019"],
    KLX230: ["2020", "2021", "2022", "2023"],
    "KLX230 ABS": ["2020", "2021"],
    KLX230R: ["2020", "2021", "2022", "2023", "2024"],
    "KLX230R S": ["2021", "2022", "2023"],
    "VN2000A Vulcan 2000 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "VN2000D Vulcan 2000 Limited Base": ["2005", "2006"],
    "ZX1000 Ninja ZX-10R Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "ZX1400 Ninja ZX-14 Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "ZX1400 Ninja ZX-14R Base": ["2012", "2013", "2014"],
    "ZX1400 Ninja ZX-14R ABS Base": ["2013", "2014", "2015", "2016", "2017"],
    "ZX1400 Ninja ZX-14R ABS SE Base": ["2016", "2017", "2018"],
    "ZX600 Ninja ZX-6R Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "EX250F Ninja 250R Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "EX300 Ninja 300 Base": ["2013", "2014", "2015", "2016", "2017"],
    "EX300 Ninja 300 ABS Base": ["2013", "2014", "2015", "2016", "2017"],
    "EX300 Ninja 300 SE Base": ["2014", "2015"],
    "EX650 Ninja 650 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "EX650 Ninja 650 ABS Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "EX650 Ninja 650R Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "KLE650 Versys Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "KLE650 Versys ABS Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KLE650 Versys ABS LT Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KLR650 Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "KLZ1000 Versys LT Base": ["2015", "2016", "2017", "2018"],
    "Z1000 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Z750S Base": ["2005", "2006"],
    "ZX1000 Ninja 1000 Base": ["2011", "2012", "2013"],
    "ZX1000 Ninja 1000 ABS Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "ZX1000 Ninja ZX-10R ABS Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "ZX600 Ninja ZX6-RR Base": ["2003", "2004", "2005", "2006"],
    "ZX636 Ninja ZX-6R Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "ZX636 Ninja ZX-6R ABS Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KAF1000 Mule PRO-DX Diesel Base": ["2016", "2017"],
    "KAF1000 Mule PRO-DX EPS Diesel Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KAF1000 Mule PRO-DX EPS LE Diesel Base": ["2016", "2017"],
    "KAF1000 Mule PRO-DXT Diesel Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KAF1000 Mule PRO-DXT EPS Diesel Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KAF1000 Mule PRO-DXT EPS LE Diesel Base": ["2016", "2017"],
    "KAF820 Mule PRO-FX Base": ["2016", "2017", "2018", "2019", "2020"],
    "KAF820 Mule PRO-FX EPS Base": ["2016", "2017", "2018", "2019", "2020"],
    "KAF820 Mule PRO-FX EPS Camo Base": ["2016", "2017"],
    "KAF820 Mule PRO-FX EPS LE Base": ["2016", "2017", "2018", "2019", "2020"],
    "KAF820 Mule PRO-FXR Base": ["2018", "2019", "2020"],
    "KAF820 Mule PRO-FXT Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KAF820 Mule PRO-FXT EPS Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KAF820 Mule PRO-FXT EPS Camo Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KAF820 Mule PRO-FXT EPS LE Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KAF820 Mule PRO-FXT Ranch Edition Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KAF950 Mule 2510 Diesel Base": ["2000", "2001", "2002"],
    "KAF950 Mule 3010 Diesel 4x4 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "KAF950 Mule 3010 Trans 4x4 Diesel Base": ["2007", "2008"],
    "KAF950 Mule 4010 Diesel 4x4 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "KAF950 Mule 4010 Trans 4x4 Diesel Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "KRF1000 Teryx KRX 1000 Base": ["2020", "2021"],
    JS440: [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    JS550: ["1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989"],
    "KRF 800 Teryx": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KRF 800 Teryx LE": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KRT 800 Teryx4": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "KRT 800 Teryx4 LE": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    KX450SR: ["2022", "2023", "2024", "2025"],
    "KRX 1000 Teryx": ["2020", "2021", "2022", "2023", "2024"],
    "KRX 1000 Teryx eS": ["2023", "2024"],
    "KRX 1000 Teryx SE": ["2021", "2022", "2023", "2024"],
    "KRX 1000 Teryx Trail": ["2021", "2022", "2023", "2024"],
    "KRX 1000 Teryx4": ["2020", "2021"],
    "KRX 1000 Teryx4 eS": ["2023", "2024"],
    "KRX 1000 Teryx4 SE": ["2023", "2024"],
    "KRX 1000 Teryx4 SE eS": ["2023", "2024"],
    "KX 85 Big Wheel": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    KX112: ["2022", "2023", "2024", "2025"],
    KLX140R: ["2021", "2022", "2023", "2024", "2025"],
    "Z900 RS ABS": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "KAF 620 Mule 4000 Trans": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "KAF 820 Mule Pro-Fxt": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KAF 820 Mule Pro-Fxt EPS": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KAF 820 Mule Pro-Fxt EPS LE": ["2020", "2021", "2022", "2023"],
    "KAF 400 Mule SX 4X4": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "KAF 400 Mule SX 4X4 XC": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "KAF 700 Mule Pro-MX": ["2019", "2020", "2021", "2022"],
    "KAF 820 Mule Pro-Fx": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KAF 820 Mule Pro-FXR": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "KAF 400 Mule SX 4x4 XC LE": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Z H2": ["2020", "2021", "2022", "2023"],
    "KLX140R L": ["2021", "2022", "2023", "2024", "2025"],
    KLX300SM: ["2021", "2022", "2023", "2024"],
    "KAF 950 Mule 2510 Diesel": ["2000", "2001", "2002"],
    "KAF 820 Mule Pro-Fx EPS": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KAF 820 Mule Pro-FX EPS LE": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "KAF 990 Mule Pro-Dx Diesel": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KAF 990 Mule Pro-Dx Diesel EPS": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "KAF 990 Mule Pro-Dx Diesel EPS FE": ["2021", "2022"],
    "KAF 990 Mule Pro-Dx Diesel EPS LE": ["2018", "2019", "2020", "2021"],
    "KAF 990 Mule Pro-Dxt Diesel": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "KAF 990 Mule Pro-Dxt Diesel EPS": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "KAF 990 Mule Pro-Dxt Diesel EPS LE": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "KVF300 Brute Force [SRA]": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KLR650 Adventure": ["2022", "2023", "2024"],
    "KLR650 Traveler ABS": ["2022", "2023"],
    KLX400SR: ["2003", "2004"],
    "KVF400A Prairie 4X4 [SRA]": ["1997", "1998"],
    "KVF400D Prairie 2X4 [SRA]": ["1999", "2000", "2001", "2002"],
    "KXF 250 Tecate 4": ["1987", "1988"],
    "KAF 700 Mule Pro-MX EPS": ["2019", "2020", "2021", "2022", "2023"],
    "KAF 700 Mule Pro-MX EPS LE": ["2019", "2020", "2021", "2022", "2023"],
    "W800 Cafe": ["2019", "2020", "2021", "2022"],
    "ZX1000 Ninja H2 SX": ["2018", "2019", "2020", "2021"],
    "1100 STX": ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "1200 STX-R": ["2002", "2003", "2004", "2005"],
    "900 STX": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "800 SX-R": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Ultra 130": ["2001", "2002", "2003", "2004"],
    "Ultra 150": ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    SS: ["1992", "1993", "1994", "1995", "1996", "1997"],
    "Xi Sport": ["1998", "1999"],
    "1100 ZXi": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "750 ZXi": ["1995", "1996", "1997"],
    "900 ZXi": ["1995", "1996", "1997"],
    "650 SX": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "300 SX": ["1987", "1988", "1989", "1990", "1991"],
    JS300: ["1986", "1987", "1988"],
    "Ninja H2 SX SE": ["2022", "2023"],
    "ZX1000 Ninja 1000 SX": ["2022", "2023"],
    "ZX1400 Ninja ZX-14R ABS": ["2022", "2023", "2024"],
    "KAF 620 mule 4010 Diesel": ["2009", "2010", "2011", "2012", "2013"],
    "KAF 950 Mule 4010 Diesel 4X4": ["2009", "2010", "2011", "2012", "2013"],
    "KAF 950 Mule 4010 Trans 4X4 Diesel": ["2009", "2010", "2011"],
    "KXT 250 Tecate": ["1984", "1985", "1986", "1987"],
    "KAF 700 Mule Pro-MX EPS SE": ["2022", "2023"],
    "KFX 90": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KFX 50": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    KLX230S: ["2022", "2023", "2024"],
    "KFX 80": ["2003", "2004", "2005", "2006"],
    "Jet Mate": ["1989", "1990", "1991", "1992"],
    SC: ["1991", "1992", "1993", "1994", "1995"],
    TS: ["1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996"],
    X2: [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "750 STS": ["1995", "1996", "1997"],
    "750 SX": ["1992", "1993", "1994", "1995"],
    "750 SXi": ["1995", "1996"],
    "750 SXi Pro": ["1998", "1999", "2000", "2001", "2002"],
    ST: ["1994", "1995"],
    "900 STS": ["2001", "2002"],
    "550 SX": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "Super Sport Xi": ["1993", "1994", "1995", "1996", "1997"],
    "KAF 620 Mule 4010 Trans 4X4 FE": ["2021", "2022", "2023"],
    "KAF 950 Mule 3010 Diesel 4X4": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "KAF 990 Mule Pro-Dxt Diesel EPS FE": ["2022", "2023"],
    "KAF 400 Mule SX 2X4": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "KVF360C Prairie 4X4 [SRA]": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "KAF 400 Mule SX 4X4 FE": ["2023", "2024"],
    "KAF 620 Mule 4010 4X4 FE": ["2021", "2022", "2023", "2024"],
    "KRF 800 Teryx S LE": ["2021", "2022", "2023", "2024"],
    "KLX140R F": ["2021", "2022", "2023", "2024"],
    "KAF 620 mule 3010 diesel": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "KAF 620 Mule 4010 4X4 SE": ["2016", "2017", "2018"],
    "KAF 620 Mule 4010 Trans 4X4 SE": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KAF 400 Mule SX 4X4 SE": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "KAF 400 Mule SX 4X4 XC SE": ["2017", "2018", "2019"],
    "KAF 950 Mule 3010 Trans 4X4 Diesel": ["2007", "2008"],
    "KLF110 Mojave [SRA]": ["1987", "1988"],
    "Ultra 310X SE": ["2014", "2015", "2016", "2017", "2018", "2019"],
    Z250SL: ["2014", "2015", "2016", "2017", "2018"],
    "Z900 SE ABS": ["2022", "2023", "2024"],
    "Z650 ABS": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Z650RS: ["2022", "2023"],
    "ZX636 Ninja ZX-6R KRT Edition": ["2022", "2023", "2024"],
    "Z H2 SE": ["2020", "2021", "2022", "2023"],
    "Z900 RS Cafe": ["2021", "2022", "2023"],
    KLT250C: ["1983", "1984", "1985"],
    "KRT 800 Teryx4 S LE": ["2021", "2022", "2023"],
    "KAF 300 Mule 500": ["1991", "1992", "1993", "1994", "1995"],
    "KLF185 Bayou [SRA]": ["1985", "1986", "1987", "1988"],
    KLT185: ["1986", "1987"],
    KLT110: ["1984", "1985", "1986"],
    "KFX700 Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "KRF750 Teryx 4x4 Base": ["2008", "2009"],
    "KRF750 Teryx FI 4x4 Base": ["2009", "2010", "2011", "2012", "2013"],
    "KRF750 Teryx FI 4x4 LE Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "KRF750 Teryx FI 4x4 LE SGE Base": ["2011", "2012"],
    "KRF750 Teryx FI 4x4 Sport Base": ["2009", "2010", "2011", "2012", "2013"],
    "KRF750 Teryx NRA Outdoors Base": ["2008", "2009"],
    "KRT750 Teryx4 4x4 EPS Base": ["2012", "2013"],
    "KRT750 Teryx4 4x4 EPS LE Base": ["2012", "2013"],
    "KVF650 Brute Force 4x4 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "KVF650 Brute Force 4x4i Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
    ],
    "KVF650 Prairie 4x4 Base": ["2002", "2003"],
    "KVF700 Prairie 4x4 Base": ["2004", "2005", "2006"],
    "KVF750 Brute Force 4x4i Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KVF750 Brute Force 4x4i EPS Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KVF750 Brute Force 4x4i EPS Camo Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "VN800A Vulcan 800 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "VN800B Vulcan 800 Classic Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "VN800E Vulcan 800 Drifter Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "W650 Base": ["2000", "2001"],
    "ZG1400 Concours Base": ["2008", "2009", "2010"],
    "ZG1400 Concours ABS Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "ZRX1100 Base": ["1999", "2000"],
    "ZRX1200 Base": ["2001", "2002", "2003", "2004", "2005"],
    "ZX1100 GPz Base": ["1983", "1984", "1995", "1996", "1997"],
    "ZX1100 Ninja ZX-11 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "ZX1200 Ninja ZX-12R Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "ZZR1200 Base": ["2002", "2003", "2004", "2005"],
    "BN125 Eliminator Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "BR125 Z125 PRO Base": ["2017", "2018", "2019", "2020"],
    "BR125 Z125 PRO KRT Edition Base": ["2017", "2018"],
    "Drifter 340 Base": ["1980", "1981"],
    "Drifter 440 Base": ["1980", "1981"],
    "EL250 Eliminator Base": ["1988", "1989", "1991", "1992"],
    "EN450A 454 Ltd Base": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "EN500 Vulcan 500 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "EN500C Vulcan 500 Ltd Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "EN650 Vulcan S Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "EN650 Vulcan S ABS Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "EN650 Vulcan S ABS Cafe Base": ["2016", "2017", "2018", "2019", "2020"],
    "EN650 Vulcan S ABS SE Base": ["2016", "2017", "2018"],
    "ER-6N Base": ["2009", "2010"],
    "ER650 Z650 Base": ["2019", "2020"],
    "ER650 Z650 ABS Base": ["2019", "2020"],
    "EX300 Ninja 300 ABS KRT Edition Base": ["2016", "2017"],
    "EX400 Ninja 400 Base": ["2018", "2019", "2020"],
    "EX400 Ninja 400 ABS Base": ["2018", "2019", "2020"],
    "EX500 Base": ["1987", "1988", "1989", "1990", "1991", "1992", "1993"],
    "EX500 Ninja 500 Base": ["1994", "1995", "1996"],
    "EX500 Ninja 500R Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "EX650 Ninja 650 ABS KRT Edition Base": ["2017", "2018"],
    "Intruder 440 Base": ["1980", "1981", "1982"],
    "Invader 340 Base": ["1980", "1981"],
    "Invader 440 Base": ["1980", "1981"],
    "Invader LTD Base": ["1980", "1981"],
    "JB650 Jet Mate Base": ["1989", "1990", "1991", "1992"],
    "JF650 TS Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "JF650 X2 Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "JH1100 1100ZXi Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "JH1100 Ultra 130 Base": ["2001", "2002", "2003", "2004"],
    "JH1200 Ultra 150 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "JH750 750SS Base": ["1992", "1993", "1994", "1995", "1996", "1997"],
    "JH750 750ZXi Base": ["1995", "1996", "1997"],
    "JH750 Super Sport XI Base": ["1993", "1994", "1995", "1996", "1997"],
    "JH750 Xi Sport Base": ["1998", "1999"],
    "JH900 900ZXi Base": ["1995", "1996", "1997"],
    "JL650 SC Base": ["1991", "1992", "1993", "1994", "1995"],
    "JS1500 SX-R Base": ["2017", "2018", "2019", "2020"],
    "JS300 Base": ["1986", "1987", "1988"],
    "JS300 300SX Base": ["1987", "1988", "1989", "1990", "1991"],
    "JS440 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "JS550 Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "JS550 550SX Base": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "JS650 650SX Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "JS750 750SX Base": ["1992", "1993", "1994", "1995"],
    "JS750 750SXi Base": ["1995", "1996"],
    "JS750 SXI Pro Base": ["1998", "1999", "2000", "2001", "2002"],
    "JS800 800 SX-R Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "JT1100 1100STX Base": ["1997", "1998", "1999"],
    "JT1100 1100STX D.I. Base": ["2000", "2001", "2002", "2003"],
    "JT1200 1200STX-R Base": ["2002", "2003", "2004", "2005"],
    "JT1200 STX-12F Base": ["2003", "2004", "2005", "2006", "2007"],
    "JT1500 STX Base": ["2009", "2010"],
    "JT1500 STX-15F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "JT1500 Ultra 250X Base": ["2007", "2008"],
    "JT1500 Ultra 260LX Base": ["2009", "2010"],
    "JT1500 Ultra 260X Base": ["2009", "2010"],
    "JT1500 Ultra 300 LX Base": ["2011", "2012", "2013"],
    "JT1500 Ultra 300 X Base": ["2011", "2012", "2013"],
    "JT1500 Ultra 310LX Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "JT1500 Ultra 310R Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "JT1500 Ultra 310X Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "JT1500 Ultra 310X SE Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "JT1500 Ultra LX Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "JT750 ST Base": ["1994", "1995"],
    "JT750 STS Base": ["1995", "1996", "1997"],
    "JT900 900STS Base": ["2001", "2002"],
    "JT900 900STX Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "KAF300 Mule 520 Base": ["2000", "2001"],
    "KAF300 Mule 550 Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2003",
      "2004",
    ],
    "KAF400 Mule 600 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "KAF400 Mule 610 4x4 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "KAF400 Mule 610 4x4 XC Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "KAF400 Mule 610 4x4 XC SE Base": ["2014", "2015", "2016"],
    "KAF400 Mule SX Base": ["2017", "2018", "2019", "2020"],
    "KAF400 Mule SX 4x4 Base": ["2017", "2018", "2019"],
    "KAF400 Mule SX 4x4 FI Base": ["2019", "2020"],
    "KAF400 Mule SX 4x4 SE Base": ["2017", "2018", "2019"],
    "KAF400 Mule SX 4x4 XC Base": ["2017", "2018", "2019"],
    "KAF400 Mule SX 4x4 XC Camo Base": ["2017", "2018", "2019"],
    "KAF400 Mule SX 4x4 XC Camo FI Base": ["2019", "2020"],
    "KAF400 Mule SX 4x4 XC FI Base": ["2019", "2020"],
    "KAF400 Mule SX 4x4 XC LE FI Base": ["2019", "2020"],
    "KAF400 Mule SX 4x4 XC SE Base": ["2017", "2018", "2019"],
    "KAF620 Mule 2500 Base": ["1994", "1995", "1997", "1998", "1999", "2000"],
    "KAF620 Mule 2510 4x4 Base": ["1997", "1998", "1999", "2000"],
    "KAF620 Mule 2520 Base": ["1997", "1998", "1999", "2000"],
    "KAF620 Mule 3000 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "KAF620 Mule 3010 4x4 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "KAF620 Mule 3010 Trans 4x4 Base": ["2005", "2006", "2007", "2008"],
    "KAF620 Mule 3020 Base": ["2001", "2002", "2003"],
    "KAF620 Mule 4000 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KAF620 Mule 4000 Trans Base": ["2018", "2019", "2020"],
    "KAF620 Mule 4010 4x4 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KAF620 Mule 4010 4x4 SE Base": ["2016", "2017", "2018"],
    "KAF620 Mule 4010 Trans 4x4 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KAF620 Mule 4010 Trans 4x4 Camo Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KAF620 Mule 4010 Trans 4x4 SE Base": ["2016", "2017", "2018"],
    "KAF700 Mule PRO-MX EPS Base": ["2019", "2020"],
    "KAF700 Mule PRO-MX EPS Camo Base": ["2019", "2020"],
    "KAF700 Mule PRO-MX EPS LE Base": ["2019", "2020"],
    "KD80 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "KDX175 Base": ["1980", "1981", "1982"],
    "KDX200 Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "KDX220R Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "KDX250 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "KDX50 Base": ["2003", "2004", "2005", "2006"],
    "KDX80 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "KE100 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "KE125 Base": ["1980", "1981", "1982", "1983"],
    "KE175 Base": ["1980", "1981", "1982", "1983"],
    "KEF300 Lakota Sport Base": ["2001", "2002", "2003"],
    "KEF300 Lakota Utility Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "KFX400 Base": ["2003", "2004", "2005", "2006"],
    "KFX450R Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "KFX50 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
    ],
    "KFX80 Base": ["2003", "2004", "2005", "2006"],
    "KFX90 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2019",
      "2020",
    ],
    "KL250 Base": ["1980", "1981", "1982", "1983", "1984"],
    "KL250 Super Sherpa Base": ["2000", "2001", "2002", "2003", "2009", "2010"],
    "KL600 Base": ["1984", "1985", "1986"],
    "KL650B Tengai Base": ["1990", "1991"],
    "KLE300 Versys-X 300 Base": ["2017", "2018", "2019", "2020"],
    "KLE300 Versys-X 300 ABS Base": ["2017", "2018", "2019", "2020"],
    "KLF110 Mojave Base": ["1987", "1988"],
    "KLF185 Bayou Base": ["1985", "1986", "1987", "1988"],
    "KLF220 Bayou Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "KLF250 Bayou Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "KLF300 Bayou 2x4 Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "KLF300 Bayou 4x4 Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "KLF400 Bayou 4x4 Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "KLR250 Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "KLR650 Camo Base": ["2016", "2017", "2018"],
    "KLT110 Base": ["1984", "1985", "1986"],
    "KLT185 Base": ["1986", "1987"],
    "KLT200 Base": ["1981", "1982", "1983", "1984"],
    "KLT250 Base": ["1981", "1982", "1983", "1984"],
    "KLX110 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KLX110L Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KLX125 Base": ["2003", "2004", "2005", "2006"],
    "KLX125L Base": ["2003", "2004", "2005", "2006"],
    "KLX140 Base": [
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KLX140G Base": ["2017", "2018", "2019", "2020"],
    "KLX140L Base": [
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KLX250 Base": ["2018", "2019", "2020"],
    "KLX250 Camo Base": ["2018", "2019", "2020"],
    "KLX250R Base": ["1994", "1995", "1996"],
    "KLX250S Base": ["2006", "2007", "2009", "2010", "2012", "2013", "2014"],
    "KLX250SF Base": ["2009", "2010"],
    "KLX300R Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "KLX450R Base": ["2008", "2009", "2010"],
    "KLX650 Base": ["1993", "1994", "1995", "1996"],
    "KLX650R Base": ["1993", "1994", "1995", "1996"],
    "KLZ1000 Versys SE LT+ Base": ["2019", "2020"],
    "Km100 Base": ["1980", "1981"],
    "KRF800 Teryx Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KRF800 Teryx Camo Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KRF800 Teryx LE Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KRT800 Teryx4 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KRT800 Teryx4 Camo Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KRT800 Teryx4 LE Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "KSF250 Mojave Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "KVF300 Brute Force Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "KVF300 Prairie 2x4 Base": ["1999", "2000", "2001", "2002"],
    "KVF300 Prairie 4x4 Base": ["1999", "2000", "2001", "2002"],
    "KVF360 Prairie 2x4 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "KVF360 Prairie 4x4 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "KVF400 Prairie 2x4 Base": ["1998", "1999", "2000", "2001", "2002"],
    "KVF400 Prairie 4x4 Base": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "KX100 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KX125 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "KX250 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2019",
      "2020",
    ],
    "KX250F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "KX420 Base": ["1980", "1981"],
    "KX450 Base": ["2019", "2020"],
    "KX450F Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "KX500 Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "KX60 Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "KX65 Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KX80 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "KX80 Big Wheel Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "KX85 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "KXF250 Tecate 4 Base": ["1987", "1988"],
    "KXT250 Tecate Base": ["1984", "1985", "1986", "1987"],
    "KZ1000A/J Base": ["1980", "1981", "1982", "1983"],
    "KZ1000B/K Ltd Base": ["1980", "1981", "1982"],
    "KZ1000C/P Police Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "KZ1000M CSR Base": ["1981", "1982"],
    "KZ1000R Lawson Replica Base": ["1982", "1983"],
    "KZ1100A Base": ["1981", "1982", "1983"],
    "KZ1100B GPz Base": ["1981", "1982"],
    "KZ1100D Spectre Base": ["1982", "1983"],
    "KZ1300 Base": ["1980", "1981", "1982"],
    "KZ250 Base": ["1980", "1981", "1982", "1983"],
    "KZ305 CSR Base": ["1981", "1982"],
    "KZ305B Ltd Base": ["1987", "1988"],
    "KZ440A Ltd Base": ["1980", "1981", "1982", "1983"],
    "KZ440B/G Base": ["1980", "1981", "1982"],
    "KZ440D Ltd Belt Base": ["1980", "1981", "1982", "1983"],
    "KZ550A Base": ["1980", "1981", "1982", "1983"],
    "KZ550C Ltd Base": ["1980", "1981", "1982", "1983"],
    "KZ550D/H GPz Base": ["1981", "1982", "1983"],
    "KZ650H CSR Base": ["1981", "1982", "1983"],
    "KZ700A Base": ["1984", "1985"],
    "KZ750B/E Base": ["1980", "1981", "1982"],
    "KZ750H LTD Base": ["1980", "1981", "1982", "1983"],
    "KZ750K LTD Belt Base": ["1983", "1984"],
    "KZ750N Spectre Base": ["1982", "1983"],
    "VN1500A Vulcan 1500 Base": ["1996", "1997", "1998", "1999"],
    "VN1500A Vulcan 88 Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "VN1500B Vulcan 88 SE Base": ["1987", "1988", "1989", "1990"],
    "VN1500C Vulcan L Base": ["1996", "1997"],
    "VN1500E Vulcan 1500 Classic Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "VN1500G Vulcan 1500 Nomad Base": ["1999", "2000", "2001"],
    "VN1500J/R Vulcan 1500 Drifter Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "VN1500L Vulcan Nomad Fi Base": ["2000", "2001", "2002", "2003", "2004"],
    "VN1500N Vulcan 1500 Classic Fi Base": ["2000", "2001", "2002"],
    "VN1500P Vulcan 1500 Mean Streak Base": ["2002", "2003"],
    "VN1600A Vulcan 1600 Classic Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "VN1600B Vulcan 1600 Mean Streak Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "VN1600D Vulcan 1600 Nomad Base": ["2005", "2006", "2007", "2008"],
    "VN1700 Vulcan 1700 Classic Base": ["2009", "2010", "2011", "2012"],
    "VN1700 Vulcan 1700 Classic LT Base": ["2009", "2010"],
    "VN1700 Vulcan 1700 Nomad Base": ["2009", "2010", "2011", "2012", "2013"],
    "VN1700 Vulcan 1700 Vaquero Base": ["2011", "2012", "2013"],
    "VN1700 Vulcan 1700 Vaquero ABS Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VN1700 Vulcan 1700 Voyager Base": ["2009", "2010", "2011", "2012", "2013"],
    "VN1700 Vulcan 1700 Voyager ABS Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VN2000E Vulcan 2000 Classic Base": ["2006", "2007", "2008", "2009"],
    "VN2000F Vulcan 2000 Classic LT Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "VN750A Vulcan 750 Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "VN900B Vulcan 900 Classic Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VN900C Vulcan 900 Custom Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VN900D Vulcan 900 Classic LT Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Z750 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "ZG1000 Concours Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "ZG1200 Voyager XII Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "ZL600 Eliminator Base": ["1986", "1987", "1996", "1997"],
    "ZL900A Eliminator Base": ["1985", "1986"],
    "ZN1100B Ltd Base": ["1984", "1985"],
    "ZN1300 Voyager Base": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "ZN1300A Base": ["1980", "1981", "1982"],
    "ZN700A Ltd Base": ["1984", "1985"],
    "Zr-7S Base": ["2001", "2002", "2003"],
    "ZR1000 Z1000 ABS Base": ["2014", "2015", "2016"],
    "ZR1100 Base": ["1992", "1993", "1994", "1995"],
    "ZR550 Zephyr Base": ["1990", "1991", "1992", "1993"],
    "ZR650 Z650 Base": ["2017", "2018"],
    "ZR650 Z650 ABS Base": ["2017", "2018"],
    "ZR750C Zephyr Base": ["1991", "1992", "1993"],
    "ZR900 Z900 Base": ["2017", "2018", "2019"],
    "ZR900 Z900 ABS Base": ["2017", "2018", "2019", "2020"],
    "ZR900 Z900RS Base": ["2018", "2019", "2020"],
    "ZR900 Z900RS CAFE Base": ["2018", "2019", "2020"],
    "ZX1000 Ninja 1000R Base": ["1986", "1987"],
    "ZX1000 Ninja H2 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "ZX1000 Ninja H2 Carbon Base": ["2017", "2018", "2019", "2020"],
    "ZX1000 Ninja H2 SX SE+ Base": ["2019", "2020"],
    "ZX1000 Ninja H2R Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "ZX1000 Ninja ZX-10 Base": ["1988", "1989", "1990"],
    "ZX1000 Ninja ZX-10R ABS KRT Edition Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "ZX1000 Ninja ZX-10R KRT Edition Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "ZX1000 Ninja ZX-10RR Base": ["2017", "2018", "2019"],
    "ZX550 GPz Base": ["1984", "1985"],
    "ZX600 Ninja 600R Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "ZX600 Ninja ZX-6 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "ZX636 Ninja ZX-6R ABS KRT Edition Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "ZX636 Ninja ZX-6R KRT Edition Base": ["2016", "2017", "2018"],
    "ZX750 GPz Base": ["1982", "1983", "1984", "1985"],
    "ZX750 Ninja ZX-7 Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "ZX750 Ninja ZX-7R Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "ZX750 Ninja ZX-7RR Base": ["1996", "1997"],
    "ZX750E Turbo Base": ["1984", "1985"],
    "ZX750F Ninja 750R Base": ["1987", "1988", "1989", "1990"],
    "ZX900 Ninja Base": ["1984", "1985", "1986"],
    "ZX900 Ninja ZX-9R Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "ZZR 600 Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "Ultra 310LX-S": ["2022", "2023"],
    "STX 160": ["2020", "2021", "2022", "2023"],
    "STX 160LX": ["2020", "2021", "2022", "2023"],
    "STX 160X": ["2020", "2021", "2022", "2023"],
    "KLX230S ABS": ["2022", "2023"],
    KLT200C: ["1983", "1984"],
    KLT250A: ["1982", "1983"],
    "ZX400 Ninja ZX-4RR KRT Edition": ["2023", "2024"],
  },
  KTM: {
    "105 SX": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "105 XC": ["2008", "2009", "2010"],
    "1090 Adventure R": ["2017", "2018", "2019", "2020"],
    "1190 Adventure": ["2013", "2014", "2015", "2016"],
    "1190 Adventure R": ["2014", "2015", "2016"],
    "1190 RC8": ["2008", "2009", "2010", "2011", "2012"],
    "1190 RC8 R": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "1190 RC8 R Race": ["2012", "2013"],
    "125 Dxc": ["1990", "1991", "1992"],
    "125 Exc": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "125 Exe": ["2000", "2001"],
    "125 Mx": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "125 Sting": ["1997", "1998"],
    "125 SX": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "125 SXS": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "1290 Super Adventure": ["2015", "2016"],
    "1290 Super Adventure R": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "1290 Super Duke GT": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "1290 Super Duke R": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "144 Sx": ["2007", "2008"],
    "150 SX": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "150 XC": ["2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "150 XC-W": ["2017", "2018", "2019", "2023", "2024", "2025"],
    "200 Exc": ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "200 Mxc": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "200 Sx": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "200 Xc": ["2006", "2007", "2008", "2009"],
    "200 Xc-W": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "250 DXC": ["1989", "1990", "1991"],
    "250 EXC": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "250 EXC-F": [
      "2003",
      "2004",
      "2005",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "250 Mx": ["1983", "1984", "1986", "1987", "1988", "1990", "1991"],
    "250 MXC": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "250 SX": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "250 SX-F": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "250 SX-F Factory Edition": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "250 SXS": ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "250 SXS-F": ["2006", "2007", "2008"],
    "250 XC": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2023",
      "2024",
      "2025",
    ],
    "250 XC-F": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "250 XC-W": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2023",
      "2024",
      "2025",
    ],
    "250 XCF-W": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "300 DXC": ["1990", "1991", "1992"],
    "300 EXC": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "300 GS": ["1985", "1986"],
    "300 MX": ["1990", "1991"],
    "300 MXC": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "300 SX": ["1992", "1993", "1994", "1995", "1996", "2023", "2024", "2025"],
    "300 TXC": ["1990", "1991", "1992"],
    "300 XC": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2023",
      "2024",
      "2025",
    ],
    "300 XC-W": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2023",
      "2024",
      "2025",
    ],
    "350 EXC-F": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "350 Lc4": ["1994", "1995"],
    "350 SX-F": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "350 XC-F": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "350 XCF-W": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "360 Exc": ["1996", "1997"],
    "360 Mxc": ["1996", "1997"],
    "360 Sx": ["1996", "1997"],
    "380 Exc": ["1998", "1999", "2000", "2001", "2002"],
    "380 Sx": ["1998", "1999", "2000", "2001", "2002"],
    "390 Duke": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "390 Gs": ["1982", "1983"],
    "390 RC390": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "400 Duke": ["1994", "1995"],
    "400 EXC 4-Stroke": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "400 Lc4": ["1998", "1999", "2000", "2001"],
    "400 MXC 4-Stroke": ["2001", "2002"],
    "400 RXC 4-Stroke": ["1995", "1996", "1997", "1998"],
    "400 SC 4-Stroke": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "400 SX 4-Stroke": ["1998", "1999", "2000", "2001", "2002"],
    "400 SXC 4-Stroke": ["1997", "1998", "1999", "2000"],
    "400 XC-W 4-Stroke": ["2009", "2010"],
    "420 Mxc": ["1983", "1984"],
    "440 Exc": ["1994", "1995"],
    "440 Mxc": ["1994", "1995"],
    "450 EXC-F": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "450 EXC-R 4-Stroke": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "450 MXC 4-Stroke": ["2003", "2004", "2005"],
    "450 SMR 4-Stroke": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
    ],
    "450 SX-F": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "450 SX-F Factory Edition": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "450 SXS 4-Stroke": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "450 XC-F": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "450 XCF-W": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2023",
      "2024",
      "2025",
    ],
    "495 Mx": ["1981", "1982", "1983", "1984"],
    "495 Mxc": ["1983", "1984"],
    "50 Jr Adventure": ["2000", "2001", "2002", "2003"],
    "50 Mini Adventure": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "50 Sr Adventure": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "50 SX": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "50 SX Junior": ["2007", "2008", "2009"],
    "50 SX Mini": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "50 SX Pro Jr LC": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "50 SX Pro Sr LC": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "50 SXR Pro Jr": ["1996", "1997", "1998"],
    "50 SXR Pro Sr": ["1996", "1997", "1998"],
    "50 SXS": ["2011", "2012", "2013", "2014", "2015"],
    "50-3 Sx": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "500 EXC-F": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "500 Lc4": ["1989", "1990", "1991", "1992"],
    "500 Mx": ["1985", "1986", "1988", "1989", "1990", "1991"],
    "500 MXC": ["1985", "1986"],
    "500 SX": ["1992", "1993"],
    "500 XCF-W": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "505 Xc-F": ["2008", "2009"],
    "520 EXC 4-Stroke": ["2000", "2001", "2002"],
    "520 MXC 4-Stroke": ["2000", "2001", "2002"],
    "520 SX 4-Stroke": ["2000", "2001", "2002"],
    "525 EXC 4-Stroke": ["2003", "2004", "2005", "2006", "2007"],
    "525 EXC-G Racing": ["2006", "2007"],
    "525 MXC 4-Stroke": ["2003", "2004", "2005"],
    "525 SMR 4-Stroke": ["2004", "2005", "2006"],
    "525 SX 4-Stroke": ["2003", "2004", "2005", "2006"],
    "525 XC-G 4-Stroke": ["2006", "2007"],
    "530 EXC-R 4-Stroke": ["2008", "2009", "2010", "2011", "2012"],
    "530 XC-W 4-Stroke": ["2008", "2009", "2010", "2011"],
    "540 Dxc": ["1990", "1991"],
    "540 SXC 4-Stroke": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "550 Mxc": ["1993", "1994", "1995", "1996"],
    "560 SMR 4-Stroke": ["2006", "2007", "2008"],
    "60 Sx": ["1998", "1999", "2000"],
    "600 Dxc": ["1989", "1990", "1991", "1992"],
    "600 Mx": ["1988", "1989", "1990", "1991"],
    "620 Duke": ["1994", "1995", "1996", "1997"],
    "620 Exc": ["1996", "1997"],
    "620 Lc4": ["1997", "1998"],
    "620 Rxc": ["1995", "1996"],
    "620 Sc": ["1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    "620 Super Moto": ["1999", "2000", "2001"],
    "620 Sx": ["1998", "1999"],
    "625 Smc": ["2004", "2005", "2006"],
    "640 Adventure": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2008",
    ],
    "640 Duke Ii": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "640 Enduro": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "640 Supermoto": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "65 SX": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "65 SXS": ["2012", "2013", "2014", "2015"],
    "65 XC": ["2008", "2009"],
    "660 Rallye": ["2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "660 Smc": ["2002", "2003", "2004", "2005", "2006"],
    "690 Duke": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "690 Enduro R": [
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "690 Smc": ["2008", "2009", "2010"],
    "85 SX (17/14)": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "85 SX (19/16)": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "85 SXS": ["2012", "2013", "2014", "2015"],
    "85 XC": ["2008", "2009"],
    "950 Adventure": ["2002", "2003", "2004", "2005", "2006"],
    "950 Adventure S": ["2003", "2004", "2005", "2006"],
    "950 Super Enduro R": ["2007", "2008", "2009"],
    "950 Supermoto": ["2007", "2008", "2009"],
    "990 Adventure": ["2006", "2007"],
    "990 Adventure R": ["2010", "2011", "2012", "2013"],
    "990 Adventure S": ["2006", "2007", "2008"],
    "990 Super Duke": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "990 Super Duke R": ["2007", "2008", "2009", "2010", "2011"],
    "990 Supermoto R": ["2008", "2009", "2010", "2011", "2012"],
    "990 Supermoto T": ["2009", "2010", "2011", "2012", "2013"],
    "Freeride 250R 4-Stroke": ["2015", "2016", "2017"],
    "125 Exc Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "125 EXC Factory Edition Base": ["2012", "2013", "2014", "2015"],
    "125 EXC Six Days Base": ["2013", "2014", "2015", "2016"],
    "125 SX Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "125 SXS Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "144 Sx Base": ["2007", "2008"],
    "150 SX Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "150 XC Base": ["2010", "2011", "2012", "2013", "2014"],
    "200 Exc Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "200 Xc Base": ["2006", "2007", "2008", "2009"],
    "200 Xc-W Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "250 EXC Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "250 EXC-F Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "250 SX Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "250 SX-F Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "250 SXS-F Base": ["2006", "2007", "2008"],
    "250 XC Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "250 XC-F Base": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "250 XC-W Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "250 XCF-W Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "300 EXC Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "300 XC Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "300 XC-W Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "300 XC-W Six Days Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "400 Xc-W Base": ["2009", "2010"],
    "450 EXC Base": [
      "2003",
      "2004",
      "2005",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "450 EXC-R Base": ["2008", "2009", "2010", "2011"],
    "450 SX-F Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "450 SXS Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "450 XC-F Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "450 XC-W Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "500 EXC Base": ["2012", "2013", "2014", "2015", "2016"],
    "500 EXC Six Days Base": ["2012", "2013", "2014", "2015"],
    "500 XC-W Base": ["2012", "2013", "2014", "2015", "2016"],
    "505 Sx-F Base": ["2007", "2008"],
    "505 Xc-F Base": ["2008", "2009"],
    "530 Exc-R Base": ["2008", "2009", "2010", "2011"],
    "530 Xc-W Base": ["2008", "2009", "2010", "2011"],
    "200 Duke": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "RC 390": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "1290 Super Adventure S": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "350 XCF-W Six Days": ["2015", "2016"],
    "450 EXC-F Six Days": ["2017", "2018", "2019"],
    "500 EXC-F Six Days": ["2020", "2021", "2022", "2023"],
    "505 Sx-F": ["2008", "2009"],
    "790 Adventure": ["2019", "2020", "2021", "2022"],
    "790 Adventure R": ["2019", "2020", "2021", "2022"],
    "790 Duke": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "890 Adventure": ["2021", "2022", "2023"],
    "890 Adventure R": ["2021", "2022", "2023", "2024"],
    "890 Duke R": ["2020", "2021", "2022", "2023"],
    "250 EXC-G Racing": ["2002", "2003", "2004", "2005"],
    "450 XC ATV": ["2008", "2009", "2010"],
    "525 XC ATV": ["2007", "2008", "2009", "2010"],
    "540 SXS": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "400 Egs": ["1996", "1997"],
    "620 Egs": ["1994", "1995", "1996", "1997"],
    "640 Lc4": ["1998", "1999", "2000", "2001", "2002"],
    "390 Adventure": ["2020", "2021", "2022"],
    "625 Sxc": ["2004", "2005", "2006"],
    "690 SMC R": ["2019", "2020", "2021", "2022", "2023"],
    "1190 RC8 Base": ["2008", "2009", "2010", "2011"],
    "1190 RC8 R Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "125 XC": ["2021", "2022", "2023", "2024"],
    "150 XC-W TPi": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "450 SX ATV": ["2009", "2010"],
    "505 SX ATV": ["2009", "2010"],
    "250 XC TPi": ["2020", "2021", "2022"],
    "250 XC-W TPi": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "300 XC TPi": ["2020", "2021", "2022"],
    "300 XC-W TPi": ["2019", "2020", "2021", "2022", "2023"],
    "890 Duke": ["2021", "2022", "2023"],
    "Freeride 250 F": ["2018", "2019", "2020"],
    "350 XC-F Factory Edition": ["2023", "2024"],
    "380 Mxc": ["1998", "1999", "2000", "2001", "2002"],
    "125 Egs": ["1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    "200 Egs": ["1998", "1999"],
    "250 EGS": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "300 EGS": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "360 Egs": ["1996", "1997"],
    "380 Egs": ["1998", "1999"],
    "400 EXC-G Racing": ["2004", "2005", "2006", "2007"],
    "450 EXC-G Racing": ["2003", "2004", "2005", "2006", "2007"],
    "450 SM-S 4-Stroke": ["2003", "2004"],
    "SX-E 5": ["2020", "2021", "2022", "2023", "2024"],
    "620 Comp": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "990 Supermoto": ["2008", "2009", "2010", "2011"],
    "690 Rallye Factory Replica": ["2008", "2009"],
    "660 Rallye Factory Replica": ["2006", "2007"],
    "300 XC-W Six Days": ["2015", "2016", "2017", "2018"],
    "890 Adventure R Rally": ["2021", "2022"],
    "Freeride E-XC": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "450 MXC-G Racing": ["2000", "2001", "2002"],
    "350 EXC-F Six Days": ["2020", "2021", "2022"],
    "450 Rally Replica": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "950 Supermoto R": ["2007", "2008"],
    "SX-E 3": ["2023", "2024"],
    "1290 Super Duke R Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "400 Comp.": ["1995", "1996", "1997", "1998", "1999"],
    "105 SX Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "105 XC Base": ["2008", "2009", "2010"],
    "1090 Adventure R Base": ["2017", "2018", "2019"],
    "1190 Adventure Base": ["2014", "2015", "2016"],
    "1190 Adventure R Base": ["2014", "2015", "2016"],
    "125 Dxc Base": ["1990", "1991", "1992"],
    "125 Egs Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "125 Exe Base": ["2000", "2001"],
    "125 Mx Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "125 Sting Base": ["1997", "1998"],
    "1290 Super Adventure Base": ["2015", "2016"],
    "1290 Super Adventure R Base": ["2017", "2018", "2019", "2020"],
    "1290 Super Adventure S Base": ["2018", "2019", "2020"],
    "1290 Super Duke GT Base": ["2017", "2018", "2019", "2020"],
    "150 XC-W Base": ["2017", "2018", "2019"],
    "200 Egs Base": ["1998", "1999"],
    "200 Mxc Base": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "200 Sx Base": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "250 DXC Base": ["1989", "1990", "1991"],
    "250 EGS Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "250 EXC 4-Stroke Base": ["2003", "2004", "2005"],
    "250 Mx Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "250 MXC Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "250 SXS Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "250 XC-W TPi Base": ["2019", "2020"],
    "300 DXC Base": ["1990", "1991", "1992"],
    "300 EGS Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "300 GS Base": ["1985", "1986"],
    "300 MX Base": ["1990", "1991"],
    "300 MXC Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "300 SX Base": ["1992", "1993", "1994", "1995", "1996"],
    "300 TXC Base": ["1990", "1991", "1992"],
    "300 XC-W TPi Base": ["2019", "2020"],
    "300 XC-W TPI Six Days Base": ["2019", "2020"],
    "350 EGS Base": ["1990", "1991"],
    "350 EXC Base": ["1989", "1990", "1991"],
    "350 EXC-F Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "350 Lc4 Base": ["1994", "1995"],
    "350 Mx Base": ["1989", "1990", "1991"],
    "350 MXC Base": ["1985", "1986", "1987", "1988"],
    "350 SX-F Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "350 XC-F Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "350 XCF-W Base": ["2012", "2013", "2014", "2015", "2016"],
    "360 Egs Base": ["1996", "1997"],
    "360 Exc Base": ["1996", "1997"],
    "360 Mxc Base": ["1996", "1997"],
    "360 Sx Base": ["1996", "1997"],
    "380 Egs Base": ["1998", "1999"],
    "380 Exc Base": ["1998", "1999", "2000", "2001", "2002"],
    "380 Mxc Base": ["1998", "1999", "2000", "2001", "2002"],
    "380 Sx Base": ["1998", "1999", "2000", "2001", "2002"],
    "390 Duke Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "390 Gs Base": ["1982", "1983"],
    "400 Duke Base": ["1994", "1995"],
    "400 Egs Base": ["1996", "1997"],
    "400 Exc Base": ["2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "400 Lc4 Base": ["1998", "1999", "2000", "2001"],
    "400 Lse Base": ["1997", "1998"],
    "400 Mxc Base": ["2001", "2002"],
    "400 Rxc Base": ["1996", "1997", "1998"],
    "400 Sc Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "400 Sx Base": ["1998", "1999", "2000", "2001", "2002"],
    "400 Sxc Base": ["1997", "1998", "1999", "2000"],
    "420 Mxc Base": ["1983", "1984"],
    "440 Exc Base": ["1994", "1995"],
    "440 Mxc Base": ["1994", "1995"],
    "450 MXC Base": ["2003", "2004", "2005"],
    "450 SMR Base": ["2005", "2006", "2007", "2008", "2009"],
    "450 SX-F Factory Edition Base": ["2012", "2013"],
    "450 XC Base": ["2008", "2009", "2010"],
    "450SX Base": ["2009", "2010"],
    "495 Mx Base": ["1981", "1982", "1983", "1984"],
    "495 Mxc Base": ["1983", "1984"],
    "50 Jr Adventure Base": ["2000", "2001", "2002", "2003"],
    "50 Mini Adventure Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "50 Sr Adventure Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "50 SX Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "50 SX Junior Base": ["2007", "2008", "2009"],
    "50 SX Mini Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "50 SX Pro Jr LC Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "50 SX Pro Sr LC Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "50 SXR Pro Jr Base": ["1996", "1997", "1998"],
    "50 SXR Pro Sr Base": ["1996", "1997", "1998"],
    "50 SXS Base": ["2012", "2013"],
    "50-3 Sx Base": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "500 EXC-F Base": ["2017", "2018", "2019", "2020"],
    "500 Lc4 Base": ["1989", "1990", "1991", "1992"],
    "500 Mx Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "500 MXC Base": ["1985", "1986"],
    "500 SX Base": ["1992", "1993"],
    "505SX Base": ["2009", "2010"],
    "520 Exc Base": ["2000", "2001", "2002"],
    "520 Mxc Base": ["2000", "2001", "2002"],
    "520 Sx Base": ["2000", "2001", "2002"],
    "525 Exc Base": ["2003", "2004", "2005", "2006"],
    "525 Exc-G Base": ["2006", "2007"],
    "525 Mxc Base": ["2003", "2004", "2005"],
    "525 Smr Base": ["2004", "2005", "2006"],
    "525 Sx Base": ["2003", "2004", "2005", "2006"],
    "525 XC Base": ["2008", "2009", "2010"],
    "525 Xc-G Base": ["2006", "2007"],
    "540 Dxc Base": ["1990", "1991"],
    "540 Sxc Base": ["2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "550 Mxc Base": ["1993", "1994", "1995", "1996"],
    "560 Smr Base": ["2006", "2007", "2008"],
    "60 Sx Base": ["1998", "1999", "2000"],
    "600 Dxc Base": ["1989", "1990", "1991", "1992"],
    "600 Mx Base": ["1988", "1989", "1990", "1991"],
    "620 Duke Base": ["1994", "1995", "1996", "1997"],
    "620 Egs Base": ["1994", "1995", "1996", "1997"],
    "620 Exc Base": ["1994", "1995", "1996", "1997"],
    "620 Lc4 Exc Base": ["1994", "1995", "1996", "1997"],
    "620 Lc4 Sx Base": ["1997", "1998"],
    "620 Rxc Base": ["1995", "1996", "1997", "1998"],
    "620 Sc Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "620 Super Moto Base": ["1998", "1999", "2000", "2001"],
    "620 Sx Base": ["1996", "1997", "1998", "1999"],
    "625 Smc Base": ["2004", "2005", "2006"],
    "625 Sxc Base": ["2003", "2004"],
    "640 Adventure Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "640 Duke Ii Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "640 Enduro Base": ["1999", "2000", "2001", "2002"],
    "640 Supermoto Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "65 SX Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "65 XC Base": ["2008", "2009"],
    "660 Rally Base": ["2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "660 Smc Base": ["2002", "2003", "2004", "2005", "2006"],
    "690 Duke Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "690 Enduro R Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
      "2020",
    ],
    "690 Smc Base": ["2008", "2009", "2010", "2011"],
    "690 SMC-R Base": ["2019", "2020"],
    "690 Supermoto Base": ["2007", "2008"],
    "790 Adventure Base": ["2019", "2020"],
    "790 Adventure R Base": ["2019", "2020"],
    "790 Duke Base": ["2018", "2019", "2020"],
    "85 SX (17/14) Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "85 SX (19/16) Base": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "85 SXS Base": ["2012", "2013"],
    "85 XC Base": ["2008", "2009"],
    "950 Adventure Base": ["2002", "2003", "2004", "2005", "2006"],
    "950 Adventure S Base": ["2004", "2005", "2006"],
    "950 Super Enduro R Base": ["2007", "2008", "2009"],
    "950 Supermoto Base": ["2005", "2006", "2007", "2008"],
    "990 Adventure Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "990 Adventure R Base": ["2009", "2010", "2011", "2012"],
    "990 Adventure S Base": ["2006", "2007", "2008"],
    "990 Super Duke Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "990 Super Duke R Base": ["2007", "2008", "2009", "2010", "2011"],
    "990 Supermoto R Base": ["2008", "2009", "2010", "2011"],
    "990 Supermoto T Base": ["2010", "2011"],
    "Freeride 250 R Base": ["2015", "2016", "2017"],
    "RC 390 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "660 Lc4": ["1999", "2000"],
  },
  Kymco: {
    "Super 8 150": ["2009", "2010", "2011", "2012"],
    "MXU 500": ["2006", "2007", "2008", "2009", "2014", "2015"],
    "UXV 500i": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Mongoose 250": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "Mongoose 300": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "MXU 250": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "MXU 300": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "MXU 500 IRS 4x4": ["2010", "2011", "2012", "2013"],
    "MXU 700i": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "UXV 700i": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "UXV 450i": ["2015", "2016", "2017", "2018"],
    "Mongoose 90": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "Maxxer 450i": ["2014", "2015", "2016"],
    "UXV 450i LE": ["2015", "2016", "2017", "2018"],
    "UXV 450i TURF": ["2015", "2016", "2017", "2018"],
    "Maxxer 375 IRS 4x4": ["2010", "2011", "2012"],
    "Maxxer 450i IRS 4x4": ["2012", "2013"],
    "MXU 450i": ["2014", "2015", "2016", "2017"],
    "MXU 450i IRS 4x4": ["2012", "2013"],
    "MXU 500 IRS 4x4 LE": ["2010", "2011", "2012"],
    "MXU 700i LE": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "MXU 150": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Xciting 500 Base": ["2005", "2006", "2007", "2008"],
    "Xciting 500Ri Base": ["2009", "2010", "2011", "2012"],
    "Xciting 500Ri ABS Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "MXU 375 IRS 4x4": ["2009", "2010", "2011", "2012", "2013"],
    "Mongoose 50": ["2003", "2004", "2005", "2006", "2007", "2008", "2009"],
    "K-Pipe 125 Base": ["2017", "2018"],
    "Maxxer 375 4x4 IRS Base": ["2010", "2011"],
    "Maxxer 450i 4x4 Base": ["2012", "2013", "2014", "2015", "2016"],
    "Mongoose 250 Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "Mongoose 270 Base": ["2016", "2017", "2018"],
    "Mongoose 300 Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Mongoose 50 Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "Mongoose 70 Base": ["2007", "2008", "2009", "2010", "2013", "2014"],
    "Mongoose 70s Base": ["2015", "2016", "2017", "2018"],
    "Mongoose 90 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Mongoose 90 R Base": ["2012", "2013", "2014"],
    "Mongoose 90s Base": ["2015", "2016", "2017", "2018"],
    "Mxer 150 Base": ["2002", "2003", "2004"],
    "MXU150 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "MXU150X Base": ["2016", "2017", "2018"],
    "MXU250 Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "MXU270 Base": ["2016", "2017", "2018"],
    "MXU300 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "MXU375 4x4 IRS Base": ["2012", "2013"],
    "MXU375 IRS Base": ["2010", "2011"],
    "MXU375 IRS LE Base": ["2010", "2011"],
    "MXU450i Base": ["2015", "2016", "2017", "2018"],
    "MXU450i 4x4 IRS Base": ["2012", "2013", "2014"],
    "MXU450i 4x4 IRS LE Base": ["2012", "2013", "2014"],
    "MXU450i Camo Base": ["2015", "2016", "2017", "2018"],
    "MXU450i LE Base": ["2016", "2017", "2018"],
    "MXU500 Base": ["2006", "2007", "2008", "2009"],
    "MXU500 4x4 IRS Base": ["2012", "2013", "2014"],
    "MXU500 IRS Base": ["2010", "2011"],
    "MXU500i Base": ["2015", "2016", "2017", "2018"],
    "MXU500i 4x4 IRS Base": ["2012", "2013", "2014"],
    "MXU500i 4x4 IRS LE Base": ["2012", "2013", "2014"],
    "MXU700i Base": ["2015", "2016", "2017", "2018"],
    "MXU700i 4x4 IRS Base": ["2013", "2014"],
    "MXU700i 4x4 IRS LE Base": ["2013", "2014"],
    "MXU700i LE EPS Base": ["2016", "2017", "2018"],
    "MXU700i LE EPS Camo Base": ["2017", "2018"],
    "UXV 450i Base": ["2015", "2016", "2017", "2018"],
    "UXV 450i Camo Base": ["2015", "2016", "2017", "2018"],
    "UXV 450i LE Base": ["2016", "2017", "2018"],
    "UXV 450i TURF Base": ["2015", "2016", "2017", "2018"],
    "UXV 500 4X4 Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "UXV 500 4X4 LE Base": ["2010", "2011"],
    "UXV 500i Base": ["2015", "2016", "2017", "2018"],
    "UXV 500i 4X4 Base": ["2012", "2013", "2014"],
    "UXV 500i Camo Base": ["2015", "2016"],
    "UXV 500i LE Base": ["2012", "2013", "2014"],
    "UXV 500i SE Base": ["2012", "2013"],
    "UXV 500i SP Base": ["2013", "2014"],
    "UXV 500i TURF Base": ["2014", "2015"],
    "UXV 700i Base": ["2014", "2015", "2016", "2017", "2018"],
    "UXV 700i Camo Base": ["2015", "2016", "2017"],
    "UXV 700i LE Base": ["2016", "2017"],
    "UXV 700i LE EPS Base": ["2017", "2018"],
    "UXV 700i LE EPS Camo Base": ["2017", "2018"],
    "UXV 700i TURF Base": ["2014", "2015", "2016", "2017"],
    "MXU 375 IRS 4x4 LE": ["2010", "2011"],
    "MXU 450i IRS 4x4 LE": ["2012", "2013"],
    "MXU 500i": ["2013", "2014", "2015"],
    "MXU 500i LE": ["2013", "2014", "2015"],
    "Mongoose 70": ["2006", "2007", "2008", "2009"],
    "Mongoose 90 R": ["2012", "2013"],
    "Mxer 150": ["2004", "2005"],
    "UXV 500i 4x4 LE": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "UXV 500i 4x4 SE": ["2011", "2012", "2013"],
    "UXV 700i LE": ["2014", "2015", "2016"],
    "People GT 300i Base": ["2015", "2016", "2017"],
  },
  LEM: {
    CX2: ["2006", "2007"],
    "CX2 Sr": ["2008", "2009", "2010"],
    CX3: ["2006", "2007"],
    "CX3 Sr": ["2007", "2008", "2009", "2010"],
    "Dx 150": ["2010", "2011", "2012", "2013"],
    Dx2: ["2010", "2011"],
    "Dx2 Jr": ["2011", "2012"],
    Dx3: ["2010", "2011"],
    "Dx3 Jr": ["2011", "2012"],
    "Four X": ["2006", "2007"],
    "Four X Pro": ["2007", "2008", "2009"],
    "Four X-R": ["2006", "2007"],
    L2: ["2004", "2005"],
    Lx1: ["1999", "2000", "2001", "2002", "2003"],
    "Lx1 Sport": ["2004", "2005"],
    Lx2: ["1998", "1999", "2000", "2001", "2002"],
    "Lx2 Factory": ["1999", "2000", "2001"],
    "Lx2 Racer": ["2001", "2002", "2003"],
    "Lx2 Sport": ["2001", "2002", "2003", "2004", "2005"],
    "Lx2 Sr": ["2003", "2004", "2005"],
    "Lx2 Super": ["1999", "2000", "2001", "2002"],
    Lx3: ["1998", "1999", "2000", "2001", "2002"],
    "Lx3 Factory": ["1999", "2000", "2001"],
    "Lx3 Racer": ["2001", "2002", "2003", "2004"],
    "Lx3 Sport": ["2002", "2003", "2004", "2005"],
    "Lx3 Super": ["1999", "2000", "2001", "2002"],
    Lx4: ["1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    NX2: ["2008", "2009", "2010"],
    NX3: ["2008", "2009", "2010", "2011"],
    R2: ["2002", "2003", "2004", "2005"],
    R3: ["2002", "2003", "2004", "2005"],
    "R3 Xc": ["2003", "2004", "2005"],
    RX125: ["2008", "2009"],
    RX150: ["2010", "2011"],
    RX65: ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    RX2: ["2006", "2007", "2008", "2009", "2010", "2011"],
    Rx3: ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Cayman LC Base": ["2003", "2004"],
    "Cayman S6 Base": ["2003", "2004", "2005"],
    "Condor Boy Base": ["2009", "2010", "2011", "2012", "2013"],
    "Condor Kid Base": ["2009", "2010", "2011", "2012", "2013"],
    "Condor R Base": ["2009", "2010"],
    "Condor S6 Base": ["2003", "2004", "2005", "2006", "2007"],
    "CR2 Base": ["1999", "2000", "2001"],
    "CR3 Base": ["1999", "2000", "2001"],
    "CX2 Base": ["2006", "2007"],
    "CX2 Sr Base": ["2008", "2009", "2010"],
    "CX3 Base": ["2006", "2007"],
    "CX3 Sr Base": ["2007", "2008", "2009", "2010"],
    "DX150 Base": ["2010", "2011", "2012", "2013"],
    "DX150 Motard Base": ["2010", "2011", "2012", "2013"],
    "DX2 Junior Base": ["2011", "2012"],
    "DX3 Junior Base": ["2011", "2012"],
    "Four X Base": ["2006", "2007"],
    "Four X Pro Base": ["2007", "2008", "2009"],
    "Four X-R Base": ["2006", "2007"],
    "L2 Base": ["2004", "2005"],
    "Lx1 Base": ["1999", "2000", "2001", "2002", "2003"],
    "Lx1 Sport Base": ["2004", "2005"],
    "Lx2 Base": ["1998", "1999", "2000", "2001", "2002"],
    "Lx2 Factory Base": ["1999", "2000", "2001"],
    "Lx2 Racer Base": ["2001", "2002", "2003"],
    "Lx2 Sport Base": ["2001", "2002", "2003", "2004", "2005"],
    "Lx2 Sr Base": ["2003", "2004", "2005"],
    "Lx2 Super Base": ["1999", "2000", "2001", "2002"],
    "Lx3 Base": ["1998", "1999", "2000", "2001", "2002"],
    "Lx3 Factory Base": ["1999", "2000", "2001"],
    "Lx3 Racer Base": ["2001", "2002", "2003", "2004"],
    "Lx3 Sport Base": ["2002", "2003", "2004", "2005"],
    "Lx3 Super Base": ["1999", "2000", "2001", "2002"],
    "Lx4 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "NX2 Base": ["2008", "2009", "2010"],
    "NX3 Base": ["2008", "2009", "2010", "2011"],
    "R2 Base": ["2002", "2003", "2004", "2005"],
    "R3 Base": ["2002", "2003", "2004", "2005"],
    "R3 Xc Base": ["2003", "2004", "2005"],
    "RX 125 Base": ["2008", "2009"],
    "RX 150 Motard Base": ["2010", "2011"],
    "RX 65 Base": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "RX 65 Motard Base": ["2010", "2011"],
    "RX2 Base": ["2006", "2007", "2008", "2009", "2010"],
    "RX2 70 Base": ["2007", "2008"],
    "Rx3 Base": ["2006", "2007", "2008", "2009", "2010"],
    "SM2 Base": ["2003", "2004", "2005"],
  },
  Maico: {
    250: ["1981", "1982", "1983"],
    "250 Enduro": ["1978", "1979"],
    400: ["1981", "1982", "1983"],
    "400 Enduro": ["1978", "1979"],
    "450 Enduro": ["1978", "1979"],
    490: ["1982", "1983"],
    "250 Base": ["1981", "1982", "1983"],
    "400 Base": ["1981", "1982", "1983"],
    "490 Base": ["1981", "1982", "1983"],
  },
  "Moto Guzzi": {
    "1100 California": ["1995", "1996"],
    "1100 California I": ["1995", "1996"],
    "1100 Sport": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "850 Lemans": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    Audace: ["2015", "2016", "2017", "2018"],
    "Breva 1100": ["2005", "2006", "2007", "2008"],
    "Breva 750": ["2004", "2005", "2006", "2007", "2008"],
    "Breva 850": ["2007", "2008", "2009", "2010"],
    "California 1400 Custom": ["2013", "2014", "2015", "2016", "2017"],
    "California 1400 Touring": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "California Aquila Nera (Black Eagle)": ["2010", "2011"],
    "California EV": ["2001", "2002", "2003", "2004", "2005"],
    "California Stone": ["2002", "2003", "2004", "2005"],
    "California Stone Metal": ["2002", "2003"],
    "California Stone Touring": ["2004", "2005"],
    "California Vintage": ["2007", "2008", "2009", "2010"],
    "Daytona RS": ["1996", "1997", "1998", "1999", "2000"],
    Eldorado: ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Griso 1100": ["2006", "2007", "2008", "2009"],
    "Griso 1200 8V SE": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Le Mans 1000": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Le Mans Cl": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "Le Mans Se": ["1986", "1987", "1988"],
    "MGS-01": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "MGX-21 Flying Fortress": ["2016", "2017", "2018", "2019", "2020"],
    "Nevada Classic 750": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "Norge 1200": ["2007", "2008", "2009"],
    "Norge 1200 GT 8V": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Norge 850": ["2008", "2009"],
    "Stelvio 1200": ["2009", "2010", "2011"],
    "Stelvio 1200 NTX": [
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "V11 Bassa": ["1999", "2000"],
    "V11 EV": ["1998", "1999"],
    "V11 Quota": ["1999", "2000"],
    "V11 Sport": ["2000", "2001"],
    "V7 Classic": ["2010", "2011"],
    "V7 II Dark Rider": ["2015", "2016"],
    "V7 II Racer": ["2015", "2016", "2017"],
    "V7 II Scrambler": ["2015", "2016", "2017"],
    "V7 II Stone": ["2015", "2016", "2017"],
    "V7 II Stornello": ["2016", "2017"],
    "V7 Racer": ["2011", "2012", "2013", "2014"],
    "V7 Special": ["2012", "2013", "2014"],
    "V7 Stone": ["2013", "2014", "2022", "2023"],
    "V9 Bobber": ["2016", "2017", "2018", "2019", "2020"],
    "V9 Roamer": ["2016", "2017", "2018", "2019", "2020"],
    "Breva 1100 Base": ["2006", "2007", "2008"],
    "Sport 1200 Base": ["2006", "2007", "2008"],
    "California 1400 Custom Base": ["2013", "2014", "2015", "2016"],
    "California 1400 Touring Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Eldorado Base": ["2015", "2016", "2017", "2018"],
    "V85 TT": ["2019", "2020", "2021", "2022"],
    "V85 TT Adventure": ["2020", "2021"],
    "V85 TT Travel": ["2020", "2021", "2022"],
    "V7 Racer Base": ["2011", "2012", "2013", "2014"],
    "V7 Special Base": ["2013", "2014", "2015"],
    "V7 Stone Base": ["2013", "2014"],
    "V9 Bobber Base": ["2016", "2017", "2018"],
    "V9 Roamer Base": ["2016", "2017", "2018"],
    "1100 California Base": ["1995", "1996"],
    "1100 California I Base": ["1995", "1996"],
    "1100 Sport Base": ["1995", "1996"],
    "Audace Base": ["2015", "2016", "2017", "2018"],
    "Breva 750 Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "California Classic Touring Base": ["2006", "2007"],
    "California EV Base": ["2001", "2002", "2003", "2004", "2005"],
    "California Stone Base": ["2002", "2003", "2004", "2005"],
    "California Stone Metal Base": ["2002", "2003"],
    "California Stone Touring Base": ["2004", "2005"],
    "California Vintage Base": ["2006", "2007", "2008", "2009", "2010"],
    "Griso 1100 Base": ["2005", "2006", "2007", "2008"],
    "Griso 1200 Base": ["2007", "2008", "2009", "2010"],
    "Griso 1200 SE Base": ["2017", "2018"],
    "Griso 8V SE Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "MGS-01 Corsa Base": ["2004", "2005", "2006", "2007"],
    "Nevada Classic 750 Base": ["2004", "2005", "2006", "2007", "2008"],
    "Norge 1200 Base": ["2007", "2008", "2009"],
    "Norge GT8V Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Stelvio 1200 Base": ["2009", "2010", "2011"],
    "Stelvio 1200 NTX Base": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "V11 Bassa Base": ["1999", "2000"],
    "V11 EV Base": ["1998", "1999"],
    "V11 Quota Base": ["1999", "2000"],
    "V11 Sport Base": ["2000", "2001"],
    "V7 Classic Base": ["2008", "2009", "2010", "2011", "2012"],
    "V7 II Stone Base": ["2015", "2016"],
    "V7 III Anniversario Base": ["2017", "2018"],
    "V7 III Racer Base": ["2017", "2018"],
    "V7 III Special Base": ["2017", "2018"],
    "V7 III Stone Base": ["2017", "2018"],
    "Audace Carbon": ["2017", "2018", "2019", "2020"],
    "V7 III Rough": ["2019", "2020"],
    "V7 III Special": ["2018", "2019", "2020"],
    "V7 III Stone": ["2018", "2019", "2020"],
    "V7 III Stone Night Pack": ["2019", "2020"],
    "V9 Bobber Sport": ["2019", "2020"],
  },
  "MV Agusta": {
    "Brutale 1090": ["2013", "2014", "2017", "2018"],
    "Brutale 1090 Corsa": ["2017", "2018"],
    "Brutale 1090 R": ["2012", "2013", "2014"],
    "Brutale 1090 RR": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
    ],
    "Brutale 675": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Brutale 800": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Brutale 800 RR": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Brutale 910 R": ["2006", "2007", "2008"],
    "Brutale 990 R": ["2010", "2011"],
    "Brutale S": ["2004", "2005"],
    "Dragster 800": ["2015", "2016", "2017", "2018"],
    "Dragster 800 RC": ["2017", "2018"],
    "Dragster 800 RR": ["2015", "2016", "2017", "2018"],
    "Dragster 800 RR LH44": ["2016", "2017", "2018"],
    "F3 675": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "F3 675 RC": ["2016", "2017", "2018"],
    "F3 800": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "F3 800 AGO": ["2016", "2017", "2018", "2019"],
    "F3 800 RC": ["2016", "2017", "2018", "2019", "2020"],
    "F4 1000": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "F4 1000 RC": ["2016", "2017", "2018"],
    "F4 1000 RR": [
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "F4 R": ["2012", "2013", "2014"],
    "F4-1000 S": ["2000", "2001", "2002", "2003", "2005", "2006"],
    "F4-1000 S 1+1": ["2005", "2006"],
    "F4-750 S": ["2000", "2001", "2002", "2003"],
    "F4-S": ["2000", "2001", "2002", "2003"],
    "F4-S 1+1": ["2001", "2002"],
    "F4Z Zagato": ["2017", "2018"],
    "Rivale 800": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Stradale 800": ["2015", "2016", "2017", "2018"],
    "Turismo Veloce 800": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Turismo Veloce 800 Lusso": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Turismo Veloce 800 RC": ["2017", "2018", "2019"],
    "Brutale 800 America": ["2018", "2019"],
    "Brutale 800 RC": ["2018", "2019"],
    "Brutale 1000 Serie Ono": ["2019", "2020", "2021", "2022"],
    "Brutale 1000RR": ["2021", "2022", "2023"],
    "Brutale 800 Rosso": ["2021", "2022"],
    "Brutale 1090 Base": ["2013", "2014", "2015"],
    "Brutale 1090 ABS Base": ["2013", "2014"],
    "Brutale 1090R Base": ["2012", "2013", "2014"],
    "Brutale 1090R ABS Base": ["2013", "2014"],
    "Brutale 1090RR Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Brutale 1090RR ABS Base": ["2013", "2014"],
    "Brutale 675 Base": ["2013", "2014", "2015", "2016"],
    "Brutale 675 EAS Base": ["2013", "2014"],
    "Brutale 800 Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Brutale 800 Dragster Base": ["2014", "2015", "2016"],
    "Brutale 800 Dragster RC Base": ["2017", "2018"],
    "Brutale 800 EAS Base": ["2013", "2014"],
    "Brutale 800 ITALIA Base": ["2013", "2014"],
    "Brutale 800RC Base": ["2018", "2019"],
    "Brutale 800RR Base": ["2015", "2016", "2017", "2018", "2019"],
    "Brutale 800RR Pirelli Base": ["2018", "2019"],
    "Brutale 910 R Base": ["2006", "2007", "2008"],
    "Brutale 990R Base": ["2010", "2011"],
    "Brutale Corsa Base": ["2013", "2014"],
    "Brutale S Base": ["2004", "2005"],
    "F3 675 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "F3 675 EAS Base": ["2013", "2014"],
    "F3 675 RC Base": ["2016", "2017", "2018", "2019"],
    "F3 800 Base": ["2015", "2016", "2017", "2018", "2019"],
    "F3 800 EAS Base": ["2013", "2014"],
    "F3 800 RC Base": ["2016", "2017", "2018", "2019"],
    "F4 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "F4 ABS Base": ["2013", "2014"],
    "F4 LH44 Base": ["2018", "2019"],
    "F4 RC Base": ["2018", "2019"],
    "F4-1000 S Base": ["2005", "2006"],
    "F4-1000 S 1+1 Base": ["2005", "2006"],
    "F4-S Base": ["2000", "2001", "2002"],
    "F4-S 1+1 Base": ["2001", "2002"],
    "F4R Base": ["2013", "2014"],
    "F4R ABS Base": ["2013", "2014"],
    "F4RC Base": ["2015", "2016", "2017"],
    "F4RR Base": ["2013", "2014", "2015", "2016", "2017"],
    "F4RR ABS Base": ["2013", "2014"],
    "Rivale 800 Base": ["2013", "2014", "2016", "2017", "2018"],
    "RVS#1 Base": ["2018", "2019"],
    "Stradale 800 Base": ["2015", "2016"],
    "Turismo Veloce 800 Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Turismo Veloce Lusso 800 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Turismo Veloce RC 800 Base": ["2017", "2018"],
    "SuperVeloce 800 Serie Oro": ["2020", "2021"],
  },
  Piaggio: {
    "MP3 250": ["2007", "2008", "2009", "2010"],
    "MP3 400": ["2008", "2009", "2010"],
    "MP3 500": ["2008", "2009", "2010"],
    "Fly 150 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "MP3 250 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Typhoon 125 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "BV 350 Base": ["2012", "2013", "2014", "2015"],
    "BV 350 ABS Base": ["2015", "2016", "2017"],
    "BV Tourer 250 Base": ["2007", "2008", "2009", "2010"],
    "MP3 500 Sport ABS Base": ["2015", "2016"],
    "BV Tourer 500 Base": ["2007", "2008", "2009", "2010"],
    "MP3 400 Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "MP3 500 Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "Typhoon 50 Base": ["2013", "2014", "2015", "2016", "2017"],
    "Fly 50 4V Base": ["2013", "2014", "2015", "2016", "2017"],
    "Fly 50 Base": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "Liberty 150 Base": ["2018", "2019"],
    "Liberty 50 Base": ["2018", "2019"],
    "Liberty S 150 Base": ["2018", "2019"],
  },
  SDG: {
    "Speed Mini 107": ["2004", "2005", "2006"],
    "Lil Mini 50 Base": ["2005", "2006"],
    "Pro Mini 125 Base": ["2005", "2006"],
    "Speed Mini 107 Base": ["2004", "2005", "2006"],
  },
  Sherco: {
    "125 SE-R Racing": ["2017", "2018", "2019", "2020", "2021"],
    "250 SE-R Racing": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "250 SEF-R Racing": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "290 X-Ride": ["2017", "2018"],
    "300 SE-R Racing": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "300 SEF-R Racing": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "450 SEF-R Racing": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "125 SE-R Factory": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "250 SE-R Factory": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "250 SEF-R Factory": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "300 SE-R Factory": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "300 SEF-R Factory": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "450 SEF-R Factory": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "250 SC Cross Country": ["2017", "2018", "2019", "2020"],
    "300 SC Cross Country": ["2017", "2018", "2019", "2020"],
    "450 SC-F Cross Country": ["2019", "2020"],
    "500 SC-F Cross Country": ["2019", "2020"],
    "500 SEF-R Factory": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "125 SC Cross Country": ["2019", "2020"],
    "500 SEF-R Racing": ["2020", "2021"],
    "250 SC-F Cross Country": ["2017", "2018", "2019", "2020"],
    "300 SC-F Cross Country": ["2017", "2018", "2019", "2020"],
  },
  TM: {
    "125E": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "250E": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "300E": ["1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "80E": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "EN 125": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "EN 125 2T": ["1998", "1999", "2003", "2004", "2006", "2007", "2008"],
    "EN 144": ["2008", "2009", "2017", "2018", "2019", "2020"],
    "EN 250": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "EN 250 2T": ["2002", "2003", "2004", "2005", "2007", "2008"],
    "EN 250 FI 2T": ["2017", "2018", "2019"],
    "EN 250F": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "EN 300": ["2009", "2010", "2017", "2018", "2019", "2020", "2021"],
    "EN 300 2T": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "EN 300 FI 2T": ["2017", "2018", "2019"],
    "EN 450 4T": ["2004", "2005", "2006", "2007"],
    "EN 450F": ["2008", "2009", "2010", "2017", "2018", "2019", "2020"],
    "EN 530 4T": ["2005", "2006", "2007"],
    "EN 530F": [
      "2002",
      "2003",
      "2004",
      "2008",
      "2009",
      "2010",
      "2011",
      "2017",
      "2018",
    ],
    "MX 100 Junior": ["2001", "2002", "2003", "2017", "2018"],
    "MX 125": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "MX 125 2T": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "MX 144": ["2017", "2018", "2019", "2020"],
    "MX 250": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "MX 250 2T": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
    ],
    "MX 250 TPI 2T": [
      "2009",
      "2010",
      "2011",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "MX 250F": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "MX 300": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "MX 300 FI 2T": ["2017", "2018", "2019", "2020"],
    "MX 450 4T": ["2004", "2005", "2006", "2007", "2008"],
    "MX 450F": ["2009", "2010", "2017", "2018", "2019", "2020"],
    "MX 530 4T": ["2005", "2006"],
    "MX 530F": [
      "2002",
      "2003",
      "2004",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2017",
      "2018",
    ],
    "MX 80 Junior (17/14)": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2017",
      "2018",
    ],
    "MX 80 Junior (19/16)": ["2017", "2018"],
    "MX 85 (21/19)": ["2017", "2018"],
    "MX 85 Junior (17/14)": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "MX 85 Junior (19/16)": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2017",
      "2018",
    ],
    "SMM 125": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "SMM 450F": ["2005", "2006", "2007", "2008", "2009"],
    "SMM 530F": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "SMR 125": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "SMR 450F": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "SMR 530F": ["2005", "2006", "2007", "2008", "2009"],
    "SMX 450F": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "SMX 660F": ["2004", "2005", "2006", "2008", "2009"],
    "EN 400F": ["2002", "2003"],
    "MX 400F": ["2002", "2003"],
    "125E Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "250E Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "300E Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "80E Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "EN125 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "EN144 Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "EN250 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "EN250F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
    ],
    "EN300 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "EN450F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "EN530F Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Mx100 Base": ["2001", "2002", "2003"],
    "Mx125 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "MX144 Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Mx250 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "MX250F Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "MX300 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "MX450F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "MX530F Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Mx80 Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "MX85 (17/14) Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "MX85 (19/16) Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "MX85 jr Base": ["2014", "2015"],
    "SMM125 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "SMM450F Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "SMM530F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "SMR125 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "SMR450F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "SMR530F Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "SMX450F Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "SMX530F Base": ["2012", "2013"],
    "SMX660F Base": ["2004", "2005", "2006", "2008", "2009", "2010"],
  },
  Triumph: {
    Adventurer: ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    "America 800": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "America 865": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "America LT": ["2014", "2015", "2016", "2017"],
    "Bonneville 800": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Bonneville 865": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Bonneville Bobber 1200": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Bonneville SE 865": ["2009", "2010", "2011", "2012"],
    "Bonneville T100 800": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Bonneville T100 865": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Bonneville T100 900": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Bonneville T120 1200": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Daytona 1200": ["1993", "1994", "1995", "1996", "1997"],
    "Daytona 600R": ["2002", "2003", "2004"],
    "Daytona 675": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Daytona 675R": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Daytona 900": ["1994", "1995", "1996", "1997"],
    "Daytona 900 Super III": ["1994", "1995", "1996", "1997"],
    "Daytona 955i": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Daytona T595": ["1997", "1998"],
    "Legend TT 900": ["1999", "2000", "2001", "2002"],
    "Rocket 3": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "Rocket 3 Classic": ["2006", "2007", "2008", "2009"],
    "Rocket 3 Roadster": [
      "2010",
      "2011",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Rocket 3 Touring": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
    ],
    "Rocket III Roadster": ["2012", "2013"],
    "Scrambler 865": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Scrambler 900": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "Speed Four 600 I.E.": ["2002", "2003", "2004", "2005", "2006"],
    "Speed Triple 1050": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Speed Triple 900 T509": ["1997", "1998", "1999", "2000"],
    "Speed Triple 955 I.E.": ["2000", "2001", "2002", "2003", "2004"],
    "Speed Triple R 1050": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Speed Triple S 1050": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Speedmaster 800": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Speedmaster 865": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Sprint 900": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Sprint Gt 1050": ["2011", "2012"],
    "Sprint Rs 955 I.E": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Sprint Sport": ["1995", "1996", "1997", "1998"],
    "Sprint St 1050": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Sprint St 955 I.E.": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Street Cup 900": ["2017", "2018"],
    "Street Scrambler 900": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Street Triple 675": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Street Triple 675 R": ["2016", "2017"],
    "Street Triple 675R": ["2011", "2012", "2014", "2015"],
    "Street Twin 900": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "Thruxton 1200": ["2016", "2017", "2018"],
    "Thruxton 1200 R": ["2016", "2017", "2018"],
    "Thruxton 865": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    Thunderbird: [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2010",
      "2011",
      "2012",
    ],
    "Thunderbird 1600": ["2010", "2011", "2012", "2013", "2014"],
    "Thunderbird 1700": ["2010", "2011"],
    "Thunderbird 900": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Thunderbird Commander": ["2014", "2015"],
    "Thunderbird LT": ["2014", "2015", "2016", "2017"],
    "Thunderbird Sport": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Thunderbird Storm": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Tiger 1050": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Tiger 1215 Explorer": ["2012", "2013", "2014", "2015"],
    "Tiger 1215 Explorer XC": ["2013", "2014", "2015"],
    "Tiger 1215 Explorer XCa": ["2016", "2017", "2018", "2019", "2020"],
    "Tiger 1215 Explorer XCx": ["2016", "2017", "2018", "2019"],
    "Tiger 1215 Explorer XCx Low": ["2016", "2017"],
    "Tiger 1215 Explorer XR": ["2016", "2017", "2018", "2019"],
    "Tiger 1215 Explorer XRt": ["2016", "2017", "2018", "2019"],
    "Tiger 1215 Explorer XRx": ["2016", "2017", "2018", "2019"],
    "Tiger 1215 Explorer XRx Low": ["2016", "2017", "2018", "2019"],
    "Tiger 800": ["2011", "2012", "2013", "2014"],
    "Tiger 800 Xc": ["2011", "2012", "2013", "2014"],
    "Tiger 800 XCa": ["2016", "2017", "2018", "2019", "2020"],
    "Tiger 800 XCx": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Tiger 800 XCx Low": ["2016", "2017"],
    "Tiger 800 XR": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Tiger 800 XRt": ["2016", "2017", "2018", "2019", "2020"],
    "Tiger 800 XRx": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Tiger 800 XRx Low": ["2016", "2017", "2018", "2019", "2020"],
    "Tiger 900": ["1995", "1996", "1997", "1998", "2020", "2021", "2022"],
    "Tiger 955 I.E.": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Trident 900": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Trophy 1200": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Trophy 900": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Trophy SE 1215": ["2013", "2014", "2015", "2016", "2017"],
    "TT600 I.E.": ["2000", "2001", "2002", "2003"],
    "Spitfire Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "Stag Base": ["1970", "1971", "1972", "1973"],
    "TR6 Base": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
    "TR7 Base": ["1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    "Bonneville Bobber 1200 Black": ["2018", "2019", "2020"],
    "Bonneville Speedmaster 1200": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Street Triple 765 R": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Street Triple 765 R Low": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Street Triple 765 RS": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Street Triple 765 S": ["2018", "2019", "2020"],
    "Tiger 900 GT": ["2020", "2021", "2022", "2023", "2024"],
    "Tiger 900 GT Pro": ["2020", "2021", "2022", "2023", "2024"],
    "Tiger 900 Rally": ["2020", "2021", "2022", "2023", "2024"],
    "Tiger 900 Rally Pro": ["2020", "2021", "2022", "2023", "2024"],
    "Daytona 675 Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Daytona 675 R Base": ["2011", "2012", "2013", "2014", "2016", "2017"],
    "Tiger Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Tiger 1050 ABS Base": ["2010", "2011"],
    "Tiger 1050 SE Base": ["2010", "2011"],
    "Sprint GT Base": ["2011", "2012"],
    "Sprint ST Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Trophy SE Base": ["2013", "2014", "2016", "2017"],
    "Tiger 1200XCa": ["2018", "2019", "2020"],
    "Tiger 1200XCx": ["2018", "2019", "2020", "2021", "2022"],
    "Tiger 1200XR": ["2018", "2019", "2020", "2021", "2022"],
    "Tiger 1200XRt": ["2018", "2019", "2020", "2021", "2022"],
    "Tiger 1200XRx": ["2018", "2019", "2020", "2021", "2022"],
    "Tiger 1200XRX Low": ["2018", "2019", "2020"],
    "Speed Triple RS 1050": ["2018", "2019", "2020", "2021", "2022"],
    "Trident 660": ["2021", "2022", "2023"],
    "Speed Twin 1200": ["2020", "2021", "2022", "2023"],
    "Speed Triple 1200 RS": ["2021", "2022", "2023"],
    TF250X: ["2024", "2025"],
    "Speed Triple 1200 RR": ["2023", "2024"],
    "Scrambler 1200 XC": ["2020", "2021", "2022", "2023", "2024"],
    "Scrambler 1200 XE": ["2020", "2021", "2022", "2023", "2024"],
    "Tiger 900 GT Low": ["2020", "2021", "2022", "2023", "2024"],
    "Rocket 3 GT": ["2020", "2021", "2022", "2023"],
    "Rocket 3 R": ["2020", "2021", "2022", "2023"],
    "Tiger 850 Sport": ["2021", "2022", "2023", "2024"],
    "Tiger Sport 660": ["2023", "2024"],
    "Thruxton RS 1200": ["2020", "2021", "2022", "2023"],
    "Daytona 955i Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Speed Triple Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Speed Triple ABS Base": ["2011", "2012", "2013", "2014", "2015"],
    "Speed Triple R ABS Base": ["2012", "2013", "2014", "2015"],
    "Sprint RS Base": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "Thunderbird Sport Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Tiger 800 ABS Base": ["2011", "2012", "2013", "2014"],
    "Tiger 800 Xc Base": ["2014", "2015", "2016"],
    "Tiger 800 XC ABS Base": ["2011", "2012", "2013"],
    "Tiger 800 XCx Base": ["2015", "2016", "2017", "2018", "2019"],
    "Tiger 800 XR Base": ["2015", "2016", "2017", "2018", "2019"],
    "Tiger 800 XRx Base": ["2015", "2016", "2017", "2018", "2019"],
    "Trophy 1200 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Trophy 900 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "TR8 Base": ["1980", "1981"],
    "Adventurer Base": ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    "America Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "America LT Base": ["2014", "2015", "2016"],
    "Bonneville Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Bonneville Bobber Base": ["2017", "2018", "2019"],
    "Bonneville Bobber Black Base": ["2018", "2019"],
    "Bonneville SE Base": ["2009", "2010", "2011", "2012", "2013"],
    "Bonneville Speedmaster Base": ["2018", "2019"],
    "Bonneville T100 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
    ],
    "Bonneville T100 Black Base": ["2014", "2015", "2017", "2018", "2019"],
    "Bonneville T120 Base": ["2016", "2017", "2018", "2019"],
    "Bonneville T120 Black Base": ["2016", "2017", "2018", "2019"],
    "Daytona 1200 Base": ["1993", "1994", "1995", "1996", "1997"],
    "Daytona 600 Base": ["2003", "2004"],
    "Daytona 900 Base": ["1994", "1995", "1996"],
    "Daytona 900 Super III Base": ["1994", "1995", "1996", "1997"],
    "Legend TT Base": ["1999", "2000", "2001", "2002"],
    "LF Harris Bonneville Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Rocket III Base": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "Rocket III Classic Base": ["2006", "2007", "2008", "2009"],
    "Rocket III Classic Tourer Base": ["2007", "2008", "2009", "2010", "2011"],
    "Rocket III Roadster Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Rocket III Touring Base": ["2012", "2013", "2014", "2016", "2017"],
    "Scrambler Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Speed Four Base": ["2002", "2003", "2004", "2005", "2006"],
    "Speed Triple R Base": ["2016", "2017"],
    "Speed Triple RS Base": ["2018", "2019"],
    "Speed Triple S Base": ["2016", "2017", "2018", "2019"],
    "Speed Triple T509 Base": ["1997", "1998", "1999", "2000"],
    "Speedmaster Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Sprint Base": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Street Cup Base": ["2017", "2018", "2019"],
    "Street Scrambler Base": ["2017", "2018", "2019"],
    "Street Triple 675 Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Street Triple ABS Base": ["2014", "2015", "2016"],
    "Street Triple R Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2017",
      "2018",
      "2019",
    ],
    "Street Triple R ABS Base": ["2014", "2015", "2016"],
    "Street Triple R Low Base": ["2018", "2019"],
    "Street Triple RS Base": ["2018", "2019"],
    "Street Triple S Base": ["2018", "2019"],
    "Street Twin Base": ["2016", "2017", "2018", "2019"],
    "Thruxton Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Thruxton 1200 Base": ["2016", "2017", "2018", "2019"],
    "Thruxton 1200 R Base": ["2017", "2018", "2019"],
    "Thunderbird Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Thunderbird 1700 Base": ["2010", "2011"],
    "Thunderbird ABS Base": ["2010", "2011", "2012", "2013"],
    "Thunderbird LT Base": ["2016", "2017"],
    "Thunderbird Storm Base": ["2011", "2012", "2013", "2014", "2016", "2017"],
    "Thunderbird Storm ABS Base": ["2012", "2013"],
    "Tiger 1200 XCa Base": ["2018", "2019"],
    "Tiger 1200 XCx Base": ["2018", "2019"],
    "Tiger 1200 XR Base": ["2018", "2019"],
    "Tiger 1200 XRt Base": ["2018", "2019"],
    "Tiger 1200 XRx Base": ["2018", "2019"],
    "Tiger 1200 XRx Low Base": ["2018", "2019"],
    "Tiger 800 XCa Base": ["2016", "2017", "2018", "2019"],
    "Tiger 800 XCx Low Base": ["2016", "2017"],
    "Tiger 800 XRt Base": ["2016", "2017", "2018", "2019"],
    "Tiger 800 XRx Low Base": ["2016", "2017", "2018", "2019"],
    "Tiger Explorer Base": ["2012", "2013", "2014"],
    "Tiger Explorer XC Base": ["2013", "2014"],
    "Trident Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "TT600 Base": ["2000", "2001", "2002", "2003"],
    "Bonneville T120 1200 Black": ["2022", "2023"],
    "Rocket 3 TFC": ["2020", "2021"],
    "TR3A Base": ["1957", "1958", "1959", "1960", "1961", "1962"],
    "TR4 Base": ["1961", "1962", "1963", "1964", "1965"],
    "TR4A Base": ["1965", "1966", "1967", "1968"],
  },
  Vespa: {
    Et2: ["2001", "2002", "2003", "2004", "2005"],
    Et4: ["2001", "2002", "2003", "2004", "2005"],
    "Lx 50": ["2005", "2006", "2007", "2008", "2009"],
    "S 150": ["2008", "2009"],
    "GTS 300 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "GTS 300 Super Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "GTS 300 Super Sport Base": ["2015", "2016", "2017", "2018"],
    "GTS 300 Super Sport SE Base": ["2013", "2014"],
    "GTV 300 Base": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "GT 200 Granturismo Base": ["2004", "2005", "2006", "2007"],
    "GTS 250 Base": ["2006", "2007", "2008", "2009"],
    "GTV 250 Base": ["2007", "2008", "2009", "2010"],
    "LX 150 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "LXV 150 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "PX 150 Base": ["2005", "2006", "2007"],
    "S 150 Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "S 150 Sport SE Base": ["2013", "2014"],
    "Sprint 150 Base": ["2015", "2016", "2017", "2018"],
    "Sprint 50 Base": ["2015", "2016", "2017", "2018"],
    "Sprint S 150 Base": ["2015", "2016", "2017", "2018"],
    "946 Base": ["2013", "2014"],
    "Et2 Base": ["2001", "2002", "2003", "2004", "2005"],
    "Et4 Base": ["2001", "2002", "2003", "2004", "2005"],
    "Lx 50 Base": ["2005", "2006", "2007", "2008", "2009"],
    "LX 50 4V Base": ["2010", "2011", "2012", "2013", "2014"],
    "Primavera 150 Base": ["2015", "2016", "2017", "2018"],
    "Primavera 50 Base": ["2015", "2016", "2017", "2018"],
    "Primavera Touring 150 Base": ["2015", "2016"],
    "S 50 4V Base": ["2010", "2011", "2012", "2013", "2014"],
    "S 50 4V Sport SE Base": ["2013", "2014"],
  },
  Victory: {
    Boardwalk: ["2013", "2014"],
    "Cross Country": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Cross Country 8-Ball": ["2014", "2015", "2016"],
    "Cross Country Tour": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Cross Roads": ["2010", "2011", "2012", "2013"],
    "Cross Roads Classic Le": ["2012", "2013", "2014"],
    Gunner: ["2015", "2016", "2017"],
    Hammer: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Hammer 8-Ball": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Hammer S": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2016",
      "2017",
    ],
    "Hard Ball": ["2012", "2013"],
    "High Ball": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    Judge: ["2013", "2014"],
    Kingpin: [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Kingpin 8-Ball": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Kingpin Deluxe": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Kingpin Tour": ["2007", "2008", "2009", "2010", "2011", "2012"],
    Magnum: ["2015", "2016", "2017"],
    "Magnum X-1": ["2015", "2016", "2017"],
    "Ness Cross Country": ["2011", "2012", "2013", "2014"],
    "Ness Jackpot": ["2006", "2007", "2008", "2009", "2010"],
    "Ness Vegas": ["2011", "2012"],
    "Ness Vision": ["2009", "2010", "2011", "2012", "2013"],
    "V92C Classic": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "V92C Special Edition": ["2000", "2001", "2002"],
    "V92Sc Sport Cruiser": ["2000", "2001"],
    "V92Tc Touring Cruiser": ["2002", "2003", "2004", "2005", "2006"],
    Vegas: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2016",
      "2017",
    ],
    "Vegas 8-Ball": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Vegas Jackpot": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Vegas Low": ["2008", "2009"],
    "Vision 8-Ball": ["2010", "2011", "2012"],
    "Vision Street": ["2008", "2009"],
    "Vision Street Premium": ["2008", "2009"],
    "Vision Tour": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Vision Tour Comfort": ["2008", "2009"],
    "Vision Tour Premium": ["2008", "2009"],
    "Arlen Ness Jackpot Base": ["2006", "2007", "2008"],
    "Hammer Base": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "Hammer S Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2016",
      "2017",
    ],
    "Kingpin Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Kingpin Tour Base": ["2007", "2008", "2009"],
    "Vegas Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2016",
      "2017",
    ],
    "Vegas Jackpot Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Arlen Ness Vision Base": ["2009", "2010", "2011", "2012", "2013"],
    "Boardwalk Base": ["2013", "2014"],
    "Cory Ness Cross Country Base": ["2011", "2012"],
    "Cory Ness Jackpot Base": ["2008", "2009", "2010"],
    "Cross Country Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Cross Country 8-Ball Base": ["2014", "2015", "2016"],
    "Cross Country Tour Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Cross Roads Base": ["2010", "2011", "2012"],
    "Cross Roads Classic Base": ["2013", "2014"],
    "Gunner Base": ["2015", "2016", "2017"],
    "Hammer 8-Ball Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Hard-Ball Base": ["2012", "2013"],
    "High-Ball Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Judge Base": ["2013", "2014"],
    "Kingpin 8-Ball Base": ["2008", "2009", "2010", "2011"],
    "Magnum Base": ["2015", "2016", "2017"],
    "Touring Cruiser Base": ["2003", "2004", "2005", "2006"],
    "V92C Standard Cruiser Base": ["1998", "1999", "2000", "2001", "2002"],
    "V92C Standard Cruiser Deluxe Base": ["2001", "2002"],
    "V92Sc Sport Cruiser Base": ["2000", "2001"],
    "Vegas 8-Ball Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Vegas Low Base": ["2008", "2009"],
    "Vision Base": ["2016", "2017"],
    "Vision 8-Ball Base": ["2010", "2011"],
    "Vision Street Base": ["2008", "2009"],
    "Vision Street Premium Base": ["2008", "2009"],
    "Vision Tour Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Vision Tour Comfort Base": ["2008", "2009"],
    "Vision Tour Premium Base": ["2008", "2009"],
    "Zach Ness Vegas Base": ["2011", "2012"],
  },
  Vor: {
    "400 En": ["2000", "2001", "2002"],
    "400 Mx": ["2000", "2001"],
    "400 Sm": ["2000", "2001", "2002"],
    "500 En": ["2000", "2001"],
    "500 Mx": ["2000", "2001"],
    "500 Sm": ["2000", "2001"],
    "400 En Base": ["2000", "2001", "2002"],
    "400 Mx Base": ["2000", "2001"],
    "400 Sm Base": ["2000", "2001", "2002"],
    "450 En-E Base": ["2004", "2005"],
    "450 Mx Base": ["2004", "2005"],
    "450 SM-RC Base": ["2004", "2005"],
    "450 SME Base": ["2004", "2005"],
    "500 En Base": ["2000", "2001"],
    "500 Mx Base": ["2000", "2001"],
    "500 Sm Base": ["2000", "2001"],
    "530 En-E Base": ["2004", "2005"],
    "530 Mx Base": ["2004", "2005"],
    "530 SME Base": ["2004", "2005"],
    "570 SM-RC Base": ["2004", "2005"],
  },
  Yamaha: {
    AT1: ["1969", "1970", "1971"],
    At1M: ["1970", "1971"],
    Bw200: ["1985", "1986", "1987", "1988"],
    Bw350: ["1987", "1988"],
    Bw80: ["1986", "1987", "1988", "1989", "1990"],
    "CP250 Morphous": ["2006", "2007", "2008"],
    CS3: ["1970", "1971"],
    CT1: ["1969", "1970", "1971"],
    "CV80 Riva 80": ["1983", "1984", "1985", "1986", "1987"],
    "CW50 Zuma II": ["1997", "1998", "1999", "2000", "2001"],
    "CY50 Jog": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    DS6: ["1969", "1970"],
    Dt100: [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    Dt125: ["1974", "1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    Dt175: ["1974", "1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    Dt2: ["1972", "1973"],
    Dt250: ["1974", "1975", "1976", "1977", "1978", "1979"],
    Dt400: ["1975", "1976", "1977", "1978"],
    Dt50: ["1988", "1989", "1990"],
    Dt80: ["1981", "1982", "1983"],
    "FJ-09": ["2015", "2016", "2017"],
    FJ1100: ["1984", "1985", "1986"],
    FJ1200: [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    FJ600: ["1984", "1985", "1986", "1990", "1991", "1992", "1993"],
    FJR1300: ["2001", "2002", "2003", "2004", "2005", "2006"],
    "FJR1300A ABS": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2018",
      "2019",
    ],
    FJR1300AE: ["2005", "2006", "2007", "2008", "2009", "2010"],
    FJR1300ES: ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "FZ-07": ["2015", "2016", "2017"],
    "FZ-09": ["2014", "2015", "2016", "2017"],
    FZ600: ["1986", "1987", "1988", "1989"],
    "FZ700 Genesis": ["1986", "1987"],
    FZ750: [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    FZR1000: [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    FZR400: ["1988", "1989", "1990"],
    FZR600R: [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    FZR750R: ["1987", "1988", "1989", "1990", "1991", "1992"],
    "FZS1000 FZ1": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "FZS600 Fazer": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "FZS600 FZ6": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "FZS600 FZ6R": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FZS700 Fazer": ["1986", "1987"],
    "FZS800 FZ8": ["2010", "2011", "2012", "2013"],
    G6S: ["1970", "1971"],
    GT80: ["1973", "1974", "1975", "1976", "1977", "1978", "1979", "1980"],
    GTMX: ["1973", "1974", "1975", "1976", "1977", "1978", "1979"],
    GTS1000A: ["1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    HS1: ["1970", "1971"],
    Ht1: ["1970", "1971"],
    It125: ["1980", "1981"],
    It175: ["1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    It200: ["1984", "1985", "1986"],
    It250: ["1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    It400: ["1976", "1977", "1978", "1979"],
    It465: ["1981", "1982"],
    It490: ["1983", "1984"],
    LB50: ["1981", "1982"],
    Mx100: ["1974", "1975", "1979", "1980", "1981", "1982", "1983"],
    Mx125: ["1974", "1975", "1976"],
    Mx175: ["1974", "1975", "1976", "1977", "1978", "1979", "1980", "1981"],
    Mx250: ["1973", "1974", "1975"],
    Mx360: ["1973", "1974"],
    Mx80: ["1980", "1981", "1982"],
    "PW 50": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "PW 80": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    Qt50: [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    R5: ["1970", "1971", "1972"],
    RD125: ["1975", "1976"],
    RD200: ["1974", "1975", "1976"],
    RD250: ["1973", "1974", "1975"],
    RD350: ["1973", "1974", "1975"],
    RD400: ["1976", "1977", "1978", "1979"],
    RD60: ["1973", "1974", "1975"],
    RS100: ["1975", "1976"],
    Rt1: ["1970", "1971"],
    Rt100: [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    Rt180: [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    Rt1Mx: ["1970", "1971"],
    Rt2: ["1972", "1973"],
    RZ350: ["1984", "1985"],
    Sc500: ["1973", "1974"],
    SR185: ["1981", "1982"],
    SR250: ["1980", "1981", "1982"],
    SR400: ["2015", "2016", "2017", "2018", "2019"],
    SR500: [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    TDM850: [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "TT-R110E": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TT-R125": ["2000", "2001", "2002", "2003"],
    "TT-R125E": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "TT-R125L": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "TT-R125LE": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TT-R225": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "TT-R230": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TT-R250": ["1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "TT-R50E": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "TT-R90": ["2000", "2001", "2002", "2003"],
    "TT-R90E": ["2003", "2004", "2005", "2006", "2007", "2008"],
    TT225: ["1986", "1987"],
    TT250: ["1980", "1981", "1982", "1999", "2000"],
    TT350: ["1986", "1987"],
    TT500: ["1976", "1977", "1978", "1979", "1980", "1981"],
    TT600: ["1983", "1984", "1985", "1986"],
    TW200: [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    TX500: ["1973", "1974"],
    TX650: ["1973", "1974"],
    TX750: ["1973", "1974"],
    Ty175: ["1975", "1976", "1977", "1978", "1979"],
    Ty250: ["1974", "1975", "1976", "1977", "1978"],
    Ty350: ["1985", "1986"],
    Ty80: ["1974", "1975"],
    Tz250: ["1980", "1981", "1982"],
    Tz350: ["1976", "1977", "1978"],
    "VMX1200 V-Max": [
      "1985",
      "1986",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VMX1700 V-Max": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    WR250: ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    WR250F: [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    WR250R: [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    WR250X: ["2008", "2009", "2010", "2011"],
    WR400F: ["1998", "1999", "2000"],
    WR426F: ["2001", "2002"],
    WR450F: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    WR500: ["1992", "1993"],
    "XC125 Riva 125": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "XC155F S-Max": ["2015", "2016", "2017"],
    "XC180 Riva 180": ["1983", "1984", "1985"],
    "XC180Z Riva": ["1983", "1984"],
    "XC200 Riva": ["1987", "1988", "1989", "1990", "1991"],
    "XC50 Vino 50 Classic": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "XF50 C3": ["2007", "2008", "2009", "2010", "2011"],
    "XJ550 Maxim": ["1981", "1982", "1983"],
    "XJ550R Seca": ["1981", "1982", "1983"],
    "XJ600S Diversion/Seca Ii": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "XJ650 Maxim": ["1980", "1981", "1982", "1983", "1984"],
    "XJ650L Turbo Seca": ["1981", "1982", "1983", "1984", "1985"],
    "XJ650R Seca": ["1982", "1983"],
    "XJ700 Maxim": ["1985", "1986"],
    "XJ700X Maxim X": ["1985", "1986"],
    "XJ750 Maxim": ["1982", "1983"],
    "XJ750R Seca": ["1981", "1982", "1983"],
    "XP50 C3": ["2007", "2008", "2009"],
    "XP500 TMAX": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2015",
      "2016",
    ],
    XS1: ["1970", "1971"],
    XS1100: ["1978", "1979", "1980", "1981", "1982", "1983", "1984"],
    "XS1100L Mid-Special": ["1980", "1981"],
    "XS1100S Special": ["1979", "1980", "1981"],
    XS360: ["1976", "1977"],
    XS400: ["1977", "1978", "1979", "1980", "1981"],
    "XS400 Maxim": ["1982", "1983"],
    "XS400-2": ["1978", "1979"],
    "XS400R Seca": ["1982", "1983"],
    "XS400S Special": ["1980", "1981", "1982"],
    XS500: ["1975", "1976", "1977", "1978"],
    XS650: [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
    ],
    "XS650S Special": ["1978", "1979", "1980", "1981", "1982", "1983"],
    XS750: ["1976", "1977", "1978", "1979", "1980"],
    XS750S: ["1978", "1979"],
    XS850: ["1980", "1981"],
    "XS850L Mid-Special": ["1980", "1981"],
    "XS850S Special": ["1980", "1981"],
    XSR900: [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    XT125: ["1982", "1983"],
    XT200: ["1982", "1983"],
    XT225: [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    XT250: [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    XT350: [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    XT500: ["1976", "1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    XT550: ["1982", "1983"],
    XT600: [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "XTZ1200 Super T\u00e9n\u00e9r\u00e9": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "XTZ1200E Super T\u00e9n\u00e9r\u00e9 ES": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "XV1000 Virago": ["1981", "1982", "1983", "1984", "1985"],
    "XV1100 Virago": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "XV16A Road Star": ["1999", "2000", "2001", "2002", "2003"],
    "XV16AS Road Star Midnight": ["2000", "2001", "2002", "2003"],
    "XV16AT Road Star Silverado": ["1999", "2000", "2001", "2002", "2003"],
    "XV17A Road Star": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "XV17AM Road Star Midnight": ["2004", "2005", "2006", "2007"],
    "XV17AS Road Star S": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XV17AT Road Star Silverado": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "XV17ATM Road Star Midnight Silverado": ["2004", "2005", "2006", "2007"],
    "XV17ATS Road Star Silverado S": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XV17PC Road Star Warrior": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XV17PCM Road Star Midnight Warrior": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XV19C Raider": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "XV19CS Raider S": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "XV19CT Stratoliner": ["2006", "2007", "2009", "2010", "2011", "2012"],
    "XV19CTF Stratoliner Deluxe": ["2010", "2011", "2012"],
    "XV19CTM Stratoliner Midnight": ["2006", "2007", "2008"],
    "XV19CTS Stratoliner S": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XV19SCL Raider SCL": ["2012", "2013"],
    "XV19V Roadliner": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "XV19VM Roadliner Midnight": ["2006", "2007", "2008", "2009"],
    "XV19VS Roadliner S": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XV250 Route 66": ["1988", "1989", "1990"],
    "XV250 V-Star 250": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "XV250 Virago": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "XV500 Virago": ["1983", "1984"],
    "XV535 Virago": [
      "1987",
      "1988",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "XV700 Virago": ["1984", "1985", "1986", "1987"],
    "XV750 Virago": [
      "1981",
      "1982",
      "1983",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "XV920 Virago": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "XV920R Seca": ["1981", "1982"],
    "XVS11 V-Star 1100 Custom": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XVS11A V-Star 1100 Classic": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XVS11AT V-Star 1100 Silverado": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XVS13A V-Star 1300": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "XVS13C Stryker": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "XVS13CG Stryker Bullet Cowl": ["2015", "2016"],
    "XVS13CT V-Star 1300 Tourer": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "XVS13CTF V-Star 1300 Deluxe": ["2013", "2014", "2015", "2016", "2017"],
    "XVS65 V-Star 650 Custom": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "XVS65A V-Star 650 Classic": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XVS65AT V-Star 650 Silverado": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "XVS95 V-Star 950": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "XVS95C Bolt": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "XVS95C Bolt R Spec": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "XVS95CR Bolt C Spec": ["2015", "2016"],
    "XVS95CT V-Star 950 Tourer": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "XVZ1200 Venture": ["1983", "1984"],
    "XVZ1200D Venture Royale": ["1983", "1984", "1985", "1986"],
    "XVZ1300 Venture": ["1987", "1988"],
    "XVZ1300A Royal Star": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "XVZ1300A Royal Star Boulevard": ["1999", "2000", "2001", "2006", "2007"],
    "XVZ1300AT Royal Star Tour Classic": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "XVZ1300CT Royal Star Tour Deluxe": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XVZ1300CTM Royal Star Midnight Tour Deluxe": ["2006", "2007"],
    "XVZ1300D Venture Royale": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "XVZ1300TF Royal Star Venture": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XVZ1300TFM Royal Star Midnight Venture": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "XVZ1300TFS Royal Star Venture S": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "XZ550R Vision": ["1982", "1983"],
    "YJ125 Vino 125": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "YJ50 Vino": ["2001", "2002", "2003", "2004"],
    "YJ50RA Vino Classic": ["2002", "2003", "2004", "2005"],
    "YP400 Majesty": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    YSR50: ["1987", "1988", "1989", "1990", "1991", "1992"],
    "YW125 Zuma 125": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "YW50 Zuma": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "YW50F Zuma": ["2012", "2013", "2014", "2015", "2016"],
    "YW50FX Zuma": ["2014", "2015", "2016", "2017", "2018"],
    "YX600 Radian": ["1986", "1987", "1988", "1989", "1990", "1991"],
    YZ100: ["1976", "1977", "1978", "1979", "1980", "1981", "1982", "1983"],
    YZ125: [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    YZ250: [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    YZ250F: [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    YZ250FX: [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    YZ250WR: ["1989", "1990"],
    YZ250X: [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    YZ360: ["1974", "1975"],
    YZ400: ["1976", "1977", "1978", "1979"],
    YZ400F: ["1998", "1999"],
    YZ426F: ["2000", "2001", "2002"],
    YZ450F: [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    YZ450FX: [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    YZ465: ["1980", "1981"],
    YZ490: [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    YZ60: ["1981", "1982", "1983"],
    YZ65: ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    YZ80: [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    YZ85: [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "YZF-R1": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YZF-R1M": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YZF-R1S": ["2016", "2017", "2018"],
    "YZF-R3": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YZF-R6": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "YZF-R6S": ["2006", "2007", "2008", "2009", "2010"],
    "YZF-R7": ["1999", "2000", "2001", "2022", "2023", "2024"],
    YZF600R: [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    YZF750R: ["1993", "1994", "1995", "1996", "1997", "1998"],
    YZ125X: ["2020", "2021", "2022", "2023", "2024", "2025"],
    "YXR700F Rhino 700": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Apex GT": ["2006", "2007", "2008", "2009", "2010"],
    "Apex LTX GT": ["2008", "2009", "2010"],
    "Apex MTX": ["2008", "2009", "2010"],
    "Apex RTX": ["2006", "2007", "2008", "2009"],
    "RS Venture": [
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
    ],
    "RS Viking Pro": ["2008", "2009", "2010", "2013", "2014", "2015"],
    "VK Pro": ["2006", "2007", "2011", "2012"],
    YFZ450: ["2004", "2005", "2006", "2007", "2008", "2009", "2012", "2013"],
    "YFZ450 Bill Balance Edition": ["2006", "2007"],
    "YFZ450 SE": ["2007", "2008"],
    YFZ450R: [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "YFZ450R SE": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    YFZ450X: ["2010", "2011"],
    "YFM350FX Wolverine 4WD [SRA]": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "YFM350X Warrior": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "YFM600FG Grizzly 4WD [SRA]": ["1998", "1999", "2000", "2001"],
    "YFB250 Timberwolf 2WD [SRA]": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "YFB250FW Timberwolf 4WD [SRA]": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "YFM250 Moto-4": ["1989", "1990", "1991"],
    "YFM350ER Moto-4": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "YFM350FW Big Bear 4WD [SRA]": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "YFM400FA Kodiak 4WD [SRA]": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "AR 210 [Boat]": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2018",
      "2019",
    ],
    "AR 230 HO [Boat]": ["2005", "2006", "2007", "2008", "2009"],
    "AR 230 [Boat]": ["2004", "2005", "2006"],
    "FX (FX1000)": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "FX Cruiser (FX1000A)": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "FX Cruiser HO (FX1100-A)": ["2004", "2005", "2006", "2007", "2008"],
    "FX HO (FX1100)": ["2004", "2005", "2006", "2007", "2008"],
    "SR 210 [Boat]": ["2006", "2007"],
    "SR 230 [Boat]": ["2003", "2004", "2005"],
    "SX 210 [Boat]": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2018",
      "2019",
    ],
    "SX 230 HO [Boat]": ["2005", "2006", "2007", "2008", "2009"],
    "SX 230 [Boat]": ["2004", "2005", "2006"],
    "VX Sport (VX1100-C)": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "YFM350BA Bruin 2WD [SRA]": ["2004", "2005", "2006"],
    "YFM350FA Bruin 4WD [SRA]": ["2004", "2005", "2006"],
    "YFM400A Kodiak 2WD [SRA]": ["2000", "2001", "2002", "2003", "2004"],
    "YFM450FA Kodiak 4WD [IRS]": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YFM660FG Grizzly 4WD [IRS]": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "EX (EX1050-C)": ["2017", "2018", "2019", "2020", "2022", "2023"],
    "EX Deluxe (EX1050-A)": ["2017", "2018", "2019", "2020", "2022", "2023"],
    "EX Sport (EX1050-B)": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "MT-03": ["2020", "2021", "2022", "2023", "2024"],
    "MT-07": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "MT-09": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "MT-10": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "MTT9 Tracer 900": ["2018", "2019"],
    "MTT9GT Tracer 900 GT": ["2018", "2019", "2020", "2021", "2022"],
    "MXT9 Niken": ["2019", "2020", "2021"],
    "MXT9GT Niken GT": ["2019", "2020", "2021"],
    "VX Cruiser (VX1100-B)": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "VX Deluxe (VX1100-A)": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    XSR700: ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "XTZ700 T\u00e9n\u00e9r\u00e9": ["2020", "2021", "2022", "2023", "2024"],
    "XV19F Star Venture": ["2018", "2019", "2020", "2021"],
    "YFM350FG Grizzly 4WD [SRA]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "YFM350FGI Grizzly 4WD [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "YFM350G Grizzly 2WD [SRA]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "YFM350X Wolverine 2WD [SRA]": ["2006", "2007", "2008", "2009"],
    "YFM400FG Grizzly 4WD [IRS]": ["2007", "2008"],
    "YFM450FG Grizzly 4WD [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "YFM450FGP Grizzly 4WD EPS [IRS]": ["2011", "2012", "2013", "2014"],
    "YFM450FX Wolverine 4WD [SRA]": ["2006", "2007", "2008", "2009", "2010"],
    "YFM550FG Grizzly FI 4WD [IRS]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "YFM550FGP Grizzly FI 4WD EPS [IRS]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "YFM700F Grizzly Fi 4WD EPS SE [IRS]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YFM700F Grizzly Fi 4WD EPS [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YFM700G Grizzly Fi 4WD [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "YXR450F Rhino 450": ["2006", "2007", "2008", "2009"],
    "YFM700 Raptor": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "YFM700R Raptor": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "YFM700RSE Raptor SE": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "YFM200DX Moto-4": ["1985", "1986", "1987", "1988", "1989"],
    "YFM225 Moto-4": ["1986", "1987", "1988"],
    "YFM250B Big Bear [SRA]": ["2007", "2008", "2009"],
    "YFM250B Bruin 2WD [SRA]": ["2005", "2006"],
    "YFM250X Bear Tracker 2WD [SRA]": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "YTM200 Tri-Moto": ["1983", "1984", "1985"],
    "YTM225D Tri-Moto": ["1983", "1984", "1985", "1986"],
    "YFM350R Raptor": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "YFM350U Big Bear 2WD [SRA]": ["1996", "1997", "1998", "1999"],
    "YFM400 Big Bear 2WD [SRA]": ["2000", "2001", "2002", "2003", "2004"],
    "YFM400FB Big Bear 4WD [SRA]": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "YFM400FBI Big Bear 4WD [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "YFM660R Raptor": ["2001", "2002", "2003", "2004", "2005"],
    "YFM250R Raptor": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "YZ250F Monster Energy RE": ["2021", "2022"],
    "YZ450F Monster Energy RE": ["2021", "2022"],
    "CP250 Morphous Base": ["2006", "2007", "2008"],
    "FZS600 FZ6 Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "XP500 TMAX Base": ["2009", "2010", "2011", "2015", "2016"],
    "XTZ1200 Super T\u00e9n\u00e9r\u00e9 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "XTZ1200 Super Tenere ES Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "XV1900 Roadliner Base": ["2006", "2007"],
    "XV1900CT Stratoliner Base": ["2006", "2007"],
    "XV1900CT Stratoliner Deluxe Base": ["2010", "2011", "2012"],
    "XV1900CTM Stratoliner Midnight Base": ["2006", "2007", "2008"],
    "XV1900CTS Stratoliner S Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XV1900M Roadliner Midnight Base": ["2006", "2007", "2008", "2009"],
    "XV1900S Roadliner S Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
    ],
    "YZF-R1 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YZF-R3 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "YZF-R6 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YZF-R6S Base": ["2006", "2007", "2008", "2009"],
    "YXZ1000R SE Base": ["2016", "2017", "2018", "2019", "2020"],
    "YXZ1000R SS Base": ["2017", "2018", "2019", "2020"],
    "YXZ1000R SS SE Base": ["2017", "2018", "2019", "2020"],
    "FX Nytro": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "FX Nytro MTX": ["2008", "2009", "2010", "2013", "2014"],
    "FX Nytro MTX SE": ["2010", "2011", "2012"],
    "FX Nytro RTX": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "FX Nytro RTX SE": ["2009", "2010"],
    "FX Nytro XTX": ["2009", "2010", "2011", "2012", "2013", "2014"],
    Nytro: ["2006", "2007"],
    "RS Vector": ["2013", "2014", "2016", "2017", "2018"],
    "RS Vector GT": ["2008", "2009", "2010", "2011"],
    "RS Vector LTX": ["2008", "2009", "2013", "2014"],
    "RS Vector LTX GT": ["2008", "2009", "2010", "2011"],
    "RS Vector XTX": ["2016", "2017"],
    "RS Venture GT": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "RS Venture TF": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2020",
      "2021",
      "2022",
    ],
    "RX-1 ER": ["2004", "2005"],
    "RX-1 LE": ["2003", "2004"],
    "RX-1 Mountain": ["2003", "2004"],
    "VK Pro II": ["2016", "2017", "2018", "2020", "2021", "2022"],
    "SUV 1200 (SV1200)": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "XL 1200 (XA1200)": ["1998", "1999", "2000", "2001"],
    "XL 1200 LTD (XA1200)": ["1999", "2000"],
    XT600E: ["1990", "1991", "1992", "1993", "1994", "1995"],
    "YFM100 Champ": ["1987", "1988", "1989", "1990", "1991"],
    "YFM50R Raptor": ["2004", "2005", "2006", "2007", "2008"],
    "YFM80G Grizzly": ["2005", "2006", "2007", "2008"],
    "YFM80R Raptor": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "YXR660F Rhino 660": ["2004", "2005", "2006", "2007"],
    "YFM450KP Kodiak 4WD EPS [IRS]": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YFM450KPSE Kodiak 4WD EPS SE [IRS]": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YXZ 1000 R": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sidewinder B-TX LE": ["2017", "2018", "2019", "2020", "2021"],
    "Sidewinder B-TX SE": ["2017", "2018"],
    "Sidewinder L-TX DX": ["2017", "2018", "2019"],
    "Sidewinder L-TX LE": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Sidewinder L-TX SE": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sidewinder M-TX SE": ["2017", "2018"],
    "Sidewinder R-TX LE": ["2017", "2018"],
    "Sidewinder R-TX SE": ["2017", "2018"],
    "Sidewinder S-TX DX": ["2017", "2018"],
    "Sidewinder X-TX SE": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "SR Viper L-TX": ["2018", "2019"],
    "SR Viper L-TX DX": ["2015", "2016", "2017", "2018"],
    "SR Viper L-TX LE": ["2015", "2016", "2017", "2018"],
    "SR Viper L-TX SE": ["2014", "2015", "2016", "2017"],
    "SR Viper M-TX": ["2015", "2016"],
    "SR Viper M-TX LE": ["2015", "2016"],
    "SR Viper M-TX SE": ["2015", "2016", "2017"],
    "SR Viper R-TX DX": ["2015", "2016", "2017"],
    "SR Viper R-TX LE": ["2015", "2016"],
    "SR Viper R-TX SE": ["2014", "2015", "2016", "2017"],
    "SR Viper S-TX DX": ["2015", "2016", "2017"],
    "SR Viper X-TX SE": ["2014", "2015", "2016"],
    'Mountain Max LE 154"': ["2021", "2022", "2023", "2024"],
    'Mountain Max LE 154" SL': ["2022", "2023", "2024"],
    'Mountain Max LE 165"': ["2021", "2022", "2023", "2024"],
    "Sidewinder L-TX GT": ["2020", "2021"],
    "Sidewinder L-TX GT EPS": ["2022", "2023", "2024"],
    "Sidewinder S-RX LE": ["2019", "2020", "2021", "2022"],
    "Sidewinder S-TX GT EPS": ["2022", "2023", "2024"],
    "Sidewinder X-TX LE": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "SR Viper L-TX GT": ["2020", "2021", "2022", "2023", "2024"],
    "Transporter 800": ["2021", "2022", "2023", "2024", "2025"],
    "Apex Mountain": ["2006", "2007"],
    "Bravo 250": ["2006", "2007", "2008", "2009"],
    "Bravo LT": [
      "1990",
      "1991",
      "1993",
      "1994",
      "1995",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Mountain Max 600": ["1999", "2000", "2001"],
    "Mountain Max 700": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2002",
      "2003",
      "2004",
    ],
    "Ovation LE": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Phazer 500": ["1999", "2000", "2001"],
    "Phazer GT": ["2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "Phazer Mountain Lite": ["1997", "1998", "1999", "2000", "2001"],
    "Phazer MTX": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Phazer RTX": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Phazer SS": ["1997", "1998"],
    "Phazer XTX": ["2014", "2015", "2016", "2017", "2018"],
    Rage: ["2006", "2007"],
    "RS Venture TF LE": ["2016", "2017"],
    "SRX 600": ["1998", "1999"],
    "SRX 700": ["1998", "1999", "2000", "2001", "2002"],
    "SX 500 R": ["2000", "2001"],
    "SX 600 R": ["2002", "2003"],
    "SX Venom": ["2004", "2005", "2021", "2022", "2023", "2024", "2025"],
    "SX Viper ER": ["2002", "2003", "2004"],
    "SX Viper Mountain": ["2003", "2004", "2005", "2006"],
    "Vector GT": ["2006", "2007"],
    "Venture 500": ["2000", "2001"],
    "Venture 600": ["1999", "2000", "2001", "2004", "2005", "2006"],
    "Venture 700": ["2002", "2003", "2004"],
    "Venture Lite": ["2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "Venture MP": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Venture TR": ["1996", "1997", "1998"],
    "Venture XL": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "2000",
      "2001",
    ],
    "Viking 540": ["2000", "2001", "2002"],
    "VMax 500": ["1995", "1996", "2000", "2001"],
    "VMax 500 XTC": ["1997", "1998"],
    "VMax 600": ["1995", "1996"],
    "VMax 600 XT": ["1997", "1998"],
    "VMax 700": ["1999", "2000"],
    "VMax 700 Deluxe": ["1999", "2000"],
    "MT-09 SP": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "MT-10 SP": ["2022", "2023", "2024"],
    "YFZ350 Banshee": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "YFS200 Blaster": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "YXE1000 Wolverine RMAX2 Limited Edition": ["2021", "2022", "2023", "2024"],
    "YXE1000 Wolverine RMAX2 R-Spec": ["2022", "2023", "2024"],
    "YXE1000 Wolverine RMAX2 Sport": ["2022", "2023", "2024"],
    "YXE1000 Wolverine RMAX2 XT-R": ["2021", "2022", "2023", "2024"],
    "YXF1000 Wolverine RMAX4": ["2021", "2022"],
    "YXF1000 Wolverine RMAX4 Limited Edition": ["2021", "2022", "2023", "2024"],
    "YXF1000 Wolverine RMAX4 R-Spec": ["2022", "2023", "2024"],
    "YXF1000 Wolverine RMAX4 XT-R": ["2021", "2022", "2023", "2024"],
    "YXZ 1000R SE": ["2016", "2017", "2018", "2019", "2020"],
    "YXZ 1000R SS": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "YXZ 1000R SS SE": ["2017", "2018", "2019", "2020", "2021"],
    "YFM700F Grizzly Fi 4WD EPS XT-R [IRS]": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YFM700K Kodiak [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YFM700KP Kodiak EPS [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YFM700KPS Kodiak EPS SE [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YXZ 1000R SS XT-R": ["2020", "2021", "2022", "2023"],
    "YXE700 Wolverine R-Spec": ["2016", "2017"],
    "YXE700 Wolverine R-Spec EPS": ["2016", "2017", "2018"],
    "YXE700 Wolverine R-Spec EPS SE": ["2016", "2017", "2018"],
    "YXE850 Wolverine X2 R-Spec": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YXE850 Wolverine X2 R-Spec SE": ["2019", "2020"],
    "YXE850 Wolverine X2 R-Spec XT-R": ["2020", "2021", "2022", "2023", "2024"],
    "YXF850 Wolverine X4 R-Spec": ["2022", "2023", "2024"],
    "YXF850 Wolverine X4 XT-R": ["2020", "2021", "2022", "2023", "2024"],
    "YXM700 Viking EPS": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "YXM700 Viking EPS SE": ["2014", "2015", "2016", "2017", "2019", "2020"],
    "YXM700 Viking VI EPS": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "YXM700 Viking VI EPS SE": ["2015", "2016", "2017"],
    "YXR700F Rhino 700 Special Edition": ["2008", "2009", "2010", "2011"],
    "YXR700F Rhino 700 Sport Edition": ["2008", "2009", "2011", "2012", "2013"],
    "FX Cruiser SHO (FA1800-A)": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "FX Cruiser SVHO (FC1800-A)": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "FX LTD SVHO (FC1800B)": ["2017", "2018", "2019", "2020"],
    "FX SHO (FX/FA1800)": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "FX SVHO (FC1800)": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GP 1800 SVHO (GP1800)": ["2021", "2022"],
    "EXR (ER1050)": ["2019", "2020", "2021"],
    "Jet Blaster (JB1050)": ["2022", "2023"],
    "SuperJet (SJ1050)": ["2021", "2022", "2023"],
    "VX (VX1050-C)": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "VX Cruiser (VX1050-B)": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "VX Deluxe (VX1050-A)": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "VX LTD (VX1050-F)": ["2016", "2017", "2018", "2019", "2020"],
    "VX-C (VX1050-G)": ["2019", "2020"],
    "Sidewinder M-TX LE": ["2018", "2019"],
    "Sidewinder S-TX GT": ["2020", "2021"],
    "SX Venom Mountain": ["2021", "2022", "2023", "2024"],
    "Transporter Lite": ["2021", "2022", "2023", "2024", "2025"],
    Apex: ["2010", "2011", "2012", "2013", "2014", "2016", "2017"],
    "Apex SE": ["2011", "2012", "2013", "2014", "2015"],
    "Apex XTX": ["2011", "2012", "2013", "2014", "2016", "2017"],
    "RS Vector ER": ["2008", "2009"],
    'SnoScoot ES 93"': ["2019", "2020", "2021", "2022", "2023", "2024"],
    "VK 540 III": ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "Yt125 Tri-Moto": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "YFM125R Raptor": ["2011", "2012", "2013"],
    "YFM80 Badger": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "FX Cruiser HO (FY/FB1800-A)": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "FX HO (FB/FY1800)": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "FZ-R 1800 (GX1800)": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FZ-S 1800 (GX1800-A)": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "GP 1800 (GP1800)": ["2017", "2018", "2019", "2020"],
    "VX-R (VX1800-A)": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "VX-S (VX1800)": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "YXE700 Wolverine": ["2016", "2017", "2018"],
    "YXE850 Wolverine X2": ["2019", "2020"],
    "YXF850 Wolverine X4 SE": ["2018", "2019", "2020"],
    "YXM700 Viking": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "YXF850 Wolverine X4": ["2018", "2019", "2020", "2021"],
    "WaveRunner III (WRA650)": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "WaveRunner III (WRA700)": ["1994", "1995"],
    "VX (VX1100-C)": ["2007", "2008", "2009"],
    "XL 800 (XA800)": ["2000", "2001"],
    "XLT 1200 (XA1200-A)": ["2001", "2002", "2003", "2004", "2005"],
    "XLT 800 (XA800-A)": ["2002", "2003", "2004"],
    "GP 1200 R (GP1200)": ["2000", "2001", "2002"],
    "GP 1300 R (GP1300)": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "GP 800 (GP800)": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "WaveRaider (RA1100)": ["1995", "1996"],
    "WaveRaider (RA700)": ["1994", "1995", "1996", "1997"],
    "WaveBlaster (WB700)": ["1993", "1994", "1995", "1996"],
    "SuperJet (SJ650)": ["1990", "1991", "1992", "1993"],
    YZ85LW: ["2022", "2023", "2024"],
    "YXM700 Viking VI": ["2015", "2016", "2017"],
    "GP 1800 HO (GP1800)": ["2021", "2022"],
    "VX Cruiser HO (VC1800)": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "GP 760 (GP760)": ["1999", "2000"],
    "YFM125G Grizzly [SRA]": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "YFM125GH Grizzly Hunter": ["2005", "2006", "2007", "2008"],
    "YFM300G Grizzly [SRA]": ["2012", "2013"],
    "YFM90G Grizzly": ["2019", "2020", "2021", "2022", "2023"],
    'SRX 120 68"': ["2013", "2014", "2015", "2016"],
    'SRX 120R 67"': ["2019", "2020", "2021", "2022"],
    "XJ50 Vino": ["2001", "2002", "2003", "2004"],
    "YFM90R Raptor": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "XV19B Star Eluder": ["2018", "2019", "2020"],
    "YFA1 Breeze 125": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "YTM200E Tri-Moto": ["1983", "1984", "1985"],
    "WaveBlaster II (WB760)": ["1996", "1997"],
    "WaveRunner (GP760)": ["1997", "1998"],
    "XL 760 (XL760)": ["1998", "1999"],
    "FX1 (FX700)": ["1994", "1995"],
    "SuperJet (SJ700)": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VXR (WRB650)": ["1991", "1992", "1993", "1994", "1995"],
    "VK 540": ["1990", "1991", "2017", "2018", "2019", "2020", "2021"],
    "Phazer II": ["1990", "1991", "1992", "1993", "1994", "1995", "1996"],
    "Phazer II ST": ["1991", "1992", "1993", "1994", "1995"],
    "VK 540 II": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "VMax-4": ["1992", "1993", "1994"],
    "VMax-4 800": ["1995", "1996", "1997"],
    "Apex XTX 1.75 LE": ["2016", "2017", "2018"],
    "RS Venture TF BAT": ["2017", "2018"],
    "Enticer II LT": ["1992", "1993", "1994", "1995"],
    "Exciter II": ["1991", "1992", "1993"],
    "EX Limited (EX1050)": ["2022", "2023"],
    YFZ50: ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "Phazer II LE": ["1990", "1991", "1992", "1993", "1994", "1995", "1996"],
    XMAX: ["2019", "2020"],
    "Exciter II LE": ["1991", "1992"],
    "190 FSH Deluxe [Boat]": ["2016", "2017", "2018", "2019", "2020"],
    "190 FSH Sport [Boat]": ["2016", "2017", "2018", "2019", "2020"],
    "190 FSH [Boat]": ["2016", "2017", "2018", "2019"],
    "212 Limited S [Boat]": ["2017", "2018", "2019"],
    "212 Limited [Boat]": ["2017", "2018", "2019"],
    "212 SS [Boat]": [
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "212 X [Boat]": [
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "242 Limited E-Series [Boat]": ["2016", "2017"],
    "242 Limited S [Boat]": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "242 X E-Series [Boat]": ["2016", "2017", "2018", "2019"],
    "AR 190 [Boat]": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "AR 192 [Boat]": ["2013", "2014", "2015", "2016"],
    "AR 195 [Boat]": ["2017", "2018", "2019"],
    "AR 240 HO [Boat]": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "SX 190 [Boat]": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "SX 192 [Boat]": ["2013", "2014", "2015", "2016"],
    "SX 195 [Boat]": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2017",
      "2018",
      "2019",
    ],
    "SX 240 HO [Boat]": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "VMax-4 ST": ["1994", "1995"],
    "YXM700 Viking VI EPS Ranch Edition": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Yt175 Tri-Moto": ["1982", "1983"],
    "YTZ250 Tri-Z": ["1985", "1986"],
    "Transporter Lite 2-Up": ["2022", "2023", "2024"],
    "210 FSH Deluxe [Boat]": ["2018", "2019", "2020", "2021"],
    "210 FSH Sport [Boat]": ["2018", "2019", "2020", "2021"],
    "GP 1200 (GP1200)": ["1997", "1998", "1999"],
    "LS 2000 [Boat]": ["1999", "2000", "2001", "2002", "2003"],
    "LX 210 [Boat]": ["2003", "2004", "2005"],
    "VXR Pro (WRB700)": ["1993", "1994"],
    "WaveVenture (WVT700)": ["1995", "1996", "1997", "1998"],
    "WaveJammer (WJ500)": ["1987", "1988", "1989", "1990"],
    "WaveRunner (WR500)": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "WaveRunner LX (WR650)": ["1990", "1991", "1992", "1993"],
    "WaveVenture (WVT1100)": ["1996", "1997"],
    "XL 700 (XL700)": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "XR 1800 [Boat]": ["2000", "2001"],
    "YXP1000A Pro Hauler 1000": ["2004", "2005"],
    "YXP700A Pro Hauler 700": ["2004", "2005", "2006"],
    "YTM200E YamaHauler": ["1983", "1984", "1985"],
    "Apex LE": ["2016", "2017", "2018"],
    "Apex XTX 1.75": ["2016", "2017"],
    "210 FSH [Boat]": ["2018", "2019"],
    "232 Limited [Boat]": ["2008", "2009"],
    "242 Limited S E-Series [Boat]": ["2016", "2017", "2018", "2019"],
    "242 Limited [Boat]": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "YZ125 Monster Energy RE": ["2022", "2023"],
    "Venture GT": ["1992", "1993"],
    "FJ1200 Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "FZR1000 Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "GTS1000A Base": ["1993", "1994"],
    "PZ50 Phazer Base": ["2007", "2008", "2009"],
    "PZ50 Venture MP Base": ["2015", "2016", "2017", "2018"],
    "PZ50GT Phazer GT Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "PZ50MT Phazer Mountain Lite Base": ["2007", "2008"],
    "PZ50MT Phazer MTX Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "PZ50RTX Phazer RTX Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "PZ50VT Venture Lite Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "PZ50XT Phazer XTX Base": ["2014", "2015", "2016", "2017", "2018"],
    "RPZ50 Venture MP Base": ["2013", "2014"],
    "RX10GT Apex GT Base": ["2006", "2007", "2008", "2009", "2010"],
    "RX10L Apex LE Base": ["2016", "2017"],
    "RX10LT Apex LTX Base": ["2008", "2009", "2010"],
    "RX10LTGT Apex LTX GT Base": ["2008", "2009", "2010"],
    "RX10M Apex Mountain Base": ["2006", "2007"],
    "RX10MT Apex MTX Base": ["2008", "2009", "2010"],
    "RX10P Apex Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "RX10PS Apex SE Base": ["2011", "2012", "2013", "2014", "2015"],
    "RX10R Apex Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "RX10R Apex ER Base": ["2006", "2007"],
    "RX10RT Apex RTX Base": ["2006", "2007"],
    "RX10RTR Apex RTX ER Base": ["2007", "2008"],
    "RX10XT Apex XTX Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "RX10XT75 Apex XTX 1.75 Base": ["2016", "2017"],
    "RX10XTL Apex XTX 1.75 LE Base": ["2016", "2017"],
    "RXW10 Attack Base": ["2006", "2007"],
    "YFM660R Raptor Base": ["2001", "2002", "2003", "2004", "2005"],
    'SnoSport 90"': ["1990", "1991"],
    "BR250 Bravo Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1992",
      "1993",
    ],
    "BR250T Bravo Base": ["2007", "2008", "2009"],
    "BR250T Bravo LT Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "BR250T Bravo T Base": ["1987", "1988", "1989", "2008", "2009", "2010"],
    "Bw200 Base": ["1985", "1986", "1987", "1988"],
    "Bw350 Base": ["1987", "1988"],
    "Bw80 Base": ["1986", "1987", "1988", "1989", "1990"],
    "CF300 Inviter Base": ["1986", "1987", "1988", "1989", "1990"],
    "CS340 Ovation Base": ["1989", "1990"],
    "CS340E Ovation LE Base": [
      "1989",
      "1990",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "DR2A The Drive2 Adventurer Sport 2+2 EFI Base": ["2019", "2020"],
    "DR2A The Drive2 Concierge 4 EFI Base": ["2019", "2020"],
    "DR2A The Drive2 Concierge 6 EFI Base": ["2019", "2020"],
    "DR2A The Drive2 Fleet Carb Base": ["2017", "2018"],
    "DR2A The Drive2 Fleet EFI Base": ["2017", "2018", "2019", "2020"],
    "DR2A The Drive2 PTV EFI Base": ["2017", "2018", "2019", "2020"],
    "DR2A The Drive2 Super Hauler EFI Base": ["2019", "2020"],
    "Dt100 Base": ["1980", "1981", "1982", "1983"],
    "Dt125 Base": ["1980", "1981"],
    "Dt175 Base": ["1980", "1981"],
    "Dt50 Base": ["1988", "1989", "1990"],
    "Dt80 Base": ["1981", "1982", "1983"],
    "EC340 Excel III Base": ["1984", "1985", "1986", "1987", "1988"],
    "ELT1050 210 FSH Base": ["2018", "2019"],
    "ELT1050 210 FSH Deluxe Base": ["2018", "2019", "2020"],
    "ELT1050 210 FSH Sport Base": ["2018", "2019", "2020"],
    "ET250 Base": ["1980", "1981"],
    "ET300 Base": ["1980", "1981"],
    "ET300 Enticer 300 Base": ["1983", "1984"],
    "ET340 Enticer 340 Base": ["1984", "1985", "1986", "1987", "1988"],
    "ET340T Enticer 340T Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "ET400TR Enticer LTR Base": ["1989", "1990"],
    "ET410TR Enticer II LT Base": ["1992", "1993", "1994", "1995"],
    "EX1050 EX Base": ["2017", "2018", "2019", "2020"],
    "EX1050 EX Deluxe Base": ["2017", "2018", "2019", "2020"],
    "EX1050 EX Sport Base": ["2017", "2018", "2019", "2020"],
    "EX440 Base": ["1980", "1981"],
    "EX570 Exciter Base": ["1987", "1988", "1989", "1990"],
    "EX570 Exciter II Base": ["1991", "1992", "1993"],
    "EX570E Exciter Deluxe Base": ["1988", "1989"],
    "EX570E Exciter II LE Base": ["1991", "1992", "1993"],
    "EXT1100 Exciter Base": ["1996", "1997"],
    "FA1800 WaveRunner FX SHO Base": ["2013", "2014", "2015"],
    "FA1800A WaveRunner FX Cruiser SHO Base": ["2013", "2014", "2015", "2016"],
    "FAT1100 212SS Base": ["2008", "2009", "2010"],
    "FAT1100 212X Base": ["2008", "2009", "2010"],
    "FB1800 WaveRunner FX HO Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "FB1800A WaveRunner FX Cruiser HO Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "FC1800 WaveRunner FX SVHO Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "FC1800A WaveRunner FX Cruiser SVHO Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "FC1800B WaveRunner FX Limited SVHO Base": ["2017", "2018", "2019", "2020"],
    "FJ-09 Base": ["2015", "2016", "2017"],
    "FJ1100 Base": ["1984", "1985"],
    "FJ600 Base": ["1984", "1985"],
    "FJR1300 Base": ["2003", "2004", "2005"],
    "FJR1300A Base": ["2015", "2016", "2018", "2019"],
    "FJR1300A ABS Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "FJR1300AE Base": ["2005", "2006", "2007", "2008", "2009"],
    "FJR1300ES Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "FPT1800 275E Base": ["2019", "2020"],
    "FPT1800 275SD Base": ["2019", "2020"],
    "FPT1800 275SE Base": ["2019", "2020"],
    "FRT1100 AR210 Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "FRT1100 SR210 Base": ["2006", "2007"],
    "FRT1100A SX210 Base": ["2006", "2007"],
    "FRT1100B SX210 Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "FX10 FX Nytro Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "FX1000 FX140 Base": ["2003", "2004"],
    "FX1000 WaveRunner FX Base": ["2005", "2006", "2007", "2008"],
    "FX1000A FX140 Cruiser Base": ["2002", "2003", "2004"],
    "FX1000A WaveRunner FX Cruiser Base": ["2005", "2006", "2007", "2008"],
    "FX10M FX Nytro MTX 153 Base": ["2012", "2013", "2014"],
    "FX10M FX Nytro MTX 162 Base": ["2013", "2014"],
    "FX10M FX Nytro MTX SE 153 Base": ["2010", "2011", "2012"],
    "FX10M FX Nytro MTX SE 162 Base": ["2010", "2011", "2012"],
    "FX10MT FX Nytro MTX Base": ["2008", "2009", "2010"],
    "FX10RTR FX Nytro RTX Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "FX10RTRS FX Nytro RTX SE Base": ["2009", "2010"],
    "FX10XT FX Nytro XTX Base": ["2009", "2010", "2011", "2012", "2013"],
    "FX10XT FX Nytro XTX 1.75 Base": ["2013", "2014"],
    "FX1100 WaveRunner FX HO Base": ["2004", "2005", "2006"],
    "FX1100A WaveRunner FX Cruiser HO Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "FX1800 WaveRunner FX Cruiser SHO Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "FX1800 WaveRunner FX SHO Base": ["2008", "2009", "2010", "2011", "2012"],
    "FX700 FX-1 Base": ["1994", "1995"],
    "FY1800 WaveRunner FX HO Base": ["2009", "2010", "2011"],
    "FY1800A WaveRunner FX Cruiser HO Base": ["2009", "2010", "2011"],
    "FZ-07 Base": ["2015", "2016", "2017"],
    "FZ-09 Base": ["2014", "2015", "2016", "2017"],
    "FZ600 Base": ["1986", "1987", "1988"],
    "FZ6R Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "FZ750 Base": ["1985", "1986", "1987", "1988"],
    "FZ8 Base": ["2011", "2012", "2013"],
    "FZR400 Base": ["1988", "1989", "1990"],
    "FZR600R Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "FZR750R Base": ["1987", "1988"],
    "FZS1000 FZ1 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "FZX700 Fazer Base": ["1986", "1987"],
    "G1-A Base": ["1980", "1981", "1982", "1983", "1984", "1985", "1986"],
    "G11-A Yamahauler Base": [
      "1993",
      "1994",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "G14-A Ultima Base": ["1995", "1996"],
    "G16-A Ultima Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "G2-A Base": ["1985", "1986", "1987", "1988", "1989", "1990", "1991"],
    "G20-A Concierge Base": ["2000", "2001", "2002"],
    "G21-A Base": ["2000", "2001", "2002", "2003", "2004"],
    "G22-A G-MAX Base": ["2003", "2004", "2005", "2006", "2007"],
    "G23-A U-MAX Medium Duty I Base": ["2006", "2007", "2008", "2009"],
    "G27-A U-MAX Light Duty Base": ["2004", "2005", "2006", "2007", "2008"],
    "G28-A U-MAX Medium Duty II Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "G5-A Sun Classic Base": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "G8-A Fleet Classic Base": ["1990", "1991", "1992", "1993", "1994"],
    "G9-A Fleet Master Base": ["1991", "1992", "1993", "1994", "1995"],
    "GP1200 WaveRunner GP1200 Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "GP1300 WaveRunner GP1300R Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "GP1800 Base": ["2017", "2018"],
    "GP760 WaveRunner GP760 Base": ["1997", "1998", "1999", "2000"],
    "GP800 WaveRunner GP800 Base": ["1998", "1999", "2000"],
    "GP800A WaveRunner GP800R Base": ["2001", "2002", "2003", "2004", "2005"],
    "GX1800 WaveRunner FZR Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "GX1800A WaveRunner FZS Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "It125 Base": ["1980", "1981"],
    "It175 Base": ["1980", "1981", "1982", "1983"],
    "It200 Base": ["1984", "1985", "1986"],
    "It250 Base": ["1980", "1981", "1982", "1983"],
    "It465 Base": ["1981", "1982"],
    "It490 Base": ["1983", "1984"],
    "LAT1100 AR210 Base": ["2012", "2013", "2014", "2015"],
    "LAT1100 SX210 Base": ["2012", "2013", "2014", "2015"],
    "LB50 Base": ["1981", "1982"],
    "LBT1050 AR210 Base": ["2017", "2018", "2019", "2020"],
    "LBT1050 SX210 Base": ["2017", "2018", "2019", "2020"],
    "LST1200 LS2000 Base": ["1999", "2000", "2001", "2002", "2003"],
    "LST1200A LX210 Base": ["2003", "2004", "2005"],
    "LST1200D AR210 Base": ["2003", "2004", "2005"],
    "MM600 Mountain Max 600 Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "MM700 Mountain Max 700 Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "MT-07 Base": ["2018", "2019", "2020"],
    "MT-09 Base": ["2018", "2019", "2020"],
    "MT-10 Base": ["2018", "2019", "2020"],
    "Mx100 Base": ["1980", "1981", "1982", "1983"],
    "Mx175 Base": ["1980", "1981"],
    "Mx80 Base": ["1980", "1981", "1982"],
    "PW50 Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "PW80 Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "PZ480 Phazer Base": ["1984", "1985", "1986", "1987", "1988", "1989"],
    "PZ480 Phazer II Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "PZ480 Phazer SS Base": ["1997", "1998"],
    "PZ480E Phazer Deluxe Base": ["1987", "1988", "1989"],
    "PZ480E Phazer II LE Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "PZ480E Phazer SS Electric Base": ["1997", "1998"],
    "PZ480ST Phazer II ST Base": ["1991", "1992", "1993", "1994", "1995"],
    "PZ480ST Phazer Mountain Lite Base": ["1996", "1997", "1998", "1999"],
    "PZ500 Phazer 500 Base": ["1999", "2000", "2001"],
    "PZ500ML Phazer Mountain Lite Base": ["2000", "2001"],
    "R15 Base": ["2009", "2010"],
    "RA1100 WaveRaider 1100 Base": ["1995", "1996"],
    "RA700 WaveRaider Base": ["1994", "1995", "1996", "1997"],
    "RM1800 AR192 Base": ["2013", "2014", "2015", "2016"],
    "RM1800 SX192 Base": ["2013", "2014", "2015", "2016"],
    "RP1800 AR195 Base": ["2017", "2018"],
    "RP1800 SX195 Base": ["2017", "2018"],
    "RS10 RS Venture TF Base": ["2013", "2014"],
    "RS90 RS Vector Base": [
      "2005",
      "2006",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "RS90GT Vector GT Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "RS90LT RS Vector LTX Base": [
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "RS90LTGT RS Vector LTX GT Base": ["2008", "2009", "2010", "2011"],
    "RS90M RS Vector Mountain Base": ["2005", "2006", "2007"],
    "RS90MS RS Vector Mountain SE Base": ["2006", "2007"],
    "RS90N Nytro Base": ["2006", "2007"],
    "RS90NR Nytro ER Base": ["2006", "2007"],
    "RS90R RS Vector Base": ["2008", "2009", "2012", "2013", "2014"],
    "RS90R RS Vector ER Base": ["2005", "2006", "2007"],
    "RS90XT RS Vector XTX Base": ["2016", "2017"],
    "RS90XT75 RS Vector XTX 1.75 Base": ["2016", "2017"],
    "RS90XTL RS Vector XTX 1.75 LE Base": ["2016", "2017"],
    "RSG90 RS Rage Base": ["2005", "2006", "2007"],
    "RST90 RS Venture Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "RST90GT RS Venture GT Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "RST90TF RS Venture TF Base": ["2015", "2016", "2017"],
    "RST90TFL RS Venture TF LE Base": ["2016", "2017"],
    "RST90TFY RS Venture TF BAT Base": ["2016", "2017"],
    "Rt100 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Rt180 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "RX10 RX-1 Base": ["2003", "2004", "2005"],
    "RX10M RX-1 Mountain Base": ["2003", "2004", "2005"],
    "RX10MS RX-1 Mountain LE Base": ["2003", "2004", "2005"],
    "RX10R RX-1 ER Base": ["2003", "2004", "2005"],
    "RX10RS RX-1 ER LE Base": ["2003", "2004", "2005"],
    "RX10S RX-1 LE Base": ["2003", "2004"],
    "RX1800 AR190 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "RX1800 SX190 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "RXW10 RX Warrior Base": ["2004", "2005"],
    "RXW10S RX Warrior LE Base": ["2004", "2005"],
    "RZ350 Base": ["1984", "1985"],
    "SAT1800 242 Limited Base": ["2015", "2016"],
    "SAT1800 242 Limited E Series Base": ["2016", "2017"],
    "SAT1800 242 Limited S Base": ["2015", "2016", "2017", "2018", "2019"],
    "SAT1800 242 Limited S E Series Base": ["2016", "2017", "2018", "2019"],
    "SAT1800 242X E Series Base": ["2016", "2017", "2018", "2019"],
    "SAT1800 AR240 HO Base": ["2015", "2016", "2017", "2018", "2019"],
    "SAT1800 SX240 HO Base": ["2015", "2016", "2017", "2018", "2019"],
    "SH1800 190 FSH Base": ["2016", "2017", "2018"],
    "SH1800 190 FSH Deluxe Base": ["2016", "2017", "2018"],
    "SH1800 190 FSH Sport Base": ["2016", "2017", "2018"],
    "SJ650 Super Jet Base": ["1990", "1991", "1992", "1993"],
    "SJ700 Super Jet Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "SR10L SR Viper LTX Base": ["2018", "2019"],
    "SR10LD SR Viper LTX DX Base": ["2015", "2016", "2017", "2018"],
    "SR10LL SR Viper LTX LE Base": ["2015", "2016", "2017"],
    "SR10LS SR Viper LTX SE Base": ["2015", "2016", "2017"],
    "SR10M53 SR Viper MTX 153 Base": ["2015", "2016"],
    "SR10M53S SR Viper MTX 153 SE Base": ["2015", "2016", "2017"],
    "SR10M62L SR Viper MTX 162 LE Base": ["2015", "2016"],
    "SR10M62S SR Viper MTX 162 SE Base": ["2015", "2016", "2017"],
    "SR10RD SR Viper RTX DX Base": ["2015", "2016", "2017"],
    "SR10RL SR Viper RTX LE Base": ["2015", "2016"],
    "SR10RS SR Viper RTX SE Base": ["2015", "2016", "2017"],
    "SR10S37D SR Viper STX 137 DX Base": ["2016", "2017"],
    "SR10S46D SR Viper STX 146 DX Base": ["2016", "2017"],
    "SR10XL SR Viper XTX LE Base": ["2015", "2016"],
    "SR10XS SR Viper XTX SE Base": ["2015", "2016", "2017", "2018"],
    "SR185 Base": ["1981", "1982"],
    "SR250 Base": ["1980", "1981", "1982"],
    "SR400 Base": ["2015", "2016", "2017", "2018"],
    "SR500 Base": ["1980", "1981"],
    "SR540 Base": ["1980", "1981", "1982", "1983"],
    "SR540 SRV Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "SRT1000 SR230 Base": ["2003", "2004", "2005"],
    "SRT1000A SX230 Base": ["2004", "2005", "2006"],
    "SRT1000B AR230 Base": ["2004", "2005", "2006"],
    "SRT1100 AR230 HO Base": ["2005", "2006"],
    "SRT1100 SX230 HO Base": ["2005", "2006"],
    "SRX120 SRX120 Base": ["2015", "2016", "2017", "2018"],
    "SRX120 SX120 Base": ["2013", "2014"],
    "SRX440 Base": ["1980", "1981"],
    "SRX600 Base": ["1998", "1999"],
    "SRX700 Base": ["1998", "1999", "2000", "2001", "2002"],
    "SRX700S Base": ["1998", "1999", "2000", "2001", "2002"],
    "SS440 Base": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "SV1200 WaveRunner SUV1200 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "SV125 Snosport Base": ["1990", "1991"],
    "SV125E Snosport (Electric Start) Base": ["1990", "1991"],
    "SV80 Snoscoot Base": ["1988", "1989", "1990"],
    "SV80E Snoscoot (Electric Start) Base": ["1988", "1989", "1990"],
    "SW10LD Sidewinder LTX DX Base": ["2017", "2018", "2019"],
    "SW10LL Sidewinder LTX LE Base": ["2017", "2018", "2019"],
    "SW10LS Sidewinder LTX SE Base": ["2017", "2018", "2019"],
    "SW10MS62 Sidewinder MTX 162 SE Base": ["2017", "2018"],
    "SW10RS Sidewinder RTX SE Base": ["2017", "2018"],
    "SW10SD37 Sidewinder STX 137 DX Base": ["2017", "2018"],
    "SW10XS41 Sidewinder XTX 141 SE Base": ["2018", "2019"],
    "SX500/R Base": ["2000", "2001"],
    "SX600/R Base": ["2000", "2001", "2002", "2003"],
    "SX700/R Base": ["2000", "2001"],
    "SXT1100 232 Limited Base": ["2008", "2009"],
    "SXT1100 AR230 HO Base": ["2007", "2008", "2009"],
    "SXT1100 SX230 HO Base": ["2007", "2008", "2009"],
    "SXT1800 242 Limited Base": ["2010", "2011", "2012", "2013", "2014"],
    "SXT1800 242 Limited S Base": ["2010", "2011", "2012", "2013", "2014"],
    "SXT1800 AR240 HO Base": ["2010", "2011", "2012", "2013", "2014"],
    "SXT1800 SX240 HO Base": ["2010", "2011", "2012", "2013", "2014"],
    "SXV60 SX Venom Base": ["2004", "2005", "2006"],
    "SXV60ER SX Venom ER Base": ["2004", "2005", "2006"],
    "SXV700 SX Viper Base": ["2002", "2003"],
    "SXV700ER SX Viper ER Base": ["2002", "2003", "2004"],
    "SXV70MH SX Viper Mountain Base": ["2003", "2004", "2005", "2006"],
    "TDM850 Base": ["1992", "1993"],
    "TP1800 AR195 Base": ["2019", "2020"],
    "TP1800 SX195 Base": ["2019", "2020"],
    "TT225 Base": ["1986", "1987"],
    "TT250 Base": ["1980", "1981", "1982"],
    "TT350 Base": ["1986", "1987"],
    "TT500 Base": ["1980", "1981"],
    "TT600 Base": ["1983", "1984", "1985", "1986"],
    "TTR110E Base": [
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "TTR125 Base": ["2000", "2001", "2002", "2003", "2004"],
    "TTR125E Base": ["2003", "2004", "2005", "2006", "2007", "2008", "2009"],
    "TTR125L Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "TTR125LE Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "TTR225 Base": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "TTR230 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "TTR250 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "TTR50E Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "TTR90 Base": ["2000", "2001", "2002", "2003"],
    "TTR90E Base": ["2003", "2004", "2005", "2006", "2007"],
    "TW200 Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "TX1800 AR190 Base": ["2019", "2020"],
    "TX1800 SX190 Base": ["2019", "2020"],
    "Ty350 Base": ["1985", "1986"],
    "Tz250 Base": ["1980", "1981", "1982", "1999", "2000", "2001"],
    "UX1800 190FSH Deluxe Base": ["2019", "2020"],
    "UX1800 190FSH Sport Base": ["2019", "2020"],
    "VK10 Viking Professional Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "VK10F VK Professional II Base": ["2016", "2017"],
    "VK540 Base": ["1988", "1989", "1990", "1991"],
    "VK540 II Base": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "VK540 III Base": ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "VK540 VK 540 Base": ["2017", "2018", "2019"],
    "VMX1200 V-Max Base": [
      "1985",
      "1986",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "VMX1700 V-Max Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VMX540 VMax Base": ["1983", "1984", "1985", "1986", "1987"],
    "VT480 Venture XL Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "VT480GT Venture GT Base": ["1992", "1993"],
    "VT480TR Venture TR Base": ["1996", "1997", "1998"],
    "VT500 Venture 500 Base": ["1997", "1998", "1999", "2000", "2001"],
    "VT500XL Venture 500 XL Base": ["1999", "2000", "2001"],
    "VT600 Venture 600 Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "VT700 Venture 700 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "VX1050A WaveRunner VX Cruiser Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VX1050B WaveRunner VX Deluxe Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VX1050C WaveRunner VX Base": ["2016", "2017", "2018", "2019", "2020"],
    "VX1050F WaveRunner VX Limited Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VX1100 WaveRunner 1100 Sport Base": ["2005", "2006"],
    "VX1100 WaveRunner VX Base": ["2007", "2008", "2009", "2010"],
    "VX1100A WaveRunner 1100 Deluxe Base": ["2005", "2006"],
    "VX1100A WaveRunner VX Cruiser Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "VX1100B WaveRunner VX Deluxe Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "VX1100C WaveRunner VX Sport Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "VX1800 WaveRunner VX Cruiser HO Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "VX1800AK WaveRunner VXR Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "VX1800K WaveRunner VXS Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "VX500 VMAX 500 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "VX500DX VMAX 500 Deluxe Base": ["2000", "2001"],
    "VX500DX VMAX 500 DX Base": ["1994", "1995", "1996"],
    "VX500E VAMX 500 LE Base": ["1994", "1995", "1996"],
    "VX500XT VMAX 500 XT Base": ["1997", "1998"],
    "VX500XTC VMAX 500 XTC Base": ["1997", "1998"],
    "VX600 VMAX 600 Base": ["1994", "1995", "1996", "1997"],
    "VX600DX VMAX 600 Deluxe Base": ["2000", "2001"],
    "VX600DX VMAX 600 DX Base": ["1994", "1995", "1996"],
    "VX600E VMAX 600 LE Base": ["1994", "1995", "1996"],
    "VX600ER VMAX 600 ER Base": ["2002", "2003"],
    "VX600ST VMAX 600 ST Base": ["1994", "1995"],
    "VX600SX VMAX 600 SX Base": ["1997", "1998", "1999"],
    "VX600XT VMAX 600 XT Base": ["1997", "1998"],
    "VX600XTC VMAX 600 XTC Base": ["1997", "1998"],
    "VX700 VMAX 700 Base": ["1999", "2000", "2001"],
    "VX700DX VMAX 700 Deluxe Base": ["1999", "2000", "2001"],
    "VX700SX VMAX 700 SX Base": ["1997", "1998", "1999"],
    "VX750 VMAX-4 Base": ["1992", "1993", "1994"],
    "VX800 VMAX-4 800 Base": ["1995", "1996", "1997"],
    "WB700 WaveBlaster Base": ["1993", "1994", "1995", "1996"],
    "WB760 WaveBlaster 760 Base": ["1996", "1997"],
    "WJ500 WaveJammer Base": ["1987", "1988", "1989", "1990"],
    "WR250 Base": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "WR250F Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "WR250R Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "WR250X Base": ["2008", "2009", "2010", "2011"],
    "WR400F Base": ["1998", "1999", "2000"],
    "WR426F Base": ["2001", "2002"],
    "WR450F Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "WR500 Base": ["1992", "1993"],
    "WR500 WaveRunner Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "WR650 WaveRunner LX Base": ["1990", "1991", "1992", "1993"],
    "WRA650 WaveRunner III Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1995",
      "1996",
    ],
    "WRB650 WaveRunner VXR Base": ["1991", "1992", "1993", "1994", "1995"],
    "WRB700 WaveRunner Pro VXR Base": ["1993", "1994"],
    "WVT1100 WaveVenture 1100 Base": ["1996", "1997"],
    "WVT700 WaveVenture 700 Base": ["1995", "1996"],
    "XA1200 WaveRunner XL12 LTD Base": ["1999", "2000"],
    "XA1200A WaveRunner XLT1200 Base": ["2001", "2002", "2003", "2004", "2005"],
    "XA800 WaveRunner XL800 Base": ["2000", "2001"],
    "XA800A WaveRunner XLT800 Base": ["2002", "2003", "2004"],
    "XAT1800 212SS Base": ["2012", "2013", "2014", "2015", "2016"],
    "XAT1800 212X Base": ["2012", "2013", "2014", "2015", "2016"],
    "XBT1800 212 Limited Base": ["2017", "2018", "2019"],
    "XBT1800 212 Limited S Base": ["2017", "2018", "2019"],
    "XBT1800 212X Base": ["2017", "2018", "2019"],
    "XJ550 Maxim Base": ["1981", "1982", "1983"],
    "XJ550R Seca Base": ["1981", "1982", "1983"],
    "XJ600S Seca II Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "XJ650 Maxim Base": ["1980", "1981", "1982", "1983"],
    "XJ650L Turbo Seca Base": ["1981", "1982", "1983"],
    "XJ750 Maxim Base": ["1982", "1983"],
    "XJ750R Seca Base": ["1981", "1982", "1983"],
    "XL540 VLX Base": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "XL700 WaveRunner XL700 Base": ["1999", "2000", "2001"],
    "XL700A WaveVenture XL700 Base": ["2002", "2003", "2004"],
    "XL760 WaveRunner XL760 Base": ["1998", "1999"],
    "XRT1200 XR1800 Base": ["2000", "2001"],
    "XS1100 Base": ["1980", "1981"],
    "XS1100L Mid-Special Base": ["1980", "1981"],
    "XS1100S Special Base": ["1980", "1981"],
    "XS400 Base": ["1980", "1981"],
    "XS400 Maxim Base": ["1982", "1983"],
    "XS400R Seca Base": ["1982", "1983"],
    "XS400S Special Base": ["1980", "1981", "1982"],
    "XS650 Base": ["1980", "1981"],
    "XS650S Special Base": ["1980", "1981", "1982", "1983"],
    "XS850 Base": ["1980", "1981"],
    "XS850L Mid-Special Base": ["1980", "1981"],
    "XS850S Special Base": ["1980", "1981"],
    "XSR700 Base": ["2018", "2019", "2020"],
    "XSR900 Base": ["2016", "2017", "2018", "2019", "2020"],
    "XT125 Base": ["1982", "1983"],
    "XT200 Base": ["1982", "1983"],
    "XT225 Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "XT250 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "XT350 Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "XT500 Base": ["1980", "1981"],
    "XT550 Base": ["1982", "1983"],
    "XT600 Base": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "XV1000 Virago Base": ["1984", "1985"],
    "XV1100 Virago Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "XV1600A Road Star Base": ["1999", "2000", "2001", "2002", "2003"],
    "XV1600AS Road Star Midnight Base": ["2000", "2001", "2002", "2003"],
    "XV1600AT Road Star Silverado Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "XV1700A Road Star Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "XV1700AM Road Star Midnight Base": ["2004", "2005", "2006", "2007"],
    "XV1700AS Road Star S Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XV1700AT Road Star Silverado Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XV1700ATM Road Star Midnight Silverado Base": [
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "XV1700ATS Road Star Silverado S Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XV1700PC Road Star Warrior Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XV1700PCM Road Star Midnight Warrior Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XV19C Raider Base": ["2015", "2016", "2017"],
    "XV19C Raider SCL Base": ["2012", "2013", "2014"],
    "XV19CX Raider Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XV19CXC Raider S Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XV250 Route 66 Base": ["1988", "1989", "1990"],
    "XV250 V Star 250 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "XV250 Virago Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "XV500 Virago Base": ["1983", "1984"],
    "XV535 Virago Base": [
      "1987",
      "1988",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "XV700 Virago Base": ["1984", "1985", "1986", "1987"],
    "XV750 Virago Base": [
      "1981",
      "1982",
      "1983",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "XV920 Virago Base": ["1982", "1983"],
    "XV920R Seca Base": ["1981", "1982"],
    "XVS1100 V Star 1100 Custom Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XVS1100A V Star 1100 Classic Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XVS1100AT V Star 1100 Silverado Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XVS13 Stryker Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "XVS13 Stryker Bullet Cowl Base": ["2015", "2016"],
    "XVS1300 V Star 1300 Base": [
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "XVS1300 V Star 1300 Deluxe Base": ["2013", "2014", "2015", "2016", "2017"],
    "XVS1300A V Star 1300 Tourer Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "XVS650 V Star Custom Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "XVS650A V Star Classic Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XVS650AT V Star Silverado Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XVS950 Bolt Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "XVS950 Bolt C-Spec Base": ["2015", "2016"],
    "XVS950 Bolt R-Spec Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "XVS950 V Star 950 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "XVS950CT V Star 950 Tourer Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "XVZ1200 Venture Base": ["1983", "1984"],
    "XVZ1200D Venture Royale Base": ["1983", "1984", "1985"],
    "XVZ1300 Venture Base": ["1987", "1988"],
    "XVZ1300 Venture Royale Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "XVZ1300A Royal Star Base": ["1996", "1997", "1998"],
    "XVZ1300AL Royal Star Boulevard Base": ["1999", "2000", "2001"],
    "XVZ1300AT Royal Star Tour Classic Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "XVZ1300CT Royal Star Tour Deluxe Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XVZ1300CTM Royal Star Midnight Tour Deluxe Base": ["2006", "2007"],
    "XVZ1300CTS Royal Star Tour Deluxe S Base": ["2008", "2009"],
    "XVZ1300TF Royal Star Venture Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "XVZ1300TFM Royal Star Midnight Venture Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "XVZ1300TFS Royal Star Venture S Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "XZ550R Vision Base": ["1982", "1983"],
    "YDR-A Adventurer Super Hauler Base": ["2016", "2017", "2018"],
    "YDR-A Concierge 4-Passenger Base": ["2014", "2015", "2016"],
    "YDR-A Concierge 6-Passenger Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "YDR-A SVL Concierge 6-Passenger Base": ["2009", "2010", "2011"],
    "YDR-A SVS Concierge 4-Passenger Base": ["2009", "2010", "2011"],
    "YDR-A The DRIVE Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "YDR-A The DRIVE EFI Base": ["2013", "2014", "2015", "2016"],
    "YDR-A The DRIVE PTV Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "YDR-A The DRIVE PTV EFI Base": ["2014", "2015", "2016"],
    "YFA-1 Breeze125 Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "YFB250 Timberwolf 2x4 Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "YFB250FW Timberwolf 4x4 Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "YFM100 Champ Base": ["1987", "1988", "1989", "1990", "1991"],
    "YFM125 Grizzly Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "YFM125 Raptor Base": ["2011", "2012", "2013"],
    "YFM200 Moto-4 Base": ["1985", "1986", "1987", "1988", "1989"],
    "YFM225 Moto-4 Base": ["1986", "1987", "1988"],
    "YFM250 Bear Tracker Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "YFM250 Big Bear Base": ["2007", "2008", "2009"],
    "YFM250 Bruin Base": ["2005", "2006"],
    "YFM250 Moto-4 Base": ["1989", "1990", "1991"],
    "YFM250 Raptor Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "YFM300 Grizzly Automatic Base": ["2012", "2013"],
    "YFM350 Bruin Auto 2x4 Base": ["2004", "2005", "2006"],
    "YFM350 Grizzly 4x4 Auto Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "YFM350 Grizzly Auto Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "YFM350 Grizzly IRS 4x4 Auto Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "YFM350 Raptor Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "YFM350 Wolverine Base": ["2006", "2007", "2008", "2009"],
    "YFM350ER Moto-4 Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "YFM350F Wolverine 4x4 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "YFM350FA Bruin Auto 4x4 Base": ["2004", "2005", "2006"],
    "YFM350FW Big Bear 4x4 Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "YFM350U Big Bear 2x4 Base": ["1996", "1997", "1998", "1999"],
    "YFM350X Warrior Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "YFM400 Big Bear 2x4 Base": ["2000", "2001", "2002", "2003", "2004"],
    "YFM400 Big Bear 4x4 Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "YFM400 Big Bear IRS 4x4 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "YFM400 Grizzly 4x4 Auto Base": ["2007", "2008"],
    "YFM400A Kodiak Base": ["2000", "2001", "2002", "2003", "2004"],
    "YFM400F Kodiak 4x4 Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "YFM450 Grizzly 4x4 Auto Base": [
      "2007",
      "2008",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "YFM450 Grizzly 4x4 Auto EPS Base": ["2011", "2012", "2013", "2014"],
    "YFM450 Grizzly 4x4 Auto IRS Base": ["2009", "2010"],
    "YFM450 Kodiak 450 Base": ["2018", "2019", "2020", "2021"],
    "YFM450 Kodiak 450 EPS Base": ["2018", "2019", "2020", "2021"],
    "YFM450 Kodiak 450 EPS SE Base": ["2019", "2020", "2021"],
    "YFM450F Kodiak Auto 4x4 Base": ["2003", "2004", "2005", "2006"],
    "YFM450FX Wolverine 4x4 Base": ["2006", "2007", "2008", "2009", "2010"],
    "YFM50 Raptor Base": ["2004", "2005", "2006", "2007", "2008"],
    "YFM550 Grizzly FI 4x4 Auto Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "YFM550 Grizzly FI 4x4 Auto EPS Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "YFM600FW Grizzly 4x4 Base": ["1998", "1999", "2000", "2001"],
    "YFM660F Grizzly 4x4 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "YFM700 Grizzly EPS Base": ["2018", "2019", "2020", "2021"],
    "YFM700 Grizzly EPS LE Base": ["2016", "2017", "2018"],
    "YFM700 Grizzly EPS SE Base": ["2018", "2019", "2020", "2021"],
    "YFM700 Grizzly FI 4x4 Auto Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "YFM700 Grizzly FI 4x4 Auto EPS Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "YFM700 Grizzly FI 4x4 Auto EPS SE Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "YFM700 Raptor Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YFM700K Kodiak Base": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "YFM700K Kodiak EPS Base": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "YFM700K Kodiak EPS SE Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "YFM700R Raptor Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YFM700R Raptor SE Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YFM80 Badger Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "YFM80 Grizzly Base": ["2005", "2006", "2007", "2008"],
    "YFM80W Raptor Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "YFM90 Grizzly 90 Base": ["2019", "2020"],
    "YFM90 Raptor Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YFS200 Blaster Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "YFZ350 Banshee Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "YFZ450 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "YFZ450 Bill Balance Edition Base": ["2006", "2007"],
    "YFZ450 SE Base": ["2007", "2008"],
    "YFZ450R Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YFZ450R SE Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "YFZ450X Base": ["2010", "2011"],
    "YFZ50 Base": ["2017", "2018", "2019", "2020"],
    "YSR50 Base": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Yt125 Tri-Moto Base": ["1980", "1981", "1982", "1983", "1984", "1985"],
    "Yt175 Tri-Moto Base": ["1982", "1983"],
    "YT60 Zinger Base": ["1984", "1985"],
    "YTF-1 Adventurer One Base": ["2009", "2010", "2011", "2012", "2013"],
    "YTF-1A Adventurer 2+2 Base": ["2014", "2015", "2016", "2017"],
    "YTF-1A Adventurer One Base": ["2014", "2015", "2016", "2017", "2018"],
    "YTF-1A Adventurer Sport Base": ["2014", "2015", "2016", "2017", "2018"],
    "YTF-2 Adventurer Two Base": ["2009", "2010", "2011", "2012", "2013"],
    "YTF-2A Adventurer Two Base": ["2017", "2018"],
    "YTF-2A Fairway Lounge Base": ["2014", "2015", "2016", "2017", "2018"],
    "YTM200 Tri-Moto Base": ["1983", "1984", "1985"],
    "YTM200E YamaHauler Base": ["1983", "1984", "1985"],
    "YTM225 Tri-Moto Base": ["1983", "1984", "1985", "1986"],
    "YTZ250 Tri-Z Base": ["1985", "1986"],
    "YUM1A UMAX One EFI Base": ["2019", "2020"],
    "YUM1A UMAX One Rally EFI Base": ["2019", "2020"],
    "YUM2A UMAX Bistro EFI Base": ["2019", "2020"],
    "YUM2A UMAX Rally 2+2 EFI Base": ["2019", "2020"],
    "YUM2A UMAX Range Picker EFI Base": ["2019", "2020"],
    "YUM2A UMAX Two EFI Base": ["2019", "2020"],
    "YX600 Radian Base": ["1986", "1987", "1988", "1989", "1990"],
    "YXE70 Wolverine Base": ["2016", "2017", "2018"],
    "YXE70 Wolverine R-Spec Base": ["2016", "2017"],
    "YXE70 Wolverine R-Spec EPS Base": ["2016", "2017", "2018"],
    "YXE70 Wolverine R-Spec EPS SE Base": ["2016", "2017"],
    "YXE85 Wolverine X2 Base": ["2019", "2020"],
    "YXF85 Wolverine X4 Base": ["2018", "2019", "2020"],
    "YXF85 Wolverine X4 SE Base": ["2018", "2019"],
    "YXM700 Viking EPS Ranch Edition Base": ["2018", "2019", "2020"],
    "YXM700 Viking EPS with Suntop Base": ["2018", "2019", "2020"],
    "YXM700 Viking FI 4x4 Base": ["2014", "2015"],
    "YXM700 Viking FI 4x4 EPS Base": ["2014", "2015"],
    "YXM700 Viking FI 4x4 EPS SE Base": ["2014", "2015", "2016", "2017"],
    "YXM700 Viking FI 4x4 EPS with Suntop Base": [
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "YXM700 Viking FI 4x4 with Suntop Base": ["2014", "2015", "2016", "2017"],
    "YXM700 Viking VI Base": ["2015", "2016", "2017"],
    "YXM700 Viking VI EPS Base": ["2015", "2016", "2017", "2018", "2019"],
    "YXM700 Viking VI EPS Ranch Edition Base": ["2016", "2017", "2018", "2019"],
    "YXM700 Viking VI EPS SE Base": ["2015", "2016", "2017"],
    "YXM700 Viking with Suntop Base": ["2018", "2019", "2020"],
    "YXP1000A Pro Hauler 1000 Base": ["2004", "2005"],
    "YXP700A Pro Hauler 700 Base": ["2004", "2005", "2006"],
    "YXR45F Rhino 450 Base": ["2006", "2007", "2008", "2009"],
    "YXR45F Rhino 450 Special Edition Base": ["2007", "2008"],
    "YXR66F Rhino 660 Base": ["2004", "2005", "2006", "2007"],
    "YXR66F Rhino 660 Exploring Edition Base": ["2006", "2007"],
    "YXR66F Rhino 660 Special Edition Base": ["2006", "2007"],
    "YXR700F Rhino 700 FI Base": ["2008", "2009", "2011", "2012", "2013"],
    "YXR700F Rhino 700 FI Ducks Unlimited Base": ["2008", "2009"],
    "YXR700F Rhino 700 FI Special Edition Base": ["2008", "2009"],
    "YXR700F Rhino 700 FI Sport Edition Base": [
      "2008",
      "2009",
      "2011",
      "2012",
      "2013",
    ],
    "YXZ1000R Base": ["2016", "2017", "2018", "2019", "2020"],
    "YZ100 Base": ["1980", "1981", "1982", "1983"],
    "YZ125 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YZ250 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YZ250F Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YZ250FX Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "YZ250WR Base": ["1989", "1990"],
    "YZ250X Base": ["2016", "2017", "2018", "2019", "2020"],
    "YZ400F Base": ["1998", "1999"],
    "YZ426F Base": ["2000", "2001", "2002"],
    "YZ450F Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YZ450FX Base": ["2016", "2017", "2018", "2019", "2020"],
    "YZ465 Base": ["1980", "1981"],
    "YZ490 Base": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "YZ60 Base": ["1981", "1982", "1983"],
    "YZ80 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "YZ85 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "YZF-R1M Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "YZF-R1S Base": ["2016", "2017", "2018"],
    "YZF-R3 ABS Base": ["2017", "2018", "2019"],
    "YZF600R Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "YZF750R Base": ["1994", "1995", "1996", "1997", "1998"],
    "YT60 Zinger": ["1984", "1985"],
    "Sidewinder L-TX LE EPS": ["2023", "2024"],
    "Sidewinder S-RX LE EPS": ["2023", "2024"],
    "YFM700F Grizzly Fi 4WD EPS Hunter [IRS]": ["2019", "2020", "2021"],
    "YFM700KP Kodiak EPS Hunter [IRS]": ["2019", "2020", "2021"],
    "YXM700 Viking VI EPS Hunter Edition": ["2018", "2019", "2020", "2021"],
    "YXE10 Wolverine RMAX2 Limited Edition Base": ["2021", "2022"],
    "YXE10 Wolverine RMAX2 XT-R Base": ["2021", "2022"],
    "YXF10 Wolverine RMAX4 Limited Edition Base": ["2021", "2022"],
    "YXF10 Wolverine RMAX4 XT-R Base": ["2021", "2022"],
    "XC155 SMAX Base": ["2015", "2016", "2017", "2018"],
    "YJ125 Vino 125 Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "YP400 Majesty Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
    ],
    "YW125 Zuma 125 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "XC50 Vino 50 Classic Base": ["2013", "2014", "2015"],
    "XC50 Vino Classic Base": ["2016", "2017", "2018"],
    "YW50F Zuma 50F Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "YW50FX Zuma 50FX Base": ["2014", "2015", "2016", "2017", "2018"],
    "XV19F Star Venture Base": ["2020", "2021"],
    "YFM700 Grizzly EPS XT-R Base": ["2020", "2021"],
  },
  Zero: {
    DS: ["2010", "2011", "2012", "2013", "2014", "2015"],
    Fx: ["2013", "2014", "2015"],
    Mx: ["2010", "2011", "2012", "2013"],
    S: ["2010", "2011", "2012", "2013", "2014", "2015"],
    SR: ["2014", "2015"],
    X: ["2010", "2011", "2012"],
    Xu: ["2012", "2013"],
    "Zero DS ZF11.4 Base": ["2013", "2014"],
    "Zero DS ZF8.5 Base": ["2013", "2014"],
    "Zero S ZF11.4 Base": ["2013", "2014"],
    "Zero S ZF8.5 Base": ["2013", "2014"],
    "Zero FX ZF2.8 Base": ["2014", "2015"],
    "Zero FX ZF3.3 Base": ["2016", "2017"],
    "Zero FX ZF5.7 Base": ["2014", "2015"],
    "Zero FX ZF6.5 Base": ["2016", "2017"],
    "Zero FXS ZF3.3 Base": ["2016", "2017"],
    "Zero FXS ZF6.5 Base": ["2016", "2017"],
  },
  Polaris: {
    "Sportsman 550": ["2010", "2011", "2012", "2013"],
    "Sportsman 550 EPS": ["2010", "2011", "2012", "2013", "2014"],
    "Sportsman Touring 550 EPS": ["2010", "2011", "2012", "2013", "2014"],
    "Sportsman X2 550": ["2010", "2011", "2012", "2013", "2014"],
    "Atp 500": ["2004", "2005"],
    "Ranger 500 4X4": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "Scrambler 500 4X4": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Sportsman 500 HO 2x4": [
      "2001",
      "2002",
      "2003",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Sportsman 6X6 500": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Sportsman Touring 500": ["2008", "2009"],
    "Sportsman Touring 500 HO": ["2010", "2011", "2012"],
    "Sportsman X2 500": ["2006", "2007", "2008", "2009"],
    '600 Pro-RMK 155"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    '600 RMK 144"': [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    '600 Rush Pro-S 120"': ["2015", "2016", "2017", "2018", "2019", "2020"],
    '600 Rush XCR 121"': ["2017", "2018", "2019"],
    '600 Switchback Adventure 137"': ["2015", "2016", "2017", "2018", "2019"],
    '600 Switchback Assault 144"': [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    '600 Switchback Pro-S 137"': [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    '600 Switchback SP 144"': ["2017", "2018", "2019"],
    '600 Voyageur 144"': ["2017", "2018", "2019", "2020", "2021"],
    '800 Pro-RMK 155"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    '800 Pro-RMK 163"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    '800 RMK Assault 155"': [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    '800 Rush Pro-S 120"': ["2015", "2016", "2017", "2018", "2019", "2020"],
    '800 Rush Pro-X 120"': ["2015", "2016", "2017", "2018"],
    '800 Rush XCR 121"': ["2017", "2018"],
    '800 SKS 155"': ["2016", "2017", "2018", "2019", "2020"],
    '800 Switchback Adventure 137"': ["2016", "2017", "2018", "2019"],
    '800 Switchback Assault 144"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    '800 Switchback Pro-S 137"': [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    '800 Switchback Pro-X 137"': ["2015", "2016", "2017", "2018"],
    "Atp 330": ["2004", "2005"],
    "Big Boss 500 6X6": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "Diesel 500": ["1999", "2000", "2001", "2002"],
    "Hawkeye 300 2X4": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Hawkeye 300 4X4": ["2006", "2007"],
    "Magnum 325 2X4": ["2000", "2001", "2002"],
    "Magnum 325 4X4": ["2000", "2001", "2002"],
    "Magnum 330 2X4": ["2003", "2004", "2005"],
    "Magnum 330 4X4": ["2003", "2004", "2005", "2006"],
    "Magnum 425 2X4": ["1995", "1996", "1997", "1998"],
    "Magnum 425 4X4": ["1995", "1996", "1997", "1998"],
    "Magnum 425 6X6": ["1996", "1997"],
    "Magnum 500 4X4": ["1999", "2000", "2001", "2002", "2003"],
    "Ranger 400 4X4 [Midsize]": ["2010", "2011", "2012", "2013", "2014"],
    "Ranger 425 2X4": ["2001", "2002", "2003", "2004"],
    "Ranger 500 2X4": ["2005", "2006", "2007", "2008", "2009"],
    "Ranger 500 6X6": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Ranger Crew 500 4x4": ["2011", "2012", "2013"],
    "Sportsman 300 4x4": ["2008", "2009", "2010"],
    "Sportsman 335": ["1998", "1999", "2000"],
    "Sportsman 400 4X4": [
      "1994",
      "1995",
      "1996",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Sportsman 400 HO 2x4": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Sportsman 450": ["2006", "2007", "2016", "2017"],
    "Sportsman 500 4X4": ["1996", "1997", "1998", "1999", "2000"],
    "Sportsman 500 Efi": ["2006", "2007", "2008", "2009"],
    "Sportsman 500 Rse 4x4": ["1999", "2000"],
    "Trail Blazer 330": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Trail Boss 325": ["1999", "2000", "2001", "2002"],
    "Trail Boss 330": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Xpedition 325": ["2000", "2001", "2002"],
    "Xpedition 425": ["2000", "2001", "2002"],
    "Ranger 700 6X6": ["2006", "2007", "2008", "2009"],
    "Ranger 800 4x4": ["2010", "2011", "2013", "2014"],
    "Ranger 800 4x4 EPS": ["2013", "2014"],
    "Ranger 800 4x4 [Midsize]": ["2013", "2014"],
    "Ranger 800 6X6": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Ranger 800 HD": ["2010", "2011"],
    "Ranger 800 HD EPS": ["2011", "2012"],
    "Ranger Crew 700 4x4": ["2008", "2009"],
    "Ranger Crew 800 4x4": ["2010", "2011", "2012", "2013", "2014"],
    "Ranger Crew 800 4x4 EPS": ["2010", "2011", "2012", "2013", "2014"],
    "Ranger XP 700": ["2005", "2006", "2007", "2008", "2009"],
    "Ranger XP 900": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "Ranger XP 900 EPS": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "RZR 4 800": ["2009", "2010", "2011", "2012", "2013"],
    "RZR 4 800 EPS": ["2011", "2012", "2013", "2014"],
    "RZR 570": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "RZR 800": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "RZR 800 EPS": ["2011", "2012", "2013", "2014"],
    "RZR 800 S": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "RZR 800 S EPS": ["2013", "2014"],
    "Sportsman 600 4x4": ["2003", "2004", "2005"],
    "Sportsman 700 Efi 4x4": ["2004", "2005", "2006", "2007"],
    "Sportsman 800 EFI": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Sportsman Big Boss 6X6 800": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Sportsman Touring 800": ["2008", "2009"],
    "Sportsman X2 800 EFI": ["2007", "2008", "2009"],
    "Outlaw 450 Mxr": ["2008", "2009", "2010"],
    "Outlaw 525 Irs": ["2007", "2008", "2009", "2010", "2011"],
    "Outlaw 525 S": ["2008", "2009", "2010"],
    "Outlaw 500": ["2006", "2007"],
    "Predator 500": ["2003", "2004", "2005", "2006", "2007"],
    "Slingshot Base": ["2015", "2016", "2017"],
    "Slingshot SL Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Slingshot SL LE Base": ["2015", "2016", "2017"],
    "Slingshot SLR Base": ["2017", "2018", "2019"],
    "RZR XP 4 Turbo EPS Base": ["2016", "2017", "2018", "2019"],
    "RZR XP Turbo EPS DYNAMIX Edition Base": ["2018", "2019"],
    '550 IQ LXT 136"': ["2011", "2012", "2013"],
    '550 IQ Shift 121"': ["2009", "2010", "2011", "2012", "2013"],
    '600 IQ 121"': ["2009", "2010"],
    '600 IQ Shift 121"': ["2008", "2009", "2010", "2011", "2012"],
    '600 RMK 155"': ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    '600 Switchback 136"': [
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    '800 RMK 155"': [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    '800 RMK Dragon 155"': ["2008", "2009", "2010"],
    '800 RMK Dragon 163"': ["2008", "2009", "2010"],
    '800 Switchback 136"': [
      "2004",
      "2005",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
    ],
    "RZR Pro XP Base": ["2020", "2021"],
    "RZR Pro XP 4 Base": ["2020", "2021"],
    "RZR Pro XP 4 Premium Base": ["2020", "2021", "2022", "2023", "2024"],
    "RZR Pro XP 4 Ultimate Base": ["2020", "2021", "2022", "2023", "2024"],
    "RZR Pro XP Premium Base": ["2020", "2021", "2022", "2023", "2024"],
    "RZR Pro XP Ultimate Base": ["2020", "2021", "2022", "2023", "2024"],
    "RZR XP 4 Turbo Base": ["2020", "2021"],
    "RZR XP 4 Turbo EPS DYNAMIX Edition Base": ["2018", "2019"],
    "RZR XP 4 Turbo S Base": ["2019", "2020"],
    "RZR XP Turbo Base": ["2020", "2021"],
    "RZR XP Turbo EPS Base": ["2016", "2017", "2018", "2019"],
    "RZR XP Turbo S Base": ["2018", "2019", "2020"],
    "Ranger 570": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Ranger 570 [Fullsize]": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ranger Crew 570-4 EPS": ["2016", "2017", "2018", "2019", "2020"],
    "RZR 570 EPS": ["2016", "2017", "2018", "2019"],
    "RZR 900": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "RZR 900 S": ["2015", "2016", "2017", "2018", "2019"],
    "RZR 900 S EPS": ["2015", "2016", "2017", "2018", "2019"],
    "RZR XP 1000 EPS": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "RZR XP 4 1000 EPS": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman 570": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "RZR XP 900": ["2011", "2012", "2013"],
    "RZR XP 900 LE": ["2011", "2012"],
    "RZR 4 900 EPS": ["2014", "2015", "2016", "2017", "2018"],
    "RZR S4 1000 EPS": ["2019", "2020"],
    "RZR XP 4 1000 Premium": ["2020", "2021", "2022", "2023"],
    "RZR XP 4 1000 Sport": ["2021", "2022", "2023"],
    "RZR XP 4 Turbo": ["2019", "2020", "2021"],
    "RZR XP 4 Turbo EPS": ["2016", "2017", "2018"],
    "RZR 1000 S EPS": ["2016", "2017", "2018", "2019", "2020"],
    "RZR 1000 Trail S Premium": ["2021", "2022", "2023"],
    "RZR 1000 Trail S Ultimate": ["2021", "2022", "2023", "2024"],
    "RZR 900 Trail S Sport": ["2021", "2022", "2023", "2024"],
    "RZR 900 Trail Ultimate EPS": ["2021", "2022", "2023", "2024"],
    "RZR XP 1000 Premium": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "RZR XP 1000 Sport": ["2021", "2022", "2023", "2024", "2025"],
    "RZR XP Turbo": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "Ranger 325 ETX [Midsize]": ["2015", "2016"],
    "Ranger 500": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Ranger 570 EPS": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Ranger EV 4x4 [Midsize]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "General 1000 EPS": ["2016", "2017", "2018", "2019", "2020"],
    "General 1000 LE EPS": ["2018", "2019"],
    "General 1000 Premium EPS": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "General 1000 Ride Command Edition EPS": ["2017", "2018", "2019"],
    "Ranger 1000 Diesel": ["2015", "2016", "2017", "2018"],
    "Ranger 1000 Diesel HST": ["2015", "2016", "2017"],
    "Ranger 900 Diesel": ["2011", "2012", "2013", "2014"],
    "Ranger Crew 1000 Diesel": ["2015", "2016", "2017", "2018"],
    "Ranger Crew 900": ["2014", "2015"],
    "Ranger Crew 900 Diesel": ["2012", "2013", "2014"],
    "Ranger Crew 900 EPS": ["2014", "2015"],
    "Ranger Crew XP 900": ["2017", "2018", "2019"],
    "Ranger Crew XP 900 EPS": ["2017", "2018", "2019"],
    "Ranger XP 1000 EPS": ["2017", "2018", "2019"],
    "RZR XP 1000": ["2014", "2015", "2016", "2017"],
    "RZR XP 1000 Ride Command EPS": ["2018", "2019"],
    "RZR XP 4 1000 Ride Command Edition EPS": ["2018", "2019"],
    "Ranger 1000 EPS": ["2020", "2021", "2022", "2023", "2024"],
    "Ranger 1000 Premium": ["2020", "2021", "2022", "2023", "2024"],
    "Ranger Crew 1000": ["2020", "2021", "2022", "2023", "2024"],
    "Ranger Crew 570 [Fullsize]": [
      "2014",
      "2015",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ranger SP 570 Premium": ["2022", "2023", "2024"],
    "RZR 900 EPS": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "RZR 900 Trail Premium EPS": ["2020", "2021", "2022", "2023", "2024"],
    "RZR 900 XC Edition EPS": ["2015", "2016", "2017"],
    "RZR Pro XP": ["2020", "2021"],
    "RZR Pro XP Premium": ["2020", "2021", "2022", "2023", "2024"],
    "RZR Pro XP Sport": ["2021", "2022", "2023", "2024"],
    "RZR Pro XP Ultimate": ["2020", "2021", "2022", "2023", "2024"],
    "Ranger XP 1000 High Lifter Edition EPS": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Ranger XP 1000 Northstar Premium": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ranger XP 1000 Northstar Trail Boss": ["2023", "2024"],
    "Ranger XP 1000 Northstar Ultimate": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ranger XP 1000 Northstar Ultimate Ride Command": ["2022", "2023"],
    "Ranger XP 1000 Premium": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Ranger XP 1000 Texas Edition": ["2020", "2021"],
    "Ranger XP 1000 Trail Boss": ["2021", "2022"],
    "RZR Pro R 4 Premium": ["2022", "2023", "2024"],
    "RZR Pro R 4 Ultimate": ["2022", "2023", "2024"],
    "RZR Pro R Premium": ["2022", "2023", "2024"],
    "RZR Pro R Ultimate": ["2022", "2023", "2024"],
    "RZR XP 1000 High Lifter Edition EPS": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "RZR XP 1000 Trails & Rocks EPS": ["2018", "2019", "2020", "2021", "2022"],
    "RZR XP 4 1000 High Lifter Edition EPS": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "RZR 1000 RS1": ["2018", "2019", "2020", "2021", "2022"],
    "RZR XP 4 Turbo Dynamix Edition EPS": ["2018", "2019"],
    "RZR XP 4 Turbo S": ["2019", "2020"],
    "RZR XP Turbo Dynamix Edition EPS": ["2018", "2019"],
    "RZR XP Turbo EPS": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "RZR XP Turbo S": ["2018", "2019", "2020", "2021"],
    "General 1000 Deluxe EPS": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "General 4 1000 Deluxe": ["2020", "2021"],
    "General 4 1000 Deluxe Ride Command Edition": ["2020", "2021", "2022"],
    "General 4 1000 Premium": ["2021", "2022"],
    "RZR 900 Trail EPS": ["2015", "2016"],
    "RZR 900 Trail Sport": ["2021", "2022", "2023", "2024"],
    "RZR XP 4 Turbo S Velocity": ["2019", "2020"],
    "RZR XP Turbo LE EPS": ["2019", "2020", "2021"],
    "RZR XP Turbo S Velocity": ["2019", "2020"],
    "RZR XP 1000 Ultimate": ["2023", "2024", "2025"],
    '850 Pro-RMK 155"': ["2019", "2020", "2021", "2023", "2024"],
    '850 Pro-RMK 163"': ["2019", "2020", "2021"],
    '850 Pro-RMK 174"': ["2019", "2020", "2021"],
    '850 SKS 146"': ["2019", "2020", "2021"],
    '850 SKS 155"': ["2019", "2020", "2021"],
    '850 Switchback Assault 144"': ["2019", "2020", "2021"],
    "Ranger 1000": ["2020", "2021", "2022", "2023", "2024"],
    "Ranger 150": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Ranger 500 EPS": ["2017", "2018", "2019", "2020", "2021"],
    "Ranger 570 Premium": ["2020", "2021"],
    "Ranger Crew 570 Premium": ["2020", "2021"],
    "Ranger Crew 570-4": ["2016", "2017", "2018", "2019", "2020"],
    "Ranger Crew 570-6": ["2016", "2017", "2018", "2019", "2020"],
    "Ranger Crew XP 1000 EPS": ["2017", "2018", "2019"],
    "Ranger Crew XP 1000 High Lifter Edition EPS": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Ranger Crew XP 1000 Northstar HVAC Edition EPS": ["2017", "2018", "2019"],
    "Ranger Crew XP 1000 Northstar Premium EPS": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ranger Crew XP 1000 Northstar Ultimate EPS": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Ranger Crew XP 1000 Premium EPS": ["2020", "2021", "2022", "2023", "2024"],
    "Ranger Crew XP 1000 Texas Edition EPS": ["2020", "2021", "2022"],
    "Ranger Crew XP 1000 Trail Boss EPS": ["2021", "2022", "2023"],
    "Ranger XP 1000 Northstar HVAC": ["2017", "2018"],
    "RZR Pro XP 4 Premium": ["2020", "2021", "2022", "2023", "2024"],
    "RZR Pro XP 4 Ultimate": ["2020", "2021", "2022", "2023", "2024"],
    "General 1000 Deluxe Ride Command Edition": ["2021", "2022"],
    "General 1000 Sport": ["2020", "2021", "2022", "2023", "2024"],
    "General 4 1000 EPS": ["2017", "2018", "2019", "2020"],
    "General 4 1000 Ride Command Edition EPS": ["2018", "2019"],
    "General XP 1000 Deluxe": ["2020", "2021", "2022"],
    "General XP 4 1000 Deluxe": ["2020", "2021", "2022"],
    "Ranger XP 900 Hunter Deluxe Edition EPS": ["2015", "2016"],
    "Ranger XP 900 Hunter Edition EPS": ["2015", "2016"],
    "Ranger XP 900 LE Browning EPS": ["2013", "2014"],
    "Ranger XP 900 LE EPS": ["2013", "2014"],
    "Ranger XP 900 Northstar Edition EPS": ["2015", "2016"],
    "Ranger 800 4x4 EPS LE": ["2013", "2014"],
    "Ranger 800 4x4 EPS [Midsize] LE": ["2013", "2014"],
    "Ranger XP 800": ["2010", "2011", "2012"],
    "Ranger XP 800 EPS": ["2010", "2011", "2012"],
    "RZR 4 800 LE EPS": ["2013", "2014"],
    "RZR 4 800 Robbie Gordon": ["2010", "2011", "2012"],
    "RZR 4 800 Robbie Gordon EPS": ["2011", "2012"],
    "RZR 800 LE": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "RZR 800 LE EPS": ["2010", "2011", "2012", "2013", "2014"],
    "Sportsman 450 HO": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Sportsman 450 HO EPS": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sportsman 450 HO Utility Edition": [
      "2017",
      "2018",
      "2019",
      "2022",
      "2023",
      "2024",
    ],
    "Sportsman 570 EFI HD": ["2016", "2017", "2018"],
    "Sportsman 570 EPS": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2022",
      "2023",
      "2024",
    ],
    "Sportsman 570 EPS LE": ["2018", "2019"],
    "Sportsman 570 Premium": ["2020", "2021", "2022", "2023", "2024"],
    "Sportsman 570 SP": ["2015", "2016", "2017", "2018", "2019"],
    "Sportsman 570 SP LE": ["2015", "2016", "2018", "2019"],
    "Sportsman 570 Trail": ["2021", "2022", "2023", "2024"],
    "Sportsman 570 Utility Edition EPS": ["2017", "2018", "2019"],
    "Sportsman 570 Utility HD EPS": ["2021", "2022", "2023", "2024"],
    "Sportsman 6X6 570 EPS": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Sportsman 850": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sportsman 850 High Lifter Edition": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sportsman 850 Premium": ["2020", "2021", "2022", "2023", "2024"],
    "Sportsman 850 SP": ["2015", "2016", "2017", "2018", "2019"],
    "Sportsman 850 Ultimate Trail": ["2021", "2022", "2023", "2024"],
    "Sportsman Touring 570": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sportsman Touring 570 EPS": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Sportsman Touring 570 Premium": ["2020", "2021", "2022", "2023"],
    "Sportsman Touring 570 SP": ["2015", "2016", "2017", "2018", "2019"],
    "Sportsman Touring 850 EPS": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Sportsman Touring 850 SP": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman Touring XP 1000": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Sportsman X2 570 EPS": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Sportsman XP 1000": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Sportsman XP 1000 High Lifter Edition EPS": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sportsman XP 1000 LE": ["2017", "2018", "2019"],
    "Sportsman XP 1000 Premium": ["2019", "2020"],
    "Sportsman XP 1000 S": ["2020", "2021", "2022", "2023", "2024"],
    '600 Indy 121"': [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    '600 Indy Adventure 137"': ["2020", "2021"],
    '600 Indy SP 121"': ["2013", "2014", "2015", "2016", "2017", "2018"],
    '600 Indy SP 129"': ["2019", "2020", "2021", "2022"],
    '600 Indy SP 137"': ["2020", "2021", "2022"],
    '600 Indy Voyageur 144"': ["2014", "2015", "2016"],
    '600 Indy XC 129"': ["2019", "2020", "2021"],
    '600 Indy XC 137"': ["2020", "2021"],
    '600 Indy XCR 129"': ["2020", "2021"],
    '600 Rush 120"': ["2010", "2011", "2012", "2013"],
    '600 Rush Pro-R 120"': ["2011", "2012", "2013", "2014"],
    "600 Rush Pro-X": ["2015", "2016"],
    '600 Switchback Adventure 136"': ["2012", "2013", "2014"],
    '600 Switchback Pro-R 136"': ["2012", "2013", "2014"],
    "600 Switchback Pro-X": ["2015", "2016"],
    '600 Switchback XCR 136"': ["2020", "2021"],
    '600 Switchback XCR 137"': ["2018", "2019", "2020"],
    '800 Indy SP 121"': ["2014", "2015", "2016"],
    '800 Indy XC 129"': ["2019", "2020"],
    '800 Pro-RMK 174"': ["2018", "2019", "2020"],
    '800 Pro-RMK LE 155"': ["2014", "2015"],
    '800 Rush 120"': ["2011", "2012", "2013"],
    '800 Rush Pro-R 121"': ["2011", "2012", "2013", "2014"],
    '800 SKS 146"': ["2018", "2019", "2020"],
    '800 Switchback Pro-R 136"': ["2012", "2013", "2014"],
    "800 Switchback Pro-R LE": ["2013", "2014"],
    '550 Shift 136"': ["2011", "2012"],
    '600 Dragon Switchback 136"': ["2008", "2009", "2010"],
    '600 IQ LXT 136"': ["2011", "2012", "2013", "2014", "2015"],
    '600 IQ Touring 136"': ["2008", "2009", "2010"],
    '600 IQ Widetrak 156"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    '800 Dragon Switchback 136"': ["2009", "2010"],
    '800 IQ 121"': ["2008", "2009", "2010"],
    "500 Classic": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    '500 Indy 121"': [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2005",
      "2006",
    ],
    "500 XC": ["1999", "2000", "2001", "2002", "2003"],
    '550 Classic 121"': ["2002", "2003", "2004", "2005", "2006"],
    '550 SuperSport 121"': [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    '600 Classic 121"': ["2001", "2002", "2003", "2004", "2005", "2006"],
    "700 Classic": ["2001", "2002", "2003", "2004"],
    '850 Rush Pro-S 120"': ["2019", "2020", "2021"],
    '850 Switchback Pro-S 137"': ["2019", "2020", "2021", "2022", "2023"],
    '850 Switchback XCR 136"': ["2019", "2020", "2021"],
    '650 Switchback Assault 146"': ["2021", "2022", "2023", "2024", "2025"],
    '850 Switchback Assault 146"': ["2021", "2022", "2023", "2024"],
    '650 Indy Adventure 137"': ["2022", "2023", "2024", "2025"],
    '650 Indy SP 137"': ["2023", "2024", "2025"],
    '650 Indy VR1 129"': ["2021", "2022", "2023"],
    '650 Indy VR1 137"': ["2021", "2022", "2023", "2024", "2025"],
    '650 Indy XC 129"': ["2022", "2023", "2024"],
    '650 Indy XC 137"': ["2022", "2023", "2024"],
    '650 Indy XCR 128"': ["2022", "2023", "2024", "2025"],
    '650 Indy XCR 136"': ["2022", "2023", "2024", "2025"],
    '850 Indy Adventure 137"': ["2020", "2021", "2022", "2023"],
    '850 Indy VR1 129"': ["2021", "2022", "2023"],
    '850 Indy VR1 137"': ["2021", "2022", "2023", "2024"],
    '850 Indy XC 129"': ["2019", "2020", "2021", "2022", "2023", "2024"],
    '850 Indy XC 137"': ["2020", "2021", "2022", "2023", "2024"],
    '850 Indy XCR 128"': ["2020", "2021", "2022", "2023", "2024"],
    '850 Indy XCR 136"': ["2022", "2023", "2024"],
    '900 Switchback Assault Patriot Boost 146"': ["2023", "2024"],
    '550 RMK EVO 144"': ["2020", "2021", "2022", "2023", "2024"],
    '850 RMK Khaos 155"': ["2020", "2021", "2023", "2024"],
    "340 Indy Deluxe": ["1999", "2000", "2001", "2002"],
    "340 Indy Touring": ["1999", "2000", "2001", "2002", "2003"],
    "440 IQ": ["2005", "2006", "2007"],
    '550 Indy 121"': [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    '550 Indy 144"': [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    '550 Indy Adventure 144"': [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    '550 Indy Adventure 155"': [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    '550 Indy LXT 144"': [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    '550 Indy Voyageur 144"': ["2014", "2015", "2016"],
    '550 Indy Voyageur 155"': ["2015", "2016"],
    '550 LX 121"': ["2007", "2008"],
    '550 Trail Touring 136"': [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
    ],
    '550 Trail Touring Deluxe 136"': ["2007", "2008", "2009"],
    '550 Widetrack LX 156"': ["2016", "2017", "2018", "2019", "2020"],
    "600 IQ Racer": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    '600 RMK Shift 155"': ["2008", "2009"],
    '700 RMK 155"': ["2008", "2009", "2010"],
    '750 FS IQ Touring 136"': ["2007", "2008", "2009"],
    '750 FS IQ Widetrak 156"': ["2010", "2011", "2012", "2013"],
    '750 FST IQ Touring 136"': ["2007", "2008", "2009", "2010"],
    '750 IQ Turbo 121"': ["2010", "2011", "2012"],
    '750 IQ Turbo Dragon 121"': ["2008", "2009", "2010"],
    '750 IQ Turbo LX 136"': ["2010", "2011", "2012"],
    '750 IQ Turbo LXT 136"': ["2011", "2012", "2013", "2014"],
    '750 IQ Widetrak 156"': ["2009", "2010"],
    '750 Turbo Switchback 136"': ["2008", "2009"],
    "FS Touring": ["2011", "2012", "2013"],
    "RZR Pro XP 4 Sport": ["2021", "2022", "2023", "2024"],
    "RZR S4 900 EPS": ["2018", "2019"],
    "General XP 1000 Premium": ["2023", "2024"],
    "General XP 1000 Sport": ["2023", "2024"],
    "General XP 1000 Ultimate": ["2023", "2024"],
    "General XP 4 1000 Premium": ["2021", "2022", "2023", "2024"],
    "General XP 4 1000 Sport": ["2023", "2024"],
    "General XP 4 1000 Ultimate": ["2023", "2024"],
    "Ranger Crew 1000 Premium": ["2020", "2021", "2022", "2023", "2024"],
    "Ranger Crew SP 570": ["2022", "2023", "2024"],
    "Ranger Crew SP 570 NorthStar Edition": ["2022", "2023", "2024"],
    "Ranger Crew SP 570 Premium": ["2022", "2023", "2024"],
    "Ranger Crew XP 1000 Northstar Ultimate Ride Command EPS": [
      "2022",
      "2023",
      "2024",
    ],
    "Ranger SP 570": ["2022", "2023", "2024"],
    "Ranger SP 570 NorthStar Edition": ["2022", "2023"],
    "Ranger XP Kinetic Premium": ["2023", "2024"],
    "Ranger XP Kinetic Ultimate": ["2023", "2024"],
    "RZR Turbo R 4 Premium": ["2022", "2023", "2024"],
    "RZR Turbo R 4 Sport": ["2022", "2023", "2024"],
    "RZR Turbo R 4 Ultimate": ["2022", "2023", "2024"],
    "RZR Turbo R Premium": ["2022", "2023", "2024"],
    "RZR Turbo R Sport": ["2022", "2023", "2024"],
    "RZR Turbo R Ultimate": ["2022", "2023", "2024"],
    "Ranger 1000 Diesel HST Deluxe": ["2015", "2016"],
    "Ranger 500 4X4 EFI": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Ranger Crew 570": ["2014", "2015"],
    "ACE 900 Xc": ["2017", "2018", "2019"],
    "RZR XP 4 900": ["2012", "2013"],
    "Ranger 700 4X4": ["2005", "2006", "2007", "2008", "2009"],
    "ACE 570": ["2014", "2015", "2016", "2017"],
    "ACE 570 EPS": ["2018", "2019"],
    "Ace 570 HD": ["2015", "2016", "2017", "2018", "2019"],
    "ACE 570 Sp": ["2015", "2016", "2017"],
    "Ranger Crew 570 EPS [Fullsize]": ["2014", "2015"],
    "RZR 570 Trail": ["2020", "2021", "2022"],
    "RZR 570 Trail EPS": ["2015", "2016"],
    "RZR 570 Trail Premium": ["2020", "2021"],
    "RZR 800 S LE": ["2010", "2011"],
    "RZR XP 4 900 EPS": ["2012", "2013"],
    "RZR XP 900 EPS": ["2012", "2013"],
    "Scrambler 850": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Scrambler XP 1000 EPS": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Scrambler XP 1000 S": ["2020", "2021", "2022", "2023", "2024"],
    "Sportsman 400 HO 4x4": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Sportsman 500 HO 4x4": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Sportsman 570 HD": ["2014", "2015"],
    "Sportsman 570 Hunt Edition": ["2020", "2021", "2022"],
    "Sportsman 570 Ultimate Trail LE": ["2021", "2022"],
    "Sportsman XP 1000 Ultimate Trail": ["2022", "2023"],
    "Sportsman XP 550": ["2009", "2010", "2013", "2014"],
    "Sportsman XP 850": ["2009", "2010", "2011", "2012", "2013"],
    "Sportsman XP 850 EPS": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Sportsman XP 850 EPS LE": ["2012", "2013", "2014"],
    "Ranger 500 4x4 EFI LE": ["2012", "2013"],
    "Ranger Crew 500 4x4 LE": ["2012", "2013"],
    "Ranger Crew 800 4x4 EPS LE": ["2010", "2011"],
    "ACE 325": ["2014", "2015", "2016"],
    "ACE 500": ["2017", "2018", "2019"],
    "Scrambler XP 850": ["2013", "2014"],
    "Scrambler XP 850 EPS": ["2013", "2014"],
    "Sportsman 700 4x4": ["2002", "2003", "2004", "2005", "2006"],
    "Big Boss 400L 6X6": ["1994", "1995", "1996", "1997"],
    "Scrambler 400 4X4": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Sportsman 500 4x4 Duse": ["2001", "2002"],
    "Sportsman 500 HO RSE": ["2001", "2002"],
    "Xplorer 250 4X4": ["2000", "2001", "2002"],
    "Xplorer 300 4X4": ["1996", "1997", "1998", "1999", "2000", "2001"],
    '550 Trail RMK 136"': [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "ACE 150": ["2017", "2018", "2019", "2020", "2021"],
    "SLT 700": ["1996", "1997"],
    "SLT 750": ["1994", "1995"],
    "SLT 780": ["1996", "1997"],
    SLTH: ["1998", "1999"],
    '550 Indy EVO 121"': ["2019", "2020", "2021", "2022", "2023", "2024"],
    '550 Indy EVO ES 121"': ["2019", "2020"],
    '550 Voyageur 144"': [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    '550 Voyageur 155"': [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    '800 Indy XCR 129"': ["2020", "2021"],
    '800 Titan Adventure 155"': [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    '800 Titan SP 155"': ["2018", "2019", "2020", "2021"],
    '800 Titan XC 155"': ["2018", "2019", "2020", "2021", "2022"],
    "300 2X4": ["1994", "1995"],
    "300 4X4": ["1994", "1995"],
    "400L 2X4": ["1994", "1995"],
    "Big Boss 250 4X6": ["1989", "1990", "1991", "1992"],
    "Big Boss 250 6X6": ["1991", "1992", "1993"],
    "Hawkeye 400 HO 2x4": ["2011", "2012", "2013", "2014"],
    "Scrambler 400 2X4": ["1999", "2000", "2001", "2002"],
    "Scrambler 500 2X4": ["2000", "2001", "2002"],
    "Sport 400L": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "Trail Blazer 250": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Trail Boss 250 2X4": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Trail Boss 250 4X4": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Trail Boss 350L 2X4": ["1990", "1991", "1992", "1993"],
    "Trail Boss 350L 4X4": ["1990", "1991", "1992", "1993"],
    "Worker 500": ["1999", "2000", "2001", "2002"],
    "Xplorer 400 4X4": ["1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    "Xpress 300": ["1996", "1997", "1998", "1999"],
    "Xpress 400L": ["1996", "1997"],
    "Ranger EV Li-Ion 4x4 [Midsize]": ["2016", "2017", "2018"],
    "120 Indy": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "RZR 170": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Ranger Crew 570 EPS": ["2014", "2015"],
    "Ranger EV LSV 4x4": ["2011", "2012"],
    "Ranger TM": ["2004", "2005", "2006"],
    "Outlaw 70": ["2021", "2022", "2023", "2024"],
    '650 Switchback XC 146"': ["2022", "2023", "2024", "2025"],
    '650 Voyageur 146"': ["2022", "2023", "2024", "2025"],
    '850 Switchback XC 146"': ["2022", "2023", "2024"],
    '650 Pro-RMK Matryx 155"': ["2022", "2023", "2024"],
    '650 RMK Khaos Matryx Slash 146"': ["2022", "2023", "2024"],
    "900 RMK": ["2005", "2006"],
    "900 Switchback": ["2005", "2006"],
    'RMK 800 Assault 146"': ["2009", "2010"],
    "Sportsman Touring XP 1000 LE": ["2015", "2016"],
    "Sportsman Touring XP 1000 Trail": ["2022", "2023", "2024"],
    "ATV PRO 500": ["2002", "2003", "2004"],
    "900 Fusion": ["2005", "2006"],
    "Outlaw 110": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlaw 50": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Outlaw 90": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Phoenix 200": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Predator 50": ["2004", "2005", "2006", "2007"],
    "Predator 90": ["2003", "2004", "2005", "2006"],
    Sawtooth: ["2006", "2007"],
    "Scrambler 250": ["1985", "1986"],
    "Scrambler 50": ["2001", "2002", "2003"],
    "Scrambler 90": ["2001", "2002", "2003"],
    "Sportsman 110": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sportsman 90": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Frontier Classic": ["2003", "2004"],
    "Frontier Touring": ["2003", "2004", "2005"],
    SL650: ["1992", "1993", "1994", "1995"],
    SL750: ["1993", "1994", "1995"],
    SL780: ["1996", "1997"],
    "SLX 780": ["1995", "1996"],
    "700 Freedom": ["2002", "2003", "2004"],
    "700 Hurricane": ["1996", "1997"],
    "700 Virage": ["2000", "2001", "2002", "2003", "2004"],
    SL700: ["1996", "1997"],
    SL900: ["1996", "1997"],
    "Sportsman 700 Mv7 4x4": ["2005", "2006"],
    "Sportsman 800 EFI LE": ["2006", "2007"],
    "Ranger XP 800 EPS LE": ["2010", "2011", "2012"],
    "Ranger XP 800 LE": ["2010", "2011", "2012"],
    "Sportsman 550 EPS LE": ["2011", "2012", "2013", "2014"],
    440: ["1992", "1993", "1994", "1995", "1996", "1997"],
    "500 RMK": ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    '550 Sport Touring 136"': [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    '700 RMK 136"': ["1997", "1998", "1999", "2000", "2001", "2002"],
    Trail: [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "440 TranSport": ["1996", "1997", "1998", "1999"],
    Sport: [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    StarLite: ["1991", "1992", "1993", "1994", "1995"],
    LITE: ["1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998"],
    "StarLite GT": ["1993", "1994"],
    "440 Pro-X": ["2001", "2002", "2003"],
    "440 XCR": ["1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    '500 XC SP 121"': [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    '600 Pro-X 121"': ["2001", "2002", "2003", "2004"],
    '600 Switchback HO 144"': ["2006", "2007"],
    '600 Touring 136"': ["2005", "2006"],
    '600 XC SP 121"': ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "600 XCR": ["1994", "1995", "1996", "1997", "1998"],
    "700 SKS": ["1999", "2000", "2001", "2002", "2003"],
    "700 XC": ["1997", "1998", "1999", "2003", "2004"],
    '700 XC SP 121"': ["1999", "2000", "2001", "2002", "2003"],
    "700 XCR": ["1998", "1999"],
    "800 XC SP": ["2001", "2002", "2003"],
    "800 XCR": ["1999", "2000", "2001", "2002", "2003"],
    Ultra: ["1997", "1998"],
    "Ultra SP": ["1996", "1997"],
    "Ultra Touring": ["1997", "1998"],
    "440 XCR SP": ["1994", "1995", "1996"],
    "500 (EFI)": ["1993", "1994", "1995", "1996", "1997"],
    "500 SKS (EFI)": ["1993", "1994", "1995", "1996"],
    "600 XLT": ["1993", "1994", "1995", "1996", "1997"],
    "600 XLT SKS": ["1994", "1995", "1996", "1997"],
    "600 XLT Special": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "600 XLT Touring": ["1995", "1996", "1997", "1998", "1999"],
    '700 Pro-X 121"': ["2003", "2004"],
    "800 Pro-X": ["2003", "2004"],
    "LITE Deluxe": ["1992", "1993", "1994", "1995", "1996", "1997", "1998"],
    "LITE GT": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "RXL Touring": ["1994", "1995"],
    Storm: ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Storm SKS": ["1993", "1994", "1995", "1996"],
    "Trail Deluxe": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "XLT RMK": ["1995", "1996", "1997"],
    "XLT SKS": ["1993", "1994", "1995", "1996", "1997"],
    "XLT SP": ["1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    "XLT Touring": ["1995", "1996", "1997", "1998", "1999"],
    '700 RMK 144"': ["2001", "2002", "2003", "2004", "2005", "2006"],
    '700 RMK 151"': ["2002", "2003", "2004", "2005", "2006"],
    "500 Edge": ["2003", "2004"],
    "500 XC SP M-10": ["2002", "2003", "2004", "2005"],
    "WideTrak LX": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "440 SKS": ["1993", "1994", "1995"],
    "500 SKS": ["1990", "1991", "1992"],
    "500 SP": ["1990", "1991", "1992"],
    "650 RXL": ["1990", "1991", "1992"],
    "650 RXL SKS": ["1991", "1992"],
    WideTrak: ["1991", "1992", "1993"],
    XCF: ["1997", "1998", "1999"],
    "XLT Classic": ["1998", "1999"],
    "500 Classic Touring": ["2001", "2002", "2003"],
    "600 Classic Touring": ["2001", "2002", "2003", "2004"],
    "600 XC": ["1996", "1997", "1998", "1999"],
    "600 XLT Classic": ["1998", "1999"],
    Slingshot: ["2015", "2016", "2017"],
    "777 Octane": ["2002", "2003", "2004"],
    "800 DI": ["2002", "2003", "2004"],
    Octane: ["2003", "2004"],
    "700 Classic Touring": ["2003", "2004"],
    "700 XC SP M 10": ["2002", "2003"],
    "800 Classic Touring": ["2003", "2004"],
    "800 XC SP M 10": ["2002", "2003"],
    "600 XC Edge": ["2003", "2004", "2005"],
    "600 XC SP M-10": ["2002", "2003", "2004", "2005"],
    "Storm RMK": ["1996", "1997"],
    RXL: ["1993", "1994", "1995", "1996", "1997"],
    "WideTrak GT": ["1993", "1994", "1995", "1996", "1997"],
    XLT: ["1993", "1994", "1995", "1996", "1997"],
    '850 Pro-RMK Matryx Slash 155 2.75"': ["2022", "2023", "2024"],
    '850 Pro-RMK Matryx Slash 155 3"': ["2022", "2023"],
    '850 Pro-RMK Matryx Slash 165 2.75"': ["2022", "2023", "2024"],
    '850 RMK Khaos Matryx Slash 146"': ["2022", "2023", "2024"],
    '850 RMK Khaos Matryx Slash 155"': ["2022", "2023", "2024"],
    '850 RMK Khaos Matryx Slash 165 2.75"': ["2022", "2023", "2024"],
    '550 Indy Sport 121"': ["2023", "2024", "2025"],
    '340 Classic 121"': ["2003", "2004", "2005", "2006"],
    '340 Touring 136"': ["2004", "2005", "2006", "2007"],
    Freedom: ["2002", "2003", "2004"],
    Genesis: ["1999", "2000", "2001", "2002"],
    "Genesis I": ["2001", "2002", "2003", "2004"],
    Hurricane: ["1996", "1997"],
    "MSX 140 HO": ["2003", "2004"],
    "PRO 1200": ["2000", "2001"],
    "PRO 785": ["1998", "1999", "2000"],
    "SLH 700": ["1998", "1999", "2000", "2001"],
    SLTX: ["1998", "1999"],
    SLX: ["1995", "1996", "1999", "2000", "2001"],
    Virage: ["2000", "2001", "2002", "2003", "2004"],
    "Virage I": ["2002", "2003", "2004"],
    "Virage TX": ["2000", "2001", "2002"],
    "Virage TXI": ["2001", "2002"],
    "Slingshot SL": ["2016", "2017", "2018"],
    "Slingshot SLR": ["2017", "2018"],
    "600 XLT Ltd": ["1997", "1998"],
    "RZR Pro XP 4 Sport Base": ["2022", "2023", "2024"],
    "RZR Pro XP Sport Base": ["2021", "2022", "2023", "2024"],
    "RZR Turbo R 4 Premium Base": ["2022", "2023", "2024"],
    "RZR Turbo R 4 Sport Base": ["2022", "2023", "2024"],
    "RZR Turbo R 4 Ultimate Base": ["2022", "2023", "2024"],
    "RZR Turbo R Premium Base": ["2023", "2024"],
    "RZR Turbo R Sport Base": ["2022", "2023", "2024"],
    "RZR Turbo R Ultimate Base": ["2022", "2023", "2024"],
    "Classic Touring": ["1993", "1994", "1996", "1997", "1998", "1999", "2000"],
    400: ["1990", "1991"],
    "500 (CARB)": ["1995", "1996"],
    "600 RMK XLT": ["1996", "1997"],
    Classic: ["1992", "1993", "1994", "1995", "1996", "1997", "1998"],
    "Trail SuperTrak": ["1990", "1991"],
    "XLT Limited": ["1997", "1998"],
    '650 Indy Adventure X2 137"': ["2023", "2024"],
    '650 Pro-RMK 155"': ["2023", "2024"],
    '650 SKS 146"': ["2023", "2024"],
    '650 Switchback SP 146"': ["2023", "2024"],
    "120 Dragon": ["2008", "2009", "2010"],
    "120 Pro X": ["2004", "2005", "2006"],
    "120 Pro-R": ["2012", "2013"],
    "600R Racer": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "1200 Genesis": ["1999", "2000", "2001"],
    "1200 Virage TX": ["2000", "2001", "2002"],
    "Genesis FFI": ["1999", "2000"],
    "MSX 150": ["2003", "2004"],
    "500 XC Base": ["1999", "2000", "2001", "2002", "2003"],
    "600 PRO X Base": ["2001", "2002", "2003", "2004"],
    "600 RMK Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "700 PRO X Base": ["2003", "2004"],
    "700 RMK Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "700 XC Base": ["1997", "1998", "1999", "2003", "2004"],
    "RZR Pro R 4 Premium Base": ["2022", "2023", "2024"],
    "RZR Pro R 4 Ultimate Base": ["2022", "2023", "2024"],
    "RZR Pro R Premium Base": ["2022", "2023", "2024"],
    "RZR Pro R Ultimate Base": ["2022", "2023", "2024"],
    '850 Pro-RMK Matryx Slash 165 3"': ["2023", "2024"],
    '850 RMK Khaos Matryx Slash Patriot Boost 155"': ["2022", "2023", "2024"],
    '850 RMK Khaos Matryx Slash Patriot Boost 165"': ["2023", "2024"],
    '900 Pro-RMK Matryx Slash Patriot 9R 155"': ["2023", "2024"],
    '900 Pro-RMK Matryx Slash Patriot 9R 165"': ["2023", "2024"],
    '900 Pro-RMK Matryx Slash Patriot Boost 155"': ["2023", "2024"],
    '900 Pro-RMK Matryx Slash Patriot Boost 165"': ["2022", "2023", "2024"],
    '900 RMK Khaos Matryx Slash Patriot Boost 9R 146"': ["2023", "2024"],
    '900 RMK Khaos Matryx Slash Patriot Boost 9R 155"': ["2023", "2024"],
    '900 RMK Khaos Matryx Slash Patriot Boost 9R 165"': ["2023", "2024"],
    "Xpedition Adv 5 Northstar": ["2024", "2025"],
    "Xpedition Adv 5 Ultimate": ["2024", "2025"],
    "Xpedition Adv Northstar": ["2024", "2025"],
    "Xpedition Adv Ultimate": ["2024", "2025"],
    "Xpedition XP 5 Northstar": ["2024", "2025"],
    "Xpedition XP 5 Ultimate": ["2024", "2025"],
    "RZR Turbo S Base": ["2021", "2022"],
    "RZR Turbo S Velocity Base": ["2021", "2022"],
    "RZR XP 1000 Base": ["2020", "2021"],
    "RZR XP 1000 EPS Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "RZR XP 1000 EPS High Lifter Edition Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "RZR XP 1000 EPS Ride Command Edition Base": ["2018", "2019"],
    "RZR XP 1000 EPS Trails and Rock Edition Base": ["2018", "2019"],
    "RZR XP 1000 High Lifter Edition Base": ["2020", "2021"],
    "RZR XP 1000 Premium Base": ["2020", "2021", "2022"],
    "RZR XP 1000 Trails & Rocks Base": ["2021", "2022"],
    "RZR XP 4 1000 Base": ["2020", "2021"],
    "RZR XP 4 1000 High Lifter Edition Base": ["2020", "2021"],
    "RZR XP 4 1000 Premium Base": ["2020", "2021"],
    "Ranger RZR XP 4 900 Base": ["2012", "2013"],
    "Ranger RZR XP 4 900 EPS LE Base": ["2012", "2013"],
    "Ranger RZR XP 900 Base": ["2011", "2012", "2013"],
    "Ranger RZR XP 900 LE Base": ["2011", "2012", "2013"],
    "RZR RS1 Base": ["2018", "2019", "2020"],
    "RZR XP 4 1000 EPS Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "RZR XP 4 1000 EPS High Lifter Edition Base": ["2017", "2018", "2019"],
    "RZR XP 4 1000 EPS Ride Command Edition Base": ["2018", "2019"],
    '550 Switchback Sport 144"': ["2023", "2024"],
    "600 Edge Touring": ["2005", "2006"],
    '550 Voyageur Adventure 144"': ["2023", "2024"],
    "120 Dragon Base": ["2007", "2008", "2009", "2010", "2011"],
    "120 Indy Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "120 Pro X Base": ["2004", "2005", "2006"],
    "120 Pro-R Base": ["2012", "2013"],
    "120 XC SP Base": ["2001", "2002", "2003"],
    "300 2X4 Base": ["1994", "1995"],
    "300 4X4 Base": ["1994", "1995"],
    "340 Classic Base": ["2003", "2004", "2005", "2006"],
    "340 Deluxe Base": ["1999", "2000", "2001", "2002"],
    "340 Touring Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "400 Base": ["1985", "1986", "1987", "1988", "1989", "1990", "1991"],
    "400 SKS Base": ["1987", "1988"],
    "400L 2X4 Base": ["1994", "1995"],
    "440 Base": ["1992", "1993", "1994", "1995", "1996", "1997", "1998"],
    "440 IQ Base": ["2005", "2006", "2007"],
    "440 Pro X Base": ["2001", "2002", "2003"],
    "440 Pro X Fan Base": ["2002", "2003"],
    "440 SKS Base": ["1993", "1994", "1995"],
    "440 XCR Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "440 XCR SP Base": ["1994", "1995", "1996"],
    "500 Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "500 Carb Base": ["1995", "1996"],
    "500 Classic Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "500 Classic Touring Base": ["2001", "2002", "2003"],
    "500 EFI Base": ["1993", "1994", "1995", "1996", "1997"],
    "500 EFI SKS Base": ["1993", "1994", "1995", "1996"],
    "500 RMK Base": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "500 SKS Base": ["1989", "1990", "1991", "1992"],
    "500 SP Base": ["1989", "1990", "1991", "1992"],
    "500 XC SP Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "550 Classic Base": ["2002", "2003", "2004", "2005", "2006"],
    "550 INDY Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "550 INDY 144 Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "550 INDY Adventure 144 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "550 INDY Adventure 155 Base": ["2015", "2016", "2017", "2018", "2019"],
    "550 INDY LXT Base": ["2014", "2015"],
    "550 INDY Voyageur 144 Base": ["2015", "2016"],
    "550 INDY Voyageur 155 Base": ["2015", "2016"],
    "550 IQ LXT Base": ["2011", "2012", "2013"],
    "550 IQ Shift Base": ["2009", "2010", "2011", "2012", "2013"],
    "550 LX Base": ["2007", "2008"],
    "550 Shift 136 Base": ["2011", "2012", "2013"],
    "550 Voyageur 144 Base": ["2017", "2018", "2019"],
    "550 Voyageur 155 Base": ["2017", "2018", "2019"],
    "550 Widetrack LX Base": ["2016", "2017"],
    "550 WideTrak LX Base": ["2018", "2019"],
    "600 Base": ["1985", "1986", "1987"],
    "600 Classic Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "600 Classic Touring Base": ["2001", "2002", "2003", "2004"],
    "600 Dragon SwitchBack Base": ["2008", "2009", "2010"],
    "600 INDY Base": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "600 INDY SP Base": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "600 INDY Voyageur Base": ["2015", "2016"],
    "600 IQ Base": ["2009", "2010"],
    "600 IQ LXT Base": ["2011", "2012", "2013", "2014", "2015"],
    "600 IQ Shift Base": ["2009", "2010", "2011", "2012"],
    "600 IQ Touring Base": ["2009", "2010"],
    "600 IQ Widetrack Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "600 PRO-RMK 155 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "600 RMK 144 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "600 RMK 155 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "600 Rush Base": ["2010", "2011", "2012", "2013"],
    "600 Rush PRO-R Base": ["2011", "2012", "2013", "2014"],
    "600 Rush PRO-S Base": ["2015", "2016", "2017", "2018", "2019"],
    "600 Rush XCR Base": ["2017", "2018", "2019"],
    "600 SwitchBack Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "600 SwitchBack Adventure Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "600 SwitchBack Assault 144 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "600 SwitchBack PRO-R Base": ["2012", "2013", "2014"],
    "600 SwitchBack PRO-S Base": ["2015", "2016", "2017", "2018", "2019"],
    "600 SwitchBack SP 144 Base": ["2017", "2018", "2019"],
    "600 SwitchBack XCR Base": ["2018", "2019"],
    "600 Touring Base": ["2004", "2005", "2006"],
    "600 Voyageur 144 Base": ["2017", "2018", "2019"],
    "600 XC Base": ["1996", "1997", "1998", "1999"],
    "600 XC SP Base": ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "600 XCR Base": ["1994", "1995", "1996", "1997", "1998"],
    "650 Base": ["1988", "1989", "1990", "1991", "1992"],
    "650 RXL Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "650 RXL SKS Base": ["1991", "1992", "1993"],
    "650 RXL Touring Base": ["1994", "1995"],
    "650 SKS Base": ["1988", "1989", "1990"],
    "700 Classic Base": ["2001", "2002", "2003", "2004"],
    "700 Classic Touring Base": ["2003", "2004"],
    "700 Dragon RMK 155 Base": ["2007", "2008"],
    "700 RMK 155 Base": ["2008", "2009", "2010"],
    "700 SKS Base": ["1999", "2000", "2001", "2002", "2003"],
    "700 XC SP Base": ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "700 XCR Base": ["1998", "1999"],
    "800 Assault RMK 146 Base": ["2009", "2010"],
    "800 Classic Touring Base": ["2003", "2004"],
    "800 Dragon Base": ["2009", "2010"],
    "800 Dragon RMK 155 Base": ["2008", "2009", "2010"],
    "800 Dragon RMK 163 Base": ["2008", "2009", "2010"],
    "800 Dragon Swtichback Base": ["2009", "2010"],
    "800 INDY SP Base": ["2014", "2015", "2016"],
    "800 IQ Base": ["2008", "2009", "2010"],
    "800 PRO X Base": ["2003", "2004"],
    "800 PRO-RMK 155 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "800 PRO-RMK 155 3in. Base": ["2016", "2017", "2018", "2019"],
    "800 PRO-RMK 163 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "800 PRO-RMK 163 3in. Base": ["2016", "2017", "2018", "2019"],
    "800 PRO-RMK 174 Base": ["2018", "2019"],
    "800 RMK Base": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "800 RMK 144 Base": ["2009", "2010"],
    "800 RMK 155 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "800 RMK Assault 155 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "800 RMK Assault 155 3in. Base": ["2016", "2017"],
    "800 Rush Base": ["2011", "2012", "2013"],
    "800 Rush PRO-R Base": ["2011", "2012", "2013", "2014"],
    "800 Rush PRO-S Base": ["2015", "2016", "2017", "2018", "2019"],
    "800 Rush PRO-X Base": ["2015", "2016", "2017", "2018"],
    "800 Rush XCR Base": ["2017", "2018"],
    "800 SKS 146 Base": ["2018", "2019"],
    "800 SKS 155 Base": ["2016", "2017", "2018", "2019"],
    "800 SwitchBack Base": [
      "2004",
      "2005",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "800 SwitchBack Adventure Base": ["2016", "2017", "2018", "2019"],
    "800 SwitchBack Assault 144 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "800 SwitchBack PRO-R Base": ["2012", "2013", "2014"],
    "800 SwitchBack PRO-S Base": ["2015", "2016", "2017", "2018", "2019"],
    "800 SwitchBack PRO-X Base": ["2015", "2016", "2017", "2018"],
    "800 Titan Adventure 155 Base": ["2018", "2019"],
    "800 Titan SP 155 Base": ["2018", "2019"],
    "800 Titan XC 155 Base": ["2018", "2019"],
    "800 Touring Base": ["2004", "2005"],
    "800 XC Base": ["2003", "2004"],
    "800 XC SP Base": ["2001", "2002", "2003", "2004", "2005"],
    "800 XCR Base": ["1999", "2000", "2001", "2002", "2003"],
    "900 Fusion Base": ["2005", "2006"],
    "900 RMK Base": ["2005", "2006"],
    "900 Switchback Base": ["2005", "2006"],
    "ACE 150 Base": ["2017", "2018", "2019"],
    "ACE 500 Base": ["2017", "2018", "2019"],
    "ACE 570 Base": ["2016", "2017"],
    "ACE 570 EPS Base": ["2018", "2019"],
    "ACE 570 Sp Base": ["2016", "2017"],
    "ACE 900 Xc Base": ["2017", "2018", "2019"],
    "Atp 330 Base": ["2004", "2005"],
    "Atp 500 Base": ["2004", "2005"],
    "Big Boss 250 4X6 Base": ["1989", "1990", "1991", "1992"],
    "Big Boss 250 6X6 Base": ["1991", "1992", "1993"],
    "Big Boss 400L 6X6 Base": ["1994", "1995", "1996", "1997"],
    "Big Boss 500 6X6 Base": ["1998", "1999"],
    "Brutus Base": ["2013", "2014"],
    "Brutus HD Base": ["2013", "2014"],
    "Brutus HDPTO Base": ["2013", "2014", "2015", "2016", "2017"],
    "Brutus HDPTO Deluxe Base": ["2015", "2016", "2017", "2018"],
    "Centurion Base": ["1980", "1981", "1982"],
    "Classic Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Classic Touring Base": [
      "1993",
      "1994",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Cutlass 440 Base": ["1981", "1982"],
    "Diesel (455cc) Base": ["1999", "2000", "2001", "2002"],
    "Freedom Base": ["2002", "2003", "2004"],
    "Frontier Classic Base": ["2003", "2004"],
    "Frontier Touring Base": ["2003", "2004", "2005"],
    "FS IQ Touring Base": ["2007", "2008", "2009"],
    "FS IQ Widetrack Base": ["2011", "2012", "2013"],
    "FST IQ Cruiser Base": ["2007", "2008"],
    "FST IQ Touring Base": ["2007", "2008", "2009", "2010"],
    "FST Switchback Base": ["2006", "2007"],
    "Galaxy 440 Base": ["1980", "1981"],
    "Gemini 244 Base": ["1980", "1981"],
    "General 1000 EPS Base": ["2016", "2017", "2018", "2019"],
    "General 1000 EPS Deluxe Base": ["2016", "2017", "2018", "2019"],
    "General 1000 EPS Hunter Edition Base": ["2017", "2018", "2019"],
    "General 1000 EPS Premium Base": ["2018", "2019"],
    "General 1000 EPS Ride Command Edition Base": ["2017", "2018", "2019"],
    "General 4 1000 EPS Base": ["2017", "2018", "2019"],
    "General 4 1000 EPS Ride Command Edition Base": ["2018", "2019"],
    "Genesis Base": ["1999", "2000", "2001", "2002"],
    "Genesis FFI Base": ["1999", "2000"],
    "Genesis I Base": ["2002", "2003", "2004"],
    "Hawkeye 2x4 Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Hawkeye 4x4 Base": ["2006", "2007"],
    "Hurricane Base": ["1996", "1997"],
    "IQ Turbo Dragon Base": ["2009", "2010"],
    "LITE Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "LITE Deluxe Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "LITE GT Base": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    "Longtrak Base": ["1985", "1986", "1987", "1988"],
    "Longtrak w/ Reverse Base": ["1986", "1987"],
    "M1400 Base": ["2015", "2016"],
    "Magnum 325 2X4 Base": ["2000", "2001", "2002"],
    "Magnum 325 4X4 Base": ["2000", "2001", "2002"],
    "Magnum 330 2X4 Base": ["2003", "2004", "2005"],
    "Magnum 330 4X4 Base": ["2003", "2004", "2005", "2006"],
    "Magnum 425 2X4 Base": ["1995", "1996", "1997", "1998"],
    "Magnum 425 4X4 Base": ["1995", "1996", "1997", "1998"],
    "Magnum 425 6X6 Base": ["1996", "1997"],
    "Magnum 500 4X4 Base": ["1999", "2000", "2001", "2002", "2003"],
    "MSX 140 Base": ["2003", "2004"],
    "Octane Base": ["2002", "2003", "2004"],
    "Outlaw 110 EFI Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlaw 450 Mxr Base": ["2008", "2009", "2010"],
    "Outlaw 50 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Outlaw 500 Base": ["2006", "2007"],
    "Outlaw 525 Irs Base": ["2007", "2008", "2009", "2010", "2011"],
    "Outlaw 525 S Base": ["2008", "2009", "2010"],
    "Outlaw 90 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Phoenix 200 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Predator 50 Base": ["2004", "2005", "2006", "2007"],
    "Predator 500 Base": ["2003", "2004", "2005", "2006", "2007"],
    "Predator 90 Base": ["2003", "2004", "2005", "2006"],
    "PRO 1200 Base": ["2000", "2001"],
    "PRO 785 Base": ["1999", "2000"],
    "PRO XD 2000D 2WD Base": ["2019", "2020"],
    "PRO XD 2000D AWD Base": ["2019", "2020"],
    "PRO XD 4000D AWD Base": ["2019", "2020"],
    "Ranger 150 EFI Base": ["2018", "2019", "2020"],
    "Ranger 2x4 425 Base": ["2001", "2002", "2003", "2004"],
    "Ranger 2x4 500 Base": ["2005", "2006", "2007", "2008", "2009"],
    "Ranger 4x4 400 Base": ["2010", "2011", "2012", "2013", "2014"],
    "Ranger 4x4 500 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Ranger 4x4 500 EFI Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Ranger 500 Base": ["2017", "2018", "2019", "2020"],
    "Ranger 500 Crew Base": ["2011", "2012", "2013"],
    "Ranger 500 EFI Base": ["2012", "2013"],
    "Ranger 500 EFI LE Base": ["2012", "2013"],
    "Ranger 570 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Ranger 570 Crew Base": ["2014", "2015"],
    "Ranger 570 EPS Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Ranger 570 EPS Full-Size Base": ["2015", "2016"],
    "Ranger 570 Full-Size Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Ranger 570-4 Crew Base": ["2016", "2017"],
    "Ranger 570-4 Crew EPS Base": ["2016", "2017"],
    "Ranger 570-6 Crew Base": ["2016", "2017"],
    "Ranger 6x6 500 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Ranger 6x6 700 EFI Base": ["2006", "2007", "2008", "2009"],
    "Ranger 6x6 800 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Ranger 800 Crew Base": ["2010", "2011", "2012", "2013", "2014"],
    "Ranger 800 Crew EPS Base": ["2010", "2011", "2012"],
    "Ranger 800 Crew EPS LE Base": ["2012", "2013"],
    "Ranger 800 EFI Base": ["2013", "2014"],
    "Ranger 800 EFI EPS LE Base": ["2013", "2014"],
    "Ranger 800 EFI Mid-Size Base": ["2013", "2014"],
    "Ranger 800 HD EPS Base": ["2011", "2012"],
    "Ranger 800 XP Base": ["2010", "2011", "2012"],
    "Ranger 800 XP EPS Base": ["2010", "2011", "2012"],
    "Ranger 900 Crew Base": ["2014", "2015"],
    "Ranger 900 Crew EPS Base": ["2014", "2015"],
    "Ranger 900 XP Base": ["2013", "2014", "2015", "2016", "2017"],
    "Ranger 900 XP EPS Base": ["2013", "2014", "2015", "2016", "2017"],
    "Ranger 900 XP EPS Browning LE Base": ["2013", "2014"],
    "Ranger 900 XP EPS Hunter Deluxe Edition Base": ["2015", "2016"],
    "Ranger 900 XP EPS Hunter Edition Base": ["2015", "2016"],
    "Ranger 900 XP EPS LE Base": ["2013", "2014", "2015"],
    "Ranger 900 XP EPS Northstar Edition Base": ["2015", "2016"],
    "Ranger 900-6 Crew Base": ["2015", "2016"],
    "Ranger 900-6 Crew EPS Base": ["2015", "2016"],
    "Ranger Crew 570-4 Base": ["2018", "2019", "2020"],
    "Ranger Crew 570-4 EPS Base": ["2018", "2019"],
    "Ranger Crew 570-6 Base": ["2018", "2019", "2020"],
    "Ranger Crew 700 Base": ["2008", "2009"],
    "Ranger Crew Diesel Base": ["2012", "2013", "2014", "2016", "2017", "2018"],
    "Ranger Crew XP 1000 EPS Base": ["2017", "2018", "2019"],
    "Ranger Crew XP 1000 EPS High Lifter Edition Base": [
      "2017",
      "2018",
      "2019",
    ],
    "Ranger Crew XP 1000 EPS Northstar HVAC Edition Base": [
      "2017",
      "2018",
      "2019",
    ],
    "Ranger Crew XP 900 Base": ["2017", "2018", "2019"],
    "Ranger Crew XP 900 EPS Base": ["2017", "2018", "2019"],
    "Ranger Diesel Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Ranger Diesel HST Base": ["2014", "2015"],
    "Ranger Diesel HST Deluxe Base": ["2014", "2015"],
    "Ranger ETX Base": ["2015", "2016"],
    "Ranger MVRS 700 4x4 Base": ["2007", "2008"],
    "Ranger RZR 170 Base": ["2009", "2010", "2011", "2012", "2013"],
    "Ranger RZR 4 800 Base": ["2012", "2013"],
    "Ranger RZR 4 800 Gordon Edition Base": ["2010", "2011", "2012"],
    "Ranger RZR 570 Base": ["2012", "2013"],
    "Ranger RZR 800 Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Ranger RZR 800 EPS Base": ["2010", "2011"],
    "Ranger RZR 800 EPS LE Base": ["2012", "2013"],
    "Ranger RZR 800 LE Base": ["2012", "2013"],
    "Ranger RZR 800 S Base": ["2009", "2010", "2011", "2012", "2013"],
    "Ranger RZR 800 S LE Base": ["2012", "2013"],
    "Ranger TM 650 Base": ["2004", "2005", "2006"],
    "Ranger XP 1000 EPS Base": ["2017", "2018", "2019"],
    "Ranger XP 1000 EPS High Lifter Edition Base": ["2017", "2018", "2019"],
    "Ranger XP 1000 EPS Northstar HVAC Edition Base": ["2017", "2018", "2019"],
    "Ranger XP 700 Base": ["2005", "2006", "2007", "2008", "2009"],
    "Ranger XP 900 Base": ["2018", "2019"],
    "Ranger XP 900 EPS Base": ["2018", "2019"],
    "RZR 170 EFI Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "RZR 4 900 EPS Base": ["2015", "2016", "2017"],
    "RZR 570 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "RZR 570 EPS Base": ["2017", "2018", "2019"],
    "RZR 570 EPS Trail Base": ["2015", "2016"],
    "RZR 900 Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "RZR 900 EPS Base": ["2017", "2018", "2019"],
    "RZR 900 EPS Trail Base": ["2015", "2016"],
    "RZR 900 EPS XC Edition Base": ["2016", "2017"],
    "RZR S 1000 EPS Base": ["2016", "2017", "2018", "2019", "2020"],
    "RZR S 900 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "RZR S 900 EPS Base": ["2015", "2016", "2017", "2018", "2019"],
    "RZR S4 1000 EPS Base": ["2019", "2020"],
    "Sawtooth Base": ["2006", "2007"],
    "Scrambler 1000 XP Base": ["2016", "2017", "2018"],
    "Scrambler 1000 XP EPS Base": ["2014", "2015"],
    "Scrambler 250 Base": ["1985", "1986"],
    "Scrambler 400 2X4 Base": ["2000", "2001", "2002"],
    "Scrambler 400 4X4 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Scrambler 50 Base": ["2001", "2002", "2003"],
    "Scrambler 500 2X4 Base": ["2001", "2002"],
    "Scrambler 500 4X4 Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Scrambler 850 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Scrambler 850 XP HO Base": ["2013", "2014"],
    "Scrambler 850 XP HO EPS LE Base": ["2013", "2014"],
    "Scrambler 90 Base": ["2001", "2002", "2003"],
    "SL 650 Base": ["1992", "1993", "1994", "1995"],
    "SL 700 Base": ["1996", "1997"],
    "SL 750 Base": ["1993", "1994", "1995"],
    "SL 780 Base": ["1996", "1997"],
    "SL 900 Base": ["1996", "1997"],
    "SLH Base": ["1998", "1999", "2000", "2001"],
    "Slingshot Grand Touring Base": ["2019", "2020"],
    "Slingshot S Base": ["2018", "2019", "2020"],
    "SLT 700 Base": ["1996", "1997"],
    "SLT 750 Base": ["1994", "1995"],
    "SLT 780 Base": ["1996", "1997"],
    "SLTH Base": ["1998", "1999"],
    "SLTX Base": ["1996", "1997", "1998", "1999"],
    "SLX Base": ["1999", "2000", "2001"],
    "SLX 780 Base": ["1995", "1996"],
    "SLX PRO 785 Base": ["1997", "1998"],
    "Sport Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
    ],
    "Sport 400L Base": ["1994", "1995", "1996", "1997", "1998", "1999"],
    "Sport GT Base": ["1990", "1991", "1992"],
    "Sport Touring Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Sportsman 1000 Touring XP Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman 1000 XP Base": ["2015", "2016", "2017", "2018", "2019"],
    "Sportsman 1000 XP High Lifter Edition Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman 1000 XP Hunter Edition Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman 110 EFI Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Sportsman 300 Base": ["2008", "2009", "2010"],
    "Sportsman 335 Base": ["1998", "1999", "2000"],
    "Sportsman 400 Base": ["2001", "2002", "2003", "2004", "2005"],
    "Sportsman 400 4X4 Base": ["1993", "1994", "1995", "1996"],
    "Sportsman 400 HO Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Sportsman 400 HO South Edition Base": ["2013", "2014"],
    "Sportsman 450 Base": ["2006", "2007"],
    "Sportsman 450 HO Base": ["2016", "2017", "2018", "2019", "2020"],
    "Sportsman 450 HO EPS Base": ["2016", "2017", "2018", "2019", "2020"],
    "Sportsman 450 HO Utility Edition Base": ["2017", "2018", "2019"],
    "Sportsman 500 4X4 Base": ["1996", "1997", "1998", "1999", "2000"],
    "Sportsman 500 6x6 Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Sportsman 500 Efi Base": ["2006", "2007", "2008", "2009"],
    "Sportsman 500 EFI Touring Base": ["2008", "2009", "2010"],
    "Sportsman 500 EFI X2 Base": ["2006", "2007", "2008", "2009"],
    "Sportsman 500 HO Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Sportsman 500 HO Touring Base": ["2010", "2011", "2012", "2013"],
    "Sportsman 500 Rse Base": ["1999", "2000"],
    "Sportsman 550 Base": ["2012", "2013"],
    "Sportsman 550 EFI Base": ["2010", "2011"],
    "Sportsman 550 EFI Touring w/ EPS Base": ["2010", "2011"],
    "Sportsman 550 EFI w/ EPS Base": ["2010", "2011"],
    "Sportsman 550 EPS Base": ["2012", "2013", "2014"],
    "Sportsman 550 EPS Browning LE Base": ["2011", "2012", "2013", "2014"],
    "Sportsman 550 Touring EPS Base": ["2012", "2013", "2014"],
    "Sportsman 550 X2 Base": ["2010", "2011", "2012", "2013"],
    "Sportsman 570 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman 570 6x6 Base": ["2019", "2020"],
    "Sportsman 570 Big Boss 6x6 EPS Base": ["2017", "2018"],
    "Sportsman 570 EPS Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman 570 EPS Utility Edition Base": ["2017", "2018", "2019"],
    "Sportsman 570 SP Base": ["2015", "2016", "2017", "2018", "2019"],
    "Sportsman 570 SP Hunters Edition Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Sportsman 570 Touring Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman 570 Touring EPS Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman 570 Touring SP Base": ["2015", "2016", "2017", "2018", "2019"],
    "Sportsman 570 X2 EPS Base": ["2015", "2016", "2017", "2018", "2019"],
    "Sportsman 600 Base": ["2003", "2004", "2005"],
    "Sportsman 700 Base": ["2002", "2003", "2004", "2005", "2006"],
    "Sportsman 700 Efi Base": ["2004", "2005", "2006", "2007"],
    "Sportsman 700 MV Base": ["2006", "2007"],
    "Sportsman 800 6x6 Big Boss Base": ["2012", "2013", "2014"],
    "Sportsman 800 EFI Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Sportsman 800 EFI 6x6 Big Boss Base": ["2009", "2010", "2011"],
    "Sportsman 800 EFI HO Base": ["2008", "2009", "2010"],
    "Sportsman 800 EFI Touring Base": ["2008", "2009"],
    "Sportsman 800 EFI X2 Base": ["2007", "2008", "2009"],
    "Sportsman 850 Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Sportsman 850 EFI Touring EPS Base": ["2010", "2011"],
    "Sportsman 850 EFI XP Base": ["2009", "2010", "2011"],
    "Sportsman 850 EFI XP w/ EPS Base": ["2009", "2010", "2011"],
    "Sportsman 850 High Lifter Edition Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Sportsman 850 HO Touring EPS Base": ["2012", "2013", "2014"],
    "Sportsman 850 HO XP Base": ["2012", "2013"],
    "Sportsman 850 HO XP EPS Base": ["2012", "2013", "2014"],
    "Sportsman 850 HO XP EPS Browning LE Base": ["2012", "2013", "2014"],
    "Sportsman 850 SP Base": ["2015", "2016", "2017", "2018", "2019"],
    "Sportsman 850 Touring SP Base": ["2015", "2016", "2017", "2018", "2019"],
    "Sportsman 90 Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Sportsman ACE Base": ["2014", "2015"],
    "Sportsman Forest 500 Base": ["2011", "2012", "2013"],
    "Sportsman Forest 550 Base": ["2011", "2012", "2013", "2014"],
    "Sportsman Forest 800 Base": ["2012", "2013", "2014"],
    "Sportsman Forest 800 6x6 Base": ["2012", "2013", "2014"],
    "Sportsman Forest 850 Base": ["2011", "2012", "2013", "2014"],
    "Sportsman Forest Tractor 500 Base": ["2011", "2012", "2013"],
    "Sprint Base": ["1986", "1987"],
    "Sprint ES Base": ["1986", "1987", "1988", "1989", "1990"],
    "SS Base": ["1985", "1986"],
    "Star Base": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
    ],
    "Star Trak Base": ["1987", "1988", "1989", "1990"],
    "StarLite Base": ["1991", "1992", "1993", "1994", "1995"],
    "StarLite GT Base": ["1993", "1994"],
    "Storm Base": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Storm RMK Base": ["1996", "1997"],
    "Storm SKS Base": ["1993", "1994", "1995", "1996"],
    "Super Sport Base": [
      "1983",
      "1984",
      "1985",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Super Sport M-10 Base": ["2003", "2004"],
    "Trail Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Trail Blazer 250 Base": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Trail Blazer 330 Base": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Trail Boss 250 Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Trail Boss 250 2X4 Base": ["1988", "1989", "1990", "1991", "1992", "1993"],
    "Trail Boss 250 4X4 Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Trail Boss 250R/Es Base": ["1985", "1986", "1987", "1988"],
    "Trail Boss 325 Base": ["1999", "2000", "2001", "2002"],
    "Trail Boss 330 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Trail Boss 350L 2X4 Base": ["1990", "1991", "1992", "1993"],
    "Trail Boss 350L 4X4 Base": ["1990", "1991", "1992", "1993"],
    "Trail Deluxe Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Trail ES Base": ["1987", "1988", "1989"],
    "Trail RMK Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Trail SKS Base": ["1987", "1988", "1989"],
    "Trail SP Base": ["1988", "1989"],
    "Trail Super Trak Base": ["1989", "1990", "1991"],
    "Trail Touring Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "Trail Touring DLX Base": ["2005", "2006", "2007", "2008", "2009"],
    "Tran Sport Base": ["1996", "1997", "1998", "1999"],
    "Turbo IQ Base": ["2011", "2012"],
    "Turbo IQ LX Base": ["2011", "2012"],
    "Turbo IQ LXT Base": ["2011", "2012", "2013", "2014"],
    "Turbo SwitchBack Base": ["2008", "2009"],
    "TX-L 340 Base": ["1980", "1981", "1982"],
    "Ultra Base": ["1997", "1998"],
    "Ultra SP Base": ["1996", "1997"],
    "Ultra Touring Base": ["1997", "1998"],
    "Virage Base": ["2000", "2001", "2002", "2003", "2004"],
    "Virage I Base": ["2002", "2003", "2004"],
    "Virage TX Base": ["2000", "2001"],
    "Virage TXI Base": ["2001", "2002"],
    "Wide Track IQ Base": ["2009", "2010"],
    "Wide Trak Base": ["1991", "1992", "1993"],
    "Wide Trak GT Base": ["1993", "1994", "1995", "1996", "1997"],
    "Wide Trak LX Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "XCF Base": ["1997", "1998", "1999", "2000"],
    "XLT Base": ["1993", "1994", "1995", "1996", "1997"],
    "XLT Classic Base": ["1998", "1999"],
    "XLT LTD Base": ["1997", "1998"],
    "XLT RMK Base": ["1995", "1996", "1997"],
    "XLT SKS Base": ["1993", "1994", "1995", "1996", "1997"],
    "XLT SP Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "XLT Touring Base": ["1995", "1996", "1997", "1998", "1999"],
    "Xpedition 325 Base": ["2000", "2001", "2002"],
    "Xpedition 425 Base": ["2000", "2001", "2002"],
    "Xplorer 250 4X4 Base": ["2000", "2001", "2002"],
    "Xplorer 300 4X4 Base": ["1996", "1997", "1998", "1999", "2000", "2001"],
    "Xplorer 400 4X4 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Xpress 300 Base": ["1996", "1997", "1998", "1999"],
    "Xpress 400L Base": ["1996", "1997"],
    '850 RMK Khaos Axys 165 2.75"': ["2022", "2023"],
    '1000 Indy Adventure Prostar S4 137"': ["2023", "2024"],
    '1000 Indy XC Prostar S4 129"': ["2023", "2024"],
    '1000 Indy XC Prostar S4 137"': ["2023", "2024"],
    '1000 Titan Adventure Prostar S4 155"': ["2023", "2024"],
    '1000 Voyageur Prostar S4 146"': ["2023", "2024"],
    '900 Indy VR1 Patriot Boost 137"': ["2023", "2024"],
    "Sportsman Touring 850 EPS LE": ["2012", "2013", "2014"],
    "Outlaw 70 EFI Base": ["2021", "2022", "2023", "2024"],
    "PRO XD Full Size Diesel": ["2022", "2023", "2024"],
    "PRO XD Full Size Diesel Crew": ["2022", "2023", "2024"],
    "RZR 200 EFI": ["2022", "2023", "2024"],
    "Pro XD Mid-Size Gas": ["2023", "2024"],
    "Ranger Crew XP 1000 Northstar Trail Boss EPS": ["2023", "2024"],
    "120 XC SP": ["2001", "2002", "2003"],
    "General XP 4 1000 Deluxe Base": ["2020", "2021"],
  },
  "Aston Martin": {
    "DB11 Base": ["2017", "2018", "2019", "2020"],
    "DB6 Base": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "DB6 Radford": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "DB6 Vantage": ["1965", "1966", "1967", "1968", "1969"],
    "DB6 Volante": ["1965", "1966", "1967", "1968", "1969", "1970"],
    "DBS Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "DBS Vantage": ["1967", "1968", "1969", "1970", "1971"],
    "Vantage Base": ["1972", "1973", "1974", "2018", "2019"],
    "DBS Volante": ["2010", "2011", "2012"],
    "V12 Vantage Base": ["2010", "2011", "2012", "2013"],
    "V12 Vantage S": ["2015", "2016", "2017"],
    "V8 Vantage Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "V8 Vantage GT": ["2015", "2016"],
    "V8 Vantage S": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "DB9 Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "DB9 Volante": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Rapide Base": ["2010", "2011", "2012", "2013"],
    "Rapide S": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Vanquish Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Vanquish Carbon": ["2016", "2017"],
    "Vanquish S": ["2005", "2006"],
    "Vanquish Volante": ["2014", "2015", "2016", "2017", "2018"],
    "DB7 Base": ["1997", "1998"],
    "DB7 GT": ["2003", "2004"],
    "DB7 Vantage": ["2000", "2001", "2002", "2003", "2004"],
    "DB7 Vantage Volante": ["2000", "2001", "2002", "2003", "2004"],
    "DB7 Volante": ["1997", "1998"],
    "DB11 Volante": ["2019", "2020"],
    "DBS Superleggera": ["2019", "2020"],
    "Lagonda Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "V-8 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "V-8 Vantage": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "V-8 Vantage Volante": ["1987", "1988"],
    "V-8 Volante": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "Virage Base": ["1989", "1990", "1991", "1992", "1993", "1994"],
    "Virage Volante": ["1993", "1994"],
    "Zagato Base": ["1987", "1988"],
  },
  Bentley: {
    "Continental GT": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Continental GT Azure": ["2023", "2024"],
    "Continental GT Mulliner": ["2023", "2024"],
    "Continental GT S": ["2023", "2024"],
    "Continental GT Speed": [
      "2008",
      "2009",
      "2010",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2022",
      "2023",
      "2024",
    ],
    "Continental Flying Spur": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
    ],
    "Continental Flying Spur Speed": ["2009", "2010", "2011", "2012", "2013"],
    "Continental GTC": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Continental GTC Speed": [
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Continental Supersports": ["2010", "2011", "2012"],
    "Arnage R": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Arnage RL": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Arnage T": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Azure Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Azure T": ["2009", "2010"],
    "Brooklands Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "2008",
      "2009",
    ],
    "Arnage Red Label": ["2000", "2001", "2002"],
    "Arnage Green Label": ["2000", "2001"],
    "Azure Mulliner": ["1999", "2000", "2001", "2002"],
    "Brooklands LWB": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "Continental GT V8": ["2013", "2014", "2015", "2016", "2017"],
    "Continental GTC V8": ["2013", "2014", "2015", "2016", "2017"],
    "Mulsanne Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Turbo R Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Turbo R LWB": ["1992", "1993", "1994", "1995", "1996", "1997", "1998"],
    "Flying Spur Base": ["2014", "2015", "2016", "2017"],
    "Flying Spur V8": ["2015", "2016", "2017", "2018", "2019"],
    "Bentayga Mulliner": ["2018", "2019"],
    "Bentayga V8": ["2019", "2020"],
    "Continental Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Continental GT V8 S": ["2015", "2016", "2017"],
    "Continental GTC V8 S": ["2015", "2016", "2017"],
    "Continental R": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Continental SC": ["1999", "2000"],
    "Continental T": ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "Corniche Base": ["1982", "1983", "1984"],
    "Eight Base": ["1986", "1987", "1988", "1989", "1990", "1991"],
    "Flying Spur V8 S": ["2017", "2018", "2019"],
    "Flying Spur W12": ["2018", "2019", "2020"],
    "Mulsanne L": ["1985", "1986"],
    "Mulsanne S": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "Mulsanne Speed": ["2016", "2017", "2018", "2019", "2020"],
    "Mulsanne Turbo": ["1982", "1983"],
    "Flying Spur W12 S": ["2018", "2019"],
  },
  Freightliner: {
    "Sprinter 2500 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Sprinter 3500 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Sprinter 3500XD Base": ["2018", "2019", "2020", "2021"],
    "Sprinter 1500 Base": ["2019", "2020"],
  },
  Lamborghini: {
    "Diablo VT 6.0": ["2000", "2001"],
    "Diablo Base": ["1990", "1991", "1992", "1993"],
    "Diablo SV": ["1998", "1999"],
    "Diablo VT": ["1994", "1995", "1996", "1997", "1998", "1999", "2000"],
    "Murcielago Base": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "Murcielago LP640": ["2006", "2007", "2008", "2009", "2010"],
    "Gallardo Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "Gallardo Spyder": ["2006", "2007", "2008", "2009"],
    "Gallardo LP550-2": ["2011", "2012", "2013", "2014"],
    "Gallardo LP560-4": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Gallardo LP560-4 Spyder": ["2010", "2011", "2012", "2013", "2014"],
    "Gallardo LP570-4 Performante Spyder": ["2011", "2012", "2013", "2014"],
    "Gallardo LP570-4 Superleggera": ["2011", "2012", "2013", "2014"],
    "Countach 5000 quattrovalvole": ["1985", "1986", "1987", "1988", "1989"],
    "Countach LP500S": ["1982", "1983", "1984"],
    "Jalpa Base": ["1982", "1983", "1984", "1985", "1986", "1987", "1988"],
    "Urraco P300": ["1974", "1975", "1976"],
    "Aventador LP700-4": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Aventador LP700-4 Roadster": ["2013", "2014", "2015", "2016", "2017"],
    "Countach LP400S": ["1981", "1982"],
    "Gallardo LP550-2 Spyder": ["2012", "2013", "2014"],
    "Gallardo Superleggera": ["2007", "2008"],
    "Huracan LP580-2": ["2017", "2018", "2019"],
    "Huracan LP610-4": ["2015", "2016", "2017", "2018", "2019"],
    "LM American Base": ["1991", "1992", "1993"],
    "LM002 Base": ["1986", "1987", "1988", "1989", "1990"],
    "Urus Base": ["2019", "2020", "2021"],
  },
  "Rolls-Royce": {
    "Dawn Base": ["2016", "2017", "2018", "2019", "2020"],
    "Ghost Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Ghost EWB": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Phantom Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Phantom Coupe": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Phantom Drophead Coupe": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Phantom EWB": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2018",
      "2019",
      "2020",
    ],
    "Wraith Base": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "Silver Cloud Base": ["1955", "1956", "1957", "1958", "1959"],
    "Camargue Base": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Corniche Base": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "2000",
      "2001",
      "2002",
    ],
    "Corniche II Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Corniche IV Base": ["1993", "1994", "1995"],
    "Cullinan Base": ["2019", "2020"],
    "Silver Dawn Base": ["1995", "1996", "1997"],
    "Silver Seraph Base": ["1999", "2000", "2001", "2002"],
    "Silver Spirit Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
    ],
    "Silver Spirit III": ["1994", "1995"],
    "Silver Spur Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1996",
      "1997",
      "1998",
    ],
    "Silver Spur III": ["1994", "1995"],
    "Silver Shadow Base": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
    ],
  },
  Smart: {
    "Fortwo Brabus": ["2009", "2010"],
    "Fortwo Electric Drive": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Fortwo Passion": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Fortwo Passion Cabrio": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Fortwo Prime": ["2016", "2017"],
    "Fortwo Proxy": ["2016", "2017"],
    "Fortwo Pure": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
  },
  Volvo: {
    "C70 T5": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "S60 2.4": ["2004", "2005"],
    "S60 2.5T": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "S60 R": ["2004", "2005", "2006", "2007"],
    "S60 T5": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "S60 T6": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "S80 3.2": ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "S80 T6": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "S80 V8": ["2007", "2008", "2009", "2010"],
    "V70 2.4": ["2004", "2005", "2006", "2007"],
    "V70 2.5T": ["2004", "2005", "2006", "2007"],
    "V70 3.2": ["2008", "2009", "2010"],
    "V70 R": ["2004", "2005", "2006", "2007"],
    "XC60 3.2": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "XC60 T6": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "XC60 T6 R-Design": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "XC70 3.2": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "XC70 T6": ["2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "XC90 3.2": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "XC90 V8": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "XC90 V8 Sport": ["2007", "2008"],
    "C30 T5": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "C30 T5 R-Design": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "S40 2.4i": ["2006", "2007", "2008", "2009", "2010"],
    "S40 i": ["2004", "2005"],
    "S40 T5": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "S40 T5 R-Design": ["2010", "2011"],
    "V50 2.4i": ["2006", "2007", "2008", "2009", "2010"],
    "V50 T5": ["2005", "2006", "2007", "2008", "2009"],
    "V50 T5 R-Design": ["2010", "2011"],
    "740 Base": ["1989", "1990", "1991", "1992"],
    "740 GL": ["1989", "1990"],
    "740 GLE": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "740 T": ["1991", "1992"],
    "760 Base": ["1989", "1990"],
    "760 GLE": ["1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990"],
    "940 Base": ["1993", "1994", "1995"],
    "940 T": ["1991", "1992", "1993", "1994", "1995"],
    "240 Base": ["1990", "1991", "1992", "1993"],
    "242 Base": ["1976", "1977", "1978", "1979"],
    "242 DL": ["1980", "1981", "1982", "1983", "1984"],
    "242 GLT": ["1981", "1982", "1983", "1984"],
    "244 DL": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "244 GL": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "244 GLT": ["1982", "1983"],
    "245 Base": ["1975", "1976", "1977", "1978", "1984", "1985"],
    "245 DL": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
    "245 GL": ["1982", "1983", "1986", "1987", "1988", "1989"],
    "245 GLT": ["1981", "1982", "1983"],
    "262 C": ["1978", "1979"],
    "264 GL": ["1976", "1977", "1978", "1979", "1980", "1981"],
    "264 GLE": ["1980", "1981", "1982"],
    "265 GL": ["1977", "1978", "1979"],
    "265 GLE": ["1980", "1981"],
    "XC70 Base": ["2004", "2005", "2006", "2007"],
    "XC90 2.5T": ["2004", "2005", "2006"],
    "XC90 T6": ["2003", "2004", "2005"],
    "S60 Polestar": ["2017", "2018"],
    "S60 T5 Dynamic": ["2017", "2018"],
    "S60 T5 Inscription": ["2017", "2018", "2019", "2020", "2021"],
    "S60 T5 Premier": ["2015", "2016"],
    "S60 T6 Platinum": ["2015", "2016"],
    "S60 T6 Polestar": ["2015", "2016"],
    "S60 T6 R-Design": ["2013", "2014", "2015", "2016", "2019", "2020", "2021"],
    "S60 T6 R-Design Platinum": ["2015", "2016", "2017", "2018"],
    "S60 Cross Country T5": ["2017", "2018"],
    "S80 T5": ["2015", "2016"],
    "S90 T5 Momentum": ["2017", "2018", "2019"],
    "S90 T6 Inscription": ["2017", "2018", "2019", "2020", "2021"],
    "S90 T6 Momentum": ["2017", "2018", "2019", "2020", "2021"],
    "S90 T8 Inscription": ["2018", "2019", "2020"],
    "S90 T8 Momentum": ["2018", "2019"],
    "V60 Polestar": ["2017", "2018"],
    "V60 T5": ["2015", "2016", "2017"],
    "V60 T5 Platinum": ["2015", "2016", "2017", "2018"],
    "V60 T5 Premier": ["2015", "2016", "2017", "2018"],
    "V60 T6 Polestar": ["2015", "2016"],
    "V60 T6 R-Design": ["2015", "2016", "2017"],
    "V60 T6 R-Design Platinum": ["2015", "2016"],
    "V60 Cross Country T5": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2020",
      "2021",
      "2022",
    ],
    "V60 Cross Country T5 Platinum": ["2016", "2017", "2018"],
    "V90 T5 Inscription": ["2018", "2019", "2020", "2021"],
    "V90 T5 R-Design": ["2018", "2019", "2020", "2021"],
    "V90 T6 Inscription": ["2018", "2019", "2020", "2021"],
    "V90 T6 R-Design": ["2018", "2019", "2020", "2021"],
    "V90 Cross Country T5": ["2018", "2019"],
    "V90 Cross Country T6": ["2017", "2018", "2019", "2020", "2021"],
    "V90 Cross Country T6 Ocean Race": ["2018", "2019"],
    "XC60 T5": ["2015", "2016"],
    "XC60 T5 Inscription": ["2017", "2018", "2019", "2020", "2021"],
    "XC60 T6 Inscription": ["2017", "2018", "2019", "2020", "2021"],
    "XC70 T5": ["2015", "2016"],
    "XC90 T5 Momentum": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "XC90 T5 R-Design": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "XC90 T6 Inscription": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "XC90 T6 Momentum": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "XC90 T6 R-Design": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "XC90 T8 Excellence": ["2017", "2018", "2019"],
    "XC90 T8 Inscription": ["2016", "2017", "2018", "2019", "2020"],
    "XC90 T8 Momentum": ["2018", "2019", "2020"],
    "XC90 T8 R-Design": ["2016", "2017", "2018", "2019", "2020"],
    "C70 Base": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "S40 Base": ["2000", "2001", "2002", "2003", "2004"],
    "S60 2.4T": ["2001", "2002", "2003"],
    "S60 AWD": ["2002", "2003"],
    "S60 Base": ["2001", "2002", "2003"],
    "S70 AWD": ["1999", "2000"],
    "S70 Base": ["1998", "1999", "2000"],
    "S70 GLT": ["1998", "1999", "2000"],
    "S70 T5": ["1998", "1999", "2000"],
    "S80 2.5T": ["2004", "2005", "2006"],
    "S80 2.5T AWD": ["2004", "2005", "2006"],
    "S80 2.9": ["1999", "2000", "2001", "2002", "2003", "2004"],
    "V40 Base": ["2000", "2001", "2002", "2003", "2004"],
    "V70 2.4T": ["2001", "2002", "2003"],
    "V70 AWD": ["1998", "1999", "2002", "2003"],
    "V70 Base": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "V70 GLT": ["1998", "1999", "2000"],
    "V70 R AWD": ["1999", "2000"],
    "V70 T5": ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "V70 X/C": ["2001", "2002"],
    "V70 X/C AWD": ["1998", "1999", "2000"],
    "XC90 3.2 R-Design": ["2013", "2014"],
    "244 Base": ["1976", "1977", "1978"],
    "XC90 B5 Core": ["2023", "2024"],
    "XC90 B5 Plus": ["2023", "2024"],
    "XC90 B6 Core": ["2023", "2024"],
    "XC90 B6 Plus": ["2023", "2024"],
    "XC90 B6 Ultimate": ["2023", "2024"],
    "XC90 T8 Recharge Core": ["2023", "2024"],
    "XC90 T8 Recharge Inscription": ["2021", "2022"],
    "XC90 T8 Recharge Inscription Expression": ["2021", "2022"],
    "XC90 T8 Recharge Plus": ["2023", "2024"],
    "XC90 T8 Recharge R-Design": ["2021", "2022"],
    "XC90 T8 Recharge Ultimate": ["2023", "2024"],
    "S60 2.5T AWD": ["2004", "2005"],
    "S60 B5 Core": ["2023", "2024"],
    "S60 B5 Plus": ["2023", "2024"],
    "S60 B5 Ultimate": ["2023", "2024"],
    "S60 T5 Momentum": ["2019", "2020", "2021"],
    "S60 T5 R-Design": ["2019", "2020", "2021"],
    "S60 T6 Inscription": ["2019", "2020", "2021"],
    "S60 T6 Momentum": ["2019", "2020", "2021"],
    "S60 T8 Inscription": ["2019", "2020"],
    "S60 T8 Polestar": ["2020", "2021", "2022"],
    "S60 T8 R-Design": ["2019", "2020"],
    "S60 T8 Recharge Core": ["2023", "2024"],
    "S60 T8 Recharge Inscription": ["2021", "2022"],
    "S60 T8 Recharge Plus": ["2023", "2024"],
    "S60 T8 Recharge Polestar": ["2021", "2022", "2023"],
    "S60 T8 Recharge R-Design": ["2021", "2022"],
    "S60 T8 Recharge R-Design Expression": ["2021", "2022"],
    "S60 T8 Recharge Ultimate": ["2023", "2024"],
    "S90 B6 Plus": ["2023", "2024"],
    "S90 B6 Ultimate": ["2023", "2024"],
    "S90 T6 R-Design": ["2020", "2021"],
    "S90 T8 Recharge Inscription": ["2021", "2022"],
    "S90 T8 Recharge R-Design": ["2021", "2022"],
    "S90 T8 Recharge Ultimate": ["2023", "2024"],
    "V60 T5 Inscription": ["2020", "2021"],
    "V60 T5 Momentum": ["2019", "2020", "2021"],
    "V60 T5 R-Design": ["2019", "2020", "2021"],
    "V60 T8 Recharge Polestar": ["2021", "2022", "2023", "2024"],
    "XC40 B5 Core": ["2023", "2024"],
    "XC40 B5 Plus": ["2023", "2024"],
    "XC40 B5 Ultimate": ["2023", "2024"],
    "XC40 T4 Inscription": ["2019", "2020", "2021", "2022"],
    "XC40 T4 Momentum": ["2019", "2020", "2021", "2022"],
    "XC40 T4 R-Design": ["2019", "2020", "2021", "2022"],
    "XC40 T5 Inscription": ["2019", "2020", "2021", "2022"],
    "XC40 T5 Momentum": ["2019", "2020", "2021", "2022"],
    "XC40 T5 R-Design": ["2019", "2020", "2021", "2022"],
    "XC60 B5 Core": ["2023", "2024"],
    "XC60 B5 Plus": ["2023", "2024"],
    "XC60 B5 Ultimate": ["2023", "2024"],
    "XC60 T5 Momentum": ["2018", "2019", "2020", "2021"],
    "XC60 T5 R-Design": ["2018", "2019", "2020", "2021"],
    "XC60 T6 Momentum": ["2018", "2019", "2020", "2021"],
    "XC60 T8 Inscription": ["2018", "2019", "2020"],
    "XC60 T8 Momentum": ["2018", "2019", "2020"],
    "XC60 T8 R-Design": ["2018", "2019", "2020"],
    "XC60 T8 Recharge Core": ["2023", "2024"],
    "XC60 T8 Recharge Inscription": ["2021", "2022"],
    "XC60 T8 Recharge Inscription Expression": ["2021", "2022"],
    "XC60 T8 Recharge Plus": ["2023", "2024"],
    "XC60 T8 Recharge Polestar": ["2021", "2022", "2023", "2024"],
    "XC60 T8 Recharge R-Design": ["2021", "2022"],
    "XC60 T8 Recharge Ultimate": ["2023", "2024"],
    "850 Base": ["1994", "1995", "1996", "1997"],
    "850 GLT": ["1993", "1994", "1995", "1996", "1997"],
    "850 R": ["1996", "1997"],
    "850 Turbo": ["1994", "1995", "1996"],
    "780 Base": ["1987", "1988", "1989", "1990", "1991"],
    "960 Base": ["1992", "1993", "1994", "1995", "1996", "1997"],
    "S90 Base": ["1997", "1998"],
    "V90 Base": ["1997", "1998"],
    "142 Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "142 E": ["1971", "1972"],
    "142 S": ["1967", "1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "144 Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "144 S": ["1967", "1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "164 Base": ["1969", "1970", "1971", "1972"],
    "164 E": ["1973", "1974"],
    "164 S": ["1969", "1970", "1971", "1972", "1973", "1974"],
    "145 Base": ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "145 S": ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "1800 E": ["1970", "1971", "1972"],
    "V60 Cross Country B5 Plus": ["2023", "2024"],
    "V60 Cross Country B5 Ultimate": ["2023", "2024"],
    "V90 Cross Country B6 Plus": ["2023", "2024"],
    "V90 Cross Country B6 Ultimate": ["2023", "2024"],
  },
  Tesla: {
    "3 Long Range": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "3 Performance": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "X 100D": ["2018", "2019"],
    "X 75D": ["2017", "2018", "2019"],
    "X 90D": ["2016", "2017"],
    "X Base": ["2022", "2023"],
    "X Long Range Plus": ["2020", "2021"],
    "X P100D": ["2017", "2018", "2019"],
    "X Performance": ["2020", "2021"],
    "X Plaid": ["2021", "2022", "2023", "2024"],
    "S 100D": ["2018", "2019"],
    "S 75D": ["2017", "2018", "2019"],
    "S Long Range Plus": ["2020", "2021"],
    "S P100D": ["2017", "2018", "2019"],
    "S Performance": ["2020", "2021"],
    "Y Long Range": ["2020", "2021", "2022", "2023", "2024"],
    "Y Performance": ["2020", "2021", "2022", "2023", "2024"],
    "S 90D": ["2016", "2017"],
    "S Base": ["2012", "2013", "2014", "2015", "2022", "2023"],
    "S Signature": ["2014", "2015"],
    "3 Base": ["2017", "2018", "2019", "2022", "2023", "2024"],
    "3 Standard Plus": ["2020", "2021"],
    "S Plaid": ["2021", "2022", "2023", "2024"],
    "Roadster Base": ["2008", "2009", "2010"],
  },
  Bricklin: {
    "SV-1 Base": ["1974", "1975", "1976"],
  },
  Isuzu: {
    "Hombre S": ["1996", "1997", "1998", "1999", "2000"],
    "Hombre XS": ["1996", "1997", "1998", "1999", "2000"],
    "Amigo S": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1998",
      "1999",
      "2000",
    ],
    "Amigo XS": ["1989", "1990", "1991", "1992", "1993", "1994"],
    "Pickup Base": ["1981", "1982", "1983", "1984", "1985", "1986", "1987"],
    "Pickup DLX": ["1981", "1982", "1983", "1984", "1985", "1986", "1987"],
    "Pickup LS": ["1986", "1987", "1988", "1989", "1990", "1991", "1992"],
    "Pickup LX": ["1984", "1985"],
    "Pickup S": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Trooper Base": ["1984", "1985"],
    "Trooper DLX": ["1986", "1987"],
    "Trooper LS": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "2000",
      "2001",
      "2002",
    ],
    "Oasis LS": ["1996", "1997", "1998", "1999"],
    "Oasis S": ["1996", "1997", "1998", "1999"],
    "Rodeo LS": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Rodeo S": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Rodeo XS": ["1991", "1992"],
    "Ascender Limited": ["2003", "2004", "2005"],
    "Ascender LS": ["2003", "2004", "2005", "2006"],
    "Ascender S": ["2004", "2005", "2007", "2008"],
    "Trooper RS": ["1989", "1990", "1993", "1994", "1995"],
    "Trooper S": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Trooper XS": ["1988", "1989", "1990", "1991"],
    "i-370 LS": ["2007", "2008"],
    "Impulse RS": ["1991", "1992"],
    "Impulse XS": ["1990", "1991", "1992"],
    "Stylus S": ["1991", "1992", "1993"],
    "i-290 S": ["2007", "2008"],
    "Rodeo LSE": ["1999", "2000", "2001", "2002", "2003"],
    "Rodeo S V6": ["2001", "2002", "2003"],
    "Rodeo Sport S": ["2001", "2002", "2003"],
    "Rodeo Sport S V6": ["2001", "2002", "2003"],
    "Trooper Limited": ["2000", "2001", "2002"],
    "Axiom Base": ["2002", "2003"],
    "Axiom XS": ["2002", "2003", "2004"],
    "Pickup 1 Ton": ["1988", "1989", "1990", "1991", "1992"],
    "Pickup XS": ["1989", "1990"],
    "I-Mark Base": ["1981", "1982", "1983", "1984", "1985", "1986", "1987"],
    "I-Mark S": ["1987", "1988", "1989"],
    "I-Mark XS": ["1988", "1989"],
    "VehiCROSS Base": ["1999", "2000", "2001"],
    "I-Mark DLX": ["1981", "1982", "1983", "1984", "1985"],
    "I-Mark LS": ["1982", "1983"],
    "Impulse Base": ["1983", "1984", "1985", "1986", "1987", "1988", "1989"],
  },
  Merkur: {
    "XR4Ti Base": ["1985", "1986", "1987", "1988", "1989"],
    "Scorpio Base": ["1988", "1989"],
  },
  "American Motors": {
    "Ambassador Brougham": ["1971", "1972", "1973", "1974"],
    "Ambassador Custom": ["1958", "1959", "1960", "1961", "1962"],
    "Ambassador DPL": ["1966", "1967", "1968", "1969", "1970", "1971"],
    "Ambassador SST": ["1968", "1969", "1970", "1971", "1972"],
    "Ambassador Super": ["1958", "1959", "1960", "1961"],
    "American 440": ["1965", "1966", "1967", "1968"],
    "American Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
    ],
    "American Custom": ["1960", "1961", "1962"],
    "American Rogue": ["1967", "1968"],
    "American Super": ["1958", "1959", "1960", "1961"],
    "Classic 660": ["1964", "1965"],
    "Classic 770": ["1963", "1964", "1965", "1966"],
    "Classic Base": ["1961", "1962", "1963", "1964", "1965", "1966"],
    "Gremlin Base": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Gremlin Custom": ["1976", "1977", "1978"],
    "Hornet Base": ["1970", "1971", "1973", "1974", "1975", "1976", "1977"],
    "Hornet Sportabout": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
    ],
    "Hornet SST": ["1970", "1971", "1972"],
    "Javelin AMX": ["1971", "1972", "1973", "1974"],
    "Javelin Base": ["1968", "1969", "1970", "1971", "1972", "1973", "1974"],
    "Javelin SST": ["1968", "1969", "1970", "1971", "1972"],
    "Matador Base": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
    ],
    "Pacer Base": ["1975", "1976", "1977", "1978"],
    "Rambler Base": ["1959", "1960"],
    "Rambler Custom": ["1958", "1959", "1960"],
    "Rambler Super": ["1958", "1959", "1960"],
    "Rebel 770": ["1967", "1968"],
    "Rebel Base": ["1959", "1960", "1961", "1966", "1967", "1969", "1970"],
    "Rebel Custom": ["1958", "1959", "1960"],
    "Rebel SST": ["1967", "1968", "1969", "1970"],
    "Rebel Super": ["1958", "1959", "1960"],
    "Concord Base": ["1978", "1979", "1980", "1981", "1982", "1983"],
    "Concord DL": ["1979", "1980", "1981", "1982", "1983"],
    "Concord Limited": ["1979", "1980", "1981", "1982", "1983"],
    "Eagle Base": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
    ],
    "Eagle DL Kammback": ["1981", "1982"],
    "Eagle DL SX4": ["1981", "1982", "1983"],
    "Eagle Kammback": ["1981", "1982"],
    "Eagle Limited": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
    ],
    "Eagle SX4": ["1981", "1982", "1983"],
    "Spirit Base": ["1979", "1980", "1981", "1982"],
    "Spirit DL": ["1980", "1981", "1982", "1983"],
    "AMX Base": ["1968", "1969", "1970", "1978", "1979", "1980"],
    "Pacer DL": ["1979", "1980"],
    "Pacer Limited": ["1979", "1980"],
    "Ambassador 990": ["1965", "1966", "1967"],
    "Ambassador Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
    ],
    "Marlin Base": ["1965", "1966", "1967"],
    "Classic Custom": ["1961", "1962"],
    "Custom Base": ["1961", "1962"],
    "Deluxe Base": ["1961", "1962"],
    "Super Six Base": ["1961", "1962"],
  },
  Austin: {
    "Marina Base": ["1973", "1974", "1975"],
    "Marina GT": ["1973", "1974", "1975"],
    "America Base": ["1968", "1969", "1970", "1971", "1972"],
  },
  Checker: {
    "Taxicab Base": ["1959", "1960", "1961", "1962", "1963", "1964"],
    "Marathon Base": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1980",
      "1981",
      "1982",
    ],
    "Marathon Deluxe": ["1980", "1981", "1982"],
    "Aerobus Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
    ],
    "Marathon Town Custom": ["1963", "1964", "1965", "1966"],
  },
  Edsel: {
    "Ranger Base": ["1958", "1959", "1960"],
    "Villager Base": ["1958", "1959", "1960"],
    "Corsair Base": ["1958", "1959"],
  },
  International: {
    "200 Base": ["1974", "1975"],
    "Scout Base": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
    ],
    "Scout II Base": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
    ],
    "Scout II SS2": ["1978", "1979"],
    "Scout II Terra": ["1976", "1977", "1978", "1979", "1980"],
    "Scout II Traveler": ["1976", "1977", "1978", "1979", "1980"],
    "1110 Base": ["1971", "1972", "1973"],
    "AM120 Base": ["1961", "1962", "1963", "1964", "1965"],
    "1000D Base": ["1969", "1970"],
    "1010 Base": ["1971", "1972", "1973"],
    "1010 Travelall": ["1972", "1973"],
    "1100D Base": ["1969", "1970"],
    "1200D Base": ["1969", "1970"],
    "1210 Base": ["1971", "1972", "1973"],
    "1300D Base": ["1969", "1970"],
    "1310 Base": ["1971", "1972", "1973"],
    "M1100 Base": ["1969", "1970", "1971", "1972"],
    "M1200 Base": ["1969", "1970", "1971", "1972"],
    "M800 Base": ["1969", "1970", "1971"],
    "M800 Post Office Base": ["1969", "1970", "1971", "1972"],
    "MA1200 Base": ["1969", "1970", "1971"],
    "MS1210 Base": ["1972", "1973", "1974"],
  },
  MG: {
    "MGB Base": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "MGB GT": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "MGB MK IV": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "MGB V-8": ["1973", "1974", "1975", "1976"],
    "Midget Base": ["1969", "1970", "1971", "1972", "1973", "1974"],
    "Midget MK IV": ["1975", "1976", "1977", "1978", "1979"],
    "TD Base": ["1950", "1951", "1952", "1953"],
    "TF Base": ["1954", "1955"],
  },
  Opel: {
    "1900 Base": ["1971", "1972", "1973", "1974", "1975"],
    "1900 Rallye": ["1971", "1972"],
    "Manta Base": ["1971", "1972", "1973", "1974", "1975"],
    "Opel GT": ["1970", "1971", "1972", "1973"],
    "Kadett Base": ["1971", "1972"],
  },
  Packard: {
    "200 Base": ["1951", "1952"],
    "200 Deluxe": ["1951", "1952"],
    "250 Base": ["1951", "1952"],
    "300 Base": ["1951", "1952"],
    "Cavalier Base": ["1953", "1954"],
    "Cavalier Caribbean Custom": ["1953", "1954"],
    "Cavalier Mayfair": ["1953", "1954"],
    "Clipper Special": ["1953", "1954"],
    "Custom Eight Base": ["1948", "1949", "1950"],
    "Deluxe Eight Base": ["1948", "1949", "1950"],
    "Patrician Base": ["1951", "1952"],
    "Patrician Corporate": ["1953", "1954"],
    "Patrician Executive": ["1953", "1954"],
    "Standard Eight Base": ["1948", "1949", "1950"],
    "Super Deluxe Eight Base": ["1949", "1950"],
    "Super Eight Base": ["1948", "1949", "1950"],
  },
  Peugeot: {
    "504 Base": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
    ],
    "504 SL": ["1975", "1976", "1977", "1978"],
    "505 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1986",
      "1987",
      "1989",
      "1990",
    ],
    "505 DL": ["1988", "1989", "1990", "1991"],
    "505 GL": ["1984", "1985", "1986", "1987"],
    "505 GLS": ["1987", "1988"],
    "505 S": ["1984", "1985", "1986", "1987", "1988", "1989", "1990"],
    "505 STI": ["1983", "1984", "1985", "1986", "1987", "1988"],
    "505 STX": ["1987", "1988", "1989"],
    "505 SW8": ["1989", "1990", "1991"],
    "604 Base": ["1977", "1978", "1979", "1982", "1983", "1984"],
    "405 DL": ["1989", "1990", "1991"],
    "405 Mi 16": ["1989", "1990", "1991"],
    "405 S": ["1989", "1990", "1991"],
    "304 Base": ["1971", "1972"],
    "404 Base": ["1969", "1970"],
  },
  Studebaker: {
    "Avanti Base": ["1963", "1964"],
    "Commander Base": ["1955", "1956", "1957", "1958"],
    "Cruiser Base": ["1963", "1964"],
    "E12 Base": ["1955", "1956"],
    "E13 Base": ["1955", "1956"],
    "E28 Base": ["1955", "1956"],
    "E38 Base": ["1955", "1956"],
    "E7 Base": ["1955", "1956"],
    "Golden Hawk Base": ["1956", "1957", "1958"],
    "Hawk Base": ["1960", "1961", "1962", "1963", "1964"],
    "Lark Base": ["1959", "1960", "1961", "1962", "1963", "1964"],
    "Police Car Base": ["1955", "1956"],
    "President Base": ["1955", "1956", "1957", "1958"],
    "Silver Hawk Base": ["1957", "1958", "1959"],
    "Taxi Base": ["1958", "1959", "1960"],
    "Transtar 3E12": ["1957", "1958"],
    "Transtar 3E7": ["1957", "1958"],
  },
  Sunbeam: {
    "Tiger Base": ["1965", "1966", "1967"],
  },
  "AM General": {
    "Hummer Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "FJ8 Base": ["1973", "1974"],
    "DJ5 Base": ["1972", "1973", "1974"],
  },
  "Arctic Cat": {
    "1000 Mud Pro LTD": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "1000 TRV Cruiser": ["2009", "2010", "2011", "2012"],
    "1000 TRV Ltd EPS": ["2013", "2014", "2015"],
    "1000 XT EPS": ["2013", "2014", "2015", "2016", "2017"],
    "366 4X4 Auto": ["2008", "2009", "2010"],
    "400 4X4 TRV": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "550 4X4": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "550 4X4 LTD": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "550 4X4 TRV": ["2009", "2010", "2011", "2012"],
    "550 4X4 TRV XT EPS": ["2013", "2014", "2015"],
    "550 4X4 XT EPS": ["2013", "2014"],
    "650 4X4 H1 TRV": ["2007", "2008", "2009"],
    "700 4X4": ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "700 4X4 LTD": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "700 4X4 Mud Pro": ["2009", "2010", "2011", "2012", "2013"],
    "700 4X4 Mud Pro LTD": ["2014", "2015", "2016", "2017"],
    "700 4X4 TBX": ["2014", "2015", "2016", "2017"],
    "700 4X4 TBX XT": ["2013", "2014"],
    "700 4X4 TRV LTD": ["2013", "2014", "2015"],
    "700 4X4 TRV XT EPS": ["2013", "2014", "2015"],
    "700 4X4 XT": ["2013", "2014"],
    "Prowler 1000 XTZ": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Prowler 550 XT": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Prowler 650 XT": ["2006", "2007", "2008", "2009"],
    "Prowler 700 HDX": ["2011", "2012", "2013", "2014"],
    "Prowler 700 HDX XT": ["2015", "2016", "2017"],
    "Prowler 700 XTX": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "Wildcat 1000 Eps": ["2013", "2014", "2015"],
    "Wildcat 1000 LTD EPS": ["2013", "2014"],
    "Wildcat X 1000 Eps": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "650 4x4 Auto V2": ["2005", "2006"],
    "400 4X4": ["1998", "1999", "2000", "2001", "2002", "2014", "2015"],
    "400 4X4 Auto Tbx": ["2004", "2005", "2006"],
    "400 4X4 Auto Vp": ["2005", "2006"],
    "400 4X4 Vp": ["2005", "2006"],
    "500 4X4 Auto": ["2000", "2001", "2002"],
    "500 4X4 Auto FIS LTD": ["2005", "2006"],
    "500 4X4 Auto Tbx": ["2002", "2003", "2004", "2005", "2006"],
    "500 4X4 Auto Trv": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "400 DVX": ["2004", "2005", "2006", "2007", "2008"],
    "250 2x4": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "300 2X4": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "300 4X4": ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    'XF 6000 Cross Country Limited ES 137"': ["2017", "2018", "2019"],
    'XF 6000 CrossTrek ES 137"': ["2017", "2018"],
    'XF 7000 CrossTour 141"': ["2014", "2015"],
    'XF 7000 Limited 137"': ["2014", "2015"],
    'XF 7000 LXR 137"': ["2014", "2015"],
    'XF 7000 SnoPro 137"': ["2014", "2015"],
    'XF 8000 Cross Country Limited ES 137"': ["2017", "2018", "2019"],
    'XF 8000 CrossTour 141"': ["2014", "2015"],
    'XF 8000 CrossTrek ES 137"': ["2017", "2018"],
    'XF 8000 High Country Limited 141"': ["2014", "2015", "2016"],
    'XF 8000 Limited 137"': ["2014", "2015"],
    'XF 8000 LXR 137"': ["2014", "2015"],
    'XF 8000 SnoPro 137"': ["2014", "2015"],
    'XF 9000 Cross Country Limited 137"': ["2017", "2018", "2019"],
    'XF 9000 CrossTour 141"': ["2014", "2015"],
    'XF 9000 CrossTrek 137"': ["2016", "2017", "2018"],
    'XF 9000 High Country Limited 141"': [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'XF 9000 Limited 137"': ["2014", "2015"],
    'XF 9000 LXR 137"': ["2014", "2015"],
    'XF 9000 SnoPro 137"': ["2014", "2015"],
    'ZR 6000 129" ES': ["2018", "2019"],
    'ZR 6000 137" ES': ["2018", "2019"],
    'ZR 6000 El Tigr\u00e9 129" ES': ["2017", "2018"],
    'ZR 6000 El Tigr\u00e9 137" ES': ["2017", "2018"],
    'ZR 6000 Limited 129" ES': ["2017", "2018", "2019"],
    'ZR 6000 Limited 137" ES': ["2017", "2018", "2019", "2020", "2021", "2022"],
    'ZR 6000 Limited 137" ES iACT': ["2019", "2020"],
    'ZR 6000 R XC 137"': ["2020", "2021"],
    'ZR 6000 RR 137" ES': ["2017", "2018", "2019"],
    'ZR 6000 Sno Pro 137" ES': ["2017", "2018"],
    'ZR 6000 SnoPro 129" ES': ["2017", "2018", "2019"],
    'ZR 6000 SnoPro 137" ES': ["2019", "2020"],
    'ZR 7000 137"': ["2018", "2019"],
    'ZR 7000 El Tigr\u00e9 129"': ["2015", "2016", "2017"],
    'ZR 7000 Limited 137"': ["2016", "2017", "2018", "2019"],
    'ZR 7000 LXR 129"': ["2014", "2015", "2016", "2017"],
    'ZR 7000 LXR 137"': ["2016", "2017"],
    'ZR 7000 SnoPro 137"': ["2016", "2017", "2018"],
    'ZR 8000 129" ES': ["2018", "2019"],
    'ZR 8000 137" ES': ["2018", "2019"],
    'ZR 8000 El Tigr\u00e9 129" ES': ["2017", "2018"],
    'ZR 8000 El Tigr\u00e9 137" ES': ["2017", "2018"],
    'ZR 8000 Limited 129" ES': ["2017", "2018", "2019"],
    'ZR 8000 Limited 129" ES iACT': ["2019", "2020"],
    'ZR 8000 Limited 137" ES': ["2017", "2018", "2019", "2020", "2021", "2022"],
    'ZR 8000 Limited 137" ES iACT': ["2019", "2020"],
    'ZR 8000 Limited 137" ES w/ATAC': ["2021", "2022"],
    'ZR 8000 RR 129" ES': ["2017", "2018", "2019"],
    'ZR 8000 RR 137" ES': [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    'ZR 8000 SnoPro 129" ES': ["2017", "2018", "2019"],
    'ZR 8000 SnoPro 137" ES': ["2019", "2020"],
    'ZR 8000 SnoPro ES 137"': ["2017", "2018"],
    'ZR 9000 Limited 129"': ["2014", "2015", "2016", "2017"],
    'ZR 9000 Limited 137"': ["2016", "2017"],
    'ZR 9000 LXR 137"': ["2016", "2017"],
    'ZR 9000 RR 129"': ["2014", "2015", "2016", "2017"],
    'ZR 9000 RR 137"': ["2017", "2018", "2019", "2023", "2024"],
    'ZR 9000 SnoPro 137"': ["2016", "2017", "2018"],
    'ZR 9000 Thundercat 137"': [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    'ZR 9000 Thundercat 137" EPS w/ATAC': ["2022", "2023", "2024"],
    'ZR 9000 Thundercat 137" iACT': ["2019", "2020"],
    'M 800 Hill Climb Racer 153"': ["2012", "2013"],
    'Pantera 6000 ES 146"': ["2018", "2019"],
    'Pantera 7000 146"': ["2015", "2016"],
    'Pantera 7000 Limited 146"': ["2015", "2016", "2017", "2018", "2019"],
    'Pantera 7000 XT Limited 154"': ["2016", "2017", "2018", "2019"],
    'Riot 6000 146"/1.35"': ["2021", "2022"],
    'Riot 6000 146"/1.60"': ["2020", "2021", "2022", "2023"],
    'Riot 8000 146"/1.35"': ["2020", "2021", "2022"],
    'Riot 8000 146"/1.60"': ["2020", "2021", "2022", "2023", "2024"],
    'Riot 8000 146"/1.60" w/ATAC': ["2022", "2023", "2024"],
    'Pantera 3000 146"': ["2016", "2017", "2018", "2019"],
    'XF 1100 LXR 141"': ["2012", "2013"],
    'XF 1100 SnoPro 141"': ["2012", "2013"],
    'XF 1100 SnoPro Limited  141"': ["2012", "2013"],
    'XF 7000 CrossTour 146"': ["2016", "2017", "2018"],
    'XF 7000 CrossTrek 137"': ["2017", "2018"],
    'XF 800 LXR 141"': ["2012", "2013"],
    'XF 800 SnoPro 141"': ["2012", "2013"],
    'XF 800 SnoPro High Country 141"': ["2012", "2013"],
    'ZR 3000 129"': ["2018", "2019"],
    'ZR 4000 LXR 129"': ["2015", "2016", "2017"],
    'ZR 5000 LXR 129"': ["2014", "2015", "2016"],
    'ZR 6000 El Tigr\u00e9 129"': ["2014", "2015", "2016"],
    'ZR 6000 Limited 129"': ["2015", "2016"],
    'ZR 6000 LXR 129"': ["2015", "2016"],
    'ZR 6000 RR 129"': ["2014", "2015", "2016"],
    'ZR 6000 SnoPro 129"': ["2015", "2016"],
    'ZR 7000 Limited 129"': ["2014", "2015", "2016"],
    'ZR 7000 RR 129"': ["2015", "2016"],
    'ZR 7000 SnoPro 129"': ["2014", "2015", "2016"],
    'ZR 8000 El Tigr\u00e9 129"': ["2015", "2016"],
    'ZR 8000 Limited 129"': ["2014", "2015", "2016"],
    'ZR 8000 LXR 129"': ["2014", "2015", "2016"],
    'ZR 8000 RR 129"': ["2014", "2015", "2016"],
    'ZR 8000 SnoPro 129"': ["2014", "2015", "2016"],
    'Bearcat 2000 LT 151"': ["2015", "2016"],
    'Bearcat 2000 LT ES 151"': ["2017", "2018"],
    'Bearcat 2000 XT 154"': ["2015", "2016"],
    'Bearcat 2000 XTE 154"': ["2015", "2016"],
    'Bearcat 3000 LT 146"': ["2016", "2017"],
    'Bearcat 570 151"': [
      "2004",
      "2005",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    'Bearcat 570 XT 154"': ["2011", "2012", "2013", "2014"],
    'Bearcat 570 XT 156"': ["2009", "2010"],
    'Bearcat 7000 XT 154"': ["2016", "2017", "2018", "2019"],
    'Bearcat 7000 XT Groomer Special 154"': ["2016", "2017", "2018"],
    'Bearcat Z1 XT 154"': ["2011", "2012", "2013", "2014"],
    'Bearcat Z1 XT 156"': ["2009", "2010"],
    'Bearcat Z1 XT Groomer Special 156"': ["2012", "2013"],
    'Bearcat Z1 XT Limited 154"': ["2011", "2012", "2013", "2014"],
    'Crossfire 1000 136"': ["2007", "2008", "2009", "2010", "2011"],
    'Crossfire 1000 SnoPro 136"': ["2007", "2008", "2009", "2010", "2011"],
    'Crossfire 5 136"': ["2007", "2008"],
    'Crossfire 6 136"': ["2006", "2007", "2008"],
    'Crossfire 6 141"': ["2009", "2010", "2011"],
    'Crossfire 8 136"': ["2007", "2008"],
    'Crossfire 8 141"': ["2009", "2010", "2011"],
    'Crossfire 8 Limited 141"': ["2010", "2011"],
    'Crossfire 8 SnoPro 136"': ["2007", "2008"],
    'Crossfire 8 SnoPro 141"': ["2009", "2010", "2011"],
    'F 5 128"': ["2007", "2008", "2009", "2013", "2014"],
    'F 5 LXR 128"': ["2007", "2008", "2009", "2010", "2011", "2012"],
    'F 570 128"': ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    'F 6 128"': ["2007", "2008"],
    'F 6 LXR 128"': ["2007", "2008"],
    'F 6 SnoPro 128"': ["2007", "2008", "2009", "2010", "2011"],
    'F 8 128"': ["2007", "2008", "2009", "2010"],
    'F 8 LXR 128"': ["2007", "2008", "2009", "2010", "2011"],
    'F 8 SnoPro 128"': ["2008", "2009", "2010", "2011"],
    'F 8 SnoPro Limited 128"': ["2010", "2011"],
    'Lynx 2000 ES 129"': ["2017", "2018", "2019", "2020"],
    'Lynx 2000 LT 144"': ["2015", "2016"],
    'Lynx 2000 LT ES 144"': ["2017", "2018", "2019", "2020"],
    'M 1100 153"': ["2012", "2013"],
    'M 1100 Turbo 153"': ["2012", "2013"],
    'M 1100 Turbo Hill Climb Racer 162"': ["2012", "2013"],
    'M 1100 Turbo SnoPro 162"': ["2012", "2013"],
    'M 6 153"': ["2007", "2008", "2009", "2010", "2011"],
    'M 6000 SE ES 141"': ["2016", "2017", "2018", "2019"],
    'M 6000 SE ES 153"': ["2016", "2017", "2018", "2019"],
    'M 6000 SnoPro 153"': ["2014", "2015", "2016", "2017"],
    'M 6000 SnoPro ES 153"': ["2016", "2017"],
    'M 7000 SnoPro 153"': ["2015", "2016"],
    'M 8 153"': ["2007", "2008", "2009", "2010", "2011"],
    'M 8 162"': ["2007", "2008", "2009", "2010", "2011"],
    'M 8 Hill Climb Racer 153"': ["2009", "2010", "2011"],
    'M 8 SnoPro 153"': ["2007", "2008", "2009", "2010", "2011"],
    'M 8 SnoPro 162"': ["2009", "2010", "2011"],
    'M 800 153"': ["2012", "2013"],
    'M 800 SnoPro 153"': ["2012", "2013"],
    'M 8000 153"': ["2014", "2015"],
    'M 8000 Hill Climb Racer 153"': ["2014", "2015", "2016", "2017"],
    'M 8000 Limited 153"': ["2014", "2015", "2016", "2017"],
    'M 8000 Limited 153" ES': ["2014", "2015", "2016", "2017"],
    'M 8000 Limited 162"': ["2014", "2015", "2016", "2017"],
    'M 8000 Limited 162" ES': ["2014", "2015", "2016", "2017"],
    'M 8000 Mountain Cat 153"': ["2017", "2018", "2019"],
    'M 8000 Mountain Cat 162"': ["2017", "2018", "2019"],
    'M 8000 SE 153" ES': ["2016", "2017"],
    'M 8000 SnoPro 141" ES': ["2016", "2017"],
    'M 8000 SnoPro 153"': ["2014", "2015", "2016", "2017", "2018", "2019"],
    'M 8000 SnoPro 153" ES': ["2016", "2017"],
    'M 8000 SnoPro 162"': ["2014", "2015", "2016", "2017", "2018", "2019"],
    'M 8000 SnoPro 162" ES': ["2016", "2017"],
    'M 9000 Hill Climb Racer 162"': ["2014", "2015"],
    'M 9000 Limited 162"': ["2014", "2015", "2016"],
    'T 500 144"': ["2008", "2009"],
    'T 570 144"': ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    'XF 1100 Turbo LXR 141"': ["2012", "2013"],
    'XF 1100 Turbo SnoPro 141"': ["2012", "2013"],
    'XF 1100 Turbo SnoPro High Country 141"': ["2012", "2013"],
    'XF 1100 Turbo SnoPro Limited 141"': ["2012", "2013"],
    'XF 6000 High Country 141"': ["2015", "2016", "2017"],
    'XF 7000 High Country 141"': ["2015", "2016"],
    'XF 8000 High Country 141"': ["2015", "2016", "2017", "2018", "2019"],
    'XF 8000 High Country Limited ES 141"': ["2017", "2018", "2019"],
    'XF 8000 High Country Limited ES 153"': ["2017", "2018", "2019"],
    'XF 9000 High Country Limited 153"': ["2017", "2018", "2019"],
    'Z 1 128"': ["2009", "2010"],
    'Z 1 LXR 128"': ["2009", "2010", "2011"],
    'Z 1 Turbo 128"': ["2009", "2010"],
    'Z 1 Turbo EXT 144"': ["2010", "2011"],
    'Z 1 Turbo LXR 128"': ["2009", "2010", "2011"],
    'Z 1 Turbo SnoPro 128"': ["2009", "2010", "2011"],
    'Z 1 Turbo SnoPro Limited 128"': ["2010", "2011"],
    'ZR 4000 RR 129"': ["2015", "2016"],
    'ZR 9000 El Tigr\u00e9 129"': ["2015", "2016"],
    'ZR 9000 LXR 129"': ["2014", "2015"],
    'ZR 9000 SnoPro 129"': ["2014", "2015", "2016"],
    'M 8000 Hardcore Alpha One 146"': ["2022", "2023", "2024"],
    'M 8000 Hardcore Alpha One 154"': ["2020", "2021", "2022", "2023", "2024"],
    'M 8000 Hardcore Alpha One 154" ES': ["2021", "2022", "2023"],
    'M 8000 Hardcore Alpha One 165"': ["2020", "2021", "2022", "2023", "2024"],
    'M 8000 Hardcore Alpha One 165" ES': ["2020", "2021", "2022", "2023"],
    'M 8000 Mountain Cat Alpha One 146"': ["2023", "2024"],
    'M 8000 Mountain Cat Alpha One 154"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    'M 8000 Mountain Cat Alpha One 154" ES': [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    'M 8000 Mountain Cat Alpha One 154"/3.00"': ["2023", "2024"],
    'M 8000 Mountain Cat Alpha One 165"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    'M 8000 Mountain Cat Alpha One 165" ES': ["2020", "2021", "2022", "2023"],
    'M 8000 Mountain Cat Alpha One 165" w/ATAC': ["2021", "2022"],
    'Norseman X 8000 153"': ["2021", "2022", "2023", "2024"],
    'Riot 9000 146"/1.60" w/ATAC': ["2023", "2024"],
    Havoc: ["2019", "2020"],
    "Havoc X": ["2018", "2019"],
    Stampede: ["2017", "2018", "2019"],
    "Stampede 4": ["2018", "2019"],
    "Stampede 4X": ["2018", "2019"],
    "Stampede X": ["2018", "2019"],
    "Wildcat XX 1000 EPS": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Wildcat XX 1000 LTD EPS": ["2018", "2019", "2022", "2023"],
    "Wildcat XX 1000 SE EPS": ["2022", "2023"],
    "Prowler 1000 XT": ["2015", "2016"],
    "Prowler 500": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Prowler 500 HDX": ["2014", "2015"],
    "Prowler 500 HDX XT": ["2016", "2017"],
    "Prowler 650": ["2007", "2008"],
    "Prowler Pro": ["2019", "2020", "2021", "2022", "2023"],
    "Prowler Pro Crew": ["2020", "2021", "2022", "2023"],
    "Wildcat 1000 GT": ["2012", "2013"],
    "1000 Thundercat": ["2008", "2009"],
    "1000 TRV": ["2009", "2010"],
    "400 4X4 Auto FIS": ["2003", "2004", "2006", "2007", "2008"],
    "400 4X4 Fis": ["2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "450 4X4": ["2010", "2011", "2012"],
    "450 4X4 TRV": ["2011", "2012"],
    "500 4X4 Auto Fis": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "500 4X4 Fis": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "500 4X4 XT": ["2013", "2014"],
    "550 4X4 TRV GT": ["2011", "2012"],
    "550 4X4 TRV LTD": ["2013", "2014", "2015"],
    "650 4X4 H1": ["2007", "2008", "2010", "2011", "2012"],
    "700 4X4 TRV": ["2010", "2011"],
    "700 4X4 TRV Cruiser": ["2008", "2009", "2010", "2011", "2012"],
    "700 4X4 TRV GT": ["2011", "2012"],
    "700 Diesel": ["2007", "2008", "2009", "2011", "2012"],
    'Riot X 8000 146"': ["2020", "2021", "2022", "2023", "2024"],
    'Riot X 8000 146" w/ATAC': ["2022", "2023", "2024"],
    'Bearcat 660 WT 156"': ["2003", "2004", "2005", "2006", "2007", "2008"],
    'Bearcat 660 WT Turbo / Articulating 156"': ["2007", "2008"],
    'Bearcat 660 WT Turbo 156"': ["2006", "2007", "2008"],
    'Blast LT 4000 146"': ["2021", "2022", "2023", "2024"],
    'Blast M 4000 146"': ["2021", "2022", "2023", "2024"],
    'Blast XR 4000 146"': ["2022", "2023", "2024"],
    'Blast XR 4000 Touring 146"': ["2022", "2023", "2024"],
    'Blast ZR 4000 121"': ["2021", "2022", "2023", "2024"],
    'CFR 1000 128"': ["2010", "2011"],
    'CFR 8 128"': ["2010", "2011"],
    "Firecat 600 (EFI)": ["2004", "2005"],
    "Firecat 600 EXT (EFI)": ["2004", "2005"],
    "Firecat 600 SnoPro (EFI)": ["2004", "2005"],
    "Firecat 700": ["2004", "2005"],
    "Firecat 700 (EFI)": ["2003", "2004", "2005"],
    "Firecat 700 EXT (EFI)": ["2004", "2005"],
    "Firecat 700 SnoPro": ["2004", "2005"],
    "Firecat 700 SnoPro (EFI)": ["2003", "2004", "2005"],
    'M 1000 153"': ["2007", "2008", "2009"],
    'M 1000 162"': ["2007", "2008", "2009"],
    'M 1000 SnoPro 153"': ["2007", "2008", "2009"],
    'M 1000 SnoPro 162"': ["2007", "2008", "2009", "2010", "2011"],
    'M 6 (EFI) 141"': ["2005", "2006"],
    'M 7 (EFI) 141"': ["2005", "2006"],
    'M 7 (EFI) 153"': ["2005", "2006"],
    'M 7 (EFI) 162"': ["2005", "2006"],
    'M 7 Limited (EFI) 153"': ["2005", "2006"],
    'M 9000 King Cat 162"': ["2018", "2019"],
    'Panther 370 136"': ["2004", "2005", "2006", "2007", "2008"],
    'Panther 570 136"': ["2004", "2005", "2006", "2007"],
    'Panther 660 Trail 121"': ["2006", "2007"],
    "Sabrecat 500": ["2004", "2005"],
    "Sabrecat 500 LX": ["2004", "2005"],
    "Sabrecat 600 (EFI)": ["2004", "2005"],
    "Sabrecat 600 EXT (EFI)": ["2004", "2005"],
    'Sabrecat 600 LX (EFI) 128"': ["2004", "2005", "2006"],
    "Sabrecat 700 (EFI)": ["2004", "2005"],
    'Sabrecat 700 EXT (EFI) 144"': ["2004", "2005", "2006"],
    'Sabrecat 700 LX (EFI) 128"': ["2004", "2005", "2006"],
    'SnoPro 500 128"': ["2010", "2011", "2012", "2013", "2014"],
    'T 660 Touring 136"': ["2004", "2005", "2006"],
    'T 660 Turbo 121"': ["2005", "2006", "2007"],
    'T 660 Turbo Limited 121"': ["2006", "2007"],
    'T 660 Turbo Touring 136"': ["2004", "2005", "2006", "2007"],
    'T 660 Turbo Touring Limited 136"': ["2006", "2007"],
    'TZ 1 144"': ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    'TZ 1 LXR 144"': ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    'XF 6000 High Country ES 141"': ["2018", "2019"],
    "ZR 800 (EFI)": ["2002", "2003"],
    "ZR 900": ["2003", "2004", "2005"],
    'ZR 900 (EFI) 121"': ["2004", "2005", "2006"],
    "ZR 900 SnoPro": ["2003", "2004", "2005"],
    'ZR 900 SnoPro (EFI) 121"': ["2004", "2005", "2006"],
    "ZR 200 ES": ["2019", "2020", "2021", "2022"],
    "250 DVX": ["2006", "2007", "2008"],
    "300 DVX": ["2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "Alterra 300": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "250 4x4": ["2001", "2002", "2003", "2004", "2005"],
    "650 4X4 H1 Mud Pro": ["2010", "2011"],
    'F 1000 128"': ["2007", "2008"],
    'F 1000 LXR 128"': ["2007", "2008"],
    'F 1000 SnoPro 128"': ["2007", "2008", "2009"],
    'F 5 Firecat 128"': ["2003", "2004", "2005", "2006"],
    'F 5 Firecat SnoPro 128"': ["2003", "2004", "2005", "2006"],
    "King Cat 900": ["2004", "2005"],
    'King Cat 900 (EFI) 162"': ["2005", "2006"],
    "Z1 1100": ["2009", "2010", "2011"],
    "1000 Mud Pro": ["2010", "2011"],
    "450 XC": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "Alterra 400": ["2016", "2017"],
    "Alterra 570 EPS": ["2019", "2020", "2021"],
    "Alterra 700": ["2016", "2017", "2018", "2019"],
    "Alterra 700 XT EPS": ["2016", "2017", "2018", "2019"],
    "Wildcat 4X 1000 EPS": ["2014", "2015", "2016"],
    "Wildcat 4X 1000 Ltd Eps": ["2014", "2015"],
    "Wildcat Sport 700": ["2015", "2016"],
    "Wildcat Sport 700 Ltd EPS": ["2015", "2016", "2017", "2018", "2019"],
    "Wildcat Sport 700 Xt": ["2015", "2016", "2017", "2018", "2019"],
    "Wildcat Trail 700": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "Wildcat Trail 700 SE EPS": ["2016", "2017"],
    "Wildcat Trail 700 Xt": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Wildcat X 1000 Ltd Eps": ["2014", "2015", "2016", "2017", "2018", "2019"],
    150: ["2016", "2017"],
    "90 2x4 4-Stroke": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
    ],
    "90 DVX": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Alterra 90": ["2020", "2021"],
    "350 4X4": ["2011", "2012"],
    "425 4X4": ["2011", "2012"],
    "500 4X4 TRV": ["2013", "2014", "2015"],
    "700 Super Duty Diesel": ["2013", "2014"],
    "Wildcat Trail 700 Ltd Eps": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "400 2X4": ["1998", "1999", "2000", "2001"],
    "454 2x4": ["1997", "1998"],
    "454 4x4": ["1996", "1997", "1998"],
    "SnoPro 120": ["2009", "2010", "2011", "2012", "2013"],
    "Z 120": ["2000", "2001"],
    "ZR 120": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "150 Utility 2x4": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2014",
      "2015",
      "2018",
      "2019",
    ],
    "4 Stroke Touring": ["2002", "2003"],
    "4 Stroke Trail": ["2002", "2003"],
    "Mountain Cat 600 (EFI)": ["2001", "2002", "2003", "2004"],
    "Mountain Cat 600 Limited (EFI)": ["2001", "2002"],
    "Mountain Cat 800 (EFI)": ["2002", "2003", "2004"],
    "Pantera 600 (EFI)": ["2004", "2005"],
    "Pantera 600 ESR (EFI)": ["2002", "2003"],
    "Pantera 800 ESR (EFI)": ["2002", "2003", "2004"],
    'T 660 Turbo ST 121"': ["2005", "2006"],
    "ZL 600 (EFI)": ["1999", "2000", "2001", "2002", "2003"],
    "ZL 600 ESR (EFI)": ["2001", "2002", "2003"],
    "ZL 600 SS (EFI)": ["2002", "2003"],
    "ZL 600 SS ESR (EFI)": ["2002", "2003"],
    "ZL 800 ESR (EFI)": ["2002", "2003"],
    "ZL 800 SS (EFI)": ["2002", "2003"],
    "ZR 600": ["1998", "1999", "2000", "2001", "2002"],
    'TZ 1 Turbo LXR 144"': ["2011", "2012", "2013"],
    "500 4X4": ["2008", "2009", "2013", "2014", "2015", "2016", "2017"],
    "550 4X4 TRV Cruiser EPS": ["2011", "2012"],
    "Alterra 700 EPS": ["2019", "2020", "2021"],
    "Alterra 700 Mud Pro LTD": ["2018", "2019"],
    "Alterra 700 TBX": ["2018", "2019", "2020"],
    "Bearcat 340": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Panther 340": ["1998", "1999", "2000"],
    "Bearcat 440": ["1995", "1996", "1997", "1998"],
    "Bearcat 440 I": ["1999", "2000"],
    "Jag 340 Deluxe": ["1998", "1999"],
    "Jag 340 Mountain Cat": ["1990", "1991"],
    "Jag 440": ["1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    "Jag 440 Deluxe": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Lynx 340": ["1991", "1992", "1993"],
    "Lynx 340 Deluxe": ["1991", "1992", "1993"],
    "Lynx 340 Mountain Cat": ["1992", "1993"],
    "Panther 440": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Panther 440 Deluxe": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Panther 440 Mountain Cat": ["1990", "1991"],
    "Puma 340": ["1994", "1995", "1996", "1997"],
    "Puma 340 2-Up": ["1994", "1995", "1996", "1997"],
    "Puma 340 Deluxe": ["1994", "1995", "1996", "1997"],
    'Z 370 121"': [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Z 370 ES": ["2000", "2001", "2002"],
    "Z 440": ["1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    "Z 440 ES": ["2000", "2001", "2002"],
    'Z 440 LX 121"': ["2004", "2005", "2006"],
    "Z 440 SnoPro": ["1999", "2000", "2001", "2002", "2003"],
    "EXT 600 Triple": ["1997", "1998"],
    "Pantera 800": ["1998", "1999", "2002", "2003", "2004"],
    "Powder Extreme 600": ["1997", "1998"],
    "Powder Special 700": ["1999", "2000"],
    "Thundercat 1000": ["1998", "1999", "2000", "2001", "2002"],
    "Thundercat 1000 Mountain Cat": ["1998", "1999", "2000"],
    "Thundercat 900 Mountain Cat": ["1994", "1995", "1996", "1997"],
    "ZR 700": ["1994", "1995", "1999", "2000"],
    "ZRT 600": ["1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    "ZRT 800": ["1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    "Mountain Cat 570": ["2002", "2003", "2004"],
    "Pantera 550": ["1993", "1994", "1995", "2002", "2003", "2004", "2005"],
    "Pantera 580 (EFI)": ["1999", "2000", "2001"],
    "Panther 550": ["1997", "1998", "1999", "2000", "2001"],
    "Triple Touring 600": ["1999", "2000", "2001"],
    'Z 370 LX 121"': ["2004", "2005", "2006"],
    'Z 570 121"': ["2002", "2003", "2004", "2005", "2006", "2007"],
    'Z 570 LX 121"': ["2004", "2005", "2006"],
    "ZL 440": ["1997", "1998", "1999", "2000"],
    "ZL 500": ["1998", "1999", "2000"],
    "ZL 500 (EFI)": ["1999", "2000"],
    "ZL 550": ["2001", "2002", "2003"],
    "ZL 600": ["1999", "2000"],
    "ZR 500": ["1998", "1999", "2000", "2001", "2002"],
    "ZR 500 (EFI)": ["1999", "2000", "2001"],
    "ZR 600 (EFI)": ["1998", "1999", "2000", "2001", "2002"],
    "EXT 580 (EFI)": ["1994", "1995", "1996", "1997", "1998"],
    "EXT 580 Mountain Cat (EFI)": ["1994", "1995", "1996"],
    "EXT 580 Powder Special": ["1995", "1996"],
    "Pantera 580": ["1996", "1997", "1998"],
    "Thundercat 900": ["1993", "1994", "1995", "1996", "1997"],
    "Wildcat 700 (EFI)": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Wildcat 700 Touring": ["1995", "1996"],
    "ZR 440": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "ZR 580 (EFI)": ["1995", "1996", "1997"],
    "SnoPro 600": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Mountain Cat 1000": ["2001", "2002"],
    "Mountain Cat 800": ["2001", "2002"],
    "Pantera 1000": ["2000", "2001"],
    "Bearcat 440 II": ["1999", "2000"],
    "Bearcat 550 WT": ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    'Bearcat 570 156"': ["2006", "2007", "2008"],
    "Mountain Cat 800 Limited": ["2001", "2002"],
    "Mountain Cat 900": ["2003", "2004"],
    "Panther 570 ESR": ["2002", "2003"],
    "Powder Special 600": ["1998", "1999", "2000"],
    "Powder Special 700 Limited": ["1999", "2000"],
    "Z 570 ESR": ["2002", "2003"],
    "ZR 440 SnoPro": ["1998", "1999", "2000"],
    "Jag 440 Z": ["1993", "1994"],
    "Wildcat 700 Mountain Cat (EFI)": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "ZR 580": ["1993", "1994", "1995", "1996"],
    "Bearcat 550": ["1995", "1996"],
    "Cheetah 440": ["1993", "1994"],
    "Cougar 550 Mountain Cat": ["1995", "1996", "1997", "1998"],
    "Jag 440 AFS LT": ["1990", "1991", "1992", "1993"],
    "Pantera 440": ["1990", "1991", "1992"],
    "Pantera 440 2-Up": ["1995", "1996", "1997"],
    "Prowler 440 Mountain Cat": ["1991", "1992"],
    "Cheetah Touring": ["1990", "1991", "1992"],
    "Jag 440 AFS": ["1990", "1991"],
    "Jag 440 AFS Deluxe": ["1990", "1991"],
    'Norseman 6000 ES 154"': ["2018", "2019"],
    "Cougar 440": ["1991", "1992", "1993", "1994"],
    "Cougar 440 Mountain Cat": ["1993", "1994"],
    "Prowler 440": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "Prowler 440 2-Up": ["1991", "1992", "1993", "1994", "1995"],
    "Wildcat 700": ["1991", "1992", "1993", "1995", "1996"],
    "Wildcat 700 Mountain Cat": ["1991", "1992", "1993", "1995", "1996"],
    "Alterra 550 XT EPS": ["2016", "2017"],
    "Alterra 570": ["2019", "2020"],
    "El Tigr\u00e9 EXT": ["1990", "1991"],
    "Super Jag 440": ["1990", "1991", "1992"],
    "ZR 200": ["2023", "2024"],
    "Tigershark 640": ["1998", "1999"],
    "Tigershark 770": ["1998", "1999"],
    "Tigershark 770L": ["1998", "1999"],
    "Tigershark 770R": ["1998", "1999"],
    "50 2X4 Auto": ["2004", "2005", "2006"],
    "90 2X4": ["2002", "2003", "2004"],
    "Cougar 550": ["1995", "1996", "1997", "1998"],
    "EXT 580": ["1993", "1994", "1995", "1996"],
    "EXT 550 Special": ["1991", "1992"],
    "EXT 580 Deluxe (EFI)": ["1996", "1997", "1998"],
    "EXT 580 Mountain Cat": ["1993", "1994"],
    "Powder Special 500 (EFI)": ["1999", "2000"],
    "Prowler 440 Special": ["1991", "1992"],
    "ZL 500 ESR (EFI)": ["2000", "2001"],
    "ZL 550 ESR": ["2000", "2001", "2002", "2003"],
    "ZR 600 Limited (EFI)": ["1998", "1999", "2000", "2001"],
    "ZR 800": ["2001", "2002"],
    "Cougar 440 2-Up": ["1991", "1992"],
    "EXT 550": ["1992", "1993"],
    'F 6 Firecat (EFI) 128"': ["2005", "2006"],
    'F 6 Firecat SnoPro (EFI) 128"': ["2005", "2006"],
    'F 7 Firecat (EFI) 128"': ["2005", "2006"],
    'F 7 Firecat 128"': ["2005", "2006"],
    'F 7 Firecat SnoPro (EFI) 128"': ["2005", "2006"],
    'F 7 Firecat SnoPro 128"': ["2005", "2006"],
    "Kitty Cat": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "SnoPro 440": ["2003", "2004", "2005"],
    "Pantera 800 (EFI)": ["2002", "2003", "2004"],
    'Crossfire 1000 141"': ["2009", "2010", "2011"],
    'Crossfire 1000 R 128"': ["2009", "2010", "2011"],
    'Crossfire 1000 R Limited 128"': ["2009", "2010", "2011"],
    'Crossfire 1000 SnoPro 141"': ["2009", "2010", "2011"],
    'Crossfire 1000 SnoPro Limited 141"': ["2009", "2010", "2011"],
    'M 600 Alpha One Sno Pro 146"/2.6"': ["2024", "2025"],
    'M 600 Alpha One Sno Pro 154"/3"': ["2024", "2025"],
    'Riot 400 146"/1.6"': ["2024", "2025"],
    "EXT 550 (EFI)": ["1992", "1993"],
    'Bearcat 540 XT 156"': ["2018", "2019"],
    "1000 EFI H2 4x4 Auto Mud Pro Base": ["2010", "2011"],
    "1000 EFI H2 4x4 Auto TRV Base": ["2010", "2011"],
    "1000 TRV Cruiser Base": ["2009", "2010", "2011"],
    "1000 XT Base": ["2013", "2014", "2015", "2016", "2017"],
    "150 Base": ["2015", "2016", "2017"],
    "150 2x4 Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "250 2x4 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "250 4x4 Base": ["2001", "2002", "2003", "2004", "2005"],
    "300 Base": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "300 2X4 Base": ["1998", "1999", "2000", "2001", "2002", "2003"],
    "300 4X4 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "350 Base": ["2011", "2012"],
    "366 4X4 Auto Base": ["2008", "2009"],
    "366 4x4 Auto SE Base": ["2010", "2011"],
    "4-Stroke Touring Base": ["2002", "2003"],
    "4-Stroke Trail Base": ["2002", "2003"],
    "400 Base": ["2014", "2015"],
    "400 2X4 Base": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
    "400 2X4 Auto Base": ["2003", "2004"],
    "400 4X4 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "400 4X4 Act Base": ["2003", "2004"],
    "400 4X4 Auto Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "400 4X4 Auto Act Base": ["2003", "2004"],
    "400 4X4 Auto Le Base": ["2005", "2006", "2007"],
    "400 4X4 Auto Mrp Base": ["2003", "2004"],
    "400 4X4 Auto Tbx Base": ["2004", "2005", "2006"],
    "400 4x4 Auto TRV Base": ["2006", "2007", "2008", "2009", "2010"],
    "400 4X4 Auto Vp Base": ["2005", "2006"],
    "400 4X4 Mrp Base": ["2003", "2004"],
    "400 4X4 Vp Base": ["2005", "2006"],
    "450 Base": ["2014", "2015"],
    "50 2X4 Base": ["2004", "2005", "2006"],
    "500 Base": ["2014", "2015", "2016", "2017"],
    "500 4X4 Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "500 4X4 Auto Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "500 4X4 Auto Le Base": ["2005", "2006"],
    "500 4X4 Auto Mrp Base": ["2003", "2004"],
    "500 4X4 Auto Tbx Base": ["2002", "2003", "2004", "2005", "2006"],
    "500 4X4 Auto Trv Base": ["2003", "2004", "2005", "2006"],
    "500 4X4 Mrp Base": ["2003", "2004"],
    "500 Xt Base": ["2013", "2014"],
    "550 4x4 Auto Base": ["2009", "2010", "2011"],
    "550 4x4 Auto LE Base": ["2009", "2010"],
    "550 4x4 Auto TRV Base": ["2009", "2010", "2011"],
    "550 Xt Base": ["2013", "2014"],
    "550i Ltd Base": ["2012", "2013"],
    "650 H1 4x4 Auto Base": ["2005", "2006", "2007", "2008", "2010", "2011"],
    "650 H1 4x4 Auto Mud Pro Base": ["2010", "2011"],
    "650 H1 4x4 Auto TRV Base": ["2008", "2009"],
    "650 V-2 4x4 Auto Base": ["2004", "2005", "2006"],
    "650 V-2 4x4 Auto LE/TS Base": ["2004", "2005", "2006"],
    "700 Diesel Base": ["2007", "2008"],
    "700 EFI 4x4 Auto Base": ["2007", "2008"],
    "700 EFI 4x4 Auto TRV Cruiser Base": ["2008", "2009", "2010", "2011"],
    "700 EFI H1 4x4 Auto Base": ["2009", "2010"],
    "700 EFI H1 4x4 Auto LE Base": ["2009", "2010"],
    "700 EFI H1 4x4 Auto Mud Pro Base": ["2009", "2010", "2011"],
    "700 EFI H1 4x4 Auto SE Base": ["2008", "2009"],
    "700 EFI H1 4x4 Auto TRV Base": ["2009", "2010", "2011"],
    "700 S Base": ["2010", "2011"],
    "700 Super Duty Diesel Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "700 TRV GT Base": ["2010", "2011"],
    "700 Xt Base": ["2013", "2014"],
    "700i Ltd Base": ["2012", "2013"],
    "90 Base": ["2015", "2016"],
    "90 2X4 Base": ["2002", "2003", "2004"],
    "90 2x4 4-Stroke Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "AC 120 Sno Pro Base": ["2007", "2008", "2009"],
    "AC 440 Sno Pro Base": ["2003", "2004", "2005", "2006"],
    "AC 440 Sno Pro Modified Base": ["2005", "2006"],
    "AC 600 Sno Pro Base": ["2007", "2008", "2009"],
    "Alterra 400 Base": ["2016", "2017"],
    "Alterra 700 Base": ["2016", "2017"],
    "Alterra 700 XT Base": ["2016", "2017"],
    "Alterra TRV 550 XT Base": ["2016", "2017"],
    "Bearcat 2000 LT Base": ["2015", "2016"],
    "Bearcat 2000 LT ES Base": ["2017", "2018"],
    "Bearcat 2000 XT Base": ["2015", "2016"],
    "Bearcat 2000 XTE Base": ["2015", "2016"],
    "Bearcat 3000 LT Base": ["2016", "2017"],
    "Bearcat 340 Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Bearcat 440 Base": ["1995", "1996", "1997", "1998"],
    "Bearcat 440 I Base": ["1999", "2000"],
    "Bearcat 440 II Base": ["1999", "2000"],
    "Bearcat 454 2x4 Base": ["1997", "1998"],
    "Bearcat 454 4x4 Base": ["1996", "1997", "1998"],
    "Bearcat 550 Base": ["1995", "1996"],
    "Bearcat 570 Base": ["2010", "2011", "2012", "2013", "2014"],
    "Bearcat 570 Long Track Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Bearcat 570 XT Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Bearcat 7000 XT Base": ["2016", "2017", "2018", "2019"],
    "Bearcat 7000 XT GS Base": ["2016", "2017", "2018"],
    "Bearcat Widetrack Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Bearcat Widetrack Turbo Base": ["2006", "2007", "2008"],
    "Bearcat Widetrack Turbo Articulating Base": ["2006", "2007", "2008"],
    "Bearcat XT Base": ["2018", "2019"],
    "Bearcat Z1 XT Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Bearcat Z1 XT GS Base": ["2012", "2013", "2014"],
    "Bearcat Z1 XT Limited Base": ["2011", "2012", "2013", "2014"],
    "CFR 1000 Base": ["2010", "2011"],
    "CFR 8 Base": ["2010", "2011"],
    "Cheetah 440 Base": ["1993", "1994"],
    "Cheetah 500 F/C Base": ["1986", "1987", "1988"],
    "Cheetah 530 L/C Base": ["1986", "1987", "1988"],
    "Cheetah Touring Base": ["1988", "1989", "1990", "1991", "1992"],
    "Cougar Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Cougar 2-Up Base": ["1991", "1992"],
    "Cougar Mountain Cat Base": [
      "1989",
      "1990",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Crossfire 1000 EFI Base": ["2007", "2008", "2009"],
    "Crossfire 1000 EFI Sno Pro Base": ["2007", "2008", "2009"],
    "Crossfire 500 EFI Base": ["2007", "2008", "2009"],
    "Crossfire 600 EFI Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Crossfire 8 Base": ["2010", "2011"],
    "Crossfire 800 EFI Base": ["2007", "2008", "2009", "2010"],
    "Crossfire 800 EFI Sno Pro Base": ["2007", "2008", "2009", "2010", "2011"],
    "Crossfire R 1000 Base": ["2009", "2010"],
    "Crossfire R 8 Base": ["2009", "2010"],
    "Crossfire R 8 LE Base": ["2009", "2010"],
    "DVX 250 Base": ["2006", "2007", "2008"],
    "DVX 300 Base": ["2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "DVX 400 Base": ["2004", "2005", "2006", "2007", "2008"],
    "DVX 400 TS Base": ["2006", "2007"],
    "DVX 90 Base": [
      "2006",
      "2007",
      "2008",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "El Tigre Base": ["1986", "1987"],
    "El Tigre 5000 Base": ["1987", "1988"],
    "El Tigre 6000 Base": ["1984", "1985", "1987", "1988", "1989"],
    "El Tigre 6000 L/C Base": ["1980", "1981"],
    "El Tigr\u00e9 EXT Base": ["1989", "1990", "1991"],
    "El Tigr\u00e9 EXT Mountain Cat Base": ["1989", "1990", "1991"],
    "EXT 550 Base": ["1992", "1993"],
    "EXT 580 Base": ["1994", "1995", "1996"],
    "EXT 580 EFI Base": ["1997", "1998"],
    "EXT 580 EFI Deluxe Base": ["1996", "1997", "1998"],
    "EXT 580 Mountain Cat Base": ["1992", "1993", "1994"],
    "EXT EFI Base": ["1993", "1994", "1995", "1996"],
    "EXT EFI Mountain Cat Base": ["1993", "1994", "1995", "1996"],
    "EXT Powder Special Base": ["1995", "1996"],
    "EXT Special Base": ["1991", "1992"],
    "F1000 EFI Base": ["2007", "2008"],
    "F1000 EFI LXR Base": ["2007", "2008"],
    "F1000 EFI Sno Pro Base": ["2007", "2008", "2009"],
    "F5 Base": ["2013", "2014"],
    "F5 EFI Base": ["2007", "2008", "2009"],
    "F5 EFI LXR Base": ["2007", "2008", "2009", "2010", "2011"],
    "F570 Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "F6 EFI Base": ["2007", "2008"],
    "F6 EFI LXR Base": ["2007", "2008"],
    "F6 EFI Sno Pro Base": ["2007", "2008", "2009", "2010", "2011"],
    "F8 EFI Base": ["2007", "2008", "2009", "2010"],
    "F8 EFI LXR Base": ["2007", "2008", "2009", "2010", "2011"],
    "F8 EFI Sno Pro Base": ["2007", "2008", "2009", "2010", "2011"],
    "F8 Sno Pro Limited Base": ["2010", "2011"],
    "Firecat 500 Base": ["2003", "2004", "2005", "2006"],
    "Firecat 500 Sno Pro Base": ["2003", "2004", "2005", "2006"],
    "Firecat 600 EFI Base": ["2004", "2005", "2006"],
    "Firecat 600 EFI EXT Base": ["2004", "2005"],
    "Firecat 600 EFI R Base": ["2005", "2006"],
    "Firecat 600 EFI Sno Pro Base": ["2004", "2005", "2006"],
    "Firecat 700 Base": ["2004", "2005", "2006"],
    "Firecat 700 EFI Base": ["2003", "2004", "2005", "2006"],
    "Firecat 700 EFI EXT Base": ["2004", "2005"],
    "Firecat 700 EFI R Base": ["2005", "2006"],
    "Firecat 700 EFI Sno Pro Base": ["2003", "2004", "2005", "2006"],
    "Firecat 700 Sno Pro Base": ["2005", "2006"],
    "HDX 500 XT Base": ["2016", "2017"],
    "HDX 700 XT Base": ["2016", "2017"],
    "Jag Base": [
      "1985",
      "1986",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Jag 340 Base": ["1987", "1988", "1989", "1990"],
    "Jag 340 Deluxe Base": ["1988", "1989", "1990", "1998", "1999"],
    "Jag 440 Base": ["1987", "1988", "1998", "1999"],
    "Jag 440 Deluxe Base": ["1998", "1999"],
    "Jag AFS Base": ["1989", "1990", "1991"],
    "Jag AFS Deluxe Base": ["1990", "1991"],
    "Jag AFS Long Track Base": ["1990", "1991"],
    "Jag AFS LT 1 Speed Base": ["1992", "1993"],
    "Jag AFS LT 2 Speed Base": ["1992", "1993"],
    "Jag Deluxe Base": ["1992", "1993", "1994", "1995", "1996", "1997"],
    "Jag Mountain Cat Base": ["1990", "1991"],
    "Jag Z Base": ["1993", "1994"],
    "Jaguar Z1 1100 EFI Base": ["2007", "2008"],
    "King Cat 900 Base": ["2004", "2005"],
    "King Cat 900 EFI Base": ["2005", "2006"],
    "Kitty Cat Base": [
      "1980",
      "1981",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
    ],
    "Lynx Base": ["1991", "1992", "1993"],
    "Lynx 2000 Base": ["2015", "2016"],
    "Lynx 2000 ES Base": ["2017", "2018", "2019"],
    "Lynx 2000 LT Base": ["2015", "2016"],
    "Lynx 2000 LT ES Base": ["2017", "2018", "2019"],
    "Lynx Deluxe Base": ["1991", "1992", "1993"],
    "Lynx Mountain Cat Base": ["1992", "1993"],
    "M 6000 Sno Pro 153 Base": ["2014", "2015", "2016", "2017"],
    "M 7000 Sno Pro 153 Base": ["2015", "2016"],
    "M 8000 153 Base": ["2014", "2015"],
    "M 8000 HCR 153 Base": ["2014", "2015", "2016", "2017"],
    "M 8000 Limited 153 Base": ["2014", "2015", "2016", "2017"],
    "M 8000 Limited 162 Base": ["2014", "2015", "2016", "2017"],
    "M 8000 Limited ES 153 Base": ["2014", "2015"],
    "M 8000 Limited ES 162 Base": ["2014", "2015"],
    "M 8000 Mountain Cat 153 Base": ["2017", "2018", "2019"],
    "M 8000 Mountain Cat 162 Base": ["2017", "2018", "2019"],
    "M 8000 Sno Pro 153 Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "M 8000 Sno Pro 162 Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "M 9000 HCR 162 Base": ["2014", "2015"],
    "M 9000 King Cat 162 Base": ["2018", "2019"],
    "M 9000 Limited 162 Base": ["2014", "2015", "2016"],
    "M1000 EFI 153 Base": ["2007", "2008", "2009"],
    "M1000 EFI 153 Sno Pro Base": ["2007", "2008", "2009"],
    "M1000 EFI 162 Base": ["2007", "2008", "2009"],
    "M1000 EFI 162 Sno Pro Base": ["2007", "2008", "2009", "2010", "2011"],
    "M5 Base": ["2005", "2006"],
    "M6 EFI 141 Base": ["2005", "2006", "2007"],
    "M6 EFI 153 Base": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "M7 EFI 141 Base": ["2005", "2006"],
    "M7 EFI 153 Base": ["2005", "2006"],
    "M7 EFI 162 Base": ["2005", "2006"],
    "M8 153 Base": ["2010", "2011"],
    "M8 162 Base": ["2010", "2011"],
    "M8 EFI 153 Base": ["2007", "2008", "2009", "2010"],
    "M8 EFI 153 Sno Pro Base": ["2007", "2008", "2009", "2010"],
    "M8 EFI 162 Base": ["2007", "2008", "2009", "2010"],
    "M8 EFI 162 Sno Pro Base": ["2009", "2010"],
    "M8 HCR 153 Base": ["2009", "2010", "2011"],
    "M8 Sno Pro 153 Base": ["2010", "2011"],
    "M8 Sno Pro 162 Base": ["2010", "2011"],
    "Mountain Cat 1000 Base": ["2001", "2002"],
    "Mountain Cat 570 Base": ["2002", "2003", "2004"],
    "Mountain Cat 600 EFI Base": ["2001", "2002"],
    "Mountain Cat 600 EFI LE Base": ["2001", "2002"],
    "Mountain Cat 800 Base": ["2001", "2002"],
    "Mountain Cat 800 EFI 151 Base": ["2003", "2004"],
    "Mountain Cat 900 151 Base": ["2003", "2004"],
    "MudPro 1000 LTD Base": ["2012", "2013", "2014", "2015"],
    "MudPro 700 LTD Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "Norseman 6000 ES Base": ["2018", "2019"],
    "Pantera Base": [
      "1980",
      "1981",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Pantera 1000 Base": ["2000", "2001"],
    "Pantera 3000 Base": ["2016", "2017", "2018", "2019"],
    "Pantera 550 Base": ["2002", "2003", "2004", "2005"],
    "Pantera 580 EFI Base": ["1999", "2000", "2001"],
    "Pantera 600 EFI Base": ["2004", "2005"],
    "Pantera 600 EFI ESR Base": ["2002", "2003"],
    "Pantera 6000 ES Base": ["2018", "2019"],
    "Pantera 7000 Base": ["2015", "2016"],
    "Pantera 7000 Limited Base": ["2015", "2016", "2017", "2018", "2019"],
    "Pantera 7000 XT Limited Base": ["2016", "2017", "2018", "2019"],
    "Pantera 800 Base": ["1998", "1999"],
    "Pantera 800 EFI ESR Base": ["2002", "2003"],
    "Pantera ES (Electric Start) Base": ["1980", "1981"],
    "Panther Base": [
      "1980",
      "1981",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Panther 340 Base": ["1998", "1999", "2000"],
    "Panther 370 Base": ["2007", "2008"],
    "Panther 370 R Base": ["2005", "2006"],
    "Panther 440 Base": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "Panther 550 Base": ["1997", "1998", "1999", "2000", "2001"],
    "Panther 570 Base": ["2004", "2005", "2006", "2007"],
    "Panther 570 ESR Base": ["2002", "2003"],
    "Panther 660 Touring Base": ["2006", "2007", "2008"],
    "Panther 660 Trail Base": ["2006", "2007"],
    "Panther Deluxe Base": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Panther Mountain Cat Base": ["1990", "1991"],
    "Powder Extreme Base": ["1997", "1998"],
    "Powder Special 500 EFI Base": ["1999", "2000"],
    "Powder Special 600 Base": ["1997", "1998", "1999", "2000"],
    "Powder Special 600 EFI Base": ["1997", "1998", "1999", "2000"],
    "Powder Special 600 EFI LE Base": ["1998", "1999", "2000"],
    "Powder Special 700 Base": ["1999", "2000"],
    "Powder Special 700 LE Base": ["1999", "2000"],
    "ProClimb M 1100 Base": ["2012", "2013"],
    "ProClimb M 1100 Turbo Base": ["2012", "2013"],
    "ProClimb M 1100 Turbo HCR Base": ["2012", "2013"],
    "ProClimb M 1100 Turbo Sno Pro Base": ["2012", "2013"],
    "ProClimb M 1100 Turbo Sno Pro Limited Base": ["2012", "2013"],
    "ProClimb M 800 Base": ["2012", "2013"],
    "ProClimb M 800 HCR Base": ["2012", "2013"],
    "ProClimb M 800 Sno Pro (153) Base": ["2012", "2013"],
    "ProClimb M 800 Sno Pro (162) Base": ["2012", "2013"],
    "ProClimb XF 1100 Turbo Sno Pro High Country Base": ["2012", "2013"],
    "ProClimb XF 800 Sno Pro High Country Base": ["2012", "2013"],
    "ProCross F 1100 LXR Base": ["2012", "2013"],
    "ProCross F 1100 Sno Pro Base": ["2012", "2013"],
    "ProCross F 1100 Sno Pro Limited Base": ["2012", "2013"],
    "ProCross F 1100 Turbo LXR Base": ["2012", "2013"],
    "ProCross F 1100 Turbo Sno Pro Base": ["2012", "2013"],
    "ProCross F 1100 Turbo Sno Pro Limited Base": ["2012", "2013"],
    "ProCross F 800 LXR Base": ["2012", "2013"],
    "ProCross F 800 Sno Pro Base": ["2012", "2013"],
    "ProCross XF 1100 LXR Base": ["2012", "2013"],
    "ProCross XF 1100 Sno Pro Base": ["2012", "2013"],
    "ProCross XF 1100 Sno Pro Limited Base": ["2012", "2013"],
    "ProCross XF 1100 Turbo LXR Base": ["2012", "2013"],
    "ProCross XF 1100 Turbo Sno Pro Base": ["2012", "2013"],
    "ProCross XF 1100 Turbo Sno Pro Limited Base": ["2012", "2013"],
    "ProCross XF 800 LXR Base": ["2012", "2013"],
    "ProCross XF 800 Sno Pro Base": ["2012", "2013"],
    "Prowler Base": ["1990", "1991", "1992", "1993", "1994"],
    "Prowler 2-Up Base": ["1991", "1992", "1993", "1994", "1995"],
    "Prowler 650 H1 Base": ["2006", "2007"],
    "Prowler HDX 500 Base": ["2014", "2015"],
    "Prowler HDX 700i Base": ["2012", "2013"],
    "Prowler Mountain Cat Base": ["1991", "1992"],
    "Prowler Special Base": ["1991", "1992"],
    "Prowler XT 1000 Base": ["2015", "2016", "2017"],
    "Prowler XT 550 Base": ["2010", "2011", "2014", "2015"],
    "Prowler XT 550i Base": ["2012", "2013"],
    "Prowler XT 650 H1 Base": ["2006", "2007"],
    "Prowler XT 700 Base": ["2015", "2016", "2017"],
    "Prowler XTX 700 Base": ["2010", "2011"],
    "Prowler XTX 700 H1 EFI Base": ["2009", "2010", "2011"],
    "Prowler XTX 700 LE Base": ["2008", "2009"],
    "Prowler XTX 700i Base": ["2012", "2013"],
    "Prowler XTZ 1000 Base": ["2010", "2011"],
    "Prowler XTZ 1000 H2 EFI Base": ["2009", "2010", "2011"],
    "Prowler XTZ 1000i Base": ["2012", "2013"],
    "Puma Base": ["1994", "1995", "1996", "1997"],
    "Puma 2-Up Base": ["1994", "1995", "1996", "1997"],
    "Puma Deluxe Base": ["1994", "1995", "1996", "1997"],
    "Riot 8000 1.35in. Base": ["2020", "2021"],
    "Sabercat 500 Base": ["2004", "2005"],
    "Sabercat 500 LX Base": ["2004", "2005"],
    "Sabercat 600 EFI Base": ["2004", "2005"],
    "Sabercat 600 EFI EXT Base": ["2004", "2005"],
    "Sabercat 600 EFI LX Base": ["2004", "2005", "2006"],
    "Sabercat 700 EFI Base": ["2004", "2005"],
    "Sabercat 700 EFI EXT Base": ["2004", "2005", "2006"],
    "Sabercat 700 EFI LX Base": ["2004", "2005", "2006"],
    "Sno Pro 120 Base": ["2010", "2011", "2012", "2013"],
    "Sno Pro 500 Base": ["2010", "2011", "2012", "2013", "2014"],
    "Super Jag Base": ["1987", "1988", "1989", "1990", "1991", "1992"],
    "T500 Base": ["2008", "2009"],
    "T570 Base": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "T660 Touring Base": ["2004", "2005", "2006", "2007", "2008"],
    "T660 Turbo ST Base": ["2005", "2006"],
    "T660 Turbo Touring Base": ["2004", "2005", "2006", "2007"],
    "T660 Turbo Touring LE Base": ["2006", "2007"],
    "T660 Turbo Trail Base": ["2006", "2007"],
    "T660 Turbo Trail LE Base": ["2006", "2007"],
    "TBX 700 Base": ["2014", "2015", "2016", "2017"],
    "Thundercat Base": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Thundercat 1000 4x4 Auto Base": ["2008", "2009", "2010"],
    "Thundercat MC Base": ["1997", "1998", "1999", "2000"],
    "Thundercat Mountain Cat Base": ["1994", "1995", "1996"],
    "Trail Cat 400 Base": ["1980", "1981"],
    "Triple Touring Base": ["1999", "2000", "2001"],
    "TRV 1000 LTD Base": ["2013", "2014", "2015"],
    "TRV 500 Base": ["2014", "2015"],
    "TRV 550 LTD Base": ["2013", "2014", "2015"],
    "TRV 550 XT Base": ["2013", "2014", "2015"],
    "TRV 700 LTD Base": ["2013", "2014", "2015"],
    "TRV 700 XT Base": ["2013", "2014", "2015"],
    "TZ1 Base": ["2010", "2011", "2012", "2013", "2014"],
    "TZ1 LXR Base": ["2010", "2011", "2012", "2013", "2014"],
    "TZ1 Touring Base": ["2008", "2009", "2010"],
    "TZ1 Touring LXR Base": ["2008", "2009", "2010"],
    "TZ1 Turbo LXR Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "TZ1 Turbo LXR LE Base": ["2009", "2010"],
    "Wildcat Base": ["1991", "1992", "1993"],
    "Wildcat 1000 Base": ["2012", "2013", "2014", "2015"],
    "Wildcat 1000 Ltd Base": ["2013", "2014"],
    "Wildcat 4 1000 Base": ["2013", "2014"],
    "Wildcat 4X Base": ["2014", "2015", "2016", "2017"],
    "Wildcat 4X Limited Base": ["2014", "2015"],
    "Wildcat 650 Base": ["1988", "1989", "1990"],
    "Wildcat EFI Base": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "Wildcat EFI Mountain Cat Base": ["1991", "1992"],
    "Wildcat Mountain Cat Base": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1995",
      "1996",
    ],
    "Wildcat Mountain Cat EFI Base": ["1993", "1994"],
    "Wildcat Sport Base": ["2015", "2016"],
    "Wildcat Sport Limited Base": ["2015", "2016", "2017"],
    "Wildcat Sport XT Base": ["2015", "2016", "2017"],
    "Wildcat Touring Base": ["1995", "1996"],
    "Wildcat Trail Base": ["2014", "2015", "2016", "2017"],
    "Wildcat Trail Limited Base": ["2015", "2016", "2017"],
    "Wildcat Trail SE Base": ["2016", "2017"],
    "Wildcat Trail XT Base": ["2014", "2015", "2016", "2017"],
    "Wildcat X Base": ["2016", "2017"],
    "Wildcat X 1000 Base": ["2013", "2014", "2015"],
    "Wildcat X Limited Base": ["2014", "2015", "2016", "2017"],
    "XC 450 Base": ["2015", "2016", "2017"],
    "XC 450i Base": ["2011", "2012", "2013", "2014"],
    "XF 6000 Cross Country Limited ES Base": ["2017", "2018", "2019"],
    "XF 6000 Crosstrek ES Base": ["2017", "2018"],
    "XF 6000 High Country Base": ["2015", "2016", "2017"],
    "XF 6000 High Country ES Base": ["2018", "2019"],
    "XF 7000 Crosstour Base": ["2014", "2015", "2016", "2017", "2018"],
    "XF 7000 Crosstrek Base": ["2016", "2017", "2018"],
    "XF 7000 High Country Base": ["2015", "2016"],
    "XF 7000 Limited Base": ["2014", "2015"],
    "XF 7000 LXR Base": ["2014", "2015"],
    "XF 7000 Sno Pro Base": ["2014", "2015"],
    "XF 8000 Cross Country Limited ES Base": ["2017", "2018", "2019"],
    "XF 8000 Crosstour Base": ["2014", "2015"],
    "XF 8000 Crosstrek ES Base": ["2017", "2018"],
    "XF 8000 High Country Base": ["2015", "2016", "2017", "2018", "2019"],
    "XF 8000 High Country Limited Base": ["2014", "2015", "2016"],
    "XF 8000 High Country Limited ES 141 Base": ["2017", "2018", "2019"],
    "XF 8000 High Country Limited ES 153 Base": ["2017", "2018", "2019"],
    "XF 8000 Limited Base": ["2014", "2015"],
    "XF 8000 LXR Base": ["2014", "2015"],
    "XF 8000 Sno Pro Base": ["2014", "2015"],
    "XF 9000 Cross Country Limited Base": ["2017", "2018", "2019"],
    "XF 9000 Crosstour Base": ["2014", "2015"],
    "XF 9000 Crosstrek Base": ["2016", "2017", "2018"],
    "XF 9000 High Country Limited Base": ["2014", "2015", "2016"],
    "XF 9000 High Country Limited 141 Base": ["2017", "2018"],
    "XF 9000 High Country Limited 153 Base": ["2017", "2018", "2019"],
    "XF 9000 Limited Base": ["2014", "2015"],
    "XF 9000 LXR Base": ["2014", "2015"],
    "XF 9000 Sno Pro Base": ["2014", "2015"],
    "Z 120 Base": ["2000", "2001"],
    "Z 370 Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Z 370 ES Base": ["2000", "2001", "2002"],
    "Z 370 LX Base": ["2004", "2005", "2006", "2007"],
    "Z 440 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Z 440 ES Base": ["2000", "2001", "2002"],
    "Z 440 LX Base": ["2004", "2005", "2006"],
    "Z 440 Sno Pro Base": ["1999", "2000", "2001", "2002", "2003"],
    "Z 570 Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "Z 570 ESR Base": ["2002", "2003"],
    "Z 570 LX Base": ["2004", "2005", "2006", "2007"],
    "Z1 1100 EFI Base": ["2009", "2010"],
    "Z1 1100 EFI LXR Base": ["2009", "2010", "2011"],
    "Z1 Turbo Base": ["2009", "2010"],
    "Z1 Turbo EXT Base": ["2010", "2011"],
    "Z1 Turbo LXR Base": ["2009", "2010", "2011"],
    "Z1 Turbo Sno Pro Base": ["2009", "2010", "2011"],
    "Z1 Turbo Sno Pro Limited Base": ["2010", "2011"],
    "ZL 440 Base": ["1997", "1998", "1999", "2000"],
    "ZL 500 Base": ["1998", "1999", "2000"],
    "ZL 500 EFI Base": ["1999", "2000"],
    "ZL 550 Base": ["2001", "2002", "2003"],
    "ZL 550 ESR Base": ["2000", "2001", "2002", "2003"],
    "ZL 600 Base": ["1999", "2000"],
    "ZL 600 EFI Base": ["1999", "2000", "2001", "2002", "2003"],
    "ZL 600 EFI ESR Base": ["2001", "2002", "2003"],
    "ZL 600 EFI SS Base": ["2002", "2003"],
    "ZL 600 EFI SS ESR Base": ["2002", "2003"],
    "ZL 800 EFI ESR Base": ["2002", "2003"],
    "ZL 800 EFI SS Base": ["2002", "2003"],
    "ZR 120 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "ZR 3000 Base": ["2018", "2019"],
    "ZR 4000 LXR Base": ["2015", "2016", "2017"],
    "ZR 4000 RR Base": ["2015", "2016"],
    "ZR 440 Base": ["1993", "1994", "1995", "1996", "1997", "1998"],
    "ZR 440 Sno Pro Base": ["1998", "1999", "2000", "2001", "2002"],
    "ZR 500 Base": ["1998", "1999", "2000", "2001", "2002"],
    "ZR 500 EFI Base": ["1999", "2000", "2001"],
    "ZR 5000 LXR Base": ["2014", "2015", "2016", "2017"],
    "ZR 580 Base": ["1993", "1994", "1995", "1996"],
    "ZR 580 EFI Base": ["1995", "1996", "1997"],
    "ZR 600 Base": ["1998", "1999", "2000", "2001", "2002"],
    "ZR 600 EFI Base": ["1998", "1999", "2000", "2001", "2002"],
    "ZR 600 EFI LE Base": ["1998", "1999", "2000", "2001"],
    "ZR 6000 El Tigre Base": ["2014", "2015", "2016"],
    "ZR 6000 El Tigre ES 129 Base": ["2017", "2018"],
    "ZR 6000 El Tigre ES 137 Base": ["2017", "2018"],
    "ZR 6000 ES 129 Base": ["2018", "2019"],
    "ZR 6000 ES 137 Base": ["2018", "2019"],
    "ZR 6000 Limited ES 129 Base": ["2017", "2018", "2019"],
    "ZR 6000 Limited ES 137 Base": ["2017", "2018", "2019"],
    "ZR 6000 RR Base": ["2014", "2015", "2016"],
    "ZR 6000 RR ES 137 Base": ["2017", "2018", "2019"],
    "ZR 6000 Sno Pro ES 129 Base": ["2017", "2018", "2019"],
    "ZR 6000 Sno Pro ES 137 Base": ["2017", "2018", "2019"],
    "ZR 700 Base": ["1994", "1995", "1999", "2000"],
    "ZR 7000 137 Base": ["2018", "2019"],
    "ZR 7000 El Tigre Base": ["2015", "2016", "2017"],
    "ZR 7000 Limited Base": ["2014", "2015"],
    "ZR 7000 Limited 137 Base": ["2016", "2017", "2018", "2019"],
    "ZR 7000 LXR Base": ["2014", "2015"],
    "ZR 7000 LXR 129 Base": ["2016", "2017"],
    "ZR 7000 LXR 137 Base": ["2016", "2017"],
    "ZR 7000 RR Base": ["2015", "2016"],
    "ZR 7000 Sno Pro Base": ["2014", "2015"],
    "ZR 7000 Sno Pro 137 Base": ["2016", "2017", "2018"],
    "ZR 800 Base": ["2001", "2002"],
    "ZR 800 EFI Base": ["2002", "2003"],
    "ZR 8000 El Tigre Base": ["2015", "2016"],
    "ZR 8000 El Tigre ES 129 Base": ["2017", "2018"],
    "ZR 8000 El Tigre ES 137 Base": ["2017", "2018"],
    "ZR 8000 ES 129 Base": ["2018", "2019"],
    "ZR 8000 ES 137 Base": ["2018", "2019"],
    "ZR 8000 Limited Base": ["2014", "2015"],
    "ZR 8000 Limited ES 129 Base": ["2017", "2018", "2019"],
    "ZR 8000 Limited ES 137 Base": ["2017", "2018", "2019"],
    "ZR 8000 LXR Base": ["2014", "2015"],
    "ZR 8000 RR Base": ["2014", "2015", "2016"],
    "ZR 8000 RR ES 129 Base": ["2017", "2018", "2019"],
    "ZR 8000 RR ES 137 Base": ["2017", "2018", "2019"],
    "ZR 8000 Sno Pro Base": ["2014", "2015"],
    "ZR 8000 Sno Pro ES 129 Base": ["2017", "2018", "2019"],
    "ZR 8000 Sno Pro ES 137 Base": ["2017", "2018", "2019"],
    "ZR 900 Base": ["2003", "2004", "2005"],
    "ZR 900 EFI Base": ["2004", "2005", "2006"],
    "ZR 900 EFI Sno Pro Base": ["2004", "2005", "2006"],
    "ZR 900 Sno Pro Base": ["2003", "2004", "2005"],
    "ZR 9000 El Tigre Base": ["2015", "2016"],
    "ZR 9000 Limited Base": ["2014", "2015"],
    "ZR 9000 Limited 129 Base": ["2016", "2017"],
    "ZR 9000 Limited 137 Base": ["2016", "2017"],
    "ZR 9000 LXR Base": ["2014", "2015", "2016", "2017"],
    "ZR 9000 RR Base": ["2014", "2015", "2016"],
    "ZR 9000 RR 137 Base": ["2017", "2018", "2019"],
    "ZR 9000 Sno Pro Base": ["2014", "2015"],
    "ZR 9000 Sno Pro 129 Base": ["2018", "2019"],
    "ZR 9000 Sno Pro 137 Base": ["2016", "2017", "2018", "2019"],
    "ZR 9000 Thundercat Base": ["2017", "2018", "2019"],
    "ZRT 600 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "ZRT 800 Base": ["1995", "1996", "1997", "1998", "1999", "2000", "2001"],
    "Prowler EV": ["2018", "2019"],
    "Prowler EV iS": ["2018", "2019"],
    "400 2X4 Auto FIS": ["2003", "2004"],
    "400 2X4 Fis": ["2002", "2003", "2004"],
    "Prowler Pro Base": ["2020", "2021"],
    "Prowler Pro Crew Base": ["2020", "2021"],
    "Prowler Pro Crew LTD Base": ["2022", "2023"],
    "Prowler Pro Crew XT Base": ["2022", "2023"],
    "Prowler Pro LTD Base": ["2022", "2023"],
    "Prowler Pro XT Base": ["2022", "2023"],
    "Wildcat XX Base": ["2020", "2021"],
    "Prowler 500 Base": ["2020", "2021"],
  },
  "Can-Am": {
    "Spyder GS": ["2008", "2009"],
    "Spyder RS": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Spyder RS-S": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "Spyder RT": [
      "2010",
      "2011",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Spyder RT Audio/Convenience": ["2010", "2011", "2012"],
    "Spyder RT-S": ["2010", "2011", "2013", "2014", "2015", "2016", "2017"],
    "DS 450": ["2008", "2009", "2010", "2011", "2012", "2014", "2015"],
    "Commander 1000": ["2011", "2012", "2013", "2014", "2015"],
    "Commander 1000 DPS": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Commander 1000 Ltd": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Commander 1000 X": ["2011", "2012", "2013"],
    "Commander 1000 XT": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Commander 800": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Commander 800 DPS": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Commander 800 XT": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Outlander 1000 DPS [IRS]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Outlander 1000 XMR [IRS]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander 1000 XT [IRS]": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander 1000 XT-P [IRS]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander 400 HO 4x4 EFI XT [IRS]": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Outlander 400 HO 4x4 EFI [IRS]": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander 400 HO 4X4 XT [IRS]": ["2007", "2008"],
    "Outlander 500": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2023",
      "2024",
    ],
    "Outlander 500 DPS": ["2013", "2014", "2015", "2023", "2024"],
    "Outlander 500 XT": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander 650 DPS [IRS]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Outlander 650 XT [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Outlander 650 XT-P [IRS]": ["2010", "2011"],
    "Outlander 650 [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Outlander 800 DPS [IRS]": ["2013", "2014", "2015"],
    "Outlander 800 XT [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander 800 XT-P [IRS]": ["2010", "2011", "2013", "2014", "2015"],
    "Outlander 800 [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander Max 1000 DPS [IRS]": ["2013", "2014", "2015"],
    "Outlander Max 1000 XT [IRS]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander Max 1000 XT-P [IRS]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander MAX 400 EFI XT [IRS]": ["2010", "2011", "2012", "2013", "2014"],
    "Outlander MAX 400 EFI [IRS]": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander MAX 400 HO [IRS]": ["2007", "2008"],
    "Outlander Max 500 DPS [IRS]": ["2013", "2014", "2015"],
    "Outlander Max 500 XT [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander Max 500 [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Outlander Max 650 DPS [IRS]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Outlander Max 650 XT [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Outlander Max 650 XT-P [IRS]": ["2010", "2011", "2012", "2016", "2017"],
    "Outlander Max 650 [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander Max 800 DPS [IRS]": ["2013", "2014", "2015"],
    "Outlander Max 800 LTD [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Outlander Max 800 XT [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander Max 800 XT-P [IRS]": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander Max 800 [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Renegade 1000 XXC [IRS]": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Renegade 1000 [IRS]": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Renegade 500 [IRS]": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Renegade 800 X [IRS]": ["2008", "2009"],
    "Renegade 800 XXC [IRS]": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Renegade 800 [IRS]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Maverick X3 DS Turbo Base": ["2021", "2022", "2023", "2024"],
    "Maverick X3 DS Turbo R Base": ["2020", "2021"],
    "Maverick X3 DS Turbo RR Base": ["2022", "2023", "2024"],
    "Maverick X3 Max DS Turbo Base": ["2021", "2022", "2023", "2024"],
    "Maverick X3 Max DS Turbo R Base": ["2020", "2021"],
    "Maverick X3 Max DS Turbo RR Base": ["2022", "2023", "2024"],
    "Maverick X3 Max RS Turbo R Base": ["2020", "2021"],
    "Maverick X3 Max RS Turbo RR Base": ["2022", "2023", "2024"],
    "Maverick X3 Max X DS Turbo RR Base": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick X3 Max X MR Turbo RR Base": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick X3 Max X RS Turbo RR Base": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick X3 Max X rs Turbo RR Smart-Shox Base": [
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick X3 RS Turbo R Base": ["2020", "2021"],
    "Maverick X3 RS Turbo RR Base": ["2022", "2023", "2024"],
    "Maverick X3 X ds Turbo RR Base": ["2020", "2021", "2022", "2023", "2024"],
    "Maverick X3 X MR Turbo Base": ["2018", "2019", "2020", "2021"],
    "Maverick X3 X MR Turbo RR Base": ["2020", "2021"],
    "Maverick X3 X mr Turbo RR 64 Base": ["2022", "2023", "2024"],
    "Maverick X3 X mr Turbo RR 72 Base": ["2022", "2023", "2024"],
    "Maverick X3 X RC Turbo Base": ["2018", "2019", "2020", "2021"],
    "Maverick X3 X RC Turbo RR Base": ["2020", "2021"],
    "Maverick X3 X rc Turbo RR 64 Base": ["2022", "2023", "2024"],
    "Maverick X3 X rc Turbo RR 72 Base": ["2022", "2023", "2024"],
    "Maverick X3 X RS Turbo RR Base": ["2020", "2021", "2022", "2023", "2024"],
    "Maverick X3 X rs Turbo RR Smart-Shox Base": [
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Spyder GS (SM5) Base": ["2008", "2009"],
    "Spyder RS (SE5) Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Spyder RS (SM5) Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Spyder RS-S (SE5) Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Spyder RS-S (SM5) Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Maverick X3 Max Turbo Base": ["2018", "2019", "2020"],
    "Maverick X3 Max Turbo R Base": ["2017", "2018", "2019"],
    "Maverick X3 Max X DS Turbo R Base": ["2017", "2018", "2019"],
    "Maverick X3 Max X RS Turbo R Base": ["2017", "2018", "2019"],
    "Maverick X3 Turbo Base": ["2018", "2019", "2020"],
    "Maverick X3 Turbo R Base": ["2017", "2018", "2019"],
    "Maverick X3 X ds Turbo R Base": ["2017", "2018", "2019"],
    "Maverick X3 X MR Turbo R Base": ["2018", "2019"],
    "Maverick X3 X RC Turbo R Base": ["2018", "2019"],
    "Maverick X3 X RS Turbo R Base": ["2017", "2018", "2019"],
    "Spyder RT (SE5) Base": ["2010", "2011"],
    "Spyder RT (SE5) Audio/Convenience Base": ["2010", "2011", "2012"],
    "Spyder RT (SM5) Base": ["2010", "2011", "2012", "2013"],
    "Spyder RT (SM5) Audio/Convenience Base": ["2010", "2011", "2012"],
    "Spyder RT Limited (SE5) Base": ["2010", "2011", "2012", "2013"],
    "Spyder RT-S (SE5) Base": ["2012", "2013"],
    "Spyder RT-S (SM5) Base": ["2012", "2013"],
    "Spyder ST (SE5) Base": ["2013", "2014", "2015"],
    "Spyder ST (SM5) Base": ["2013", "2014", "2015"],
    "Spyder ST Limited (SE5) Base": ["2013", "2014", "2015"],
    "Spyder ST-S (SE5) Base": ["2013", "2014", "2015", "2016"],
    "Spyder ST-S (SM5) Base": ["2013", "2014", "2015"],
    "Maverick X3 DS Turbo R": ["2020", "2021"],
    "Maverick X3 Max DS Turbo R": ["2020", "2021"],
    "Maverick X3 Max RS Turbo R": ["2020", "2021"],
    "Maverick X3 Max Turbo": ["2018", "2019", "2020"],
    "Maverick X3 Max Turbo R": ["2017", "2018", "2019"],
    "Maverick X3 Max XDS Turbo R": ["2017", "2018", "2019"],
    "Maverick X3 Max XDS Turbo RR 64": ["2020", "2021", "2022", "2023"],
    "Maverick X3 Max XMR Turbo RR 72": ["2020", "2021", "2022", "2023"],
    "Maverick X3 Max XRS Turbo R": ["2017", "2018", "2019"],
    "Maverick X3 Max XRS Turbo RR 72": ["2020", "2021", "2022", "2023"],
    "Maverick X3 RS Turbo R": ["2020", "2021"],
    "Maverick X3 Turbo": ["2018", "2019", "2020"],
    "Maverick X3 Turbo R": ["2017", "2018", "2019"],
    "Maverick X3 XDS Turbo R": ["2017", "2018", "2019", "2020"],
    "Maverick X3 XDS Turbo RR 64": ["2020", "2021", "2022", "2023", "2024"],
    "Maverick X3 XMR Turbo": ["2018", "2019", "2020", "2021"],
    "Maverick X3 XMR Turbo R": ["2018", "2019"],
    "Maverick X3 XMR Turbo RR 72": ["2020", "2021", "2022", "2023", "2024"],
    "Maverick X3 XRC Turbo": ["2018", "2019", "2020", "2021"],
    "Maverick X3 XRC Turbo R 72": ["2018", "2019"],
    "Maverick X3 XRC Turbo RR 72": ["2020", "2021", "2022", "2023", "2024"],
    "Maverick X3 XRS Turbo R 72": ["2017", "2018", "2019"],
    "Maverick X3 XRS Turbo RR 72": ["2020", "2021", "2022", "2023", "2024"],
    "Defender HD10 6X6 DPS": ["2020", "2021", "2022", "2023", "2024"],
    "Defender HD10 6x6 LTD": ["2022", "2023", "2024"],
    "Defender HD10 6X6 XT": ["2021", "2022", "2023", "2024"],
    "Defender HD10 DPS": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Defender HD10 LTD": ["2020", "2021", "2022", "2023", "2024"],
    "Defender HD10 Pro DPS": ["2020", "2021", "2022", "2023", "2024"],
    "Defender HD10 Pro Lone Star": ["2021", "2022"],
    "Defender HD10 PRO LTD": ["2021", "2022", "2023", "2024"],
    "Defender HD10 Pro XT": ["2020", "2021", "2022", "2023", "2024"],
    "Defender HD10 XMR": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Defender HD10 XMR W/ Half Doors": ["2023", "2024"],
    "Defender HD10 XT": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick X3 DS Turbo": ["2021", "2022", "2023", "2024"],
    "Maverick X3 DS Turbo RR 64": ["2022", "2023", "2024"],
    "Maverick X3 RS Turbo RR 72": ["2022", "2023", "2024"],
    "Maverick X3 XMR Turbo RR 64": ["2022", "2023", "2024"],
    "Maverick X3 XRC Turbo RR 64": ["2022", "2023", "2024"],
    "Maverick X3 XRS Turbo RR W/Smart-Shox 72": [
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick X3 Max DS Turbo 64": ["2021", "2022", "2023"],
    "Maverick X3 Max XRS Turbo RR W/Smart-Shox 72": ["2021", "2022", "2023"],
    "Maverick 1000": ["2013", "2014", "2015", "2016"],
    "Maverick 1000 DPS": ["2016", "2017", "2018"],
    "Maverick 1000 Turbo": ["2016", "2017"],
    "Maverick 1000 XC": ["2016", "2017", "2018"],
    "Maverick 1000 XC DPS": ["2017", "2018"],
    "Maverick 1000 XDS": ["2015", "2016"],
    "Maverick 1000 XDS DPS": ["2015", "2016"],
    "Maverick 1000 XDS Turbo": ["2015", "2016"],
    "Maverick 1000 XMR": ["2014", "2015", "2016", "2017", "2018"],
    "Maverick 1000 XXC": ["2016", "2017", "2018"],
    "Maverick Max 1000": ["2013", "2014", "2015", "2016"],
    "Maverick Max 1000 DPS": ["2016", "2017", "2018"],
    "Maverick Max 1000 Turbo": ["2016", "2017"],
    "Maverick Max 1000 XDS": ["2014", "2015", "2016"],
    "Maverick Max 1000 XDS Turbo": ["2015", "2016", "2017"],
    "Maverick Max 1000 XMR": ["2017", "2018"],
    "Maverick Max 1000 XRS Turbo": ["2016", "2017"],
    "Commander Max 1000 DPS": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Commander Max 1000 XT": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Defender HD10 XT Cab": ["2016", "2017", "2018", "2019", "2020"],
    "Defender HD10 XT-P": ["2018", "2019", "2020"],
    "Defender HD5": ["2017", "2018", "2019", "2020", "2021"],
    "Defender HD5 DPS": ["2017", "2018", "2019", "2020", "2021"],
    "Defender HD8": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "Defender HD8 DPS": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "Defender HD8 XT": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "Defender HD8 XT Cab": ["2017", "2018", "2019", "2020"],
    "Defender Max HD10 DPS": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Defender Max HD10 Lone Star": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Defender Max HD10 LTD Cab": ["2020", "2021", "2022", "2023"],
    "Defender MAX HD10 XMR": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Defender Max HD10 XT": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Defender Max HD10 XT Cab": ["2018", "2019", "2020"],
    "Defender Max HD8": ["2018", "2019", "2020", "2021"],
    "Defender Max HD8 DPS": ["2017", "2018", "2019", "2020", "2021"],
    "Defender Max HD8 XT": ["2017", "2018", "2019", "2020", "2021"],
    "Commander 1000 XT-P": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Commander Max 1000 Ltd": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Commander Max 800 DPS": ["2016", "2017", "2018", "2019", "2020"],
    "Maverick Sport 1000": ["2019", "2020", "2021", "2022"],
    "Maverick Sport 1000 DPS": ["2019", "2020", "2021", "2022", "2023"],
    "Maverick Sport 1000 XMR": ["2019", "2020", "2021", "2022", "2023"],
    "Maverick Sport 1000 XRC": ["2019", "2020", "2021", "2022", "2023"],
    "Maverick Sport 1000 XXC": ["2020", "2021", "2022", "2023"],
    "Maverick Sport Max 1000 DPS": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick Trail 1000": ["2018", "2019", "2020"],
    "Maverick Trail 1000 DPS": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick Trail 800": ["2018", "2019", "2020", "2021"],
    "Maverick Trail 800 DPS": ["2018", "2019", "2020", "2021"],
    "Ryker 600": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Ryker 900": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Outlander 1000 XXC [IRS]": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander 850 DPS [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander 850 XMR [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander 850 XT [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander 850 XT-P [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander 850 [IRS]": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "Outlander MAX 1000 6x6 DPS [IRS]": ["2020", "2021"],
    "Outlander MAX 1000 6x6 XT [IRS]": ["2019", "2020", "2021", "2022", "2023"],
    "Outlander Max 1000 LTD [IRS]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander Max 850 XT [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Outlander Max 850 XT-P [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Renegade 1000 XMR [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Commander 1000 XMR": ["2022", "2023", "2024"],
    "Commander MAX 1000 XT-P": ["2022", "2023", "2024"],
    "Ryker Rally 900": ["2019", "2020", "2021", "2022", "2023"],
    "Spyder F3": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Maverick Trail 700": ["2022", "2023"],
    "Maverick Trail 700 DPS": ["2022", "2023", "2024"],
    "Defender HD10": ["2016", "2017", "2018"],
    "Defender HD7": ["2022", "2023", "2024"],
    "Defender HD9": ["2022", "2023", "2024"],
    "Defender MAX HD7": ["2022", "2023", "2024"],
    "Defender MAX HD9": ["2022", "2023", "2024"],
    "Maverick Max 1000 XRS": ["2013", "2014", "2015"],
    "Maverick 1000 XRS": ["2013", "2014", "2015"],
    "Maverick 1000 XXC DPS": ["2014", "2015"],
    "Defender HD7 DPS": ["2022", "2023", "2024"],
    "Defender HD9 DPS": ["2022", "2023", "2024"],
    "Defender HD9 DPS Cab": ["2022", "2023", "2024"],
    "Defender HD9 XT": ["2022", "2023", "2024"],
    "Defender MAX HD9 DPS": ["2022", "2023", "2024"],
    "Defender MAX HD9 XT": ["2022", "2023", "2024"],
    "Maverick 1000 XRS DPS": ["2014", "2015"],
    "Maverick Max 1000 XRS DPS": ["2014", "2015"],
    "Maverick X3 Max DS Turbo RR 64": ["2022", "2023"],
    "Maverick X3 Max RS Turbo RR 72": ["2022", "2023"],
    "Outlander 1000 6X6 XT [IRS]": ["2015", "2016", "2017", "2018"],
    "Outlander 400 HO 4x4 [IRS]": ["2007", "2008"],
    "Outlander 450 DPS [IRS]": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Outlander 450 L DPS [IRS]": ["2015", "2016"],
    "Outlander 450 L [IRS]": ["2015", "2016"],
    "Outlander 450 [IRS]": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Outlander 570 DPS [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander 570 XMR [IRS]": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander 570 XT [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander 570 [IRS]": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander 650 6x6 DPS [IRS]": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Outlander 650 6X6 XT [IRS]": ["2015", "2016"],
    "Outlander 650 XMR [IRS]": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Outlander 800 XMR [IRS]": ["2011", "2012"],
    "Outlander 850 North Edition [IRS]": ["2018", "2019", "2020", "2021"],
    "Outlander L Max 450 DPS [IRS]": ["2015", "2016"],
    "Outlander L Max 450 [IRS]": ["2015", "2016"],
    "Outlander Max 400 HO XT [IRS]": ["2007", "2008"],
    "Outlander MAX 450 6x6 DPS [IRS]": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Outlander Max 450 DPS [IRS]": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander Max 450 [IRS]": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander Max 570 DPS [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander Max 570 XT [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander Max 570 [IRS]": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Outlander MAX 650 6x6 DPS [IRS]": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Renegade 570 XMR [IRS]": ["2017", "2018", "2019", "2020", "2021"],
    "Renegade 570 XXC [IRS]": ["2016", "2017", "2018"],
    "Renegade 570 [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Renegade 850 XXC [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Renegade 850 [IRS]": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Commander 700 DPS": ["2022", "2023", "2024"],
    "Outlander 570 MR [IRS]": ["2022", "2023"],
    "Spyder F3-LTD": ["2020", "2021", "2022"],
    "Spyder F3-S": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Spyder F3-T": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "Spyder RT-LTD": ["2020", "2021", "2022", "2023"],
    "Renegade 650 XXC [IRS]": ["2018", "2019"],
    "Commander 700 XT": ["2022", "2023", "2024"],
    "Defender MAX HD10 Lone Star CAB": ["2023", "2024"],
    "Defender Max HD10 XMR W/ Half Doors": ["2023", "2024"],
    "Defender Max HD7 DPS": ["2023", "2024"],
    "DS 90": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "DS 90 X": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "DS 250": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Spyder ST": ["2013", "2014", "2015"],
    "Spyder ST-S": ["2013", "2014", "2015", "2016"],
    "Commander E": ["2014", "2015"],
    "Commander E LSV": ["2014", "2015"],
    "Commander Electric 9KW": ["2013", "2014", "2015"],
    "DS 450 XMX": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "DS 450 XXC": ["2009", "2010", "2011", "2012", "2014", "2015"],
    "DS 70": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Renegade 650 XMR [IRS]": ["2022", "2023", "2024"],
    "Outlander Max 850 DPS": ["2023", "2024"],
    "Renegade 650": ["2023", "2024"],
    "Outlander 500 2WD": ["2023", "2024"],
    "Outlander 700": ["2023", "2024"],
    "Outlander 700 DPS": ["2023", "2024"],
    "Outlander 700 XMR": ["2023", "2024"],
    "Outlander 700 XT": ["2023", "2024"],
    "Outlander Pro HD5": ["2023", "2024"],
    "Outlander Pro HD5 Hunting Edition": ["2023", "2024"],
    "Outlander Pro HD5 XU": ["2023", "2024"],
    "Outlander Pro HD7 XU": ["2023", "2024"],
    "Maverick 1000R DPS Base": ["2016", "2017", "2018"],
    "Maverick 1000R X mr Base": ["2017", "2018"],
    "Maverick 1000R X xc Base": ["2017", "2018"],
    "Maverick 1000R XC Base": ["2016", "2017", "2018"],
    "Maverick 1000R xc DPS Base": ["2017", "2018"],
    "Maverick Max 1000R DPS Base": ["2016", "2017", "2018"],
    "Maverick Max 1000R X mr Base": ["2017", "2018"],
    "Maverick Sport 1000 Base": ["2019", "2020", "2021", "2022"],
    "Maverick Sport 1000R DPS Base": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick Sport 1000R X MR Base": ["2020", "2021", "2022", "2023", "2024"],
    "Maverick Sport 1000R X RC Base": ["2020", "2021", "2022", "2023", "2024"],
    "Maverick Sport 1000R X XC Base": ["2020", "2021", "2022", "2023"],
    "Maverick Sport MAX 1000R DPS Base": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick Trail 1000 Base": ["2019", "2020"],
    "Maverick Trail 1000 DPS Base": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Maverick Trail 700 Base": ["2022", "2023"],
    "Maverick Trail 700 DPS Base": ["2022", "2023", "2024"],
    "Maverick Trail 800 Base": ["2019", "2020", "2021"],
    "Maverick Trail 800 DPS Base": ["2019", "2020", "2021"],
    "Commander 1000 Base": ["2011", "2012", "2013", "2014"],
    "Commander 1000 DPS Base": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Commander 1000 Limited Base": ["2017", "2018"],
    "Commander 1000 Ltd Base": ["2012", "2013", "2014", "2015", "2016"],
    "Commander 1000 Mossy Oak Hunting Edition Base": ["2016", "2017", "2018"],
    "Commander 1000 X Base": ["2011", "2012", "2013"],
    "Commander 1000 XT Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Commander 1000 XT-P Base": ["2014", "2015", "2016", "2017"],
    "Commander 1000R DPS Base": ["2018", "2019", "2020"],
    "Commander 1000R Limited Base": ["2019", "2020"],
    "Commander 1000R XT Base": ["2018", "2019", "2020"],
    "Commander 800R Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Commander 800R DPS Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Commander 800R XT Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Commander DPS 800R Base": ["2013", "2014"],
    "Commander Max 1000 DPS Base": ["2014", "2015", "2016", "2017", "2018"],
    "Commander Max 1000 Limited Base": ["2017", "2018"],
    "Commander Max 1000 Ltd Base": ["2015", "2016"],
    "Commander Max 1000 XT Base": ["2014", "2015", "2016", "2017", "2018"],
    "Commander Max 1000R Limited Base": ["2019", "2020"],
    "Commander Max 1000R XT Base": ["2018", "2019", "2020"],
    "Commander Max 800R DPS Base": ["2017", "2018", "2019", "2020"],
    "Defender DPS HD10 Base": ["2016", "2017", "2018"],
    "Defender DPS HD5 Base": ["2017", "2018", "2019", "2020"],
    "Defender DPS HD8 Base": ["2016", "2017", "2018"],
    "Defender HD10 Base": ["2016", "2017", "2018"],
    "Defender HD10 Mossy Oak Hunting Edition Base": [
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Defender HD10 X MR Base": ["2018", "2019", "2020"],
    "Defender HD10 XT-P Base": ["2018", "2019", "2020"],
    "Defender HD5 Base": ["2017", "2018", "2019", "2020"],
    "Defender HD8 Base": ["2016", "2017", "2018"],
    "Defender Max HD10 DPS Base": ["2017", "2018", "2019", "2020"],
    "Defender Max HD10 Lone Star Base": ["2018", "2019", "2020"],
    "Defender Max HD10 XT Base": ["2017", "2018", "2019", "2020"],
    "Defender Max HD10 XT Cab Base": ["2018", "2019", "2020"],
    "Defender Max HD8 Base": ["2018", "2019", "2020"],
    "Defender Max HD8 DPS Base": ["2017", "2018", "2019", "2020"],
    "Defender Max HD8 XT Base": ["2017", "2018", "2019", "2020"],
    "Defender XT CAB HD10 Base": ["2016", "2017", "2018", "2019", "2020"],
    "Defender XT CAB HD8 Base": ["2018", "2019", "2020"],
    "Defender XT HD10 Base": ["2016", "2017", "2018", "2019", "2020"],
    "Defender XT HD8 Base": ["2016", "2017", "2018", "2019", "2020"],
    "DS 250 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "DS 450 Base": ["2008", "2009", "2010", "2011"],
    "DS 450 X mx Base": ["2009", "2010", "2011", "2013", "2014", "2015"],
    "DS 450 X xc Base": ["2009", "2010", "2011", "2014", "2015"],
    "DS 70 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "DS 90 Base": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "DS 90 X Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Maverick 1000R Base": ["2013", "2014", "2015", "2016"],
    "Maverick 1000R Turbo X ds Base": ["2015", "2016"],
    "Maverick 1000R X ds Base": ["2015", "2016"],
    "Maverick 1000R X mr DPS Base": ["2015", "2016"],
    "Maverick 1000R X xc DPS Base": ["2015", "2016"],
    "Maverick Max 1000R Base": ["2014", "2015"],
    "Maverick Max 1000R Turbo X ds Base": ["2015", "2016", "2017"],
    "Maverick Max 1000R Turbo X rs Base": ["2016", "2017"],
    "Maverick Max 1000R X ds Base": ["2015", "2016"],
    "Maverick Sport 1000 DPS Base": ["2019", "2020"],
    "Maverick X rs 1000R Base": ["2013", "2014"],
    "Outlander 1000 6x6 XT Base": ["2015", "2016", "2017", "2018"],
    "Outlander 1000 DPS Base": ["2017", "2018", "2019"],
    "Outlander 1000 EFI DPS Base": ["2013", "2014", "2015", "2016"],
    "Outlander 1000 EFI XT Base": ["2012", "2013", "2014", "2015", "2016"],
    "Outlander 1000 EFI XT-P Base": ["2013", "2014", "2015", "2016"],
    "Outlander 1000 Mossy Oak Hunting Edition Base": ["2017", "2018", "2019"],
    "Outlander 1000 X mr Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Outlander 1000 X xc Base": ["2018", "2019", "2020"],
    "Outlander 1000 XT Base": ["2017", "2018", "2019", "2020"],
    "Outlander 1000 XT-P Base": ["2017", "2018", "2019", "2020"],
    "Outlander 400 EFI Base": ["2011", "2012", "2013", "2014"],
    "Outlander 400 EFI XT Base": ["2011", "2012", "2013", "2014"],
    "Outlander 400 HO Base": ["2007", "2008"],
    "Outlander 400 HO EFI Base": ["2008", "2009", "2010"],
    "Outlander 400 HO EFI XT Base": ["2008", "2009", "2010"],
    "Outlander 400 HO XT Base": ["2007", "2008"],
    "Outlander 450 Base": ["2017", "2018", "2019", "2020"],
    "Outlander 450 DPS Base": ["2017", "2018", "2019", "2020"],
    "Outlander 450 Mossy Oak Hunting Edition Base": ["2018", "2019", "2020"],
    "Outlander 500 EFI Base": ["2011", "2012", "2013", "2014"],
    "Outlander 500 EFI DPS Base": ["2013", "2014", "2015"],
    "Outlander 500 EFI XT Base": ["2011", "2012", "2013", "2014", "2015"],
    "Outlander 500 HO 4x4 EFI Base": ["2007", "2008", "2009", "2010"],
    "Outlander 500 HO 4x4 EFI XT Base": ["2007", "2008", "2009", "2010"],
    "Outlander 570 Base": ["2017", "2018", "2019", "2020"],
    "Outlander 570 DPS Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlander 570 Mossy Oak Hunting Edition Base": [
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Outlander 570 X mr Base": ["2018", "2019", "2020"],
    "Outlander 570 XT Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlander 650 Base": ["2017", "2018", "2019", "2020"],
    "Outlander 650 6x6 DPS Base": ["2017", "2018"],
    "Outlander 650 6x6 XT Base": ["2015", "2016"],
    "Outlander 650 DPS Base": ["2017", "2018", "2019", "2020"],
    "Outlander 650 EFI Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Outlander 650 EFI DPS Base": ["2013", "2014", "2015", "2016"],
    "Outlander 650 EFI XT Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Outlander 650 EFI XT-P Base": ["2010", "2011"],
    "Outlander 650 HO 4x4 EFI Base": ["2007", "2008", "2009", "2010"],
    "Outlander 650 HO 4x4 EFI XT Base": ["2007", "2008", "2009", "2010"],
    "Outlander 650 North Edition Base": ["2018", "2019"],
    "Outlander 650 X mr Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Outlander 650 XT Base": ["2017", "2018", "2019", "2020"],
    "Outlander 800 HO 4x4 EFI Base": ["2007", "2008", "2009", "2010"],
    "Outlander 800 HO 4x4 EFI XT Base": ["2007", "2008", "2009", "2010"],
    "Outlander 800R EFI Base": ["2011", "2012", "2013", "2014", "2015"],
    "Outlander 800R EFI DPS Base": ["2013", "2014", "2015"],
    "Outlander 800R EFI X mr Base": ["2012", "2013"],
    "Outlander 800R EFI XT Base": ["2011", "2012", "2013", "2014", "2015"],
    "Outlander 800R EFI XT-P Base": ["2010", "2011", "2013", "2014", "2015"],
    "Outlander 850 Base": ["2019", "2020"],
    "Outlander 850 DPS Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlander 850 North Edition Base": ["2018", "2019", "2020"],
    "Outlander 850 X mr Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlander 850 XT Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlander 850 XT-P Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlander L 450 Base": ["2015", "2016"],
    "Outlander L 450 DPS Base": ["2015", "2016"],
    "Outlander L Max 450 Base": ["2015", "2016"],
    "Outlander L Max 450 DPS Base": ["2015", "2016"],
    "Outlander Max 1000 6X6 XT Base": ["2019", "2020"],
    "Outlander Max 1000 EFI DPS Base": ["2013", "2014", "2015"],
    "Outlander Max 1000 EFI LTD Base": ["2013", "2014", "2015", "2016"],
    "Outlander Max 1000 EFI XT Base": ["2013", "2014", "2015", "2016"],
    "Outlander Max 1000 EFI XT-P Base": ["2013", "2014", "2015", "2016"],
    "Outlander Max 1000 Limited Base": ["2017", "2018", "2019", "2020"],
    "Outlander Max 1000 XT Base": ["2017", "2018", "2019", "2020"],
    "Outlander Max 1000 XT-P Base": ["2017", "2018", "2019", "2020"],
    "Outlander Max 400 EFI Base": ["2011", "2012", "2013", "2014"],
    "Outlander Max 400 EFI XT Base": ["2011", "2012", "2013", "2014"],
    "Outlander Max 400 HO Base": ["2007", "2008"],
    "Outlander Max 400 HO EFI Base": ["2008", "2009", "2010"],
    "Outlander Max 400 HO EFI XT Base": ["2008", "2009", "2010"],
    "Outlander Max 400 HO XT Base": ["2007", "2008"],
    "Outlander Max 450 Base": ["2017", "2018", "2019", "2020"],
    "Outlander Max 450 DPS Base": ["2017", "2018", "2019", "2020"],
    "Outlander Max 500 EFI Base": ["2011", "2012", "2013", "2014"],
    "Outlander Max 500 EFI DPS Base": ["2013", "2014", "2015"],
    "Outlander Max 500 EFI XT Base": ["2011", "2012", "2013", "2014", "2015"],
    "Outlander Max 500 HO EFI Base": ["2007", "2008", "2009", "2010"],
    "Outlander Max 500 HO EFI XT Base": ["2007", "2008", "2009", "2010"],
    "Outlander Max 570 Base": ["2017", "2018", "2019", "2020"],
    "Outlander Max 570 DPS Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlander Max 570 XT Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlander Max 650 6X6 DPS Base": ["2019", "2020"],
    "Outlander Max 650 DPS Base": ["2017", "2018", "2019", "2020"],
    "Outlander Max 650 EFI Base": ["2011", "2012", "2013", "2014", "2015"],
    "Outlander Max 650 EFI DPS Base": ["2013", "2014", "2015", "2016"],
    "Outlander Max 650 EFI XT Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Outlander Max 650 EFI XT-P Base": ["2010", "2011", "2012"],
    "Outlander Max 650 HO EFI Base": ["2007", "2008", "2009", "2010"],
    "Outlander Max 650 HO EFI XT Base": ["2007", "2008", "2009", "2010"],
    "Outlander Max 650 North Edition Base": ["2018", "2019"],
    "Outlander Max 650 XT Base": ["2017", "2018", "2019", "2020"],
    "Outlander Max 800 HO EFI Base": ["2007", "2008", "2009", "2010"],
    "Outlander Max 800 HO EFI LTD Base": ["2007", "2008", "2009", "2010"],
    "Outlander Max 800 HO EFI XT Base": ["2007", "2008", "2009", "2010"],
    "Outlander Max 800R EFI Base": ["2011", "2012"],
    "Outlander Max 800R EFI DPS Base": ["2013", "2014", "2015"],
    "Outlander Max 800R EFI LTD Base": ["2011", "2012"],
    "Outlander Max 800R EFI XT Base": ["2011", "2012", "2013", "2014", "2015"],
    "Outlander Max 800R EFI XT-P Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Outlander Max 850 North Edition Base": ["2018", "2019", "2020"],
    "Outlander Max 850 XT Base": ["2016", "2017", "2018", "2019", "2020"],
    "Outlander Max 850 XT-P Base": ["2016", "2017", "2018", "2019", "2020"],
    "Renegade 1000 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Renegade 1000 X mr Base": ["2016", "2017", "2018", "2019", "2020"],
    "Renegade 1000 X xc Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Renegade 500 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Renegade 570 Base": ["2016", "2017", "2018", "2019", "2020"],
    "Renegade 570 X mr Base": ["2017", "2018", "2019", "2020"],
    "Renegade 800 Base": ["2007", "2008", "2009", "2010"],
    "Renegade 800 X Base": ["2008", "2009", "2010"],
    "Renegade 800 X xc Base": ["2010", "2011"],
    "Renegade 800R Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Renegade 800R X xc Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Renegade 850 Base": ["2016", "2017", "2018", "2019", "2020"],
    "Renegade 850 X xc Base": ["2016", "2017", "2018", "2019", "2020"],
    "Ryker 600 ACE Base": ["2019", "2020"],
    "Ryker 900 ACE Base": ["2019", "2020"],
    "Spyder F3 (SE6) Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Spyder F3 (SM6) Base": ["2015", "2016", "2017"],
    "Spyder F3 Limited (SE6) Base": ["2016", "2017", "2018", "2019", "2020"],
    "Spyder F3-S (SE6) Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Spyder F3-S (SM6) Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Spyder F3-S Special Series (SE6) Base": ["2019", "2020"],
    "Spyder F3-T (SE6) Base": ["2016", "2017", "2018", "2019", "2020"],
    "Spyder F3-T (SM6) Base": ["2016", "2017"],
    "Spyder RT (SE6) Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Spyder RT (SM6) Base": ["2014", "2015", "2016", "2017", "2018"],
    "Spyder RT Limited (SE6) Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Spyder RT-S (SE6) Base": ["2014", "2015", "2016", "2017"],
    "Spyder RT-S (SM6) Base": ["2014", "2015", "2016"],
    "Renegade 110 EFI Base": ["2023", "2024"],
    "Renegade 110 EFI X xc Base": ["2023", "2024"],
    "Renegade 70 EFI Base": ["2023", "2024"],
    "Ryker Sport 900": ["2022", "2023"],
    "Spyder RT Sea-to-Sky": ["2022", "2023"],
  },
  Bombardier: {
    "DS 650": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "DS 650 Baja": ["2001", "2002", "2003", "2004"],
    "Ds 650 Racer": ["2000", "2001", "2002", "2003"],
    "DS 650X": ["2005", "2006"],
    "Outlander 330 HO 2x4 [IRS]": ["2003", "2004", "2005"],
    "Outlander 330 HO 4x4 [IRS]": ["2003", "2004", "2005"],
    "Outlander 400 HO 2x4 [IRS]": ["2003", "2004", "2005", "2006"],
    "Outlander 400 HO 4X4 XT [IRS]": ["2003", "2004", "2005", "2006"],
    "Outlander 400 HO 4x4 [IRS]": ["2003", "2004", "2005", "2006"],
    "Outlander Max 400 HO XT [IRS]": ["2004", "2005", "2006"],
    "Outlander MAX 400 HO [IRS]": ["2004", "2005", "2006"],
    "Quest 500": ["2002", "2003", "2004"],
    "Quest 500 XT": ["2002", "2003", "2004"],
    "Quest 650": ["2002", "2003", "2004"],
    "Quest 650 XT": ["2002", "2003", "2004"],
    Traxter: ["1999", "2000", "2001", "2002", "2003", "2004"],
    "DS 90": ["2002", "2003", "2004", "2005", "2006"],
    "Rally 200": ["2003", "2004", "2005", "2006"],
    "Traxter MAX": ["2003", "2004"],
    "Traxter Max XT": ["2004", "2005"],
    "Traxter XL": ["1999", "2000", "2001", "2002", "2003", "2004", "2005"],
    "Traxter XT": ["2001", "2002", "2003", "2004", "2005"],
    "DS 50": ["2002", "2003", "2004", "2005", "2006"],
    "Quest 50": ["2003", "2004"],
    "DS50 Base": ["2002", "2003", "2004", "2005", "2006"],
    "DS650 Base": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "DS650 Baja Base": ["2001", "2002", "2003", "2004"],
    "DS650 Racer Base": ["2000", "2001", "2002", "2003"],
    "DS650 X Base": ["2005", "2006"],
    "DS90 Base": ["2002", "2003", "2004", "2005", "2006"],
    "DS90 4-Stroke Base": ["2002", "2003", "2004", "2005", "2006"],
    "Outlander 330 HO 2x4 Base": ["2003", "2004", "2005"],
    "Outlander 330 HO 4x4 Base": ["2003", "2004", "2005"],
    "Outlander 400 HO 2x4 Base": ["2003", "2004"],
    "Outlander 400 HO 4x4 Base": ["2003", "2004", "2005", "2006"],
    "Outlander 400 HO 4x4 XT Base": ["2003", "2004", "2005", "2006"],
    "Outlander Max 400 HO Base": ["2004", "2005", "2006"],
    "Outlander Max 400 HO XT Base": ["2004", "2005", "2006"],
    "Quest 50 Base": ["2003", "2004"],
    "Quest 500 4X4 Base": ["2002", "2003", "2004"],
    "Quest 500 4x4 XT Base": ["2002", "2003", "2004"],
    "Quest 650 4x4 Base": ["2002", "2003", "2004"],
    "Quest 650 4x4 XT Base": ["2002", "2003", "2004"],
    "Rally 200 Base": ["2003", "2004", "2005", "2006"],
    "Sarasota 1000 Base": ["2004", "2005"],
    "Traxter 500 4x4 Auto Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Traxter 500 4x4 Auto XT Base": ["2001", "2002", "2003", "2004", "2005"],
    "Traxter 500 XL Base": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "Traxter Max 500 4x4 Auto Base": ["2003", "2004", "2005"],
    "Traxter Max 500 4x4 Auto XT Base": ["2004", "2005"],
  },
  Avanti: {
    "II Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "2001",
      "2002",
      "2003",
      "2004",
    ],
    "Avanti Base": ["2005", "2006", "2007"],
  },
  Hummer: {
    "H2 Base": ["2003", "2004", "2005", "2006", "2007", "2008", "2009"],
    "H3 Alpha": ["2008", "2009", "2010"],
    "H3 Base": ["2006", "2007", "2008", "2009", "2010"],
    "H3 X": ["2007", "2008", "2009"],
    "H3T Alpha": ["2009", "2010"],
    "H3T Base": ["2009", "2010"],
    "H3 Adventure": ["2008", "2009"],
    "H3 Luxury": ["2008", "2009"],
    "H1 Base": ["2002", "2003", "2004"],
  },
  Workhorse: {
    "FasTrack FT1061 Base": ["2002", "2003", "2004", "2005"],
    "FasTrack FT1461 Base": ["2002", "2003", "2004", "2005"],
    "FasTrack FT1601 Base": ["2002", "2003", "2004", "2005"],
    "FasTrack FT1801 Base": ["2002", "2003", "2004", "2005"],
    "FasTrack FT1260 Base": ["2000", "2001"],
    "FasTrack FT1261 Base": ["2002", "2003", "2004", "2005"],
    "FasTrack FT1460 Base": ["2000", "2001", "2002"],
    "FasTrack FT1600 Base": ["2000", "2001"],
    "FasTrack FT1800 Base": ["2000", "2001"],
    "FasTrack FT1802 Base": ["2002", "2003"],
    "FasTrack FT931 Base": ["2002", "2003"],
    "P30 Base": ["2000", "2001", "2002", "2003", "2004", "2005"],
  },
  "Alfa Romeo": {
    "4C Base": ["2015", "2016", "2017", "2018"],
    "4C Spider": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Milano Gold": ["1987", "1988", "1989"],
    "Milano Platinum": ["1987", "1988", "1989"],
    "Milano Verde": ["1987", "1988", "1989"],
    "Spider Base": ["1969", "1970", "1971", "1991", "1992", "1993", "1994"],
    "Spider Graduate": ["1985", "1986", "1987", "1988", "1989", "1990"],
    "Spider Quadrifoglio": ["1986", "1987", "1988", "1989", "1990"],
    "Spider Veloce": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Giulia Speciale": ["1965", "1966"],
    "Giulia Spider": ["1965", "1966", "1967"],
    "Giulia Super": ["1967", "1968"],
    "Giulia TI": [
      "1965",
      "1966",
      "1967",
      "1968",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Giulia Veloce": ["1965", "1966", "2022", "2023", "2024"],
    "Alfetta GT": ["1975", "1976", "1977"],
    "Alfetta Sport": ["1975", "1976", "1977"],
    "GTV-6 2.5": ["1981", "1982", "1983", "1984", "1985", "1986"],
    "Sprint Veloce": ["1977", "1978", "1979"],
    "Giulia Base": ["2017", "2018", "2019", "2020"],
    "Giulia Sport": ["2019", "2020"],
    "Giulia Sprint": ["2021", "2022", "2023", "2024"],
    "164 L": ["1991", "1992", "1993"],
    "164 LS": ["1994", "1995"],
    "164 Quadrifoglio": ["1994", "1995"],
    "164 Sport": ["1991", "1992", "1993"],
    "Giulia Quadrifoglio": ["2017", "2018", "2019", "2020"],
    "Stelvio Base": ["2018", "2019", "2020"],
    "Stelvio Quadrifoglio": ["2018", "2019", "2020"],
    "Stelvio Sport": ["2019", "2020"],
    "Stelvio TI": ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Stelvio Sprint": ["2021", "2022", "2023", "2024"],
    "Stelvio Veloce": ["2022", "2023", "2024"],
  },
  Textron: {
    "Stampede Base": ["2018", "2019"],
    "Stampede 4 Base": ["2018", "2019"],
    "Alterra 700 Base": ["2018", "2019"],
    "Alterra 700 XT Base": ["2018", "2019"],
    "Alterra DVX 90 Base": ["2018", "2019"],
    "Alterra MudPro 700 LTD Base": ["2018", "2019"],
    "Alterra TBX 700 Base": ["2018", "2019"],
    "Prowler 500 Base": ["2018", "2019"],
    "Prowler Pro Base": ["2018", "2019"],
    "Prowler Pro XT Base": ["2018", "2019"],
    "Stampede 4X Base": ["2018", "2019"],
    "Stampede X Base": ["2018", "2019"],
    "Wildcat Sport Ltd Base": ["2018", "2019"],
    "Wildcat Sport XT Base": ["2018", "2019"],
    "Wildcat Trail Base": ["2018", "2019"],
    "Wildcat Trail Ltd Base": ["2018", "2019"],
    "Wildcat Trail XT Base": ["2018", "2019"],
    "Wildcat X Base": ["2018", "2019"],
    "Wildcat X Ltd Base": ["2018", "2019"],
    "Wildcat XX Base": ["2018", "2019"],
  },
  Bugatti: {
    "Veyron 16.4 Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "Veyron 16.4 Grand Sport": ["2014", "2015"],
    "Veyron 16.4 Grand Sport Vitesse": ["2013", "2014", "2015"],
    "Veyron 16.4 Super Sport": ["2014", "2015"],
  },
  Maybach: {
    "57 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "57 S": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "62 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "62 S": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "62 S Landaulet": ["2010", "2011", "2012"],
  },
  Shelby: {
    "Cobra Base": ["1963", "1964", "1965", "1966", "1967"],
    "Series 1 Base": ["1999", "2000"],
  },
  Daewoo: {
    "Nubira CDX": ["1999", "2000", "2001", "2002"],
    "Nubira SE": ["2000", "2001", "2002"],
    "Lanos S": ["1999", "2000", "2001", "2002"],
    "Lanos SE": ["1999", "2000"],
    "Lanos Sport": ["2001", "2002"],
    "Lanos SX": ["1999", "2000"],
    "Leganza CDX": ["1999", "2000", "2001", "2002"],
    "Leganza SE": ["1999", "2000", "2001", "2002"],
    "Leganza SX": ["1999", "2000", "2001"],
  },
  Willys: {
    "MB Base": ["1941", "1942", "1943"],
    "Aero Lark Base": ["1953", "1954"],
    "MA Base": ["1942", "1943"],
    "Station Wagon Base": [
      "1946",
      "1947",
      "1948",
      "1949",
      "1950",
      "1951",
      "1952",
      "1953",
    ],
  },
  Ferrari: {
    "166 Base": ["1951", "1952", "1953"],
    "195 Base": ["1950", "1951", "1952", "1953"],
    "212 Base": ["1950", "1951", "1952", "1953"],
    "250 Europa Base": ["1954", "1955"],
    "250 GT 2+2": ["1962", "1963"],
    "250 GT Base": ["1954", "1955", "1956", "1957", "1958", "1959"],
    "250 GT LWB": ["1960", "1961", "1962"],
    "250 GT SWB": ["1960", "1961", "1962", "1963", "1964"],
    "250 GTE Base": ["1960", "1961"],
    "250 LM Base": ["1963", "1964", "1965"],
    "275 GTB Base": ["1964", "1965", "1966", "1967", "1968"],
    "275 LM Base": ["1964", "1965"],
    "308 GTB Base": ["1975", "1976", "1977", "1978", "1979", "1980"],
    "308 GTB Quattrovalvole": ["1983", "1984", "1985"],
    "308 GTBi Base": ["1981", "1982"],
    "308 GTS Base": ["1977", "1978", "1979", "1980"],
    "308 GTS Quattrovalvole": ["1983", "1984", "1985"],
    "308 GTSi Base": ["1981", "1982"],
    "328 GTB Quattrovalvole": ["1986", "1987", "1988", "1989"],
    "328 GTS Quattrovalvole": ["1986", "1987", "1988", "1989"],
    "330 GT Base": ["1964", "1965", "1966", "1967", "1968"],
    "330 GTC Base": ["1966", "1967", "1968"],
    "330 GTS Base": ["1966", "1967", "1968"],
    "340 America Base": ["1951", "1952", "1953"],
    "342 America Base": ["1951", "1952", "1953"],
    "348 GTB Base": ["1993", "1994"],
    "348 GTS Base": ["1993", "1994"],
    "348 Spider Base": ["1993", "1994", "1995"],
    "348 TB Base": ["1990", "1991", "1992"],
    "348 TS Base": ["1989", "1990", "1991", "1992"],
    "365 GT Base": ["1967", "1968", "1969", "1970", "1971"],
    "365 GT4 2+2": ["1975", "1976"],
    "365 GT4 Base": ["1973", "1974"],
    "365 GT4 BB": ["1975", "1976"],
    "365 GT4 BB Competizione": ["1975", "1976"],
    "365 GTB/4 Daytona": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
    "365 GTC Base": ["1968", "1969", "1970"],
    "365 GTC/4 Base": ["1971", "1972"],
    "365 GTS Base": ["1968", "1969", "1970"],
    "365 GTS/4 Daytona": ["1970", "1971", "1972", "1973", "1974"],
    "375 America Base": ["1951", "1952", "1953", "1954", "1955"],
    "400 Superamerica Base": [
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
    ],
    "410 Superamerica Base": ["1956", "1957", "1958", "1959"],
    "500 Superfast Base": ["1964", "1965", "1966"],
    "599 GTB Fiorano": ["2007", "2008", "2009", "2010"],
    "612 Scaglietti Base": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "California Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Dino 206 GT Base": ["1967", "1968", "1969"],
    "Dino 246 GT Base": ["1969", "1970", "1971", "1972", "1973"],
    "Dino 246 GTS Base": ["1972", "1973"],
    "Dino 308 GT4 Base": ["1975", "1976", "1977", "1978", "1979"],
    "F430 Base": ["2005", "2006", "2007", "2008", "2009"],
    "F430 Scuderia": ["2008", "2009"],
    "F430 Spider": ["2005", "2006", "2007", "2008", "2009"],
    "Mondial Quattrovalvole": ["1983", "1984", "1985"],
    "Mondial 3.2 Base": ["1986", "1987", "1988"],
    "Mondial 3.2 Cabriolet": ["1986", "1987", "1988"],
    "Mondial 8 Base": ["1980", "1981", "1982"],
    "Testarossa Base": ["1985", "1986", "1987", "1988", "1989", "1990", "1991"],
    "360 Challenge": ["2002", "2003"],
    "360 Modena": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "360 Spider": ["2001", "2002", "2003", "2004", "2005"],
    "458 Italia Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "458 Spider Base": ["2012", "2013", "2014", "2015"],
    "488 GTB Base": ["2016", "2017", "2018", "2019"],
    "488 Spider Base": ["2016", "2017", "2018", "2019"],
    "Mondial t Cabriolet": ["1989", "1990", "1991", "1992", "1993"],
    "512 TR Base": ["1992", "1993", "1994"],
    "F355 Berlinetta Base": ["1994", "1995", "1996"],
    "F355 GTS Base": ["1994", "1995", "1996", "1997", "1998"],
    "F355 Spider Base": ["1996", "1997", "1998", "1999"],
    "412 Base": ["1985", "1986", "1987", "1988", "1989"],
    "456 GT Base": ["1995", "1996", "1997", "1998"],
    "456 GTA Base": ["1997", "1998"],
    "456 M Base": ["1999", "2000", "2001"],
    "456 M GT Base": ["2002", "2003", "2004"],
    "456 M GTA Base": ["2002", "2003", "2004"],
    "488 Pista Base": ["2019", "2020"],
    "488 Pista Spider Base": ["2019", "2020"],
    "550 Maranello Base": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "575 M Maranello Base": ["2002", "2003", "2004", "2005"],
    "812 Superfast Base": ["2018", "2019", "2020"],
    "California T Base": ["2015", "2016", "2017"],
    "Enzo Base": ["2003", "2004"],
    "F12 Berlinetta Base": ["2013", "2014", "2015", "2016", "2017"],
    "F12tdf Base": ["2016", "2017"],
    "F40 Base": ["1990", "1991", "1992"],
    "F50 Base": ["1995", "1996", "1997"],
    "FF Base": ["2012", "2013", "2014", "2015", "2016"],
    "GTC4Lusso Base": ["2017", "2018", "2019", "2020"],
    "GTC4Lusso T Base": ["2018", "2019", "2020"],
    "LaFerrari Base": ["2014", "2015"],
    "Portofino Base": ["2018", "2019", "2020"],
    "Roma Base": ["2020", "2021"],
  },
  Sterling: {
    "827 S": ["1989", "1990"],
    "827 Si": ["1990", "1991"],
    "827 SL": ["1989", "1990", "1991"],
    "827 SLi": ["1989", "1990", "1991"],
    "825 S": ["1987", "1988"],
    "825 SL": ["1987", "1988"],
  },
  Argo: {
    "8x8 XTD Base": ["2014", "2015", "2016"],
    "8x8 XTI Base": ["2013", "2014", "2015", "2016"],
    "Conquest 8x8 Outfitter XTi Base": ["2017", "2018"],
    "Conquest 8x8 XTd Base": ["2017", "2018"],
    "6x6 650 HD Base": ["2011", "2012", "2013", "2014"],
    "6x6 750 HDi Base": ["2015", "2016"],
    "6x6 Frontier EFI 694 Base": ["2015", "2016"],
    "6x6 Frontier EFI 747 Base": ["2015", "2016"],
    "8x8 700 HD Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "8x8 750 EFI Base": ["2015", "2016"],
    "8x8 750 HDi Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "8x8 750 HDi SE Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "8x8 Frontier EFI Base": ["2015", "2016"],
    "Avenger 700 8x8 Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Avenger 750 EFI 8x8 Base": ["2007", "2008", "2009", "2010", "2011"],
    "Avenger 8x8 Hunt Master Base": ["2017", "2018"],
    "Avenger 8x8 Hunt Master R Base": ["2017", "2018"],
    "Avenger 8x8 LX Base": ["2017", "2018"],
    "Avenger 8x8 Responder Base": ["2017", "2018"],
    "Avenger 8x8 ST Base": ["2017", "2018"],
    "Avenger 8x8 STR Base": ["2017", "2018"],
    "Centaur 954DT Base": ["2014", "2015"],
    "Conquest 800 Outfitter Base": ["2019", "2020"],
    "Conquest Pro 800 XT Base": ["2019", "2020"],
    "Conquest Pro 800 XT-L Base": ["2019", "2020"],
    "Conquest Pro 800 XT-X Base": ["2019", "2020"],
    "Frontier 580 6x6 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Frontier 600 6x6 Base": ["2019", "2020", "2021"],
    "Frontier 650 6x6 Base": ["2008", "2009", "2010"],
    "Frontier 650 8x8 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2019",
      "2020",
      "2021",
    ],
    "Frontier 6x6 Scout S Base": ["2017", "2018"],
    "Frontier 700 6x6 Base": ["2019", "2020", "2021"],
    "Frontier 700 8x8 Base": ["2019", "2020", "2021"],
    "Frontier 700 Scout 6x6 Base": ["2019", "2020", "2021"],
    "Frontier 8x8 S Base": ["2017", "2018"],
    "Frontier 8x8 Scout S Base": ["2017", "2018"],
    "Vanguard 2 6x6 Base": ["2006", "2007"],
    "Vanguard 6x6 Base": ["2006", "2007"],
    "Xplorer XR 500 Base": ["2018", "2019", "2020"],
    "Xplorer XR 500 EPS Base": ["2018", "2019"],
    "Xplorer XR 500 LE Base": ["2018", "2019", "2020"],
    "Xplorer XRT 1000 LE Base": ["2018", "2019", "2020"],
    "Xplorer XRT 500 Base": ["2018", "2019", "2020"],
    "Xplorer XRT 500 EPS Base": ["2018", "2019"],
    "Xplorer XRT 500 LE Base": ["2018", "2019", "2020"],
    "Aurora 850 SX 8x8 Base": ["2020", "2021"],
    "Aurora 850 SX Hunt Master 8x8 Base": ["2020", "2021"],
    "Aurora 850 SX-R 8x8 Base": ["2020", "2021"],
    "Aurora 950 Bigfoot MX8 Base": ["2020", "2021"],
    "Aurora 950 SX 8x8 Base": ["2020", "2021"],
    "Aurora 950 SX Hunt Master 8x8 Base": ["2020", "2021"],
    "Aurora 950 SX-R 8x8 Base": ["2020", "2021"],
    "Frontier 700 Scout 8x8 Base": ["2020", "2021"],
  },
  Saleen: {
    "S7 Base": ["2002", "2003", "2004"],
    "S7 Twin Turbo": ["2005", "2006"],
  },
  Daihatsu: {
    "Charade CLS": ["1988", "1989"],
    "Charade CLX": ["1988", "1989"],
    "Charade SE": ["1990", "1991", "1992"],
    "Charade SX": ["1990", "1991", "1992"],
    "Rocky SE": ["1990", "1991", "1992"],
    "Rocky SX": ["1990", "1991", "1992"],
  },
  "Sea-Doo": {
    "GTI 90": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "GTI LTD 155": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "GTI SE 130": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GTI SE 155": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "GTI SE 90": ["2017", "2018"],
    "GTR 230": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "GTR-X 230": ["2017", "2018", "2019"],
    "GTS 90": ["2017", "2018"],
    "GTX 155": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "GTX LTD 230": ["2017", "2018", "2019", "2020"],
    "GTX LTD 300": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GTX S 155": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "RXP-X 300": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "RXT 260": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "RXT-X 300": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Spark 2UP": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Spark 2UP HO": ["2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    "Spark 3UP": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Spark Trixx 2UP": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Spark Trixx 3UP": ["2018", "2019", "2020", "2021"],
    "Wake 155": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Wake Pro 230": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "GT 580": ["1990", "1991"],
    "GTS 580": ["1992", "1993", "1994", "1995", "1996"],
    "GTX 580": ["1992", "1993"],
    "SP 580": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "SPI 580": ["1991", "1992", "1993", "1994", "1995", "1996"],
    "XP 580": ["1991", "1992"],
    "GTR 215": ["2012", "2013", "2014", "2015", "2016"],
    "GTX 185": ["2003", "2004", "2005", "2006"],
    "GTX 215": ["2008", "2009", "2011", "2012", "2013"],
    "GTX 230": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "GTX 300": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "GTX LTD 215": ["2005", "2006", "2007", "2008", "2014", "2015", "2016"],
    "GTX LTD iS 260": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "RXP 215": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "RXP-X 255": ["2008", "2009", "2010", "2011"],
    "RXP-X 260": ["2012", "2013", "2014", "2015"],
    "RXT 215": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "RXT 230": ["2018", "2019"],
    "RXT iS 260": ["2010", "2011", "2012"],
    "RXT-X 260": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "GTI 130": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "GTI SE 170": ["2020", "2021", "2022", "2023", "2024"],
    "GTX 170": ["2020", "2021", "2022", "2023"],
    "150 Speedster 155 [Boat]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "150 Speedster 215 [Boat]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "150 Speedster 255 [Boat]": ["2009", "2010", "2011"],
    "150 Sportster 130 LE [Boat]": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
    ],
    "150 Sportster 155 4-TEC [Boat]": ["2003", "2004", "2005", "2006"],
    "150 Sportster 215 [Boat]": ["2005", "2006"],
    "180 Challenger 215 SE [Boat]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "180 Challenger 215 [Boat]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "180 Challenger 255 SE [Boat]": ["2009", "2010", "2011", "2012"],
    "180 Challenger 4-TEC [Boat]": ["2005", "2006"],
    "180 Challenger 430 [Boat]": ["2005", "2006"],
    "200 Speedster 310 Wake [Boat]": ["2006", "2007", "2008"],
    "200 Speedster 310 [Boat]": ["2004", "2005", "2006", "2007", "2008"],
    "200 Speedster 430 Wake [Boat]": ["2006", "2007", "2008", "2009"],
    "200 Speedster 430 [Boat]": ["2006", "2007", "2008", "2009"],
    "200 Speedster 510 [Boat]": ["2010", "2011", "2012"],
    "205 Utopia 310 SE [Boat]": ["2006", "2007", "2008", "2009"],
    "205 Utopia 310 [Boat]": ["2006", "2007", "2008"],
    "205 Utopia 430 SE [Boat]": ["2008", "2009"],
    "210 Challenger 310 SE [Boat]": ["2010", "2011", "2012"],
    "210 Challenger 310 [Boat]": ["2010", "2011"],
    "210 Challenger 430 SE [Boat]": ["2010", "2011", "2012"],
    "210 Wake 310 [Boat]": ["2010", "2011", "2012"],
    "210 Wake 430 [Boat]": ["2010", "2011", "2012"],
    "220 Islandia 310 SE [Boat]": ["2006", "2007"],
    "220 Islandia 430 SE [Boat]": ["2008", "2009"],
    "230 Challenger 310 SE [Boat]": ["2007", "2008", "2010", "2011", "2012"],
    "230 Challenger 310 SP [Boat]": ["2009", "2010"],
    "230 Challenger 310 [Boat]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "230 Challenger 430 SE [Boat]": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "230 Challenger 430 SP [Boat]": ["2009", "2010"],
    "230 Challenger 510 SE [Boat]": ["2009", "2010", "2011", "2012"],
    "230 Wake 430 [Boat]": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "230 Wake 510 [Boat]": ["2009", "2010", "2011", "2012"],
    "3D 800": ["2004", "2005"],
    "GSX 800": ["1996", "1997", "1998", "1999", "2000", "2001"],
    "GTI 720": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
    ],
    "GTI 800": ["2004", "2005"],
    "GTI LTD 720": ["2002", "2003", "2004"],
    "GTI LTD 800": ["2003", "2004", "2005"],
    "GTX 800": ["1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003"],
    "GTX 950": ["2000", "2001", "2002", "2003"],
    "GTX LTD 185": ["2003", "2004"],
    "GTX LTD 950": ["1998", "1999"],
    "FISH PRO 170": ["2020", "2021"],
    "GTS 130": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "GTX iS 215": ["2010", "2011"],
    "RXP-X RS 300": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "RXT-X 255": ["2008", "2009"],
    "RXT-X AS 260": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "RXT-X RS 300": ["2017", "2018", "2019", "2020", "2021", "2022"],
    "Wake 170": ["2020", "2021", "2022", "2023"],
    "Wake Pro 215": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Wake 215": ["2007", "2008"],
    "RX 950": ["2000", "2001", "2002", "2003"],
    "GS 720": ["1997", "1998", "1999", "2000", "2001"],
    "GTX 650": ["1994", "1995"],
    "SPX 650": ["1994", "1995"],
    "XP 650": ["1993", "1994"],
    "GTS 720": ["1997", "1998", "1999", "2000", "2001"],
    "HX 720": ["1995", "1996", "1997"],
    "140 Sportster 85 [Boat]": ["1997", "1998"],
    "150 Challenger 170 [Boat]": ["2000", "2001"],
    "180 Sportster 170 [Boat]": ["1998", "1999"],
    "SPX 800": ["1997", "1998", "1999"],
    "XP 800": ["1996", "1997"],
    "3D 950": ["2006", "2007"],
    "LRV 950": ["2000", "2001", "2002", "2003"],
    "VSP LTD 950": ["1999", "2000", "2001", "2002", "2003"],
    "XP 950": ["2000", "2001", "2002", "2003", "2004"],
    "RXP 155": ["2007", "2008"],
    "GSX LTD 950": ["1997", "1998", "1999"],
    "210 SP 310 [Boat]": ["2011", "2012"],
    "230 SP 430 [Boat]": ["2011", "2012"],
    "130 Explorer [Boat]": ["1993", "1994", "1995", "1996", "1997"],
    "150 Challenger 110 [Boat]": ["1996", "1997"],
    "150 Sportster 85 [Boat]": ["1995", "1996"],
    "180 Challenger 210 [Boat]": ["2000", "2001", "2002", "2003"],
    "180 Challenger 240 [Boat]": ["1997", "1998", "1999", "2001", "2002"],
    "200 Challenger 240 [Boat]": ["2000", "2001"],
    "150 Speedster 160 [Boat]": ["1994", "1995"],
    "XP LTD 950": ["1998", "1999"],
    "160 Speedster 240 [Boat]": ["2003", "2004"],
    "170 Speedster 240 [Boat]": ["2000", "2001", "2002"],
    "185 Utopia 210 [Boat]": ["2001", "2002"],
    "185 Utopia 240 [Boat]": ["2003", "2004", "2005"],
    "200 Challenger 250 X [Boat]": ["2003", "2004", "2005"],
    "200 Challenger 250 [Boat]": ["2002", "2003", "2004"],
    "205 Utopia 240 [Boat]": ["2003", "2004", "2005"],
    "220 Islandia 240 [Boat]": ["2000", "2001", "2002", "2003", "2004"],
    "230 Wake 310 [Boat]": ["2007", "2008"],
    "GTX LTD 215 SCIC": ["2005", "2006"],
    "RX-X 950": ["2001", "2002"],
    "STX 215": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "Explorer Pro 170": ["2023", "2024"],
    "Fish Pro Scout 130": ["2022", "2023"],
    "Fish Pro Sport 170": ["2022", "2023"],
    "Fish Pro Trophy 170": ["2022", "2023", "2024"],
    "150 Speedster Base": ["2011", "2012"],
    "150 Speedster (155 hp) Base": ["2007", "2008", "2009", "2010"],
    "150 Speedster (255 hp) Base": ["2009", "2010"],
    "150 Speedster HO Base": ["2011", "2012"],
    "180 Challenger Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "180 Challenger SE (1.5L HO) Base": ["2011", "2012"],
    "180 Challenger SE (1.5L Supercharged) Base": ["2011", "2012"],
    "1800 Challenger Base": ["1997", "1998", "1999", "2000", "2003", "2004"],
    "1800 Challenger 210 Base": ["2001", "2002"],
    "1800 Challenger 240 EFI Base": ["2001", "2002"],
    "1800 Sportster Base": ["1998", "1999", "2000"],
    "185 Utopia Base": ["2002", "2003", "2004", "2005"],
    "200 Speedster Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
    ],
    "2000 Challenger Base": ["2002", "2003", "2004"],
    "205 Utopia (310 hp) Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "205 Utopia SE (430 hp) Base": ["2006", "2007", "2008", "2009"],
    "210 Challenger Base": ["2010", "2011", "2012"],
    "210 Challenger SE (1.5L) Base": ["2011", "2012"],
    "210 Challenger SE Supercharged (1.5L) Base": ["2011", "2012"],
    "210 SP Base": ["2011", "2012"],
    "210 Wake (1.5L) Base": ["2011", "2012"],
    "210 Wake Supercharged (1.5L) Base": ["2011", "2012"],
    "230 Challenger Base": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "230 Challenger SE Base": ["2011", "2012"],
    "230 Challenger SE (430 hp) Base": ["2009", "2010"],
    "230 Challenger SE (510 hp) Base": ["2009", "2010"],
    "230 Challenger SE HO Base": ["2011", "2012"],
    "230 Challenger SE Supercharged Base": ["2011", "2012"],
    "230 Challenger SP (310 hp) Base": ["2009", "2010"],
    "230 Challenger SP (430 hp) Base": ["2009", "2010"],
    "230 SP Base": ["2011", "2012"],
    "230 Wake Base": ["2007", "2008", "2009", "2011", "2012"],
    "230 Wake (430 hp) Base": ["2009", "2010"],
    "230 Wake (510 hp) Base": ["2009", "2010"],
    "3D 947 DI Base": ["2006", "2007"],
    "Challenger Base": ["1996", "1997", "1998", "2000", "2001"],
    "Challenger X Base": ["2003", "2004", "2005"],
    "Explorer Base": ["1996", "1997"],
    "GS Base": ["1997", "1998", "1999", "2000", "2001"],
    "GSI Base": ["1997", "1998"],
    "GSX Base": ["1996", "1997"],
    "GSX Limited Base": ["1998", "1999"],
    "GSX RFI Base": ["1999", "2000"],
    "GT Base": ["1990", "1991"],
    "GTI Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2017",
      "2018",
    ],
    "GTI 130 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2019",
      "2020",
    ],
    "GTI 90 Base": ["2019", "2020"],
    "GTI LE Base": ["2002", "2003", "2004"],
    "GTI LE RFI Base": ["2003", "2004", "2005"],
    "GTI Limited 155 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "GTI Rental Base": ["2006", "2007"],
    "GTI SE Base": ["2006", "2007", "2017", "2018"],
    "GTI SE 130 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "GTI SE 155 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "GTI STD Base": ["2006", "2007"],
    "GTR 215 Base": ["2012", "2013", "2014", "2015", "2016"],
    "GTR 230 Base": ["2017", "2018", "2019", "2020"],
    "GTR-X 230 Base": ["2017", "2018", "2019"],
    "GTS Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2017",
      "2018",
    ],
    "GTS 130 Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "GTX Base": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "2000",
      "2001",
      "2002",
    ],
    "GTX 155 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "GTX 215 Base": ["2008", "2009", "2011", "2012", "2013"],
    "GTX 230 Base": ["2018", "2019", "2020"],
    "GTX 4-TEC Base": ["2002", "2003", "2004"],
    "GTX 4-TEC Limited Supercharged Base": ["2003", "2004"],
    "GTX 4-TEC STD Base": ["2005", "2006"],
    "GTX 4-TEC Supercharged Base": ["2003", "2004", "2005", "2006"],
    "GTX 4-TEC Wake Base": ["2003", "2004", "2005", "2006"],
    "GTX DI Base": ["2000", "2001", "2002", "2003"],
    "GTX iS 215 Base": ["2010", "2011"],
    "GTX Limited Base": ["1998", "1999"],
    "GTX Limited 215 Base": ["2014", "2015", "2016"],
    "GTX Limited 230 Base": ["2017", "2018", "2019", "2020"],
    "GTX Limited 300 Base": ["2016", "2017", "2018", "2019", "2020"],
    "GTX Limited iS 260 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "GTX RFI Base": ["1998", "1999", "2000", "2001", "2002"],
    "GTX S 155 Base": ["2012", "2013", "2014", "2015", "2016", "2017"],
    "HX Base": ["1995", "1996", "1997"],
    "Islandia Base": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "Islandia SE Base": ["2006", "2007", "2008", "2009", "2010"],
    "LRV Base": ["2000", "2001"],
    "LRV DI Base": ["2002", "2003"],
    "RX Base": ["2000", "2001", "2002"],
    "RX DI Base": ["2000", "2001", "2002", "2003"],
    "RXP Base": ["2005", "2006"],
    "RXP 215 Base": ["2008", "2009", "2010"],
    "RXP X 255 Base": ["2008", "2009", "2010", "2011"],
    "RXP X 260 Base": ["2012", "2013", "2014", "2015"],
    "RXP X 300 Base": ["2016", "2017", "2018", "2019", "2020"],
    "RXT Base": ["2005", "2006"],
    "RXT 215 Base": ["2008", "2009", "2010"],
    "RXT 230 Base": ["2018", "2019"],
    "RXT 260 Base": ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
    "RXT iS 260 Base": ["2010", "2011", "2012"],
    "RXT X 255 Base": ["2008", "2009"],
    "RXT X 260 Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "RXT X 300 Base": ["2016", "2017", "2018", "2019", "2020"],
    "RXT X aS 260 Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "SP Base": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
    ],
    "Spark 2up 900 ACE Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Spark 2up 900 H.O. ACE Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Spark 3up 900 H.O. ACE Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Spark Trixx 2UP Base": ["2018", "2019", "2020"],
    "Spark Trixx 3UP Base": ["2018", "2019", "2020"],
    "Speedster Base": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Speedster SK Base": ["1999", "2000"],
    "Speedster Wake Base": ["2006", "2007", "2008", "2009"],
    "SPI Base": ["1993", "1994", "1995", "1996"],
    "Sportster Base": ["1996", "1997", "1998"],
    "Sportster 4 TEC Base": ["2003", "2004", "2005"],
    "Sportster LE Base": ["2000", "2001", "2002", "2003", "2004", "2005"],
    "SPX Base": ["1993", "1994", "1995", "1996", "1997", "1998", "1999"],
    "Wake 155 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Wake Pro 215 Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Wake Pro 230 Base": ["2017", "2018", "2019", "2020"],
    "XP Base": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "2000",
      "2001",
      "2002",
    ],
    "XP DI Base": ["2003", "2004"],
    "XP Limited Base": ["1998", "1999"],
  },
  "Ski-Doo": {
    'Expedition LE 600 HO E-TEC 154"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    'Expedition LE 900 ACE 154"': [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    'Expedition SE 600 HO E-TEC 154"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    'Expedition SE 900 ACE 154"/1.5"': [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    'Expedition Sport 550 154"': [
      "2005",
      "2006",
      "2007",
      "2008",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    'Expedition Sport 600 ACE 154"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    'Expedition Sport 900 ACE 154"': [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Expedition Sport V-800": ["2007", "2008"],
    "Expedition TUV 600 HO SDI": ["2005", "2006", "2007", "2008", "2009"],
    "Expedition TUV V-800": ["2007", "2008", "2009"],
    'Expedition Xtreme 800R E-TEC 154"': [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    'Grand Touring LE 1200 4-TEC 137"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'Grand Touring LE 600 HO E-TEC 137"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'Grand Touring LE 900 ACE 137"': [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Grand Touring SE 1200 4-TEC 137"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'Grand Touring Sport 600 ACE 137"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    "Grand Touring Sport 600 Carb": [
      "2002",
      "2003",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "GSX 550 Fan": ["2005", "2006", "2007", "2008", "2009"],
    'GSX LE 1200 4-TEC 120"': [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    'GSX LE 600 HO E-TEC 120"': [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "GSX LE 600 HO SDI": ["2004", "2005", "2006", "2007", "2008"],
    "GSX LE 800 HO": ["2004", "2005", "2006"],
    'GSX SE 1200 4-TEC 137"': ["2010", "2011", "2012", "2013", "2014", "2015"],
    'GSX SE 600 HO E-TEC 137"': ["2012", "2013", "2014", "2015"],
    'GSX SE 800R E-TEC 137"': ["2012", "2013", "2014", "2015"],
    "GSX Sport 600 HO": ["2004", "2005"],
    "GSX Sport 600 HO SDI": ["2004", "2005", "2006", "2007"],
    "GTX 550 Fan": ["2005", "2006", "2007", "2008", "2009"],
    "GTX Limited 600 HO SDI": ["2005", "2006", "2007", "2008"],
    "GTX Sport 600 HO SDI": ["2005", "2006", "2007", "2008"],
    "Legend 380 Fan": ["2002", "2003", "2004"],
    "Legend 500 Fan": ["2002", "2003"],
    "Legend Sport 700": ["2002", "2003", "2004"],
    "Legend Touring V-800": ["2007", "2008", "2009"],
    "MX Z 380 Fan": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "MX Z 550 Fan": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "MX Z Adrenaline 800 HO": ["2004", "2005", "2006"],
    "MX Z Adrenaline 800R Power TEK": ["2008", "2009", "2010"],
    'MX Z Blizzard 1200 4-TEC 129"': ["2016", "2017", "2018"],
    'MX Z Blizzard 800R E-TEC 129"': ["2016", "2017"],
    'MX Z Blizzard 900 ACE 129"': ["2016", "2017", "2018"],
    "MX Z Renegade 800": ["2002", "2003"],
    "MX Z Renegade 800 HO": ["2004", "2005", "2006"],
    "MX Z Renegade 800R Power TEK": ["2008", "2009"],
    "MX Z Sport 550": ["2011", "2012", "2013", "2014"],
    'MX Z TNT 1200 4-TEC 129"': [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "MX Z TNT 550": ["2010", "2011", "2012"],
    'MX Z TNT 800R E-TEC 120"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    'MX Z TNT 900 ACE 129"': ["2014", "2015", "2016", "2017", "2018"],
    'MX Z X 1200 4-TEC 129"': [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "MX Z X 550": ["2006", "2007", "2008", "2009"],
    'MX Z X 800R E-TEC 129"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "MX Z X 800R Power TEK": ["2008", "2009", "2010"],
    "MX Z X Renegade 800R Power TEK": ["2008", "2009"],
    'MX Z X-RS 800R E-TEC 129"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    'Renegade Adrenaline 600 HO E-TEC 137"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'Renegade Adrenaline 800R E-TEC 137"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Renegade Adrenaline 800R Power TEK": ["2010", "2011"],
    'Renegade Adrenaline 900 ACE 137"': [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Renegade Backcountry 600 HO E-TEC 146"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'Renegade Backcountry 800R E-TEC 146"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Renegade Backcountry 800R Power TEK": ["2010", "2011"],
    "Renegade Backcountry X 600 HO E-TEC": ["2011", "2012", "2013", "2014"],
    'Renegade Backcountry X 800R E-TEC 146"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    'Renegade Enduro 600 HO E-TEC 137"': ["2016", "2017", "2018"],
    'Renegade Enduro 800R E-TEC 137"': ["2016", "2017", "2018"],
    'Renegade Enduro 900 ACE 137"': [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    'Renegade Sport 600 ACE 137"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Renegade Sport 600 Carb 137"': [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    'Renegade X 600 HO E-TEC 137"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'Renegade X 800R E-TEC 137"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    'Renegade X-RS 800R E-TEC 137"': ["2015", "2016", "2017"],
    "Skandic SUV 550": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "Skandic SUV 600": ["2003", "2004", "2005", "2006", "2007"],
    "Skandic SWT 550": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "Skandic SWT 600 ACE": ["2012", "2013", "2014"],
    'Skandic SWT 600 HO E-TEC 156"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    'Skandic SWT 900 ACE 156"': [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Skandic SWT V-800": ["2007", "2008", "2009", "2010", "2011"],
    "Skandic Tundra 550": ["2010", "2011"],
    "Skandic Tundra LT 550": ["2008", "2009", "2010", "2011"],
    "Skandic Tundra LT V-800": ["2008", "2009"],
    "Skandic Tundra Sport 550": ["2010", "2011"],
    'Skandic WT 550 154"': [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Skandic WT 600": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    'Skandic WT 600 ACE 154"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    'Skandic WT 600 HO E-TEC 154"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    'Skandic WT 900 ACE 154"': [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    "Summit Adrenaline 600 HO SDI": ["2006", "2007", "2008"],
    'Summit Adrenaline 800 HO 144"': ["2003", "2004", "2005", "2006"],
    'Summit Adrenaline 800 HO 151"': ["2005", "2006"],
    'Summit Burton 800R E-TEC 154"': ["2016", "2017"],
    "Summit Everest 600 HO E-TEC": ["2009", "2010", "2011"],
    "Summit Everest 800R Power TEK": ["2008", "2009", "2010", "2011"],
    'Summit SP 600 HO E-TEC 146"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'Summit SP 600 HO E-TEC 154"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'Summit SP 800R E-TEC 146"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    'Summit SP 800R E-TEC 154"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    'Summit SP 800R E-TEC 163"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    'Summit Sport 600 Carb 146"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    'Summit Sport 800R Power TEK 154"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Summit X 600 HO E-TEC": ["2009", "2010", "2011"],
    'Summit X 800R E-TEC 146"': ["2011", "2012", "2013", "2014", "2015"],
    'Summit X 800R E-TEC 154"': ["2011", "2012", "2013", "2014", "2015"],
    'Summit X 800R E-TEC 163"': ["2011", "2012", "2013", "2014", "2015"],
    'Summit X 800R E-TEC with T3 Package 163"': ["2015", "2016"],
    'Summit X 800R E-TEC with T3 Package 174"': ["2015", "2016"],
    'Summit X 800R Power TEK 159"': ["2007", "2008", "2009", "2010"],
    "MX Z Adrenaline 600 HO": ["2003", "2004", "2005", "2006", "2007"],
    "MX Z Adrenaline 600 HO E-TEC": ["2009", "2010"],
    "MX Z Adrenaline 600 HO SDI": ["2004", "2005", "2006", "2007", "2008"],
    'MX Z Blizzard 600 HO E-TEC 129"': ["2016", "2017", "2018"],
    "MX Z Renegade 600 HO": ["2003", "2004", "2005"],
    "MX Z Renegade 600 HO SDI": ["2004", "2005", "2006", "2007", "2008"],
    'MX Z TNT 600 HO E-TEC 129"': [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "MX Z Trail 600 HO": ["2004", "2005"],
    'MX Z X 600 HO E-TEC 129"': [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "MX Z X 600 HO SDI": ["2006", "2007", "2008"],
    "MX Z X Renegade 600 HO SDI": ["2006", "2007", "2008"],
    'MX Z X-RS 600 HO E-TEC 129"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    'MX Z X-RS Iron Dog 600 HO E-TEC 129"': ["2017", "2018"],
    "Summit Adrenaline 600 HO": ["2003", "2004", "2005"],
    'Tundra Xtreme 600 HO E-TEC 154"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    'Expedition LE 900 ACE Turbo 154"': ["2020", "2021", "2022", "2023"],
    'Expedition SE 900 ACE Turbo 154"/1.5"': ["2020", "2021", "2022", "2023"],
    'Expedition SWT 900 ACE 156" Turbo': ["2021", "2022"],
    'Grand Touring LE 900 ACE Turbo 137"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Renegade Adrenaline 900 ACE Turbo 137"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Renegade Enduro 900 ACE Turbo 137"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    'Renegade X 900 ACE Turbo 137"/1.25"': [
      "2019",
      "2020",
      "2021",
      "2024",
      "2025",
    ],
    'Renegade X-RS 900 ACE Turbo 137"': ["2019", "2020", "2021"],
    'Expedition LE 1200 4-TEC 154"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    'Expedition LE 600R E-Tec 154"': [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Expedition SE 600R E-Tec 154"': ["2020", "2021", "2022"],
    'Expedition Sport 600 EFI 154"': ["2021", "2022", "2023", "2024", "2025"],
    'Expedition SWT 600R E-Tec 154"': ["2021", "2022"],
    'Expedition SWT 900 ACE 156"': ["2018", "2019", "2020", "2021", "2022"],
    'Expedition Xtreme 850 E-TEC 154"': [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Freeride 850 E-TEC 146"': ["2018", "2019", "2020", "2021", "2022", "2023"],
    'Freeride 850 E-TEC 154"/2.5"': [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    'Freeride 850 E-TEC 165"': ["2018", "2019", "2020", "2021", "2022", "2023"],
    'Grand Touring LE 900 ACE Turbo R 137"': ["2022", "2023", "2024", "2025"],
    'Grand Touring Sport 900 ACE 137"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Renegade Adrenaline 600R E-TEC 137"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Renegade Adrenaline 850 E-TEC 137"': [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Renegade Adrenaline 900 ACE Turbo R 137"': [
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Renegade Enduro 600R E-TEC 137"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    'Renegade Enduro 850 E-TEC 137"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    'Renegade Enduro 900 ACE Turbo R 137"': ["2022", "2023", "2024"],
    'Renegade X 600R E-TEC 137"': ["2019", "2020", "2021", "2022", "2023"],
    'Renegade X 850 E-TEC 137"': [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Skandic Sport 600 EFI": ["2021", "2022", "2023", "2024", "2025"],
    'Summit Edge 850 E-TEC 154" 2.5': ["2022", "2023"],
    'Summit Edge 850 E-TEC 165"': ["2022", "2023"],
    'Summit Edge 850 E-TEC 175"': ["2022", "2023"],
    'Summit SP 800R E-TEC with T3 Package 174"': ["2016", "2017"],
    'Summit X 850 with Expert Package E-TEC 154"/3.0"': [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Summit X 850 with Expert Package E-TEC 165"/3.0"': [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Tundra LT 600 ACE 154"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "Tundra LT 600 EFI": ["2021", "2022", "2023"],
    'Tundra Sport 600 ACE 137"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    'Tundra Sport 600 ACE 146"': ["2021", "2022", "2023", "2024", "2025"],
    'Tundra Sport 600 EFI 146"': ["2021", "2022", "2023", "2024", "2025"],
    "MX Z Sport 600 EFI": ["2021", "2022", "2023", "2024", "2025"],
    'MX Z TNT 600R E-TEC 129"': ["2019", "2020", "2021", "2022"],
    'MX Z TNT 850 E-TEC 129"': ["2017", "2018", "2019", "2020", "2021", "2022"],
    'MX Z X 600R E-TEC 129"/1.25"': ["2019", "2020", "2021", "2022"],
    'MX Z X 850 E-TEC 129"/1.25"': [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    'MX Z X-RS 600R E-TEC 129"/1.25"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'MX Z X-RS 850 E-TEC 129"/1.25"': [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'MX Z Sport 600 ACE 120"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    'MX Z Sport 600 Carb 120"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    'Renegade Adrenaline 1200 4-TEC 137"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
    ],
    'Renegade Enduro 1200 4-TEC 137"': ["2016", "2017", "2018"],
    'Renegade X 1200 4-TEC 137"': [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    'Renegade X-RS 850 E-TEC 137"': [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    'MX Z Blizzard 850 E-TEC 129"': ["2018", "2019"],
    'Freeride 850 E-TEC 154" Turbo': ["2021", "2022"],
    'Freeride 850 E-TEC 165" Turbo': ["2021", "2022"],
    'Summit SP 850 E-TEC 146"': [
      "2017",
      "2018",
      "2019",
      "2021",
      "2022",
      "2023",
    ],
    'Summit SP 850 E-TEC 154"': ["2017", "2018", "2022", "2023"],
    'Summit SP 850 E-TEC 165"': ["2017", "2018", "2022", "2023"],
    'Summit X 850 E-TEC 154"/3.0"': [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Summit X 850 E-TEC Turbo 154"': ["2021", "2022"],
    'Summit X 850 with Expert Package E-TEC Turbo 175"': ["2021", "2022"],
    'Freeride 800R E-TEC 137"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    'Freeride 800R E-TEC 146"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    'Freeride 800R E-TEC 154"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    'Freeride 850 E-TEC 137"': ["2018", "2019", "2020"],
    'Summit SP 600R E-TEC 146"': ["2019", "2020", "2021", "2022"],
    "Backcountry Sport 600 EFI": ["2021", "2022", "2023"],
    "Renegade Sport 600 EFI": ["2021", "2022", "2023"],
    "Skandic WT 600 EFI": ["2021", "2022"],
    "Alpine II": ["1990", "1991", "1993", "1994", "1995"],
    Elan: ["1990", "1991", "1992", "1993", "1994", "1995", "1996"],
    'Expedition SE 1200 4-TEC 154"': [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Formula 500": ["1997", "1998"],
    "Formula Deluxe 380 Fan": ["1999", "2000", "2001"],
    "Formula Deluxe 500": ["1997", "1998", "1999", "2000", "2001"],
    "Formula Deluxe 500 (LC)": ["1999", "2000"],
    "Formula Deluxe 583": ["1998", "1999"],
    "Formula Deluxe 600": ["2000", "2001"],
    "Formula III 600": ["1996", "1997", "1998", "1999"],
    "Formula III 600 LT": ["1996", "1997", "1998"],
    "Formula III 700": ["1998", "1999"],
    "Formula Mach I": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "Formula Mach I XTC": ["1990", "1991", "1992", "1993"],
    "Formula Mach Z": ["1993", "1994", "1995"],
    "Formula MX": ["1990", "1991", "1992", "1993", "1994", "1995"],
    "Formula MX XTC R": ["1992", "1993"],
    "Formula MX Z": ["1993", "1994", "1995"],
    "Formula Plus": ["1990", "1991", "1992", "1993"],
    "Formula Plus E": ["1991", "1992", "1993"],
    "Formula Plus X": ["1992", "1993"],
    "Formula Plus XTC": ["1991", "1992", "1993"],
    "Formula Plus XTC E": ["1991", "1992"],
    "Formula S": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Formula SL": ["1995", "1996", "1997", "1998", "1999"],
    "Formula SS": ["1995", "1996"],
    "Formula STX": ["1994", "1995", "1996"],
    "Formula Z": ["1994", "1995", "1996", "1997"],
    "Formula Z 583": ["1998", "1999"],
    "Formula Z 670": ["1998", "1999"],
    "Freestyle Back Country": ["2007", "2008", "2009"],
    "Freestyle Park": ["2007", "2008"],
    "Freestyle Session 300": ["2007", "2008"],
    "Grand Touring": ["1994", "1995"],
    "Grand Touring 500": ["1996", "1997", "1998", "1999"],
    "Grand Touring 583": ["1997", "1998", "1999"],
    "Grand Touring 700": ["1998", "1999", "2000"],
    "Grand Touring SE": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
    ],
    "Grand Touring Sport 550": ["2010", "2011", "2012", "2013", "2014"],
    "GSX 380 Fan": ["2005", "2006"],
    'GSX LE 900 ACE 120"': ["2014", "2015"],
    "GSX Sport 500 SS": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "GTX 380 Fan": ["2005", "2006"],
    "GTX Limited 800 HO": ["2005", "2006"],
    "GTX Sport 500 SS": ["2005", "2006", "2007", "2008", "2009"],
    "Mach I": ["1996", "1997", "1998", "1999"],
    "Mach Z": ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    "Mach Z LT": ["1996", "1997", "1998", "1999"],
    "MX Z 440": ["1997", "1998", "1999", "2000"],
    "MX Z 440 (LC)": ["1996", "1997"],
    "MX Z 500": ["1998", "1999", "2000", "2001"],
    "MX Z 500 Fan": ["2001", "2002"],
    "MX Z 583": ["1996", "1997", "1998"],
    "MX Z 600": ["1999", "2000", "2001"],
    "MX Z 670": ["1997", "1998"],
    "MX Z 700": ["2000", "2001"],
    "MX Z Adrenaline 500 SS": ["2004", "2005", "2006", "2007"],
    "MX Z TNT 500 SS": ["2008", "2009"],
    "MX Z TNT 600": ["2010", "2011", "2012"],
    "MX Z TNT 600 ACE": ["2011", "2012"],
    "MX Z Trail 500 SS": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "MX Z X 440 (LC)": ["1998", "1999", "2000"],
    "Renegade Sport 550": ["2010", "2011", "2012", "2013", "2014"],
    "Safari Cheyenne R": ["1990", "1991"],
    "Safari Citation": ["1990", "1991"],
    "Safari Citation E": ["1990", "1991"],
    "Safari Deluxe": ["1993", "1994"],
    "Safari GLX": ["1990", "1991", "1992"],
    "Safari L": ["1990", "1991", "1992", "1993", "1994"],
    "Safari LC E": ["1991", "1992"],
    "Safari Limited Edition": ["1990", "1991", "1992"],
    "Safari LX": ["1990", "1991"],
    "Safari LX E": ["1990", "1991"],
    "Safari Rally": ["1993", "1994"],
    "Safari Scout": ["1990", "1991", "1992"],
    "Skandic 380": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Skandic 500": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Skandic II 377": ["1992", "1993", "1994"],
    "Skandic II 377R": ["1992", "1993", "1994"],
    "Skandic II 503 R S LT": ["1993", "1994"],
    "Skandic II 503R": ["1993", "1994"],
    "Skandic SWT": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "Skandic WT": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
    ],
    "Skandic WT (LC)": ["1997", "1998", "1999", "2000", "2001", "2002"],
    "Summit 500": ["1996", "1997", "1998", "1999"],
    "Summit 550 Fan": ["2003", "2004", "2005", "2006", "2007", "2008", "2009"],
    "Summit 583": ["1994", "1995", "1996", "1997", "1998"],
    "Summit 600": ["1999", "2000", "2001"],
    "Summit 670": ["1995", "1996", "1997", "1998"],
    "Summit 700": ["2000", "2001"],
    "Summit X 670": ["1998", "1999"],
    "Touring E": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Touring E LT": ["1996", "1997"],
    "Touring LE": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Touring S LE": ["1995", "1996", "1997", "1998", "1999", "2000"],
    Tundra: ["1990", "1991", "1992", "1993"],
    "Tundra 550": ["2012", "2013"],
    "Tundra II LT": ["1994", "1995", "1996", "1997", "1998"],
    "Tundra LT": ["1990", "1991", "1992", "1993"],
    'Tundra LT 550 154"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Tundra R": ["1998", "1999", "2000"],
    'Tundra Sport 550 137"': [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Legend SE 700": ["2003", "2004"],
    "Legend SE 800 SDI": ["2003", "2004"],
    "Legend Sport V-1000": ["2003", "2004", "2005"],
    "Skandic Tundra 300": ["2006", "2007", "2008", "2009"],
    "Mach Z Adrenaline 1000 SDI": ["2006", "2007"],
    "Mach Z X 1000 SDI": ["2006", "2007"],
    "MX Z X Renegade 1000 SDI": ["2006", "2007"],
    "Summit Highmark 1000 SDI": ["2005", "2006", "2007"],
    'Backcountry X-RS 850 E-TEC 154"': ["2022", "2023", "2024", "2025"],
    'Freeride 850 E-TEC Turbo R 154"': ["2023", "2024", "2025"],
    'Summit X 850 E-TEC Turbo R 154"/3.0"': ["2023", "2024", "2025"],
    'Backcountry X 850 E-TEC 146"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Backcountry X-RS 850 E-TEC 146"/1.6"': [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Backcountry 600R E-TEC 146"': ["2019", "2020", "2021", "2022", "2023"],
    'Backcountry 850 E-TEC 146"': ["2019", "2020", "2021", "2022", "2023"],
    'Backcountry X 850 E-TEC 154"': ["2021", "2022"],
    'Freeride S-38 850 E-TEC 154"': ["2018", "2019"],
    'Grand Touring LE 600R E-TEC 137"': ["2019", "2020", "2021"],
    'Grand Touring SE 900 ACE 137"': ["2017", "2018"],
    "Expedition TUV V-1000": ["2005", "2006"],
    "Grand Touring GS 700": ["2001", "2002"],
    "Summit Highmark 800": ["2001", "2002", "2003"],
    "Summit Highmark X 800": ["2001", "2002"],
    "Summit X 800": ["2001", "2002"],
    "Legend SE 600": ["2002", "2003"],
    "MX Z X 700": ["2001", "2002"],
    "MX Z X 800": ["2001", "2002"],
    "Legend GT SE V-1000": ["2004", "2005"],
    "Legend SE V-1000": ["2004", "2005"],
    "Skandic LT 440": ["2004", "2005", "2006", "2007"],
    "Grand Touring 600": ["2000", "2001"],
    "Summit 500 Fan": ["2001", "2002"],
    "Mach Z Tech Plus": ["2001", "2002"],
    "Touring 380 Fan": ["2001", "2002"],
    "MX Z Adrenaline 600": ["2001", "2002"],
    "MX Z Trail 600": ["2001", "2002", "2003"],
    "MX Z Adrenaline 700": ["2001", "2002", "2003"],
    "MX Z Trail 700": ["2001", "2002"],
    "Summit Highmark 700": ["2000", "2001"],
    'Renegade X-RS 600R E-TEC w/ Competition Package 137"': ["2022", "2023"],
    "Legend GT Sport V-1000": ["2004", "2005"],
    "Grand Touring Sport 700": ["2002", "2003"],
    "Nordik 50": ["1990", "1991"],
    "Nordik 60": ["1990", "1991"],
    'Skandic LE 600 ACE 154"': ["2023", "2024", "2025"],
    "Skandic LT": ["2001", "2002", "2003"],
    "Grand Touring Sport 500": ["2002", "2003"],
    "Legend Sport 500": ["2002", "2003"],
    "MX Z Trail 500": ["2001", "2002", "2003"],
    "Skandic SWT 600R E-Tec": ["2021", "2022"],
    "Skandic WT 600R E-Tec": ["2021", "2022"],
    Elite: ["2004", "2005"],
    "Grand Touring SE 600": ["2002", "2003"],
    "Legend Sport 600": ["2002", "2003"],
    "MX Z Adrenaline 800": ["2001", "2002", "2003"],
    "MX Z Sport 800": ["2002", "2003"],
    "MX Z X 600": ["2001", "2002"],
    "Skandic Tundra 280": ["2004", "2005"],
    "Touring 500 Fan": ["2001", "2002"],
    "Mini Z": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2006",
      "2007",
      "2008",
    ],
    'Expedition SE 850 E-Tec 154"/1.5"': ["2023", "2024", "2025"],
    'Expedition Xtreme 900 ACE Turbo R 154"': ["2023", "2024", "2025"],
    'Freeride 850 E-TEC Turbo R 146"': ["2023", "2024", "2025"],
    'Renegade X 900 ACE Turbo R 137"/1.25"': ["2022", "2023", "2024", "2025"],
    'Renegade X-RS 900 ACE Turbo R 137"/1.25"': [
      "2022",
      "2023",
      "2024",
      "2025",
    ],
    'Skandic LE 600R E-Tec 154"': ["2023", "2024", "2025"],
    'Skandic SE 600R E-TEC/1.5"': ["2023", "2024", "2025"],
    'Summit X 850 E-TEC 165"/3.0"': ["2023", "2024", "2025"],
    'Summit X 850 E-TEC Turbo R 165"/3.0"': ["2023", "2024", "2025"],
    'Summit X 850 with Expert Package E-TEC Turbo R 175"': ["2023", "2024"],
    "Alpine Base": ["1983", "1984", "1985", "1986", "1987"],
    "Alpine II Base": ["1988", "1989", "1990", "1991", "1993", "1994", "1995"],
    "Backcountry E-TEC 600R Base": ["2019", "2020", "2021"],
    "Backcountry E-TEC 850 Base": ["2019", "2020", "2021"],
    "Backcountry X E-TEC 850 Base": ["2019", "2020", "2021"],
    "Backcountry X-RS E-TEC 850 146 Base": ["2020", "2021"],
    "Backcountry X-RS E-TEC 850 154 Base": ["2020", "2021"],
    "Blizzard 5500 Base": ["1980", "1981"],
    "Blizzard 5500 MX Base": ["1981", "1982", "1983", "1984"],
    "Blizzard 7500 Plus Base": ["1980", "1981"],
    "Blizzard 9500 Plus Base": ["1980", "1981"],
    "Blizzard 9700 Base": ["1983", "1984"],
    "Citation 3500 Base": ["1980", "1981", "1982", "1983", "1984"],
    "Citation 4500 Base": ["1980", "1981", "1982", "1983"],
    "Citation LS Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Citation LSE Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
    ],
    "Citation SS Base": ["1980", "1981", "1982", "1983"],
    "Elan 250 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
    ],
    "Elite Base": ["1980", "1981", "1982"],
    "Everest 500 Base": ["1980", "1981", "1982", "1983"],
    "Everest 500E Base": ["1980", "1981", "1982", "1983"],
    "Everest L/C Base": ["1980", "1981", "1982", "1983"],
    "Expedition 550F Sport Base": ["2006", "2007", "2008"],
    "Expedition LE 4-TEC 1200 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Expedition LE ACE 900 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Expedition LE ACE 900 Turbo Base": ["2020", "2021"],
    "Expedition LE E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Expedition LE E-TEC 600R Base": ["2020", "2021"],
    "Expedition SE 4-TEC 1200 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Expedition SE ACE 900 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Expedition SE ACE 900 Turbo Base": ["2020", "2021"],
    "Expedition SE E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Expedition SE E-TEC 600R Base": ["2020", "2021"],
    "Expedition Sport 550F Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Expedition Sport 600 ACE Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Expedition Sport ACE 900 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Expedition Sport V-800 Base": ["2007", "2008"],
    "Expedition SWT ACE 900 Base": ["2018", "2019", "2020", "2021"],
    "Expedition TUV 600 Base": ["2005", "2006", "2007", "2008"],
    "Expedition TUV V-1000 Base": ["2005", "2006"],
    "Expedition TUV V-800 Base": ["2007", "2008"],
    "Expedition Xtreme E-TEC 800R Base": ["2016", "2017", "2018", "2019"],
    "Expedition Xtreme E-TEC 850 Base": ["2020", "2021"],
    "Formula 500 Base": ["1997", "1998"],
    "Formula Deluxe 380 Fan Base": ["1999", "2000", "2001"],
    "Formula Deluxe 500 Base": ["1997", "1998"],
    "Formula Deluxe 500 Fan Base": ["1999", "2000", "2001"],
    "Formula Deluxe 500 LC Base": ["1999", "2000"],
    "Formula Deluxe 583 Base": ["1998", "1999"],
    "Formula Deluxe 600 Base": ["2000", "2001"],
    "Formula III Base": ["1995", "1996", "1997"],
    "Formula III 600 Base": ["1998", "1999"],
    "Formula III 700 Base": ["1998", "1999"],
    "Formula III 800 Base": ["1999", "2000"],
    "Formula III LT Base": ["1996", "1997"],
    "Formula Mach 1 Base": ["1989", "1990", "1991", "1992", "1993"],
    "Formula Mach 1 XTC Base": ["1990", "1991"],
    "Formula Mach Z Base": ["1993", "1994", "1995"],
    "Formula MX Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1992",
      "1993",
      "1994",
      "1995",
    ],
    "Formula MX LT Base": ["1987", "1988", "1989", "1990"],
    "Formula MX Z Base": ["1993", "1994", "1995"],
    "Formula Plus Base": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Formula Plus E Base": ["1991", "1992", "1993"],
    "Formula Plus LT Base": ["1989", "1990"],
    "Formula Plus X Base": ["1991", "1992", "1993"],
    "Formula Plus XTC Base": ["1991", "1992", "1993"],
    "Formula S Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Formula SL Base": ["1995", "1996", "1997", "1998", "1999"],
    "Formula SS Base": ["1995", "1996"],
    "Formula STX Base": ["1994", "1995", "1996"],
    "Formula XTC R Base": ["1992", "1993"],
    "Formula Z Base": ["1994", "1995", "1996", "1997"],
    "Formula Z 583 Base": ["1998", "1999"],
    "Formula Z 670 Base": ["1998", "1999"],
    "Freeride E-TEC 800R 137 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Freeride E-TEC 800R 146 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Freeride E-TEC 800R 154 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Freeride E-TEC 850 137 Base": ["2018", "2019", "2020"],
    "Freeride E-TEC 850 146 Base": ["2018", "2019", "2020", "2021"],
    "Freeride E-TEC 850 154 Base": ["2018", "2019", "2020", "2021"],
    "Freeride E-TEC 850 165 Base": ["2018", "2019", "2020", "2021"],
    "Freeride S-38 E-TEC 850 154 Base": ["2018", "2019"],
    "Freestyle Back Country 550F Base": ["2007", "2008", "2009"],
    "Freestyle Park 550F Base": ["2007", "2008"],
    "Freestyle Session 300F Base": ["2007", "2008"],
    "Grand Touring Base": ["1993", "1994"],
    "Grand Touring 1200 SE Base": ["2010", "2011"],
    "Grand Touring 1200 SE 4-TEC Base": ["2012", "2013", "2014"],
    "Grand Touring 380 Fan Base": ["2002", "2003"],
    "Grand Touring 500 Base": ["1996", "1997", "1998", "1999"],
    "Grand Touring 500 Sport Base": ["2002", "2003"],
    "Grand Touring 550F Sport Base": ["2010", "2011", "2012", "2013", "2014"],
    "Grand Touring 580 Base": ["1995", "1996"],
    "Grand Touring 583 Base": ["1997", "1998", "1999"],
    "Grand Touring 600 Base": ["2000", "2001"],
    "Grand Touring 600 SE Base": ["2002", "2003"],
    "Grand Touring 600 Sport Base": ["2002", "2003", "2010", "2011"],
    "Grand Touring 700 Base": ["1998", "1999", "2000"],
    "Grand Touring 700 GS Base": ["2001", "2002"],
    "Grand Touring 700 Sport Base": ["2002", "2003"],
    "Grand Touring 800 SE Base": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Grand Touring LE 4-TEC 1200 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Grand Touring LE ACE 900 Base": ["2014", "2015", "2016", "2017", "2018"],
    "Grand Touring LE E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Grand Touring Limited ACE 900 Base": ["2019", "2020", "2021"],
    "Grand Touring Limited ACE 900 Turbo Base": ["2019", "2020", "2021"],
    "Grand Touring Limited E-TEC 600R Base": ["2019", "2020", "2021"],
    "Grand Touring SE 4-TEC 1200 Base": ["2015", "2016", "2017", "2018"],
    "Grand Touring SE ACE 900 Base": ["2017", "2018"],
    "Grand Touring Sport 600 ACE Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Grand Touring Sport 600 Carb Base": ["2012", "2013", "2014"],
    "Grand Touring Sport ACE 900 Base": ["2019", "2020", "2021"],
    "GSX 1200 Limited Base": ["2009", "2010"],
    "GSX 1200 SE Base": ["2010", "2011"],
    "GSX 380 Fan Base": ["2005", "2006"],
    "GSX 500SS Sport Base": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "GSX 550 Fan Base": ["2005", "2006", "2007", "2008", "2009"],
    "GSX 600 Base": ["2004", "2005"],
    "GSX 600 Limited Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "GSX 600 Sport Base": ["2004", "2005", "2006", "2007"],
    "GSX 800 Base": ["2004", "2005"],
    "GSX 800 Limited Base": ["2004", "2005", "2006", "2007", "2008"],
    "GSX LE 4-TEC 1200 Base": ["2011", "2012", "2013", "2014", "2015"],
    "GSX LE ACE 900 Base": ["2014", "2015"],
    "GSX LE E-TEC 600 HO Base": ["2012", "2013", "2014", "2015"],
    "GSX SE 4-TEC 1200 Base": ["2012", "2013", "2014", "2015"],
    "GSX SE E-TEC 600 HO Base": ["2012", "2013", "2014", "2015"],
    "GSX SE E-TEC 800R Base": ["2012", "2013", "2014", "2015"],
    "GTX 380F Base": ["2005", "2006"],
    "GTX 500SS Sport Base": ["2005", "2006", "2007", "2008", "2009"],
    "GTX 550 Fan Base": ["2005", "2006", "2007", "2008", "2009"],
    "GTX 600 Limited Base": ["2005", "2006", "2007", "2008", "2009"],
    "GTX 600 Sport Base": ["2005", "2006", "2007", "2008"],
    "GTX 800 Limited Base": ["2006", "2007"],
    "Legend 380 Fan Base": ["2002", "2003", "2004"],
    "Legend 500 Sport Base": ["2002", "2003", "2004"],
    "Legend 550 Fan Base": ["2003", "2004"],
    "Legend 600 SE Base": ["2002", "2003", "2004"],
    "Legend 600 Sport Base": ["2002", "2003", "2004"],
    "Legend 700 SE Base": ["2003", "2004"],
    "Legend 700 Sport Base": ["2002", "2003", "2004"],
    "Legend 800 SE SDI Base": ["2003", "2004"],
    "Legend Touring V-800 Base": ["2007", "2008", "2009"],
    "Legend Trail V-800 Base": ["2007", "2008"],
    "Legend V-1000 Sport Base": ["2003", "2004", "2005"],
    "Mach 1 Base": ["1996", "1997", "1998", "1999"],
    "Mach 1R Base": ["1998", "1999", "2000"],
    "Mach Z Base": ["1996", "1997", "1998", "1999", "2000", "2001", "2002"],
    "Mach Z Adrenaline Base": ["2006", "2007"],
    "Mach Z LT Base": ["1996", "1997", "1998", "1999"],
    "Mach Z LT R Base": ["1998", "1999"],
    "Mach Z R Base": ["1998", "1999", "2000"],
    "Mach Z Tech Plus Base": ["2001", "2002", "2003"],
    "Mach Z X Base": ["2006", "2007"],
    "Mini Z Base": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "MX Z 1000 Renegade X Base": ["2006", "2007"],
    "MX Z 1200 TNT Base": ["2009", "2010", "2011"],
    "MX Z 1200 X Base": ["2009", "2010"],
    "MX Z 380 Fan Base": ["2001", "2002", "2003", "2004", "2005", "2006"],
    "MX Z 440 Fan Base": ["1996", "1997", "1998", "1999", "2000", "2001"],
    "MX Z 440 LC X Base": ["1997", "1998", "1999", "2000"],
    "MX Z 440 X Base": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "MX Z 500 Base": ["1998", "1999", "2000", "2001"],
    "MX Z 500 Adrenaline Base": ["2003", "2004", "2005", "2006", "2007"],
    "MX Z 500 Fan Base": ["2001", "2002"],
    "MX Z 500 TNT Base": ["2008", "2009"],
    "MX Z 500 Trail Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "MX Z 550 Fan Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "MX Z 550 X Base": ["2006", "2007", "2008", "2009"],
    "MX Z 550F TNT Base": ["2010", "2011", "2012"],
    "MX Z 583 Base": ["1996", "1997", "1998"],
    "MX Z 600 Base": ["1999", "2000", "2001"],
    "MX Z 600 Adrenaline Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "MX Z 600 Renegade Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "MX Z 600 Renegade X Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "MX Z 600 Sport Base": ["2002", "2003", "2010", "2011"],
    "MX Z 600 TNT Base": ["2009", "2010", "2011"],
    "MX Z 600 Trail Base": ["2001", "2002", "2003", "2004", "2005"],
    "MX Z 600 X Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "MX Z 670 Base": ["1996", "1997", "1998", "1999"],
    "MX Z 700 Base": ["1999", "2000", "2001"],
    "MX Z 700 Adrenaline Base": ["2001", "2002", "2003"],
    "MX Z 700 Trail Base": ["2001", "2002"],
    "MX Z 700 X Base": ["2001", "2002"],
    "MX Z 800 Base": ["2000", "2001"],
    "MX Z 800 Adrenaline Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "MX Z 800 R Adrenaline Base": ["2008", "2009", "2010"],
    "MX Z 800 R X Base": ["2008", "2009", "2010"],
    "MX Z 800 Renegade Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "MX Z 800 Renegade X Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "MX Z 800 Sport Base": ["2002", "2003"],
    "MX Z 800 X Base": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "MX Z Blizzard 4-TEC 1200 Base": ["2016", "2017", "2018"],
    "MX Z Blizzard ACE 900 Base": ["2016", "2017", "2018"],
    "MX Z Blizzard E-TEC 600 HO Base": ["2016", "2017", "2018"],
    "MX Z Blizzard E-TEC 800R Base": ["2016", "2017"],
    "MX Z Blizzard E-TEC 850 Base": ["2018", "2019"],
    "MX Z Sport 550F Base": ["2011", "2012", "2013", "2014"],
    "MX Z Sport 600 ACE Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "MX Z Sport 600 Carb Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "MX Z TNT 4-TEC 1200 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "MX Z TNT 600 ACE Base": ["2011", "2012"],
    "MX Z TNT ACE 900 Base": ["2014", "2015", "2016", "2017", "2018"],
    "MX Z TNT E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "MX Z TNT E-TEC 600R Base": ["2019", "2020", "2021"],
    "MX Z TNT E-TEC 800R Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "MX Z TNT E-TEC 850 Base": ["2017", "2018", "2019", "2020", "2021"],
    "MX Z X 4-TEC 1200 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "MX Z X E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "MX Z X E-TEC 600R Base": ["2019", "2020", "2021"],
    "MX Z X E-TEC 800R Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "MX Z X E-TEC 850 Base": ["2017", "2018", "2019", "2020", "2021"],
    "MX Z X-RS 600 Base": ["2009", "2010"],
    "MX Z X-RS E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "MX Z X-RS E-TEC 600R Base": ["2019", "2020", "2021"],
    "MX Z X-RS E-TEC 800R Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "MX Z X-RS E-TEC 850 Base": ["2018", "2019", "2020", "2021"],
    "MX Z X-RS Iron Dog E-TEC 600 HO Base": ["2017", "2018"],
    "Nordik Base": ["1982", "1983", "1984"],
    "Nordik 50 Base": ["1988", "1989", "1990", "1991"],
    "Nordik 60 Base": ["1988", "1989", "1990", "1991"],
    "Renegade 550F Sport Base": ["2010", "2011", "2012"],
    "Renegade Adrenaline 4-TEC 1200 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Renegade Adrenaline ACE 900 Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Renegade Adrenaline ACE 900 Turbo Base": ["2019", "2020", "2021"],
    "Renegade Adrenaline E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Renegade Adrenaline E-TEC 600R Base": ["2019", "2020", "2021"],
    "Renegade Adrenaline E-TEC 800R Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Renegade Adrenaline E-TEC 850 Base": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Renegade Backcountry E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Renegade Backcountry E-TEC 800R Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Renegade Backcountry X E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
    ],
    "Renegade Backcountry X E-TEC 800R Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Renegade Enduro 4-TEC 1200 Base": ["2016", "2017", "2018"],
    "Renegade Enduro ACE 900 Base": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Renegade Enduro ACE 900 Turbo Base": ["2019", "2020", "2021"],
    "Renegade Enduro E-TEC 600 HO Base": ["2016", "2017", "2018"],
    "Renegade Enduro E-TEC 600R Base": ["2019", "2020", "2021"],
    "Renegade Enduro E-TEC 800R Base": ["2016", "2017", "2018"],
    "Renegade Enduro E-TEC 850 Base": ["2019", "2020", "2021"],
    "Renegade Sport 550F Base": ["2013", "2014"],
    "Renegade Sport 600 ACE Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Renegade Sport 600 Carb Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Renegade X 4-TEC 1200 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Renegade X ACE 900 Turbo Base": ["2019", "2020", "2021"],
    "Renegade X E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Renegade X E-TEC 600R Base": ["2019", "2020", "2021"],
    "Renegade X E-TEC 800R Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Renegade X E-TEC 850 Base": ["2017", "2018", "2019", "2020", "2021"],
    "Renegade X-RS ACE 900 Turbo Base": ["2019", "2020", "2021"],
    "Renegade X-RS E-TEC 800R Base": ["2015", "2016", "2017"],
    "Renegade X-RS E-TEC 850 Base": ["2018", "2019", "2020", "2021"],
    "Safari 377 Base": ["1984", "1985", "1986", "1987", "1988"],
    "Safari 377E Base": ["1984", "1985", "1986", "1987", "1988"],
    "Safari 447 Base": ["1984", "1985"],
    "Safari Chyenne Base": ["1989", "1990"],
    "Safari Citation Base": ["1989", "1990"],
    "Safari Citation E Base": ["1989", "1990"],
    "Safari Deluxe Base": ["1993", "1994"],
    "Safari GLX Base": ["1990", "1991", "1992"],
    "Safari Grand Luxe Base": ["1984", "1985", "1986"],
    "Safari L Base": ["1990", "1991", "1992", "1993", "1994"],
    "Safari LCE Base": ["1991", "1992"],
    "Safari LE Base": ["1990", "1991", "1992"],
    "Safari LX Base": ["1990", "1991"],
    "Safari LXE Base": ["1990", "1991"],
    "Safari Scout Base": ["1989", "1990"],
    "Scout Base": ["1991", "1992"],
    "Skandic 277 Base": ["1983", "1984"],
    "Skandic 300F Tundra Base": ["2006", "2007", "2008", "2009"],
    "Skandic 377 Base": ["1982", "1983", "1984", "1985", "1986"],
    "Skandic 377R Base": ["1986", "1987"],
    "Skandic 380 Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Skandic 440 LT Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Skandic 500 Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Skandic 500 SWT Base": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Skandic 500 WT Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
    ],
    "Skandic 550F SUV Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "Skandic 550F SWT Base": ["2004", "2005", "2006", "2007", "2008"],
    "Skandic 550F Tundra Base": ["2010", "2011"],
    "Skandic 550F Tundra LT Base": ["2008", "2009", "2010", "2011"],
    "Skandic 550F Tundra Sport Base": ["2010", "2011"],
    "Skandic 550F WT Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2012",
      "2013",
      "2014",
    ],
    "Skandic 600 SUV Base": ["2003", "2004", "2005", "2006", "2007", "2008"],
    "Skandic 600 WT Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Skandic II Base": ["1992", "1993", "1994"],
    "Skandic II 503R Base": ["1993", "1994"],
    "Skandic II 503R SLT Base": ["1993", "1994"],
    "Skandic II R Base": ["1992", "1993", "1994"],
    "Skandic SWT Base": ["2010", "2011"],
    "Skandic SWT ACE 600 Base": ["2012", "2013", "2014"],
    "Skandic SWT ACE 900 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Skandic SWT E-TEC 600 HO Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Skandic Tundra Base": ["2010", "2011"],
    "Skandic V-800 SWT Base": ["2007", "2008", "2009", "2010"],
    "Skandic V-800 Tundra Base": ["2007", "2008"],
    "Skandic V-800 Tundra LT Base": ["2008", "2009"],
    "Skandic WT 550F Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "Skandic WT 600 ACE Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Skandic WT ACE 900 Base": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Skandic WT E-TEC 600 HO Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Skandic WT LC Base": ["1998", "1999", "2000", "2001"],
    "Summit 1000 Highmark 151 Base": ["2006", "2007"],
    "Summit 1000 Highmark 162 Base": ["2005", "2006", "2007"],
    "Summit 1000 Highmark X 151 Base": ["2006", "2007"],
    "Summit 1000 Highmark X 162 Base": ["2005", "2006", "2007", "2008"],
    "Summit 500 Base": ["1996", "1997", "1998", "1999"],
    "Summit 500 Fan Base": ["2001", "2002"],
    "Summit 550 Fan Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Summit 583 Base": ["1994", "1995", "1996", "1997", "1998"],
    "Summit 600 Base": ["1999", "2000", "2001"],
    "Summit 600 Adrenaline Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Summit 600 Everest 146 Base": ["2009", "2010"],
    "Summit 600 X 154 Base": ["2009", "2010"],
    "Summit 670 Base": ["1995", "1996", "1997", "1998"],
    "Summit 670 X Base": ["1998", "1999"],
    "Summit 700 Base": ["2000", "2001"],
    "Summit 700 Highmark Base": ["2000", "2001"],
    "Summit 800 Adrenaline 144 Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
    ],
    "Summit 800 Adrenaline 151 Base": ["2005", "2006", "2007"],
    "Summit 800 Everest 146 Base": ["2008", "2009", "2010"],
    "Summit 800 Everest 154 Base": ["2008", "2009", "2010"],
    "Summit 800 Everest 163 Base": ["2009", "2010"],
    "Summit 800 Highmark Base": ["2000", "2001", "2002", "2003", "2004"],
    "Summit 800 Highmark X Base": ["2001", "2002", "2003", "2004"],
    "Summit 800 Highmark Xtreme Base": ["2003", "2004"],
    "Summit 800 Hill Climb Base": ["2009", "2010"],
    "Summit 800 R Everest Base": ["2007", "2008"],
    "Summit 800 X Base": ["2001", "2002", "2003", "2004"],
    "Summit 800 X 144 Base": ["2005", "2006", "2007"],
    "Summit 800 X 146 Base": ["2008", "2009", "2010"],
    "Summit 800 X 151 Base": ["2005", "2006", "2007"],
    "Summit 800 X 154 Base": ["2008", "2009", "2010"],
    "Summit 800 X 159 Base": ["2005", "2006", "2007"],
    "Summit 800 X 163 Base": ["2008", "2009", "2010"],
    "Summit Burton E-TEC 800R Base": ["2016", "2017"],
    "Summit SP E-TEC 600 HO 146 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Summit SP E-TEC 600 HO 154 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Summit SP E-TEC 600R 146 Base": ["2019", "2020", "2021"],
    "Summit SP E-TEC 600R 154 Base": ["2019", "2020", "2021"],
    "Summit SP E-TEC 800R 146 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Summit SP E-TEC 800R 154 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Summit SP E-TEC 800R 163 Base": ["2012", "2013", "2014", "2015", "2016"],
    "Summit SP E-TEC 850 146 Base": ["2018", "2019", "2020", "2021"],
    "Summit SP E-TEC 850 154 Base": ["2017", "2018", "2019", "2020", "2021"],
    "Summit SP E-TEC 850 165 Base": ["2017", "2018", "2019", "2020", "2021"],
    "Summit SP E-TEC 850 175 Base": ["2018", "2019", "2020", "2021"],
    "Summit Sport 600 Carb Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Summit Sport Power TEK 800R Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Summit X E-TEC 800R 146 Base": ["2011", "2012", "2013", "2014", "2015"],
    "Summit X E-TEC 800R 154 Base": ["2011", "2012", "2013", "2014", "2015"],
    "Summit X E-TEC 800R 163 Base": ["2011", "2012", "2013", "2014", "2015"],
    "Summit X E-TEC 850 154 Base": ["2017", "2018", "2019", "2020", "2021"],
    "Summit X E-TEC 850 165 Base": ["2017", "2018", "2019", "2020", "2021"],
    "Summit X E-TEC 850 175 Base": ["2018", "2019", "2020"],
    "Summit X T3 Package E-TEC 800R 163 Base": ["2015", "2016"],
    "Summit X T3 Package E-TEC 800R 174 Base": ["2015", "2016"],
    "Summit X with Expert Package E-TEC 850 154 Base": ["2020", "2021"],
    "Summit X with Expert Package E-TEC 850 165 Base": ["2020", "2021"],
    "Touring E Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Touring E LT Base": ["1996", "1997"],
    "Touring LE Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Touring SLE Base": ["1995", "1996", "1997", "1998", "1999", "2000"],
    "Tundra Base": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Tundra Extreme E-TEC 600 HO Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Tundra II LT Base": ["1994", "1995", "1996", "1997", "1998"],
    "Tundra LT Base": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
    ],
    "Tundra LT 550F Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Tundra LT ACE 600 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Tundra R Base": ["1998", "1999", "2000", "2002", "2003", "2004", "2005"],
    "Tundra Sport 550F Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Tundra Sport ACE 600 Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Tundra Xtreme E-TEC 600 HO Base": ["2018", "2019", "2020"],
    'Freeride 850 E-TEC Turbo R 165"': ["2024", "2025"],
    'Summit Adrenaline 850 E-TEC 146"': ["2024", "2025"],
    'Summit Adrenaline 850 E-TEC 154"': ["2024", "2025"],
    'Summit Adrenaline 850 E-TEC w/ Edge Package 146"': ["2024", "2025"],
    'Summit Adrenaline 850 E-TEC w/ Edge Package 154"/3.0"': ["2024", "2025"],
    'Summit Adrenaline 850 E-TEC w/ Edge Package 165"': ["2024", "2025"],
    'Backcountry Adrenaline 600R E-TEC 146"/1.6"': ["2024", "2025"],
    'Backcountry Adrenaline 600R E-TEC 146"/2.0"': ["2024", "2025"],
    'Backcountry Adrenaline 850 E-TEC 146"/1.6"': ["2024", "2025"],
    'Backcountry Adrenaline 850 E-TEC 146"/2.0"': ["2024", "2025"],
    'Backcountry Sport 600 EFI 146"/1.6"': ["2024", "2025"],
    'Backcountry Sport 600 EFI 146"/2.0"': ["2024", "2025"],
    'Freeride 850 E-TEC 154"/3.0"': ["2024", "2025"],
    'Grand Touring LE 900 ACE Turbo R w/ Luxury Package 137"': ["2024", "2025"],
    'Grand Touring LE 900 ACE Turbo w/ Luxury Package 137"': ["2024", "2025"],
    'MX Z Neo 600 EFI 120"': ["2023", "2024", "2025"],
    'MX Z Neo+ 600 EFI 120"': ["2023", "2024", "2025"],
    'MX Z X 600R E-TEC 129"/1.5"': ["2024", "2025"],
    'MX Z X 600R E-TEC 137"/1.25"': ["2024", "2025"],
    'MX Z X 600R E-TEC 137"/1.5"': ["2024", "2025"],
    'MX Z X 850 E-TEC 129"/1.5"': ["2024", "2025"],
    'MX Z X 850 E-TEC 137"/1.25"': ["2024", "2025"],
    'MX Z X 850 E-TEC 137"/1.5"': ["2024", "2025"],
    'MX Z X-RS 600R E-TEC 129"/1.5"': ["2024", "2025"],
    'MX Z X-RS 600R E-TEC 137"/1.25"': ["2024", "2025"],
    'MX Z X-RS 600R E-TEC 137"/1.5"': ["2024", "2025"],
    "MX Z X-RS 600R E-TEC w/ Competition Package": ["2024", "2025"],
    'MX Z X-RS 850 E-TEC 129"/1.5"': ["2024", "2025"],
    'MX Z X-RS 850 E-TEC 137"/1.25"': ["2024", "2025"],
    'MX Z X-RS 850 E-TEC 137"/1.5"': ["2024", "2025"],
    "MX Z X-RS 850 E-TEC Turbo R w/ Competition Package": ["2024", "2025"],
    'Renegade Adrenaline w/ Enduro Package 600R E-TEC 137"': ["2024", "2025"],
    'Renegade Adrenaline w/ Enduro Package 850 E-TEC 137"': ["2024", "2025"],
    'Renegade Adrenaline w/ Enduro Package 900 ACE 137"': ["2024", "2025"],
    'Renegade Adrenaline w/ Enduro Package 900 ACE Turbo 137"': [
      "2024",
      "2025",
    ],
    'Renegade Adrenaline w/ Enduro Package 900 ACE Turbo R 137"': [
      "2024",
      "2025",
    ],
    'Renegade X 900 ACE Turbo 137"/1.5"': ["2024", "2025"],
    'Renegade X 900 ACE Turbo R 137"/1.5"': ["2024", "2025"],
    'Renegade X-RS 900 ACE Turbo R 137"/1.5"': ["2024", "2025"],
    'Skandic LE 600 EFI 154"': ["2023", "2024", "2025"],
    'Summit Adrenaline 600R E-TEC 146"': ["2024", "2025"],
    'Summit Adrenaline 600R E-TEC 154"': ["2024", "2025"],
    'Summit Adrenaline 600R E-TEC w/ Edge Package 146"': ["2024", "2025"],
    'Summit Adrenaline 600R E-TEC w/ Edge Package 154"/2.5"': ["2024", "2025"],
    'Summit Adrenaline 600R E-TEC w/ Edge Package 154"/3.0"': ["2024", "2025"],
    'Summit Adrenaline 600R E-TEC w/ Edge Package 165"': ["2024", "2025"],
    'Summit Adrenaline 850 E-TEC w/ Edge Package 154"/2.5"': ["2024", "2025"],
    'Summit Neo 600 EFI 146"': ["2023", "2024", "2025"],
    'Summit Neo+ 600 EFI 146"': ["2023", "2024", "2025"],
    'Tundra LE 600 ACE 154"': ["2024", "2025"],
    'Tundra LE 600 EFI 154"': ["2024", "2025"],
  },
  DeTomaso: {
    "Mangusta Base": ["1967", "1968", "1969", "1970", "1971", "1972"],
    "Pantera Base": ["1971", "1972", "1973", "1974"],
    "Pantera GT5": ["1981", "1982", "1983", "1984", "1985"],
    "Pantera GT5-S": ["1984", "1985", "1986", "1987", "1988", "1989"],
  },
  TVR: {
    "3000M Base": ["1972", "1973", "1974"],
    "Tuscan Base": ["1968", "1969", "1970", "1971"],
  },
  Excalibur: {
    "Phaeton Base": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1986",
      "1987",
      "1988",
      "1989",
    ],
  },
  "Mobility Ventures": {
    "MV-1 DX": ["2014", "2015", "2016", "2017"],
    "MV-1 LX": ["2014", "2015", "2016"],
    "MV-1 SE": ["2015", "2016", "2017"],
  },
  SRT: {
    "Viper Base": ["2013", "2014"],
    "Viper GTS": ["2013", "2014"],
  },
  "CF-MOTO": {
    "CFORCE 400": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "CFORCE 500 HO EPS": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Cforce 500 S": ["2021", "2022"],
    "CFORCE 500S EPS": ["2017", "2018", "2019", "2020"],
    "CForce 800 XC": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "UForce 1000": ["2019", "2020", "2021", "2022", "2023"],
    "ZFORCE 1000 EPS": ["2017", "2018", "2019"],
    "ZForce 950 Sport": ["2020", "2021", "2022", "2023"],
    "CFORCE 800 EPS": ["2015", "2016", "2017"],
    "UFORCE 800": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2020",
      "2021",
      "2022",
      "2023",
    ],
    "UFORCE 800 EPS": ["2015", "2016", "2017", "2018", "2019"],
    "ZFORCE 800 EPS Trail": ["2016", "2017", "2018", "2019", "2022", "2023"],
    "ZFORCE 800 EX": ["2014", "2015", "2016", "2020", "2021", "2022", "2023"],
    "ZFORCE 800 EX EPS": ["2015", "2016", "2017", "2018", "2019"],
    "ZFORCE 800 Trail": ["2020", "2021", "2022", "2023"],
    "CForce 500": ["2013", "2014", "2015", "2022", "2023"],
    "CForce 500 X5 LWB": ["2007", "2008", "2009", "2010", "2011", "2012"],
    "CForce 500 X5 SWB": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "CFORCE 600": ["2013", "2014", "2019", "2020", "2021", "2022", "2023"],
    "UFORCE 500 EPS": ["2015", "2016", "2017", "2018", "2019"],
    "UFORCE 600": ["2013", "2014", "2021", "2022", "2023"],
    "ZFORCE 500 Trail": ["2018", "2019", "2020", "2021", "2022"],
    "450 SS": ["2023", "2024"],
    "UForce 1000 EPS XL": ["2022", "2023"],
    "ZFORCE 600": ["2013", "2014", "2015"],
    "ZFORCE 600EX": ["2013", "2014", "2015"],
    "ZFORCE 800": ["2015", "2016"],
    "Cforce 1000 Overland": ["2021", "2022", "2023"],
    "Cforce 600 Touring": ["2020", "2021", "2022", "2023"],
    "ZForce 500 HO EPS LX": ["2022", "2023"],
    "ZFORCE 800 EPS": ["2015", "2016"],
    "CFORCE 600 X6 LWB": ["2012", "2013", "2014"],
    "CFORCE 800": ["2013", "2014"],
    "ZFORCE 950 HO EX": ["2022", "2023"],
  },
  "Royal Enfield": {
    Himalayan: ["2019", "2020", "2021", "2022"],
    "Continental GT 650": ["2019", "2020", "2021", "2022", "2023"],
    "Bullet Trials 500": ["2020", "2021"],
    "Classic 500": ["2020", "2021"],
    "Bullet 500 Base": ["2015", "2016", "2017", "2018"],
    "Classic 500 Base": ["2015", "2016", "2017", "2018", "2019"],
    "Classic Battle Green Base": ["2015", "2016", "2017", "2018", "2019"],
    "Classic Chrome Base": ["2015", "2016", "2017", "2018", "2019"],
    "Classic Desert Storm Base": ["2015", "2016", "2017", "2018", "2019"],
    "Classic Gunmetal Grey Base": ["2018", "2019"],
    "Classic Squadron Blue Base": ["2017", "2018", "2019"],
    "Classic Stealth Black Base": ["2018", "2019"],
    "Continental GT Base": ["2015", "2016", "2017", "2018"],
    "Himalayan Base": ["2018", "2019"],
  },
  Bennche: {
    "Bighorn 500": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Bighorn 700": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Cowboy 500": ["2015", "2016"],
    "Cowboy 700": ["2015", "2016"],
    "T-Boss 750": ["2019", "2020"],
    "Bighorn 400": ["2013", "2014", "2015", "2016"],
    "Bighorn 700X Crew": ["2015", "2016"],
    "Cowboy 1000": ["2015", "2016"],
    "Cowboy 250": ["2015", "2016"],
    "Cowboy 400": ["2015", "2016"],
    "Spire 1000": ["2015", "2016"],
    "Spire 1000X": ["2015", "2016"],
    "Spire 250": ["2015", "2016"],
    "Gray Wolf 500": ["2015", "2016"],
    "Gray Wolf 700": ["2015", "2016"],
  },
  "John Deere": {
    "Gator HPX 4x4": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator HPX 615E": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Gator HPX 815E": ["2018", "2019", "2020", "2021", "2022", "2023"],
    "Gator HPX Diesel 4x4": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator HPX Trail Gator 4x4": ["2005", "2006", "2007"],
    "Gator XUV 550": ["2012", "2013", "2014", "2015", "2016"],
    "Gator XUV 550 S4": ["2012", "2013", "2014", "2015", "2016"],
    "Gator XUV 560": ["2016", "2017", "2018"],
    "Gator XUV 560 S4": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
    ],
    "Gator XUV 560E": ["2018", "2019", "2020", "2021"],
    "Gator XUV 560E S4": ["2018", "2019", "2020", "2021"],
    "Gator XUV 590E": ["2018", "2019", "2020", "2021"],
    "Gator XUV 590E S4": ["2018", "2019", "2020", "2021"],
    "Gator XUV 590i": ["2016", "2017"],
    "Gator XUV 590i S4": ["2016", "2017"],
    "Gator XUV 590M": ["2018", "2019", "2020", "2021"],
    "Gator XUV 590M S4": ["2018", "2019", "2020", "2021"],
    "Gator XUV 625i": ["2010", "2011", "2012", "2014", "2015"],
    "Gator XUV 825E": ["2018", "2019", "2020"],
    "Gator XUV 825i": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Gator XUV 825i S4": ["2013", "2014"],
    "Gator XUV 825M": ["2018", "2019", "2020"],
    "Gator XUV 825M S4": ["2018", "2019", "2020"],
    "Gator XUV 835E": ["2018", "2019", "2020", "2021"],
    "Gator XUV 835M": ["2018", "2019", "2020", "2021"],
    "Gator XUV 835M Cab": ["2018", "2019", "2020", "2021"],
    "Gator XUV 835M Hvac": ["2018", "2019", "2020", "2021"],
    "Gator XUV 835R": ["2018", "2019", "2020"],
    "Gator XUV 850D 4x4 Diesel": ["2007", "2008", "2009", "2010"],
    "Gator XUV 855D": ["2011", "2012", "2013"],
    "Gator XUV 855D S4": ["2013", "2014", "2015"],
    "Gator XUV 855E": ["2018", "2019", "2020"],
    "Gator XUV 855M": ["2018", "2019", "2020"],
    "Gator XUV 855M S4": ["2018", "2019", "2020"],
    "Gator XUV 865E": ["2018", "2019", "2020", "2021"],
    "Gator XUV 865M": ["2018", "2019", "2020", "2021"],
    "Gator XUV 865M Cab": ["2018", "2019", "2020", "2021"],
    "Gator XUV 865M Hvac": ["2018", "2019", "2020", "2021"],
    "Gator XUV 865R": ["2018", "2019", "2020"],
    "Gator XUV 4x4 825i": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 4x4 825i S4": ["2013", "2014", "2015", "2016", "2017"],
    "Gator XUV 4x4 855D": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 4x4 855D Power Steering": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 4x4 620i": ["2007", "2008"],
    "Gator XUV 4x4 625i": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 4x4 825i Power Steering": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 4x4 855D S4": ["2013", "2014", "2015", "2016", "2017"],
    "Gator XUV 4x4 550": ["2012", "2013", "2015", "2016"],
    "Gator XUV 4x4 550 S4": ["2012", "2013", "2015", "2016"],
    "Gator RSX 850i": ["2013", "2014", "2015"],
    "Gator RSX 850i Sport": ["2013", "2014", "2015"],
    "Gator RSX 850i Trail": ["2013", "2014", "2015"],
    "Buck 500 Auto": ["2005", "2006"],
    "Trail Buck 500": ["2004", "2005"],
    "Trail Buck 650": ["2004", "2005"],
    "Trail Buck 650 Ex": ["2004", "2005"],
    "Trail Buck 650 Ext": ["2004", "2005"],
    "Gator TH 6x4": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Gator TH 6x4 Diesel": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Gator TS": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Gator TX": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Gator RSX 860E": ["2018", "2019"],
    "Gator RSX 860i": ["2016", "2017"],
    "Gator RSX 860M": ["2018", "2019"],
    "Buck 500": ["2004", "2005", "2006"],
    "Buck 500 Base": ["2004", "2005", "2006"],
    "Buck 500 Auto Base": ["2005", "2006"],
    "Buck 500 Ex Base": ["2004", "2005"],
    "Buck 500 Ext Base": ["2004", "2005"],
    "Gator CX 4x2 Base": ["2010", "2011", "2012", "2013", "2014", "2015"],
    "Gator HPX 4x4 Base": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Gator HPX 4x4 Diesel Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Gator HPX 615E Base": ["2018", "2019"],
    "Gator HPX 815E Base": ["2018", "2019"],
    "Gator RSX 860E Base": ["2018", "2019"],
    "Gator RSX 860M Base": ["2018", "2019"],
    "Gator TH 6x4 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Gator TH 6x4 Diesel Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator TS 4x2 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator TX 4x2 Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator TX 4x2 Turf Base": ["2010", "2011", "2012"],
    "Gator XUV 550 Base": ["2012", "2013", "2014", "2015", "2016"],
    "Gator XUV 550 S4 Base": ["2012", "2013", "2014", "2015", "2016"],
    "Gator XUV 560 Base": ["2016", "2017"],
    "Gator XUV 560 S4 Base": ["2016", "2017"],
    "Gator XUV 560E Base": ["2018", "2019"],
    "Gator XUV 560E S4 Base": ["2018", "2019"],
    "Gator XUV 590E Base": ["2018", "2019"],
    "Gator XUV 590E S4 Base": ["2018", "2019"],
    "Gator XUV 590i Base": ["2016", "2017"],
    "Gator XUV 590i Power Steering Base": ["2016", "2017"],
    "Gator XUV 590i S4 Base": ["2016", "2017"],
    "Gator XUV 590i S4 Power Steering Base": ["2016", "2017"],
    "Gator XUV 590M Base": ["2018", "2019"],
    "Gator XUV 590M S4 Base": ["2018", "2019"],
    "Gator XUV 620i 4x4 Base": ["2007", "2008", "2009", "2010"],
    "Gator XUV 625i 4x4 Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "Gator XUV 825E Base": ["2018", "2019"],
    "Gator XUV 825i 4x4 Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 825i 4x4 Power Steering Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 825i 4x4 S4 Base": ["2013", "2014", "2015", "2016", "2017"],
    "Gator XUV 835E Base": ["2018", "2019"],
    "Gator XUV 835M Base": ["2018", "2019"],
    "Gator XUV 835M Cab Base": ["2018", "2019"],
    "Gator XUV 835M Hvac Base": ["2018", "2019"],
    "Gator XUV 850D 4x4 Diesel Base": ["2007", "2008", "2009", "2010"],
    "Gator XUV 855D 4x4 Diesel Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 855D 4x4 Diesel Power Steering Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 855D 4x4 Diesel S4 Base": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
    ],
    "Gator XUV 855E Base": ["2018", "2019"],
    "Gator XUV 865E Base": ["2018", "2019"],
    "Gator XUV 865M Base": ["2018", "2019"],
    "Gator XUV 865M Cab Base": ["2018", "2019"],
    "Gator XUV 865M Hvac Base": ["2018", "2019"],
    "Liquifire 440 Base": ["1980", "1981", "1982", "1983", "1984"],
    "ProGator 2020A Base": ["2010", "2011", "2012"],
    "ProGator 2030A Diesel Base": ["2010", "2011", "2012"],
    "RSX850i Base": ["2013", "2014", "2015"],
    "RSX850i Sport Base": ["2013", "2014", "2015"],
    "RSX850i Trail Base": ["2013", "2014", "2015"],
    "RSX860i Base": ["2016", "2017"],
    "Snowfire Base": ["1982", "1983", "1984"],
    "Spitfire 340 Base": ["1980", "1981", "1982"],
    "Sportfire Base": ["1980", "1981", "1982", "1983", "1984"],
    "Sprintfire Base": ["1983", "1984"],
    "Trail Buck 500 Base": ["2004", "2005"],
    "Trail Buck 650 Base": ["2004", "2005"],
    "Trail Buck 650 Ex Base": ["2004", "2005"],
    "Trail Buck 650 Ext Base": ["2004", "2005"],
    "Trailfire 340 Base": ["1980", "1981", "1982", "1983", "1984"],
    "Trailfire 440 Base": ["1980", "1981", "1982", "1983", "1984"],
    "Gator CS": ["2005", "2006"],
    "Gator CX": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Buck 500 Ex": ["2004", "2005"],
    "Buck 500 Ext": ["2004", "2005"],
    "Gator TE Electric": ["2013", "2014", "2015", "2016"],
    "Gator XUV 4x4 850": ["2007", "2008"],
    "Gator XUV 4x4 560": ["2016", "2017", "2018"],
    "Gator XUV 4x4 560 S4": ["2016", "2017", "2018"],
    "Gator XUV 4x4 590i": ["2016", "2017"],
  },
  Rieju: {
    "MR 200 Racing": ["2021", "2022", "2023"],
    "MR 250 Racing": ["2021", "2022", "2023", "2024"],
    "MR 300 Racing": ["2021", "2022", "2023", "2024"],
    "MR 250 Pro": ["2021", "2022", "2023", "2024"],
    "MR 300 Pro": ["2021", "2022", "2023", "2024"],
    "MR Ranger 200": ["2021", "2022", "2023"],
    "MR Ranger 300": ["2021", "2022", "2023"],
  },
  Mahindra: {
    Roxor: ["2018", "2019", "2020"],
    "mPact XTV 1000 C Diesel Base": ["2015", "2016", "2017", "2018", "2019"],
    "mPact XTV 1000 C Diesel Camo Base": ["2016", "2017", "2018", "2019"],
    "mPact XTV 1000 L Diesel Base": ["2015", "2016", "2017", "2018", "2019"],
    "mPact XTV 1000 S Diesel Base": ["2015", "2016", "2017", "2018", "2019"],
    "mPact XTV 1000 S Diesel Camo Base": ["2016", "2017", "2018", "2019"],
    "mPact XTV 1000 S Diesel Flexhauler Base": ["2016", "2017", "2018", "2019"],
    "mPact XTV 750 B Gas Base": ["2016", "2017", "2018", "2019"],
    "mPact XTV 750 C Gas Base": ["2015", "2016", "2017", "2018", "2019"],
    "mPact XTV 750 C Gas Camo Base": ["2016", "2017", "2018", "2019"],
    "mPact XTV 750 L Gas Base": ["2015", "2016", "2017", "2018", "2019"],
    "mPact XTV 750 S Gas Base": ["2015", "2016", "2017", "2018", "2019"],
    "mPact XTV 750 S Gas Camo Base": ["2016", "2017", "2018", "2019"],
    "mPact XTV 750 S Gas Flexhauler Base": ["2016", "2017", "2018", "2019"],
    "Retriever 1000 Diesel Crew Base": ["2018", "2019"],
    "Retriever 1000 Diesel Flexhauler Base": ["2018", "2019"],
    "Retriever 1000 Diesel Flexhauler LE Base": ["2018", "2019"],
    "Retriever 1000 Diesel Longbed Base": ["2018", "2019"],
    "Retriever 1000 Diesel Standard Base": ["2018", "2019"],
    "Retriever 1000 Diesel Standard LE Base": ["2018", "2019"],
    "Retriever 1000 Gas Flexhauler Base": ["2018", "2019"],
    "Retriever 1000 Gas Flexhauler LE Base": ["2018", "2019"],
    "Retriever 1000 Gas Standard Base": ["2018", "2019"],
    "Retriever 1000 Gas Standard LE Base": ["2018", "2019"],
    "Retriever 750 Gas Base Base": ["2018", "2019"],
    "Retriever 750 Gas Crew Base": ["2018", "2019"],
    "Retriever 750 Gas Flexhauler Base": ["2018", "2019"],
    "Retriever 750 Gas Longbed Base": ["2018", "2019"],
    "Retriever 750 Gas Standard Base": ["2018", "2019"],
    "Roxor Base": ["2018", "2019", "2020"],
  },
  "Arctic Cat/Textron": {
    "Havoc X": ["2018", "2019"],
  },
  Hisun: {
    "Forge 400": ["2016", "2017"],
    "Sector 1000": ["2016", "2017", "2018", "2019"],
    "Sector 450": ["2016", "2017", "2018", "2019"],
    "Sector 550": ["2016", "2017", "2018", "2019"],
    "Sector 750": ["2016", "2017", "2018", "2019"],
    "Strike 1000": ["2016", "2017", "2018", "2019"],
    "Strike 550": ["2017", "2018", "2019"],
    "Strike 900": ["2017", "2018", "2019"],
    "Tactic 1000": ["2016", "2017"],
    HS500: ["2015", "2016", "2018", "2019", "2020"],
    HS700: ["2015", "2016", "2018", "2019", "2020"],
    "Tactic 550 2-up": ["2019", "2020"],
  },
  ODES: {
    "Workcross 1000-3": ["2023", "2024"],
    "Workcross 1000-3 HV": ["2023", "2024"],
    "Workcross 1000-3 HVAC": ["2023", "2024"],
    "Workcross 1000-6 HV": ["2023", "2024"],
    "Workcross 1000-6 HVAC": ["2023", "2024"],
    "Workcross 650-3 EPS": ["2023", "2024"],
    "Assailant 800 Base": ["2015", "2016", "2017"],
    "Assailant Zeus Base": ["2018", "2019"],
    "Blazer 150 Base": ["2015", "2016"],
    "Dominator 800 Base": ["2012", "2013", "2014", "2015", "2016"],
    "Dominator 800 4-Door Base": ["2012", "2013", "2014", "2015", "2016"],
    "Dominator 800 Hunter Edition Base": ["2013", "2014"],
    "Dominator 800 Pro Edition Base": ["2013", "2014"],
    "Dominator X2 1000 LT Base": ["2016", "2017"],
    "Dominator X2 800 LT Base": ["2017", "2018"],
    "Dominator X4 1000 LT Base": ["2016", "2017"],
    "Dominator X4 800 LT Base": ["2016", "2017", "2018"],
    "Raider 1000 Base": ["2015", "2016", "2017"],
    "Raider 800 Base": ["2014", "2015"],
    "Raider 800 LT Base": ["2016", "2017"],
    "Ravager 1000 LT Zeus Base": ["2018", "2019"],
  },
  Kubota: {
    RTV500: [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    RTV400Ci: ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "RTV-X1100C": ["2014", "2015", "2016", "2017", "2018"],
    "RTV-X1120D": ["2014", "2015", "2016", "2017"],
    "RTV-X900": ["2014", "2015", "2016", "2017", "2018"],
    RTV1100: ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    RTV1140: ["2009", "2010", "2011"],
    RTV900: ["2005", "2006", "2007", "2008", "2009", "2010"],
    "RTV-X1100C Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "RTV-X1120 Deluxe Base": ["2018", "2019"],
    "RTV-X1120 General Purpose Base": ["2018", "2019"],
    "RTV-X1120 Worksite Base": ["2018", "2019"],
    "RTV-X1120D Base": ["2014", "2015", "2016", "2017"],
    "RTV-X1140 Base": ["2016", "2017", "2018"],
    "RTV-X900 General Purpose Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "RTV-X900 Worksite Base": ["2014", "2015", "2016", "2017", "2018", "2019"],
    "RTV-XG850 Sidekick General Purpose Base": ["2018", "2019"],
    "RTV-XG850 Sidekick Special Base": ["2018", "2019"],
    "RTV-XG850 Sidekick Worksite Base": ["2018", "2019"],
    "RTV1100 Base": ["2007", "2008", "2009", "2010", "2011", "2012", "2013"],
    "RTV1140CPX Base": ["2011", "2012", "2013", "2014", "2015", "2016"],
    "RTV400Ci Base": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "RTV500 4x4 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "RTV900 Base": ["2004", "2005", "2006", "2007", "2010", "2011"],
    "RTV900XT Base": ["2012", "2013", "2014", "2015", "2016"],
    "RTV900XT Utility Base": ["2013", "2014", "2015", "2016"],
    "RTV900XT WorkSite Base": ["2013", "2014", "2015", "2016"],
    "RTV-X1140": ["2016", "2017"],
    RTV1140CPX: ["2011", "2012", "2013", "2014", "2015", "2016"],
  },
  Tigershark: {
    "Barracuda 640": ["1994", "1995"],
    "Daytona 640": ["1994", "1995"],
    "Monte Carlo 640": ["1994", "1995", "1996", "1997"],
    "Monte Carlo 770": ["1996", "1997"],
    "Montego 640": ["1994", "1995", "1996", "1997"],
    "Montego Deluxe 640": ["1994", "1995", "1996", "1997"],
    "Daytona 770": ["1996", "1997"],
    "Barracuda Base": ["1994", "1995"],
    "Daytona Base": ["1993", "1994", "1995"],
    "Daytona 770 Base": ["1996", "1997"],
    "Monte Carlo Base": ["1994", "1995"],
    "Monte Carlo 640 Base": ["1996", "1997"],
    "Monte Carlo 770 Base": ["1996", "1997"],
    "Montego Base": ["1994", "1995", "1996", "1997"],
    "Montego Deluxe Base": ["1994", "1995", "1996", "1997"],
    "TS640 Base": ["1998", "1999"],
    "TS770 Base": ["1998", "1999"],
    "TS770L Base": ["1998", "1999"],
    "TS770R Base": ["1998", "1999"],
  },
  "Excelsior-Henderson": {
    "Super X": ["1999", "2000"],
    "Super X Base": ["1999", "2000"],
  },
  Renault: {
    "Fuego Base": ["1982", "1983", "1984", "1985"],
    "Fuego Turbo": ["1982", "1983", "1984"],
    "R18i Base": ["1981", "1982"],
    "R18i Deluxe": ["1981", "1982", "1983"],
    "R18i Sportwagon": ["1984", "1985", "1986"],
    "LeCar GTL": ["1979", "1980"],
    "LeCar TL": ["1979", "1980"],
    "R16 Base": ["1969", "1970", "1971", "1972"],
    "Alliance Base": ["1983", "1984", "1985", "1986", "1987"],
    "Alliance DL": ["1983", "1984", "1985", "1986", "1987"],
    "Alliance L": ["1983", "1984", "1985", "1986", "1987"],
    "Alliance Limited": ["1983", "1984", "1985"],
    "Encore Base": ["1984", "1985"],
    "Encore GS": ["1984", "1985", "1986"],
    "Encore LS": ["1984", "1985", "1986"],
    "Encore S": ["1984", "1985", "1986"],
    "LeCar Base": ["1981", "1982", "1983"],
    "LeCar Deluxe": ["1981", "1982", "1983"],
  },
  DeLorean: {
    "DMC 12 Base": ["1981", "1982", "1983"],
  },
  Maserati: {
    "Ghibli Base": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Ghibli S": ["2016", "2017", "2018", "2019", "2020", "2021"],
    "Ghibli S Q4": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "GranTurismo Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
    ],
    "GranTurismo MC": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "GranTurismo S": ["2009", "2010", "2011", "2012"],
    "GranTurismo Sport": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Levante Base": ["2017", "2018", "2019", "2020", "2021"],
    "Levante S": ["2017", "2018", "2019", "2020", "2021"],
    "Quattroporte Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Quattroporte Executive GT": ["2006", "2007", "2008"],
    "Quattroporte GTS": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
    ],
    "Quattroporte S": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Quattroporte S Q4": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    "Quattroporte Sport GT": ["2006", "2007", "2008"],
    "Quattroporte Sport GT S": ["2010", "2011", "2012", "2013"],
    "Coupe Cambiocorsa": ["2003", "2004", "2005", "2006", "2007"],
    "Coupe GT": ["2003", "2004", "2005", "2006", "2007"],
    "GranSport Base": ["2005", "2006", "2007"],
    "Spyder Cambiocorsa": ["2003", "2004", "2005", "2006"],
    "Spyder GT": ["2002", "2003", "2004", "2005", "2006"],
    "228i Base": ["1989", "1990"],
    "425 Base": ["1986", "1987"],
    "430i Base": ["1989", "1990"],
    "Biturbo Base": ["1983", "1984", "1985", "1986", "1987"],
    "Bora Base": ["1980", "1981", "1982", "1983"],
    "Levante GTS": ["2019", "2020"],
    "Levante Trofeo": ["2019", "2020"],
    "Merak SS": ["1980", "1981", "1982"],
    "Spyder Base": ["1986", "1987", "1989", "1990", "1991"],
  },
  Polestar: {
    "Polestar 2 Base": ["2022", "2023", "2024"],
    "Polestar 2 Launch Edition": ["2021", "2022"],
    "Polestar 1 Base": ["2020", "2021"],
  },
  Rivian: {
    "R1S Adventure": ["2022", "2023", "2024"],
    "R1S Explore": ["2022", "2023", "2024"],
  },
  Bertone: {
    "X-1/9 Base": ["1984", "1985", "1986", "1987", "1988", "1989"],
  },
  Simca: {
    "1118 Base": ["1969", "1970", "1971"],
    "1204 Base": ["1969", "1970", "1971"],
  },
  Lynx: {
    "850 E-TEC Rave RE": ["2022", "2023", "2024"],
    'Shredder DS-850 E-TEC Turbo R 154"/2.5"': ["2023", "2024"],
    'Shredder DS-850 E-TEC Turbo R 154"/3.0"': ["2023", "2024"],
    'Shredder DS-850 E-TEC Turbo R 165"': ["2023", "2024"],
    'Shredder RE-850 E-TEC 146"': ["2023", "2024"],
    'Shredder RE-850 E-TEC 154"/2.5"': ["2023", "2024"],
    'Shredder RE-850 E-TEC Turbo R 146"': ["2023", "2024"],
    'Shredder RE-850 E-TEC Turbo R 154"': ["2023", "2024"],
    "Xterrain Brutal 850 E-TEC": ["2022", "2023", "2024"],
    "Xterrain RE 850 E-TEC": ["2022", "2023", "2024"],
    "Xterrain RE 900 ACE Turbo R": ["2022", "2023", "2024"],
  },
  Morgan: {
    "4/4 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
    ],
    "Plus 8 Base": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "2002",
      "2003",
    ],
    "Aero 8 Base": ["2004", "2005", "2006", "2007"],
  },
  "American IronHorse": {
    "Bandera Base": ["2008", "2009"],
    "Classic Base": ["2000", "2001", "2002"],
    "Legend Base": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "LSC Base": ["2005", "2006", "2007"],
    "Outlaw Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
    "Ranger Base": ["2001", "2002"],
    "Slammer Base": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2007",
      "2008",
      "2009",
    ],
    "Stalker Base": ["2003", "2004"],
    "Tejas Base": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "Texas Chopper Base": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
    ],
    "Thunder Base": ["2000", "2001", "2002"],
  },
  "Big Dog": {
    "Boxer Base": ["2001", "2002", "2003", "2004", "2017", "2018"],
    "Bulldog Base": ["2001", "2002", "2003", "2004", "2005", "2010", "2011"],
    "Chopper Base": ["2003", "2004", "2006", "2007"],
    "Chopper DT Base": ["2003", "2004", "2005"],
    "Coyote Base": ["2009", "2010", "2011", "2017", "2018"],
    "Husky Base": ["2001", "2002", "2003"],
    "K-9 Base": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2016",
      "2017",
      "2018",
    ],
    "K-9 EFI Base": ["2010", "2011"],
    "Mastiff Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Mastiff EFI Base": ["2010", "2011"],
    "Pitbull Base": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Pro Sport Base": ["2001", "2002"],
    "Ridgeback Base": ["2004", "2005", "2006", "2008", "2009", "2010", "2011"],
    "Wolf Base": ["2001", "2002", "2009", "2010", "2011"],
    Boxer: ["2001", "2002", "2003", "2004"],
    Bulldog: ["2001", "2002", "2003", "2004", "2005", "2010", "2011"],
    Coyote: ["2009", "2010", "2011"],
    Husky: ["2001", "2002", "2003"],
    "K-9": ["2006", "2007", "2008", "2009", "2010", "2011"],
    Mastiff: [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    Pitbull: [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Pro Sport": ["2001", "2002"],
    Ridgeback: ["2004", "2005", "2006", "2008", "2009", "2010", "2011"],
    Wolf: ["2001", "2002", "2009", "2010", "2011"],
  },
  Bobcat: {
    "2100 (Gas) Base": ["2008", "2009", "2010"],
    "2200G (Gas) Base": ["2008", "2009", "2010"],
    "2200S (Diesel) Base": ["2008", "2009"],
    "2300 Base": ["2008", "2009", "2010"],
    "3200 4x2 (Gas) Base": ["2011", "2012", "2013", "2014"],
    "3400 4x4 (Diesel) Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "3400 4x4 (Gas) Base": [
      "2011",
      "2012",
      "2013",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "3400XL 4x4 (Diesel) Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "3400XL 4x4 (Gas) Base": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "3450 4x4 Base": ["2011", "2012"],
    "3600 4x4 Base": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "3650 4x4 Base": ["2013", "2014", "2015", "2016", "2017", "2018"],
    "Toolcat 5600 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Toolcat 5610 Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
  },
  Cagiva: {
    "Raptor 650 Base": ["2001", "2002", "2003", "2004", "2005"],
    "V Raptor 650 Base": ["2001", "2002", "2003", "2004", "2005"],
  },
  "Case IH": {
    "Scout Base": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "Scout XL 2-Passenger Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Scout XL 4-Passenger Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Scout XL Diesel 2-Passenger Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
    "Scout XL Diesel 4-Passenger Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
  },
  CFMOTO: {
    "CF500 Base": ["2007", "2008", "2009", "2010"],
    "CF500-3 (Rancher 500) Base": ["2011", "2012"],
    "CF500A Base": ["2008", "2009", "2010"],
    "CF600-5 (Rancher 600) Base": ["2011", "2012"],
    "CFORCE 400 Base": ["2016", "2017", "2018", "2019"],
    "CForce 500 Base": ["2013", "2014", "2015", "2016"],
    "CFORCE 500 HO EPS Base": ["2015", "2016", "2017", "2018"],
    "CFORCE 500S Base": ["2019", "2020"],
    "CFORCE 500S EPS Base": ["2017", "2018"],
    "CFORCE 600 Base": ["2013", "2014", "2019", "2020"],
    "CFORCE 800 Base": ["2013", "2014"],
    "CFORCE 800 EPS Base": ["2015", "2016", "2017"],
    "CForce 800 XC Base": ["2018", "2019", "2020"],
    "UForce 1000 Base": ["2019", "2020"],
    "UFORCE 500 EPS Base": ["2018", "2019", "2020"],
    "UFORCE 500 HO EPS Base": ["2016", "2017"],
    "UFORCE 800 Base": ["2013", "2014", "2015", "2016"],
    "UFORCE 800 EPS Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "X5 (Terralander 500) LWB Base": ["2011", "2012"],
    "X5 (Terralander 500) SWB Base": ["2011", "2012"],
    "X6 (Terralander 625) LWB Base": ["2011", "2012"],
    "X6 (Terralander 625) SWB Base": ["2011", "2012"],
    "Z6 (Terracross 600) Base": ["2011", "2012"],
    "ZFORCE 500 Trail EPS Base": ["2018", "2019", "2020"],
    "ZFORCE 600 Base": ["2013", "2014", "2015"],
    "ZFORCE 600 EX Base": ["2013", "2014", "2015"],
    "ZFORCE 800 Base": ["2015", "2016"],
    "ZFORCE 800 EPS Base": ["2015", "2016"],
    "ZFORCE 800 EPS Trail Base": ["2016", "2017"],
    "ZFORCE 800 EX Base": ["2014", "2015", "2016"],
    "ZFORCE 800 EX EPS Base": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "ZFORCE 800 Trail EPS Base": ["2018", "2019", "2020"],
  },
  "Cub Cadet": {
    "Challenger 400 Base": ["2016", "2017", "2018", "2019"],
    "Challenger 400 4x4 Base": ["2018", "2019"],
    "Challenger 400 LX Base": ["2016", "2017", "2018", "2019"],
    "Challenger 500 Base": ["2015", "2016", "2017", "2018", "2019"],
    "Challenger 550 Base": ["2017", "2018"],
    "Challenger 550 Camo Base": ["2017", "2018"],
    "Challenger 700 Base": ["2015", "2016", "2018", "2019"],
    "Challenger 750 Base": ["2017", "2018"],
    "Challenger 750 Camo Base": ["2017", "2018"],
    "Challenger 750 crew Base": ["2016", "2017", "2018", "2019"],
    "Challenger 750 EPS Base": ["2017", "2018"],
    "Volunteer 4x2 Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Volunteer 4x4 Base": ["2009", "2010", "2011", "2012", "2013", "2014"],
    "Volunteer 4x4 EFI Base": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
    ],
    "Volunteer 4x4D Base": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
    ],
    "Volunteer WT Base": ["2018", "2019"],
    "Volunteer WT Cab Base": ["2016", "2017", "2018", "2019"],
  },
  "E-Ton": {
    "DXL 90 Base": ["1999", "2000", "2001"],
    "Lightning 50 Base": ["1999", "2000", "2001"],
    "Rascal 40 Base": ["2000", "2001"],
    "Rover Base": ["2007", "2008", "2009", "2010"],
    "Rover GT Base": ["2007", "2008", "2009", "2010"],
    "Sierra 90 Base": ["2000", "2001", "2002"],
    "Thunder 90 Base": ["1999", "2000", "2001"],
    "TXL 50 Base": ["2000", "2001"],
    "TXL 90 Base": ["2000", "2001"],
    "Vector 250R Base": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
    ],
    "Viper 150R Base": ["2005", "2006", "2007", "2008", "2009", "2010", "2011"],
    "Viper 50 Base": ["2002", "2003", "2004"],
    "Viper 70 4-Stroke Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Viper 70 Silver Series Base": ["2009", "2010", "2011"],
    "Viper 70M 4-Stroke Base": ["2006", "2007"],
    "Viper 90 Base": ["2002", "2003", "2004", "2005", "2006", "2007"],
    "Viper 90 Silver Series Base": ["2009", "2010", "2011"],
    "Viper 90R 4-Stroke Base": ["2006", "2007", "2008", "2009", "2010", "2011"],
    "Viper 90R Silver Series Base": ["2009", "2010", "2011"],
    "Viper Jr. Base": ["2002", "2003", "2004"],
    "Yukon Base": ["2000", "2001"],
    "Yukon II CXL 150 Base": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
    ],
    "YXL 150 Base": ["2001", "2002"],
    "Vector 250": ["2005", "2006", "2007", "2008", "2009", "2010"],
    "Viper 150R": ["2006", "2007", "2008", "2009"],
  },
  "Erik Buell Racing": {
    "1190RS Base": ["2012", "2013"],
    "1190Rx Base": ["2016", "2017"],
    "1190Sx Base": ["2016", "2017"],
  },
  HM: {
    "CRE 50 Base": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
    ],
  },
  Kasea: {
    "Skyhawk 170 Base": ["2003", "2004", "2005"],
    "Skyhawk 250 Base": ["2003", "2004", "2005"],
    "Skyhawk 90 Base": ["2002", "2003", "2004", "2005"],
    "Skyhawk 90": ["2002", "2003", "2004", "2005"],
    "Skyhawk 170": ["2003", "2004", "2005"],
    "Skyhawk 250": ["2003", "2004", "2005"],
  },
  "Moto-Ski": {
    "Futura L/C Base": ["1980", "1981", "1982"],
    "Mirage I Base": ["1980", "1981", "1982"],
    "Mirage II Base": ["1980", "1981", "1982", "1983"],
    "Mirage IIE Base": ["1980", "1981", "1982", "1983"],
    "Spirit Base": ["1980", "1981", "1982", "1983"],
    "Super Sonic Base": ["1980", "1981"],
    "Ultra Sonic Base": ["1980", "1981", "1982"],
  },
  "New Holland": {
    "Rustler 115 4x2 Base": ["2010", "2011", "2012", "2013", "2014"],
    "Rustler 115 4x4 Base": ["2010", "2011", "2012", "2013", "2014"],
    "Rustler 120 Four Passenger Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Rustler 120 Two Passenger Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Rustler 125 Four Passenger Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Rustler 125 Two Passenger Base": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
    ],
    "Rustler 850 Four Passenger Base": ["2018", "2019"],
    "Rustler 850 Two Passenger Base": ["2018", "2019"],
  },
  Polini: {
    "X1R Base": ["2006", "2007", "2008", "2009", "2010"],
    "X3P Air Base": ["2006", "2007", "2008", "2009", "2010"],
    "X3R Base": ["2006", "2007", "2008", "2009", "2010"],
    "X5P Air Base": ["2006", "2007", "2008", "2009", "2010"],
    "X5P Liquid Base": ["2007", "2008", "2009", "2010"],
    "XP4R Base": ["2007", "2008", "2009", "2010"],
    "XP4T 10-12 Base": ["2006", "2007", "2008", "2009", "2010"],
    "XP4T 12-14 Base": ["2006", "2007", "2008", "2009", "2010"],
    "XP65R Base": ["2006", "2007", "2008", "2009", "2010"],
  },
  "Redcat Motors": {
    "DPX 200 Base": ["2005", "2006", "2007"],
    "DPX 250 Base": ["2005", "2006"],
    "FX 150 MKII Base": ["2005", "2006"],
    "FX 250 Base": ["2005", "2006"],
    "KMX 50 Base": ["2005", "2006"],
    "MPX 110 Base": ["2006", "2007"],
    "MPX 150 Base": ["2006", "2007"],
    "MPX 90U Base": ["2006", "2007"],
    "VX 110 Base": ["2005", "2006"],
    "VX 150 Base": ["2005", "2006"],
    "VX 200 Base": ["2005", "2006"],
    "VX 80 Base": ["2005", "2006", "2007"],
  },
  Redline: {
    "Revolt Base": ["2008", "2009"],
    "Revolt XL Base": ["2008", "2009"],
    "Riot TS750 Base": ["2008", "2009", "2010"],
  },
  Scorpion: {
    "Sting 440 Base": ["1980", "1981"],
    "TK 340 Base": ["1980", "1981"],
    "TK 440 Base": ["1980", "1981"],
    "Whip 440 Base": ["1980", "1981"],
  },
  TGB: {
    "50 Adventure Series Base": ["2005", "2006"],
    "90 Adventure Series Base": ["2005", "2006"],
    "Outback 425 C Base": ["2007", "2008"],
    "Outback 425 Camo Edition Base": ["2007", "2008"],
    "Outback 425 Special Edition Base": ["2007", "2008"],
  },
  "Wet Jet": {
    "Duo 300 Base": ["1995", "1996", "1997"],
    "Kraze Base": ["1995", "1996", "1997"],
    "ZX Base": ["1995", "1996", "1997"],
  },
  Karma: {
    "Revero Base": ["2017", "2018", "2019"],
  },
  Laforza: {
    "Laforza G.T.": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
    ],
    "Laforza Magnum": ["1998", "1999", "2000", "2001"],
  },
  Lancia: {
    "Zagato Base": ["1981", "1982"],
  },
  McLaren: {
    "570GT Base": ["2017", "2018", "2019"],
    "570S Base": ["2016", "2017", "2018", "2019", "2020"],
    "570S Spider": ["2018", "2019", "2020"],
    "600LT Base": ["2019", "2020"],
    "650S Base": ["2015", "2016"],
    "650S Spider": ["2015", "2016"],
    "720S Base": ["2018", "2019", "2020"],
    "GT Base": ["2019", "2020", "2021"],
    "MP4-12C Base": ["2012", "2013", "2014"],
    "MP4-12C Spider": ["2013", "2014"],
    "P1 Base": ["2014", "2015"],
  },
  Panoz: {
    "AIV Roadster Base": ["1999", "2000"],
    "Esperante Base": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
  },
  Qvale: {
    "Mangusta Base": ["2001", "2002"],
  },
  Spyker: {
    "C8 Spyder": ["2005", "2006", "2007", "2008", "2009"],
  },
  Utilimaster: {
    "Step Van Base": ["1989", "1990", "1991", "1992", "1993", "1994"],
  },
  Yugo: {
    "Cabrio Base": ["1990", "1991", "1992"],
    "GV Base": ["1986", "1987", "1988", "1989"],
    "GV Plus": ["1990", "1991", "1992"],
    "GVL Base": ["1988", "1989"],
    "GVX Base": ["1987", "1988", "1989"],
  },
  VPG: {
    "MV-1 Base": ["2011", "2012"],
    "MV-1 Deluxe": ["2011", "2012"],
  },
  Stark: {
    Varg: ["2022", "2023"],
  },
  Bristol: {
    "407 Base": ["1961", "1962", "1963"],
    "408 Base": ["1963", "1964", "1965"],
    "409 Base": ["1965", "1966", "1967"],
    "410 Base": ["1967", "1968", "1969"],
    "411 Base": ["1969", "1970", "1971", "1972", "1973", "1974"],
  },
  Iso: {
    "Grifo Base": ["1969", "1970", "1971", "1972", "1973", "1974"],
  },
  DeSoto: {
    "Adventurer Base": ["1958", "1959", "1960", "1961"],
    "Firedome Base": ["1958", "1959"],
    "Fireflite Base": ["1958", "1959", "1960", "1961"],
  },
  "Dual-Ghia": {
    "L6.4 Base": ["1960", "1961", "1962", "1963"],
  },
  "Facel Vega": {
    "Excellence Base": ["1959", "1960", "1961", "1962", "1963"],
    "Facel II Base": ["1962", "1963", "1964"],
    "HK500 Base": ["1959", "1960", "1961"],
  },
  Jensen: {
    "C-V8 Base": ["1964", "1965", "1966"],
    "Interceptor FF": ["1967", "1968", "1969", "1970", "1971"],
    "Interceptor MK I": ["1967", "1968", "1969"],
    "Interceptor MK II": ["1970", "1971"],
    "Interceptor MK III": ["1972", "1973", "1974", "1975", "1976"],
    "Interceptor SP": ["1972", "1973"],
  },
  Monteverdi: {
    "375 Base": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
    ],
  },
  "Austin Healey": {
    "Sprite MK IV": ["1968", "1969", "1970"],
    "3000 Base": [
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
    "Sprite Base": [
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
    ],
  },
  AC: {
    "ACE Base": [
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
    ],
    "ACE Bristol": ["1956", "1957", "1958", "1959", "1960", "1961"],
  },
};
